import { TypedDocumentNode as DocumentNode } from 'src/api/apolloPatched';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  GenericScalar: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  MultiPolygon: { input: Array<Array<Array<Array<number>>>>; output: Array<Array<Array<Array<number>>>>; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AchAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  accountType: PaymentMethodAccountType;
  address?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  routingNumber: Scalars['String']['input'];
};

export type AchAccountNode = Node & {
  __typename: 'ACHAccountNode';
  accountNumber: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  status: Maybe<AchStatus>;
};

export type AiModelAnalyticsResponseNode = {
  __typename: 'AIModelAnalyticsResponseNode';
  dailyProcessingData: Maybe<Array<Maybe<DailyProcessingDataNode>>>;
  dateRange: Maybe<Scalars['String']['output']>;
  totalExtractions: Maybe<Scalars['Int']['output']>;
  usageStats: Maybe<Array<Maybe<AiModelUsageStatsNode>>>;
};

export type AiModelUsageStatsNode = {
  __typename: 'AIModelUsageStatsNode';
  accuracyRate: Maybe<Scalars['Decimal']['output']>;
  autoApprovalRate: Maybe<Scalars['Decimal']['output']>;
  autoApprovedExtractions: Maybe<Scalars['Int']['output']>;
  avgProcessingTime: Maybe<Scalars['Decimal']['output']>;
  failedExtractions: Maybe<Scalars['Int']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  totalExtractions: Maybe<Scalars['Int']['output']>;
  verificationRate: Maybe<Scalars['Decimal']['output']>;
  verifiedExtractions: Maybe<Scalars['Int']['output']>;
};

export type AiTextSuggestionType = {
  __typename: 'AITextSuggestionType';
  errorMessage: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  processor: Scalars['String']['output'];
  sourceText: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suggestedText: Maybe<Scalars['String']['output']>;
};

export type ApBlockNode = Node & {
  __typename: 'APBlockNode';
  blockedBy: UserNode;
  blockedEntity: BlockedEntity;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
};

export type ApBlockNodeConnection = {
  __typename: 'APBlockNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApBlockNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `APBlockNode` and its cursor. */
export type ApBlockNodeEdge = {
  __typename: 'APBlockNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ApBlockNode>;
};

export type AcceptClientTosMutationInput = {
  acceptedByName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type AcceptClientTosMutationPayload = {
  __typename: 'AcceptClientTosMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptOffResqVendorSubcontractMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId: Scalars['ID']['input'];
};

export type AcceptOffResqVendorSubcontractMutationPayload = {
  __typename: 'AcceptOffResqVendorSubcontractMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  subcontract: WorkOrderSubcontractType;
};

export type AcceptOrcTosMutationInput = {
  acceptedByName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId: Scalars['ID']['input'];
};

export type AcceptOrcTosMutationPayload = {
  __typename: 'AcceptOrcTosMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptPayQVendorTosMutationInput = {
  acceptedByName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  tosVersion?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptPayQVendorTosMutationPayload = {
  __typename: 'AcceptPayQVendorTosMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptRequestForQuoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dispatchRequestId: Scalars['ID']['input'];
};

export type AcceptRequestForQuotePayload = {
  __typename: 'AcceptRequestForQuotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type AcceptVendorCreatedWorkOrderInput = {
  acceptedById: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedServiceTimeline: ExpectedServiceTimeline;
  facilityAccessDetails?: InputMaybe<Scalars['String']['input']>;
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']['input']>;
  pointOfContact: WorkOrderPointOfContactInput;
  workOrderId: Scalars['ID']['input'];
};

export type AcceptVendorCreatedWorkOrderPayload = {
  __typename: 'AcceptVendorCreatedWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type AcceptVendorDispatchRequestWithoutSchedulingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorDispatchRequestId: Scalars['ID']['input'];
};

export type AcceptVendorDispatchRequestWithoutSchedulingMutationPayload = {
  __typename: 'AcceptVendorDispatchRequestWithoutSchedulingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorDispatchRequest: VendorDispatchRequestNode;
};

export type AcceptVendorEquipmentCapabilitySuggestionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  suggestions: Array<SuggestionInput>;
  vendorId: Scalars['ID']['input'];
};

export type AcceptVendorEquipmentCapabilitySuggestionMutationPayload = {
  __typename: 'AcceptVendorEquipmentCapabilitySuggestionMutationPayload';
  capabilityIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AcceptVendorPreventiveMaintenanceRecommendationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recommendationId: Scalars['ID']['input'];
};

export type AcceptVendorPreventiveMaintenanceRecommendationMutationPayload = {
  __typename: 'AcceptVendorPreventiveMaintenanceRecommendationMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorPreventiveMaintenanceRecommendation: VendorPreventiveMaintenanceRecommendationNode;
};

export enum AccountType {
  Client = 'CLIENT',
  ControlCenter = 'CONTROL_CENTER',
  Coordinator = 'COORDINATOR',
  Independent = 'INDEPENDENT',
  OffPlatform = 'OFF_PLATFORM',
  Vendor = 'VENDOR'
}

export type AccountingIntegrationCustomerNode = Node & {
  __typename: 'AccountingIntegrationCustomerNode';
  active: Scalars['Boolean']['output'];
  address: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  balance: Maybe<Scalars['Decimal']['output']>;
  cityName: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<CountryNode>;
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  exported: Scalars['Boolean']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  integrationType: OAuthIntegrationType;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  primaryTaxIdentifier: Maybe<Scalars['String']['output']>;
  province: Maybe<ProvinceNode>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type AccountingIntegrationCustomerNodeConnection = {
  __typename: 'AccountingIntegrationCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccountingIntegrationCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AccountingIntegrationCustomerNode` and its cursor. */
export type AccountingIntegrationCustomerNodeEdge = {
  __typename: 'AccountingIntegrationCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AccountingIntegrationCustomerNode>;
};

export type AccountingIntegrationInvoiceNode = Node & {
  __typename: 'AccountingIntegrationInvoiceNode';
  balance: Scalars['Decimal']['output'];
  createdAt: Maybe<Scalars['String']['output']>;
  currency: Currency;
  customerId: Scalars['String']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  docNumber: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['String']['output']>;
  externalInvoiceId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type AccountingIntegrationInvoicePdfNode = {
  __typename: 'AccountingIntegrationInvoicePdfNode';
  file: Maybe<UploadedFileNode>;
};

export enum AchStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  Current = 'CURRENT',
  Rejected = 'REJECTED',
  Restricted = 'RESTRICTED',
  Verified = 'VERIFIED'
}

export type AcknowledgeAdvertisingCommercialHoldMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: AdvertisingCommercialHoldReason;
  vendorOrganizationId: Scalars['ID']['input'];
};

export type AcknowledgeAdvertisingCommercialHoldMutationPayload = {
  __typename: 'AcknowledgeAdvertisingCommercialHoldMutationPayload';
  advertisingCommercialHoldState: AdvertisingCommercialHoldStateType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ActivateMaintenancePlanMutation = {
  __typename: 'ActivateMaintenancePlanMutation';
  ok: Scalars['Boolean']['output'];
};

export type ActivatePreventitiveMaintenanceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  maintenancePlanId: Scalars['ID']['input'];
};

export type ActivatePreventitiveMaintenanceMutationPayload = {
  __typename: 'ActivatePreventitiveMaintenanceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ActivateTradesSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  serviceName: ResqServiceName;
};

export type ActivateTradesSubscriptionPayload = {
  __typename: 'ActivateTradesSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  failureReason: Maybe<TradesSubscriptionActivationFailureReason>;
  isTrial: Scalars['Boolean']['output'];
  serviceName: ResqServiceName;
  status: TradesSubscriptionActivationStatus;
  subscription: Maybe<OrganizationSubscriptionNode>;
  trialEndDate: Maybe<Scalars['Date']['output']>;
};

export type Activity = {
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type ActivityConnection = {
  __typename: 'ActivityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `Activity` and its cursor. */
export type ActivityEdge = {
  __typename: 'ActivityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Activity>;
};

/** An enumeration. */
export enum ActivityFeedEntryEntryType {
  /** Ai Call Ended */
  AiCallEnded = 'AI_CALL_ENDED',
  /** Ap Batch Updated */
  ApBatchUpdated = 'AP_BATCH_UPDATED',
  /** Callback Changed */
  CallbackChanged = 'CALLBACK_CHANGED',
  /** Cancelled To Reassign Vendor */
  CancelledToReassignVendor = 'CANCELLED_TO_REASSIGN_VENDOR',
  /** Client Adjustment Invoice Created */
  ClientAdjustmentInvoiceCreated = 'CLIENT_ADJUSTMENT_INVOICE_CREATED',
  /** Client Invoice Created */
  ClientInvoiceCreated = 'CLIENT_INVOICE_CREATED',
  /** Created To Reassign Vendor */
  CreatedToReassignVendor = 'CREATED_TO_REASSIGN_VENDOR',
  /** Work Order Client Rejected */
  EntryTypeWorkOrderClientRejected = 'ENTRY_TYPE_WORK_ORDER_CLIENT_REJECTED',
  /** Equipment Changed */
  EquipmentChanged = 'EQUIPMENT_CHANGED',
  /** Invoice Confirmed */
  InvoiceConfirmed = 'INVOICE_CONFIRMED',
  /** Invoice Paid */
  InvoicePaid = 'INVOICE_PAID',
  /** Invoice Set Disputed */
  InvoiceSetDisputed = 'INVOICE_SET_DISPUTED',
  /** Invoice Set Dispute Expired */
  InvoiceSetDisputeExpired = 'INVOICE_SET_DISPUTE_EXPIRED',
  /** Invoice Set Dispute Resolved */
  InvoiceSetDisputeResolved = 'INVOICE_SET_DISPUTE_RESOLVED',
  /** Inbound Vendor Invoice Created */
  InvoiceVendorInvoiceCreated = 'INVOICE_VENDOR_INVOICE_CREATED',
  /** Inbound Vendor Invoice Deleted */
  InvoiceVendorInvoiceDeleted = 'INVOICE_VENDOR_INVOICE_DELETED',
  /** Miscellaneous Hold Fulfilled */
  MiscellaneousHoldFulfilled = 'MISCELLANEOUS_HOLD_FULFILLED',
  /** Parts Update Requested */
  PartsUpdateRequested = 'PARTS_UPDATE_REQUESTED',
  /** Payment Failed */
  PaymentFailed = 'PAYMENT_FAILED',
  /** Payment Initiated */
  PaymentInitiated = 'PAYMENT_INITIATED',
  /** Payment Refunded */
  PaymentRefunded = 'PAYMENT_REFUNDED',
  /** Post Sourcing Parts Updated */
  PostSourcingPartsUpdated = 'POST_SOURCING_PARTS_UPDATED',
  /** Quote Approved */
  QuoteApproved = 'QUOTE_APPROVED',
  /** Quote Feedback Submitted */
  QuoteFeedbackSubmitted = 'QUOTE_FEEDBACK_SUBMITTED',
  /** Quote Published */
  QuotePublished = 'QUOTE_PUBLISHED',
  /** Quote Rejected */
  QuoteRejected = 'QUOTE_REJECTED',
  /** Quote Removed */
  QuoteRemoved = 'QUOTE_REMOVED',
  /** Quote Selected */
  QuoteSelected = 'QUOTE_SELECTED',
  /** Quote Set Cancelled */
  QuoteSetCancelled = 'QUOTE_SET_CANCELLED',
  /** Quote Set Rejected */
  QuoteSetRejected = 'QUOTE_SET_REJECTED',
  /** Quote Set Reset */
  QuoteSetReset = 'QUOTE_SET_RESET',
  /** Quote Spend Approved */
  QuoteSpendApproved = 'QUOTE_SPEND_APPROVED',
  /** Quote Step Approved */
  QuoteStepApproved = 'QUOTE_STEP_APPROVED',
  /** Quote Uploaded */
  QuoteUploaded = 'QUOTE_UPLOADED',
  /** Record Of Work Created */
  RecordOfWorkCreated = 'RECORD_OF_WORK_CREATED',
  /** Record Of Work Deleted */
  RecordOfWorkDeleted = 'RECORD_OF_WORK_DELETED',
  /** Record Of Work Unapproved */
  RecordOfWorkUnapproved = 'RECORD_OF_WORK_UNAPPROVED',
  /** Resq Review Started */
  ResqReviewStarted = 'RESQ_REVIEW_STARTED',
  /** Scheduling Request Fulfilled */
  SchedulingRequestFulfilled = 'SCHEDULING_REQUEST_FULFILLED',
  /** Sourcing Parts Eta Set */
  SourcingPartsEtaSet = 'SOURCING_PARTS_ETA_SET',
  /** Sourcing Parts Fulfilled */
  SourcingPartsFulfilled = 'SOURCING_PARTS_FULFILLED',
  /** Team Member Assignment Marked As Completed */
  TeamMemberAssignmentMarkedAsCompleted = 'TEAM_MEMBER_ASSIGNMENT_MARKED_AS_COMPLETED',
  /** Team Member Assignment Marked As Unresolved */
  TeamMemberAssignmentMarkedAsUnresolved = 'TEAM_MEMBER_ASSIGNMENT_MARKED_AS_UNRESOLVED',
  /** Under Warranty Changed */
  UnderWarrantyChanged = 'UNDER_WARRANTY_CHANGED',
  /** Vendor Assigned */
  VendorAssignedToWorkOrder = 'VENDOR_ASSIGNED_TO_WORK_ORDER',
  /** Vendor Dispatch Cancelled */
  VendorDispatchCancelled = 'VENDOR_DISPATCH_CANCELLED',
  /** Vendor Dispatch Expired */
  VendorDispatchExpired = 'VENDOR_DISPATCH_EXPIRED',
  /** Vendor Dispatch Request Accepted */
  VendorDispatchRequestAccepted = 'VENDOR_DISPATCH_REQUEST_ACCEPTED',
  /** Vendor Dispatch Request Declined */
  VendorDispatchRequestDeclined = 'VENDOR_DISPATCH_REQUEST_DECLINED',
  /** Vendor Dispatch Request Expired */
  VendorDispatchRequestExpired = 'VENDOR_DISPATCH_REQUEST_EXPIRED',
  /** Vendor Dispatch Request Started */
  VendorDispatchRequestStarted = 'VENDOR_DISPATCH_REQUEST_STARTED',
  /** Vendor Dispatch Reset */
  VendorDispatchReset = 'VENDOR_DISPATCH_RESET',
  /** Vendor Dispatch Started */
  VendorDispatchStarted = 'VENDOR_DISPATCH_STARTED',
  /** Vendor Dispatch Started Automatically */
  VendorDispatchStartedAutomatically = 'VENDOR_DISPATCH_STARTED_AUTOMATICALLY',
  /** Vendor Flagged Invoice Expired */
  VendorFlaggedInvoiceExpired = 'VENDOR_FLAGGED_INVOICE_EXPIRED',
  /** Vendor Invoice Dispute Resolved */
  VendorInvoiceDisputeResolved = 'VENDOR_INVOICE_DISPUTE_RESOLVED',
  /** Vendor Invoice Submitted */
  VendorInvoiceSubmitted = 'VENDOR_INVOICE_SUBMITTED',
  /** Vendor Work Order Accepted */
  VendorWorkOrderAccepted = 'VENDOR_WORK_ORDER_ACCEPTED',
  /** Vendor Work Order Payout Updated */
  VendorWorkOrderPayoutUpdated = 'VENDOR_WORK_ORDER_PAYOUT_UPDATED',
  /** Visit Ended With Next Visit Required */
  VisitEndedWithNextVisitRequired = 'VISIT_ENDED_WITH_NEXT_VISIT_REQUIRED',
  /** Visit Ended With Scheduling Required */
  VisitEndedWithSchedulingRequired = 'VISIT_ENDED_WITH_SCHEDULING_REQUIRED',
  /** Work Order Assigned */
  WorkOrderAssigned = 'WORK_ORDER_ASSIGNED',
  /** Work Order Assigned To Ops Owner */
  WorkOrderAssignedToOpsOwner = 'WORK_ORDER_ASSIGNED_TO_OPS_OWNER',
  /** Work Order Assigned To Team Member */
  WorkOrderAssignedToTeamMember = 'WORK_ORDER_ASSIGNED_TO_TEAM_MEMBER',
  /** Work Order Attributes Changed */
  WorkOrderAttributesChanged = 'WORK_ORDER_ATTRIBUTES_CHANGED',
  /** Work Order Cancelled */
  WorkOrderCancelled = 'WORK_ORDER_CANCELLED',
  /** Work Order Client Invoices Approved */
  WorkOrderClientInvoicesApproved = 'WORK_ORDER_CLIENT_INVOICES_APPROVED',
  /** Work Order Closed */
  WorkOrderClosed = 'WORK_ORDER_CLOSED',
  /** Work Order Completed */
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
  /** Work Order Created */
  WorkOrderCreated = 'WORK_ORDER_CREATED',
  /** Work Order Disputed */
  WorkOrderDisputed = 'WORK_ORDER_DISPUTED',
  /** Work Order Dispute Resolved */
  WorkOrderDisputeResolved = 'WORK_ORDER_DISPUTE_RESOLVED',
  /** Work Order Escalation Created */
  WorkOrderEscalationCreated = 'WORK_ORDER_ESCALATION_CREATED',
  /** Work Order Escalation Resolved */
  WorkOrderEscalationResolved = 'WORK_ORDER_ESCALATION_RESOLVED',
  /** Work Order Flagged */
  WorkOrderFlagged = 'WORK_ORDER_FLAGGED',
  /** Work Order Internally Disputed */
  WorkOrderInternallyDisputed = 'WORK_ORDER_INTERNALLY_DISPUTED',
  /** Work Order Internal Dispute Resolved */
  WorkOrderInternalDisputeResolved = 'WORK_ORDER_INTERNAL_DISPUTE_RESOLVED',
  /** Work Order Moved Back To Awaiting Completion */
  WorkOrderMovedBackToAwaitingCompletion = 'WORK_ORDER_MOVED_BACK_TO_AWAITING_COMPLETION',
  /** Work Order Nte Updated */
  WorkOrderNteUpdated = 'WORK_ORDER_NTE_UPDATED',
  /** Work Order Overtime Approval Removed */
  WorkOrderOvertimeApprovalRemoved = 'WORK_ORDER_OVERTIME_APPROVAL_REMOVED',
  /** Work Order Overtime Approved */
  WorkOrderOvertimeApproved = 'WORK_ORDER_OVERTIME_APPROVED',
  /** Work Order Paid In Full */
  WorkOrderPaidInFull = 'WORK_ORDER_PAID_IN_FULL',
  /** Work Order Placed In Progress */
  WorkOrderPlacedInProgress = 'WORK_ORDER_PLACED_IN_PROGRESS',
  /** Work Order Placed On Hold */
  WorkOrderPlacedOnHold = 'WORK_ORDER_PLACED_ON_HOLD',
  /** Work Order Point Of Contact Changed */
  WorkOrderPointOfContactChanged = 'WORK_ORDER_POINT_OF_CONTACT_CHANGED',
  /** Work Order Reassigned To Team Member */
  WorkOrderReassignedToTeamMember = 'WORK_ORDER_REASSIGNED_TO_TEAM_MEMBER',
  /** Work Order Rejected */
  WorkOrderRejected = 'WORK_ORDER_REJECTED',
  /** Work Order Removed From Hold */
  WorkOrderRemovedFromHold = 'WORK_ORDER_REMOVED_FROM_HOLD',
  /** Work Order Rescheduled */
  WorkOrderRescheduled = 'WORK_ORDER_RESCHEDULED',
  /** Work Order Scheduled */
  WorkOrderScheduled = 'WORK_ORDER_SCHEDULED',
  /** Work Order Sent For Triage */
  WorkOrderSentForTriage = 'WORK_ORDER_SENT_FOR_TRIAGE',
  /** Work Order Status Update Created */
  WorkOrderStatusUpdateCreated = 'WORK_ORDER_STATUS_UPDATE_CREATED',
  /** Work Order Submitted */
  WorkOrderSubmitted = 'WORK_ORDER_SUBMITTED',
  /** Work Order Tech Reassigned */
  WorkOrderTechReassigned = 'WORK_ORDER_TECH_REASSIGNED',
  /** Work Order Unassigned */
  WorkOrderUnassigned = 'WORK_ORDER_UNASSIGNED',
  /** Work Order Uncancelled */
  WorkOrderUncancelled = 'WORK_ORDER_UNCANCELLED'
}

export type ActivityFeedEntryNode = Node & {
  __typename: 'ActivityFeedEntryNode';
  activityDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultMessage: Scalars['String']['output'];
  entryType: ActivityFeedEntryEntryType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalMessage: Maybe<Scalars['String']['output']>;
  parameters: Scalars['JSONString']['output'];
  triggeredBy: UserNode;
  visibleToClient: Scalars['Boolean']['output'];
};

export type ActivityFeedEntryNodeConnection = {
  __typename: 'ActivityFeedEntryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActivityFeedEntryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ActivityFeedEntryNode` and its cursor. */
export type ActivityFeedEntryNodeEdge = {
  __typename: 'ActivityFeedEntryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ActivityFeedEntryNode>;
};

/**
 *
 * Activity types for work order vendor status transitions.
 *
 */
export enum ActivityType {
  Appointment = 'APPOINTMENT',
  ApproveQuote = 'APPROVE_QUOTE',
  ChooseVendor = 'CHOOSE_VENDOR',
  CreateQuote = 'CREATE_QUOTE',
  Dispatch = 'DISPATCH',
  FindingQuote = 'FINDING_QUOTE',
  FindingVendor = 'FINDING_VENDOR',
  OnHold = 'ON_HOLD',
  ResqReview = 'RESQ_REVIEW',
  Scheduling = 'SCHEDULING',
  SiteVisit = 'SITE_VISIT',
  SourcingParts = 'SOURCING_PARTS'
}

/**
 * Click counters for a single ad banner campaign.
 *
 * `clicks` is the global total across all users. `userClicks` is scoped to
 * the currently authenticated user under their active vendor context (drives
 * placement-window extension). For unauthenticated callers, `userClicks` is 0.
 */
export type AdBannerStatsType = {
  __typename: 'AdBannerStatsType';
  clicks: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  userClicks: Scalars['Int']['output'];
};

export type AddAfterImagesToVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  images: Array<Scalars['String']['input']>;
  visit: Scalars['ID']['input'];
};

export type AddAfterImagesToVisitPayload = {
  __typename: 'AddAfterImagesToVisitPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  visit: VisitNode;
};

export type AddAttachmentMutation = {
  __typename: 'AddAttachmentMutation';
  attachment: AttachmentNode;
};

export type AddBarcodeMutationInput = {
  attachToId: Scalars['ID']['input'];
  barcode: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AddBarcodeMutationPayload = {
  __typename: 'AddBarcodeMutationPayload';
  barcode: BarcodeNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type AddBeforeImagesToVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  images: Array<Scalars['String']['input']>;
  visit: Scalars['ID']['input'];
};

export type AddBeforeImagesToVisitPayload = {
  __typename: 'AddBeforeImagesToVisitPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  visit: VisitNode;
};

export type AddClientOrganizationMutation = {
  __typename: 'AddClientOrganizationMutation';
  clientOrganization: ClientOrganizationNode;
};

export type AddEquipmentMutation = {
  __typename: 'AddEquipmentMutation';
  equipment: EquipmentNode;
  ok: Scalars['Boolean']['output'];
};

export type AddExistingUserToClientOrganizationMutation = {
  __typename: 'AddExistingUserToClientOrganizationMutation';
  ok: Scalars['Boolean']['output'];
};

export type AddExistingUserToVendorMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type AddExistingUserToVendorMutationPayload = {
  __typename: 'AddExistingUserToVendorMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AddExternalExpenseMutationInput = {
  allocatedAmount: Scalars['Decimal']['input'];
  attachmentFileType?: InputMaybe<Scalars['String']['input']>;
  attachmentLabel?: InputMaybe<Scalars['String']['input']>;
  budgetId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expenseDate: Scalars['Date']['input'];
  expenseType: ExpenseType;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  uploadedFileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AddExternalExpenseMutationPayload = {
  __typename: 'AddExternalExpenseMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  externalExpense: SpendItemAllocationNode;
};

export type AddGatewayInput = {
  awsId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type AddGatewayPayload = {
  __typename: 'AddGatewayPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AddImageToWorkOrderMutation = {
  __typename: 'AddImageToWorkOrderMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

export type AddNewUserToClientOrganizationMutation = {
  __typename: 'AddNewUserToClientOrganizationMutation';
  ok: Scalars['Boolean']['output'];
};

export type AddNewUserToVendorArguments = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type AddNewUserToVendorMutation = {
  __typename: 'AddNewUserToVendorMutation';
  ok: Scalars['Boolean']['output'];
};

export type AddOwnerToClientOrganizationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AddOwnerToClientOrganizationMutationPayload = {
  __typename: 'AddOwnerToClientOrganizationMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AddSensorToEquipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentCategory: Scalars['String']['input'];
  equipmentId: Scalars['ID']['input'];
  sensorAwsId: Scalars['String']['input'];
  sensorModel: Scalars['String']['input'];
  sensorName: Scalars['String']['input'];
};

export type AddSensorToEquipmentPayload = {
  __typename: 'AddSensorToEquipmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AddWorkOrdersToProjectMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  workOrderIds: Array<Scalars['ID']['input']>;
};

export type AddWorkOrdersToProjectMutationPayload = {
  __typename: 'AddWorkOrdersToProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  project: ProjectNode;
};

/** An enumeration. */
export enum AddonType {
  SensorGatewayHardware = 'SENSOR_GATEWAY_HARDWARE',
  SensorHardware = 'SENSOR_HARDWARE',
  SensorInstallation = 'SENSOR_INSTALLATION',
  SensorSubscription = 'SENSOR_SUBSCRIPTION',
  SubscriptionPromo = 'SUBSCRIPTION_PROMO',
  TaggingFee = 'TAGGING_FEE'
}

export type AddressNode = Node & {
  __typename: 'AddressNode';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type AddressValidation = {
  __typename: 'AddressValidation';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  formattedAddress: Maybe<Scalars['String']['output']>;
  isPoBox: Maybe<Scalars['Boolean']['output']>;
  province: Maybe<Scalars['String']['output']>;
  /** Components that have been spell checked with corrected values */
  spellCheckedComponents: Maybe<Array<Maybe<SpellCheckedAddressComponent>>>;
  /** List of unconfirmed address components */
  unconfirmedComponents: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AdvertisingCommercialHoldBlockerType = {
  __typename: 'AdvertisingCommercialHoldBlockerType';
  blocksManage: Scalars['Boolean']['output'];
  canAcknowledge: Scalars['Boolean']['output'];
  displayKey: Scalars['String']['output'];
  openedAt: Scalars['DateTime']['output'];
  reason: AdvertisingCommercialHoldReason;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  status: AdvertisingCommercialHoldStatus;
};

/** An enumeration. */
export enum AdvertisingCommercialHoldReason {
  ExposureThresholdReached = 'EXPOSURE_THRESHOLD_REACHED',
  NoVerifiedPaymentMethod = 'NO_VERIFIED_PAYMENT_METHOD',
  PaymentFailed = 'PAYMENT_FAILED'
}

export type AdvertisingCommercialHoldStateType = {
  __typename: 'AdvertisingCommercialHoldStateType';
  blockers: Array<AdvertisingCommercialHoldBlockerType>;
  hasBlockers: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum AdvertisingCommercialHoldStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Open = 'OPEN',
  ResolvedPendingAck = 'RESOLVED_PENDING_ACK'
}

/** An enumeration. */
export enum AfterHoursDispatchSetting {
  Accepts = 'ACCEPTS',
  DoesNotAccept = 'DOES_NOT_ACCEPT'
}

/** Communication channel for message delivery */
export enum AgentMessageChannel {
  Rcs = 'RCS',
  Simulator = 'SIMULATOR',
  Sms = 'SMS',
  Web = 'WEB',
  Whatsapp = 'WHATSAPP'
}

/** GraphQL type for agent messages from Nora API */
export type AgentMessageNode = {
  __typename: 'AgentMessageNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  jobId: Maybe<Scalars['Int']['output']>;
  messageChannel: AgentMessageChannel;
  messageReceivedAt: Maybe<Scalars['DateTime']['output']>;
  messageType: AgentMessageType;
  parts: Array<AgentMessagePartNode>;
  sid: Maybe<Scalars['String']['output']>;
  summary: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  user: Maybe<UserNode>;
  userId: Scalars['Int']['output'];
  workOrderId: Maybe<Scalars['Int']['output']>;
};

export type AgentMessageNodeConnection = {
  __typename: 'AgentMessageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgentMessageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgentMessageNode` and its cursor. */
export type AgentMessageNodeEdge = {
  __typename: 'AgentMessageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AgentMessageNode>;
};

/** GraphQL type for agent message parts (text, media, etc.) */
export type AgentMessagePartNode = {
  __typename: 'AgentMessagePartNode';
  content: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  mediaUrl: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['String']['output']>;
  s3Key: Maybe<Scalars['String']['output']>;
  status: Maybe<MediaProcessingStatus>;
};

/** Type of message based on sender role */
export enum AgentMessageType {
  Agent = 'AGENT',
  System = 'SYSTEM',
  User = 'USER'
}

export type AgreeVendorTosInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type AgreeVendorTosPayload = {
  __typename: 'AgreeVendorTOSPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorTosAgreement: VendorTosAgreementNode;
};

export type Alert = {
  __typename: 'Alert';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  incident: Incident;
  rawData: Array<AlertDataRow>;
  sent: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['Float']['output'];
};

export type AlertDataRow = {
  __typename: 'AlertDataRow';
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum AllocationCanActions {
  ChangeExpenseType = 'CHANGE_EXPENSE_TYPE'
}

export type AllocationNode = Node & {
  __typename: 'AllocationNode';
  allocationType: AllocationType;
  amount: Maybe<Scalars['Decimal']['output']>;
  attachment: Maybe<AttachmentNode>;
  can: Scalars['Boolean']['output'];
  category: Maybe<Scalars['String']['output']>;
  clientManagedInvoice: Maybe<ClientManagedInvoiceNode>;
  description: Maybe<Scalars['String']['output']>;
  expenseType: ExpenseType;
  facilityName: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalRequest: Maybe<InternalRequestNode>;
  invoice: Maybe<ClientInvoiceNode>;
  submittedDate: Scalars['DateTime']['output'];
  workOrder: Maybe<WorkOrderNode>;
};


export type AllocationNodeCanArgs = {
  perform: AllocationCanActions;
};

export type AllocationNodeConnection = {
  __typename: 'AllocationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllocationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AllocationNode` and its cursor. */
export type AllocationNodeEdge = {
  __typename: 'AllocationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AllocationNode>;
};

/** An enumeration. */
export enum AllocationType {
  ClientManagedInvoice = 'CLIENT_MANAGED_INVOICE',
  InternalRequest = 'INTERNAL_REQUEST',
  Invoice = 'INVOICE',
  SpendItem = 'SPEND_ITEM',
  Upcoming = 'UPCOMING'
}

export type ApBatchNode = Node & {
  __typename: 'ApBatchNode';
  code: Scalars['String']['output'];
  dueAtDate: Maybe<Scalars['Date']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  pdfFile: Maybe<FileType>;
  referenceDate: Maybe<Scalars['DateTime']['output']>;
  referenceNumber: Maybe<Scalars['String']['output']>;
  status: ApBatchStatus;
  totalAmount: Scalars['Decimal']['output'];
  vendorInvoices: Array<VendorInvoiceNode>;
  vendorOrganization: VendorOrganizationNode;
};

export type ApBatchNodeConnection = {
  __typename: 'ApBatchNodeConnection';
  cadTotal: Scalars['Decimal']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApBatchNodeEdge>>;
  gbpTotal: Scalars['Decimal']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  usdTotal: Scalars['Decimal']['output'];
};

/** A Relay edge containing a `ApBatchNode` and its cursor. */
export type ApBatchNodeEdge = {
  __typename: 'ApBatchNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ApBatchNode>;
};

/** An enumeration. */
export enum ApBatchStatus {
  Closed = 'CLOSED',
  PartiallyClosed = 'PARTIALLY_CLOSED',
  PayoutInitiated = 'PAYOUT_INITIATED',
  Unpaid = 'UNPAID'
}

/** An enumeration. */
export enum AppName {
  Facility = 'FACILITY',
  Vendor = 'VENDOR'
}

export type AppointmentActivity = Activity & Node & {
  __typename: 'AppointmentActivity';
  activityType: ActivityType;
  appointment: AppointmentNode;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<AppointmentActivityOutcome>;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum AppointmentActivityOutcome {
  Fulfilled = 'FULFILLED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  Rescheduled = 'RESCHEDULED'
}

export type AppointmentNode = Node & {
  __typename: 'AppointmentNode';
  afterImages: Array<ImageNode>;
  beforeImages: Array<ImageNode>;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  facilityManagerName: Maybe<Scalars['String']['output']>;
  fulfilledAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  otherReschedulingReason: Maybe<Scalars['String']['output']>;
  permissions: AppointmentPermissions;
  reschedulingReason: Maybe<AppointmentReschedulingReasonType>;
  /** @deprecated Use ended_at instead, they are roughly the same. */
  signedOffAt: Maybe<Scalars['DateTime']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  technician: Maybe<UserNode>;
  vendor: Maybe<VendorOrganizationNode>;
  vendorNotifiedOnTheWayAt: Maybe<Scalars['DateTime']['output']>;
  visit: Maybe<VisitNode>;
  visitedBy: Maybe<UserNode>;
  workOrder: WorkOrderNode;
};

export type AppointmentNodeConnection = {
  __typename: 'AppointmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AppointmentNode` and its cursor. */
export type AppointmentNodeEdge = {
  __typename: 'AppointmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AppointmentNode>;
};

export type AppointmentPermissions = {
  __typename: 'AppointmentPermissions';
  fulfill: Scalars['Boolean']['output'];
  hold: Scalars['Boolean']['output'];
  reschedule: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum AppointmentReschedulingReason {
  AdjustTechnician = 'ADJUST_TECHNICIAN',
  CustomerChangeOfTime = 'CUSTOMER_CHANGE_OF_TIME',
  EarlierService = 'EARLIER_SERVICE',
  ManagerNeeded = 'MANAGER_NEEDED',
  NeedCustomerConfirmation = 'NEED_CUSTOMER_CONFIRMATION',
  Other = 'OTHER',
  PartsNotAvailable = 'PARTS_NOT_AVAILABLE',
  Reprioritized = 'REPRIORITIZED',
  StoreClosed = 'STORE_CLOSED',
  TechnicianDelay = 'TECHNICIAN_DELAY',
  VendorNoShow = 'VENDOR_NO_SHOW',
  WeatherDelay = 'WEATHER_DELAY'
}

export type AppointmentReschedulingReasonType = {
  __typename: 'AppointmentReschedulingReasonType';
  key: AppointmentReschedulingReason;
  label: Scalars['String']['output'];
};

export type ApproveQuoteActivity = Activity & Node & {
  __typename: 'ApproveQuoteActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<ApproveQuoteActivityOutcome>;
  quoteSet: QuoteSetNode;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ApproveQuoteActivityOutcome {
  AnotherQuoteRequired = 'ANOTHER_QUOTE_REQUIRED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  PartsRequired = 'PARTS_REQUIRED',
  Rejected = 'REJECTED',
  ResqReviewRequired = 'RESQ_REVIEW_REQUIRED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type ApproveQuoteSetOptionForSpendInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteSetOptionId: Scalars['ID']['input'];
};

export type ApproveQuoteSetOptionForSpendPayload = {
  __typename: 'ApproveQuoteSetOptionForSpendPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

/** Approves a record of work for invoicing. */
export type ApproveRecordOfWorkMutation = {
  __typename: 'ApproveRecordOfWorkMutation';
  recordOfWork: RecordOfWorkNode;
};

export type ApproveWorkOrderClientInvoicesArguments = {
  workOrderId: Scalars['ID']['input'];
};

export type ApproveWorkOrderClientInvoicesMutation = {
  __typename: 'ApproveWorkOrderClientInvoicesMutation';
  invoiceApproval: WorkOrderClientInvoicesApprovalNode;
  ok: Scalars['Boolean']['output'];
};

export type ApproverContact = {
  __typename: 'ApproverContact';
  email: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type ArchiveProjectMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type ArchiveProjectMutationPayload = {
  __typename: 'ArchiveProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  project: ProjectNode;
};

export type ArchiveReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportTemplateId: Scalars['ID']['input'];
};

export type ArchiveReportTemplatePayload = {
  __typename: 'ArchiveReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  reportTemplate: ReportTemplateNode;
};

export type AssignUsersToRoleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssignUsersToRoleMutationPayload = {
  __typename: 'AssignUsersToRoleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AssignWorkOrderEscalationInput = {
  assignedUserId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escalationId: Scalars['ID']['input'];
};

export type AssignWorkOrderEscalationPayload = {
  __typename: 'AssignWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type AssociateUserTagsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userProfileId: Scalars['ID']['input'];
  userTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AssociateUserTagsMutationPayload = {
  __typename: 'AssociateUserTagsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  userProfile: UserProfileNode;
};

export type AttachQuoteSetToWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  quoteSetId: Scalars['ID']['input'];
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type AttachQuoteSetToWorkOrderPayload = {
  __typename: 'AttachQuoteSetToWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: Maybe<QuoteSetNode>;
};

export type AttachedTo = EquipmentNode | FacilityNode;

export type AttachedUrlInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type AttachedUrlNode = Node & {
  __typename: 'AttachedUrlNode';
  attachedBy: UserNode;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum AttachmentCanActions {
  Delete = 'DELETE'
}

export type AttachmentInput = {
  file: Scalars['String']['input'];
  fileContentType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentNode = Node & {
  __typename: 'AttachmentNode';
  attachedBy: UserNode;
  can: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  file: Maybe<FileType>;
  fileContentType: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  sourceUserType: SourceUserType;
  url: Scalars['String']['output'];
  videoPlaybackUrl: Maybe<Scalars['String']['output']>;
  videoPosterUrl: Maybe<Scalars['String']['output']>;
  videoTranscodeStatus: Maybe<Scalars['String']['output']>;
};


export type AttachmentNodeCanArgs = {
  perform: AttachmentCanActions;
};

export type AttachmentNodeConnection = {
  __typename: 'AttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AttachmentNode` and its cursor. */
export type AttachmentNodeEdge = {
  __typename: 'AttachmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AttachmentNode>;
};

/** An enumeration. */
export enum AudienceType {
  AllCustomers = 'ALL_CUSTOMERS',
  ExistingCustomers = 'EXISTING_CUSTOMERS',
  NewCustomers = 'NEW_CUSTOMERS'
}

export enum AuthMethodType {
  GoogleSso = 'GOOGLE_SSO',
  Impersonate = 'IMPERSONATE',
  MagicLink = 'MAGIC_LINK',
  MobileOauth = 'MOBILE_OAUTH',
  OffResq = 'OFF_RESQ',
  Password = 'PASSWORD',
  Saml = 'SAML',
  StaffGoogle = 'STAFF_GOOGLE',
  Unknown = 'UNKNOWN'
}

/** Represents available phone numbers for vendor reception setup. */
export type AvailableReceptionPhoneNumbersType = {
  __typename: 'AvailableReceptionPhoneNumbersType';
  message: Maybe<Scalars['String']['output']>;
  numbers: Array<Scalars['String']['output']>;
  suggestedAreaCodes: Array<Scalars['String']['output']>;
};

/** GraphQL node for available testimonials that can be selected for a business profile. */
export type AvailableTestimonialNode = {
  __typename: 'AvailableTestimonialNode';
  comment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type AvailableTimeSlotNode = {
  __typename: 'AvailableTimeSlotNode';
  date: Scalars['Date']['output'];
  endTime: Scalars['DateTime']['output'];
  slot: TimeSlotType;
  startTime: Scalars['DateTime']['output'];
};

export type AvailableVendorNode = Node & {
  __typename: 'AvailableVendorNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  operatingAreaMatch: Scalars['Boolean']['output'];
  vendorOrganization: VendorOrganizationNode;
};

export type AvailableVendorNodeConnection = {
  __typename: 'AvailableVendorNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AvailableVendorNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AvailableVendorNode` and its cursor. */
export type AvailableVendorNodeEdge = {
  __typename: 'AvailableVendorNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<AvailableVendorNode>;
};

export type AverageMonthlyFacilitySpend = {
  __typename: 'AverageMonthlyFacilitySpend';
  avgInternalMpSpend: Scalars['Decimal']['output'];
  avgInternalSpend: Scalars['Decimal']['output'];
  avgMpSpend: Scalars['Decimal']['output'];
  avgRepairSpend: Scalars['Decimal']['output'];
  date: Scalars['DateTime']['output'];
};

export type AverageSchedulingSpeed = {
  __typename: 'AverageSchedulingSpeed';
  days: Scalars['Int']['output'];
  hasData: Scalars['Boolean']['output'];
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  months: Scalars['Int']['output'];
};

export type BankAccountNode = Node & {
  __typename: 'BankAccountNode';
  externalBankAccount: Maybe<ExternalBankAccountNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  status: Maybe<BankAccountStatus>;
  type: BankAccountType;
};

export type BankAccountNodeConnection = {
  __typename: 'BankAccountNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BankAccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BankAccountNode` and its cursor. */
export type BankAccountNodeEdge = {
  __typename: 'BankAccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BankAccountNode>;
};

/** An enumeration. */
export enum BankAccountRecordBankAccount {
  /** CAD RBC */
  CadRbc = 'CAD_RBC',
  /** GBP WISE */
  GbpWise = 'GBP_WISE',
  /** USD COMERICA */
  UsdComerica = 'USD_COMERICA'
}

/** An enumeration. */
export enum BankAccountRecordCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

/** Type for BankAccountRecord, which tracks bank account transactions and their processing status. */
export type BankAccountRecordNode = Node & {
  __typename: 'BankAccountRecordNode';
  amount: Scalars['Decimal']['output'];
  bankAccount: BankAccountRecordBankAccount;
  createdAt: Scalars['DateTime']['output'];
  currency: Maybe<BankAccountRecordCurrency>;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  notes: Maybe<Scalars['String']['output']>;
  remittanceStatement: Maybe<RemittanceStatementNode>;
  status: BankAccountRecordStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankAccountRecordNodeConnection = {
  __typename: 'BankAccountRecordNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BankAccountRecordNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BankAccountRecordNode` and its cursor. */
export type BankAccountRecordNodeEdge = {
  __typename: 'BankAccountRecordNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BankAccountRecordNode>;
};

/** An enumeration. */
export enum BankAccountRecordStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Manual */
  Manual = 'MANUAL',
  /** Matched */
  Matched = 'MATCHED',
  /** Overpaid */
  Overpaid = 'OVERPAID',
  /** Pending */
  Pending = 'PENDING',
  /** Processed */
  Processed = 'PROCESSED'
}

export enum BankAccountStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Restricted = 'RESTRICTED',
  Verified = 'VERIFIED'
}

/** An enumeration. */
export enum BankAccountType {
  ExternalAstraBankAccount = 'EXTERNAL_ASTRA_BANK_ACCOUNT',
  ExternalOrumBankAccount = 'EXTERNAL_ORUM_BANK_ACCOUNT',
  ExternalUnitBankAccount = 'EXTERNAL_UNIT_BANK_ACCOUNT',
  ExternalUnitMasterAccount = 'EXTERNAL_UNIT_MASTER_ACCOUNT',
  ExternalUsioBankAccount = 'EXTERNAL_USIO_BANK_ACCOUNT',
  InternalAccount = 'INTERNAL_ACCOUNT',
  InternalUnitMasterAccount = 'INTERNAL_UNIT_MASTER_ACCOUNT'
}

export type BarcodeNode = Node & {
  __typename: 'BarcodeNode';
  attachedBy: UserNode;
  attachedTo: Maybe<AttachedTo>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type BarcodeNodeConnection = {
  __typename: 'BarcodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BarcodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BarcodeNode` and its cursor. */
export type BarcodeNodeEdge = {
  __typename: 'BarcodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BarcodeNode>;
};

export type BatchPaymentNode = Node & {
  __typename: 'BatchPaymentNode';
  amount: Scalars['Decimal']['output'];
  canEditReferenceDate: Scalars['Boolean']['output'];
  chequeNumber: Maybe<Scalars['String']['output']>;
  currency: Currency;
  customerName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  memo: Maybe<Scalars['String']['output']>;
  organization: Maybe<ClientOrganizationNode>;
  paymentMethod: PaymentType;
  referenceDate: Scalars['DateTime']['output'];
  refundHashKey: Scalars['String']['output'];
  remittanceStatement: Maybe<RemittanceStatementNode>;
  status: PaymentStatus;
};

export type BatchPaymentNodeConnection = {
  __typename: 'BatchPaymentNodeConnection';
  cadTotal: Scalars['Decimal']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BatchPaymentNodeEdge>>;
  gbpTotal: Scalars['Decimal']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  usdTotal: Scalars['Decimal']['output'];
};

/** A Relay edge containing a `BatchPaymentNode` and its cursor. */
export type BatchPaymentNodeEdge = {
  __typename: 'BatchPaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BatchPaymentNode>;
};

export type BeneficialOwnerInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityName: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  dateOfBirth: Scalars['Date']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  ssn: Scalars['String']['input'];
};

export type BillingAddressNode = Node & {
  __typename: 'BillingAddressNode';
  address: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  city: CityNode;
  cityName: Maybe<Scalars['String']['output']>;
  country: CountryNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lat: Maybe<Scalars['Float']['output']>;
  lng: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  province: ProvinceNode;
};

export type BillingContactMutationInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

/** An enumeration. */
export enum BillingFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export type BillingInformationNode = Node & {
  __typename: 'BillingInformationNode';
  /** The time at which the autopay field of the billing information was updated. */
  autopayUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  autopayUpdatedBy: Maybe<UserNode>;
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isAutopay: Scalars['Boolean']['output'];
  /** When enabled, clients pay vendors directly instead of through ResQ for eligible work orders. */
  isDirectVendorPayment: Scalars['Boolean']['output'];
  operatingCountry: CountryNode;
  paymentTerms: Maybe<Scalars['Int']['output']>;
};

export type BillingInformationNodeConnection = {
  __typename: 'BillingInformationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingInformationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BillingInformationNode` and its cursor. */
export type BillingInformationNodeEdge = {
  __typename: 'BillingInformationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BillingInformationNode>;
};

export type BillingPeriodNode = {
  __typename: 'BillingPeriodNode';
  endDate: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
};

export type BlockApMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BlockApMutationPayload = {
  __typename: 'BlockAPMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BlockedEntity = VendorOrganizationNode | WorkOrderNode;

export type BrandNode = Node & {
  __typename: 'BrandNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  logo: Maybe<ImageType>;
  name: Scalars['String']['output'];
};

export type BrandNodeConnection = {
  __typename: 'BrandNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BrandNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BrandNode` and its cursor. */
export type BrandNodeEdge = {
  __typename: 'BrandNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BrandNode>;
};

export enum BudgetCanActions {
  CreateBudget = 'CREATE_BUDGET'
}

export type BudgetConfigurationNode = Node & {
  __typename: 'BudgetConfigurationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isCapex: Scalars['Boolean']['output'];
  isMaintenancePlan: Scalars['Boolean']['output'];
  isOnDemand: Scalars['Boolean']['output'];
  isOpex: Scalars['Boolean']['output'];
  serviceCategories: Array<ServiceCategory>;
};

export type BudgetNode = Node & {
  __typename: 'BudgetNode';
  can: Scalars['Boolean']['output'];
  capexSpentAmount: Scalars['Decimal']['output'];
  categorySpend: Maybe<Array<ExpensePerCategorySpendData>>;
  configuration: Maybe<BudgetConfigurationNode>;
  description: Scalars['String']['output'];
  endDate: Scalars['Date']['output'];
  /** @deprecated Deprecated in favour of the budget configuration */
  expenseType: Maybe<ExpenseType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  maintenancePlanSpentAmount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  onDemandSpentAmount: Scalars['Decimal']['output'];
  opexSpentAmount: Scalars['Decimal']['output'];
  organizationId: Scalars['Int']['output'];
  spentAmount: Scalars['Decimal']['output'];
  startDate: Scalars['Date']['output'];
  totalAmount: Scalars['Decimal']['output'];
  unallottedAmount: Scalars['Decimal']['output'];
  upcomingSpendAmount: Scalars['Decimal']['output'];
};


export type BudgetNodeCanArgs = {
  perform: BudgetCanActions;
};

export type BudgetNodeConnection = {
  __typename: 'BudgetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BudgetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BudgetNode` and its cursor. */
export type BudgetNodeEdge = {
  __typename: 'BudgetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BudgetNode>;
};

export type BulkCreateFavouriteVendorConfigurationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviterName?: InputMaybe<Scalars['String']['input']>;
  inviterNote?: InputMaybe<Scalars['String']['input']>;
  isInherited?: InputMaybe<Scalars['Boolean']['input']>;
  subscribeInviter?: InputMaybe<Scalars['Boolean']['input']>;
  vendorInvites: Array<VendorInviteValues>;
};

export type BulkCreateFavouriteVendorConfigurationPayload = {
  __typename: 'BulkCreateFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BulkDeleteFavouriteVendorConfigurationsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientVendorRelationshipId: Scalars['ID']['input'];
};

export type BulkDeleteFavouriteVendorConfigurationsPayload = {
  __typename: 'BulkDeleteFavouriteVendorConfigurationsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BulkInviteMembersToClientOrganizationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invites: Array<InviteInput>;
  organizationId: Scalars['ID']['input'];
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Create multiple invites in a single operation.
 *
 * This mutation processes all invites in a single transaction, which:
 * 1. Prevents partial success for bulk invite operations
 * 2. Improves performance by reducing repeated setup/teardown work
 *
 * Atomic behavior:
 * - If any invite fails validation, the entire operation fails and rolls back
 * - All invites succeed or none do
 */
export type BulkInviteMembersToClientOrganizationMutationPayload = {
  __typename: 'BulkInviteMembersToClientOrganizationMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  invites: Array<InviteNode>;
};

export type BulkRerunNoraCallEvaluations = {
  __typename: 'BulkRerunNoraCallEvaluations';
  count: Scalars['Int']['output'];
};

export type BusinessAdminAddressInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityName: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum BusinessLegalStructure {
  BCorporation = 'B_CORPORATION',
  CCorporation = 'C_CORPORATION',
  LimitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
  LimitedLiabilityPartnership = 'LIMITED_LIABILITY_PARTNERSHIP',
  NonprofitCorporation = 'NONPROFIT_CORPORATION',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  SCorporation = 'S_CORPORATION'
}

/** An enumeration. */
export enum BusinessRegistrationNumberType {
  Bn = 'BN',
  Crn = 'CRN',
  Ein = 'EIN',
  Tin = 'TIN'
}

/** An enumeration. */
export enum BusinessUnitGroupingMode {
  BusinessUnit = 'BUSINESS_UNIT',
  IndividualFacility = 'INDIVIDUAL_FACILITY'
}

export type BusinessUnitMemberNode = Node & {
  __typename: 'BusinessUnitMemberNode';
  businessUnit: BusinessUnitNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Shortcut for retrieving roles of user in business unit client. */
  roles: Array<RoleNode>;
  user: UserNode;
};

export type BusinessUnitNode = Node & {
  __typename: 'BusinessUnitNode';
  billingAddress: BillingAddressNode;
  businessLegalStructure: Maybe<BusinessLegalStructure>;
  businessRegistrationNumberType: Maybe<BusinessRegistrationNumberType>;
  businessTaxNumber: Maybe<Scalars['String']['output']>;
  client: ClientOrganizationNode;
  clientInvoices: Array<ClientInvoiceNode>;
  clientStatements: Array<ClientMonthlyStatementNode>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactName: Maybe<Scalars['String']['output']>;
  facilities: Array<FacilityNode>;
  facilityCount: Scalars['Int']['output'];
  groupedSubscriptionDataHashKey: Maybe<Scalars['String']['output']>;
  groupingMode: BusinessUnitGroupingMode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Int']['output'];
  members: Array<BusinessUnitMemberNode>;
  name: Scalars['String']['output'];
  nextSubscriptionSync: Maybe<Scalars['DateTime']['output']>;
  /** Contact's email, used to create a user after onboarding. Is set during onboarding when owner does not have payment method info */
  paymentContactEmail: Maybe<Scalars['String']['output']>;
  /** Contact's name, used to create a user after onboarding. Is set during onboarding when owner does not have payment method info */
  paymentContactName: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  pk: Scalars['Int']['output'];
  subscriptionId: Maybe<Scalars['String']['output']>;
  subscriptionUnitAmount: Maybe<Scalars['Decimal']['output']>;
  taggingFee: Maybe<Scalars['Decimal']['output']>;
  taxExempt: Maybe<Scalars['Boolean']['output']>;
  unpaidGroupedSubscriptionInvoices: Array<ClientInvoiceNode>;
  upcomingGroupedSubscriptionInvoicePreview: Maybe<SubscriptionInvoicePreview>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type BusinessUnitNodeConnection = {
  __typename: 'BusinessUnitNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BusinessUnitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BusinessUnitNode` and its cursor. */
export type BusinessUnitNodeEdge = {
  __typename: 'BusinessUnitNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<BusinessUnitNode>;
};

export type CcAccountInput = {
  externalReferenceId: Scalars['String']['input'];
  externalReferenceType: PaymentMethodExternalType;
};

export type CalculatedInvoiceNode = Node & {
  __typename: 'CalculatedInvoiceNode';
  clientSubtotal: Scalars['Decimal']['output'];
  clientSubtotalExcludingInvoiceLevelFees: Scalars['Decimal']['output'];
  clientTaxes: Array<ClientInvoiceTaxNode>;
  clientTotal: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lineItemTaxes: Array<CalculatedLineItemNode>;
  vendorRevShareTotal: Scalars['Decimal']['output'];
  vendorSubtotal: Scalars['Decimal']['output'];
  vendorTaxes: Array<VendorInvoiceTaxNode>;
  vendorTotal: Scalars['Decimal']['output'];
};

export type CalculatedLineItemNode = Node & {
  __typename: 'CalculatedLineItemNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  itemType: RecordOfWorkLineItemEnum;
  order: Scalars['Int']['output'];
  taxRates: Array<TaxRateNode>;
  vendorTaxRates: Array<TaxRateNode>;
};

export type CancelInviteMutation = {
  __typename: 'CancelInviteMutation';
  ok: Scalars['Boolean']['output'];
};

export type CancelMaintenancePlanMutation = {
  __typename: 'CancelMaintenancePlanMutation';
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum CancelReason {
  DeletedFacility = 'DELETED_FACILITY',
  FacilityShutDown = 'FACILITY_SHUT_DOWN',
  GroupNoLongerOnResq = 'GROUP_NO_LONGER_ON_RESQ',
  MigrateDeactivatedFacility = 'MIGRATE_DEACTIVATED_FACILITY',
  MigratingToUbp = 'MIGRATING_TO_UBP',
  ResqTerminatedRelationship = 'RESQ_TERMINATED_RELATIONSHIP'
}

export type CancelSubscriptionInput = {
  cancelReason?: InputMaybe<CancelReason>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataHashKey: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
};

export type CancelSubscriptionPayload = {
  __typename: 'CancelSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CancelVendorSubcontractMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Cancel active/pending subcontract and return execution to the Parent Vendor. */
export type CancelVendorSubcontractMutationPayload = {
  __typename: 'CancelVendorSubcontractMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  subcontract: WorkOrderSubcontractType;
  workOrder: Maybe<WorkOrderNode>;
};

export type CancelWorkOrderMutation = {
  __typename: 'CancelWorkOrderMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

export type CaptureVisitNotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerSignature?: InputMaybe<FacilityManagerSignatureInput>;
  images: Array<Image>;
  notes: Scalars['String']['input'];
  recommendations: Scalars['String']['input'];
  visit: Scalars['ID']['input'];
};

export type CaptureVisitNotesPayload = {
  __typename: 'CaptureVisitNotesPayload';
  aiTextSuggestions: Array<AiTextSuggestionType>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CategoryNode = Node & {
  __typename: 'CategoryNode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  equipmentRelated: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  trades: Array<TradeNode>;
};

export type CategoryNodeConnection = {
  __typename: 'CategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoryNode` and its cursor. */
export type CategoryNodeEdge = {
  __typename: 'CategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CategoryNode>;
};

export type ChangePasswordArguments = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ChangePasswordMutation = {
  __typename: 'ChangePasswordMutation';
  ok: Scalars['Boolean']['output'];
};

export type ChangeTradePlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newServiceName: ResqServiceName;
  organizationId: Scalars['ID']['input'];
  /** Optional timing preference for upgrades. Ignored for downgrades (always AT_RENEWAL). */
  preferredTiming?: InputMaybe<TradesSubscriptionChangeTiming>;
};

export type ChangeTradePlanPayload = {
  __typename: 'ChangeTradePlanPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  effectiveDate: Maybe<Scalars['Date']['output']>;
  failureReason: Maybe<TradesSubscriptionPlanChangeFailureReason>;
  isTrial: Scalars['Boolean']['output'];
  newSubscription: Maybe<OrganizationSubscriptionNode>;
  previousSubscription: Maybe<OrganizationSubscriptionNode>;
  status: TradesSubscriptionPlanChangeStatus;
  trialEndDate: Maybe<Scalars['Date']['output']>;
};

export type ChargePaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  funding?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentPlanId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetIds: Array<Scalars['ID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  pendingDeletion?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ChargePaymentMethodPayload = {
  __typename: 'ChargePaymentMethodPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentSubmittedInvoices: Maybe<Array<ClientInvoiceNode>>;
};

export type ChargeSubscriptionInvoicesMutationInput = {
  clientInvoiceIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentPlanId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

export type ChargeSubscriptionInvoicesMutationPayload = {
  __typename: 'ChargeSubscriptionInvoicesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentSubmittedInvoices: Maybe<Array<ClientInvoiceNode>>;
};

export type CheckUncheckWorkOrderTaskInput = {
  checked: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internalRequestId: Scalars['ID']['input'];
  taskListItemId: Scalars['ID']['input'];
};

export type CheckUncheckWorkOrderTaskPayload = {
  __typename: 'CheckUncheckWorkOrderTaskPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  taskListItem: WorkOrderTaskListItemNode;
};

export type ChooseVendorActivity = Activity & Node & {
  __typename: 'ChooseVendorActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<ChooseVendorActivityOutcome>;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ChooseVendorActivityOutcome {
  Chosen = 'CHOSEN',
  Failed = 'FAILED'
}

export type CityNode = Node & {
  __typename: 'CityNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CityNodeConnection = {
  __typename: 'CityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename: 'CityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CityNode>;
};

export enum ClientCalendarItemType {
  ScheduledExternal = 'SCHEDULED_EXTERNAL',
  ScheduledInternal = 'SCHEDULED_INTERNAL',
  UnscheduledExternal = 'UNSCHEDULED_EXTERNAL',
  UnscheduledInternal = 'UNSCHEDULED_INTERNAL',
  UpcomingExternal = 'UPCOMING_EXTERNAL',
  UpcomingInternal = 'UPCOMING_INTERNAL'
}

export type ClientCalendarItemsSet = {
  __typename: 'ClientCalendarItemsSet';
  scheduledExternalItems: Array<ScheduledExternalItem>;
  scheduledInternalItems: Array<ScheduledInternalItem>;
  unscheduledExternalItems: Array<UnscheduledExternalItem>;
  unscheduledInternalItems: Array<UnscheduledInternalItem>;
  upcomingExternalItems: Array<UpcomingExternalItem>;
  upcomingInternalItems: Array<UpcomingInternalItem>;
};

/** An enumeration. */
export enum ClientFeature {
  ClientRequestMpQuote = 'CLIENT_REQUEST_MP_QUOTE',
  Iyov = 'IYOV',
  NamedCsm = 'NAMED_CSM'
}

export type ClientInvoiceNode = Node & {
  __typename: 'ClientInvoiceNode';
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  businessUnit: Maybe<BusinessUnitNode>;
  chequeNumber: Maybe<Scalars['String']['output']>;
  clientOrganization: Maybe<ClientOrganizationNode>;
  code: Scalars['String']['output'];
  currency: Currency;
  dueAtDate: Scalars['Date']['output'];
  expenseType: Maybe<ExpenseType>;
  externalReferenceNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Client invoices are no longer linked directly to a facility. If the invoice is not subscription based, facility can be found under the work_order node. */
  facility: Maybe<FacilityNode>;
  hasAppliedProtectionPlan: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSet: Maybe<InvoiceSetNode>;
  invoicingVersion: InvoicingVersion;
  isSubscriptionInvoice: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by "issued_at_date" */
  issuedAt: Scalars['DateTime']['output'];
  issuedAtDate: Scalars['Date']['output'];
  lateFees: Scalars['Decimal']['output'];
  /** If payment failed, the reason for the failure. */
  latestFailureReason: Maybe<Scalars['String']['output']>;
  legacyId: Scalars['Int']['output'];
  lineItemsSubtotal: Scalars['Decimal']['output'];
  memo: Maybe<Scalars['String']['output']>;
  outstandingAmount: Scalars['Decimal']['output'];
  paidAmount: Scalars['Float']['output'];
  paidAt: Maybe<Scalars['DateTime']['output']>;
  paymentInitiatedAt: Maybe<Scalars['DateTime']['output']>;
  paymentInitiatedBy: Maybe<UserNode>;
  paymentStatus: Maybe<PaymentStatus>;
  payments: Array<PaymentNode>;
  pdfUrl: Maybe<Scalars['String']['output']>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  status: ClientInvoiceStatus;
  subtotal: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
  taxes: Array<ClientInvoiceTaxNode>;
  total: Scalars['Float']['output'];
  vapiCallResults: Maybe<Array<VapiOverdueInvoicesCallResultNode>>;
  vapiCallSuccessEvaluations: Maybe<Array<VapiOverdueInvoicesCallSuccessEvaluationNode>>;
  workOrder: Maybe<WorkOrderNode>;
};

export type ClientInvoiceNodeConnection = {
  __typename: 'ClientInvoiceNodeConnection';
  cadTotal: Scalars['Decimal']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientInvoiceNodeEdge>>;
  gbpTotal: Scalars['Decimal']['output'];
  lateFeeTotal: Scalars['Decimal']['output'];
  outstandingTotal: Scalars['Decimal']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  total: Scalars['Decimal']['output'];
  totalCount: Scalars['Int']['output'];
  usdTotal: Scalars['Decimal']['output'];
};

/** A Relay edge containing a `ClientInvoiceNode` and its cursor. */
export type ClientInvoiceNodeEdge = {
  __typename: 'ClientInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientInvoiceNode>;
};

export enum ClientInvoiceStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PaymentInitiated = 'PAYMENT_INITIATED',
  Unpaid = 'UNPAID'
}

export type ClientInvoiceTaxNode = Node & {
  __typename: 'ClientInvoiceTaxNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  taxRate: TaxRateNode;
  total: Scalars['Decimal']['output'];
};

export type ClientManagedInvoiceNode = Node & {
  __typename: 'ClientManagedInvoiceNode';
  /** The total amount of the invoice from the vendor. */
  amount: Scalars['Decimal']['output'];
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The due date on the vendor's invoice. */
  dueAtDate: Maybe<Scalars['Date']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceFile: FileType;
  /** Timestamp when the invoice was marked as paid by the client. */
  paidAtDate: Maybe<Scalars['DateTime']['output']>;
  permissions: ClientManagedInvoicePermissions;
  /** Optional reference number for the invoice. */
  referenceNumber: Maybe<Scalars['String']['output']>;
  status: ClientManagedInvoiceStatus;
  workOrder: Maybe<WorkOrderNode>;
};

export type ClientManagedInvoiceNodeConnection = {
  __typename: 'ClientManagedInvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientManagedInvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientManagedInvoiceNode` and its cursor. */
export type ClientManagedInvoiceNodeEdge = {
  __typename: 'ClientManagedInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientManagedInvoiceNode>;
};

export type ClientManagedInvoicePermissions = {
  __typename: 'ClientManagedInvoicePermissions';
  markAsPaid: Scalars['Boolean']['output'];
  markAsUnpaid: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum ClientManagedInvoiceStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type ClientMatchingProfileNode = Node & {
  __typename: 'ClientMatchingProfileNode';
  /** Indicates if their inherited vendors have been migrated to favourite vendors. This will hide all inherited vendor and dispatch preference FE for the client on both RMC and RCC if true. */
  favouriteVendorsImported: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  optedIntoMarketplace: Scalars['Boolean']['output'];
};

export enum ClientMembershipCanActions {
  BeAssigned = 'BE_ASSIGNED',
  Manage = 'MANAGE'
}

export type ClientMetricsNode = Node & {
  __typename: 'ClientMetricsNode';
  averageMonthlyFacilitySpend: Array<AverageMonthlyFacilitySpend>;
  averageSchedulingSpeed: AverageSchedulingSpeed;
  clientId: Scalars['ID']['output'];
  combinedSpend: Array<SpendByPeriod>;
  combinedUninvoiced: Array<UninvoicedByPeriod>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoicesAwaitingClientApproval: Scalars['Int']['output'];
  lastMonthSpendComparison: PeriodicSpendComparison;
  mostServicedEquipment: Array<EquipmentServiceCount>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  quotesAwaitingClientApproval: Scalars['Int']['output'];
  reviewSummary: ReviewSummary;
  serviceCategorySpend: Array<SpendByServiceCategory>;
  spendThisPeriod: Scalars['Decimal']['output'];
  spendThisPeriodBreakdown: SpendThisPeriodBreakdown;
  topSpendFacilities: Array<TopSpendFacilities>;
  topSpendWorkOrders: Array<TopSpendWorkOrders>;
  transactingFacilities: Scalars['Int']['output'];
  workOrdersAwaitingPayment: WorkOrdersAwaitingPayment;
  workOrdersAwaitingTriage: Scalars['Int']['output'];
  workOrdersByCategory: Array<ServiceCategoryCount>;
  workOrdersByStatus: WorkOrdersByStatus;
  workOrdersCompleted: Scalars['Int']['output'];
  workOrdersSubmitted: WorkOrdersSubmitted;
};

export type ClientMonthlyStatementNode = Node & {
  __typename: 'ClientMonthlyStatementNode';
  agingReportPdfUrl: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnitNode;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  outstandingAmount: Scalars['Decimal']['output'];
  transactionSummaryCsvUrl: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type ClientMonthlyStatementNodeConnection = {
  __typename: 'ClientMonthlyStatementNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientMonthlyStatementNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientMonthlyStatementNode` and its cursor. */
export type ClientMonthlyStatementNodeEdge = {
  __typename: 'ClientMonthlyStatementNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientMonthlyStatementNode>;
};

export type ClientOrganizationMemberNode = Node & {
  __typename: 'ClientOrganizationMemberNode';
  businessUnits: Array<BusinessUnitNode>;
  can: Scalars['Boolean']['output'];
  client: ClientOrganizationNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  roles: Array<RoleNode>;
  user: UserNode;
};


export type ClientOrganizationMemberNodeCanArgs = {
  perform: ClientMembershipCanActions;
};

export type ClientOrganizationMemberNodeConnection = {
  __typename: 'ClientOrganizationMemberNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientOrganizationMemberNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientOrganizationMemberNode` and its cursor. */
export type ClientOrganizationMemberNodeEdge = {
  __typename: 'ClientOrganizationMemberNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientOrganizationMemberNode>;
};

export type ClientOrganizationNode = Node & {
  __typename: 'ClientOrganizationNode';
  billingInformation: BillingInformationNode;
  businessTaxNumber: Maybe<Scalars['String']['output']>;
  businessUnits: Array<BusinessUnitNode>;
  can: Scalars['Boolean']['output'];
  clientStatus: Maybe<ClientOrganizationStatus>;
  code: Scalars['String']['output'];
  contractSignedOn: Maybe<Scalars['Date']['output']>;
  creditCardFeeNotice: Maybe<CreditCardFeeNotice>;
  facilities: Array<FacilityNode>;
  facilityGroups: Array<FacilityGroupNode>;
  featureTier: Maybe<FeatureTierNode>;
  /** @deprecated Deprecated in favour of roles with onlySubsetOfUser filter */
  grantableRoles: Array<RoleNode>;
  hasActiveProtectionPlanConfiguration: Scalars['Boolean']['output'];
  hasFacilityInCore: Maybe<Scalars['Boolean']['output']>;
  hasMissingSubscriptionPaymentMethod: Scalars['Boolean']['output'];
  hasVendorIssuedInvoices: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invites: Array<InviteNode>;
  isEnterprise: Maybe<Scalars['Boolean']['output']>;
  isSubscriptionLive: Scalars['Boolean']['output'];
  isSubscriptionMigrated: Scalars['Boolean']['output'];
  isTestData: Scalars['Boolean']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  lendingEnabled: Maybe<Scalars['Boolean']['output']>;
  matchingProfile: Maybe<ClientMatchingProfileNode>;
  members: Array<ClientOrganizationMemberNode>;
  name: Scalars['String']['output'];
  owner: Maybe<UserNode>;
  paymentPreference: ClientPaymentPreferenceNode;
  pricingModel: Maybe<PricingModelNode>;
  qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode;
  reportingManager: Maybe<UserNode>;
  sensitivity: Maybe<Sensitivity>;
  successOwner: Maybe<UserNode>;
  tier: Maybe<ClientTier>;
  trackingId: Scalars['Int']['output'];
  viewerDailyMenuFirstRunConfirmed: Scalars['Boolean']['output'];
  viewerDailyMenuFirstRunConfirmedAt: Maybe<Scalars['DateTime']['output']>;
};


export type ClientOrganizationNodeCanArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  perform: OrganizationCanActions;
};

export type ClientOrganizationNodeConnection = {
  __typename: 'ClientOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientOrganizationNode` and its cursor. */
export type ClientOrganizationNodeEdge = {
  __typename: 'ClientOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientOrganizationNode>;
};

/** An enumeration. */
export enum ClientOrganizationStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export type ClientPaymentPreferenceNode = Node & {
  __typename: 'ClientPaymentPreferenceNode';
  defaultDispatchMethod: DispatchMethod;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceApprovalStrategy: InvoiceApprovalStrategy;
  markupPercentage: Scalars['Decimal']['output'];
  offlinePaymentMethod: Maybe<OfflinePaymentMethods>;
  paymentMethod: PaymentMethodType;
  quoteApprovalStrategy: QuoteApprovalStrategy;
};

export type ClientPreferredSpendThresholdNode = Node & {
  __typename: 'ClientPreferredSpendThresholdNode';
  approvalRequiredOvertimeThreshold: Scalars['Int']['output'];
  approvalRequiredThreshold: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum ClientReportFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ClientReportNode = Node & {
  __typename: 'ClientReportNode';
  csvUrl: Maybe<Scalars['String']['output']>;
  /** The end date of the range this report was generated for. */
  endDate: Scalars['Date']['output'];
  /** The date this report was generated and sent out. */
  generatedOn: Scalars['Date']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reportType: ClientReportType;
  /** The start date of the range this report was generated for. */
  startDate: Scalars['Date']['output'];
};

export type ClientReportNodeConnection = {
  __typename: 'ClientReportNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientReportNode` and its cursor. */
export type ClientReportNodeEdge = {
  __typename: 'ClientReportNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientReportNode>;
};

export type ClientReportScheduleNode = Node & {
  __typename: 'ClientReportScheduleNode';
  frequency: ClientReportFrequency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastReportOn: Maybe<Scalars['Date']['output']>;
  nextReportOn: Maybe<Scalars['Date']['output']>;
  recipientEmailAddresses: Array<Scalars['String']['output']>;
  reportType: ClientReportType;
};

export type ClientReportScheduleNodeConnection = {
  __typename: 'ClientReportScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientReportScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientReportScheduleNode` and its cursor. */
export type ClientReportScheduleNodeEdge = {
  __typename: 'ClientReportScheduleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientReportScheduleNode>;
};

/** An enumeration. */
export enum ClientReportType {
  TransactionSummary = 'TRANSACTION_SUMMARY',
  WorkOrderSummary = 'WORK_ORDER_SUMMARY'
}

export type ClientStaffSchedule = {
  __typename: 'ClientStaffSchedule';
  scheduledInternalItems: Array<ScheduledInternalItem>;
  unscheduledInternalItems: Array<UnscheduledInternalItem>;
  upcomingInternalItems: Array<UpcomingInternalItem>;
  user: UserNode;
};

/** An enumeration. */
export enum ClientTier {
  ClientTier_1 = 'CLIENT_TIER_1',
  ClientTier_2 = 'CLIENT_TIER_2',
  ClientTier_3 = 'CLIENT_TIER_3'
}

export type ClientVendorRelationshipMetrics = {
  __typename: 'ClientVendorRelationshipMetrics';
  categoriesServiced: Maybe<Array<ServiceCategory>>;
  facilitiesInOperatingAreaCount: Scalars['Int']['output'];
  facilitiesInOperatingAreaWithCompletedWoCount: Scalars['Int']['output'];
  firstJobCompletionDate: Maybe<Scalars['DateTime']['output']>;
  maintenancePlansServicedCount: Scalars['Int']['output'];
  satisfactionRate: SatisfactionRate;
  totalInvoicedAmount: Scalars['Decimal']['output'];
  totalJobsCompletedCount: Scalars['Int']['output'];
};

export type ClientVendorRelationshipNode = Node & {
  __typename: 'ClientVendorRelationshipNode';
  client: ClientOrganizationNode;
  clientPaymentTerms: Maybe<Scalars['Int']['output']>;
  favouriteVendorConfigurations: Maybe<Array<FavouriteVendorConfigurationNode>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invite: Maybe<InviteNode>;
  invitedBy: Maybe<UserNode>;
  metrics: ClientVendorRelationshipMetrics;
  permissions: ClientVendorRelationshipPermissions;
  source: RelationshipSource;
  vendor: VendorOrganizationNode;
};


export type ClientVendorRelationshipNodeMetricsArgs = {
  metricsRangeWeeks: Scalars['Int']['input'];
};

export type ClientVendorRelationshipNodeConnection = {
  __typename: 'ClientVendorRelationshipNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientVendorRelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientVendorRelationshipNode` and its cursor. */
export type ClientVendorRelationshipNodeEdge = {
  __typename: 'ClientVendorRelationshipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ClientVendorRelationshipNode>;
};

export type ClientVendorRelationshipPermissions = {
  __typename: 'ClientVendorRelationshipPermissions';
  bulkDeleteFavourites: Scalars['Boolean']['output'];
};

export enum ClientWorkOrderStatus {
  AssignedToTeamMember = 'ASSIGNED_TO_TEAM_MEMBER',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Rejected = 'REJECTED',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING',
  Triage = 'TRIAGE'
}

export type CloseWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type CloseWorkOrderPayload = {
  __typename: 'CloseWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum CombinedCustomerEntityType {
  ClientOrganization = 'CLIENT_ORGANIZATION',
  OffResqCustomer = 'OFF_RESQ_CUSTOMER'
}

export type CombinedCustomerNode = Node & {
  __typename: 'CombinedCustomerNode';
  allServiceableFacilitiesCount: Maybe<Scalars['Int']['output']>;
  client: Maybe<ClientOrganizationNode>;
  entityId: Scalars['Int']['output'];
  entityType: CombinedCustomerEntityType;
  facilitiesCount: Maybe<Scalars['Int']['output']>;
  facilitiesWorkedWithCount: Maybe<Scalars['Int']['output']>;
  hasFavoriteOpportunity: Maybe<Scalars['Boolean']['output']>;
  hasHiddenFacilities: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  jobCount: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  offResqCustomer: Maybe<OffResqCustomerNode>;
  percentageRevenue: Maybe<Scalars['Decimal']['output']>;
  serviceableFacilitiesCount: Maybe<Scalars['Int']['output']>;
  totalInvoiced: Maybe<Scalars['Decimal']['output']>;
  uniformPayoutOffer: Maybe<PayoutOfferNode>;
  vendorMpOpportunities: Maybe<Array<MaintenancePlanTypeNode>>;
};


export type CombinedCustomerNodeAllServiceableFacilitiesCountArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeFacilitiesWorkedWithCountArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeHasFavoriteOpportunityArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeHasHiddenFacilitiesArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeJobCountArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodePercentageRevenueArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeServiceableFacilitiesCountArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeTotalInvoicedArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeUniformPayoutOfferArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedCustomerNodeVendorMpOpportunitiesArgs = {
  vendorId: Scalars['ID']['input'];
};

export type CombinedCustomerNodeConnection = {
  __typename: 'CombinedCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CombinedCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CombinedCustomerNode` and its cursor. */
export type CombinedCustomerNodeEdge = {
  __typename: 'CombinedCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CombinedCustomerNode>;
};

export type CombinedFacilityNode = Node & {
  __typename: 'CombinedFacilityNode';
  activeMaintenancePlans: Maybe<Array<MaintenancePlanNode>>;
  client: Maybe<ClientOrganizationNode>;
  clientVendorRelationship: Maybe<ClientVendorRelationshipNode>;
  entityId: Scalars['Int']['output'];
  entityType: EntityType;
  facility: Maybe<FacilityNode>;
  firstServiced: Maybe<Scalars['Date']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isFavoritedByVendor: Maybe<Scalars['Boolean']['output']>;
  isMissingBrd: Maybe<Scalars['Boolean']['output']>;
  isServiceableByVendor: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  offResqCustomer: Maybe<OffResqCustomerNode>;
  offResqFacility: Maybe<OffResqFacilityNode>;
  totalInvoiced: Maybe<Scalars['Decimal']['output']>;
  totalJobsCompleted: Maybe<Scalars['Int']['output']>;
  vendorJobCount: Maybe<Scalars['Int']['output']>;
  vendorMpOpportunities: Maybe<Array<MaintenancePlanTypeNode>>;
  vendorPercentageRevenue: Maybe<Scalars['Decimal']['output']>;
  vendorTotalInvoiced: Maybe<Scalars['Decimal']['output']>;
};


export type CombinedFacilityNodeActiveMaintenancePlansArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeClientVendorRelationshipArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeIsFavoritedByVendorArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeIsServiceableByVendorArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeVendorJobCountArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeVendorMpOpportunitiesArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeVendorPercentageRevenueArgs = {
  vendorId: Scalars['ID']['input'];
};


export type CombinedFacilityNodeVendorTotalInvoicedArgs = {
  vendorId: Scalars['ID']['input'];
};

export type CombinedFacilityNodeConnection = {
  __typename: 'CombinedFacilityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CombinedFacilityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CombinedFacilityNode` and its cursor. */
export type CombinedFacilityNodeEdge = {
  __typename: 'CombinedFacilityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CombinedFacilityNode>;
};

export type CombinedVendorInvoiceNode = Node & {
  __typename: 'CombinedVendorInvoiceNode';
  batch: Maybe<ApBatchNode>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Maybe<Scalars['String']['output']>;
  deliveryMethod: Maybe<Scalars['String']['output']>;
  dueAtDate: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSet: Maybe<InvoiceSetNode>;
  invoicingVersion: Maybe<InvoicingVersion>;
  isFastpaySurprise: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  issuedAtDate: Scalars['Date']['output'];
  paidAt: Maybe<Scalars['DateTime']['output']>;
  paymentTerms: Maybe<Scalars['Int']['output']>;
  pdfUrl: Maybe<Scalars['String']['output']>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  referenceNumber: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  status: VendorInvoiceStatus;
  total: Scalars['Decimal']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  vendorInvoice: Maybe<VendorInvoiceNode>;
  workOrder: Maybe<WorkOrderNode>;
};

export type CombinedVendorInvoiceNodeConnection = {
  __typename: 'CombinedVendorInvoiceNodeConnection';
  cadTotal: Scalars['Decimal']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CombinedVendorInvoiceNodeEdge>>;
  gbpTotal: Scalars['Decimal']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  usdTotal: Scalars['Decimal']['output'];
};

/** A Relay edge containing a `CombinedVendorInvoiceNode` and its cursor. */
export type CombinedVendorInvoiceNodeEdge = {
  __typename: 'CombinedVendorInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CombinedVendorInvoiceNode>;
};

/** An enumeration. */
export enum CombinedWorkOrderEntityType {
  OffResqWorkOrder = 'OFF_RESQ_WORK_ORDER',
  WorkOrder = 'WORK_ORDER'
}

export type CombinedWorkOrderNode = Node & {
  __typename: 'CombinedWorkOrderNode';
  code: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  entityType: CombinedWorkOrderEntityType;
  executingVendor: Maybe<VendorOrganizationNode>;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  serviceCategory: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusDisplay: Maybe<Scalars['String']['output']>;
  submittedBy: Maybe<UserNode>;
  technician: Maybe<UserNode>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: Maybe<WorkOrderNode>;
};

export type CombinedWorkOrderNodeConnection = {
  __typename: 'CombinedWorkOrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CombinedWorkOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CombinedWorkOrderNode` and its cursor. */
export type CombinedWorkOrderNodeEdge = {
  __typename: 'CombinedWorkOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CombinedWorkOrderNode>;
};

export type CommentNode = Node & {
  __typename: 'CommentNode';
  addedOn: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user: UserNode;
  visibility: CommentVisibility;
};

export type CommentNodeConnection = {
  __typename: 'CommentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CommentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CommentNode` and its cursor. */
export type CommentNodeEdge = {
  __typename: 'CommentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CommentNode>;
};

export enum CommentVisibility {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type CompleteBillingAndPaymentInfoOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteBillingAndPaymentInfoOnboardingStepMutationPayload = {
  __typename: 'CompleteBillingAndPaymentInfoOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteBillingEntityOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteBillingEntityOnboardingStepMutationPayload = {
  __typename: 'CompleteBillingEntityOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteClientOnboardingMutation = {
  __typename: 'CompleteClientOnboardingMutation';
  ok: Scalars['Boolean']['output'];
};

export type CompleteFacilitiesOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<InputMaybe<FacilitiesOnboardingStepInput>>>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteFacilitiesOnboardingStepMutationPayload = {
  __typename: 'CompleteFacilitiesOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteGetStartedOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteGetStartedOnboardingStepMutationPayload = {
  __typename: 'CompleteGetStartedOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteInternalRequestTeamMemberAssignmentInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  assignmentId: Scalars['ID']['input'];
  checkedTaskListItems: Array<InputMaybe<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  duration: Scalars['Int']['input'];
  incompleteTaskNotes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<Image>>;
};

export type CompleteInternalRequestTeamMemberAssignmentPayload = {
  __typename: 'CompleteInternalRequestTeamMemberAssignmentPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type CompletePaymentInfoOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompletePaymentInfoOnboardingStepMutationPayload = {
  __typename: 'CompletePaymentInfoOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteRatesOnboardingStepMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  vendorPriceRates: Array<UpdateVendorPriceRateInput>;
};

export type CompleteRatesOnboardingStepMutationPayload = {
  __typename: 'CompleteRatesOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorPriceRates: Array<VendorPriceRateNode>;
};

export type CompleteSelfServeOnboardingActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId: Scalars['ID']['input'];
};

export type CompleteSelfServeOnboardingActionMutationPayload = {
  __typename: 'CompleteSelfServeOnboardingActionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteStaffOnboardingStepMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteStaffOnboardingStepMutationPayload = {
  __typename: 'CompleteStaffOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteTradesSubscriptionOnboardingStepMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  serviceName?: InputMaybe<ResqServiceName>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompleteTradesSubscriptionOnboardingStepMutationPayload = {
  __typename: 'CompleteTradesSubscriptionOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  failureReason: Maybe<TradesSubscriptionActivationFailureReason>;
  isTrial: Scalars['Boolean']['output'];
  serviceName: Maybe<ResqServiceName>;
  skipped: Scalars['Boolean']['output'];
  status: Maybe<TradesSubscriptionActivationStatus>;
  subscription: Maybe<OrganizationSubscriptionNode>;
  trialEndDate: Maybe<Scalars['Date']['output']>;
};

export type CompleteTroubleshootingSessionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outcome: TroubleshootingSessionOutcome;
  troubleshootingActionId?: InputMaybe<Scalars['ID']['input']>;
  troubleshootingSessionId: Scalars['ID']['input'];
};

export type CompleteTroubleshootingSessionMutationPayload = {
  __typename: 'CompleteTroubleshootingSessionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CompleteVendorOnboardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CompleteVendorOnboardingMutationPayload = {
  __typename: 'CompleteVendorOnboardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type CompleteWorkOrderTeamMemberAssignmentInput = {
  assignmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  photos: Array<Image>;
};

export type CompleteWorkOrderTeamMemberAssignmentPayload = {
  __typename: 'CompleteWorkOrderTeamMemberAssignmentPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type CompletedWorkOrdersComparison = {
  __typename: 'CompletedWorkOrdersComparison';
  current: Scalars['Int']['output'];
  previous: Scalars['Int']['output'];
};

export type ConfirmPerUserDailyMenuFirstRunMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type ConfirmPerUserDailyMenuFirstRunMutationPayload = {
  __typename: 'ConfirmPerUserDailyMenuFirstRunMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ConfirmVendorAgreementMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type ConfirmVendorAgreementMutationPayload = {
  __typename: 'ConfirmVendorAgreementMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: VendorOrganizationNode;
};

export type ConfirmVendorRequiredInfoMutationInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<ExternalBankAccountType>;
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  taxIdType?: InputMaybe<VendorTaxIdType>;
  taxRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  transitNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  voidCheck?: InputMaybe<VendorDocumentInput>;
};

export type ConfirmVendorRequiredInfoMutationPayload = {
  __typename: 'ConfirmVendorRequiredInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ContactInquiryInternalNoteNode = Node & {
  __typename: 'ContactInquiryInternalNoteNode';
  /** Internal note content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactInquiryNode = Node & {
  __typename: 'ContactInquiryNode';
  /** Timestamp when the inbound request was actioned or rejected */
  actionedAt: Maybe<Scalars['DateTime']['output']>;
  actionedBy: Maybe<UserNode>;
  /** Primary contact name for the inbound request */
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Primary contact email for the inbound request */
  email: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalNotes: Array<ContactInquiryInternalNoteNode>;
  /** Whether the inbound request has been opened in the vendor dashboard */
  isRead: Scalars['Boolean']['output'];
  matchedCombinedCustomerId: Maybe<Scalars['ID']['output']>;
  matchedCombinedFacilityId: Maybe<Scalars['ID']['output']>;
  matchedCustomerCode: Maybe<Scalars['String']['output']>;
  matchedCustomerName: Maybe<Scalars['String']['output']>;
  matchedFacilityName: Maybe<Scalars['String']['output']>;
  /** Primary inquiry or request message body */
  message: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSONString']['output']>;
  /** Primary contact phone for the inbound request */
  phone: Scalars['String']['output'];
  rawJson: Maybe<Scalars['JSONString']['output']>;
  source: Scalars['String']['output'];
  /** Shared workflow status for this inbound request */
  status: LeadInboundRequestStatus;
  /** Primary inquiry subject or title */
  subject: Scalars['String']['output'];
  transcripts: Array<LeadInboundRequestTranscriptNode>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
};

export type ContactInquiryNodeConnection = {
  __typename: 'ContactInquiryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactInquiryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactInquiryNode` and its cursor. */
export type ContactInquiryNodeEdge = {
  __typename: 'ContactInquiryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ContactInquiryNode>;
};

/** An enumeration. */
export enum ContactReason {
  Cancellation = 'CANCELLATION',
  DispatchPreference = 'DISPATCH_PREFERENCE',
  IntercomLink = 'INTERCOM_LINK',
  InvoiceInquiry = 'INVOICE_INQUIRY',
  Other = 'OTHER',
  PaymentInquiry = 'PAYMENT_INQUIRY',
  QuoteInquiry = 'QUOTE_INQUIRY',
  Scheduling = 'SCHEDULING',
  ServicePartsEta = 'SERVICE_PARTS_ETA',
  TechSupport = 'TECH_SUPPORT',
  UserProfileAdjustment = 'USER_PROFILE_ADJUSTMENT',
  VendorChange = 'VENDOR_CHANGE',
  ZendeskLink = 'ZENDESK_LINK'
}

/** An enumeration. */
export enum ContactSource {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  Partner = 'PARTNER'
}

export type ConvertTradesTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type ConvertTradesTrialPayload = {
  __typename: 'ConvertTradesTrialPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  failureReason: Maybe<TradesTrialConversionFailureReason>;
  paidSubscription: Maybe<OrganizationSubscriptionNode>;
  status: TradesTrialConversionStatus;
  trialSubscription: Maybe<OrganizationSubscriptionNode>;
};

export type CoordinatorNode = Node & {
  __typename: 'CoordinatorNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  slackUserId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

/** Map the full range of internal statuses into a simplified set for coordinators. */
export enum CoordinatorStatusEnum {
  AwaitingAcceptance = 'AWAITING_ACCEPTANCE',
  AwaitingAssignment = 'AWAITING_ASSIGNMENT',
  AwaitingCompletion = 'AWAITING_COMPLETION',
  AwaitingFacilityApproval = 'AWAITING_FACILITY_APPROVAL',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingRecordOfWork = 'AWAITING_RECORD_OF_WORK',
  AwaitingResqApproval = 'AWAITING_RESQ_APPROVAL',
  AwaitingScheduling = 'AWAITING_SCHEDULING',
  AwaitingVendorPayout = 'AWAITING_VENDOR_PAYOUT',
  AwaitingVmApproval = 'AWAITING_VM_APPROVAL',
  Closed = 'CLOSED',
  CoordinatorAll = 'COORDINATOR_ALL',
  MissingVendorInvoice = 'MISSING_VENDOR_INVOICE',
  MultipleRecordsDraft = 'MULTIPLE_RECORDS_DRAFT',
  VendorClosed = 'VENDOR_CLOSED'
}

export type CountryNode = Node & {
  __typename: 'CountryNode';
  code: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CountryNodeConnection = {
  __typename: 'CountryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CountryNode` and its cursor. */
export type CountryNodeEdge = {
  __typename: 'CountryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<CountryNode>;
};

export type CreateActiveMaintenancePlanMutation = {
  __typename: 'CreateActiveMaintenancePlanMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean']['output'];
};

export type CreateBrandMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Image>;
  name: Scalars['String']['input'];
};

export type CreateBrandMutationPayload = {
  __typename: 'CreateBrandMutationPayload';
  brand: BrandNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreateBudgetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  facilityGroupAllotments?: InputMaybe<Array<InputMaybe<FacilityGroupAllotmentInput>>>;
  isCapex?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  isOpex?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startDate: Scalars['Date']['input'];
  total: Scalars['Decimal']['input'];
};

export type CreateBudgetMutationPayload = {
  __typename: 'CreateBudgetMutationPayload';
  budget: Maybe<BudgetNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type CreateBusinessUnitArguments = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessRegistrationNumberType?: InputMaybe<BusinessRegistrationNumberType>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  memberUserIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  subscriptionUnitAmount: Scalars['Decimal']['input'];
  taggingFee?: InputMaybe<Scalars['Decimal']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessUnitMutation = {
  __typename: 'CreateBusinessUnitMutation';
  businessUnit: BusinessUnitNode;
  ok: Scalars['Boolean']['output'];
};

export type CreateCyovDispatchInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cyovData?: InputMaybe<CyovDataInput>;
  dispatchNote?: InputMaybe<Scalars['String']['input']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']['input']>;
  isCustomDispatchNote?: InputMaybe<Scalars['Boolean']['input']>;
  selectedVendorId?: InputMaybe<Scalars['ID']['input']>;
  selectedVendors?: InputMaybe<Array<Scalars['ID']['input']>>;
  workOrderId: Scalars['ID']['input'];
};

export type CreateCyovDispatchPayload = {
  __typename: 'CreateCYOVDispatchPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorDispatch: VendorDispatchNode;
};

export type CreateClientAdjustmentInvoiceInput = {
  adjustmentAmount: Scalars['Decimal']['input'];
  allowNegativeWorkOrder?: InputMaybe<Scalars['Boolean']['input']>;
  applyAsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  recordOfWorkId: Scalars['ID']['input'];
  taxRateIds: Array<Scalars['ID']['input']>;
};

export type CreateClientAdjustmentInvoicePayload = {
  __typename: 'CreateClientAdjustmentInvoicePayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type CreateClientAutoAdjustmentInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clientInvoiceId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientAutoAdjustmentInvoiceMutationPayload = {
  __typename: 'CreateClientAutoAdjustmentInvoiceMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type CreateCommentMutation = {
  __typename: 'CreateCommentMutation';
  ok: Scalars['Boolean']['output'];
};

export type CreateContactInquiryInternalNoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactInquiryId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type CreateContactInquiryInternalNoteMutationPayload = {
  __typename: 'CreateContactInquiryInternalNoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  contactInquiryInternalNote: ContactInquiryInternalNoteNode;
};

export type CreateControlCenterUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups: Array<Scalars['ID']['input']>;
  isInvoiceProcessor?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  title: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateControlCenterUserMutationPayload = {
  __typename: 'CreateControlCenterUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type CreateCoordinatorMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  slackUserId: Scalars['String']['input'];
};

export type CreateCoordinatorMutationPayload = {
  __typename: 'CreateCoordinatorMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  coordinator: CoordinatorNode;
};

export type CreateDeviceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configs: Array<DeviceConfigRequestInput>;
  deviceId: Scalars['String']['input'];
  equipmentId: Scalars['ID']['input'];
};

export type CreateDeviceConfigsPayload = {
  __typename: 'CreateDeviceConfigsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreateDeviceDataExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  equipmentId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type CreateDeviceDataExportPayload = {
  __typename: 'CreateDeviceDataExportPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  exportUrl: Scalars['String']['output'];
};

export type CreateExternalBankAccountMutation = {
  __typename: 'CreateExternalBankAccountMutation';
  externalBankAccount: ExternalBankAccountNode;
};

export type CreateFacilityGroupInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateFacilityGroupPayload = {
  __typename: 'CreateFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facilityGroup: FacilityGroupNode;
};

export type CreateFacilityInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  businessLegalName?: InputMaybe<Scalars['String']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  busyHours?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  daysOpened?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  goliveOn?: InputMaybe<Scalars['Date']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfServe?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notReadyForOnboardingReason?: InputMaybe<NotReadyForOnboardingReasonChoice>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardingStatus: OnboardingStatus;
  onsiteHours?: InputMaybe<Scalars['String']['input']>;
  openedOn?: InputMaybe<Scalars['Date']['input']>;
  parentGroupId?: InputMaybe<Scalars['ID']['input']>;
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>;
  paymentContactName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Image>;
  plannedGoLiveOn?: InputMaybe<Scalars['Date']['input']>;
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  qrSubmissionAuthenticationMode?: InputMaybe<QrSubmissionAuthenticationMode>;
  status?: InputMaybe<FacilityStatus>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  taggingMethod?: InputMaybe<TaggingMethod>;
  transactionFee?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFacilityPayload = {
  __typename: 'CreateFacilityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facility: FacilityNode;
};

export type CreateFavouriteVendorConfigurationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds: Array<Scalars['ID']['input']>;
  inviterName?: InputMaybe<Scalars['String']['input']>;
  inviterNote?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceCategories: Array<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFavouriteVendorConfigurationPayload = {
  __typename: 'CreateFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  favouriteVendorConfiguration: FavouriteVendorConfigurationNode;
};

export type CreateInitialSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
};

export type CreateInitialSubscriptionPayload = {
  __typename: 'CreateInitialSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  dataHashKey: Scalars['String']['output'];
  subscription: SubscriptionNode;
};

export type CreateInvoiceSetDisputeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  reasonEnum: InvoiceSetDisputeReason;
};

export type CreateInvoiceSetDisputeMutationPayload = {
  __typename: 'CreateInvoiceSetDisputeMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  dispute: InvoiceSetDisputeNode;
};

export type CreateInvoiceSetNoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type CreateInvoiceSetNoteMutationPayload = {
  __typename: 'CreateInvoiceSetNoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type CreateJustifiWebComponentTokenMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeToken?: InputMaybe<Scalars['Boolean']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateJustifiWebComponentTokenMutationPayload = {
  __typename: 'CreateJustifiWebComponentTokenMutationPayload';
  accountId: Maybe<Scalars['String']['output']>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  webComponentToken: Maybe<Scalars['String']['output']>;
};

export type CreateLeadInboundRequestInternalNoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  leadInboundRequestId: Scalars['ID']['input'];
};

export type CreateLeadInboundRequestInternalNoteMutationPayload = {
  __typename: 'CreateLeadInboundRequestInternalNoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequestInternalNote: LeadInboundRequestInternalNoteNode;
};

export type CreateMaintenancePlanMutation = {
  __typename: 'CreateMaintenancePlanMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean']['output'];
};

export type CreateMarketInput = {
  acceptingNewTrades?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disabledCategories?: InputMaybe<Array<ServiceCategory>>;
  name: Scalars['String']['input'];
  operatingAreaIds: Array<Scalars['ID']['input']>;
  pricing: MarketPricingInput;
};

export type CreateMarketPayload = {
  __typename: 'CreateMarketPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  market: MarketNode;
};

export type CreateMissingDataAlertTicketInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
  incidentId: Scalars['String']['input'];
};

export type CreateMissingDataAlertTicketPayload = {
  __typename: 'CreateMissingDataAlertTicketPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOffResqCustomerMutationInput = {
  accountingIntegrationCustomerId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  billingContacts?: InputMaybe<Array<BillingContactMutationInput>>;
  businessDateOfIncorporation?: InputMaybe<Scalars['Date']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  facilities?: InputMaybe<Array<InputMaybe<OffResqFacilityInput>>>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  /** Legacy (ignored): customer-created emails are disabled. */
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateOffResqCustomerMutationPayload = {
  __typename: 'CreateOffResqCustomerMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqCustomer: OffResqCustomerNode;
};

export type CreateOffResqCustomerUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateOffResqCustomerUserMutationPayload = {
  __typename: 'CreateOffResqCustomerUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type CreateOffResqFacilityMutationInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  offResqCustomerId: Scalars['ID']['input'];
  postalCode: Scalars['String']['input'];
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  provinceId: Scalars['ID']['input'];
};

export type CreateOffResqFacilityMutationPayload = {
  __typename: 'CreateOffResqFacilityMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqFacility: OffResqFacilityNode;
};

export type CreateOffResqFacilityUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  offResqFacilityId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateOffResqFacilityUserMutationPayload = {
  __typename: 'CreateOffResqFacilityUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type CreateOffResqWorkOrderMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  appointmentEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  notifyFacility?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCategory?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  technicianLanguage?: InputMaybe<Scalars['String']['input']>;
  technicianPhone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOffResqWorkOrderMutationPayload = {
  __typename: 'CreateOffResqWorkOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
};

export type CreateOrUpdateBusinessUnitOnboardingMutationInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessRegistrationNumberType?: InputMaybe<BusinessRegistrationNumberType>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  memberUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>;
  paymentContactName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  subscriptionUnitAmount: Scalars['Decimal']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateBusinessUnitOnboardingMutationPayload = {
  __typename: 'CreateOrUpdateBusinessUnitOnboardingMutationPayload';
  businessUnit: BusinessUnitNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreateOriginalVendorInvoiceMutationInput = {
  applyProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  selectedShareTierId?: InputMaybe<Scalars['Int']['input']>;
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** Deprecated: Use invoice_set_id instead. For backward compatibility only. */
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOriginalVendorInvoiceMutationPayload = {
  __typename: 'CreateOriginalVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreatePartneredEstimateSubmissionFromBuilderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<LineItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePartneredEstimateSubmissionFromBuilderMutationPayload = {
  __typename: 'CreatePartneredEstimateSubmissionFromBuilderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  partneredEstimateSubmission: PartneredEstimateSubmissionNode;
};

export type CreatePartneredInvoiceSubmissionFromBuilderMutationInput = {
  callbackCostReason?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<LineItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  selectedShareTierId?: InputMaybe<Scalars['Int']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePartneredInvoiceSubmissionFromBuilderMutationPayload = {
  __typename: 'CreatePartneredInvoiceSubmissionFromBuilderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  partneredInvoiceSubmission: PartneredInvoiceSubmissionNode;
};

export type CreatePaymentMethodMutationInput = {
  achAccount?: InputMaybe<AchAccountInput>;
  ccAccount?: InputMaybe<CcAccountInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentType: PaymentMethodPaymentType;
};

export type CreatePaymentMethodMutationPayload = {
  __typename: 'CreatePaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  paymentMethod: PaymentMethodNode;
};

export type CreatePmOneTimeWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceId: Scalars['ID']['input'];
};

export type CreatePmOneTimeWorkOrderPayload = {
  __typename: 'CreatePmOneTimeWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type CreatePreventativeMaintenanceInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  facilityId: Scalars['ID']['input'];
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  frequencyValue: Scalars['Int']['input'];
  nextWorkOrderCreationDate: Scalars['Date']['input'];
  recurrenceDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  serviceCategory: ServiceCategory;
  taskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  taskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  taskListItems: Array<Scalars['String']['input']>;
  teamMemberIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePreventativeMaintenancePayload = {
  __typename: 'CreatePreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type CreatePriceBookCategoryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreatePriceBookCategoryMutationPayload = {
  __typename: 'CreatePriceBookCategoryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  priceBookCategory: Maybe<PriceBookCategoryNode>;
};

export type CreatePriceBookItemMutationInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  defaultRate: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  itemType: PriceBookLineItemTypeEnum;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasureEnum>;
  vendorId: Scalars['ID']['input'];
};

export type CreatePriceBookItemMutationPayload = {
  __typename: 'CreatePriceBookItemMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  priceBookItem: Maybe<PriceBookItemNode>;
};

export type CreateProjectMutationInput = {
  assignedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  projectType: ProjectType;
  status?: InputMaybe<ProjectStatus>;
  targetCompletionDate?: InputMaybe<Scalars['Date']['input']>;
  targetStartDate?: InputMaybe<Scalars['Date']['input']>;
  workOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectMutationPayload = {
  __typename: 'CreateProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  project: ProjectNode;
};

export type CreateProposalCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  proposalId: Scalars['ID']['input'];
};

export type CreateProposalCommentMutationPayload = {
  __typename: 'CreateProposalCommentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProtectionPlanEnrollmentInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coveragePeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateProtectionPlanEnrollmentPayload = {
  __typename: 'CreateProtectionPlanEnrollmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  protectionPlanEnrollment: ProtectionPlanEnrollmentNode;
};

export type CreateQuoteActivity = Activity & Node & {
  __typename: 'CreateQuoteActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<CreateQuoteActivityOutcome>;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum CreateQuoteActivityOutcome {
  Cancelled = 'CANCELLED',
  Created = 'CREATED'
}

export type CreateQuoteFromBuilderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetId: Scalars['ID']['input'];
  lineItems: Array<LineItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuoteFromBuilderMutationPayload = {
  __typename: 'CreateQuoteFromBuilderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quote: QuoteNode;
};

export type CreateQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type CreateQuoteMutationPayload = {
  __typename: 'CreateQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quote: QuoteNode;
};

export type CreateQuoteSetOptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteIds: Array<Scalars['ID']['input']>;
  quoteSetId: Scalars['ID']['input'];
};

export type CreateQuoteSetOptionsPayload = {
  __typename: 'CreateQuoteSetOptionsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type CreateRecordOfWorkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveOffer?: InputMaybe<Scalars['String']['input']>;
  effectiveOfferType?: InputMaybe<Scalars['String']['input']>;
  existingRecordOfWorkId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId: Scalars['ID']['input'];
  offerId?: InputMaybe<Scalars['ID']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates a new record of work for an invoice set,
 * potentially copying an existing published record of work.
 */
export type CreateRecordOfWorkMutationPayload = {
  __typename: 'CreateRecordOfWorkMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  recordOfWork: RecordOfWorkNode;
};

export type CreateReleaseMutationInput = {
  appName: AppName;
  buildNumber: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  minimumOtaCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  platform: Platform;
  upgradeType: UpgradeType;
  versionName: Scalars['String']['input'];
};

/**
 * Create or update a mobile app release (idempotent).
 *
 * If a release with the same platform, app_name, version_name, and build_number
 * already exists, it will be updated. Otherwise, a new release is created.
 *
 * Only accessible by staff users.
 */
export type CreateReleaseMutationPayload = {
  __typename: 'CreateReleaseMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  created: Scalars['Boolean']['output'];
  release: Maybe<ReleaseNode>;
};

export type CreateReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdById: Scalars['ID']['input'];
  day: ReportDay;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  frequency?: InputMaybe<ReportFrequency>;
  interval: Scalars['Int']['input'];
  orderBy: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  reportType: ReportType;
  title: Scalars['String']['input'];
};

export type CreateReportTemplatePayload = {
  __typename: 'CreateReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  reportTemplate: ReportTemplateNode;
};

export type CreateRoleInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<Permission>;
};

export type CreateRolePayload = {
  __typename: 'CreateRolePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  role: RoleNode;
};

export type CreateRuleViolationsFeedbackInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isPositive: Scalars['Boolean']['input'];
  ruleViolationsId: Scalars['ID']['input'];
};

export type CreateRuleViolationsFeedbackPayload = {
  __typename: 'CreateRuleViolationsFeedbackPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ruleViolations: RuleViolationsNode;
};

export type CreateRuleViolationsMutationInput = {
  allowMissingMareketplacePlan?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetId: Scalars['ID']['input'];
  recordOfWorkId: Scalars['ID']['input'];
  violations: Array<RuleBroken>;
};

export type CreateRuleViolationsMutationPayload = {
  __typename: 'CreateRuleViolationsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ruleViolations: RuleViolationsNode;
};

export type CreateServiceOrderMutationInput = {
  businessUnitId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ServiceOrderLineItemInput>;
  organizationId: Scalars['ID']['input'];
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Create a ResQ service order invoice.
 *
 * This mutation creates a ClientInvoice for ResQ services (sensor hardware,
 * installation, tagging, gateways) for a client organization.
 *
 * The operation is atomic and includes:
 * - Validation of organization and business unit
 * - Tax calculation based on business unit's tax rates
 * - Invoice and line item creation
 * - Automatic PDF generation (async)
 * - Event publishing for downstream systems
 *
 * Authorization: Coordinators only
 */
export type CreateServiceOrderMutationPayload = {
  __typename: 'CreateServiceOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  serviceOrder: Maybe<ServiceOrderOutput>;
};

export type CreateTechnicianUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateTechnicianUserMutationPayload = {
  __typename: 'CreateTechnicianUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: Maybe<UserNode>;
};

export type CreateTradesCustomerInvoiceMutationInput = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<TradesCustomerInvoiceLineItemInput>;
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTradesCustomerInvoiceMutationPayload = {
  __typename: 'CreateTradesCustomerInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  tradesCustomerInvoice: Maybe<TradesCustomerInvoiceOutput>;
};

export type CreateTroubleshootingSessionMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  facilityId: Scalars['ID']['input'];
  isCallback?: InputMaybe<Scalars['Boolean']['input']>;
  matchingRuleId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory: ServiceCategory;
  symptomId?: InputMaybe<Scalars['ID']['input']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  troubleshootingPlanId: Scalars['ID']['input'];
};

export type CreateTroubleshootingSessionMutationPayload = {
  __typename: 'CreateTroubleshootingSessionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  troubleshootingSession: Maybe<TroubleshootingSessionNode>;
};

export type CreateUpdateExternalReferenceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type CreateUpdateExternalReferenceMutationPayload = {
  __typename: 'CreateUpdateExternalReferenceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdatePayoutOfferMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveOffer?: InputMaybe<Scalars['String']['input']>;
  effectiveOfferType?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  payoutRelationship: PayoutRelationship;
  vendorId: Scalars['ID']['input'];
};

export type CreateUpdatePayoutOfferMutationPayload = {
  __typename: 'CreateUpdatePayoutOfferMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  payoutOffer: PayoutOfferNode;
};

export type CreateUpdateWorkOrderExpenseTypeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expenseType: ExpenseType;
  expenseTypeSetThrough: ExpenseTypeSetThrough;
  workOrderId: Scalars['ID']['input'];
};

export type CreateUpdateWorkOrderExpenseTypeMutationPayload = {
  __typename: 'CreateUpdateWorkOrderExpenseTypeMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrderExpenseType: Maybe<WorkOrderExpenseTypeNode>;
};

export type CreateVendorAdjustmentInvoiceMutation = {
  __typename: 'CreateVendorAdjustmentInvoiceMutation';
  ok: Scalars['Boolean']['output'];
  vendorInvoice: Scalars['ID']['output'];
};

export type CreateVendorArguments = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  currency: Currency;
  documents: Array<VendorDocumentInput>;
  email: Scalars['String']['input'];
  hasCrmFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  inheritedPaymentTerms?: InputMaybe<Scalars['Int']['input']>;
  isAutoApproveEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfServeSignup?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  lastResort?: InputMaybe<Scalars['Boolean']['input']>;
  marketplacePaymentTerms?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  openToMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  operatingCountryId: Scalars['ID']['input'];
  ownerEmail: Scalars['String']['input'];
  ownerFirstName: Scalars['String']['input'];
  ownerLastName: Scalars['String']['input'];
  ownerPhone?: InputMaybe<Scalars['String']['input']>;
  ownerTitle?: InputMaybe<Scalars['String']['input']>;
  ownerUsername: Scalars['String']['input'];
  paymentTerms: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  remittanceEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  revenueSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  schedulesInApp?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  servicedOperatingAreaIds: Array<Scalars['ID']['input']>;
  sfId?: InputMaybe<Scalars['String']['input']>;
  skillIds: Array<Scalars['ID']['input']>;
  status: VendorStatus;
  successOwner?: InputMaybe<Scalars['ID']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
};

export type CreateVendorAutoAdjustmentInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  newReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  vendorInvoiceId: Scalars['ID']['input'];
};

export type CreateVendorAutoAdjustmentInvoiceMutationPayload = {
  __typename: 'CreateVendorAutoAdjustmentInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorInvoice: VendorInvoiceNode;
};

export type CreateVendorBusinessProfileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateVendorBusinessProfileMutationPayload = {
  __typename: 'CreateVendorBusinessProfileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorBusinessProfile: Maybe<VendorBusinessProfileNode>;
};

export type CreateVendorInternalNoteArguments = {
  content: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type CreateVendorInternalNoteMutation = {
  __typename: 'CreateVendorInternalNoteMutation';
  ok: Scalars['Boolean']['output'];
  vendorInternalNote: VendorInternalNoteNode;
};

export type CreateVendorInvoiceBatchMutation = {
  __typename: 'CreateVendorInvoiceBatchMutation';
  vendorInvoiceBatch: ApBatchNode;
};

export type CreateVendorMutation = {
  __typename: 'CreateVendorMutation';
  ok: Scalars['Boolean']['output'];
  vendor: VendorOrganizationNode;
};

export type CreateVendorPreventiveMaintenanceRecommendationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  photos?: InputMaybe<Array<Image>>;
  workOrderId: Scalars['ID']['input'];
};

export type CreateVendorPreventiveMaintenanceRecommendationMutationPayload = {
  __typename: 'CreateVendorPreventiveMaintenanceRecommendationMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorPreventiveMaintenanceRecommendation: VendorPreventiveMaintenanceRecommendationNode;
};

export type CreateVendorPromotionMutationInput = {
  audienceType: AudienceType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountType: DiscountType;
  discountValue: Scalars['Decimal']['input'];
  limitCount?: InputMaybe<Scalars['Int']['input']>;
  promotionType: PromotionType;
  serviceCategory: ServiceCategory;
  usageLimitType: UsageLimitType;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateVendorPromotionMutationPayload = {
  __typename: 'CreateVendorPromotionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorPromotion: Maybe<VendorPromotionNode>;
};

export type CreateVendorRankingForEquipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
  vendorRanking: Array<VendorEntryInput>;
};

export type CreateVendorRankingForEquipmentMutationPayload = {
  __typename: 'CreateVendorRankingForEquipmentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorRanking: Maybe<VendorRankingNode>;
};

export type CreateVendorRankingForFacilityAndServiceCategoryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory: ServiceCategory;
  vendorRanking: Array<VendorEntryInput>;
};

export type CreateVendorRankingForFacilityAndServiceCategoryMutationPayload = {
  __typename: 'CreateVendorRankingForFacilityAndServiceCategoryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorRanking: Maybe<VendorRankingNode>;
};

export type CreateVendorSubcontractMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dispatchNote?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  subcontractVendorId: Scalars['ID']['input'];
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Create a subcontract on a work order where Parent Vendor remains vendor-of-record. */
export type CreateVendorSubcontractMutationPayload = {
  __typename: 'CreateVendorSubcontractMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  subcontract: WorkOrderSubcontractType;
  workOrder: Maybe<WorkOrderNode>;
};

export type CreateVendorSubcontractPairingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentVendorId: Scalars['ID']['input'];
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<VendorSubcontractPairingScopeInput>>;
  shareTiers?: InputMaybe<Array<VendorSubcontractPairingShareTierInput>>;
  subcontractVendorId: Scalars['ID']['input'];
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Coordinator-only pairing management between Parent Vendor and Subcontract Vendor orgs. */
export type CreateVendorSubcontractPairingMutationPayload = {
  __typename: 'CreateVendorSubcontractPairingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  pairing: VendorSubcontractPairingType;
};

export type CreateVendorWebsiteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
  sourceSiteRef?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type CreateVendorWebsiteMutationPayload = {
  __typename: 'CreateVendorWebsiteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorWebsite: Maybe<VendorWebsiteNode>;
};

export type CreateVendorWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVendorWorkOrderInternalNotePayload = {
  __typename: 'CreateVendorWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  note: VendorWorkOrderInternalNoteNode;
};

export type CreateVisitReviewMutation = {
  __typename: 'CreateVisitReviewMutation';
  ok: Scalars['Boolean']['output'];
};

export type CreateWebsiteAdvertisingCampaignMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
};

export type CreateWebsiteAdvertisingCampaignMutationPayload = {
  __typename: 'CreateWebsiteAdvertisingCampaignMutationPayload';
  campaign: WebsiteAdvertisingCampaignType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CreateWorkOrderEscalationInput = {
  channel?: InputMaybe<EscalationChannel>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  escalatedBy?: InputMaybe<Scalars['ID']['input']>;
  otherReason?: InputMaybe<Scalars['String']['input']>;
  reason: WorkOrderEscalationReason;
  sourceOrg?: InputMaybe<Scalars['ID']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type CreateWorkOrderEscalationPayload = {
  __typename: 'CreateWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type CreateWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type CreateWorkOrderInternalNotePayload = {
  __typename: 'CreateWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  note: WorkOrderInternalNoteNode;
};

export type CreateWorkOrderInvoiceSetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Creates a new invoice set for a work order and vendor. */
export type CreateWorkOrderInvoiceSetMutationPayload = {
  __typename: 'CreateWorkOrderInvoiceSetMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  invoiceSet: InvoiceSetNode;
};

export type CreateWorkOrderNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inquiryNoteTemplate?: InputMaybe<Scalars['String']['input']>;
  inquiryType?: InputMaybe<InquiryType>;
  inquiryTypeCategory?: InputMaybe<Scalars['String']['input']>;
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type CreateWorkOrderNotePayload = {
  __typename: 'CreateWorkOrderNotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  note: WorkOrderNoteNode;
};

export type CreateWorkOrderReviewArguments = {
  comment: Scalars['String']['input'];
  feedbackIds: Array<Scalars['ID']['input']>;
  reviewRequestId?: InputMaybe<Scalars['ID']['input']>;
  satisfied: Scalars['Boolean']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type CreateWorkOrderReviewMutation = {
  __typename: 'CreateWorkOrderReviewMutation';
  workOrder: Maybe<WorkOrderNode>;
};

export type CreateWorkOrderV2Input = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  callbackOriginalWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID generated by the client to identify a new work order before the backend assigns an ID. */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facilityAccessDetails?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']['input']>;
  images: Array<Image>;
  isCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContact?: InputMaybe<WorkOrderPointOfContactInput>;
  reasonForEmergency?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  /** Name of the anonymous user submitting the work order */
  requestorName?: InputMaybe<Scalars['String']['input']>;
  selectedVendorId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory: ServiceCategory;
  symptomId?: InputMaybe<Scalars['ID']['input']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  troubleshootingSessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWorkOrderV2Payload = {
  __typename: 'CreateWorkOrderV2Payload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type CreditCardFeeNotice = {
  __typename: 'CreditCardFeeNotice';
  defaultRatePercentage: Maybe<Scalars['Decimal']['output']>;
  exemptFacilityRegionNames: Array<Scalars['String']['output']>;
  feeEffectiveOn: Scalars['Date']['output'];
  isFeeEffective: Scalars['Boolean']['output'];
  isNoticeActive: Scalars['Boolean']['output'];
  regionalRateOverrides: Array<CreditCardFeeNoticeRegionalRateOverride>;
};

export type CreditCardFeeNoticeRegionalRateOverride = {
  __typename: 'CreditCardFeeNoticeRegionalRateOverride';
  ratePercentage: Scalars['Decimal']['output'];
  regionName: Scalars['String']['output'];
};

export type CreditCardPaymentNode = Node & {
  __typename: 'CreditCardPaymentNode';
  brand: Maybe<Scalars['String']['output']>;
  cardholderName: Scalars['String']['output'];
  expiryMonth: Scalars['String']['output'];
  expiryYear: Scalars['String']['output'];
  funding: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
};

export type CreditCardPaymentPreview = {
  __typename: 'CreditCardPaymentPreview';
  brand: Scalars['String']['output'];
  creditCardLastFour: Scalars['String']['output'];
  facilityPreviews: Array<FacilityPaymentPreview>;
  total: Scalars['Decimal']['output'];
  workOrders: Array<WorkOrderNode>;
};

/** An enumeration. */
export enum Currency {
  Cad = 'CAD',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CustomerMatchSet = {
  __typename: 'CustomerMatchSet';
  accountingIntegrationCustomer: Maybe<AccountingIntegrationCustomerNode>;
  facility: Maybe<FacilityNode>;
  offResqCustomer: Maybe<OffResqCustomerNode>;
  offResqFacility: Maybe<OffResqFacilityNode>;
};

/** An enumeration. */
export enum CustomerTypeEnum {
  Offresq = 'OFFRESQ',
  Resq = 'RESQ'
}

export type CyovDataInput = {
  cyovNCallbackVendor?: InputMaybe<Scalars['Int']['input']>;
  cyovNFavouriteVendor?: InputMaybe<Scalars['Int']['input']>;
  cyovNResqVerifiedVendor?: InputMaybe<Scalars['Int']['input']>;
  cyovNVendorDirectory?: InputMaybe<Scalars['Int']['input']>;
  listIndex?: InputMaybe<Scalars['Int']['input']>;
  selectedFrom?: InputMaybe<VendorOption>;
  selectedFromSavingsCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DailyProcessingDataNode = {
  __typename: 'DailyProcessingDataNode';
  count: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['Date']['output']>;
  provider: Maybe<Scalars['String']['output']>;
};

export type DeactivateEquipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
};

export type DeactivateEquipmentPayload = {
  __typename: 'DeactivateEquipmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  equipment: EquipmentNode;
};

export type DeactivateFacilityInput = {
  cancelSubscriptionReason?: InputMaybe<CancelReason>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
};

export type DeactivateFacilityPayload = {
  __typename: 'DeactivateFacilityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facility: FacilityNode;
};

export type DeactivateOrganizationSubscriptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type DeactivateOrganizationSubscriptionsPayload = {
  __typename: 'DeactivateOrganizationSubscriptionsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DecideProposalMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  decision: OffResqQuoteDecision;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Unified proposal decision mutation for OffResq, standalone quotes, and
 * maintenance plan proposals.
 *
 * Accepts an optional metadata JSON blob; signature is required for approvals.
 */
export type DecideProposalMutationPayload = {
  __typename: 'DecideProposalMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  maintenancePlan: Maybe<MaintenancePlanNode>;
  quote: Maybe<QuoteNode>;
};

export type DecimalObjectType = Node & {
  __typename: 'DecimalObjectType';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  value: Maybe<Scalars['Decimal']['output']>;
};

export type DeclineOffResqVendorSubcontractMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineOffResqVendorSubcontractMutationPayload = {
  __typename: 'DeclineOffResqVendorSubcontractMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  subcontract: WorkOrderSubcontractType;
};

export type DeclineVendorDispatchRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otherReason?: InputMaybe<Scalars['String']['input']>;
  reasonChoice?: InputMaybe<VendorDispatchRequestDeclineReasonChoices>;
  vendorDispatchRequestId: Scalars['ID']['input'];
};

export type DeclineVendorDispatchRequestMutationPayload = {
  __typename: 'DeclineVendorDispatchRequestMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorDispatchRequest: VendorDispatchRequestNode;
};

export type DeclineVendorPreventiveMaintenanceRecommendationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  declineReason: VendorPreventiveMaintenanceRecommendationDeclineReason;
  recommendationId: Scalars['ID']['input'];
};

export type DeclineVendorPreventiveMaintenanceRecommendationMutationPayload = {
  __typename: 'DeclineVendorPreventiveMaintenanceRecommendationMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorPreventiveMaintenanceRecommendation: VendorPreventiveMaintenanceRecommendationNode;
};

export type DefaultVendorRevenueShareNode = Node & {
  __typename: 'DefaultVendorRevenueShareNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourPercentage: Maybe<Scalars['Decimal']['output']>;
  otherPercentage: Maybe<Scalars['Decimal']['output']>;
  partsPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']['output']>;
  travelPercentage: Maybe<Scalars['Decimal']['output']>;
  truckPercentage: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type DefaultVendorRevenueShareNodeConnection = {
  __typename: 'DefaultVendorRevenueShareNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DefaultVendorRevenueShareNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DefaultVendorRevenueShareNode` and its cursor. */
export type DefaultVendorRevenueShareNodeEdge = {
  __typename: 'DefaultVendorRevenueShareNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<DefaultVendorRevenueShareNode>;
};

export type DefaultVendorRevenueShareOverrideNode = Node & {
  __typename: 'DefaultVendorRevenueShareOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourPercentage: Maybe<Scalars['Decimal']['output']>;
  otherPercentage: Maybe<Scalars['Decimal']['output']>;
  partsPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']['output']>;
  travelPercentage: Maybe<Scalars['Decimal']['output']>;
  truckPercentage: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type DefaultVendorRevenueShareOverrideNodeConnection = {
  __typename: 'DefaultVendorRevenueShareOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DefaultVendorRevenueShareOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DefaultVendorRevenueShareOverrideNode` and its cursor. */
export type DefaultVendorRevenueShareOverrideNodeEdge = {
  __typename: 'DefaultVendorRevenueShareOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<DefaultVendorRevenueShareOverrideNode>;
};

export type DeleteAttachmentMutation = {
  __typename: 'DeleteAttachmentMutation';
  ok: Scalars['Boolean']['output'];
};

export type DeleteBrandMutationInput = {
  brandId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBrandMutationPayload = {
  __typename: 'DeleteBrandMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteBudgetMutationInput = {
  budgetId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBudgetMutationPayload = {
  __typename: 'DeleteBudgetMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteBusinessUnitMutationInput = {
  businessUnitId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBusinessUnitMutationPayload = {
  __typename: 'DeleteBusinessUnitMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteClientManagedInvoiceInput = {
  clientManagedInvoiceId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteClientManagedInvoicePayload = {
  __typename: 'DeleteClientManagedInvoicePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteClientReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  reportType: ClientReportType;
};

export type DeleteClientReportScheduleMutationPayload = {
  __typename: 'DeleteClientReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteCommentMutation = {
  __typename: 'DeleteCommentMutation';
  ok: Scalars['Boolean']['output'];
};

export type DeleteFacilityGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['ID']['input'];
};

export type DeleteFacilityGroupPayload = {
  __typename: 'DeleteFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
};

export type DeleteFacilityPayload = {
  __typename: 'DeleteFacilityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facility: FacilityNode;
};

export type DeleteFavouriteVendorConfigurationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favouriteVendorConfigurationId: Scalars['ID']['input'];
};

export type DeleteFavouriteVendorConfigurationPayload = {
  __typename: 'DeleteFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteGatewayInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  gatewayId: Scalars['String']['input'];
};

export type DeleteGatewayPayload = {
  __typename: 'DeleteGatewayPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteImageFromWorkOrderMutation = {
  __typename: 'DeleteImageFromWorkOrderMutation';
  ok: Scalars['Boolean']['output'];
};

export type DeleteInboundVendorInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inboundVendorInvoiceId: Scalars['ID']['input'];
};

export type DeleteInboundVendorInvoiceMutationPayload = {
  __typename: 'DeleteInboundVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteInvoiceSetNoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['ID']['input'];
};

export type DeleteInvoiceSetNoteMutationPayload = {
  __typename: 'DeleteInvoiceSetNoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteOffResqWorkOrderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId: Scalars['ID']['input'];
};

export type DeleteOffResqWorkOrderMutationPayload = {
  __typename: 'DeleteOffResqWorkOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePartneredSubmissionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partneredSubmissionId: Scalars['ID']['input'];
};

export type DeletePartneredSubmissionMutationPayload = {
  __typename: 'DeletePartneredSubmissionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeletePreventativeMaintenanceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceId: Scalars['ID']['input'];
};

export type DeletePreventativeMaintenancePayload = {
  __typename: 'DeletePreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeletePriceBookCategoryMutationInput = {
  categoryId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePriceBookCategoryMutationPayload = {
  __typename: 'DeletePriceBookCategoryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeletePriceBookItemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
};

export type DeletePriceBookItemMutationPayload = {
  __typename: 'DeletePriceBookItemMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteProposalCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
};

export type DeleteProposalCommentMutationPayload = {
  __typename: 'DeleteProposalCommentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteProtectionPlanEnrollmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  protectionPlanEnrollmentId: Scalars['ID']['input'];
};

export type DeleteProtectionPlanEnrollmentPayload = {
  __typename: 'DeleteProtectionPlanEnrollmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteRecordOfWorkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recordOfWorkId: Scalars['ID']['input'];
};

export type DeleteRecordOfWorkMutationPayload = {
  __typename: 'DeleteRecordOfWorkMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};

export type DeleteRolePayload = {
  __typename: 'DeleteRolePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteSensorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
  sensorId: Scalars['String']['input'];
};

export type DeleteSensorPayload = {
  __typename: 'DeleteSensorPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteTestimonialMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  testimonialId: Scalars['ID']['input'];
};

/** Mutation to delete a testimonial from a vendor business profile. */
export type DeleteTestimonialMutationPayload = {
  __typename: 'DeleteTestimonialMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteVendorFacilityInsuranceDocumentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type DeleteVendorFacilityInsuranceDocumentMutationPayload = {
  __typename: 'DeleteVendorFacilityInsuranceDocumentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteVendorPromotionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotionId: Scalars['ID']['input'];
};

export type DeleteVendorPromotionMutationPayload = {
  __typename: 'DeleteVendorPromotionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteVendorRankingForFacilityAndServiceCategoryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['ID']['input'];
  serviceCategory: Scalars['String']['input'];
};

export type DeleteVendorRankingForFacilityAndServiceCategoryMutationPayload = {
  __typename: 'DeleteVendorRankingForFacilityAndServiceCategoryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteVendorRankingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
};

export type DeleteVendorRankingMutationPayload = {
  __typename: 'DeleteVendorRankingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteVendorReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  reportType: VendorReportType;
};

export type DeleteVendorReportScheduleMutationPayload = {
  __typename: 'DeleteVendorReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteVendorWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['ID']['input'];
};

export type DeleteVendorWorkOrderInternalNotePayload = {
  __typename: 'DeleteVendorWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeleteWorkOrderInternalNoteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['ID']['input'];
};

export type DeleteWorkOrderInternalNotePayload = {
  __typename: 'DeleteWorkOrderInternalNotePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DetermineTroubleshootingPlanNode = {
  __typename: 'DetermineTroubleshootingPlanNode';
  id: Scalars['ID']['output'];
  troubleshootingPlan: Maybe<TroubleshootingPlanNode>;
};

export type Device = {
  __typename: 'Device';
  createdAt: Scalars['DateTime']['output'];
  equipment: EquipmentNode;
  facility: FacilityNode;
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: ClientOrganizationNode;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceConfig = {
  __typename: 'DeviceConfig';
  createdAt: Scalars['String']['output'];
  deviceId: Scalars['ID']['output'];
  disabledAt: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastDataAt: Maybe<Scalars['String']['output']>;
  lastPolledAt: Maybe<Scalars['String']['output']>;
  pollingLengthSeconds: Scalars['Int']['output'];
  readingType: DeviceConfigReadingType;
  thresholdType: DeviceConfigThresholdType;
  thresholdValue: Scalars['Decimal']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum DeviceConfigReadingType {
  Data = 'DATA',
  Humidity = 'HUMIDITY',
  Temperature = 'TEMPERATURE'
}

export type DeviceConfigRequestInput = {
  configId?: InputMaybe<Scalars['String']['input']>;
  readingType: Scalars['String']['input'];
  thresholdType: Scalars['String']['input'];
  thresholdValue: Scalars['Decimal']['input'];
};

/** An enumeration. */
export enum DeviceConfigThresholdType {
  Higher = 'HIGHER',
  Lower = 'LOWER'
}

export type DeviceData = {
  __typename: 'DeviceData';
  data: Array<DeviceDataRow>;
  deviceId: Scalars['ID']['output'];
};

/** An enumeration. */
export enum DeviceDataInputTimescale {
  Custom = 'CUSTOM',
  Last_24Hours = 'LAST_24_HOURS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR'
}

export type DeviceDataRow = {
  __typename: 'DeviceDataRow';
  humidity: Maybe<Scalars['Decimal']['output']>;
  temperature: Maybe<Scalars['Decimal']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type DeviceDataSet = {
  __typename: 'DeviceDataSet';
  deviceSet: Array<DeviceData>;
  equipment: EquipmentNode;
  timebinInSeconds: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum DiscountType {
  FlatAmount = 'FLAT_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DismissMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
};

export type DismissMutationPayload = {
  __typename: 'DismissMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DismissWorkOrderNoteMetadataMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type DismissWorkOrderNoteMetadataMutationPayload = {
  __typename: 'DismissWorkOrderNoteMetadataMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type DispatchActivity = Activity & Node & {
  __typename: 'DispatchActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dispatch: Maybe<VendorDispatchNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<DispatchActivityOutcome>;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum DispatchActivityOutcome {
  Dispatched = 'DISPATCHED',
  NoneAccepted = 'NONE_ACCEPTED',
  NoResponse = 'NO_RESPONSE'
}

/** Dispatch method preferences for work orders. */
export enum DispatchMethod {
  DispatchOrder = 'DISPATCH_ORDER',
  Manual = 'MANUAL'
}

export type DisputeWorkOrderArguments = {
  reason: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type DisputeWorkOrderMutation = {
  __typename: 'DisputeWorkOrderMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String']['output'];
  /** The message of the exception */
  message: Scalars['String']['output'];
  /** The stack trace */
  stack: Scalars['String']['output'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  encoding: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  isoLevel: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  sql: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  transId: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  transStatus: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String']['output'];
};

export type DjangoGroupNode = Node & {
  __typename: 'DjangoGroupNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DjangoGroupNodeConnection = {
  __typename: 'DjangoGroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DjangoGroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DjangoGroupNode` and its cursor. */
export type DjangoGroupNodeEdge = {
  __typename: 'DjangoGroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<DjangoGroupNode>;
};

export type DjangoPermissionNode = Node & {
  __typename: 'DjangoPermissionNode';
  codename: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DjangoPermissionNodeConnection = {
  __typename: 'DjangoPermissionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DjangoPermissionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DjangoPermissionNode` and its cursor. */
export type DjangoPermissionNodeEdge = {
  __typename: 'DjangoPermissionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<DjangoPermissionNode>;
};

export type EditBlockedGroupsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  facilityGroupIds: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type EditBlockedGroupsPayload = {
  __typename: 'EditBlockedGroupsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientOrganization: ClientOrganizationNode;
  vendor: VendorOrganizationNode;
};

export type EditClientOrganizationMemberMutation = {
  __typename: 'EditClientOrganizationMemberMutation';
  member: ClientOrganizationMemberNode;
};

export type EditClientOrganizationMutation = {
  __typename: 'EditClientOrganizationMutation';
  clientOrganization: ClientOrganizationNode;
};

export type EditClientVendorRelationshipInviteInput = {
  businessName: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  inviteId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type EditClientVendorRelationshipInvitePayload = {
  __typename: 'EditClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  invite: InviteNode;
};

export type EditEquipmentMutation = {
  __typename: 'EditEquipmentMutation';
  equipment: EquipmentNode;
  ok: Scalars['Boolean']['output'];
};

export type EditFavouriteVendorConfigurationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds: Array<Scalars['ID']['input']>;
  favouriteVendorConfigurationId: Scalars['ID']['input'];
  serviceCategories: Array<ServiceCategory>;
};

export type EditFavouriteVendorConfigurationPayload = {
  __typename: 'EditFavouriteVendorConfigurationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  favouriteVendorConfiguration: FavouriteVendorConfigurationNode;
};

export type EditOrgOwnerMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type EditOrgOwnerMutationPayload = {
  __typename: 'EditOrgOwnerMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrganizationFeaturesMutationInput = {
  additionalFeatures?: InputMaybe<Array<Features>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  removedFeatures?: InputMaybe<Array<Features>>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

export type EditOrganizationFeaturesMutationPayload = {
  __typename: 'EditOrganizationFeaturesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditPreventativeMaintenanceInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deletedTaskListAdditionalUrls?: InputMaybe<Array<Scalars['ID']['input']>>;
  deletedTaskListAttachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  frequencyValue: Scalars['Int']['input'];
  newTaskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  newTaskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  nextWorkOrderCreationDate: Scalars['Date']['input'];
  preventativeMaintenanceId: Scalars['ID']['input'];
  recurrenceDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  taskListItems: Array<Scalars['String']['input']>;
  teamMemberIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type EditPreventativeMaintenancePayload = {
  __typename: 'EditPreventativeMaintenancePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type EditQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<LineItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
};

export type EditQuoteMutationPayload = {
  __typename: 'EditQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quote: QuoteNode;
};

export type EditUserDjangoGroupsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groups: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type EditUserDjangoGroupsMutationPayload = {
  __typename: 'EditUserDjangoGroupsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type EditVendorUserDetailsMutation = {
  __typename: 'EditVendorUserDetailsMutation';
  ok: Scalars['Boolean']['output'];
};

export type EditWorkOrderInput = {
  assignedTeamMemberId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facilityAccessInfo?: InputMaybe<Scalars['String']['input']>;
  firstVisitSchedulingNotes?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Image>>;
  isCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContact?: InputMaybe<WorkOrderPointOfContactInput>;
  reasonForEmergency?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  selectedVendorId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  symptomId?: InputMaybe<Scalars['ID']['input']>;
  taxonomyNodeId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type EditWorkOrderPayload = {
  __typename: 'EditWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

/**
 * A GraphQL node that combines both Offer and OrganizationOffer models.
 * This provides a unified interface for querying offer data regardless of the underlying model type.
 */
export type EffectiveOfferNode = Node & {
  __typename: 'EffectiveOfferNode';
  currency: Maybe<Scalars['String']['output']>;
  forOrganization: Maybe<VendorOrganizationNode>;
  id: Scalars['ID']['output'];
  offerType: Maybe<OfferType>;
  pricingType: Maybe<PricingType>;
  rate: Maybe<Scalars['Decimal']['output']>;
  relatedToOrganization: Maybe<ClientOrganizationNode>;
  resqService: Maybe<ResqServiceNode>;
  type: Scalars['String']['output'];
};

export type EnableVendorNoraEmailForwardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type EnableVendorNoraEmailForwardingMutationPayload = {
  __typename: 'EnableVendorNoraEmailForwardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type EndActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type EndActivityPayload = {
  __typename: 'EndActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EndOffResqWorkOrderVisitMutationInput = {
  afterImages?: InputMaybe<Array<Image>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerSignature?: InputMaybe<FacilityManagerSignatureInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqAppointmentId: Scalars['ID']['input'];
};

export type EndOffResqWorkOrderVisitMutationPayload = {
  __typename: 'EndOffResqWorkOrderVisitMutationPayload';
  aiTextSuggestions: Array<AiTextSuggestionType>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqAppointment: Maybe<OffResqAppointmentNode>;
};

export type EndVisitInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerSignature?: InputMaybe<FacilityManagerSignatureInput>;
  holdReason?: InputMaybe<Scalars['String']['input']>;
  images: Array<Image>;
  nextAppointmentEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  nextAppointmentStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  nextAppointmentTechnician?: InputMaybe<Scalars['ID']['input']>;
  notes: Scalars['String']['input'];
  outcome?: InputMaybe<VisitOutcome>;
  recommendations: Scalars['String']['input'];
  sourcingPartsHoldEtaEnd?: InputMaybe<Scalars['Date']['input']>;
  sourcingPartsHoldEtaStart?: InputMaybe<Scalars['Date']['input']>;
  visit?: InputMaybe<Scalars['ID']['input']>;
};

export type EndVisitPayload = {
  __typename: 'EndVisitPayload';
  aiTextSuggestions: Array<AiTextSuggestionType>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum EntityType {
  Facility = 'FACILITY',
  OffResqFacility = 'OFF_RESQ_FACILITY'
}

export type EquipmentCategoryNode = Node & {
  __typename: 'EquipmentCategoryNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<EquipmentCategoryNode>;
  path: Array<EquipmentCategoryNode>;
  serviceCategory: Maybe<EquipmentCategoryServiceCategory>;
  taxonomyNode: Maybe<TaxonomyNodeNode>;
};

export type EquipmentCategoryNodeConnection = {
  __typename: 'EquipmentCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EquipmentCategoryNode` and its cursor. */
export type EquipmentCategoryNodeEdge = {
  __typename: 'EquipmentCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentCategoryNode>;
};

/** An enumeration. */
export enum EquipmentCategoryServiceCategory {
  /** Accessibility & Hardware */
  AccessibilityHardware = 'ACCESSIBILITY_HARDWARE',
  /** Air Compressors */
  AirCompressors = 'AIR_COMPRESSORS',
  /** Architect/Design */
  ArchitectDesign = 'ARCHITECT_DESIGN',
  /** Asbestos */
  Asbestos = 'ASBESTOS',
  /** Audits */
  Audits = 'AUDITS',
  /** Awaiting Categorization */
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  /** Backflow */
  Backflow = 'BACKFLOW',
  /** Beverage Equipment */
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  /** Bowling Equipment */
  BowlingEquipment = 'BOWLING_EQUIPMENT',
  /** Burglar Alarm */
  BurglarAlarm = 'BURGLAR_ALARM',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Chowbotics */
  Chowbotics = 'CHOWBOTICS',
  /** Cleaning */
  Cleaning = 'CLEANING',
  /** Closed Circuit Television */
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  /** CO2 */
  Co2 = 'CO2',
  /** Coffee */
  Coffee = 'COFFEE',
  /** Consumables & Replenishment */
  ConsumablesReplenishment = 'CONSUMABLES_REPLENISHMENT',
  /** Cutting Board Resurfacing */
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  /** Drive Thru Items */
  DriveThuItems = 'DRIVE_THU_ITEMS',
  /** Electrical */
  Electrical = 'ELECTRICAL',
  /** Elevators & Dumbwaiters */
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  /** EMERGENCY_LIGHTS */
  EmergencyLights = 'EMERGENCY_LIGHTS',
  /** Environmental Consulting */
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  /** Equipment Leasing */
  EquipmentLeasing = 'EQUIPMENT_LEASING',
  /** Fire Alarms */
  FireAlarms = 'FIRE_ALARMS',
  /** Fire Suppression */
  FireSuppression = 'FIRE_SUPPRESSION',
  /** FIXTURES */
  Fixtures = 'FIXTURES',
  /** Flooring */
  Flooring = 'FLOORING',
  /** Food Equipment */
  FoodEquipment = 'FOOD_EQUIPMENT',
  /** Fuel Oil */
  FuelOil = 'FUEL_OIL',
  /** Furniture */
  Furniture = 'FURNITURE',
  /** Gaskets */
  Gaskets = 'GASKETS',
  /** Gas & Boilers */
  GasBoilers = 'GAS_BOILERS',
  /** General Contracting */
  GeneralContracting = 'GENERAL_CONTRACTING',
  /** General Repair/Handywork */
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  /** Generators & Power Supply */
  Generators = 'GENERATORS',
  /** Grease Traps */
  GreaseTrap = 'GREASE_TRAP',
  /** Gym Equipment */
  GymEquipment = 'GYM_EQUIPMENT',
  /** Heating & Cooling/HVAC */
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  /** Hoods */
  Hoods = 'HOODS',
  /** Hospitality */
  Hospitality = 'HOSPITALITY',
  /** Hot Water Systems */
  HotWaterTank = 'HOT_WATER_TANK',
  /** Ice Machines */
  IceMachine = 'ICE_MACHINE',
  /** Landscaping */
  Landscaping = 'LANDSCAPING',
  /** Locks & Doors */
  LocksDoors = 'LOCKS_DOORS',
  /** Medical Equipment */
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  /** Menu Screens */
  MenuScreens = 'MENU_SCREENS',
  /** Messenger Services */
  MessengerServices = 'MESSENGER_SERVICES',
  /** Millwork */
  Millwork = 'MILLWORK',
  /** Miscellaneous */
  Miscellaneous = 'MISCELLANEOUS',
  /** Moving Services */
  MovingServices = 'MOVING_SERVICES',
  /** Pack Screens */
  PackScreens = 'PACK_SCREENS',
  /** Painting */
  Painting = 'PAINTING',
  /** Parts/Supply Order */
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  /** Pavement */
  Pavement = 'PAVEMENT',
  /** Pest Control */
  PestControl = 'PEST_CONTROL',
  /** Planned Project */
  PlannedProject = 'PLANNED_PROJECT',
  /** Plumbing */
  Plumbing = 'PLUMBING',
  /** Refrigeration */
  Refrigeration = 'REFRIGERATION',
  /** Roofing */
  Roofing = 'ROOFING',
  /** Room Setup / Take Down */
  RoomSetupTakeDown = 'ROOM_SETUP_TAKE_DOWN',
  /** Security */
  Security = 'SECURITY',
  /** Shredding */
  Shredding = 'SHREDDING',
  /** Signage */
  Signage = 'SIGNAGE',
  /** Snow Removal */
  SnowRemoval = 'SNOW_REMOVAL',
  /** Soda/Beer */
  SodaBeer = 'SODA_BEER',
  /** Spa Equipment */
  SpaEquipment = 'SPA_EQUIPMENT',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Temp Services */
  TempServices = 'TEMP_SERVICES',
  /** Tiling */
  Tiling = 'TILING',
  /** Uniforms & Laundry */
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  /** Upholstery */
  Upholstery = 'UPHOLSTERY',
  /** Vending Machines */
  VendingMachines = 'VENDING_MACHINES',
  /** Ware Washing Equipment */
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  /** Waste Removal */
  WasteRemoval = 'WASTE_REMOVAL',
  /** Water Treatment */
  WaterFiltration = 'WATER_FILTRATION',
  /** Welding */
  Welding = 'WELDING',
  /** Windows, Doors & Locks */
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  /** Windows & Glass */
  WindowsGlass = 'WINDOWS_GLASS'
}

export type EquipmentImageNode = {
  __typename: 'EquipmentImageNode';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type EquipmentManufacturerNode = Node & {
  __typename: 'EquipmentManufacturerNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentManufacturerNodeConnection = {
  __typename: 'EquipmentManufacturerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentManufacturerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EquipmentManufacturerNode` and its cursor. */
export type EquipmentManufacturerNodeEdge = {
  __typename: 'EquipmentManufacturerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentManufacturerNode>;
};

export type EquipmentNode = Node & {
  __typename: 'EquipmentNode';
  alerts: Array<Alert>;
  barCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced with service category */
  category: Maybe<CategoryNode>;
  code: Scalars['String']['output'];
  cost: Maybe<Scalars['Decimal']['output']>;
  description: Maybe<Scalars['String']['output']>;
  devices: Array<Device>;
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  externalTotalSpend: Maybe<Scalars['Decimal']['output']>;
  facility: Maybe<FacilityNode>;
  hasWarranty: Maybe<Scalars['Boolean']['output']>;
  historicalSpend: Maybe<Scalars['Decimal']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** @deprecated Replaced with main_image */
  image: Maybe<Scalars['String']['output']>;
  incidents: Array<Incident>;
  installedOn: Maybe<Scalars['Date']['output']>;
  internalTotalSpend: Maybe<Scalars['Decimal']['output']>;
  isUnderCyovWarranty: Maybe<Scalars['Boolean']['output']>;
  location: Scalars['String']['output'];
  mainImage: Maybe<ImageType>;
  manufacturer: Maybe<Scalars['String']['output']>;
  modelNo: Maybe<Scalars['String']['output']>;
  modelTagImage: Maybe<ImageType>;
  name: Scalars['String']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  /** @deprecated Replaced with main/model tag images */
  photos: Array<EquipmentImageNode>;
  serialNo: Maybe<Scalars['String']['output']>;
  serviceCategory: Maybe<ServiceCategory>;
  shouldUpdateWarranty: Scalars['Boolean']['output'];
  status: EquipmentStatus;
  /** @deprecated Replaced with service category */
  subcategory: Maybe<TradeNode>;
  symptoms: Array<TaxonomySymptomNode>;
  totalSpend: Maybe<Scalars['Decimal']['output']>;
  vendorRanking: Maybe<VendorRankingNode>;
  warrantyExpiresOn: Maybe<Scalars['Date']['output']>;
  warrantyInfoReceivedOn: Maybe<Scalars['DateTime']['output']>;
  warrantyNotes: Maybe<Scalars['String']['output']>;
  workOrderCount: Scalars['Int']['output'];
  workOrders: Array<WorkOrderNode>;
};


export type EquipmentNodeIncidentsArgs = {
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
};

export type EquipmentNodeConnection = {
  __typename: 'EquipmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquipmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EquipmentNode` and its cursor. */
export type EquipmentNodeEdge = {
  __typename: 'EquipmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<EquipmentNode>;
};

export type EquipmentServiceCount = {
  __typename: 'EquipmentServiceCount';
  count: Scalars['Int']['output'];
  equipment: EquipmentNode;
};

export enum EquipmentStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** An enumeration. */
export enum EscalationChannel {
  App = 'APP',
  Email = 'EMAIL',
  Phone = 'PHONE',
  Sms = 'SMS'
}

export type EscalationChannelType = {
  __typename: 'EscalationChannelType';
  key: EscalationChannel;
  label: Scalars['String']['output'];
};

/** An enumeration. */
export enum ExpansionRequestType {
  FacilityExpansion = 'FACILITY_EXPANSION',
  NoExpansionPossible = 'NO_EXPANSION_POSSIBLE'
}

/** An enumeration. */
export enum ExpectedServiceTimeline {
  Asap = 'ASAP',
  ByNextBusinessDay = 'BY_NEXT_BUSINESS_DAY',
  Flexible = 'FLEXIBLE',
  SameDay = 'SAME_DAY',
  Within_7Days = 'WITHIN_7_DAYS'
}

export type ExpectedServiceTimelineType = {
  __typename: 'ExpectedServiceTimelineType';
  expectedArrivalTimestamp: Maybe<Scalars['DateTime']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  key: ExpectedServiceTimeline;
  label: Scalars['String']['output'];
  validatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ExpensePerCategorySpendData = {
  __typename: 'ExpensePerCategorySpendData';
  serviceCategory: ServiceCategory;
  totalSpend: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum ExpenseType {
  Capex = 'CAPEX',
  Opex = 'OPEX'
}

/** An enumeration. */
export enum ExpenseTypeSetThrough {
  BudgetEdit = 'BUDGET_EDIT',
  QuoteProcess = 'QUOTE_PROCESS',
  WorkOrderCreation = 'WORK_ORDER_CREATION',
  WorkOrderEdit = 'WORK_ORDER_EDIT'
}

export type ExperienceAreas = {
  __typename: 'ExperienceAreas';
  dispatch: Scalars['Boolean']['output'];
};

export type ExternalBankAccountNode = Node & {
  __typename: 'ExternalBankAccountNode';
  accountNumber: Scalars['String']['output'];
  address: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Maybe<CityNode>;
  cityName: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<CountryNode>;
  firstName: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  institutionNumber: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  province: Maybe<ProvinceNode>;
  routingNumber: Scalars['String']['output'];
  type: ExternalBankAccountType;
};

export type ExternalBankAccountNodeConnection = {
  __typename: 'ExternalBankAccountNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalBankAccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ExternalBankAccountNode` and its cursor. */
export type ExternalBankAccountNodeEdge = {
  __typename: 'ExternalBankAccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ExternalBankAccountNode>;
};

/** An enumeration. */
export enum ExternalBankAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type ExtractionNode = Node & {
  __typename: 'ExtractionNode';
  /** ID of the entity this extraction was converted to */
  convertedToObjectId: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  extractedData: Maybe<Scalars['JSONString']['output']>;
  extractionSet: ExtractionSetNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Versioned schema class name (e.g., 'OffResqWorkOrderData_v1', 'ProposalData_v1', 'OffResqCustomerData_v1', 'OffResqFacilityData_v1', 'ContactData_v1') */
  schemaName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExtractionSetNode = Node & {
  __typename: 'ExtractionSetNode';
  createdAt: Scalars['DateTime']['output'];
  extractions: Array<ExtractionNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  leadInboundRequest: LeadInboundRequestNode;
  /** Status of the extraction attempt */
  status: ExtractionSetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum ExtractionSetStatus {
  /** Failed */
  Failed = 'FAILED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Retry */
  Retry = 'RETRY',
  /** Success */
  Success = 'SUCCESS'
}

export type FacilitiesOnboardingStepInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  busyHours?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onsiteHours?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['ID']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum FacilityCanActions {
  Manage = 'MANAGE',
  ManageEquipment = 'MANAGE_EQUIPMENT',
  ManageSensors = 'MANAGE_SENSORS'
}

export type FacilityGroupAllotmentInput = {
  allotment: Scalars['Decimal']['input'];
  facilityGroupId: Scalars['ID']['input'];
};

export type FacilityGroupMembershipNode = Node & {
  __typename: 'FacilityGroupMembershipNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Shortcut for retrieving roles of user in facility client. */
  roles: Array<RoleNode>;
  user: UserNode;
};

export type FacilityGroupNode = Node & {
  __typename: 'FacilityGroupNode';
  allBlockedVendors: Array<VendorOrganizationNode>;
  allMemberships: Array<FacilityGroupMembershipNode>;
  blocklist: Array<VendorOrganizationNode>;
  children: Array<FacilityGroupNode>;
  facility: Maybe<FacilityNode>;
  facilityCount: Scalars['Int']['output'];
  facilityIds: Array<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  memberships: Array<FacilityGroupMembershipNode>;
  name: Scalars['String']['output'];
  opsOwner: Maybe<UserNode>;
  organization: ClientOrganizationNode;
  parent: Maybe<FacilityGroupNode>;
  parentId: Maybe<Scalars['ID']['output']>;
  pathIds: Array<Scalars['ID']['output']>;
  permissions: FacilityGroupPermissions;
  qrSubmissionAuthenticationMode: Maybe<QrSubmissionAuthenticationMode>;
};

export type FacilityGroupNodeConnection = {
  __typename: 'FacilityGroupNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityGroupNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FacilityGroupNode` and its cursor. */
export type FacilityGroupNodeEdge = {
  __typename: 'FacilityGroupNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FacilityGroupNode>;
};

export type FacilityGroupPermissions = {
  __typename: 'FacilityGroupPermissions';
  manage: Scalars['Boolean']['output'];
};

export type FacilityGroupSelectionNode = Node & {
  __typename: 'FacilityGroupSelectionNode';
  facilityGroups: FacilityGroupNodeConnection;
  facilityIds: Maybe<Array<Scalars['Int']['output']>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  organization: ClientOrganizationNode;
};


export type FacilityGroupSelectionNodeFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FacilityGroupSelectionNodeConnection = {
  __typename: 'FacilityGroupSelectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityGroupSelectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FacilityGroupSelectionNode` and its cursor. */
export type FacilityGroupSelectionNodeEdge = {
  __typename: 'FacilityGroupSelectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FacilityGroupSelectionNode>;
};

export type FacilityGroupSpendNode = Node & {
  __typename: 'FacilityGroupSpendNode';
  allottedAmount: Scalars['Decimal']['output'];
  facilityGroup: FacilityGroupNode;
  id: Scalars['ID']['output'];
  spentAmount: Scalars['Decimal']['output'];
  upcomingSpendAmount: Scalars['Decimal']['output'];
  upcomingSpendCount: Scalars['Int']['output'];
};

export type FacilityManagerSignatureInput = {
  upload?: InputMaybe<SignatureUploadInput>;
};

export type FacilityNode = Node & {
  __typename: 'FacilityNode';
  accessInfo: Scalars['String']['output'];
  actualGoLiveOn: Maybe<Scalars['Date']['output']>;
  address: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  allowedServiceCategories: Array<ServiceCategory>;
  brand: Maybe<BrandNode>;
  businessLegalName: Maybe<Scalars['String']['output']>;
  businessLegalStructure: Maybe<BusinessLegalStructure>;
  businessTaxNumber: Maybe<Scalars['String']['output']>;
  businessUnit: Maybe<BusinessUnitNode>;
  busyHoursJson: Maybe<Scalars['String']['output']>;
  can: Scalars['Boolean']['output'];
  city: CityNode;
  cityName: Maybe<Scalars['String']['output']>;
  clientOrganization: ClientOrganizationNode;
  code: Scalars['String']['output'];
  country: CountryNode;
  currency: Currency;
  daysOpenedJson: Maybe<Scalars['String']['output']>;
  disabledCategories: Array<ServiceCategory>;
  email: Scalars['String']['output'];
  equipment: Array<EquipmentNode>;
  /** @deprecated Replaced by 'equipment' */
  equipments: Array<EquipmentNode>;
  facilityInsuranceDocument: Maybe<VendorDocumentNode>;
  gateways: Maybe<GatewaysResponse>;
  goliveOn: Maybe<Scalars['Date']['output']>;
  group: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isBillable: Scalars['Boolean']['output'];
  isDirectVendorPaymentEnabled: Scalars['Boolean']['output'];
  isMissingBrd: Maybe<Scalars['Boolean']['output']>;
  isTaggingCharged: Maybe<Scalars['Boolean']['output']>;
  lat: Maybe<Scalars['Float']['output']>;
  lng: Maybe<Scalars['Float']['output']>;
  maintenancePlans: Array<MaintenancePlanNode>;
  /** @deprecated Use group.memberships instead. */
  memberships: Array<FacilityGroupMembershipNode>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  onboardingStatus: Maybe<OnboardingStatus>;
  onsiteHoursJson: Maybe<Scalars['String']['output']>;
  openedOn: Maybe<Scalars['Date']['output']>;
  operatingArea: Maybe<OperatingAreaNode>;
  /** Contact's email, used to create a user after onboarding. Is set during onboarding when owner does not have payment method info */
  paymentContactEmail: Maybe<Scalars['String']['output']>;
  /** Contact's name, used to create a user after onboarding. Is set during onboarding when owner does not have payment method info */
  paymentContactName: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  paymentMethods: Maybe<Array<PaymentMethodNode>>;
  phone: Scalars['String']['output'];
  photo: Maybe<ImageType>;
  plannedGoLiveOn: Maybe<Scalars['Date']['output']>;
  postalCode: Scalars['String']['output'];
  province: ProvinceNode;
  qrCode: Maybe<Scalars['String']['output']>;
  qrSubmissionAuthenticationMode: Maybe<QrSubmissionAuthenticationMode>;
  satisfactionRate: SatisfactionRate;
  status: FacilityStatus;
  storeNumber: Maybe<Scalars['String']['output']>;
  subscription: Maybe<SubscriptionNode>;
  taggingMethod: Maybe<TaggingMethod>;
  timezone: Scalars['String']['output'];
  transactionFee: Scalars['Float']['output'];
  /** @deprecated Replaced by top-level 'workOrders' query */
  workOrders: Array<WorkOrderNode>;
  zipCode: Scalars['String']['output'];
};


export type FacilityNodeCanArgs = {
  perform: FacilityCanActions;
};


export type FacilityNodeGatewaysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FacilityNodeConnection = {
  __typename: 'FacilityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FacilityNode` and its cursor. */
export type FacilityNodeEdge = {
  __typename: 'FacilityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FacilityNode>;
};

export type FacilityPaymentPreview = {
  __typename: 'FacilityPaymentPreview';
  facility: FacilityNode;
  invoiceCount: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
  workOrderCount: Scalars['Int']['output'];
};

export enum FacilityStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type FacilitySubscriptionInput = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  goliveOn?: InputMaybe<Scalars['Date']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityVendorRelationshipMetrics = {
  __typename: 'FacilityVendorRelationshipMetrics';
  totalInvoicedAmount: Scalars['Decimal']['output'];
  totalJobCount: Scalars['Int']['output'];
};

export type FacilityVendorRelationshipNode = Node & {
  __typename: 'FacilityVendorRelationshipNode';
  client: ClientOrganizationNode;
  facility: FacilityNode;
  favouritedServiceCategories: Array<ServiceCategory>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  metrics: FacilityVendorRelationshipMetrics;
  vendor: VendorOrganizationNode;
};


export type FacilityVendorRelationshipNodeMetricsArgs = {
  metricsRangeWeeks: Scalars['Int']['input'];
};

export type FacilityVendorRelationshipNodeConnection = {
  __typename: 'FacilityVendorRelationshipNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FacilityVendorRelationshipNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FacilityVendorRelationshipNode` and its cursor. */
export type FacilityVendorRelationshipNodeEdge = {
  __typename: 'FacilityVendorRelationshipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FacilityVendorRelationshipNode>;
};

export type FastPaySurpriseNode = Node & {
  __typename: 'FastPaySurpriseNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSet: Maybe<InvoiceSetNode>;
  offer: OfferNode;
  vendor: VendorOrganizationNode;
};

export type FastPaySurpriseNodeConnection = {
  __typename: 'FastPaySurpriseNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FastPaySurpriseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FastPaySurpriseNode` and its cursor. */
export type FastPaySurpriseNodeEdge = {
  __typename: 'FastPaySurpriseNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FastPaySurpriseNode>;
};

export type FavouriteVendorConfigurationNode = Node & {
  __typename: 'FavouriteVendorConfigurationNode';
  facilityGroups: Array<FacilityGroupNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  permissions: FavouriteVendorConfigurationPermissions;
  serviceCategories: Array<ServiceCategory>;
  vendor: VendorOrganizationNode;
};

export type FavouriteVendorConfigurationNodeConnection = {
  __typename: 'FavouriteVendorConfigurationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FavouriteVendorConfigurationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FavouriteVendorConfigurationNode` and its cursor. */
export type FavouriteVendorConfigurationNodeEdge = {
  __typename: 'FavouriteVendorConfigurationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FavouriteVendorConfigurationNode>;
};

export type FavouriteVendorConfigurationPermissions = {
  __typename: 'FavouriteVendorConfigurationPermissions';
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
};

export type FeatureTierNode = Node & {
  __typename: 'FeatureTierNode';
  features: Array<Features>;
  hidden: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pricingModel: Maybe<PricingModelNode>;
};

export type FeatureTierNodeConnection = {
  __typename: 'FeatureTierNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeatureTierNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FeatureTierNode` and its cursor. */
export type FeatureTierNodeEdge = {
  __typename: 'FeatureTierNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FeatureTierNode>;
};

/** An enumeration. */
export enum Features {
  AssetTrackingAndManagement = 'ASSET_TRACKING_AND_MANAGEMENT',
  BudgetManagement = 'BUDGET_MANAGEMENT',
  ConsolidatedApAndInvoicing = 'CONSOLIDATED_AP_AND_INVOICING',
  CustomizableReporting = 'CUSTOMIZABLE_REPORTING',
  CustomizableRolesAndPermissions = 'CUSTOMIZABLE_ROLES_AND_PERMISSIONS',
  CustomizableSpendControls = 'CUSTOMIZABLE_SPEND_CONTROLS',
  DedicatedAccountManager = 'DEDICATED_ACCOUNT_MANAGER',
  DefaultRolesAndPermissions = 'DEFAULT_ROLES_AND_PERMISSIONS',
  DefaultSpendControls = 'DEFAULT_SPEND_CONTROLS',
  EquipmentTroubleshooting = 'EQUIPMENT_TROUBLESHOOTING',
  InternalTechnicianManagement = 'INTERNAL_TECHNICIAN_MANAGEMENT',
  InvoiceApprovals = 'INVOICE_APPROVALS',
  InvoiceFlaggingAlgorithm = 'INVOICE_FLAGGING_ALGORITHM',
  IotTemperatureSensors = 'IOT_TEMPERATURE_SENSORS',
  PersonalizedDashboard = 'PERSONALIZED_DASHBOARD',
  PreventativeMaintenanceManagement = 'PREVENTATIVE_MAINTENANCE_MANAGEMENT',
  QuarterlyBusinessReviews = 'QUARTERLY_BUSINESS_REVIEWS',
  RepairVsReplaceTracking = 'REPAIR_VS_REPLACE_TRACKING',
  ResqOnDemand = 'RESQ_ON_DEMAND',
  SingleSignOn = 'SINGLE_SIGN_ON',
  TwentyFourSevenTechnicalSupport = 'TWENTY_FOUR_SEVEN_TECHNICAL_SUPPORT',
  UnlimitedUsers = 'UNLIMITED_USERS',
  VendorManagementAndPerformanceMetrics = 'VENDOR_MANAGEMENT_AND_PERFORMANCE_METRICS',
  WorkOrderManagement = 'WORK_ORDER_MANAGEMENT'
}

export type FileType = {
  __typename: 'FileType';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FilterInput = {
  datatype: ReportFilterDatatype;
  field: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  operator: ReportFilterOperator;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FinanceInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  financeRequests: Array<FinanceInvoiceRequestInput>;
};

export type FinanceInvoiceMutationPayload = {
  __typename: 'FinanceInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  results: Array<FinanceInvoiceResult>;
  success: Scalars['Boolean']['output'];
};

export type FinanceInvoiceRequestInput = {
  invoiceId: Scalars['ID']['input'];
  invoicePaymentPlanId: Scalars['String']['input'];
  issuedProductId: Scalars['ID']['input'];
};

export type FinanceInvoiceResult = {
  __typename: 'FinanceInvoiceResult';
  error: Maybe<Scalars['String']['output']>;
  financedInvoiceId: Maybe<Scalars['ID']['output']>;
  invoiceId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type FinancedInvoiceNode = Node & {
  __typename: 'FinancedInvoiceNode';
  clientInvoice: Maybe<ClientInvoiceNode>;
  createdAt: Scalars['DateTime']['output'];
  externalInvoiceId: Maybe<Scalars['String']['output']>;
  externalProvider: LenderProviderKey;
  feeAmount: Maybe<Scalars['Decimal']['output']>;
  financedAmount: Maybe<Scalars['Decimal']['output']>;
  fundedAmount: Maybe<Scalars['Decimal']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoicePaymentPlanId: Maybe<Scalars['String']['output']>;
  issuedProduct: Maybe<IssuedProductNode>;
  metadata: Maybe<Scalars['JSONString']['output']>;
  status: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendorInvoice: Maybe<VendorInvoiceNode>;
};

export type FinancedInvoiceNodeConnection = {
  __typename: 'FinancedInvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FinancedInvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FinancedInvoiceNode` and its cursor. */
export type FinancedInvoiceNodeEdge = {
  __typename: 'FinancedInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<FinancedInvoiceNode>;
};

export type FirstTimeFixRate = {
  __typename: 'FirstTimeFixRate';
  rate: Scalars['Decimal']['output'];
  serviceCategory: ServiceCategory;
};

export type ForceLogoutUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type ForceLogoutUserMutationPayload = {
  __typename: 'ForceLogoutUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  sessionsRevoked: Scalars['Int']['output'];
  user: UserNode;
};

export type ForceWorkOrderCompletionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  visitDate?: InputMaybe<Scalars['DateTime']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type ForceWorkOrderCompletionMutationPayload = {
  __typename: 'ForceWorkOrderCompletionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum FormatOptions {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Svg = 'SVG',
  Webp = 'WEBP'
}

export type GlCodeNode = Node & {
  __typename: 'GLCodeNode';
  code: Scalars['String']['output'];
  expenseType: Maybe<ExpenseType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategory: ServiceCategory;
};

export type GlCodeNodeConnection = {
  __typename: 'GLCodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GlCodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GLCodeNode` and its cursor. */
export type GlCodeNodeEdge = {
  __typename: 'GLCodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<GlCodeNode>;
};

export type Gateway = {
  __typename: 'Gateway';
  awsId: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  facility: FacilityNode;
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastUplinkReceived: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organization: ClientOrganizationNode;
  snapshotCheckError: Maybe<Scalars['String']['output']>;
  snapshotCheckedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GatewayConnection = {
  __typename: 'GatewayConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GatewayEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `Gateway` and its cursor. */
export type GatewayEdge = {
  __typename: 'GatewayEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Gateway>;
};

/** An enumeration. */
export enum GatewayStatusFilter {
  CheckFailed = 'CHECK_FAILED',
  NeverSeen = 'NEVER_SEEN',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Stale_24HPlus = 'STALE_24H_PLUS'
}

/** Response type for paginated gateways with total count. */
export type GatewaysResponse = {
  __typename: 'GatewaysResponse';
  gateways: Array<Gateway>;
  totalCount: Scalars['Int']['output'];
};

export type GenerateKustomerLoginTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type GenerateKustomerLoginTokenPayload = {
  __typename: 'GenerateKustomerLoginTokenPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type GenerateMagicLinkTokenMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  navigableLocation: NavigableLocation;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateMagicLinkTokenMutationPayload = {
  __typename: 'GenerateMagicLinkTokenMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  magicLink: Maybe<Scalars['String']['output']>;
};

export type GenerateOffResqCustomerPortalLinkInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GenerateOffResqCustomerPortalLinkPayload = {
  __typename: 'GenerateOffResqCustomerPortalLinkPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  portalLink: Scalars['String']['output'];
};

export type GenerateVendorInvoicePdfInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<LineItemInput>;
  notes: Scalars['String']['input'];
  overrideNotes: Scalars['String']['input'];
  vendorNotes: Scalars['String']['input'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']['input']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type GenerateVendorInvoicePdfPayload = {
  __typename: 'GenerateVendorInvoicePDFPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  pdfFile: Scalars['String']['output'];
};

export type GetAllAlertsInput = {
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  incidentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAllDevicesInput = {
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetClientCalendarItemsSetInput = {
  calendarItemTypes?: InputMaybe<Array<ClientCalendarItemType>>;
  endDate: Scalars['Date']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['Date']['input'];
};

export type GetClientStaffSchedulesInput = {
  endDate: Scalars['Date']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  staffMemberIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type GetDeviceDataInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  equipmentId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timescale?: InputMaybe<DeviceDataInputTimescale>;
};

export type GoogleAdsAccountStateType = {
  __typename: 'GoogleAdsAccountStateType';
  campaignActivationStatus: WebsiteAdvertisingCampaignActivationStatus;
  canEnableCampaign: Scalars['Boolean']['output'];
  currencyCode: Maybe<Scalars['String']['output']>;
  providerAccountId: Maybe<Scalars['String']['output']>;
  providerDisplayName: Maybe<Scalars['String']['output']>;
  status: WebsiteAdvertisingAccountStatus;
  timeZone: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsBillingStateType = {
  __typename: 'GoogleAdsBillingStateType';
  canLaunch: Scalars['Boolean']['output'];
  dailyManagementFeeAmount: Maybe<Scalars['Decimal']['output']>;
  dailySpendAmount: Maybe<Scalars['Decimal']['output']>;
  fundingMode: Maybe<WebsiteAdvertisingBillingConfigFundingMode>;
  intendedSpendAmount: Maybe<Scalars['Decimal']['output']>;
  managementFeeAmount: Maybe<Scalars['Decimal']['output']>;
  managementFeeRate: Scalars['Decimal']['output'];
  status: GoogleAdsBillingStatus;
};

/** An enumeration. */
export enum GoogleAdsBillingStatus {
  Draft = 'DRAFT',
  NotConfigured = 'NOT_CONFIGURED',
  Ready = 'READY'
}

/** An enumeration. */
export enum GoogleAdsCampaignChannelType {
  Search = 'SEARCH'
}

export type GoogleAdsCampaignDraftPreviewStateType = {
  __typename: 'GoogleAdsCampaignDraftPreviewStateType';
  draftType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keywordPlannerMapping: Maybe<GoogleAdsKeywordPlannerMappingStateType>;
  preview: GoogleAdsDraftPreviewStateType;
  status: GoogleAdsDraftPreviewStatus;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsCampaignInputMetadataType = {
  __typename: 'GoogleAdsCampaignInputMetadataType';
  generationSource: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  llmRejectionReason: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
};

export type GoogleAdsCampaignInputSnapshotLocationTargetType = {
  __typename: 'GoogleAdsCampaignInputSnapshotLocationTargetType';
  canonicalName: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  lookupName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceLabel: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
};

export type GoogleAdsCampaignInputSnapshotStateType = {
  __typename: 'GoogleAdsCampaignInputSnapshotStateType';
  descriptions: Array<Scalars['String']['output']>;
  finalUrl: Scalars['String']['output'];
  headlines: Array<Scalars['String']['output']>;
  keywords: Array<GoogleAdsKeywordSuggestionType>;
  languageCode: Scalars['String']['output'];
  locationTargets: Array<GoogleAdsCampaignInputSnapshotLocationTargetType>;
};

export type GoogleAdsCampaignStateType = {
  __typename: 'GoogleAdsCampaignStateType';
  campaignStatusUpdate: Maybe<GoogleAdsCampaignStatusWorkflowStateType>;
  channelType: GoogleAdsCampaignChannelType;
  dailyBudgetAmount: Scalars['Decimal']['output'];
  draftPreviews: Array<GoogleAdsCampaignDraftPreviewStateType>;
  id: Scalars['ID']['output'];
  inputSnapshot: Maybe<GoogleAdsCampaignInputSnapshotStateType>;
  name: Scalars['String']['output'];
  orchestration: Maybe<GoogleAdsOrchestrationStateType>;
  providerCampaignBudgetResourceName: Scalars['String']['output'];
  providerCampaignResourceName: Scalars['String']['output'];
  reporting: Maybe<GoogleAdsReportingWorkspaceType>;
  websiteAdvertisingCampaignId: Scalars['ID']['output'];
};


export type GoogleAdsCampaignStateTypeCampaignStatusUpdateArgs = {
  jobId?: InputMaybe<Scalars['Int']['input']>;
};


export type GoogleAdsCampaignStateTypeReportingArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleAdsCampaignStatusWorkflowStateType = {
  __typename: 'GoogleAdsCampaignStatusWorkflowStateType';
  adGroupAdResourceName: Scalars['String']['output'];
  adGroupResourceName: Scalars['String']['output'];
  blockedReason: Scalars['String']['output'];
  campaignResourceName: Scalars['String']['output'];
  changed: Scalars['Boolean']['output'];
  errorPayload: Scalars['GenericScalar']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  jobId: Scalars['Int']['output'];
  observedAdGroupAdStatus: Scalars['String']['output'];
  observedAdGroupStatus: Scalars['String']['output'];
  observedCampaignStatus: Scalars['String']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  targetStatus: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsDraftPreviewStateType = {
  __typename: 'GoogleAdsDraftPreviewStateType';
  availableServiceCategories: Array<ServiceCategory>;
  callPhoneNumber: Maybe<Scalars['String']['output']>;
  callPhoneNumberConfigured: Scalars['Boolean']['output'];
  descriptions: Array<Scalars['String']['output']>;
  finalUrl: Maybe<Scalars['String']['output']>;
  generationInputsDirty: Scalars['Boolean']['output'];
  hasSavedDraft: Scalars['Boolean']['output'];
  headlines: Array<Scalars['String']['output']>;
  keywords: Array<GoogleAdsKeywordSuggestionType>;
  message: Maybe<Scalars['String']['output']>;
  metadata: Maybe<GoogleAdsCampaignInputMetadataType>;
  reasonCode: Maybe<Scalars['String']['output']>;
  sampleSearches: Array<Scalars['String']['output']>;
  selectedIntentKeys: Array<Scalars['String']['output']>;
  selectedLocationTargets: Array<GoogleAdsCampaignInputSnapshotLocationTargetType>;
  selectedServiceCategories: Array<ServiceCategory>;
  status: GoogleAdsDraftPreviewStatus;
  websiteAdvertisingCampaignId: Maybe<Scalars['ID']['output']>;
};

/** An enumeration. */
export enum GoogleAdsDraftPreviewStatus {
  NotReady = 'NOT_READY',
  Ready = 'READY'
}

/** Top-level outcomes a Google Ads flow orchestrator can report. */
export enum GoogleAdsFlowOutcome {
  Blocked = 'BLOCKED',
  Enqueued = 'ENQUEUED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Succeeded = 'SUCCEEDED'
}

/** An enumeration. */
export enum GoogleAdsKeywordMatchType {
  Exact = 'EXACT',
  Phrase = 'PHRASE'
}

export type GoogleAdsKeywordPlannerAdGroupKeywordPlanType = {
  __typename: 'GoogleAdsKeywordPlannerAdGroupKeywordPlanType';
  keywords: Array<GoogleAdsKeywordPlannerMappedKeywordType>;
  name: Scalars['String']['output'];
  rawIdeasCount: Scalars['Int']['output'];
  rawMetricsCount: Scalars['Int']['output'];
  rejectedKeywords: Array<GoogleAdsKeywordPlannerRejectedKeywordType>;
  seedKeywords: Array<Scalars['String']['output']>;
  serviceCategories: Array<Scalars['String']['output']>;
};

export type GoogleAdsKeywordPlannerMappedKeywordMonthlySearchVolumeType = {
  __typename: 'GoogleAdsKeywordPlannerMappedKeywordMonthlySearchVolumeType';
  month: Maybe<Scalars['String']['output']>;
  monthlySearches: Maybe<Scalars['Int']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type GoogleAdsKeywordPlannerMappedKeywordType = {
  __typename: 'GoogleAdsKeywordPlannerMappedKeywordType';
  averageCpcMicros: Maybe<Scalars['Int']['output']>;
  avgMonthlySearches: Maybe<Scalars['Int']['output']>;
  closeVariants: Array<Scalars['String']['output']>;
  competition: Maybe<Scalars['String']['output']>;
  competitionIndex: Maybe<Scalars['Int']['output']>;
  highTopOfPageBidMicros: Maybe<Scalars['Int']['output']>;
  lowTopOfPageBidMicros: Maybe<Scalars['Int']['output']>;
  matchType: GoogleAdsKeywordMatchType;
  monthlySearchVolumes: Array<GoogleAdsKeywordPlannerMappedKeywordMonthlySearchVolumeType>;
  providerMetrics: Scalars['GenericScalar']['output'];
  providerRow: Scalars['GenericScalar']['output'];
  source: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GoogleAdsKeywordPlannerMappingStateType = {
  __typename: 'GoogleAdsKeywordPlannerMappingStateType';
  adGroupKeywordPlans: Array<GoogleAdsKeywordPlannerAdGroupKeywordPlanType>;
  blockedReason: Scalars['String']['output'];
  errorPayload: Scalars['GenericScalar']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  jobId: Scalars['Int']['output'];
  mappedKeywordsCount: Scalars['Int']['output'];
  rawIdeasCount: Scalars['Int']['output'];
  rawMetricsCount: Scalars['Int']['output'];
  rejectedKeywordsCount: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: GoogleAdsKeywordPlannerMappingStatus;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration. */
export enum GoogleAdsKeywordPlannerMappingStatus {
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  Superseded = 'SUPERSEDED'
}

export type GoogleAdsKeywordPlannerRejectedKeywordType = {
  __typename: 'GoogleAdsKeywordPlannerRejectedKeywordType';
  reason: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GoogleAdsKeywordSuggestionType = {
  __typename: 'GoogleAdsKeywordSuggestionType';
  matchType: GoogleAdsKeywordMatchType;
  text: Scalars['String']['output'];
};

export type GoogleAdsLocationGeometryInput = {
  canonicalName?: InputMaybe<Scalars['String']['input']>;
  clientKey?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleAdsManagementFeeSnapshotType = {
  __typename: 'GoogleAdsManagementFeeSnapshotType';
  adSpend: Scalars['Float']['output'];
  captureSource: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  managementFee: Scalars['Float']['output'];
  month: Scalars['Date']['output'];
};

export type GoogleAdsOrchestrationStageStateType = {
  __typename: 'GoogleAdsOrchestrationStageStateType';
  blockedReason: Maybe<Scalars['String']['output']>;
  jobId: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  status: GoogleAdsStageStatus;
};

export type GoogleAdsOrchestrationStateType = {
  __typename: 'GoogleAdsOrchestrationStateType';
  currentJobId: Maybe<Scalars['Int']['output']>;
  currentStageKey: Maybe<Scalars['String']['output']>;
  currentStageLabel: Maybe<Scalars['String']['output']>;
  flowKey: Scalars['String']['output'];
  flowType: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  outcome: GoogleAdsFlowOutcome;
  reasonCode: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  stages: Array<GoogleAdsOrchestrationStageStateType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsReportingCampaignResultType = {
  __typename: 'GoogleAdsReportingCampaignResultType';
  fetchedAt: Maybe<Scalars['DateTime']['output']>;
  isStale: Scalars['Boolean']['output'];
  metrics: GoogleAdsReportingMetricsType;
  primaryCampaignStatus: Maybe<Scalars['String']['output']>;
  refreshInProgress: Scalars['Boolean']['output'];
  rows: Array<GoogleAdsReportingCampaignRowType>;
  staleAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsReportingCampaignRowType = {
  __typename: 'GoogleAdsReportingCampaignRowType';
  advertisingChannelType: Maybe<Scalars['String']['output']>;
  campaignBudget: Maybe<Scalars['Float']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  campaignStatus: Scalars['String']['output'];
  metrics: GoogleAdsReportingMetricsType;
};

export type GoogleAdsReportingCustomerResultType = {
  __typename: 'GoogleAdsReportingCustomerResultType';
  customerDescriptiveName: Maybe<Scalars['String']['output']>;
  customerId: Maybe<Scalars['String']['output']>;
  fetchedAt: Maybe<Scalars['DateTime']['output']>;
  isStale: Scalars['Boolean']['output'];
  metrics: GoogleAdsReportingMetricsType;
  refreshInProgress: Scalars['Boolean']['output'];
  staleAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsReportingGeographicResultType = {
  __typename: 'GoogleAdsReportingGeographicResultType';
  fetchedAt: Maybe<Scalars['DateTime']['output']>;
  isStale: Scalars['Boolean']['output'];
  refreshInProgress: Scalars['Boolean']['output'];
  rows: Array<GoogleAdsReportingGeographicRowType>;
  staleAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsReportingGeographicRowType = {
  __typename: 'GoogleAdsReportingGeographicRowType';
  campaignId: Maybe<Scalars['String']['output']>;
  canonicalName: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  locationKey: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationType: Maybe<Scalars['String']['output']>;
  metrics: GoogleAdsReportingMetricsType;
  targetType: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsReportingMetricsType = {
  __typename: 'GoogleAdsReportingMetricsType';
  clicks: Scalars['Int']['output'];
  conversions: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
};

export type GoogleAdsReportingTimeseriesPointType = {
  __typename: 'GoogleAdsReportingTimeseriesPointType';
  day: Scalars['Date']['output'];
  metrics: GoogleAdsReportingMetricsType;
};

export type GoogleAdsReportingTimeseriesResultType = {
  __typename: 'GoogleAdsReportingTimeseriesResultType';
  fetchedAt: Maybe<Scalars['DateTime']['output']>;
  isStale: Scalars['Boolean']['output'];
  points: Array<GoogleAdsReportingTimeseriesPointType>;
  refreshInProgress: Scalars['Boolean']['output'];
  staleAt: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleAdsReportingWorkspaceType = {
  __typename: 'GoogleAdsReportingWorkspaceType';
  billingHistory: Array<VendorInvoiceNode>;
  campaigns: GoogleAdsReportingCampaignResultType;
  customer: GoogleAdsReportingCustomerResultType;
  customerId: Maybe<Scalars['String']['output']>;
  dateRangeEnd: Scalars['Date']['output'];
  dateRangeStart: Scalars['Date']['output'];
  geographic: GoogleAdsReportingGeographicResultType;
  isConnected: Scalars['Boolean']['output'];
  managementFee: GoogleAdsManagementFeeSnapshotType;
  timeseries: GoogleAdsReportingTimeseriesResultType;
};

export type GoogleAdsResolvedLocationGeometryBoundsType = {
  __typename: 'GoogleAdsResolvedLocationGeometryBoundsType';
  east: Scalars['Float']['output'];
  north: Scalars['Float']['output'];
  south: Scalars['Float']['output'];
  west: Scalars['Float']['output'];
};

export type GoogleAdsResolvedLocationGeometryPointType = {
  __typename: 'GoogleAdsResolvedLocationGeometryPointType';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GoogleAdsResolvedLocationGeometryType = {
  __typename: 'GoogleAdsResolvedLocationGeometryType';
  bounds: Maybe<GoogleAdsResolvedLocationGeometryBoundsType>;
  center: Maybe<GoogleAdsResolvedLocationGeometryPointType>;
  clientKey: Scalars['String']['output'];
  confidence: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  placeType: Scalars['String']['output'];
  polygon: Maybe<Scalars['GenericScalar']['output']>;
  sourceProvider: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Normalized stage states used by the base engine while evaluating the flow. */
export enum GoogleAdsStageStatus {
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED'
}

export type GoogleAdsStateType = {
  __typename: 'GoogleAdsStateType';
  account: Maybe<GoogleAdsAccountStateType>;
  billing: GoogleAdsBillingStateType;
  campaigns: Array<GoogleAdsCampaignStateType>;
  reporting: Maybe<GoogleAdsReportingWorkspaceType>;
};


export type GoogleAdsStateTypeCampaignsArgs = {
  googleAdsCampaignId?: InputMaybe<Scalars['ID']['input']>;
};


export type GoogleAdsStateTypeReportingArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleBusinessConnectionStatus = {
  __typename: 'GoogleBusinessConnectionStatus';
  connected: Scalars['Boolean']['output'];
  connectedAt: Maybe<Scalars['DateTime']['output']>;
  manageUrl: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
  vendorName: Maybe<Scalars['String']['output']>;
  vendorTrackingId: Scalars['Int']['output'];
};

export type Image = {
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ImageNode = Node & {
  __typename: 'ImageNode';
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};


export type ImageNodeUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** GraphQL type for Django's ImageField. */
export type ImageType = {
  __typename: 'ImageType';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


/** GraphQL type for Django's ImageField. */
export type ImageTypeUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportAccountingIntegrationCustomersMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationType: OAuthIntegrationType;
  vendorId: Scalars['ID']['input'];
};

export type ImportAccountingIntegrationCustomersMutationPayload = {
  __typename: 'ImportAccountingIntegrationCustomersMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ImportBankStatementsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ImportBankStatementsMutationPayload = {
  __typename: 'ImportBankStatementsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type InboundEmailAttachmentConnection = {
  __typename: 'InboundEmailAttachmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboundEmailAttachmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InboundEmailAttachment` and its cursor. */
export type InboundEmailAttachmentEdge = {
  __typename: 'InboundEmailAttachmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InboundEmailAttachmentNode>;
};

/** Type for InboundEmailAttachment, which represents a file attachment from an inbound email. */
export type InboundEmailAttachmentNode = Node & {
  __typename: 'InboundEmailAttachmentNode';
  attachmentUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Type for InboundEmail, which represents an email received through SendGrid's inbound parse webhook. */
export type InboundEmailNode = Node & {
  __typename: 'InboundEmailNode';
  attachments: Maybe<InboundEmailAttachmentConnection>;
  createdAt: Scalars['DateTime']['output'];
  fromAddress: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};


/** Type for InboundEmail, which represents an email received through SendGrid's inbound parse webhook. */
export type InboundEmailNodeAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum InboundInvoiceAutoApproveRejectionReason {
  ContainsFees = 'CONTAINS_FEES',
  ContainsPromotion = 'CONTAINS_PROMOTION',
  DirectVendorPayment = 'DIRECT_VENDOR_PAYMENT',
  LineItemsMismatch = 'LINE_ITEMS_MISMATCH',
  MarkupInvoicingVersion = 'MARKUP_INVOICING_VERSION',
  MultipleInvoicesForSameWorkOrder = 'MULTIPLE_INVOICES_FOR_SAME_WORK_ORDER',
  PostalCodeMismatch = 'POSTAL_CODE_MISMATCH',
  ProcessingIssue = 'PROCESSING_ISSUE',
  ProvinceTaxRateMismatch = 'PROVINCE_TAX_RATE_MISMATCH',
  QuoteAmountMismatch = 'QUOTE_AMOUNT_MISMATCH',
  TaxRateMismatch = 'TAX_RATE_MISMATCH',
  TaxTypeMismatch = 'TAX_TYPE_MISMATCH',
  TotalMismatch = 'TOTAL_MISMATCH',
  TotalTooHigh = 'TOTAL_TOO_HIGH',
  UkFacility = 'UK_FACILITY',
  WorkOrderNotFound = 'WORK_ORDER_NOT_FOUND'
}

/** An enumeration. */
export enum InboundInvoiceProcessingIssue {
  DuplicateVendorRefNumber = 'DUPLICATE_VENDOR_REF_NUMBER',
  FailedToCreateRecordOfWork = 'FAILED_TO_CREATE_RECORD_OF_WORK',
  FailedToExtract = 'FAILED_TO_EXTRACT',
  LineItemDescriptionTooLong = 'LINE_ITEM_DESCRIPTION_TOO_LONG',
  MissingGlobalRevShare = 'MISSING_GLOBAL_REV_SHARE',
  PayloadTooLarge = 'PAYLOAD_TOO_LARGE',
  WrongWorkOrder = 'WRONG_WORK_ORDER'
}

/** An enumeration. */
export enum InboundVendorInvoiceDeliveryMethod {
  /** Created in PMC */
  CreatedInPmc = 'CREATED_IN_PMC',
  /** Email */
  Email = 'EMAIL',
  /** Synced from QuickBooks Online */
  SyncedFromQuickbooks = 'SYNCED_FROM_QUICKBOOKS',
  /** Uploaded by Invited Vendor */
  UploadedByInvitedVendor = 'UPLOADED_BY_INVITED_VENDOR',
  /** Uploaded in Client App */
  UploadedInClientApp = 'UPLOADED_IN_CLIENT_APP',
  /** Uploaded in Partner App */
  UploadedInPartnerApp = 'UPLOADED_IN_PARTNER_APP',
  /** Uploaded in PMC */
  UploadedInPmc = 'UPLOADED_IN_PMC',
  /** Uploaded in RMC */
  UploadedInRmc = 'UPLOADED_IN_RMC'
}

/** GraphQL node for InboundVendorInvoiceExtraction, which tracks extraction data from invoice processing. */
export type InboundVendorInvoiceExtractionNode = Node & {
  __typename: 'InboundVendorInvoiceExtractionNode';
  assignedTo: Maybe<UserNode>;
  /** Reason for assigning this extraction to a coordinator */
  assignmentReason: Maybe<Scalars['String']['output']>;
  autoApproveRejectionReason: Maybe<InboundInvoiceAutoApproveRejectionReason>;
  autoApproved: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  externalId: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundVendorInvoice: Maybe<InboundVendorInvoiceNode>;
  invoiceSet: Maybe<InvoiceSetNode>;
  lastRetry: Maybe<Scalars['DateTime']['output']>;
  primaryExtraction: Maybe<Scalars['JSONString']['output']>;
  processingComplete: Maybe<Scalars['DateTime']['output']>;
  processingIssue: Maybe<InboundInvoiceProcessingIssue>;
  provider: Maybe<InvoiceExtractionProvider>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Maybe<UserNode>;
  retries: Scalars['Int']['output'];
  secondaryExtraction: Maybe<Scalars['JSONString']['output']>;
  total: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Maybe<Scalars['Boolean']['output']>;
  workOrder: Maybe<WorkOrderNode>;
};

export type InboundVendorInvoiceExtractionNodeConnection = {
  __typename: 'InboundVendorInvoiceExtractionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboundVendorInvoiceExtractionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InboundVendorInvoiceExtractionNode` and its cursor. */
export type InboundVendorInvoiceExtractionNodeEdge = {
  __typename: 'InboundVendorInvoiceExtractionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InboundVendorInvoiceExtractionNode>;
};

export type InboundVendorInvoiceNode = Node & {
  __typename: 'InboundVendorInvoiceNode';
  createdAt: Scalars['DateTime']['output'];
  deliveryMethod: InboundVendorInvoiceDeliveryMethod;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceFile: FileType;
  invoiceSet: Maybe<InvoiceSetNode>;
  name: Scalars['String']['output'];
  recordOfWork: Maybe<RecordOfWorkNode>;
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type InboundVendorInvoiceNodeConnection = {
  __typename: 'InboundVendorInvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboundVendorInvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InboundVendorInvoiceNode` and its cursor. */
export type InboundVendorInvoiceNodeEdge = {
  __typename: 'InboundVendorInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InboundVendorInvoiceNode>;
};

/** An enumeration. */
export enum InboundVendorInvoiceSource {
  CreatedInPmc = 'CREATED_IN_PMC',
  Email = 'EMAIL',
  SyncedFromQuickbooks = 'SYNCED_FROM_QUICKBOOKS',
  UploadedByInvitedVendor = 'UPLOADED_BY_INVITED_VENDOR',
  UploadedInClientApp = 'UPLOADED_IN_CLIENT_APP',
  UploadedInPartnerApp = 'UPLOADED_IN_PARTNER_APP',
  UploadedInPmc = 'UPLOADED_IN_PMC',
  UploadedInRmc = 'UPLOADED_IN_RMC'
}

export type InboundVendorInvoiceValidationNode = Node & {
  __typename: 'InboundVendorInvoiceValidationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  validationResult: Maybe<InboundVendorInvoiceValidationResult>;
};

export type InboundVendorInvoiceValidationResult = {
  __typename: 'InboundVendorInvoiceValidationResult';
  canOverride: Scalars['Boolean']['output'];
  validationMessage: Scalars['String']['output'];
};

export type InboxItemExternalReference = VendorDispatchNode | WorkOrderNode | WorkOrderTeamMemberAssignmentNode;

export type InboxItemNode = Node & {
  __typename: 'InboxItemNode';
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data: Maybe<Scalars['JSONString']['output']>;
  externalReference: InboxItemExternalReference;
  externalReferenceId: Scalars['ID']['output'];
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  itemType: InboxItemType;
  readAt: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
  user: UserNode;
  workOrder: Maybe<WorkOrderNode>;
};

export type InboxItemNodeConnection = {
  __typename: 'InboxItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboxItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InboxItemNode` and its cursor. */
export type InboxItemNodeEdge = {
  __typename: 'InboxItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InboxItemNode>;
};

/** An enumeration. */
export enum InboxItemType {
  ChecklistAssigned = 'CHECKLIST_ASSIGNED',
  DispatchFailed = 'DISPATCH_FAILED',
  InvoiceApproval = 'INVOICE_APPROVAL',
  QuoteApproval = 'QUOTE_APPROVAL',
  QuoteSelection = 'QUOTE_SELECTION',
  QuoteSpendApproval = 'QUOTE_SPEND_APPROVAL',
  WorkOrderTeamMemberAssignment = 'WORK_ORDER_TEAM_MEMBER_ASSIGNMENT',
  WorkOrderTriage = 'WORK_ORDER_TRIAGE'
}

export type Incident = {
  __typename: 'Incident';
  alerts: Array<Alert>;
  config: DeviceConfig;
  createdAt: Scalars['DateTime']['output'];
  device: Device;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  equipment: EquipmentNode;
  id: Scalars['ID']['output'];
  snoozedUntil: Maybe<Scalars['DateTime']['output']>;
  status: IncidentStatus;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  workOrder: Maybe<WorkOrderNode>;
};

export type IncidentConnection = {
  __typename: 'IncidentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IncidentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `Incident` and its cursor. */
export type IncidentEdge = {
  __typename: 'IncidentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Incident>;
};

/** An enumeration. */
export enum IncidentStatus {
  Closed = 'CLOSED',
  Ongoing = 'ONGOING',
  Resolved = 'RESOLVED'
}

/** An enumeration. */
export enum Industry {
  AgricultureAndFoodProduction = 'AGRICULTURE_AND_FOOD_PRODUCTION',
  ConstructionAndEngineering = 'CONSTRUCTION_AND_ENGINEERING',
  EducationalInstitutions = 'EDUCATIONAL_INSTITUTIONS',
  EntertainmentAndRecreation = 'ENTERTAINMENT_AND_RECREATION',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthcareFacilities = 'HEALTHCARE_FACILITIES',
  HospitalityAndLodging = 'HOSPITALITY_AND_LODGING',
  IndustrialAndManufacturing = 'INDUSTRIAL_AND_MANUFACTURING',
  MediaAndCommunication = 'MEDIA_AND_COMMUNICATION',
  OfficeBuildingsAndCorporateFacilities = 'OFFICE_BUILDINGS_AND_CORPORATE_FACILITIES',
  PublicServicesAndGovernment = 'PUBLIC_SERVICES_AND_GOVERNMENT',
  RealEstateAndPropertyManagement = 'REAL_ESTATE_AND_PROPERTY_MANAGEMENT',
  Residential = 'RESIDENTIAL',
  RestaurantsAndFoodServices = 'RESTAURANTS_AND_FOOD_SERVICES',
  RetailStores = 'RETAIL_STORES',
  TechnologyAndItServices = 'TECHNOLOGY_AND_IT_SERVICES',
  TransportationAndLogistics = 'TRANSPORTATION_AND_LOGISTICS',
  UtilitiesAndEnergy = 'UTILITIES_AND_ENERGY'
}

export type InitiateMarketplaceOnboardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type InitiateMarketplaceOnboardingMutationPayload = {
  __typename: 'InitiateMarketplaceOnboardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  onboardingAction: OnboardingActionNode;
};

export type InitiateVendorFacilityInviteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqFacilityId: Scalars['ID']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneNumber: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type InitiateVendorFacilityInviteMutationPayload = {
  __typename: 'InitiateVendorFacilityInviteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  inviteId: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum InquiryType {
  Invoice = 'INVOICE',
  PartUpdates = 'PART_UPDATES',
  Quote = 'QUOTE'
}

export type InternalAppointmentNode = Node & {
  __typename: 'InternalAppointmentNode';
  closedAt: Maybe<Scalars['DateTime']['output']>;
  closedBy: Maybe<UserNode>;
  date: Scalars['Date']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalRequest: InternalRequestNode;
  outcome: Maybe<InternalAppointmentOutcome>;
};

export type InternalAppointmentNodeConnection = {
  __typename: 'InternalAppointmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InternalAppointmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InternalAppointmentNode` and its cursor. */
export type InternalAppointmentNodeEdge = {
  __typename: 'InternalAppointmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InternalAppointmentNode>;
};

/** An enumeration. */
export enum InternalAppointmentOutcome {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  Rescheduled = 'RESCHEDULED',
  SentToVendor = 'SENT_TO_VENDOR'
}

export type InternalRequestCompletionNode = Node & {
  __typename: 'InternalRequestCompletionNode';
  additionalNotes: Maybe<Scalars['String']['output']>;
  /** The date the user indicated that the work was completed on */
  completionDate: Maybe<Scalars['Date']['output']>;
  cost: Maybe<Scalars['Decimal']['output']>;
  /** The duration of the completion in seconds. */
  duration: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  incompleteTaskNotes: Maybe<Scalars['String']['output']>;
  photos: Array<InternalRequestCompletionPhotoNode>;
};

export type InternalRequestCompletionPhotoNode = Node & {
  __typename: 'InternalRequestCompletionPhotoNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  photo: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type InternalRequestCompletionPhotoNodeUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum InternalRequestHoldReason {
  AdditionalVisitRequired = 'ADDITIONAL_VISIT_REQUIRED',
  AwaitingParts = 'AWAITING_PARTS',
  Other = 'OTHER'
}

export type InternalRequestNode = Node & {
  __typename: 'InternalRequestNode';
  appointments: Maybe<Array<InternalAppointmentNode>>;
  assignments: Array<WorkOrderTeamMemberAssignmentNode>;
  closedAt: Maybe<Scalars['DateTime']['output']>;
  closedBy: Maybe<UserNode>;
  completion: Maybe<InternalRequestCompletionNode>;
  currentAppointment: Maybe<InternalAppointmentNode>;
  deletedPreventativeMaintenanceTitle: Maybe<Scalars['String']['output']>;
  holdComments: Maybe<Scalars['String']['output']>;
  holdReason: Maybe<InternalRequestHoldReason>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<InternalRequestOutcome>;
  permissions: InternalRequestPermissions;
  preventativeMaintenance: Maybe<PreventativeMaintenanceNode>;
  taskListAttachments: Array<AttachmentNode>;
  taskListUrls: Array<AttachedUrlNode>;
  tasks: Array<WorkOrderTaskListItemNode>;
  workOrder: WorkOrderNode;
};

export type InternalRequestNodeConnection = {
  __typename: 'InternalRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InternalRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InternalRequestNode` and its cursor. */
export type InternalRequestNodeEdge = {
  __typename: 'InternalRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InternalRequestNode>;
};

/** An enumeration. */
export enum InternalRequestOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  SentToVendor = 'SENT_TO_VENDOR'
}

export type InternalRequestPermissions = {
  __typename: 'InternalRequestPermissions';
  /** Permissions to cancel internal request */
  cancel: Scalars['Boolean']['output'];
  /** Permissions to complete internal request */
  complete: Scalars['Boolean']['output'];
  /** Permissions to mark internal request as unresolved */
  markAsUnresolved: Scalars['Boolean']['output'];
  /** Permissions to reassign internal request to other team members */
  reassign: Scalars['Boolean']['output'];
  /** Permissions to submit internal request to a vendor */
  submitToVendor: Scalars['Boolean']['output'];
};

export enum InviteCanActions {
  Cancel = 'CANCEL'
}

/** Input for a single invite in bulk operations. */
export type InviteInput = {
  assignedFacilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedRoleIds: Array<Scalars['ID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InviteMemberToClientOrganizationMutation = {
  __typename: 'InviteMemberToClientOrganizationMutation';
  invite: InviteNode;
};

export type InviteMemberToVendorArguments = {
  assignedRoleIds: Array<Scalars['ID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type InviteMemberToVendorMutation = {
  __typename: 'InviteMemberToVendorMutation';
  ok: Scalars['Boolean']['output'];
};

export type InviteNode = Node & {
  __typename: 'InviteNode';
  acceptedAt: Maybe<Scalars['String']['output']>;
  assignedFacilities: Array<FacilityNode>;
  assignedFacilityGroups: Array<FacilityGroupNode>;
  assignedRoles: Array<RoleNode>;
  can: Scalars['Boolean']['output'];
  clientOrganization: ClientOrganizationNode;
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  expiresAt: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasOnboardingAction: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  lastSentAt: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  status: Maybe<InviteStatus>;
  subscribedUsers: Maybe<Array<Maybe<UserNode>>>;
  vendorOrganization: VendorOrganizationNode;
};


export type InviteNodeCanArgs = {
  perform: InviteCanActions;
};

export type InviteNodeConnection = {
  __typename: 'InviteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InviteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InviteNode` and its cursor. */
export type InviteNodeEdge = {
  __typename: 'InviteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InviteNode>;
};

export type InviteOwnerToOnboardingMutation = {
  __typename: 'InviteOwnerToOnboardingMutation';
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum InviteType {
  ClientSelfServeOnboarding = 'CLIENT_SELF_SERVE_ONBOARDING',
  Iyof = 'IYOF',
  Iyov = 'IYOV',
  User = 'USER'
}

export type InvoiceApprovalProgress = {
  __typename: 'InvoiceApprovalProgress';
  approvedCount: Scalars['Int']['output'];
  requiredCount: Scalars['Int']['output'];
};

export type InvoiceApprovalSettings = {
  __typename: 'InvoiceApprovalSettings';
  approvalRoles: Array<RoleNode>;
  firstApprovalRoles: Array<RoleNode>;
  secondApprovalRoles: Array<RoleNode>;
  strategy: InvoiceApprovalStrategy;
};

/** An enumeration. */
export enum InvoiceApprovalStrategy {
  Auto = 'AUTO',
  Double = 'DOUBLE',
  Single = 'SINGLE'
}

export type InvoiceBatchChargeNode = Node & {
  __typename: 'InvoiceBatchChargeNode';
  client: Maybe<ClientOrganizationNode>;
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoicePayments: Array<InvoicePaymentNode>;
  paymentMethod: Maybe<PaymentMethodNode>;
  pdfUrl: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  retriedAt: Maybe<Scalars['DateTime']['output']>;
  status: InvoiceBatchChargeStatus;
  total: Scalars['Decimal']['output'];
};

export type InvoiceBatchChargeNodeConnection = {
  __typename: 'InvoiceBatchChargeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceBatchChargeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceBatchChargeNode` and its cursor. */
export type InvoiceBatchChargeNodeEdge = {
  __typename: 'InvoiceBatchChargeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InvoiceBatchChargeNode>;
};

/** An enumeration. */
export enum InvoiceBatchChargeStatus {
  Failure = 'FAILURE',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

/**
 * Enum representing invoice categories.
 * Maps to InvoiceCategory choices from core.billing.constants.invoice_category.
 */
export enum InvoiceCategoryEnum {
  ClientOffPlatform = 'CLIENT_OFF_PLATFORM',
  ClientSubscription = 'CLIENT_SUBSCRIPTION',
  ClientTradesCustomer = 'CLIENT_TRADES_CUSTOMER',
  ClientWorkOrder = 'CLIENT_WORK_ORDER',
  VendorOffPlatform = 'VENDOR_OFF_PLATFORM',
  VendorSubscription = 'VENDOR_SUBSCRIPTION',
  VendorTradesCustomer = 'VENDOR_TRADES_CUSTOMER',
  VendorWorkOrder = 'VENDOR_WORK_ORDER'
}

/** Type for InvoiceEmailRecord, which tracks email attachments that may contain invoices and their processing status. */
export type InvoiceEmailRecordNode = Node & {
  __typename: 'InvoiceEmailRecordNode';
  attachment: Maybe<InboundEmailAttachmentNode>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundEmail: Maybe<InboundEmailNode>;
  offResqInvoice: Scalars['Boolean']['output'];
  reason: Maybe<InvoiceEmailRecordReason>;
  status: InvoiceEmailRecordStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceEmailRecordNodeConnection = {
  __typename: 'InvoiceEmailRecordNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceEmailRecordNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceEmailRecordNode` and its cursor. */
export type InvoiceEmailRecordNodeEdge = {
  __typename: 'InvoiceEmailRecordNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InvoiceEmailRecordNode>;
};

/** An enumeration. */
export enum InvoiceEmailRecordReason {
  /** AI error */
  AiError = 'AI_ERROR',
  /** Direct vendor payment */
  DirectVendorPayment = 'DIRECT_VENDOR_PAYMENT',
  /** Invalid attachment */
  InvalidAttachment = 'INVALID_ATTACHMENT',
  /** Lookup failed */
  LookupFailed = 'LOOKUP_FAILED',
  /** No work order codes */
  NoCodes = 'NO_CODES',
  /** Too many work order codes */
  TooMany = 'TOO_MANY'
}

/** An enumeration. */
export enum InvoiceEmailRecordStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Manually Processed */
  Manual = 'MANUAL',
  /** Pending */
  Pending = 'PENDING',
  /** Processed */
  Processed = 'PROCESSED'
}

/** An enumeration. */
export enum InvoiceExtractionProvider {
  Claude = 'CLAUDE',
  Gemini = 'GEMINI',
  Openai = 'OPENAI'
}

export type InvoiceLevelFeeNode = Node & {
  __typename: 'InvoiceLevelFeeNode';
  fee: Maybe<ValueUnion>;
  feeType: RecordOfWorkLineItemEnum;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type InvoiceLevelFeesNode = Node & {
  __typename: 'InvoiceLevelFeesNode';
  fees: Maybe<Array<InvoiceLevelFeeNode>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type InvoicePaymentNode = {
  __typename: 'InvoicePaymentNode';
  invoice: ClientInvoiceNode;
  paymentAmount: Scalars['Decimal']['output'];
};

export type InvoicePaymentPreview = {
  __typename: 'InvoicePaymentPreview';
  achPreviews: Maybe<Array<PreAuthorizedDebitPreview>>;
  creditCardPreviews: Maybe<Array<CreditCardPaymentPreview>>;
  eftPreviews: Maybe<Array<PreAuthorizedDebitPreview>>;
  invoiceCount: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
  workOrderCount: Scalars['Int']['output'];
};

export type InvoiceSetDisputeNode = Node & {
  __typename: 'InvoiceSetDisputeNode';
  client: ClientOrganizationNode;
  clientInvoices: Array<ClientInvoiceNode>;
  createdAt: Scalars['DateTime']['output'];
  disputedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSet: InvoiceSetNode;
  reason: Scalars['String']['output'];
  reasonEnum: InvoiceSetDisputeReason;
  replacedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Maybe<UserNode>;
  vendor: VendorOrganizationNode;
  vendorInvoices: Array<VendorInvoiceNode>;
  workOrder: Maybe<WorkOrderNode>;
};

export type InvoiceSetDisputeNodeConnection = {
  __typename: 'InvoiceSetDisputeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceSetDisputeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceSetDisputeNode` and its cursor. */
export type InvoiceSetDisputeNodeEdge = {
  __typename: 'InvoiceSetDisputeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InvoiceSetDisputeNode>;
};

/** An enumeration. */
export enum InvoiceSetDisputeReason {
  InvoiceIsIncorrect = 'INVOICE_IS_INCORRECT',
  IssueNotFixed = 'ISSUE_NOT_FIXED',
  Other = 'OTHER'
}

/** An enumeration. */
export enum InvoiceSetDisputeResolvedMethod {
  ClientSatisfied = 'CLIENT_SATISFIED',
  ExternalResolution = 'EXTERNAL_RESOLUTION',
  VendorScheduledAnotherVisit = 'VENDOR_SCHEDULED_ANOTHER_VISIT'
}

export type InvoiceSetNode = Node & {
  __typename: 'InvoiceSetNode';
  client: Maybe<ClientOrganizationNode>;
  clientInvoiceDueAtDate: Maybe<Scalars['Date']['output']>;
  clientInvoiceStatus: InvoiceSetStatus;
  clientInvoices: Array<ClientInvoiceNode>;
  clientInvoicesTotal: Maybe<Scalars['Decimal']['output']>;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  disputes: Array<InvoiceSetDisputeNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundVendorInvoices: Array<InboundVendorInvoiceNode>;
  location: Maybe<CombinedFacilityNode>;
  notes: Maybe<Array<InvoiceSetNoteNode>>;
  offResqCustomer: Maybe<OffResqCustomerNode>;
  offResqFacility: Maybe<OffResqFacilityNode>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  payoutOffer: Maybe<PayoutOfferNode>;
  recordOfWorks: Array<RecordOfWorkNode>;
  unresolvedDisputes: Array<InvoiceSetDisputeNode>;
  vendor: VendorOrganizationNode;
  vendorInvoices: Array<VendorInvoiceNode>;
  workOrder: Maybe<WorkOrderNode>;
};

export type InvoiceSetNodeConnection = {
  __typename: 'InvoiceSetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceSetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceSetNode` and its cursor. */
export type InvoiceSetNodeEdge = {
  __typename: 'InvoiceSetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InvoiceSetNode>;
};

export type InvoiceSetNoteNode = Node & {
  __typename: 'InvoiceSetNoteNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSetId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  permissions: InvoiceSetNotePermissions;
};

export type InvoiceSetNoteNodeConnection = {
  __typename: 'InvoiceSetNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceSetNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceSetNoteNode` and its cursor. */
export type InvoiceSetNoteNodeEdge = {
  __typename: 'InvoiceSetNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<InvoiceSetNoteNode>;
};

export type InvoiceSetNotePermissions = {
  __typename: 'InvoiceSetNotePermissions';
  /** Permission to delete an internal invoice set note */
  deleteNote: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum InvoiceSetStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PaymentInitiated = 'PAYMENT_INITIATED',
  Unpaid = 'UNPAID'
}

/** Types of invoice strategies available for work orders. */
export enum InvoiceStrategyType {
  DirectVendorPayment = 'DIRECT_VENDOR_PAYMENT',
  ResqPayment = 'RESQ_PAYMENT'
}

export enum InvoiceTypeEnum {
  LateFee = 'LATE_FEE',
  Service = 'SERVICE'
}

export type InvoiceValidationNode = Node & {
  __typename: 'InvoiceValidationNode';
  flaggingRulesBroken: Array<RuleBroken>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  ranFlaggingRules: Scalars['Boolean']['output'];
  validationMessages: Array<Scalars['String']['output']>;
  validationResults: Array<InvoiceValidationResult>;
};

export type InvoiceValidationResult = {
  __typename: 'InvoiceValidationResult';
  validationAction: Maybe<ValidationRuleResultAction>;
  validationMessage: Scalars['String']['output'];
};

/** An enumeration. */
export enum InvoicingVersion {
  Markup = 'MARKUP',
  RevenueShare = 'REVENUE_SHARE'
}

export type IssuedProductNode = Node & {
  __typename: 'IssuedProductNode';
  externalBusinessId: Scalars['String']['output'];
  externalIssuedProductId: Scalars['String']['output'];
  externalProvider: LenderProviderKey;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lendingOffer: Maybe<LendingOfferNode>;
  metadata: Maybe<Scalars['JSONString']['output']>;
  organization: Maybe<LendingOfferOrgNode>;
  paymentMethodId: Maybe<Scalars['ID']['output']>;
  pricingPlans: Array<PricingPlanNode>;
  productType: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type IssuedProductNodeConnection = {
  __typename: 'IssuedProductNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IssuedProductNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `IssuedProductNode` and its cursor. */
export type IssuedProductNodeEdge = {
  __typename: 'IssuedProductNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<IssuedProductNode>;
};

export type JobsPerServiceCategory = {
  __typename: 'JobsPerServiceCategory';
  count: Scalars['Int']['output'];
  month: Scalars['DateTime']['output'];
  serviceCategory: ServiceCategory;
};

export type JobsPerType = {
  __typename: 'JobsPerType';
  maintenancePlanJobsCount: Scalars['Int']['output'];
  onDemandJobsCount: Scalars['Int']['output'];
};

export type KustomerWorkOrderEscalationNode = Node & {
  __typename: 'KustomerWorkOrderEscalationNode';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  kustomerConversationId: Scalars['String']['output'];
  kustomerUrl: Maybe<Scalars['String']['output']>;
  ticketNumber: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum Language {
  English = 'ENGLISH',
  French = 'FRENCH',
  Russian = 'RUSSIAN',
  Spanish = 'SPANISH',
  Ukrainian = 'UKRAINIAN'
}

export type LanguageType = {
  __typename: 'LanguageType';
  key: Language;
  label: Scalars['String']['output'];
};

export type LaunchGoogleAdsSetupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
  websiteAdvertisingCampaignId: Scalars['ID']['input'];
};

/** Validate launch prerequisites and enqueue the setup orchestrator. */
export type LaunchGoogleAdsSetupPayload = {
  __typename: 'LaunchGoogleAdsSetupPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  flowKey: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type LeadInboundRequestConversionDataType = {
  __typename: 'LeadInboundRequestConversionDataType';
  extractionSet: Maybe<ExtractionSetNode>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type LeadInboundRequestConversionInfoType = {
  __typename: 'LeadInboundRequestConversionInfoType';
  offResqCustomerId: Maybe<Scalars['ID']['output']>;
  offResqCustomerName: Maybe<Scalars['String']['output']>;
  offResqFacilityId: Maybe<Scalars['ID']['output']>;
  offResqFacilityName: Maybe<Scalars['String']['output']>;
  proposalCode: Maybe<Scalars['String']['output']>;
  proposalCreatedAt: Maybe<Scalars['DateTime']['output']>;
  proposalId: Maybe<Scalars['ID']['output']>;
  workOrderCode: Maybe<Scalars['String']['output']>;
  workOrderCreatedAt: Maybe<Scalars['DateTime']['output']>;
  workOrderId: Maybe<Scalars['ID']['output']>;
};

export type LeadInboundRequestInternalNoteNode = Node & {
  __typename: 'LeadInboundRequestInternalNoteNode';
  /** Internal note content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadInboundRequestMatchInfoType = {
  __typename: 'LeadInboundRequestMatchInfoType';
  confidence: Scalars['Float']['output'];
  matchType: Scalars['String']['output'];
  matchedCombinedCustomerId: Maybe<Scalars['ID']['output']>;
  matchedCombinedFacilityId: Maybe<Scalars['ID']['output']>;
  matchedCustomerCode: Maybe<Scalars['String']['output']>;
  matchedCustomerName: Maybe<Scalars['String']['output']>;
  matchedFacilityName: Maybe<Scalars['String']['output']>;
};

export type LeadInboundRequestNode = Node & {
  __typename: 'LeadInboundRequestNode';
  actionedAt: Maybe<Scalars['DateTime']['output']>;
  actionedBy: Maybe<UserNode>;
  /** Agent runtime call identifier for phone inbound requests */
  callId: Maybe<Scalars['String']['output']>;
  /** Twilio Call SID for phone inbound requests */
  callSid: Maybe<Scalars['String']['output']>;
  /** Phone-call lifecycle status for phone inbound requests */
  callStatus: Maybe<Scalars['String']['output']>;
  contactName: Maybe<Scalars['String']['output']>;
  /** Provider conversation or thread identifier */
  conversationId: Maybe<Scalars['String']['output']>;
  conversionInfo: Maybe<LeadInboundRequestConversionInfoType>;
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  extractionSets: Array<ExtractionSetNode>;
  /** Source email address for email inbound requests */
  fromEmail: Maybe<Scalars['String']['output']>;
  /** Source phone number for phone or SMS inbound requests */
  fromPhone: Maybe<Scalars['String']['output']>;
  hasExtractionSet: Scalars['Boolean']['output'];
  hasProposalDraft: Scalars['Boolean']['output'];
  /** Whether the inbound payload contains transcript content */
  hasTranscript: Scalars['Boolean']['output'];
  hasWorkOrderDraft: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  intent: Scalars['String']['output'];
  internalNotes: Array<LeadInboundRequestInternalNoteNode>;
  /** Whether the inbound request has been opened in the vendor dashboard */
  isRead: Scalars['Boolean']['output'];
  latestExtractionStatus: Maybe<Scalars['String']['output']>;
  lead: LeadNode;
  matchInfo: Maybe<LeadInboundRequestMatchInfoType>;
  message: Maybe<Scalars['String']['output']>;
  /** Completed call status recorded for the Nora greeting experiment */
  noraGreetingCallStatus: Maybe<Scalars['String']['output']>;
  /** Whether the call appears to have hung up before meaningful conversation */
  noraGreetingDirectHangup: Maybe<Scalars['Boolean']['output']>;
  /** Completed call duration in seconds for the Nora greeting experiment */
  noraGreetingDurationSecs: Maybe<Scalars['Float']['output']>;
  /** Provider or agent end reason recorded for the Nora greeting experiment */
  noraGreetingEndedReason: Maybe<Scalars['String']['output']>;
  /** Nora greeting experiment assigned to this phone inbound request */
  noraGreetingExperimentKey: Scalars['String']['output'];
  /** Exact Nora greeting phrase assigned to this phone inbound request */
  noraGreetingPhrase: Scalars['String']['output'];
  /** Nora greeting variant assigned to this phone inbound request */
  noraGreetingVariantKey: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  /** Short text preview for list and search surfaces */
  previewText: Scalars['String']['output'];
  rawJson: Maybe<Scalars['JSONString']['output']>;
  scoringInfo: LeadInboundRequestScoringInfoType;
  smsDetails: Maybe<LeadInboundRequestSmsDetailsType>;
  /** Timestamp when the source provider received this inbound request */
  sourceReceivedAt: Maybe<Scalars['DateTime']['output']>;
  /** Source of the inbound request (EMAIL, SMS, WEB, PHONE) */
  src: LeadInboundRequestSrc;
  status: Scalars['String']['output'];
  subject: Maybe<Scalars['String']['output']>;
  /** Destination email addresses for email inbound requests */
  toEmails: Scalars['JSONString']['output'];
  /** Destination phone number for phone or SMS inbound requests */
  toPhone: Maybe<Scalars['String']['output']>;
  transcripts: Array<LeadInboundRequestTranscriptNode>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
};

export type LeadInboundRequestNodeConnection = {
  __typename: 'LeadInboundRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LeadInboundRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeadInboundRequestNode` and its cursor. */
export type LeadInboundRequestNodeEdge = {
  __typename: 'LeadInboundRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<LeadInboundRequestNode>;
};

export type LeadInboundRequestScoringInfoType = {
  __typename: 'LeadInboundRequestScoringInfoType';
  leadQuality: Scalars['String']['output'];
  leadScore: Maybe<Scalars['Int']['output']>;
  propertyType: Scalars['String']['output'];
  scoreReasons: Array<Scalars['String']['output']>;
  scoredAt: Maybe<Scalars['DateTime']['output']>;
  scoringVersion: Scalars['String']['output'];
};

export type LeadInboundRequestSmsDetailsType = {
  __typename: 'LeadInboundRequestSmsDetailsType';
  fromPhone: Maybe<Scalars['String']['output']>;
  toPhone: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum LeadInboundRequestSrc {
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE',
  /** ResQ */
  Resq = 'RESQ',
  /** SMS */
  Sms = 'SMS',
  /** Web */
  Web = 'WEB'
}

/** An enumeration. */
export enum LeadInboundRequestStatus {
  /** Actioned */
  Actioned = 'ACTIONED',
  /** New */
  New = 'NEW',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum LeadInboundRequestTranscriptChannel {
  /** Email */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE',
  /** SMS */
  Sms = 'SMS'
}

export type LeadInboundRequestTranscriptNode = Node & {
  __typename: 'LeadInboundRequestTranscriptNode';
  /** Inbound channel for this transcript row */
  channel: LeadInboundRequestTranscriptChannel;
  createdAt: Scalars['DateTime']['output'];
  /** Provider message identifier for idempotent upsert */
  externalMessageId: Maybe<Scalars['String']['output']>;
  /** Provider utterance identifier when available */
  externalUtteranceId: Maybe<Scalars['String']['output']>;
  /** Sender address or phone number */
  fromAddress: Scalars['String']['output'];
  /** HTML email body content when available */
  htmlContent: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Provider timestamp for this transcript row */
  occurredAt: Maybe<Scalars['DateTime']['output']>;
  /** Speaker role for this transcript row */
  role: LeadInboundRequestTranscriptRole;
  /** Display order within the inbound request */
  sequence: Scalars['Int']['output'];
  /** Provider-specific metadata for this transcript row */
  sourceMetadata: Scalars['JSONString']['output'];
  /** Email subject when this transcript row is an email message */
  subject: Scalars['String']['output'];
  /** Plain text transcript or email body content */
  textContent: Scalars['String']['output'];
  /** Recipient addresses or phone numbers */
  toAddresses: Scalars['JSONString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LeadInboundRequestTranscriptRole {
  /** Assistant */
  Assistant = 'ASSISTANT',
  /** System */
  System = 'SYSTEM',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** User */
  User = 'USER'
}

export type LeadNode = Node & {
  __typename: 'LeadNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundRequests: Array<LeadInboundRequestNode>;
  /** Current status of the lead */
  status: LeadStatus;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
};

export type LeadNodeConnection = {
  __typename: 'LeadNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LeadNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeadNode` and its cursor. */
export type LeadNodeEdge = {
  __typename: 'LeadNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<LeadNode>;
};

/** An enumeration. */
export enum LeadStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Converted */
  Converted = 'CONVERTED',
  /** Done */
  Done = 'DONE',
  /** Lost */
  Lost = 'LOST',
  /** Open */
  Open = 'OPEN'
}

/** An enumeration. */
export enum LenderProviderKey {
  Kanmon = 'KANMON'
}

export type LendingOfferNode = Node & {
  __typename: 'LendingOfferNode';
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  externalOfferId: Scalars['String']['output'];
  externalProvider: LenderProviderKey;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  offer: Maybe<OfferNode>;
  organization: Maybe<LendingOfferOrgNode>;
  status: LendingOfferStatus;
};

export type LendingOfferNodeConnection = {
  __typename: 'LendingOfferNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LendingOfferNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LendingOfferNode` and its cursor. */
export type LendingOfferNodeEdge = {
  __typename: 'LendingOfferNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<LendingOfferNode>;
};

export type LendingOfferOrgNode = ClientOrganizationNode | VendorOrganizationNode;

/** An enumeration. */
export enum LendingOfferStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

/** An enumeration. */
export enum LendingOnboardingBannerStateEnum {
  Denied = 'DENIED',
  None = 'NONE',
  OfferAcceptedUnused = 'OFFER_ACCEPTED_UNUSED',
  OfferAvailable = 'OFFER_AVAILABLE',
  OfferExpired = 'OFFER_EXPIRED',
  Registered = 'REGISTERED'
}

export type LendingOnboardingNode = Node & {
  __typename: 'LendingOnboardingNode';
  createdAt: Scalars['DateTime']['output'];
  decisionedAt: Maybe<Scalars['DateTime']['output']>;
  deniedBannerShownAt: Maybe<Scalars['DateTime']['output']>;
  externalProvider: LenderProviderKey;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  shouldShow: Scalars['Boolean']['output'];
  state: LendingOnboardingBannerStateEnum;
  status: LendingOnboardingStatus;
  statusReason: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LendingOnboardingNodeConnection = {
  __typename: 'LendingOnboardingNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LendingOnboardingNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LendingOnboardingNode` and its cursor. */
export type LendingOnboardingNodeEdge = {
  __typename: 'LendingOnboardingNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<LendingOnboardingNode>;
};

/** An enumeration. */
export enum LendingOnboardingStatus {
  /** Denied */
  Denied = 'DENIED',
  /** None */
  None = 'NONE',
  /** Offer accepted unused */
  OfferAcceptedUnused = 'OFFER_ACCEPTED_UNUSED',
  /** Offer available */
  OfferAvailable = 'OFFER_AVAILABLE',
  /** Offer expired */
  OfferExpired = 'OFFER_EXPIRED',
  /** Registered */
  Registered = 'REGISTERED'
}

/** An enumeration. */
export enum LendingOnboardingStatusEnum {
  Denied = 'DENIED',
  None = 'NONE',
  OfferAcceptedUnused = 'OFFER_ACCEPTED_UNUSED',
  OfferAvailable = 'OFFER_AVAILABLE',
  OfferExpired = 'OFFER_EXPIRED',
  Registered = 'REGISTERED'
}

export type LineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount: Scalars['Decimal']['input'];
  itemType: RecordOfWorkLineItemEnum;
  markup?: InputMaybe<Scalars['Decimal']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
  partManufacturer?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['input'];
  rate?: InputMaybe<Scalars['Decimal']['input']>;
  ratePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  revShare?: InputMaybe<Scalars['Decimal']['input']>;
  taxRateIds: Array<Scalars['ID']['input']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warranty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationAddressResolutionNode = Node & {
  __typename: 'LocationAddressResolutionNode';
  address: Maybe<Scalars['String']['output']>;
  addressesMatch: Scalars['Boolean']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isOverridden: Scalars['Boolean']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  province: Maybe<Scalars['String']['output']>;
  resolvedSuccessfully: Scalars['Boolean']['output'];
  validationMessages: Array<Scalars['String']['output']>;
};

export type LocationAddressResolutionNodeConnection = {
  __typename: 'LocationAddressResolutionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationAddressResolutionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LocationAddressResolutionNode` and its cursor. */
export type LocationAddressResolutionNodeEdge = {
  __typename: 'LocationAddressResolutionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<LocationAddressResolutionNode>;
};

export enum MaintenancePlanFrequencyUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** An enumeration. */
export enum MaintenancePlanInitialWorkOrderStatus {
  AwaitingRecordOfWork = 'AWAITING_RECORD_OF_WORK',
  AwaitingResqApproval = 'AWAITING_RESQ_APPROVAL',
  AwaitingScheduling = 'AWAITING_SCHEDULING'
}

export type MaintenancePlanNode = Node & {
  __typename: 'MaintenancePlanNode';
  activeSubcontractConfig: Maybe<MaintenancePlanSubcontractConfigType>;
  attachments: Array<AttachmentNode>;
  autoRenew: Scalars['Boolean']['output'];
  autoRenewEligible: Scalars['Boolean']['output'];
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int']['output'];
  canDirectlyChangeDate: Scalars['Boolean']['output'];
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  cancelledReason: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contractEndDate: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  currency: Currency;
  currentWorkOrder: Maybe<WorkOrderNode>;
  facilities: Array<FacilityNode>;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String']['output'];
  maintenancePlanType: MaintenancePlanTypeNode;
  /** Specifies the name of the MP, historical data backfilled with name of associated MP type */
  name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use next_work_order_creation_date instead. Removed in RESQ-1647. */
  nextExpectedServiceDate: Scalars['DateTime']['output'];
  nextWorkOrderCreationDate: Scalars['Date']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  opsOwner: Maybe<UserNode>;
  organization: Maybe<ClientOrganizationNode>;
  pdfFile: Maybe<FileType>;
  price: Scalars['Decimal']['output'];
  priceAfterMarkup: Scalars['Decimal']['output'];
  priceBeforeMarkup: Scalars['Decimal']['output'];
  recordOfWorkTemplate: Maybe<RecordOfWorkTemplateNode>;
  scopeOfWork: Scalars['String']['output'];
  selfService: Scalars['Boolean']['output'];
  serviceFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue: Maybe<Scalars['Int']['output']>;
  source: MaintenancePlanSource;
  status: MaintenancePlanStatus;
  /** @deprecated Unused. Please refer to RESQ-1943 */
  taxRate: Scalars['Decimal']['output'];
  variablePricing: Scalars['Boolean']['output'];
  vendor: VendorOrganizationNode;
  vendorRecommendation: Maybe<VendorPreventiveMaintenanceRecommendationNode>;
  workOrders: Array<WorkOrderNode>;
};

export type MaintenancePlanNodeConnection = {
  __typename: 'MaintenancePlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaintenancePlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MaintenancePlanNode` and its cursor. */
export type MaintenancePlanNodeEdge = {
  __typename: 'MaintenancePlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MaintenancePlanNode>;
};

export enum MaintenancePlanSource {
  Internal = 'INTERNAL',
  Vendor = 'VENDOR'
}

export enum MaintenancePlanStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type MaintenancePlanSubcontractConfigType = {
  __typename: 'MaintenancePlanSubcontractConfigType';
  createdAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedReason: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  parentVendor: VendorOrganizationNode;
  subcontractVendor: VendorOrganizationNode;
};

export type MaintenancePlanTypeNode = Node & {
  __typename: 'MaintenancePlanTypeNode';
  defaultBillingFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  defaultBillingFrequencyValue: Maybe<Scalars['Int']['output']>;
  defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  defaultServiceFrequencyUnit: Maybe<MaintenancePlanFrequencyUnit>;
  defaultServiceFrequencyValue: Maybe<Scalars['Int']['output']>;
  defaultVariablePricing: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  eligibleFacilities: Array<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  image: ImageType;
  maintenancePlans: Array<MaintenancePlanNode>;
  name: Scalars['String']['output'];
  serviceCategory: ServiceCategory;
  /** @deprecated Replaced with service category */
  subcategory: TradeNode;
};


export type MaintenancePlanTypeNodeEligibleFacilitiesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MaintenancePlanTypeNodeMaintenancePlansArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MaintenancePlanTypeNodeConnection = {
  __typename: 'MaintenancePlanTypeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaintenancePlanTypeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MaintenancePlanTypeNode` and its cursor. */
export type MaintenancePlanTypeNodeEdge = {
  __typename: 'MaintenancePlanTypeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MaintenancePlanTypeNode>;
};

export type ManageOffResqNotificationSettingsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disableFacilityUserNotifications: Scalars['Boolean']['input'];
  scopedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  scopedFacilityId?: InputMaybe<Scalars['ID']['input']>;
  scopedWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

/**
 * Manage notification settings for off-resq work orders.
 *
 * Allows vendors to control facility user notifications at different levels:
 * - Vendor-level (global): Don't provide any scope IDs
 * - Customer-level: Provide only scopedCustomerId
 * - Facility-level: Provide only scopedFacilityId
 * - Work order-level: Provide only scopedWorkOrderId
 */
export type ManageOffResqNotificationSettingsMutationPayload = {
  __typename: 'ManageOffResqNotificationSettingsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  notificationSetting: Maybe<OffResqNotificationSettingsNode>;
};

export type MarkApBatchesAsPaidMutationInput = {
  apBatchIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceDate: Scalars['Date']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type MarkApBatchesAsPaidMutationPayload = {
  __typename: 'MarkAPBatchesAsPaidMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MarkApBatchesAsUnpaidMutationInput = {
  apBatchIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkApBatchesAsUnpaidMutationPayload = {
  __typename: 'MarkAPBatchesAsUnpaidMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MarkBankAccountRecordProcessedMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the bank account record to mark as processed */
  id: Scalars['ID']['input'];
};

export type MarkBankAccountRecordProcessedMutationPayload = {
  __typename: 'MarkBankAccountRecordProcessedMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type MarkClientManagedInvoicesAsPaidInput = {
  clientManagedInvoiceIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkClientManagedInvoicesAsPaidPayload = {
  __typename: 'MarkClientManagedInvoicesAsPaidPayload';
  clientManagedInvoices: Array<ClientManagedInvoiceNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type MarkClientManagedInvoicesAsUnpaidInput = {
  clientManagedInvoiceIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkClientManagedInvoicesAsUnpaidPayload = {
  __typename: 'MarkClientManagedInvoicesAsUnpaidPayload';
  clientManagedInvoices: Array<ClientManagedInvoiceNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type MarkInboxItemReadMutation = {
  __typename: 'MarkInboxItemReadMutation';
  inboxItem: InboxItemNode;
};

export type MarkInvoiceEmailRecordProcessedMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MarkInvoiceEmailRecordProcessedMutationPayload = {
  __typename: 'MarkInvoiceEmailRecordProcessedMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MarkLeadInboundRequestDoneMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
};

export type MarkLeadInboundRequestDoneMutationPayload = {
  __typename: 'MarkLeadInboundRequestDoneMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type MarkLeadInboundRequestReadMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
};

export type MarkLeadInboundRequestReadMutationPayload = {
  __typename: 'MarkLeadInboundRequestReadMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type MarkLendingOnboardingBannerShownMutationInput = {
  bannerState: LendingOnboardingStatusEnum;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MarkLendingOnboardingBannerShownMutationPayload = {
  __typename: 'MarkLendingOnboardingBannerShownMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  deniedBannerShownAt: Maybe<Scalars['DateTime']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MarkNoraCallEvaluationReviewed = {
  __typename: 'MarkNoraCallEvaluationReviewed';
  noraCallEvaluation: NoraCallEvaluationNode;
};

export type MarkOffResqVendorInvoiceAsPaidMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorInvoiceId: Scalars['ID']['input'];
};

export type MarkOffResqVendorInvoiceAsPaidMutationPayload = {
  __typename: 'MarkOffResqVendorInvoiceAsPaidMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type MarkRecordOfWorkAsAwaitingVendorOnboardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recordOfWorkId: Scalars['ID']['input'];
  total: Scalars['Decimal']['input'];
};

export type MarkRecordOfWorkAsAwaitingVendorOnboardingMutationPayload = {
  __typename: 'MarkRecordOfWorkAsAwaitingVendorOnboardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  recordOfWork: RecordOfWorkNode;
};

export type MarkSubcontractSettlementInvoiceAsPaidExternallyMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPaymentNote?: InputMaybe<Scalars['String']['input']>;
  externalPaymentReference?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Decimal']['input']>;
  paidExternallyAt: Scalars['Date']['input'];
  subcontractSettlementInvoiceId: Scalars['ID']['input'];
};

export type MarkSubcontractSettlementInvoiceAsPaidExternallyMutationPayload = {
  __typename: 'MarkSubcontractSettlementInvoiceAsPaidExternallyMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  subcontractSettlementInvoice: SubcontractSettlementInvoiceNode;
};

export type MarkSubcontractSettlementInvoiceAsUnpaidMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subcontractSettlementInvoiceId: Scalars['ID']['input'];
};

export type MarkSubcontractSettlementInvoiceAsUnpaidMutationPayload = {
  __typename: 'MarkSubcontractSettlementInvoiceAsUnpaidMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  subcontractSettlementInvoice: SubcontractSettlementInvoiceNode;
};

export type MarkSubcontractSettlementInvoicesAsPaidExternallyMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPaymentNote?: InputMaybe<Scalars['String']['input']>;
  externalPaymentReference?: InputMaybe<Scalars['String']['input']>;
  paidExternallyAt: Scalars['Date']['input'];
  subcontractSettlementInvoiceIds: Array<Scalars['ID']['input']>;
};

export type MarkSubcontractSettlementInvoicesAsPaidExternallyMutationPayload = {
  __typename: 'MarkSubcontractSettlementInvoicesAsPaidExternallyMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  subcontractSettlementInvoices: Array<SubcontractSettlementInvoiceNode>;
};

export type MarkWorkOrderAsAwaitingPaymentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type MarkWorkOrderAsAwaitingPaymentPayload = {
  __typename: 'MarkWorkOrderAsAwaitingPaymentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput = {
  assignmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  photos: Array<Image>;
};

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload = {
  __typename: 'MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload';
  assignment: WorkOrderTeamMemberAssignmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type MarketCategoryPricingInput = {
  labourCost: Scalars['Decimal']['input'];
  serviceCallCost: Scalars['Decimal']['input'];
  serviceCategory: ServiceCategory;
};

export type MarketCategoryPricingNode = Node & {
  __typename: 'MarketCategoryPricingNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourCost: Scalars['Decimal']['output'];
  serviceCallCost: Scalars['Decimal']['output'];
  serviceCategory: ServiceCategory;
};

export type MarketNode = Node & {
  __typename: 'MarketNode';
  acceptingNewTrades: Scalars['Boolean']['output'];
  disabledCategories: Maybe<Array<ServiceCategory>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isCore: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  operatingAreas: Array<OperatingAreaNode>;
  pricing: MarketPricingNode;
};

export type MarketNodeConnection = {
  __typename: 'MarketNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MarketNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketNode` and its cursor. */
export type MarketNodeEdge = {
  __typename: 'MarketNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MarketNode>;
};

export type MarketPricingInput = {
  categoryPricing: Array<MarketCategoryPricingInput>;
  markupPercentage: Scalars['Decimal']['input'];
};

export type MarketPricingNode = Node & {
  __typename: 'MarketPricingNode';
  categoryPricing: Array<MarketCategoryPricingNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  markupPercentage: Scalars['Decimal']['output'];
};

export type MarkupInputLineItemType = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount: Scalars['Decimal']['input'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal']['input'];
  order: Scalars['Int']['input'];
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
  partManufacturer?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['input'];
  rate: Scalars['Decimal']['input'];
  ratePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  taxRateIds: Array<Scalars['ID']['input']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warranty: Scalars['Boolean']['input'];
};

export type MatchBadExperience = {
  __typename: 'MatchBadExperience';
  hasDispute: Scalars['Boolean']['output'];
  hasNegativeReview: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

/** Status of media processing */
export enum MediaProcessingStatus {
  Downloaded = 'DOWNLOADED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum MemberPermission {
  Manage = 'MANAGE',
  Onboard = 'ONBOARD',
  Schedule = 'SCHEDULE'
}

export type MergeApBatchesMutationInput = {
  batchIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueAtDate: Scalars['Date']['input'];
};

export type MergeApBatchesMutationPayload = {
  __typename: 'MergeAPBatchesMutationPayload';
  batch: ApBatchNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum Metrics {
  CompletedJobs = 'COMPLETED_JOBS',
  CustomerSatisfaction = 'CUSTOMER_SATISFACTION',
  FirstTimeFixRate = 'FIRST_TIME_FIX_RATE',
  OverallScore = 'OVERALL_SCORE',
  QualityScore = 'QUALITY_SCORE',
  SpeedScore = 'SPEED_SCORE'
}

export type MetricsPeriod = {
  __typename: 'MetricsPeriod';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type MigrateClientToPerUserPricingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, convert ALL roles to Work Order Submitter. Use with userEmailsToKeep. */
  convertAllRoles?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  /** Role IDs whose members should be converted to Work Order Submitter. */
  roleIdsToConvert?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Feature tier: 'Basic' or 'Pro'. Defaults to 'Basic'. */
  tierName?: InputMaybe<Scalars['String']['input']>;
  /** User emails to exclude from conversion (keep their current roles). */
  userEmailsToKeep?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Migrate a client organization to per-user pricing model.
 *
 * This mutation:
 * 1. Sets the organization's pricing model to per-user subscription
 * 2. Updates the feature tier to Basic or Pro
 * 3. Creates the Work Order Submitter role if it doesn't exist
 * 4. Optionally converts specified role members to Work Order Submitter
 *
 * Authorization: Control center users only.
 */
export type MigrateClientToPerUserPricingMutationPayload = {
  __typename: 'MigrateClientToPerUserPricingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  membersConverted: Scalars['Int']['output'];
  pricingModelUpdated: Scalars['Boolean']['output'];
  submitterRoleCreated: Scalars['Boolean']['output'];
  tierUpdated: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type MiscellaneousHold = Node & {
  __typename: 'MiscellaneousHold';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this hold was cancelled. Operations that can cancel a hold: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  /** The time at which this hold was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']['output']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** The vendor's description as to why the work order was placed on hold. */
  notes: Scalars['String']['output'];
  permissions: MiscellaneousHoldPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type MiscellaneousHoldConnection = {
  __typename: 'MiscellaneousHoldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MiscellaneousHoldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MiscellaneousHold` and its cursor. */
export type MiscellaneousHoldEdge = {
  __typename: 'MiscellaneousHoldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<MiscellaneousHold>;
};

export type MiscellaneousHoldPermissions = {
  __typename: 'MiscellaneousHoldPermissions';
  fulfill: Scalars['Boolean']['output'];
};

export type MoveAllEquipmentToAnotherFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationFacilityId: Scalars['ID']['input'];
  sourceFacilityId: Scalars['ID']['input'];
};

export type MoveAllEquipmentToAnotherFacilityPayload = {
  __typename: 'MoveAllEquipmentToAnotherFacilityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MoveEquipmentToFacilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationFacilityId: Scalars['ID']['input'];
  equipmentIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type MoveEquipmentToFacilityPayload = {
  __typename: 'MoveEquipmentToFacilityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type MoveWorkOrderToAwaitingRecordOfWorkMutation = {
  __typename: 'MoveWorkOrderToAwaitingRecordOfWorkMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

export type Mutations = {
  __typename: 'Mutations';
  acceptClientTos: Maybe<AcceptClientTosMutationPayload>;
  acceptOffResqVendorSubcontract: Maybe<AcceptOffResqVendorSubcontractMutationPayload>;
  acceptOrcTos: Maybe<AcceptOrcTosMutationPayload>;
  acceptPayqVendorTos: Maybe<AcceptPayQVendorTosMutationPayload>;
  acceptRequestForQuote: Maybe<AcceptRequestForQuotePayload>;
  acceptVendorCreatedWorkOrder: Maybe<AcceptVendorCreatedWorkOrderPayload>;
  acceptVendorDispatchRequestWithoutScheduling: Maybe<AcceptVendorDispatchRequestWithoutSchedulingMutationPayload>;
  acceptVendorEquipmentCapabilitySuggestion: Maybe<AcceptVendorEquipmentCapabilitySuggestionMutationPayload>;
  acceptVendorPreventiveMaintenanceRecommendation: Maybe<AcceptVendorPreventiveMaintenanceRecommendationMutationPayload>;
  acknowledgeAdvertisingCommercialHold: Maybe<AcknowledgeAdvertisingCommercialHoldMutationPayload>;
  activateMaintenancePlan: Maybe<ActivateMaintenancePlanMutation>;
  activatePreventativeMaintenance: Maybe<ActivatePreventitiveMaintenanceMutationPayload>;
  activateTradesSubscription: Maybe<ActivateTradesSubscriptionPayload>;
  addAfterImagesToVisit: Maybe<AddAfterImagesToVisitPayload>;
  addAttachment: Maybe<AddAttachmentMutation>;
  addBarcode: Maybe<AddBarcodeMutationPayload>;
  addBeforeImagesToVisit: Maybe<AddBeforeImagesToVisitPayload>;
  addClientOrganization: Maybe<AddClientOrganizationMutation>;
  addEquipment: Maybe<AddEquipmentMutation>;
  addExistingUserToClientOrganization: Maybe<AddExistingUserToClientOrganizationMutation>;
  addExistingUserToVendor: Maybe<AddExistingUserToVendorMutationPayload>;
  addExternalExpense: Maybe<AddExternalExpenseMutationPayload>;
  addGateway: Maybe<AddGatewayPayload>;
  addImageToWorkOrder: Maybe<AddImageToWorkOrderMutation>;
  addNewUserToClientOrganization: Maybe<AddNewUserToClientOrganizationMutation>;
  addNewUserToVendor: Maybe<AddNewUserToVendorMutation>;
  addOwnerToClientOrganization: Maybe<AddOwnerToClientOrganizationMutationPayload>;
  addSensorToEquipment: Maybe<AddSensorToEquipmentPayload>;
  addWorkOrdersToProject: Maybe<AddWorkOrdersToProjectMutationPayload>;
  agreeVendorTos: Maybe<AgreeVendorTosPayload>;
  approveQuoteSetOptionForSpend: Maybe<ApproveQuoteSetOptionForSpendPayload>;
  /** Approves a record of work for invoicing. */
  approveRecordOfWork: Maybe<ApproveRecordOfWorkMutation>;
  approveWorkOrderClientInvoices: Maybe<ApproveWorkOrderClientInvoicesMutation>;
  archiveProject: Maybe<ArchiveProjectMutationPayload>;
  archiveReportTemplate: Maybe<ArchiveReportTemplatePayload>;
  assignUsersToRole: Maybe<AssignUsersToRoleMutationPayload>;
  assignWorkOrderEscalation: Maybe<AssignWorkOrderEscalationPayload>;
  associateUserTags: Maybe<AssociateUserTagsMutationPayload>;
  attachQuoteSetToWorkOrder: Maybe<AttachQuoteSetToWorkOrderPayload>;
  blockAp: Maybe<BlockApMutationPayload>;
  bulkCreateFavouriteVendorConfiguration: Maybe<BulkCreateFavouriteVendorConfigurationPayload>;
  bulkDeleteFavouriteVendorConfigurations: Maybe<BulkDeleteFavouriteVendorConfigurationsPayload>;
  /**
   * Create multiple invites in a single operation.
   *
   * This mutation processes all invites in a single transaction, which:
   * 1. Prevents partial success for bulk invite operations
   * 2. Improves performance by reducing repeated setup/teardown work
   *
   * Atomic behavior:
   * - If any invite fails validation, the entire operation fails and rolls back
   * - All invites succeed or none do
   */
  bulkInviteMembersToClientOrganization: Maybe<BulkInviteMembersToClientOrganizationMutationPayload>;
  bulkRerunNoraCallEvaluations: Maybe<BulkRerunNoraCallEvaluations>;
  cancelInvite: Maybe<CancelInviteMutation>;
  cancelMaintenancePlan: Maybe<CancelMaintenancePlanMutation>;
  cancelSubscription: Maybe<CancelSubscriptionPayload>;
  /** Cancel active/pending subcontract and return execution to the Parent Vendor. */
  cancelVendorSubcontract: Maybe<CancelVendorSubcontractMutationPayload>;
  cancelWorkOrder: Maybe<CancelWorkOrderMutation>;
  captureVisitNotes: Maybe<CaptureVisitNotesPayload>;
  changePassword: Maybe<ChangePasswordMutation>;
  changeTradesPlan: Maybe<ChangeTradePlanPayload>;
  chargePaymentMethod: Maybe<ChargePaymentMethodPayload>;
  chargeSubscriptionInvoices: Maybe<ChargeSubscriptionInvoicesMutationPayload>;
  checkUncheckWorkOrderTask: Maybe<CheckUncheckWorkOrderTaskPayload>;
  closeWorkOrder: Maybe<CloseWorkOrderPayload>;
  completeBillingAndPaymentInfoOnboardingStep: Maybe<CompleteBillingAndPaymentInfoOnboardingStepMutationPayload>;
  completeBillingEntityOnboardingStep: Maybe<CompleteBillingEntityOnboardingStepMutationPayload>;
  completeClientOnboarding: Maybe<CompleteClientOnboardingMutation>;
  completeFacilitiesOnboardingStep: Maybe<CompleteFacilitiesOnboardingStepMutationPayload>;
  completeGetStartedOnboardingStep: Maybe<CompleteGetStartedOnboardingStepMutationPayload>;
  completeInternalRequestTeamMemberAssignment: Maybe<CompleteInternalRequestTeamMemberAssignmentPayload>;
  completePaymentInfoOnboardingStep: Maybe<CompletePaymentInfoOnboardingStepMutationPayload>;
  completeRatesOnboardingStep: Maybe<CompleteRatesOnboardingStepMutationPayload>;
  completeSelfServeOnboardingAction: Maybe<CompleteSelfServeOnboardingActionMutationPayload>;
  completeStaffOnboardingStep: Maybe<CompleteStaffOnboardingStepMutationPayload>;
  completeTradesSubscriptionOnboardingStep: Maybe<CompleteTradesSubscriptionOnboardingStepMutationPayload>;
  completeTroubleshootingSession: Maybe<CompleteTroubleshootingSessionMutationPayload>;
  completeVendorOnboarding: Maybe<CompleteVendorOnboardingMutationPayload>;
  completeWorkOrderTeamMemberAssignment: Maybe<CompleteWorkOrderTeamMemberAssignmentPayload>;
  confirmPerUserDailyMenuFirstRun: Maybe<ConfirmPerUserDailyMenuFirstRunMutationPayload>;
  confirmVendorAgreement: Maybe<ConfirmVendorAgreementMutationPayload>;
  confirmVendorRequiredInfo: Maybe<ConfirmVendorRequiredInfoMutationPayload>;
  convertTradesTrial: Maybe<ConvertTradesTrialPayload>;
  createActiveMaintenancePlan: Maybe<CreateActiveMaintenancePlanMutation>;
  createBrand: Maybe<CreateBrandMutationPayload>;
  createBudget: Maybe<CreateBudgetMutationPayload>;
  createBusinessUnit: Maybe<CreateBusinessUnitMutation>;
  createClientAdjustmentInvoice: Maybe<CreateClientAdjustmentInvoicePayload>;
  createClientAutoAdjustmentInvoice: Maybe<CreateClientAutoAdjustmentInvoiceMutationPayload>;
  createComment: Maybe<CreateCommentMutation>;
  createContactInquiryInternalNote: Maybe<CreateContactInquiryInternalNoteMutationPayload>;
  createControlCenterUser: Maybe<CreateControlCenterUserMutationPayload>;
  createCoordinator: Maybe<CreateCoordinatorMutationPayload>;
  createCyovDispatch: Maybe<CreateCyovDispatchPayload>;
  createDeviceConfigs: Maybe<CreateDeviceConfigsPayload>;
  createDeviceDataExport: Maybe<CreateDeviceDataExportPayload>;
  createExternalBankAccount: Maybe<CreateExternalBankAccountMutation>;
  createFacility: Maybe<CreateFacilityPayload>;
  createFacilityGroup: Maybe<CreateFacilityGroupPayload>;
  createFavouriteVendorConfiguration: Maybe<CreateFavouriteVendorConfigurationPayload>;
  createInitialSubscription: Maybe<CreateInitialSubscriptionPayload>;
  createInvoiceSetDispute: Maybe<CreateInvoiceSetDisputeMutationPayload>;
  createInvoiceSetNote: Maybe<CreateInvoiceSetNoteMutationPayload>;
  createJustifiWebComponentToken: Maybe<CreateJustifiWebComponentTokenMutationPayload>;
  createLeadInboundRequestInternalNote: Maybe<CreateLeadInboundRequestInternalNoteMutationPayload>;
  createMaintenancePlan: Maybe<CreateMaintenancePlanMutation>;
  createMarket: Maybe<CreateMarketPayload>;
  createMissingDataAlertTicket: Maybe<CreateMissingDataAlertTicketPayload>;
  createOffResqCustomer: Maybe<CreateOffResqCustomerMutationPayload>;
  createOffResqCustomerUser: Maybe<CreateOffResqCustomerUserMutationPayload>;
  createOffResqFacility: Maybe<CreateOffResqFacilityMutationPayload>;
  createOffResqFacilityUser: Maybe<CreateOffResqFacilityUserMutationPayload>;
  createOffResqWorkOrder: Maybe<CreateOffResqWorkOrderMutationPayload>;
  createOrUpdateBusinessUnitOnboarding: Maybe<CreateOrUpdateBusinessUnitOnboardingMutationPayload>;
  createOriginalVendorInvoice: Maybe<CreateOriginalVendorInvoiceMutationPayload>;
  createPartneredEstimateSubmissionFromBuilder: Maybe<CreatePartneredEstimateSubmissionFromBuilderMutationPayload>;
  createPartneredInvoiceSubmissionFromBuilder: Maybe<CreatePartneredInvoiceSubmissionFromBuilderMutationPayload>;
  createPaymentMethod: Maybe<CreatePaymentMethodMutationPayload>;
  createPmOneTimeWorkOrder: Maybe<CreatePmOneTimeWorkOrderPayload>;
  createPreventativeMaintenance: Maybe<CreatePreventativeMaintenancePayload>;
  createPriceBookCategory: Maybe<CreatePriceBookCategoryMutationPayload>;
  createPriceBookItem: Maybe<CreatePriceBookItemMutationPayload>;
  createProject: Maybe<CreateProjectMutationPayload>;
  createProposalComment: Maybe<CreateProposalCommentMutationPayload>;
  createProtectionPlanEnrollment: Maybe<CreateProtectionPlanEnrollmentPayload>;
  createQuote: Maybe<CreateQuoteMutationPayload>;
  createQuoteFromBuilder: Maybe<CreateQuoteFromBuilderMutationPayload>;
  createQuoteSetOptions: Maybe<CreateQuoteSetOptionsPayload>;
  /**
   * Creates a new record of work for an invoice set,
   * potentially copying an existing published record of work.
   */
  createRecordOfWork: Maybe<CreateRecordOfWorkMutationPayload>;
  /**
   * Create or update a mobile app release (idempotent).
   *
   * If a release with the same platform, app_name, version_name, and build_number
   * already exists, it will be updated. Otherwise, a new release is created.
   *
   * Only accessible by staff users.
   */
  createRelease: Maybe<CreateReleaseMutationPayload>;
  createReportTemplate: Maybe<CreateReportTemplatePayload>;
  createRole: Maybe<CreateRolePayload>;
  createRuleViolations: Maybe<CreateRuleViolationsMutationPayload>;
  createRuleViolationsFeedback: Maybe<CreateRuleViolationsFeedbackPayload>;
  /**
   * Create a ResQ service order invoice.
   *
   * This mutation creates a ClientInvoice for ResQ services (sensor hardware,
   * installation, tagging, gateways) for a client organization.
   *
   * The operation is atomic and includes:
   * - Validation of organization and business unit
   * - Tax calculation based on business unit's tax rates
   * - Invoice and line item creation
   * - Automatic PDF generation (async)
   * - Event publishing for downstream systems
   *
   * Authorization: Coordinators only
   */
  createServiceOrder: Maybe<CreateServiceOrderMutationPayload>;
  createTechnicianUser: Maybe<CreateTechnicianUserMutationPayload>;
  createTradesCustomerInvoice: Maybe<CreateTradesCustomerInvoiceMutationPayload>;
  createTroubleshootingSession: Maybe<CreateTroubleshootingSessionMutationPayload>;
  createUpdateExternalReference: Maybe<CreateUpdateExternalReferenceMutationPayload>;
  createUpdatePayoutOffer: Maybe<CreateUpdatePayoutOfferMutationPayload>;
  createUpdateWorkOrderExpenseType: Maybe<CreateUpdateWorkOrderExpenseTypeMutationPayload>;
  createVendor: Maybe<CreateVendorMutation>;
  createVendorAdjustmentInvoice: Maybe<CreateVendorAdjustmentInvoiceMutation>;
  createVendorAutoAdjustmentInvoice: Maybe<CreateVendorAutoAdjustmentInvoiceMutationPayload>;
  createVendorBusinessProfile: Maybe<CreateVendorBusinessProfileMutationPayload>;
  createVendorInternalNote: Maybe<CreateVendorInternalNoteMutation>;
  createVendorInvoiceBatch: Maybe<CreateVendorInvoiceBatchMutation>;
  createVendorPreventiveMaintenanceRecommendation: Maybe<CreateVendorPreventiveMaintenanceRecommendationMutationPayload>;
  createVendorPromotion: Maybe<CreateVendorPromotionMutationPayload>;
  createVendorRankingForEquipment: Maybe<CreateVendorRankingForEquipmentMutationPayload>;
  createVendorRankingForFacilityAndServiceCategory: Maybe<CreateVendorRankingForFacilityAndServiceCategoryMutationPayload>;
  /** Create a subcontract on a work order where Parent Vendor remains vendor-of-record. */
  createVendorSubcontract: Maybe<CreateVendorSubcontractMutationPayload>;
  /** Coordinator-only pairing management between Parent Vendor and Subcontract Vendor orgs. */
  createVendorSubcontractPairing: Maybe<CreateVendorSubcontractPairingMutationPayload>;
  createVendorWebsite: Maybe<CreateVendorWebsiteMutationPayload>;
  createVendorWorkOrderInternalNote: Maybe<CreateVendorWorkOrderInternalNotePayload>;
  createVisitReview: Maybe<CreateVisitReviewMutation>;
  createWebsiteAdvertisingCampaign: Maybe<CreateWebsiteAdvertisingCampaignMutationPayload>;
  createWorkOrderEscalation: Maybe<CreateWorkOrderEscalationPayload>;
  createWorkOrderInternalNote: Maybe<CreateWorkOrderInternalNotePayload>;
  /** Creates a new invoice set for a work order and vendor. */
  createWorkOrderInvoiceSet: Maybe<CreateWorkOrderInvoiceSetMutationPayload>;
  createWorkOrderNote: Maybe<CreateWorkOrderNotePayload>;
  createWorkOrderReview: Maybe<CreateWorkOrderReviewMutation>;
  createWorkOrderV2: Maybe<CreateWorkOrderV2Payload>;
  deactivateEquipmentMutation: Maybe<DeactivateEquipmentPayload>;
  deactivateFacility: Maybe<DeactivateFacilityPayload>;
  /**
   * Unified proposal decision mutation for OffResq, standalone quotes, and
   * maintenance plan proposals.
   *
   * Accepts an optional metadata JSON blob; signature is required for approvals.
   */
  decideProposal: Maybe<DecideProposalMutationPayload>;
  declineOffResqVendorSubcontract: Maybe<DeclineOffResqVendorSubcontractMutationPayload>;
  declineVendorDispatchRequest: Maybe<DeclineVendorDispatchRequestMutationPayload>;
  declineVendorPreventiveMaintenanceRecommendation: Maybe<DeclineVendorPreventiveMaintenanceRecommendationMutationPayload>;
  deleteAttachment: Maybe<DeleteAttachmentMutation>;
  deleteBrand: Maybe<DeleteBrandMutationPayload>;
  deleteBudget: Maybe<DeleteBudgetMutationPayload>;
  deleteBusinessUnit: Maybe<DeleteBusinessUnitMutationPayload>;
  deleteClientManagedInvoice: Maybe<DeleteClientManagedInvoicePayload>;
  deleteClientReportSchedule: Maybe<DeleteClientReportScheduleMutationPayload>;
  deleteComment: Maybe<DeleteCommentMutation>;
  deleteFacility: Maybe<DeleteFacilityPayload>;
  deleteFacilityGroup: Maybe<DeleteFacilityGroupPayload>;
  deleteFavouriteVendorConfiguration: Maybe<DeleteFavouriteVendorConfigurationPayload>;
  deleteGateway: Maybe<DeleteGatewayPayload>;
  deleteImageFromWorkOrder: Maybe<DeleteImageFromWorkOrderMutation>;
  deleteInboundVendorInvoice: Maybe<DeleteInboundVendorInvoiceMutationPayload>;
  deleteInvoiceSetNote: Maybe<DeleteInvoiceSetNoteMutationPayload>;
  deleteOffResqWorkOrder: Maybe<DeleteOffResqWorkOrderMutationPayload>;
  deletePartneredSubmission: Maybe<DeletePartneredSubmissionMutationPayload>;
  deletePreventativeMaintenance: Maybe<DeletePreventativeMaintenancePayload>;
  deletePriceBookCategory: Maybe<DeletePriceBookCategoryMutationPayload>;
  deletePriceBookItem: Maybe<DeletePriceBookItemMutationPayload>;
  deleteProposalComment: Maybe<DeleteProposalCommentMutationPayload>;
  deleteProtectionPlanEnrollment: Maybe<DeleteProtectionPlanEnrollmentPayload>;
  deleteRecordOfWork: Maybe<DeleteRecordOfWorkMutationPayload>;
  deleteRole: Maybe<DeleteRolePayload>;
  deleteSensor: Maybe<DeleteSensorPayload>;
  /** Mutation to delete a testimonial from a vendor business profile. */
  deleteTestimonial: Maybe<DeleteTestimonialMutationPayload>;
  deleteVendorFacilityInsuranceDocument: Maybe<DeleteVendorFacilityInsuranceDocumentMutationPayload>;
  deleteVendorPromotion: Maybe<DeleteVendorPromotionMutationPayload>;
  deleteVendorRanking: Maybe<DeleteVendorRankingMutationPayload>;
  deleteVendorRankingForFacilityAndServiceCategory: Maybe<DeleteVendorRankingForFacilityAndServiceCategoryMutationPayload>;
  deleteVendorReportSchedule: Maybe<DeleteVendorReportScheduleMutationPayload>;
  deleteVendorWorkOrderInternalNote: Maybe<DeleteVendorWorkOrderInternalNotePayload>;
  deleteWorkOrderInternalNote: Maybe<DeleteWorkOrderInternalNotePayload>;
  dismiss: Maybe<DismissMutationPayload>;
  dismissWorkOrderNoteMetadata: Maybe<DismissWorkOrderNoteMetadataMutationPayload>;
  disputeWorkOrder: Maybe<DisputeWorkOrderMutation>;
  editBlockedGroups: Maybe<EditBlockedGroupsPayload>;
  editClientOrganization: Maybe<EditClientOrganizationMutation>;
  editClientOrganizationMember: Maybe<EditClientOrganizationMemberMutation>;
  editClientVendorRelationshipInvite: Maybe<EditClientVendorRelationshipInvitePayload>;
  editEquipment: Maybe<EditEquipmentMutation>;
  editFavouriteVendorConfiguration: Maybe<EditFavouriteVendorConfigurationPayload>;
  editOrgOwner: Maybe<EditOrgOwnerMutationPayload>;
  editOrganizationFeatures: Maybe<EditOrganizationFeaturesMutationPayload>;
  editPreventativeMaintenance: Maybe<EditPreventativeMaintenancePayload>;
  editQuote: Maybe<EditQuoteMutationPayload>;
  editUserDjangoGroups: Maybe<EditUserDjangoGroupsMutationPayload>;
  /** @deprecated Deprecated in favour of updateUserProfile. */
  editVendorUserDetails: Maybe<EditVendorUserDetailsMutation>;
  editWorkOrder: Maybe<EditWorkOrderPayload>;
  enableVendorNoraEmailForwarding: Maybe<EnableVendorNoraEmailForwardingMutationPayload>;
  endActivity: Maybe<EndActivityPayload>;
  endOffResqWorkOrderVisit: Maybe<EndOffResqWorkOrderVisitMutationPayload>;
  endVisit: Maybe<EndVisitPayload>;
  financeInvoice: Maybe<FinanceInvoiceMutationPayload>;
  forceLogoutUser: Maybe<ForceLogoutUserMutationPayload>;
  forceWorkOrderCompletion: Maybe<ForceWorkOrderCompletionMutationPayload>;
  generateKustomerLoginToken: Maybe<GenerateKustomerLoginTokenPayload>;
  generateMagicLinkToken: Maybe<GenerateMagicLinkTokenMutationPayload>;
  generateOffResqCustomerPortalLink: Maybe<GenerateOffResqCustomerPortalLinkPayload>;
  generateVendorInvoicePdf: Maybe<GenerateVendorInvoicePdfPayload>;
  importAccountingIntegrationCustomers: Maybe<ImportAccountingIntegrationCustomersMutationPayload>;
  importBankStatements: Maybe<ImportBankStatementsMutationPayload>;
  initiateMarketplaceOnboarding: Maybe<InitiateMarketplaceOnboardingMutationPayload>;
  initiateVendorFacilityInvite: Maybe<InitiateVendorFacilityInviteMutationPayload>;
  inviteMemberToClientOrganization: Maybe<InviteMemberToClientOrganizationMutation>;
  inviteMemberToVendor: Maybe<InviteMemberToVendorMutation>;
  inviteOwnerToOnboarding: Maybe<InviteOwnerToOnboardingMutation>;
  /** Validate launch prerequisites and enqueue the setup orchestrator. */
  launchGoogleAdsSetup: Maybe<LaunchGoogleAdsSetupPayload>;
  /**
   * Manage notification settings for off-resq work orders.
   *
   * Allows vendors to control facility user notifications at different levels:
   * - Vendor-level (global): Don't provide any scope IDs
   * - Customer-level: Provide only scopedCustomerId
   * - Facility-level: Provide only scopedFacilityId
   * - Work order-level: Provide only scopedWorkOrderId
   */
  manageOffResqNotificationSettings: Maybe<ManageOffResqNotificationSettingsMutationPayload>;
  markApBatchesAsPaid: Maybe<MarkApBatchesAsPaidMutationPayload>;
  markApBatchesAsUnpaid: Maybe<MarkApBatchesAsUnpaidMutationPayload>;
  markBankAccountRecordProcessed: Maybe<MarkBankAccountRecordProcessedMutationPayload>;
  markClientManagedInvoicesAsPaid: Maybe<MarkClientManagedInvoicesAsPaidPayload>;
  markClientManagedInvoicesAsUnpaid: Maybe<MarkClientManagedInvoicesAsUnpaidPayload>;
  markInboxItemRead: Maybe<MarkInboxItemReadMutation>;
  markInvoiceEmailRecordProcessed: Maybe<MarkInvoiceEmailRecordProcessedMutationPayload>;
  markLeadInboundRequestDone: Maybe<MarkLeadInboundRequestDoneMutationPayload>;
  markLeadInboundRequestRead: Maybe<MarkLeadInboundRequestReadMutationPayload>;
  markLendingOnboardingBannerShown: Maybe<MarkLendingOnboardingBannerShownMutationPayload>;
  markNoraCallEvaluationReviewed: Maybe<MarkNoraCallEvaluationReviewed>;
  markOffResqVendorInvoiceAsPaid: Maybe<MarkOffResqVendorInvoiceAsPaidMutationPayload>;
  markRecordOfWorkAsAwaitingVendorOnboarding: Maybe<MarkRecordOfWorkAsAwaitingVendorOnboardingMutationPayload>;
  markSubcontractSettlementInvoiceAsPaidExternally: Maybe<MarkSubcontractSettlementInvoiceAsPaidExternallyMutationPayload>;
  markSubcontractSettlementInvoiceAsUnpaid: Maybe<MarkSubcontractSettlementInvoiceAsUnpaidMutationPayload>;
  markSubcontractSettlementInvoicesAsPaidExternally: Maybe<MarkSubcontractSettlementInvoicesAsPaidExternallyMutationPayload>;
  markWorkOrderAsAwaitingPayment: Maybe<MarkWorkOrderAsAwaitingPaymentPayload>;
  markWorkOrderTeamMemberAssignmentAsUnresolved: Maybe<MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload>;
  mergeApBatches: Maybe<MergeApBatchesMutationPayload>;
  /**
   * Migrate a client organization to per-user pricing model.
   *
   * This mutation:
   * 1. Sets the organization's pricing model to per-user subscription
   * 2. Updates the feature tier to Basic or Pro
   * 3. Creates the Work Order Submitter role if it doesn't exist
   * 4. Optionally converts specified role members to Work Order Submitter
   *
   * Authorization: Control center users only.
   */
  migrateClientToPerUserPricing: Maybe<MigrateClientToPerUserPricingMutationPayload>;
  moveAllEquipmentToAnotherFacility: Maybe<MoveAllEquipmentToAnotherFacilityPayload>;
  moveEquipmentToFacility: Maybe<MoveEquipmentToFacilityPayload>;
  moveWorkOrderToAwaitingRecordOfWork: Maybe<MoveWorkOrderToAwaitingRecordOfWorkMutation>;
  notifyOffResqWorkOrderOnMyWay: Maybe<NotifyOffResqWorkOrderOnMyWayMutationPayload>;
  notifyWorkOrderOnMyWay: Maybe<NotifyWorkOrderOnMyWayMutationPayload>;
  overrideLocationAddress: Maybe<OverrideLocationAddressMutationPayload>;
  performVendorWebsiteMonitorDomainAction: Maybe<PerformVendorWebsiteMonitorDomainActionMutationPayload>;
  /** Persist advertiser-guide acceptance for a website-scoped Google Ads setup. */
  persistGoogleAdsAdvertiserGuideAcceptance: Maybe<PersistGoogleAdsAdvertiserGuideAcceptancePayload>;
  /** Mutation to polish and professionalize the About Us text using AI. */
  polishAboutUsText: Maybe<PolishAboutUsTextMutationPayload>;
  prefillOffResqEstimateFromFile: Maybe<PrefillOffResqEstimateFromFileMutationPayload>;
  prefillPartneredEstimateFromFile: Maybe<PrefillPartneredEstimateFromFileMutationPayload>;
  prefillPartneredInvoiceFromFile: Maybe<PrefillPartneredInvoiceFromFileMutationPayload>;
  previewAiTextSuggestions: Maybe<PreviewAiTextSuggestionsPayload>;
  /**
   * Calculate a preview of per-user subscription costs without creating subscription.
   * Shows breakdown of billable users, rates, and total amounts.
   */
  previewPerUserSubscription: Maybe<PreviewPerUserSubscriptionPayload>;
  previewVendorNoraEmailForwarding: Maybe<PreviewVendorNoraEmailForwardingMutationPayload>;
  /** Generate and persist the initial Google Ads setup draft. */
  prewarmVendorWebsiteGoogleAdsDraft: Maybe<PrewarmVendorWebsiteGoogleAdsDraftMutationPayload>;
  /**
   * Unified mutation for creating, updating, and publishing proposals.
   *
   * This mutation is a pure routing layer that delegates to proposal-level handlers.
   * All business logic is handled by the interactors, which use strategy-based routing.
   *
   * - CREATE: Routes to create_proposal router
   * - UPDATE: Routes to update_proposal router
   * - PUBLISH: Routes to PublishProposalInteractor
   */
  proposal: Maybe<ProposalMutationPayload>;
  purchaseReceptionistPhoneNumber: Maybe<PurchaseReceptionistPhoneNumberMutationPayload>;
  raiseApprovedSpendDuringWorkOrderSubmission: Maybe<RaiseApprovedSpendDuringWorkOrderSubmissionPayload>;
  reactivateEquipmentMutation: Maybe<ReactivateEquipmentPayload>;
  reactivateFacility: Maybe<ReactivateFacilityMutationPayload>;
  reassignWorkOrderVendor: Maybe<ReassignWorkOrderVendorPayload>;
  recordAdBannerClick: Maybe<RecordAdBannerClickMutationPayload>;
  recordClientVendorPromotionView: Maybe<RecordClientVendorPromotionViewMutationPayload>;
  /**
   * Record extraction conversion links for a lead inbound request.
   *
   * Called after the conversion flow has created OffResq entities (work order,
   * proposal, customer, facility) via their respective mutations. This mutation
   * updates the Extraction records in the given ExtractionSet by setting their
   * ``converted_to`` GenericForeignKey to the created entities, so that each
   * Extraction (e.g. OffResqWorkOrderData_v1, ProposalData_v1) is linked to the
   * corresponding OffResqWorkOrder, Proposal, OffResqCustomer, or OffResqFacility.
   *
   * Use when: the user has completed the inbound-request conversion UI, created
   * any new customer/facility/work order/proposal, and the frontend needs to
   * persist which Extractions were converted to which entities (and optionally
   * drive Lead status updates when all extractions are converted).
   */
  recordLeadInboundRequestConversion: Maybe<RecordLeadInboundRequestConversionMutationPayload>;
  recordPayment: Maybe<RecordPaymentPayload>;
  recordSuccessfulTroubleshooting: Maybe<RecordSuccessfulTroubleshootingMutationPayload>;
  recordVendorPromotionView: Maybe<RecordVendorPromotionViewMutationPayload>;
  refundBatchPayment: Maybe<RefundBatchPaymentMutationPayload>;
  regenerateRsgCompletionReport: Maybe<RegenerateRsgCompletionReportMutationPayload>;
  /** Mutation to regenerate AI cover image for a vendor business profile. */
  regenerateVendorCoverImage: Maybe<RegenerateVendorCoverImageMutationPayload>;
  reinitializeSubscription: Maybe<ReinitializeSubscriptionPayload>;
  rejectClientWorkOrder: Maybe<RejectClientWorkOrderPayload>;
  rejectLeadInboundRequest: Maybe<RejectLeadInboundRequestMutationPayload>;
  rejectQuoteSet: Maybe<RejectQuoteSetPayload>;
  rejectQuoteSetOptionForSpend: Maybe<RejectQuoteSetOptionForSpendPayload>;
  rejectVendorEquipmentCapabilitySuggestion: Maybe<RejectVendorEquipmentCapabilitySuggestionMutationPayload>;
  remindFacilityPaymentContactToAddPaymentMethod: Maybe<RemindFacilityPaymentContactToAddPaymentMethodMutationPayload>;
  removePaymentMethod: Maybe<RemovePaymentMethodMutationPayload>;
  removeQuote: Maybe<RemoveQuoteMutation>;
  removeQuoteSetOption: Maybe<RemoveQuoteSetOptionPayload>;
  removeUpcomingAllocation: Maybe<RemoveUpcomingAllocationMutationPayload>;
  removeUserFromClientOrganization: Maybe<RemoveUserFromClientOrganizationMutation>;
  removeUsersFromRole: Maybe<RemoveUsersFromRoleMutationPayload>;
  removeVendorMember: Maybe<RemoveVendorMemberMutation>;
  removeVendorPayoutInfo: Maybe<RemoveVendorPayoutInfoMutationPayload>;
  removeWorkOrdersFromProject: Maybe<RemoveWorkOrdersFromProjectMutationPayload>;
  reopenLeadInboundRequest: Maybe<ReopenLeadInboundRequestMutationPayload>;
  replaceDisputedInvoice: Maybe<ReplaceDisputedInvoiceMutationPayload>;
  replaceVendorSlaPolicy: Maybe<ReplaceVendorSlaPolicyMutationPayload>;
  requestAutopayChanges: Maybe<RequestAutopayChangesMutationPayload>;
  requestDispatchChanges: Maybe<RequestDispatchChangesMutationPayload>;
  requestEstimate: Maybe<RequestEstimateMutationPayload>;
  requestGoogleAdsGrowthExpert: Maybe<RequestGoogleAdsGrowthExpertMutationPayload>;
  requestMaintenancePlan: Maybe<RequestMaintenancePlanMutationPayload>;
  requestMaintenancePlanDateChange: Maybe<RequestMaintenancePlanDateChangeMutation>;
  requestNewCapexProject: Maybe<RequestNewCapexProjectMutationPayload>;
  requestPlannedMaintenanceQuote: Maybe<RequestPlannedMaintenanceQuoteMutationPayload>;
  requestQuote: Maybe<RequestMaintenancePlanQuoteMutation>;
  requestRsgEstimate: Maybe<RequestRsgEstimatePayload>;
  rerunNoraCallEvaluation: Maybe<RerunNoraCallEvaluation>;
  rescheduleAppointment: Maybe<RescheduleAppointmentPayload>;
  rescheduleInternalAppointment: Maybe<RescheduleInternalAppointmentPayload>;
  resendClientVendorRelationshipInvite: Maybe<ResendClientVendorRelationshipInvitePayload>;
  resetQuoteSet: Maybe<ResetQuoteSetPayload>;
  resolveFacilityExpansion: Maybe<ResolveFacilityExpansionMutationPayload>;
  resolveFlaggedInvoice: Maybe<ResolveFlaggedInvoicePayload>;
  resolveGoogleAdsLocationGeometries: Maybe<ResolveGoogleAdsLocationGeometriesMutationPayload>;
  resolveIncidents: Maybe<ResolveIncidentsPayload>;
  resolveInvoiceSetDispute: Maybe<ResolveInvoiceSetDisputeMutationPayload>;
  resolveWorkOrderDispute: Maybe<ResolveWorkOrderDisputeMutation>;
  resolveWorkOrderEscalation: Maybe<ResolveWorkOrderEscalationPayload>;
  resubmitGoogleAdsBillingPayment: Maybe<ResubmitGoogleAdsBillingPaymentMutationPayload>;
  retryInvoiceBatchCharge: Maybe<RetryInvoiceBatchChargeMutationPayload>;
  /**
   * Retry payment for all unpaid subscription invoices for a given subscription.
   *
   * Accepts either a facility_id (for facility-scoped v3 subscriptions), a business_unit_id
   * (for grouped business-unit invoices), or an organization_subscription_id (for per-user
   * subscriptions). Uses the canonical payment method for that invoice scope.
   */
  retrySubscriptionPayment: Maybe<RetrySubscriptionPaymentMutationPayload>;
  reverseClientInvoicePayment: Maybe<ReverseClientInvoicePaymentMutationPayload>;
  revokeClientVendorRelationshipInvite: Maybe<RevokeClientVendorRelationshipInvitePayload>;
  /** Coordinator-only pairing revocation between Parent Vendor and Subcontract Vendor orgs. */
  revokeVendorSubcontractPairing: Maybe<RevokeVendorSubcontractPairingMutationPayload>;
  /** Creates or updates a record of work by work order. */
  saveRecordOfWork: Maybe<SaveRecordOfWorkMutation>;
  saveReviewedOffResqWorkOrderVisitNotes: Maybe<SaveReviewedOffResqWorkOrderVisitNotesMutationPayload>;
  saveReviewedVisitNotes: Maybe<SaveReviewedVisitNotesPayload>;
  saveVendorBrandLogo: Maybe<SaveVendorBrandLogoMutationPayload>;
  /** Mutation to save a preview cover image URL to the vendor business profile. */
  saveVendorCoverImage: Maybe<SaveVendorCoverImageMutationPayload>;
  saveVendorOrder: Maybe<SaveVendorOrderMutationPayload>;
  saveVendorRankingForFacilityAndServiceCategoryOrder: Maybe<SaveVendorRankingForFacilityAndServiceCategoryOrderMutationPayload>;
  saveVendorWebsiteGoogleAdsBillingConfig: Maybe<SaveVendorWebsiteGoogleAdsBillingConfigMutationPayload>;
  saveVendorWebsiteGoogleAdsDraft: Maybe<SaveVendorWebsiteGoogleAdsDraftMutationPayload>;
  scheduleInternalAppointment: Maybe<ScheduleInternalAppointmentPayload>;
  scheduleVendorNoraConfigurationInterview: Maybe<ScheduleVendorNoraConfigurationInterviewMutationPayload>;
  searchGoogleAdsLocationTargets: Maybe<SearchGoogleAdsLocationTargetsMutationPayload>;
  selectQuoteSetOption: Maybe<SelectQuoteSetOptionPayload>;
  sendInviteSms: Maybe<SendInviteSmsMutation>;
  sendProposalReminder: Maybe<SendProposalReminderMutationPayload>;
  sendReport: Maybe<SendReportPayload>;
  sendVendorEmailNotification: Maybe<SendVendorEmailNotificationPayload>;
  /** Mutation to send intro email from vendor to facility. */
  sendVendorIntroEmail: Maybe<SendVendorIntroEmailMutationPayload>;
  sendVendorPromoEmail: Maybe<SendVendorPromoEmailMutationPayload>;
  sendVendorSubscriptionPaymentLink: Maybe<SendVendorSubscriptionPaymentLinkMutationPayload>;
  sendWelcomeEmail: Maybe<SendWelcomeEmailMutationPayload>;
  setEntityPinned: Maybe<SetEntityPinnedMutationPayload>;
  setEstimatedTimeOfArrivalSourcingParts: Maybe<SetEstimatedTimeOfArrivalSourcingPartsMutationPayload>;
  setGoogleAdsCampaignBudget: Maybe<SetGoogleAdsCampaignBudgetMutationPayload>;
  setGoogleAdsCampaignStatus: Maybe<SetGoogleAdsCampaignStatusMutationPayload>;
  setReceptionistEnabled: Maybe<SetReceptionistEnabledMutationPayload>;
  setReceptionistTransfer: Maybe<SetReceptionistTransferMutationPayload>;
  setSensorConfigState: Maybe<SetSensorConfigStatePayload>;
  setSubscriptionAddons: Maybe<SetSubscriptionAddonsPayload>;
  setUserNotificationPreference: Maybe<SetUserNoficationPreferenceMutationPayload>;
  setVendorAgreementPlans: Maybe<SetVendorAgreementPlansMutationPayload>;
  setVendorSubscriptionPaymentMethod: Maybe<SetVendorSubscriptionPaymentMethodMutationPayload>;
  setWebsiteAdvertisingCampaignDailyBudget: Maybe<SetWebsiteAdvertisingCampaignDailyBudgetMutationPayload>;
  setupPreAuthorizedDebit: Maybe<SetupPreAuthorizedDebitMutationPayload>;
  skipOnboardingStep: Maybe<SkipOnboardingStepMutationPayload>;
  skipWorkOrderReview: Maybe<SkipWorkOrderReviewMutation>;
  snooze: Maybe<SnoozeMutationPayload>;
  snoozeIncidents: Maybe<SnoozeIncidentsPayload>;
  snoozeReviews: Maybe<SnoozeReviewsPayload>;
  /** Unified mutation for accepting or rejecting standalone quotes. */
  standaloneQuoteAction: Maybe<StandaloneQuoteActionMutationPayload>;
  startAppointmentActivity: Maybe<StartAppointmentActivityPayload>;
  startChooseVendorActivity: Maybe<StartChooseVendorActivityPayload>;
  startDispatchActivity: Maybe<StartDispatchActivityPayload>;
  startFindingQuoteActivity: Maybe<StartFindingQuoteActivityPayload>;
  startOffResqWorkOrderVisit: Maybe<StartOffResqWorkOrderVisitMutationPayload>;
  startOnHoldActivity: Maybe<StartOnHoldActivityPayload>;
  startOrganizationSubscription: Maybe<StartOrganizationSubscriptionMutationPayload>;
  /** Mutation to start an overdue invoices calldown. */
  startOverdueInvoicesCalldown: Maybe<StartOverdueInvoicesCalldownPayload>;
  startPerUserSubscription: Maybe<StartPerUserSubscriptionPayload>;
  startResqReviewActivity: Maybe<StartResqReviewActivityPayload>;
  startSchedulingActivity: Maybe<StartSchedulingActivityPayload>;
  startSchedulingCalldown: Maybe<StartSchedulingCalldownPayload>;
  startSiteVisitActivity: Maybe<StartSiteVisitActivityPayload>;
  startSourcingPartsActivity: Maybe<StartSourcingPartsActivityPayload>;
  startSubscription: Maybe<StartSubscriptionPayload>;
  startVisit: Maybe<StartVisitMutationPayload>;
  stopOrganizationSubscriptions: Maybe<DeactivateOrganizationSubscriptionsPayload>;
  submitBusinessInformation: Maybe<SubmitBusinessInformationPayload>;
  submitOffResqVendorInvoice: Maybe<SubmitOffResqVendorInvoiceMutationPayload>;
  submitQuoteFeedback: Maybe<SubmitQuoteFeedbackMutation>;
  submitRecordOfWork: Maybe<SubmitRecordOfWorkPayload>;
  submitVendorInvoice: Maybe<SubmitVendorInvoiceMutation>;
  submitVendorWebsiteBuilderSurvey: Maybe<SubmitVendorWebsiteBuilderSurveyMutationPayload>;
  submitWorkOrder: Maybe<SubmitWorkOrderPayload>;
  submitWorkOrderForApproval: Maybe<SubmitWorkOrderForApproval>;
  subscribeToWorkOrderNotes: Maybe<SubscribeToWorkOrderNotesPayload>;
  terminateUserSession: Maybe<TerminateUserSessionMutationPayload>;
  triggerSampleNotification: Maybe<TriggerSampleNotificationPayload>;
  /** Unapproves a record of work for invoicing. */
  unapproveRecordOfWork: Maybe<UnapproveRecordOfWorkMutationPayload>;
  unarchiveReportTemplate: Maybe<UnarchiveReportTemplatePayload>;
  unassignedWorkOrderFromVendorCompany: Maybe<UnassignWorkOrderFromVendorCompanyMutation>;
  unblockAp: Maybe<UnblockApMutationPayload>;
  unblockVendor: Maybe<UnblockVendorMutation>;
  uncancelWorkOrder: Maybe<UncancelWorkOrderMutation>;
  unsubscribeFromWorkOrderNotes: Maybe<UnsubscribeFromWorkOrderNotesPayload>;
  updateApBatch: Maybe<UpdateApBatchMutationPayload>;
  updateBankAccountRecordNotes: Maybe<UpdateBankAccountRecordNotesMutationPayload>;
  updateBatchPayment: Maybe<UpdateBatchPaymentMutationPayload>;
  updateBrand: Maybe<UpdateBrandMutationPayload>;
  updateBudget: Maybe<UpdateBudgetMutationPayload>;
  updateBusinessUnit: Maybe<UpdateBusinessUnitMutation>;
  updateBusinessUnitSubscriptionPaymentMethod: Maybe<UpdateBusinessUnitSubscriptionPaymentMethodMutationPayload>;
  updateClientManagedInvoice: Maybe<UpdateClientManagedInvoicePayload>;
  updateClientMatchingProfile: Maybe<UpdateClientMatchingProfilePayload>;
  updateClientOrgSensitivity: Maybe<UpdateClientOrgSensitivityMutationPayload>;
  updateClientOrganizationStatus: Maybe<UpdateClientOrganizationStatusMutationPayload>;
  updateClientReportSchedule: Maybe<UpdateClientReportScheduleMutationPayload>;
  updateClientVendorRelationshipPaymentTerms: Maybe<UpdateClientVendorRelationshipPaymentTermsPayload>;
  updateContactInquiry: Maybe<UpdateContactInquiryMutationPayload>;
  updateDevice: Maybe<UpdateDeviceMutation>;
  updateDeviceConfigs: Maybe<UpdateDeviceConfigsPayload>;
  updateDispatchMethodPreference: Maybe<UpdateDispatchMethodPreferencePayload>;
  updateExternalBankAccount: Maybe<UpdateExternalBankAccountMutation>;
  updateExternalExpense: Maybe<UpdateExternalExpenseMutationPayload>;
  updateFacility: Maybe<UpdateFacilityMutation>;
  updateFacilityAllowedServiceCategories: Maybe<UpdateFacilityAllowedServiceCategoriesMutationPayload>;
  updateFacilityGroup: Maybe<UpdateFacilityGroupPayload>;
  updateFacilityGroupOpsOwnerMutation: Maybe<UpdateFacilityGroupOpsOwnerPayload>;
  updateFavouriteVendorInviteSubscription: Maybe<UpdateFavouriteVendorInviteSubscriptionMutationPayload>;
  updateGlCodes: Maybe<UpdateGlCodesMutationPayload>;
  updateGoogleAdsCampaignLocationTargets: Maybe<UpdateGoogleAdsCampaignLocationTargetsMutationPayload>;
  updateInboundInvoiceExtraction: Maybe<UpdateInboundInvoiceExtractionPayload>;
  /** This mutation only handles transitioning to CLIENT_IN_PROGRESS and on hold. */
  updateInternalRequestStatus: Maybe<UpdateInternalRequestStatusPayload>;
  updateInternalRequestTeamMemberAssignments: Maybe<UpdateInternalRequestTeamMemberAssignmentsPayload>;
  updateInvoiceApprovalSettings: Maybe<UpdateInvoiceApprovalSettingsPayload>;
  updateMaintenancePlan: Maybe<UpdateMaintenancePlanMutation>;
  updateMaintenancePlanAutoRenew: Maybe<UpdateMaintenancePlanAutoRenewMutation>;
  updateMaintenancePlanNextWorkOrderCreationDate: Maybe<UpdateMaintenancePlanNextWorkOrderCreationDateMutation>;
  updateMarket: Maybe<UpdateMarketPayload>;
  updateOffResqCustomer: Maybe<UpdateOffResqCustomerMutationPayload>;
  updateOffResqCustomerUser: Maybe<UpdateOffResqCustomerUserMutationPayload>;
  updateOffResqFacility: Maybe<UpdateOffResqFacilityMutationPayload>;
  updateOffResqFacilityUser: Maybe<UpdateOffResqFacilityUserMutationPayload>;
  updateOffResqWorkOrder: Maybe<UpdateOffResqWorkOrderMutationPayload>;
  updateOrganizationSubscription: Maybe<UpdateOrganizationSubscriptionMutationPayload>;
  updatePaymentMethodDefault: Maybe<UpdatePaymentMethodDefaultMutationPayload>;
  updatePerUserCount: Maybe<UpdatePerUserCountPayload>;
  updatePerUserSubscriptionGlCode: Maybe<UpdatePerUserSubscriptionGlCodePayload>;
  updatePreventativeMaintenanceTaskListItems: Maybe<UpdatePreventativeMaintenanceTaskListItemsPayload>;
  updatePriceBookCategory: Maybe<UpdatePriceBookCategoryMutationPayload>;
  updatePriceBookItem: Maybe<UpdatePriceBookItemMutationPayload>;
  updatePriceRateOverrides: Maybe<UpdatePriceRateOverridesMutationPayload>;
  updateProject: Maybe<UpdateProjectMutationPayload>;
  updateProtectionPlanEnrollment: Maybe<UpdateProtectionPlanEnrollmentPayload>;
  updateQuoteAcceptanceSettings: Maybe<UpdateQuoteAcceptanceSettingsPayload>;
  updateQuoteApprovalThresholds: Maybe<UpdateQuoteApprovalThresholdsPayload>;
  /**
   * Update an existing mobile app release.
   *
   * Only accessible by staff users.
   */
  updateRelease: Maybe<UpdateReleaseMutationPayload>;
  updateReportTemplate: Maybe<UpdateReportTemplatePayload>;
  updateRevenueShareOverrides: Maybe<UpdateRevenueShareOverridesMutationPayload>;
  updateRole: Maybe<UpdateRolePayload>;
  updateServiceCategories: Maybe<UpdateServiceCategoriesPayload>;
  updateSpendApprovalPreferences: Maybe<UpdateSpendApprovalPreferencesPayload>;
  updateSubscription: Maybe<UpdateSubscriptionPayload>;
  updateSubscriptionBusinessUnit: Maybe<UpdateSubscriptionBusinessUnitPayload>;
  updateSubscriptionPaymentMethod: Maybe<UpdateSubscriptionPaymentMethodPayload>;
  updateTaxRates: Maybe<UpdateTaxRatesMutationPayload>;
  updateTroubleshootingAction: Maybe<UpdateTroubleshootingActionMutationPayload>;
  updateUserProfile: Maybe<UpdateUserProfileMutationPayload>;
  updateUserStatus: Maybe<UpdateUserStatusMutationPayload>;
  updateVendor: Maybe<UpdateVendorMutation>;
  updateVendorAnticipatedStandardPayoutDays: Maybe<UpdateVendorAnticipatedStandardPayoutDaysMutationPayload>;
  updateVendorBusinessProfile: Maybe<UpdateVendorBusinessProfileMutationPayload>;
  updateVendorEquipmentCapability: Maybe<UpdateVendorEquipmentCapabilityMutationPayload>;
  updateVendorFacilityInsuranceDocument: Maybe<UpdateVendorFacilityInsuranceDocumentMutationPayload>;
  updateVendorGeneralInfo: Maybe<UpdateVendorGeneralInfoMutationPayload>;
  updateVendorInsuranceDocument: Maybe<UpdateVendorInsuranceDocumentMutationPayload>;
  updateVendorMember: Maybe<UpdateVendorMemberMutation>;
  updateVendorOpenToMarketplace: Maybe<UpdateVendorOpenToMarketplaceMutationPayload>;
  updateVendorPaymentInstructions: Maybe<UpdateVendorPaymentInstructionsMutationPayload>;
  updateVendorPayoutInfo: Maybe<UpdateVendorPayoutInfoMutationPayload>;
  updateVendorPriceRates: Maybe<UpdateVendorPriceRatesMutationPayload>;
  updateVendorProfileDispatch: Maybe<UpdateVendorProfileDispatchMutationPayload>;
  updateVendorPromotion: Maybe<UpdateVendorPromotionMutationPayload>;
  updateVendorReceptionistGuidance: Maybe<UpdateVendorReceptionistGuidanceMutationPayload>;
  updateVendorRemittanceEmailAddresses: Maybe<UpdateVendorRemittanceEmailAddressesMutationPayload>;
  updateVendorReportSchedule: Maybe<UpdateVendorReportScheduleMutationPayload>;
  updateVendorRevenueShares: Maybe<UpdateVendorRevenueSharesMutationPayload>;
  /** Resolve the active or pending subcontract for a work order target. */
  updateVendorSubcontract: Maybe<UpdateVendorSubcontractMutationPayload>;
  /** Coordinator-only commercial term updates for an existing parent/subcontract pairing. */
  updateVendorSubcontractPairing: Maybe<UpdateVendorSubcontractPairingMutationPayload>;
  updateVendorWebsite: Maybe<UpdateVendorWebsiteMutationPayload>;
  updateVisit: Maybe<UpdateVisitPayload>;
  updateWebsiteAdvertisingCampaignName: Maybe<UpdateWebsiteAdvertisingCampaignNameMutationPayload>;
  updateWorkOrderCompletionTime: Maybe<UpdateWorkOrderCompletionTimePayload>;
  updateWorkOrderNte: Maybe<UpdateWorkOrderNtePayload>;
  updateWorkOrderOpsOwner: Maybe<UpdateWorkOrderOpsOwnerMutation>;
  uploadAfterImages: Maybe<UploadAfterImagesMutation>;
  uploadClientManagedInvoice: Maybe<UploadClientManagedInvoicePayload>;
  uploadPartneredEstimateSubmission: Maybe<UploadPartneredEstimateSubmissionMutationPayload>;
  uploadPartneredInvoiceSubmission: Maybe<UploadPartneredInvoiceSubmissionMutationPayload>;
  uploadQuote: Maybe<UploadQuoteMutationPayload>;
  uploadRemittanceStatement: Maybe<UploadRemittanceStatementPayload>;
  uploadVendorInvoice: Maybe<UploadVendorInvoicePayload>;
  uploadedInvoiceCheck: Maybe<UploadedInvoiceCheckMutationPayload>;
  vendorChangeWorkOrderState: Maybe<VendorChangeWorkOrderStatePayload>;
  vendorCreateWorkOrder: Maybe<VendorCreateWorkOrderPayload>;
  voidSubcontractSettlementInvoice: Maybe<VoidSubcontractSettlementInvoiceMutationPayload>;
  voidSubcontractSettlementInvoices: Maybe<VoidSubcontractSettlementInvoicesMutationPayload>;
  voidSubscriptionInvoiceMutation: Maybe<VoidSubscriptionInvoiceMutationPayload>;
};


export type MutationsAcceptClientTosArgs = {
  input: AcceptClientTosMutationInput;
};


export type MutationsAcceptOffResqVendorSubcontractArgs = {
  input: AcceptOffResqVendorSubcontractMutationInput;
};


export type MutationsAcceptOrcTosArgs = {
  input: AcceptOrcTosMutationInput;
};


export type MutationsAcceptPayqVendorTosArgs = {
  input: AcceptPayQVendorTosMutationInput;
};


export type MutationsAcceptRequestForQuoteArgs = {
  input: AcceptRequestForQuoteInput;
};


export type MutationsAcceptVendorCreatedWorkOrderArgs = {
  input: AcceptVendorCreatedWorkOrderInput;
};


export type MutationsAcceptVendorDispatchRequestWithoutSchedulingArgs = {
  input: AcceptVendorDispatchRequestWithoutSchedulingMutationInput;
};


export type MutationsAcceptVendorEquipmentCapabilitySuggestionArgs = {
  input: AcceptVendorEquipmentCapabilitySuggestionMutationInput;
};


export type MutationsAcceptVendorPreventiveMaintenanceRecommendationArgs = {
  input: AcceptVendorPreventiveMaintenanceRecommendationMutationInput;
};


export type MutationsAcknowledgeAdvertisingCommercialHoldArgs = {
  input: AcknowledgeAdvertisingCommercialHoldMutationInput;
};


export type MutationsActivateMaintenancePlanArgs = {
  maintenancePlanId: Scalars['ID']['input'];
};


export type MutationsActivatePreventativeMaintenanceArgs = {
  input: ActivatePreventitiveMaintenanceMutationInput;
};


export type MutationsActivateTradesSubscriptionArgs = {
  input: ActivateTradesSubscriptionInput;
};


export type MutationsAddAfterImagesToVisitArgs = {
  input: AddAfterImagesToVisitInput;
};


export type MutationsAddAttachmentArgs = {
  attachToId: Scalars['ID']['input'];
  file: Scalars['String']['input'];
  fileContentType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsAddBarcodeArgs = {
  input: AddBarcodeMutationInput;
};


export type MutationsAddBeforeImagesToVisitArgs = {
  input: AddBeforeImagesToVisitInput;
};


export type MutationsAddClientOrganizationArgs = {
  contractSignedOn?: InputMaybe<Scalars['Date']['input']>;
  currency: Currency;
  invoiceApprovalStrategy: InvoiceApprovalStrategy;
  isEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  markup: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  offlinePaymentMethod?: InputMaybe<OfflinePaymentMethods>;
  operatingCountryId: Scalars['ID']['input'];
  paymentMethod: PaymentMethodType;
  pricingModelId?: InputMaybe<Scalars['ID']['input']>;
  quoteApprovalStrategy: QuoteApprovalStrategy;
  reportingManagerId?: InputMaybe<Scalars['ID']['input']>;
  sensitivity?: InputMaybe<Sensitivity>;
  sfId?: InputMaybe<Scalars['String']['input']>;
  successOwnerId?: InputMaybe<Scalars['ID']['input']>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddEquipmentArgs = {
  barCode: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  historicalSpend?: InputMaybe<Scalars['Decimal']['input']>;
  installedOn?: InputMaybe<Scalars['Date']['input']>;
  location: Scalars['String']['input'];
  mainImage?: InputMaybe<Image>;
  manufacturer: Scalars['String']['input'];
  modelNo: Scalars['String']['input'];
  modelTagImage?: InputMaybe<Image>;
  name: Scalars['String']['input'];
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Image>>>;
  serialNo: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']['input']>;
  warrantyNotes?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddExistingUserToClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID']['input'];
  facilityIds: Array<Scalars['ID']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};


export type MutationsAddExistingUserToVendorArgs = {
  input: AddExistingUserToVendorMutationInput;
};


export type MutationsAddExternalExpenseArgs = {
  input: AddExternalExpenseMutationInput;
};


export type MutationsAddGatewayArgs = {
  input: AddGatewayInput;
};


export type MutationsAddImageToWorkOrderArgs = {
  imageKey: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationsAddNewUserToClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  facilityIds: Array<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};


export type MutationsAddNewUserToVendorArgs = {
  arguments: AddNewUserToVendorArguments;
};


export type MutationsAddOwnerToClientOrganizationArgs = {
  input: AddOwnerToClientOrganizationMutationInput;
};


export type MutationsAddSensorToEquipmentArgs = {
  input: AddSensorToEquipmentInput;
};


export type MutationsAddWorkOrdersToProjectArgs = {
  input: AddWorkOrdersToProjectMutationInput;
};


export type MutationsAgreeVendorTosArgs = {
  input: AgreeVendorTosInput;
};


export type MutationsApproveQuoteSetOptionForSpendArgs = {
  input: ApproveQuoteSetOptionForSpendInput;
};


export type MutationsApproveRecordOfWorkArgs = {
  allowMissingMareketplacePlan?: InputMaybe<Scalars['Boolean']['input']>;
  ranFlaggingRules?: InputMaybe<Scalars['Boolean']['input']>;
  recordOfWorkId: Scalars['ID']['input'];
};


export type MutationsApproveWorkOrderClientInvoicesArgs = {
  arguments: ApproveWorkOrderClientInvoicesArguments;
};


export type MutationsArchiveProjectArgs = {
  input: ArchiveProjectMutationInput;
};


export type MutationsArchiveReportTemplateArgs = {
  input: ArchiveReportTemplateInput;
};


export type MutationsAssignUsersToRoleArgs = {
  input: AssignUsersToRoleMutationInput;
};


export type MutationsAssignWorkOrderEscalationArgs = {
  input: AssignWorkOrderEscalationInput;
};


export type MutationsAssociateUserTagsArgs = {
  input: AssociateUserTagsMutationInput;
};


export type MutationsAttachQuoteSetToWorkOrderArgs = {
  input: AttachQuoteSetToWorkOrderInput;
};


export type MutationsBlockApArgs = {
  input: BlockApMutationInput;
};


export type MutationsBulkCreateFavouriteVendorConfigurationArgs = {
  input: BulkCreateFavouriteVendorConfigurationInput;
};


export type MutationsBulkDeleteFavouriteVendorConfigurationsArgs = {
  input: BulkDeleteFavouriteVendorConfigurationsInput;
};


export type MutationsBulkInviteMembersToClientOrganizationArgs = {
  input: BulkInviteMembersToClientOrganizationMutationInput;
};


export type MutationsBulkRerunNoraCallEvaluationsArgs = {
  highestFindingSeverity?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  overallStatus?: InputMaybe<Scalars['String']['input']>;
  primaryIssueCategory?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewDecision?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCancelInviteArgs = {
  inviteId: Scalars['ID']['input'];
};


export type MutationsCancelMaintenancePlanArgs = {
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  maintenancePlanId: Scalars['ID']['input'];
};


export type MutationsCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationsCancelVendorSubcontractArgs = {
  input: CancelVendorSubcontractMutationInput;
};


export type MutationsCancelWorkOrderArgs = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  cancelReason?: InputMaybe<WorkOrderCancellationReason>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<WorkOrderCancellationSource>;
  workOrderId: Scalars['ID']['input'];
};


export type MutationsCaptureVisitNotesArgs = {
  input: CaptureVisitNotesInput;
};


export type MutationsChangePasswordArgs = {
  arguments: ChangePasswordArguments;
};


export type MutationsChangeTradesPlanArgs = {
  input: ChangeTradePlanInput;
};


export type MutationsChargePaymentMethodArgs = {
  input: ChargePaymentMethodInput;
};


export type MutationsChargeSubscriptionInvoicesArgs = {
  input: ChargeSubscriptionInvoicesMutationInput;
};


export type MutationsCheckUncheckWorkOrderTaskArgs = {
  input: CheckUncheckWorkOrderTaskInput;
};


export type MutationsCloseWorkOrderArgs = {
  input: CloseWorkOrderInput;
};


export type MutationsCompleteBillingAndPaymentInfoOnboardingStepArgs = {
  input: CompleteBillingAndPaymentInfoOnboardingStepMutationInput;
};


export type MutationsCompleteBillingEntityOnboardingStepArgs = {
  input: CompleteBillingEntityOnboardingStepMutationInput;
};


export type MutationsCompleteClientOnboardingArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationsCompleteFacilitiesOnboardingStepArgs = {
  input: CompleteFacilitiesOnboardingStepMutationInput;
};


export type MutationsCompleteGetStartedOnboardingStepArgs = {
  input: CompleteGetStartedOnboardingStepMutationInput;
};


export type MutationsCompleteInternalRequestTeamMemberAssignmentArgs = {
  input: CompleteInternalRequestTeamMemberAssignmentInput;
};


export type MutationsCompletePaymentInfoOnboardingStepArgs = {
  input: CompletePaymentInfoOnboardingStepMutationInput;
};


export type MutationsCompleteRatesOnboardingStepArgs = {
  input: CompleteRatesOnboardingStepMutationInput;
};


export type MutationsCompleteSelfServeOnboardingActionArgs = {
  input: CompleteSelfServeOnboardingActionMutationInput;
};


export type MutationsCompleteStaffOnboardingStepArgs = {
  input: CompleteStaffOnboardingStepMutationInput;
};


export type MutationsCompleteTradesSubscriptionOnboardingStepArgs = {
  input: CompleteTradesSubscriptionOnboardingStepMutationInput;
};


export type MutationsCompleteTroubleshootingSessionArgs = {
  input: CompleteTroubleshootingSessionMutationInput;
};


export type MutationsCompleteVendorOnboardingArgs = {
  input: CompleteVendorOnboardingMutationInput;
};


export type MutationsCompleteWorkOrderTeamMemberAssignmentArgs = {
  input: CompleteWorkOrderTeamMemberAssignmentInput;
};


export type MutationsConfirmPerUserDailyMenuFirstRunArgs = {
  input: ConfirmPerUserDailyMenuFirstRunMutationInput;
};


export type MutationsConfirmVendorAgreementArgs = {
  input: ConfirmVendorAgreementMutationInput;
};


export type MutationsConfirmVendorRequiredInfoArgs = {
  input: ConfirmVendorRequiredInfoMutationInput;
};


export type MutationsConvertTradesTrialArgs = {
  input: ConvertTradesTrialInput;
};


export type MutationsCreateActiveMaintenancePlanArgs = {
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int']['input'];
  contractEndDate: Scalars['Date']['input'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  maintenancePlanTypeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextWorkOrderCreationDate: Scalars['Date']['input'];
  offResqFacilityId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  scopeOfWork: Scalars['String']['input'];
  serviceFrequencyUnit: MaintenancePlanFrequencyUnit;
  serviceFrequencyValue: Scalars['Int']['input'];
  variablePricing?: InputMaybe<Scalars['Boolean']['input']>;
  vendorCompanyId: Scalars['ID']['input'];
};


export type MutationsCreateBrandArgs = {
  input: CreateBrandMutationInput;
};


export type MutationsCreateBudgetArgs = {
  input: CreateBudgetMutationInput;
};


export type MutationsCreateBusinessUnitArgs = {
  arguments: CreateBusinessUnitArguments;
};


export type MutationsCreateClientAdjustmentInvoiceArgs = {
  input: CreateClientAdjustmentInvoiceInput;
};


export type MutationsCreateClientAutoAdjustmentInvoiceArgs = {
  input: CreateClientAutoAdjustmentInvoiceMutationInput;
};


export type MutationsCreateCommentArgs = {
  contactReason?: InputMaybe<ContactReason>;
  contactSource?: InputMaybe<ContactSource>;
  message: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationsCreateContactInquiryInternalNoteArgs = {
  input: CreateContactInquiryInternalNoteMutationInput;
};


export type MutationsCreateControlCenterUserArgs = {
  input: CreateControlCenterUserMutationInput;
};


export type MutationsCreateCoordinatorArgs = {
  input: CreateCoordinatorMutationInput;
};


export type MutationsCreateCyovDispatchArgs = {
  input: CreateCyovDispatchInput;
};


export type MutationsCreateDeviceConfigsArgs = {
  input: CreateDeviceConfigsInput;
};


export type MutationsCreateDeviceDataExportArgs = {
  input: CreateDeviceDataExportInput;
};


export type MutationsCreateExternalBankAccountArgs = {
  accountNumber: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  routingNumber: Scalars['String']['input'];
  type: ExternalBankAccountType;
};


export type MutationsCreateFacilityArgs = {
  input: CreateFacilityInput;
};


export type MutationsCreateFacilityGroupArgs = {
  input: CreateFacilityGroupInput;
};


export type MutationsCreateFavouriteVendorConfigurationArgs = {
  input: CreateFavouriteVendorConfigurationInput;
};


export type MutationsCreateInitialSubscriptionArgs = {
  input: CreateInitialSubscriptionInput;
};


export type MutationsCreateInvoiceSetDisputeArgs = {
  input: CreateInvoiceSetDisputeMutationInput;
};


export type MutationsCreateInvoiceSetNoteArgs = {
  input: CreateInvoiceSetNoteMutationInput;
};


export type MutationsCreateJustifiWebComponentTokenArgs = {
  input: CreateJustifiWebComponentTokenMutationInput;
};


export type MutationsCreateLeadInboundRequestInternalNoteArgs = {
  input: CreateLeadInboundRequestInternalNoteMutationInput;
};


export type MutationsCreateMaintenancePlanArgs = {
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int']['input'];
  facilityId: Scalars['ID']['input'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String']['input'];
  maintenancePlanTypeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextWorkOrderCreationDate: Scalars['Date']['input'];
  opsOwnerId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceAfterMarkup?: InputMaybe<Scalars['Decimal']['input']>;
  priceBeforeMarkup?: InputMaybe<Scalars['Decimal']['input']>;
  scopeOfWork: Scalars['String']['input'];
  selfService?: InputMaybe<Scalars['Boolean']['input']>;
  serviceFrequencyUnit?: InputMaybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  subcontractVendorId?: InputMaybe<Scalars['ID']['input']>;
  templateLineItems?: InputMaybe<Array<LineItemInput>>;
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  templateVendorNotes?: InputMaybe<Scalars['String']['input']>;
  variablePricing: Scalars['Boolean']['input'];
  vendorCompanyId: Scalars['ID']['input'];
  vendorPreventiveMaintenanceRecommendationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateMarketArgs = {
  input: CreateMarketInput;
};


export type MutationsCreateMissingDataAlertTicketArgs = {
  input: CreateMissingDataAlertTicketInput;
};


export type MutationsCreateOffResqCustomerArgs = {
  input: CreateOffResqCustomerMutationInput;
};


export type MutationsCreateOffResqCustomerUserArgs = {
  input: CreateOffResqCustomerUserMutationInput;
};


export type MutationsCreateOffResqFacilityArgs = {
  input: CreateOffResqFacilityMutationInput;
};


export type MutationsCreateOffResqFacilityUserArgs = {
  input: CreateOffResqFacilityUserMutationInput;
};


export type MutationsCreateOffResqWorkOrderArgs = {
  input: CreateOffResqWorkOrderMutationInput;
};


export type MutationsCreateOrUpdateBusinessUnitOnboardingArgs = {
  input: CreateOrUpdateBusinessUnitOnboardingMutationInput;
};


export type MutationsCreateOriginalVendorInvoiceArgs = {
  input: CreateOriginalVendorInvoiceMutationInput;
};


export type MutationsCreatePartneredEstimateSubmissionFromBuilderArgs = {
  input: CreatePartneredEstimateSubmissionFromBuilderMutationInput;
};


export type MutationsCreatePartneredInvoiceSubmissionFromBuilderArgs = {
  input: CreatePartneredInvoiceSubmissionFromBuilderMutationInput;
};


export type MutationsCreatePaymentMethodArgs = {
  input: CreatePaymentMethodMutationInput;
};


export type MutationsCreatePmOneTimeWorkOrderArgs = {
  input: CreatePmOneTimeWorkOrderInput;
};


export type MutationsCreatePreventativeMaintenanceArgs = {
  input: CreatePreventativeMaintenanceInput;
};


export type MutationsCreatePriceBookCategoryArgs = {
  input: CreatePriceBookCategoryMutationInput;
};


export type MutationsCreatePriceBookItemArgs = {
  input: CreatePriceBookItemMutationInput;
};


export type MutationsCreateProjectArgs = {
  input: CreateProjectMutationInput;
};


export type MutationsCreateProposalCommentArgs = {
  input: CreateProposalCommentMutationInput;
};


export type MutationsCreateProtectionPlanEnrollmentArgs = {
  input: CreateProtectionPlanEnrollmentInput;
};


export type MutationsCreateQuoteArgs = {
  input: CreateQuoteMutationInput;
};


export type MutationsCreateQuoteFromBuilderArgs = {
  input: CreateQuoteFromBuilderMutationInput;
};


export type MutationsCreateQuoteSetOptionsArgs = {
  input: CreateQuoteSetOptionsInput;
};


export type MutationsCreateRecordOfWorkArgs = {
  input: CreateRecordOfWorkMutationInput;
};


export type MutationsCreateReleaseArgs = {
  input: CreateReleaseMutationInput;
};


export type MutationsCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


export type MutationsCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationsCreateRuleViolationsArgs = {
  input: CreateRuleViolationsMutationInput;
};


export type MutationsCreateRuleViolationsFeedbackArgs = {
  input: CreateRuleViolationsFeedbackInput;
};


export type MutationsCreateServiceOrderArgs = {
  input: CreateServiceOrderMutationInput;
};


export type MutationsCreateTechnicianUserArgs = {
  input: CreateTechnicianUserMutationInput;
};


export type MutationsCreateTradesCustomerInvoiceArgs = {
  input: CreateTradesCustomerInvoiceMutationInput;
};


export type MutationsCreateTroubleshootingSessionArgs = {
  input: CreateTroubleshootingSessionMutationInput;
};


export type MutationsCreateUpdateExternalReferenceArgs = {
  input: CreateUpdateExternalReferenceMutationInput;
};


export type MutationsCreateUpdatePayoutOfferArgs = {
  input: CreateUpdatePayoutOfferMutationInput;
};


export type MutationsCreateUpdateWorkOrderExpenseTypeArgs = {
  input: CreateUpdateWorkOrderExpenseTypeMutationInput;
};


export type MutationsCreateVendorArgs = {
  arguments: CreateVendorArguments;
};


export type MutationsCreateVendorAdjustmentInvoiceArgs = {
  adjustmentAmount: Scalars['Decimal']['input'];
  applyAsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  recordOfWorkId: Scalars['ID']['input'];
  taxRateIds: Array<Scalars['ID']['input']>;
};


export type MutationsCreateVendorAutoAdjustmentInvoiceArgs = {
  input: CreateVendorAutoAdjustmentInvoiceMutationInput;
};


export type MutationsCreateVendorBusinessProfileArgs = {
  input: CreateVendorBusinessProfileMutationInput;
};


export type MutationsCreateVendorInternalNoteArgs = {
  arguments: CreateVendorInternalNoteArguments;
};


export type MutationsCreateVendorInvoiceBatchArgs = {
  vendorInvoiceIds: Array<Scalars['ID']['input']>;
};


export type MutationsCreateVendorPreventiveMaintenanceRecommendationArgs = {
  input: CreateVendorPreventiveMaintenanceRecommendationMutationInput;
};


export type MutationsCreateVendorPromotionArgs = {
  input: CreateVendorPromotionMutationInput;
};


export type MutationsCreateVendorRankingForEquipmentArgs = {
  input: CreateVendorRankingForEquipmentMutationInput;
};


export type MutationsCreateVendorRankingForFacilityAndServiceCategoryArgs = {
  input: CreateVendorRankingForFacilityAndServiceCategoryMutationInput;
};


export type MutationsCreateVendorSubcontractArgs = {
  input: CreateVendorSubcontractMutationInput;
};


export type MutationsCreateVendorSubcontractPairingArgs = {
  input: CreateVendorSubcontractPairingMutationInput;
};


export type MutationsCreateVendorWebsiteArgs = {
  input: CreateVendorWebsiteMutationInput;
};


export type MutationsCreateVendorWorkOrderInternalNoteArgs = {
  input: CreateVendorWorkOrderInternalNoteInput;
};


export type MutationsCreateVisitReviewArgs = {
  outcome: VisitReviewOutcome;
  visitReviewRequestId: Scalars['ID']['input'];
};


export type MutationsCreateWebsiteAdvertisingCampaignArgs = {
  input: CreateWebsiteAdvertisingCampaignMutationInput;
};


export type MutationsCreateWorkOrderEscalationArgs = {
  input: CreateWorkOrderEscalationInput;
};


export type MutationsCreateWorkOrderInternalNoteArgs = {
  input: CreateWorkOrderInternalNoteInput;
};


export type MutationsCreateWorkOrderInvoiceSetArgs = {
  input: CreateWorkOrderInvoiceSetMutationInput;
};


export type MutationsCreateWorkOrderNoteArgs = {
  input: CreateWorkOrderNoteInput;
};


export type MutationsCreateWorkOrderReviewArgs = {
  arguments: CreateWorkOrderReviewArguments;
};


export type MutationsCreateWorkOrderV2Args = {
  input: CreateWorkOrderV2Input;
};


export type MutationsDeactivateEquipmentMutationArgs = {
  input: DeactivateEquipmentInput;
};


export type MutationsDeactivateFacilityArgs = {
  input: DeactivateFacilityInput;
};


export type MutationsDecideProposalArgs = {
  input: DecideProposalMutationInput;
};


export type MutationsDeclineOffResqVendorSubcontractArgs = {
  input: DeclineOffResqVendorSubcontractMutationInput;
};


export type MutationsDeclineVendorDispatchRequestArgs = {
  input: DeclineVendorDispatchRequestMutationInput;
};


export type MutationsDeclineVendorPreventiveMaintenanceRecommendationArgs = {
  input: DeclineVendorPreventiveMaintenanceRecommendationMutationInput;
};


export type MutationsDeleteAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationsDeleteBrandArgs = {
  input: DeleteBrandMutationInput;
};


export type MutationsDeleteBudgetArgs = {
  input: DeleteBudgetMutationInput;
};


export type MutationsDeleteBusinessUnitArgs = {
  input: DeleteBusinessUnitMutationInput;
};


export type MutationsDeleteClientManagedInvoiceArgs = {
  input: DeleteClientManagedInvoiceInput;
};


export type MutationsDeleteClientReportScheduleArgs = {
  input: DeleteClientReportScheduleMutationInput;
};


export type MutationsDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationsDeleteFacilityArgs = {
  input: DeleteFacilityInput;
};


export type MutationsDeleteFacilityGroupArgs = {
  input: DeleteFacilityGroupInput;
};


export type MutationsDeleteFavouriteVendorConfigurationArgs = {
  input: DeleteFavouriteVendorConfigurationInput;
};


export type MutationsDeleteGatewayArgs = {
  input: DeleteGatewayInput;
};


export type MutationsDeleteImageFromWorkOrderArgs = {
  imageId: Scalars['String']['input'];
};


export type MutationsDeleteInboundVendorInvoiceArgs = {
  input: DeleteInboundVendorInvoiceMutationInput;
};


export type MutationsDeleteInvoiceSetNoteArgs = {
  input: DeleteInvoiceSetNoteMutationInput;
};


export type MutationsDeleteOffResqWorkOrderArgs = {
  input: DeleteOffResqWorkOrderMutationInput;
};


export type MutationsDeletePartneredSubmissionArgs = {
  input: DeletePartneredSubmissionMutationInput;
};


export type MutationsDeletePreventativeMaintenanceArgs = {
  input: DeletePreventativeMaintenanceInput;
};


export type MutationsDeletePriceBookCategoryArgs = {
  input: DeletePriceBookCategoryMutationInput;
};


export type MutationsDeletePriceBookItemArgs = {
  input: DeletePriceBookItemMutationInput;
};


export type MutationsDeleteProposalCommentArgs = {
  input: DeleteProposalCommentMutationInput;
};


export type MutationsDeleteProtectionPlanEnrollmentArgs = {
  input: DeleteProtectionPlanEnrollmentInput;
};


export type MutationsDeleteRecordOfWorkArgs = {
  input: DeleteRecordOfWorkMutationInput;
};


export type MutationsDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationsDeleteSensorArgs = {
  input: DeleteSensorInput;
};


export type MutationsDeleteTestimonialArgs = {
  input: DeleteTestimonialMutationInput;
};


export type MutationsDeleteVendorFacilityInsuranceDocumentArgs = {
  input: DeleteVendorFacilityInsuranceDocumentMutationInput;
};


export type MutationsDeleteVendorPromotionArgs = {
  input: DeleteVendorPromotionMutationInput;
};


export type MutationsDeleteVendorRankingArgs = {
  input: DeleteVendorRankingMutationInput;
};


export type MutationsDeleteVendorRankingForFacilityAndServiceCategoryArgs = {
  input: DeleteVendorRankingForFacilityAndServiceCategoryMutationInput;
};


export type MutationsDeleteVendorReportScheduleArgs = {
  input: DeleteVendorReportScheduleMutationInput;
};


export type MutationsDeleteVendorWorkOrderInternalNoteArgs = {
  input: DeleteVendorWorkOrderInternalNoteInput;
};


export type MutationsDeleteWorkOrderInternalNoteArgs = {
  input: DeleteWorkOrderInternalNoteInput;
};


export type MutationsDismissArgs = {
  input: DismissMutationInput;
};


export type MutationsDismissWorkOrderNoteMetadataArgs = {
  input: DismissWorkOrderNoteMetadataMutationInput;
};


export type MutationsDisputeWorkOrderArgs = {
  arguments: DisputeWorkOrderArguments;
};


export type MutationsEditBlockedGroupsArgs = {
  input: EditBlockedGroupsInput;
};


export type MutationsEditClientOrganizationArgs = {
  contractSignedOn?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  isAutopay?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectVendorPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  lendingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markup: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  offlinePaymentMethod?: InputMaybe<OfflinePaymentMethods>;
  paymentMethod: PaymentMethodType;
  qrSubmissionAuthenticationMode?: InputMaybe<QrSubmissionAuthenticationMode>;
  reportingManagerId?: InputMaybe<Scalars['ID']['input']>;
  sensitivity?: InputMaybe<Sensitivity>;
  strategy?: InputMaybe<QuoteApprovalStrategy>;
  successOwnerId?: InputMaybe<Scalars['ID']['input']>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsEditClientOrganizationMemberArgs = {
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsEditClientVendorRelationshipInviteArgs = {
  input: EditClientVendorRelationshipInviteInput;
};


export type MutationsEditEquipmentArgs = {
  barCode: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  equipmentId: Scalars['ID']['input'];
  historicalSpend?: InputMaybe<Scalars['Decimal']['input']>;
  installedOn?: InputMaybe<Scalars['Date']['input']>;
  location: Scalars['String']['input'];
  mainImage?: InputMaybe<Image>;
  manufacturer: Scalars['String']['input'];
  modelNo: Scalars['String']['input'];
  modelTagImage?: InputMaybe<Image>;
  name: Scalars['String']['input'];
  photos?: InputMaybe<Array<InputMaybe<Image>>>;
  serialNo: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']['input']>;
  warrantyNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsEditFavouriteVendorConfigurationArgs = {
  input: EditFavouriteVendorConfigurationInput;
};


export type MutationsEditOrgOwnerArgs = {
  input: EditOrgOwnerMutationInput;
};


export type MutationsEditOrganizationFeaturesArgs = {
  input: EditOrganizationFeaturesMutationInput;
};


export type MutationsEditPreventativeMaintenanceArgs = {
  input: EditPreventativeMaintenanceInput;
};


export type MutationsEditQuoteArgs = {
  input: EditQuoteMutationInput;
};


export type MutationsEditUserDjangoGroupsArgs = {
  input: EditUserDjangoGroupsMutationInput;
};


export type MutationsEditVendorUserDetailsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationsEditWorkOrderArgs = {
  input: EditWorkOrderInput;
};


export type MutationsEnableVendorNoraEmailForwardingArgs = {
  input: EnableVendorNoraEmailForwardingMutationInput;
};


export type MutationsEndActivityArgs = {
  input: EndActivityInput;
};


export type MutationsEndOffResqWorkOrderVisitArgs = {
  input: EndOffResqWorkOrderVisitMutationInput;
};


export type MutationsEndVisitArgs = {
  input: EndVisitInput;
};


export type MutationsFinanceInvoiceArgs = {
  input: FinanceInvoiceMutationInput;
};


export type MutationsForceLogoutUserArgs = {
  input: ForceLogoutUserMutationInput;
};


export type MutationsForceWorkOrderCompletionArgs = {
  input: ForceWorkOrderCompletionMutationInput;
};


export type MutationsGenerateKustomerLoginTokenArgs = {
  input: GenerateKustomerLoginTokenInput;
};


export type MutationsGenerateMagicLinkTokenArgs = {
  input: GenerateMagicLinkTokenMutationInput;
};


export type MutationsGenerateOffResqCustomerPortalLinkArgs = {
  input: GenerateOffResqCustomerPortalLinkInput;
};


export type MutationsGenerateVendorInvoicePdfArgs = {
  input: GenerateVendorInvoicePdfInput;
};


export type MutationsImportAccountingIntegrationCustomersArgs = {
  input: ImportAccountingIntegrationCustomersMutationInput;
};


export type MutationsImportBankStatementsArgs = {
  input: ImportBankStatementsMutationInput;
};


export type MutationsInitiateMarketplaceOnboardingArgs = {
  input: InitiateMarketplaceOnboardingMutationInput;
};


export type MutationsInitiateVendorFacilityInviteArgs = {
  input: InitiateVendorFacilityInviteMutationInput;
};


export type MutationsInviteMemberToClientOrganizationArgs = {
  assignedFacilityGroupIds: Array<Scalars['ID']['input']>;
  assignedRoleIds: Array<Scalars['ID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteType?: InputMaybe<InviteType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  noExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsInviteMemberToVendorArgs = {
  arguments: InviteMemberToVendorArguments;
};


export type MutationsInviteOwnerToOnboardingArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerFirstName: Scalars['String']['input'];
  ownerLastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsLaunchGoogleAdsSetupArgs = {
  input: LaunchGoogleAdsSetupInput;
};


export type MutationsManageOffResqNotificationSettingsArgs = {
  input: ManageOffResqNotificationSettingsMutationInput;
};


export type MutationsMarkApBatchesAsPaidArgs = {
  input: MarkApBatchesAsPaidMutationInput;
};


export type MutationsMarkApBatchesAsUnpaidArgs = {
  input: MarkApBatchesAsUnpaidMutationInput;
};


export type MutationsMarkBankAccountRecordProcessedArgs = {
  input: MarkBankAccountRecordProcessedMutationInput;
};


export type MutationsMarkClientManagedInvoicesAsPaidArgs = {
  input: MarkClientManagedInvoicesAsPaidInput;
};


export type MutationsMarkClientManagedInvoicesAsUnpaidArgs = {
  input: MarkClientManagedInvoicesAsUnpaidInput;
};


export type MutationsMarkInboxItemReadArgs = {
  inboxItemId: Scalars['ID']['input'];
};


export type MutationsMarkInvoiceEmailRecordProcessedArgs = {
  input: MarkInvoiceEmailRecordProcessedMutationInput;
};


export type MutationsMarkLeadInboundRequestDoneArgs = {
  input: MarkLeadInboundRequestDoneMutationInput;
};


export type MutationsMarkLeadInboundRequestReadArgs = {
  input: MarkLeadInboundRequestReadMutationInput;
};


export type MutationsMarkLendingOnboardingBannerShownArgs = {
  input: MarkLendingOnboardingBannerShownMutationInput;
};


export type MutationsMarkNoraCallEvaluationReviewedArgs = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  noraCallEvaluationId: Scalars['ID']['input'];
  reviewDecision: NoraCallEvaluationReviewDecision;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsMarkOffResqVendorInvoiceAsPaidArgs = {
  input: MarkOffResqVendorInvoiceAsPaidMutationInput;
};


export type MutationsMarkRecordOfWorkAsAwaitingVendorOnboardingArgs = {
  input: MarkRecordOfWorkAsAwaitingVendorOnboardingMutationInput;
};


export type MutationsMarkSubcontractSettlementInvoiceAsPaidExternallyArgs = {
  input: MarkSubcontractSettlementInvoiceAsPaidExternallyMutationInput;
};


export type MutationsMarkSubcontractSettlementInvoiceAsUnpaidArgs = {
  input: MarkSubcontractSettlementInvoiceAsUnpaidMutationInput;
};


export type MutationsMarkSubcontractSettlementInvoicesAsPaidExternallyArgs = {
  input: MarkSubcontractSettlementInvoicesAsPaidExternallyMutationInput;
};


export type MutationsMarkWorkOrderAsAwaitingPaymentArgs = {
  input: MarkWorkOrderAsAwaitingPaymentInput;
};


export type MutationsMarkWorkOrderTeamMemberAssignmentAsUnresolvedArgs = {
  input: MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput;
};


export type MutationsMergeApBatchesArgs = {
  input: MergeApBatchesMutationInput;
};


export type MutationsMigrateClientToPerUserPricingArgs = {
  input: MigrateClientToPerUserPricingMutationInput;
};


export type MutationsMoveAllEquipmentToAnotherFacilityArgs = {
  input: MoveAllEquipmentToAnotherFacilityInput;
};


export type MutationsMoveEquipmentToFacilityArgs = {
  input: MoveEquipmentToFacilityInput;
};


export type MutationsMoveWorkOrderToAwaitingRecordOfWorkArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type MutationsNotifyOffResqWorkOrderOnMyWayArgs = {
  input: NotifyOffResqWorkOrderOnMyWayMutationInput;
};


export type MutationsNotifyWorkOrderOnMyWayArgs = {
  input: NotifyWorkOrderOnMyWayMutationInput;
};


export type MutationsOverrideLocationAddressArgs = {
  input: OverrideLocationAddressMutationInput;
};


export type MutationsPerformVendorWebsiteMonitorDomainActionArgs = {
  input: PerformVendorWebsiteMonitorDomainActionMutationInput;
};


export type MutationsPersistGoogleAdsAdvertiserGuideAcceptanceArgs = {
  input: PersistGoogleAdsAdvertiserGuideAcceptanceInput;
};


export type MutationsPolishAboutUsTextArgs = {
  input: PolishAboutUsTextMutationInput;
};


export type MutationsPrefillOffResqEstimateFromFileArgs = {
  input: PrefillOffResqEstimateFromFileMutationInput;
};


export type MutationsPrefillPartneredEstimateFromFileArgs = {
  input: PrefillPartneredEstimateFromFileMutationInput;
};


export type MutationsPrefillPartneredInvoiceFromFileArgs = {
  input: PrefillPartneredInvoiceFromFileMutationInput;
};


export type MutationsPreviewAiTextSuggestionsArgs = {
  input: PreviewAiTextSuggestionsInput;
};


export type MutationsPreviewPerUserSubscriptionArgs = {
  input: PreviewPerUserSubscriptionInput;
};


export type MutationsPreviewVendorNoraEmailForwardingArgs = {
  input: PreviewVendorNoraEmailForwardingMutationInput;
};


export type MutationsPrewarmVendorWebsiteGoogleAdsDraftArgs = {
  input: PrewarmVendorWebsiteGoogleAdsDraftMutationInput;
};


export type MutationsProposalArgs = {
  input: ProposalMutationInput;
};


export type MutationsPurchaseReceptionistPhoneNumberArgs = {
  input: PurchaseReceptionistPhoneNumberMutationInput;
};


export type MutationsRaiseApprovedSpendDuringWorkOrderSubmissionArgs = {
  input: RaiseApprovedSpendDuringWorkOrderSubmissionInput;
};


export type MutationsReactivateEquipmentMutationArgs = {
  input: ReactivateEquipmentInput;
};


export type MutationsReactivateFacilityArgs = {
  input: ReactivateFacilityMutationInput;
};


export type MutationsReassignWorkOrderVendorArgs = {
  input: ReassignWorkOrderVendorInput;
};


export type MutationsRecordAdBannerClickArgs = {
  input: RecordAdBannerClickMutationInput;
};


export type MutationsRecordClientVendorPromotionViewArgs = {
  input: RecordClientVendorPromotionViewMutationInput;
};


export type MutationsRecordLeadInboundRequestConversionArgs = {
  input: RecordLeadInboundRequestConversionMutationInput;
};


export type MutationsRecordPaymentArgs = {
  input: RecordPaymentInput;
};


export type MutationsRecordSuccessfulTroubleshootingArgs = {
  input: RecordSuccessfulTroubleshootingMutationInput;
};


export type MutationsRecordVendorPromotionViewArgs = {
  input: RecordVendorPromotionViewMutationInput;
};


export type MutationsRefundBatchPaymentArgs = {
  input: RefundBatchPaymentMutationInput;
};


export type MutationsRegenerateRsgCompletionReportArgs = {
  input: RegenerateRsgCompletionReportMutationInput;
};


export type MutationsRegenerateVendorCoverImageArgs = {
  input: RegenerateVendorCoverImageMutationInput;
};


export type MutationsReinitializeSubscriptionArgs = {
  input: ReinitializeSubscriptionInput;
};


export type MutationsRejectClientWorkOrderArgs = {
  input: RejectClientWorkOrderInput;
};


export type MutationsRejectLeadInboundRequestArgs = {
  input: RejectLeadInboundRequestMutationInput;
};


export type MutationsRejectQuoteSetArgs = {
  input: RejectQuoteSetInput;
};


export type MutationsRejectQuoteSetOptionForSpendArgs = {
  input: RejectQuoteSetOptionForSpendInput;
};


export type MutationsRejectVendorEquipmentCapabilitySuggestionArgs = {
  input: RejectVendorEquipmentCapabilitySuggestionMutationInput;
};


export type MutationsRemindFacilityPaymentContactToAddPaymentMethodArgs = {
  input: RemindFacilityPaymentContactToAddPaymentMethodMutationInput;
};


export type MutationsRemovePaymentMethodArgs = {
  input: RemovePaymentMethodMutationInput;
};


export type MutationsRemoveQuoteArgs = {
  arguments: RemoveQuoteArguments;
};


export type MutationsRemoveQuoteSetOptionArgs = {
  input: RemoveQuoteSetOptionInput;
};


export type MutationsRemoveUpcomingAllocationArgs = {
  input: RemoveUpcomingAllocationMutationInput;
};


export type MutationsRemoveUserFromClientOrganizationArgs = {
  clientOrganizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationsRemoveUsersFromRoleArgs = {
  input: RemoveUsersFromRoleMutationInput;
};


export type MutationsRemoveVendorMemberArgs = {
  arguments: RemoveVendorMemberArguments;
};


export type MutationsRemoveVendorPayoutInfoArgs = {
  input: RemoveVendorPayoutInfoMutationInput;
};


export type MutationsRemoveWorkOrdersFromProjectArgs = {
  input: RemoveWorkOrdersFromProjectMutationInput;
};


export type MutationsReopenLeadInboundRequestArgs = {
  input: ReopenLeadInboundRequestMutationInput;
};


export type MutationsReplaceDisputedInvoiceArgs = {
  input: ReplaceDisputedInvoiceMutationInput;
};


export type MutationsReplaceVendorSlaPolicyArgs = {
  input: ReplaceVendorSlaPolicyMutationInput;
};


export type MutationsRequestAutopayChangesArgs = {
  input: RequestAutopayChangesMutationInput;
};


export type MutationsRequestDispatchChangesArgs = {
  input: RequestDispatchChangesMutationInput;
};


export type MutationsRequestEstimateArgs = {
  input: RequestEstimateMutationInput;
};


export type MutationsRequestGoogleAdsGrowthExpertArgs = {
  input: RequestGoogleAdsGrowthExpertMutationInput;
};


export type MutationsRequestMaintenancePlanArgs = {
  input: RequestMaintenancePlanMutationInput;
};


export type MutationsRequestMaintenancePlanDateChangeArgs = {
  maintenancePlanId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  requestedDate: Scalars['Date']['input'];
};


export type MutationsRequestNewCapexProjectArgs = {
  input: RequestNewCapexProjectMutationInput;
};


export type MutationsRequestPlannedMaintenanceQuoteArgs = {
  input: RequestPlannedMaintenanceQuoteMutationInput;
};


export type MutationsRequestQuoteArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  maintenancePlanTypeId: Scalars['ID']['input'];
};


export type MutationsRequestRsgEstimateArgs = {
  input: RequestRsgEstimateInput;
};


export type MutationsRerunNoraCallEvaluationArgs = {
  noraCallEvaluationId: Scalars['ID']['input'];
};


export type MutationsRescheduleAppointmentArgs = {
  input: RescheduleAppointmentInput;
};


export type MutationsRescheduleInternalAppointmentArgs = {
  input: RescheduleInternalAppointmentInput;
};


export type MutationsResendClientVendorRelationshipInviteArgs = {
  input: ResendClientVendorRelationshipInviteInput;
};


export type MutationsResetQuoteSetArgs = {
  input: ResetQuoteSetInput;
};


export type MutationsResolveFacilityExpansionArgs = {
  input: ResolveFacilityExpansionMutationInput;
};


export type MutationsResolveFlaggedInvoiceArgs = {
  input: ResolveFlaggedInvoiceInput;
};


export type MutationsResolveGoogleAdsLocationGeometriesArgs = {
  input: ResolveGoogleAdsLocationGeometriesMutationInput;
};


export type MutationsResolveIncidentsArgs = {
  input: ResolveIncidentsInput;
};


export type MutationsResolveInvoiceSetDisputeArgs = {
  input: ResolveInvoiceSetDisputeMutationInput;
};


export type MutationsResolveWorkOrderDisputeArgs = {
  arguments: ResolveWorkOrderDisputeArguments;
};


export type MutationsResolveWorkOrderEscalationArgs = {
  input: ResolveWorkOrderEscalationInput;
};


export type MutationsResubmitGoogleAdsBillingPaymentArgs = {
  input: ResubmitGoogleAdsBillingPaymentMutationInput;
};


export type MutationsRetryInvoiceBatchChargeArgs = {
  input: RetryInvoiceBatchChargeMutationInput;
};


export type MutationsRetrySubscriptionPaymentArgs = {
  input: RetrySubscriptionPaymentMutationInput;
};


export type MutationsReverseClientInvoicePaymentArgs = {
  input: ReverseClientInvoicePaymentMutationInput;
};


export type MutationsRevokeClientVendorRelationshipInviteArgs = {
  input: RevokeClientVendorRelationshipInviteInput;
};


export type MutationsRevokeVendorSubcontractPairingArgs = {
  input: RevokeVendorSubcontractPairingMutationInput;
};


export type MutationsSaveRecordOfWorkArgs = {
  arguments: SaveRecordOfWorkArguments;
};


export type MutationsSaveReviewedOffResqWorkOrderVisitNotesArgs = {
  input: SaveReviewedOffResqWorkOrderVisitNotesMutationInput;
};


export type MutationsSaveReviewedVisitNotesArgs = {
  input: SaveReviewedVisitNotesInput;
};


export type MutationsSaveVendorBrandLogoArgs = {
  input: SaveVendorBrandLogoMutationInput;
};


export type MutationsSaveVendorCoverImageArgs = {
  input: SaveVendorCoverImageMutationInput;
};


export type MutationsSaveVendorOrderArgs = {
  input: SaveVendorOrderMutationInput;
};


export type MutationsSaveVendorRankingForFacilityAndServiceCategoryOrderArgs = {
  input: SaveVendorRankingForFacilityAndServiceCategoryOrderMutationInput;
};


export type MutationsSaveVendorWebsiteGoogleAdsBillingConfigArgs = {
  input: SaveVendorWebsiteGoogleAdsBillingConfigMutationInput;
};


export type MutationsSaveVendorWebsiteGoogleAdsDraftArgs = {
  input: SaveVendorWebsiteGoogleAdsDraftMutationInput;
};


export type MutationsScheduleInternalAppointmentArgs = {
  input: ScheduleInternalAppointmentInput;
};


export type MutationsScheduleVendorNoraConfigurationInterviewArgs = {
  input: ScheduleVendorNoraConfigurationInterviewMutationInput;
};


export type MutationsSearchGoogleAdsLocationTargetsArgs = {
  input: SearchGoogleAdsLocationTargetsMutationInput;
};


export type MutationsSelectQuoteSetOptionArgs = {
  input: SelectQuoteSetOptionInput;
};


export type MutationsSendInviteSmsArgs = {
  inviteId: Scalars['ID']['input'];
};


export type MutationsSendProposalReminderArgs = {
  input: SendProposalReminderMutationInput;
};


export type MutationsSendReportArgs = {
  input: SendReportInput;
};


export type MutationsSendVendorEmailNotificationArgs = {
  input: SendVendorEmailNotificationInput;
};


export type MutationsSendVendorIntroEmailArgs = {
  input: SendVendorIntroEmailMutationInput;
};


export type MutationsSendVendorPromoEmailArgs = {
  input: SendVendorPromoEmailMutationInput;
};


export type MutationsSendVendorSubscriptionPaymentLinkArgs = {
  input: SendVendorSubscriptionPaymentLinkMutationInput;
};


export type MutationsSendWelcomeEmailArgs = {
  input: SendWelcomeEmailMutationInput;
};


export type MutationsSetEntityPinnedArgs = {
  input: SetEntityPinnedMutationInput;
};


export type MutationsSetEstimatedTimeOfArrivalSourcingPartsArgs = {
  input: SetEstimatedTimeOfArrivalSourcingPartsMutationInput;
};


export type MutationsSetGoogleAdsCampaignBudgetArgs = {
  input: SetGoogleAdsCampaignBudgetMutationInput;
};


export type MutationsSetGoogleAdsCampaignStatusArgs = {
  input: SetGoogleAdsCampaignStatusMutationInput;
};


export type MutationsSetReceptionistEnabledArgs = {
  input: SetReceptionistEnabledMutationInput;
};


export type MutationsSetReceptionistTransferArgs = {
  input: SetReceptionistTransferMutationInput;
};


export type MutationsSetSensorConfigStateArgs = {
  input: SetSensorConfigStateInput;
};


export type MutationsSetSubscriptionAddonsArgs = {
  input: SetSubscriptionAddonsInput;
};


export type MutationsSetUserNotificationPreferenceArgs = {
  input: SetUserNoficationPreferenceMutationInput;
};


export type MutationsSetVendorAgreementPlansArgs = {
  input: SetVendorAgreementPlansMutationInput;
};


export type MutationsSetVendorSubscriptionPaymentMethodArgs = {
  input: SetVendorSubscriptionPaymentMethodMutationInput;
};


export type MutationsSetWebsiteAdvertisingCampaignDailyBudgetArgs = {
  input: SetWebsiteAdvertisingCampaignDailyBudgetMutationInput;
};


export type MutationsSetupPreAuthorizedDebitArgs = {
  input: SetupPreAuthorizedDebitMutationInput;
};


export type MutationsSkipOnboardingStepArgs = {
  input: SkipOnboardingStepMutationInput;
};


export type MutationsSkipWorkOrderReviewArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type MutationsSnoozeArgs = {
  input: SnoozeMutationInput;
};


export type MutationsSnoozeIncidentsArgs = {
  input: SnoozeIncidentsInput;
};


export type MutationsSnoozeReviewsArgs = {
  input: SnoozeReviewsInput;
};


export type MutationsStandaloneQuoteActionArgs = {
  input: StandaloneQuoteActionMutationInput;
};


export type MutationsStartAppointmentActivityArgs = {
  input: StartAppointmentActivityInput;
};


export type MutationsStartChooseVendorActivityArgs = {
  input: StartChooseVendorActivityInput;
};


export type MutationsStartDispatchActivityArgs = {
  input: StartDispatchActivityInput;
};


export type MutationsStartFindingQuoteActivityArgs = {
  input: StartFindingQuoteActivityInput;
};


export type MutationsStartOffResqWorkOrderVisitArgs = {
  input: StartOffResqWorkOrderVisitMutationInput;
};


export type MutationsStartOnHoldActivityArgs = {
  input: StartOnHoldActivityInput;
};


export type MutationsStartOrganizationSubscriptionArgs = {
  input: StartOrganizationSubscriptionMutationInput;
};


export type MutationsStartOverdueInvoicesCalldownArgs = {
  input: StartOverdueInvoicesCalldownInput;
};


export type MutationsStartPerUserSubscriptionArgs = {
  input: StartPerUserSubscriptionInput;
};


export type MutationsStartResqReviewActivityArgs = {
  input: StartResqReviewActivityInput;
};


export type MutationsStartSchedulingActivityArgs = {
  input: StartSchedulingActivityInput;
};


export type MutationsStartSchedulingCalldownArgs = {
  input: StartSchedulingCalldownInput;
};


export type MutationsStartSiteVisitActivityArgs = {
  input: StartSiteVisitActivityInput;
};


export type MutationsStartSourcingPartsActivityArgs = {
  input: StartSourcingPartsActivityInput;
};


export type MutationsStartSubscriptionArgs = {
  input: StartSubscriptionInput;
};


export type MutationsStartVisitArgs = {
  input: StartVisitMutationInput;
};


export type MutationsStopOrganizationSubscriptionsArgs = {
  input: DeactivateOrganizationSubscriptionsInput;
};


export type MutationsSubmitBusinessInformationArgs = {
  input: SubmitBusinessInformationInput;
};


export type MutationsSubmitOffResqVendorInvoiceArgs = {
  input: SubmitOffResqVendorInvoiceMutationInput;
};


export type MutationsSubmitQuoteFeedbackArgs = {
  arguments: SubmitQuoteFeedbackArguments;
};


export type MutationsSubmitRecordOfWorkArgs = {
  input: SubmitRecordOfWorkInput;
};


export type MutationsSubmitVendorInvoiceArgs = {
  arguments: SubmitVendorInvoiceMutationArguments;
};


export type MutationsSubmitVendorWebsiteBuilderSurveyArgs = {
  input: SubmitVendorWebsiteBuilderSurveyMutationInput;
};


export type MutationsSubmitWorkOrderArgs = {
  input: SubmitWorkOrderInput;
};


export type MutationsSubmitWorkOrderForApprovalArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type MutationsSubscribeToWorkOrderNotesArgs = {
  input: SubscribeToWorkOrderNotesInput;
};


export type MutationsTerminateUserSessionArgs = {
  input: TerminateUserSessionMutationInput;
};


export type MutationsTriggerSampleNotificationArgs = {
  input: TriggerSampleNotificationInput;
};


export type MutationsUnapproveRecordOfWorkArgs = {
  input: UnapproveRecordOfWorkMutationInput;
};


export type MutationsUnarchiveReportTemplateArgs = {
  input: UnarchiveReportTemplateInput;
};


export type MutationsUnassignedWorkOrderFromVendorCompanyArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type MutationsUnblockApArgs = {
  input: UnblockApMutationInput;
};


export type MutationsUnblockVendorArgs = {
  clientOrganizationId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};


export type MutationsUncancelWorkOrderArgs = {
  arguments: UncancelWorkOrderArguments;
};


export type MutationsUnsubscribeFromWorkOrderNotesArgs = {
  input: UnsubscribeFromWorkOrderNotesInput;
};


export type MutationsUpdateApBatchArgs = {
  input: UpdateApBatchMutationInput;
};


export type MutationsUpdateBankAccountRecordNotesArgs = {
  input: UpdateBankAccountRecordNotesMutationInput;
};


export type MutationsUpdateBatchPaymentArgs = {
  input: UpdateBatchPaymentMutationInput;
};


export type MutationsUpdateBrandArgs = {
  input: UpdateBrandMutationInput;
};


export type MutationsUpdateBudgetArgs = {
  input: UpdateBudgetMutationInput;
};


export type MutationsUpdateBusinessUnitArgs = {
  arguments: UpdateBusinessUnitArguments;
};


export type MutationsUpdateBusinessUnitSubscriptionPaymentMethodArgs = {
  input: UpdateBusinessUnitSubscriptionPaymentMethodMutationInput;
};


export type MutationsUpdateClientManagedInvoiceArgs = {
  input: UpdateClientManagedInvoiceInput;
};


export type MutationsUpdateClientMatchingProfileArgs = {
  input: UpdateClientMatchingProfileInput;
};


export type MutationsUpdateClientOrgSensitivityArgs = {
  input: UpdateClientOrgSensitivityMutationInput;
};


export type MutationsUpdateClientOrganizationStatusArgs = {
  input: UpdateClientOrganizationStatusMutationInput;
};


export type MutationsUpdateClientReportScheduleArgs = {
  input: UpdateClientReportScheduleMutationInput;
};


export type MutationsUpdateClientVendorRelationshipPaymentTermsArgs = {
  input: UpdateClientVendorRelationshipPaymentTermsInput;
};


export type MutationsUpdateContactInquiryArgs = {
  input: UpdateContactInquiryMutationInput;
};


export type MutationsUpdateDeviceArgs = {
  buildType?: InputMaybe<Scalars['String']['input']>;
  device: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  expoProjectId?: InputMaybe<Scalars['String']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  pushNotificationService?: InputMaybe<Scalars['String']['input']>;
  pushUserType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsUpdateDeviceConfigsArgs = {
  input: UpdateDeviceConfigsInput;
};


export type MutationsUpdateDispatchMethodPreferenceArgs = {
  input: UpdateDispatchMethodPreferenceInput;
};


export type MutationsUpdateExternalBankAccountArgs = {
  accountNumber: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  externalBankAccountId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  routingNumber: Scalars['String']['input'];
  type: ExternalBankAccountType;
};


export type MutationsUpdateExternalExpenseArgs = {
  input: UpdateExternalExpenseMutationInput;
};


export type MutationsUpdateFacilityArgs = {
  arguments?: InputMaybe<UpdateFacilityArguments>;
};


export type MutationsUpdateFacilityAllowedServiceCategoriesArgs = {
  input: UpdateFacilityAllowedServiceCategoriesMutationInput;
};


export type MutationsUpdateFacilityGroupArgs = {
  input: UpdateFacilityGroupInput;
};


export type MutationsUpdateFacilityGroupOpsOwnerMutationArgs = {
  input: UpdateFacilityGroupOpsOwnerInput;
};


export type MutationsUpdateFavouriteVendorInviteSubscriptionArgs = {
  input: UpdateFavouriteVendorInviteSubscriptionMutationInput;
};


export type MutationsUpdateGlCodesArgs = {
  input: UpdateGlCodesMutationInput;
};


export type MutationsUpdateGoogleAdsCampaignLocationTargetsArgs = {
  input: UpdateGoogleAdsCampaignLocationTargetsMutationInput;
};


export type MutationsUpdateInboundInvoiceExtractionArgs = {
  input: UpdateInboundInvoiceExtractionInput;
};


export type MutationsUpdateInternalRequestStatusArgs = {
  input: UpdateInternalRequestStatusInput;
};


export type MutationsUpdateInternalRequestTeamMemberAssignmentsArgs = {
  input: UpdateInternalRequestTeamMemberAssignmentsInput;
};


export type MutationsUpdateInvoiceApprovalSettingsArgs = {
  input: UpdateInvoiceApprovalSettingsInput;
};


export type MutationsUpdateMaintenancePlanArgs = {
  billingFrequencyUnit: MaintenancePlanFrequencyUnit;
  billingFrequencyValue: Scalars['Int']['input'];
  initialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus;
  internalNotes: Scalars['String']['input'];
  maintenancePlanId: Scalars['ID']['input'];
  maintenancePlanTypeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextWorkOrderCreationDate: Scalars['Date']['input'];
  opsOwnerId?: InputMaybe<Scalars['ID']['input']>;
  priceAfterMarkup: Scalars['Decimal']['input'];
  priceBeforeMarkup: Scalars['Decimal']['input'];
  scopeOfWork: Scalars['String']['input'];
  selfService?: InputMaybe<Scalars['Boolean']['input']>;
  serviceFrequencyUnit?: InputMaybe<MaintenancePlanFrequencyUnit>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  subcontractVendorId?: InputMaybe<Scalars['ID']['input']>;
  templateLineItems?: InputMaybe<Array<LineItemInput>>;
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  templateVendorNotes?: InputMaybe<Scalars['String']['input']>;
  variablePricing: Scalars['Boolean']['input'];
  vendorCompanyId: Scalars['ID']['input'];
  vendorPreventiveMaintenanceRecommendationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateMaintenancePlanAutoRenewArgs = {
  autoRenew: Scalars['Boolean']['input'];
  maintenancePlanId: Scalars['ID']['input'];
};


export type MutationsUpdateMaintenancePlanNextWorkOrderCreationDateArgs = {
  maintenancePlanId: Scalars['ID']['input'];
  nextWorkOrderCreationDate: Scalars['Date']['input'];
};


export type MutationsUpdateMarketArgs = {
  input: UpdateMarketInput;
};


export type MutationsUpdateOffResqCustomerArgs = {
  input: UpdateOffResqCustomerMutationInput;
};


export type MutationsUpdateOffResqCustomerUserArgs = {
  input: UpdateOffResqCustomerUserMutationInput;
};


export type MutationsUpdateOffResqFacilityArgs = {
  input: UpdateOffResqFacilityMutationInput;
};


export type MutationsUpdateOffResqFacilityUserArgs = {
  input: UpdateOffResqFacilityUserMutationInput;
};


export type MutationsUpdateOffResqWorkOrderArgs = {
  input: UpdateOffResqWorkOrderMutationInput;
};


export type MutationsUpdateOrganizationSubscriptionArgs = {
  input: UpdateOrganizationSubscriptionMutationInput;
};


export type MutationsUpdatePaymentMethodDefaultArgs = {
  input: UpdatePaymentMethodDefaultMutationInput;
};


export type MutationsUpdatePerUserCountArgs = {
  input: UpdatePerUserCountInput;
};


export type MutationsUpdatePerUserSubscriptionGlCodeArgs = {
  input: UpdatePerUserSubscriptionGlCodeInput;
};


export type MutationsUpdatePreventativeMaintenanceTaskListItemsArgs = {
  input: UpdatePreventativeMaintenanceTaskListItemsInput;
};


export type MutationsUpdatePriceBookCategoryArgs = {
  input: UpdatePriceBookCategoryMutationInput;
};


export type MutationsUpdatePriceBookItemArgs = {
  input: UpdatePriceBookItemMutationInput;
};


export type MutationsUpdatePriceRateOverridesArgs = {
  input: UpdatePriceRateOverridesMutationInput;
};


export type MutationsUpdateProjectArgs = {
  input: UpdateProjectMutationInput;
};


export type MutationsUpdateProtectionPlanEnrollmentArgs = {
  input: UpdateProtectionPlanEnrollmentInput;
};


export type MutationsUpdateQuoteAcceptanceSettingsArgs = {
  input: UpdateQuoteAcceptanceSettingsInput;
};


export type MutationsUpdateQuoteApprovalThresholdsArgs = {
  input: UpdateQuoteApprovalThresholdsInput;
};


export type MutationsUpdateReleaseArgs = {
  input: UpdateReleaseMutationInput;
};


export type MutationsUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationsUpdateRevenueShareOverridesArgs = {
  input: UpdateRevenueShareOverridesMutationInput;
};


export type MutationsUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationsUpdateServiceCategoriesArgs = {
  input: UpdateServiceCategoriesInput;
};


export type MutationsUpdateSpendApprovalPreferencesArgs = {
  input: UpdateSpendApprovalPreferencesInput;
};


export type MutationsUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationsUpdateSubscriptionBusinessUnitArgs = {
  input: UpdateSubscriptionBusinessUnitInput;
};


export type MutationsUpdateSubscriptionPaymentMethodArgs = {
  input: UpdateSubscriptionPaymentMethodInput;
};


export type MutationsUpdateTaxRatesArgs = {
  input: UpdateTaxRatesMutationInput;
};


export type MutationsUpdateTroubleshootingActionArgs = {
  input: UpdateTroubleshootingActionMutationInput;
};


export type MutationsUpdateUserProfileArgs = {
  input: UpdateUserProfileMutationInput;
};


export type MutationsUpdateUserStatusArgs = {
  input: UpdateUserStatusMutationInput;
};


export type MutationsUpdateVendorArgs = {
  arguments: UpdateVendorArguments;
};


export type MutationsUpdateVendorAnticipatedStandardPayoutDaysArgs = {
  input: UpdateVendorAnticipatedStandardPayoutDaysMutationInput;
};


export type MutationsUpdateVendorBusinessProfileArgs = {
  input: UpdateVendorBusinessProfileMutationInput;
};


export type MutationsUpdateVendorEquipmentCapabilityArgs = {
  input: UpdateVendorEquipmentCapabilityMutationInput;
};


export type MutationsUpdateVendorFacilityInsuranceDocumentArgs = {
  input: UpdateVendorFacilityInsuranceDocumentMutationInput;
};


export type MutationsUpdateVendorGeneralInfoArgs = {
  input: UpdateVendorGeneralInfoMutationInput;
};


export type MutationsUpdateVendorInsuranceDocumentArgs = {
  input: UpdateVendorInsuranceDocumentMutationInput;
};


export type MutationsUpdateVendorMemberArgs = {
  arguments: UpdateVendorMemberArguments;
};


export type MutationsUpdateVendorOpenToMarketplaceArgs = {
  input: UpdateVendorOpenToMarketplaceMutationInput;
};


export type MutationsUpdateVendorPaymentInstructionsArgs = {
  input: UpdateVendorPaymentInstructionsMutationInput;
};


export type MutationsUpdateVendorPayoutInfoArgs = {
  input: UpdateVendorPayoutInfoMutationInput;
};


export type MutationsUpdateVendorPriceRatesArgs = {
  input: UpdateVendorPriceRatesMutationInput;
};


export type MutationsUpdateVendorProfileDispatchArgs = {
  input: UpdateVendorProfileDispatchMutationInput;
};


export type MutationsUpdateVendorPromotionArgs = {
  input: UpdateVendorPromotionMutationInput;
};


export type MutationsUpdateVendorReceptionistGuidanceArgs = {
  input: UpdateVendorReceptionistGuidanceMutationInput;
};


export type MutationsUpdateVendorRemittanceEmailAddressesArgs = {
  input: UpdateVendorRemittanceEmailAddressesMutationInput;
};


export type MutationsUpdateVendorReportScheduleArgs = {
  input: UpdateVendorReportScheduleMutationInput;
};


export type MutationsUpdateVendorRevenueSharesArgs = {
  input: UpdateVendorRevenueSharesMutationInput;
};


export type MutationsUpdateVendorSubcontractArgs = {
  input: UpdateVendorSubcontractMutationInput;
};


export type MutationsUpdateVendorSubcontractPairingArgs = {
  input: UpdateVendorSubcontractPairingMutationInput;
};


export type MutationsUpdateVendorWebsiteArgs = {
  input: UpdateVendorWebsiteMutationInput;
};


export type MutationsUpdateVisitArgs = {
  input: UpdateVisitInput;
};


export type MutationsUpdateWebsiteAdvertisingCampaignNameArgs = {
  input: UpdateWebsiteAdvertisingCampaignNameMutationInput;
};


export type MutationsUpdateWorkOrderCompletionTimeArgs = {
  input: UpdateWorkOrderCompletionTimeInput;
};


export type MutationsUpdateWorkOrderNteArgs = {
  input: UpdateWorkOrderNteInput;
};


export type MutationsUpdateWorkOrderOpsOwnerArgs = {
  opsOwnerId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type MutationsUploadAfterImagesArgs = {
  appointmentId: Scalars['ID']['input'];
  images: Array<InputMaybe<Image>>;
};


export type MutationsUploadClientManagedInvoiceArgs = {
  input: UploadClientManagedInvoiceInput;
};


export type MutationsUploadPartneredEstimateSubmissionArgs = {
  input: UploadPartneredEstimateSubmissionMutationInput;
};


export type MutationsUploadPartneredInvoiceSubmissionArgs = {
  input: UploadPartneredInvoiceSubmissionMutationInput;
};


export type MutationsUploadQuoteArgs = {
  input: UploadQuoteMutationInput;
};


export type MutationsUploadRemittanceStatementArgs = {
  input: UploadRemittanceStatementInput;
};


export type MutationsUploadVendorInvoiceArgs = {
  input: UploadVendorInvoiceInput;
};


export type MutationsUploadedInvoiceCheckArgs = {
  input: UploadedInvoiceCheckMutationInput;
};


export type MutationsVendorChangeWorkOrderStateArgs = {
  input: VendorChangeWorkOrderStateInput;
};


export type MutationsVendorCreateWorkOrderArgs = {
  input: VendorCreateWorkOrderInput;
};


export type MutationsVoidSubcontractSettlementInvoiceArgs = {
  input: VoidSubcontractSettlementInvoiceMutationInput;
};


export type MutationsVoidSubcontractSettlementInvoicesArgs = {
  input: VoidSubcontractSettlementInvoicesMutationInput;
};


export type MutationsVoidSubscriptionInvoiceMutationArgs = {
  input: VoidSubscriptionInvoiceMutationInput;
};

export enum NavigableLocation {
  EstimateDetailsPage = 'EstimateDetailsPage',
  WorkOrderDetailsPage = 'WorkOrderDetailsPage'
}

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type NonDeactivatedVendorOrganizationNode = Node & {
  __typename: 'NonDeactivatedVendorOrganizationNode';
  code: Scalars['String']['output'];
  hasServicedClient: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profile: VendorProfileNode;
};

export type NonDeactivatedVendorOrganizationNodeConnection = {
  __typename: 'NonDeactivatedVendorOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NonDeactivatedVendorOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `NonDeactivatedVendorOrganizationNode` and its cursor. */
export type NonDeactivatedVendorOrganizationNodeEdge = {
  __typename: 'NonDeactivatedVendorOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<NonDeactivatedVendorOrganizationNode>;
};

/** An enumeration. */
export enum NoraCallEvaluationEvaluationStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Running */
  Running = 'RUNNING',
  /** Skipped */
  Skipped = 'SKIPPED',
  /** Succeeded */
  Succeeded = 'SUCCEEDED'
}

/** An enumeration. */
export enum NoraCallEvaluationEventEventType {
  /** Assigned */
  Assigned = 'ASSIGNED',
  /** Rerun Completed */
  RerunCompleted = 'RERUN_COMPLETED',
  /** Rerun Requested */
  RerunRequested = 'RERUN_REQUESTED',
  /** Review Updated */
  ReviewUpdated = 'REVIEW_UPDATED'
}

export type NoraCallEvaluationEventNode = Node & {
  __typename: 'NoraCallEvaluationEventNode';
  actor: Maybe<UserNode>;
  after: Maybe<Scalars['JSONString']['output']>;
  before: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventType: NoraCallEvaluationEventEventType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
};

/** An enumeration. */
export enum NoraCallEvaluationHighestFindingSeverity {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** None */
  None = 'NONE'
}

export type NoraCallEvaluationNode = Node & {
  __typename: 'NoraCallEvaluationNode';
  actionCorrect: Maybe<Scalars['Boolean']['output']>;
  actualAction: Scalars['String']['output'];
  actualLeadQuality: Scalars['String']['output'];
  assignedTo: Maybe<UserNode>;
  callReceivedAt: Maybe<Scalars['DateTime']['output']>;
  callSid: Scalars['String']['output'];
  callSummarySnapshot: Scalars['String']['output'];
  configCompliance: Maybe<Scalars['JSONString']['output']>;
  configComplianceCorrect: Maybe<Scalars['Boolean']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage: Scalars['String']['output'];
  evaluatedAt: Maybe<Scalars['DateTime']['output']>;
  evaluationStatus: NoraCallEvaluationEvaluationStatus;
  events: Maybe<Array<NoraCallEvaluationEventNode>>;
  evidence: Maybe<Scalars['JSONString']['output']>;
  expectedAction: Scalars['String']['output'];
  expectedLeadQuality: Scalars['String']['output'];
  findings: Maybe<Scalars['JSONString']['output']>;
  highestFindingSeverity: NoraCallEvaluationHighestFindingSeverity;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  ingestionType: Scalars['String']['output'];
  leadInboundRequest: Maybe<LeadInboundRequestNode>;
  leadQualityCorrect: Maybe<Scalars['Boolean']['output']>;
  leadScoreEvaluation: Maybe<Scalars['JSONString']['output']>;
  modelName: Scalars['String']['output'];
  modelProvider: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  overallStatus: Maybe<NoraCallEvaluationOverallStatus>;
  primaryIssueCategory: Maybe<NoraCallEvaluationPrimaryIssueCategory>;
  promptContractVersion: Scalars['String']['output'];
  rawResult: Maybe<Scalars['JSONString']['output']>;
  reviewDecision: Maybe<NoraCallEvaluationReviewDecision>;
  reviewNote: Scalars['String']['output'];
  reviewStatus: NoraCallEvaluationReviewStatus;
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  reviewedBy: Maybe<UserNode>;
  rootCause: Maybe<NoraCallEvaluationRootCause>;
  rubricVersion: Scalars['String']['output'];
  stageScores: Maybe<Scalars['JSONString']['output']>;
  suggestedFix: Scalars['String']['output'];
  transcriptSha256: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urgencyCorrect: Maybe<Scalars['Boolean']['output']>;
  urgencyLevel: Maybe<NoraCallEvaluationUrgencyLevel>;
  vendor: Maybe<VendorOrganizationNode>;
  vendorConfigSnapshot: Maybe<Scalars['JSONString']['output']>;
};

export type NoraCallEvaluationNodeConnection = {
  __typename: 'NoraCallEvaluationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NoraCallEvaluationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `NoraCallEvaluationNode` and its cursor. */
export type NoraCallEvaluationNodeEdge = {
  __typename: 'NoraCallEvaluationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<NoraCallEvaluationNode>;
};

/** An enumeration. */
export enum NoraCallEvaluationOverallStatus {
  /** Fail */
  Fail = 'FAIL',
  /** Needs Review */
  NeedsReview = 'NEEDS_REVIEW',
  /** Pass */
  Pass = 'PASS',
  /** Warning */
  Warning = 'WARNING'
}

/** An enumeration. */
export enum NoraCallEvaluationPrimaryIssueCategory {
  /** Answer Quality */
  AnswerQuality = 'ANSWER_QUALITY',
  /** Caller Identity Handling */
  CallerIdentityHandling = 'CALLER_IDENTITY_HANDLING',
  /** Config Compliance */
  ConfigCompliance = 'CONFIG_COMPLIANCE',
  /** Contact Inquiry Handling */
  ContactInquiryHandling = 'CONTACT_INQUIRY_HANDLING',
  /** Data Quality */
  DataQuality = 'DATA_QUALITY',
  /** Lead Scoring */
  LeadScoring = 'LEAD_SCORING',
  /** Other */
  Other = 'OTHER',
  /** Path Selection */
  PathSelection = 'PATH_SELECTION',
  /** Transfer */
  Transfer = 'TRANSFER',
  /** Unsupported Promise */
  UnsupportedPromise = 'UNSUPPORTED_PROMISE',
  /** Urgency */
  Urgency = 'URGENCY',
  /** Work Order Details */
  WorkOrderDetails = 'WORK_ORDER_DETAILS'
}

/** An enumeration. */
export enum NoraCallEvaluationReviewDecision {
  /** Confirmed Issue */
  ConfirmedIssue = 'CONFIRMED_ISSUE',
  /** Data Issue */
  DataIssue = 'DATA_ISSUE',
  /** False Negative */
  FalseNegative = 'FALSE_NEGATIVE',
  /** False Positive */
  FalsePositive = 'FALSE_POSITIVE',
  /** No Action Needed */
  NoActionNeeded = 'NO_ACTION_NEEDED',
  /** Prompt Or Config Updated */
  PromptOrConfigUpdated = 'PROMPT_OR_CONFIG_UPDATED',
  /** Scoring Issue */
  ScoringIssue = 'SCORING_ISSUE'
}

/** An enumeration. */
export enum NoraCallEvaluationReviewStatus {
  /** Fixed */
  Fixed = 'FIXED',
  /** Fix Planned */
  FixPlanned = 'FIX_PLANNED',
  /** Needs Review */
  NeedsReview = 'NEEDS_REVIEW',
  /** No Action Needed */
  NoActionNeeded = 'NO_ACTION_NEEDED',
  /** Triaged */
  Triaged = 'TRIAGED',
  /** Unreviewed */
  Unreviewed = 'UNREVIEWED',
  /** Wont Fix */
  WontFix = 'WONT_FIX'
}

/** An enumeration. */
export enum NoraCallEvaluationRootCause {
  /** Agent Tooling */
  AgentTooling = 'AGENT_TOOLING',
  /** Evaluator Uncertain */
  EvaluatorUncertain = 'EVALUATOR_UNCERTAIN',
  /** External Provider */
  ExternalProvider = 'EXTERNAL_PROVIDER',
  /** Ingestion Data */
  IngestionData = 'INGESTION_DATA',
  /** Lead Scoring Logic */
  LeadScoringLogic = 'LEAD_SCORING_LOGIC',
  /** Nora Behavior */
  NoraBehavior = 'NORA_BEHAVIOR',
  /** Prompt Gap */
  PromptGap = 'PROMPT_GAP',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** Vendor Config */
  VendorConfig = 'VENDOR_CONFIG'
}

/** An enumeration. */
export enum NoraCallEvaluationUrgencyLevel {
  /** Emergency */
  Emergency = 'EMERGENCY',
  /** Routine */
  Routine = 'ROUTINE',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** Urgent */
  Urgent = 'URGENT'
}

export type NoraGreetingExperimentResultType = {
  __typename: 'NoraGreetingExperimentResultType';
  assignedCalls: Scalars['Int']['output'];
  averageDurationSecs: Maybe<Scalars['Float']['output']>;
  directHangupRate: Maybe<Scalars['Float']['output']>;
  directHangups: Scalars['Int']['output'];
  experimentKey: Scalars['String']['output'];
  outcomeCalls: Scalars['Int']['output'];
  phrase: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
};

/** Enum for Nora user type */
export enum NoraUserType {
  Admin = 'ADMIN',
  Offresq = 'OFFRESQ',
  Technician = 'TECHNICIAN'
}

/** An enumeration. */
export enum NotReadyForOnboardingReasonChoice {
  ExpansionOpportunity = 'EXPANSION_OPPORTUNITY',
  Other = 'OTHER',
  RestaurantNotYetInOperation = 'RESTAURANT_NOT_YET_IN_OPERATION'
}

/** An enumeration. */
export enum NoteSource {
  Client = 'CLIENT',
  Resq = 'RESQ',
  Vendor = 'VENDOR'
}

/** An enumeration. */
export enum NotificationChannel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

/**
 *
 * Enum representing which level we're checking notification settings for.
 *
 * This determines the hierarchy check:
 * - VENDOR: Only check if vendor itself is disabled (nothing higher)
 * - CUSTOMER: Check vendor level as "higher"
 * - FACILITY: Check vendor + customer as "higher"
 * - WORK_ORDER: Check vendor + customer + facility as "higher"
 *
 */
export enum NotificationCheckingLevelEnum {
  Customer = 'CUSTOMER',
  Facility = 'FACILITY',
  Vendor = 'VENDOR',
  WorkOrder = 'WORK_ORDER'
}

export type NotificationInputItem = {
  __typename: 'NotificationInputItem';
  name: Scalars['String']['output'];
};

/**
 * Represents the state of notification settings considering the hierarchy.
 *
 * This type is used to determine if a toggle should be disabled based on
 * higher-level settings and what the current value is for a specific level.
 */
export type NotificationSettingsStateType = {
  __typename: 'NotificationSettingsStateType';
  /** Current enabled/disabled state at THIS specific level */
  currentValue: Maybe<Scalars['Boolean']['output']>;
  /** Which level disabled it: 'vendor', 'customer', or 'facility' */
  disabledAtLevel: Maybe<Scalars['String']['output']>;
  /** Whether this level is disabled by a higher-level setting */
  isDisabledByHigherLevel: Maybe<Scalars['Boolean']['output']>;
  /** Human-readable reason why it's disabled */
  reason: Maybe<Scalars['String']['output']>;
};

export type NotificationSkeleton = {
  __typename: 'NotificationSkeleton';
  email: Scalars['Boolean']['output'];
  inputs: Array<NotificationInputItem>;
  name: Scalars['String']['output'];
  push: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

export type NotifyOffResqWorkOrderOnMyWayMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqAppointmentId: Scalars['ID']['input'];
};

export type NotifyOffResqWorkOrderOnMyWayMutationPayload = {
  __typename: 'NotifyOffResqWorkOrderOnMyWayMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type NotifyWorkOrderOnMyWayMutationInput = {
  appointmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type NotifyWorkOrderOnMyWayMutationPayload = {
  __typename: 'NotifyWorkOrderOnMyWayMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type OAuthCredentialNode = Node & {
  __typename: 'OAuthCredentialNode';
  accessTokenExpiresOn: Scalars['DateTime']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  integrationType: Maybe<OAuthIntegrationType>;
  organization: Maybe<VendorOrganizationNode>;
  refreshTokenExpiresOn: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum OAuthIntegrationType {
  QuickBooks = 'QUICK_BOOKS'
}

export type OffResqAppointmentNode = Node & {
  __typename: 'OffResqAppointmentNode';
  afterPhotoUrls: Array<Scalars['String']['output']>;
  beforePhotoUrls: Array<Scalars['String']['output']>;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  facilityManagerName: Scalars['String']['output'];
  facilityManagerSignatureUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  offResqWorkOrder: OffResqWorkOrderNode;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  technician: Maybe<UserNode>;
  vendorNotifiedOnTheWayAt: Maybe<Scalars['DateTime']['output']>;
  visitEndedAt: Maybe<Scalars['DateTime']['output']>;
  visitStartedAt: Maybe<Scalars['DateTime']['output']>;
};

export type OffResqAppointmentNodeConnection = {
  __typename: 'OffResqAppointmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffResqAppointmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OffResqAppointmentNode` and its cursor. */
export type OffResqAppointmentNodeEdge = {
  __typename: 'OffResqAppointmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OffResqAppointmentNode>;
};

export enum OffResqCustomerCanActions {
  CreateFacility = 'CREATE_FACILITY',
  CreateWorkOrder = 'CREATE_WORK_ORDER'
}

export type OffResqCustomerNode = Node & {
  __typename: 'OffResqCustomerNode';
  billingAddress: BillingAddressNode;
  businessDateOfIncorporation: Maybe<Scalars['DateTime']['output']>;
  businessLegalStructure: Maybe<BusinessLegalStructure>;
  businessTaxNumber: Maybe<Scalars['String']['output']>;
  can: Scalars['Boolean']['output'];
  currency: Maybe<Currency>;
  facilities: Array<OffResqFacilityNode>;
  hasAcceptedTos: Scalars['Boolean']['output'];
  hasUnresolvedDisputedInvoices: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceTotalLimit: Maybe<Scalars['Decimal']['output']>;
  isCreditWorthy: Maybe<Scalars['Boolean']['output']>;
  isMissingBrd: Scalars['Boolean']['output'];
  jobCount: Maybe<Scalars['Int']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'facilities' instead. This field will be removed in a future version. */
  offResqFacility: Maybe<OffResqFacilityNode>;
  owedAmountExceededThreshold: Maybe<Scalars['Decimal']['output']>;
  people: Array<OffResqFacilityPerson>;
  tosVersion: Maybe<OffResqCustomerTosVersion>;
  totalInvoiced: Scalars['Int']['output'];
  users: Array<UserNode>;
  vendor: Maybe<VendorOrganizationNode>;
};


export type OffResqCustomerNodeCanArgs = {
  perform: OffResqCustomerCanActions;
};


export type OffResqCustomerNodeJobCountArgs = {
  vendorId: Scalars['ID']['input'];
};

export type OffResqCustomerNodeConnection = {
  __typename: 'OffResqCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffResqCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OffResqCustomerNode` and its cursor. */
export type OffResqCustomerNodeEdge = {
  __typename: 'OffResqCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OffResqCustomerNode>;
};

/** An enumeration. */
export enum OffResqCustomerTosVersion {
  Version_1 = 'VERSION_1'
}

export type OffResqFacilityInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  provinceId: Scalars['ID']['input'];
};

export type OffResqFacilityNode = Node & {
  __typename: 'OffResqFacilityNode';
  address: Maybe<Scalars['String']['output']>;
  cityName: Maybe<Scalars['String']['output']>;
  country: CountryNode;
  /** Default approver for off-resq estimates. */
  defaultApprover: Maybe<ApproverContact>;
  facilityInsuranceDocument: Maybe<VendorDocumentNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  industry: Maybe<Industry>;
  name: Scalars['String']['output'];
  /** Deduped list of users associated with this facility or its customer, with source labels. */
  people: Array<OffResqFacilityPerson>;
  preResqPaymentTermsDays: Maybe<Scalars['Int']['output']>;
  province: ProvinceNode;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type OffResqFacilityPerson = {
  __typename: 'OffResqFacilityPerson';
  customerRoles: Array<RoleNode>;
  email: Maybe<Scalars['String']['output']>;
  facilityRoles: Array<RoleNode>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  membershipStatus: OffResqMembershipStatus;
  phone: Maybe<Scalars['String']['output']>;
  roles: Array<RoleNode>;
  sources: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum OffResqMembershipStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED'
}

export type OffResqNotificationSettingsNode = Node & {
  __typename: 'OffResqNotificationSettingsNode';
  createdAt: Scalars['DateTime']['output'];
  /** When True, facility users will not receive SMS/email notifications */
  disableFacilityUserNotifications: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  scopeLevel: Maybe<NotificationCheckingLevelEnum>;
  /** If set, settings apply to this specific customer only */
  scopedCustomer: Maybe<OffResqCustomerNode>;
  /** If set, settings apply to this specific facility only */
  scopedFacility: Maybe<OffResqFacilityNode>;
  /** If set, settings apply to this specific work order only */
  scopedWorkOrder: Maybe<OffResqWorkOrderNode>;
  updatedAt: Scalars['DateTime']['output'];
  /** The vendor organization that controls these notification settings */
  vendor: VendorOrganizationNode;
};

/** Unified quote decision verbs used across off-resq and standalone flows. */
export enum OffResqQuoteDecision {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type OffResqWorkOrderNode = Node & {
  __typename: 'OffResqWorkOrderNode';
  activeSubcontract: Maybe<WorkOrderSubcontractType>;
  /** Additional details provided when creating the work order */
  additionalDetails: Scalars['String']['output'];
  appointments: Array<OffResqAppointmentNode>;
  /** Whether the viewer may load partnered estimate/invoice submissions and subcontract settlement invoices for this work order. */
  canViewPartneredFinancials: Scalars['Boolean']['output'];
  /** Human-readable identifier for the work order */
  code: Maybe<Scalars['String']['output']>;
  /** Timestamp when the work order was completed */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerEstimateReceivedAt: Maybe<Scalars['DateTime']['output']>;
  customerInvoiceReceivedOn: Maybe<Scalars['Date']['output']>;
  /** Detailed description of the work */
  description: Scalars['String']['output'];
  executingVendor: Maybe<VendorOrganizationNode>;
  facility: OffResqFacilityNode;
  facilityInsuranceDocument: Maybe<VendorDocumentNode>;
  hasRsgCompletionReport: Scalars['Boolean']['output'];
  hasSubmittedActualInvoice: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSets: Array<InvoiceSetNode>;
  isPinnedByMe: Scalars['Boolean']['output'];
  isSubcontracted: Scalars['Boolean']['output'];
  latestAppointment: Maybe<OffResqAppointmentNode>;
  latestAppointmentTechnician: Maybe<UserNode>;
  latestApprovedEstimate: Maybe<QuoteNode>;
  latestSubcontract: Maybe<WorkOrderSubcontractType>;
  onHoldReason: Maybe<Scalars['String']['output']>;
  originatingInboundRequest: Maybe<LeadInboundRequestNode>;
  partnerSla: Maybe<VendorSlaChecklistType>;
  partneredDisplay: Maybe<PartneredDisplayType>;
  partneredEstimateSubmissions: Array<PartneredEstimateSubmissionNode>;
  partneredInvoiceSubmissions: Array<PartneredInvoiceSubmissionNode>;
  /** Priority level of the work order */
  priority: OffResqWorkOrderPriority;
  quoteSets: Array<QuoteSetNode>;
  quotes: Array<QuoteNode>;
  /** Optional service category */
  serviceCategory: Maybe<OffResqWorkOrderServiceCategory>;
  /** Current status of the work order */
  status: OffResqWorkOrderStatus;
  subcontractHistory: Array<WorkOrderSubcontractType>;
  subcontractMarket: Maybe<MarketNode>;
  subcontractSettlementInvoices: Array<SubcontractSettlementInvoiceNode>;
  /** Tech notes visible only to technician */
  techNotes: Scalars['String']['output'];
  /** @deprecated Deprecated compatibility alias for the latest appointment technician. Use appointments[].technician instead. */
  technician: Maybe<UserNode>;
  /** Brief description of the work needed */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type OffResqWorkOrderNodeConnection = {
  __typename: 'OffResqWorkOrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffResqWorkOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OffResqWorkOrderNode` and its cursor. */
export type OffResqWorkOrderNodeEdge = {
  __typename: 'OffResqWorkOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OffResqWorkOrderNode>;
};

/** An enumeration. */
export enum OffResqWorkOrderPriority {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** urgent */
  Urgent = 'URGENT'
}

/** An enumeration. */
export enum OffResqWorkOrderServiceCategory {
  /** Accessibility & Hardware */
  AccessibilityHardware = 'ACCESSIBILITY_HARDWARE',
  /** Air Compressors */
  AirCompressors = 'AIR_COMPRESSORS',
  /** Architect/Design */
  ArchitectDesign = 'ARCHITECT_DESIGN',
  /** Asbestos */
  Asbestos = 'ASBESTOS',
  /** Audits */
  Audits = 'AUDITS',
  /** Awaiting Categorization */
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  /** Backflow */
  Backflow = 'BACKFLOW',
  /** Beverage Equipment */
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  /** Bowling Equipment */
  BowlingEquipment = 'BOWLING_EQUIPMENT',
  /** Burglar Alarm */
  BurglarAlarm = 'BURGLAR_ALARM',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Chowbotics */
  Chowbotics = 'CHOWBOTICS',
  /** Cleaning */
  Cleaning = 'CLEANING',
  /** Closed Circuit Television */
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  /** CO2 */
  Co2 = 'CO2',
  /** Coffee */
  Coffee = 'COFFEE',
  /** Consumables & Replenishment */
  ConsumablesReplenishment = 'CONSUMABLES_REPLENISHMENT',
  /** Cutting Board Resurfacing */
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  /** Drive Thru Items */
  DriveThuItems = 'DRIVE_THU_ITEMS',
  /** Electrical */
  Electrical = 'ELECTRICAL',
  /** Elevators & Dumbwaiters */
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  /** EMERGENCY_LIGHTS */
  EmergencyLights = 'EMERGENCY_LIGHTS',
  /** Environmental Consulting */
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  /** Equipment Leasing */
  EquipmentLeasing = 'EQUIPMENT_LEASING',
  /** Fire Alarms */
  FireAlarms = 'FIRE_ALARMS',
  /** Fire Suppression */
  FireSuppression = 'FIRE_SUPPRESSION',
  /** FIXTURES */
  Fixtures = 'FIXTURES',
  /** Flooring */
  Flooring = 'FLOORING',
  /** Food Equipment */
  FoodEquipment = 'FOOD_EQUIPMENT',
  /** Fuel Oil */
  FuelOil = 'FUEL_OIL',
  /** Furniture */
  Furniture = 'FURNITURE',
  /** Gaskets */
  Gaskets = 'GASKETS',
  /** Gas & Boilers */
  GasBoilers = 'GAS_BOILERS',
  /** General Contracting */
  GeneralContracting = 'GENERAL_CONTRACTING',
  /** General Repair/Handywork */
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  /** Generators & Power Supply */
  Generators = 'GENERATORS',
  /** Grease Traps */
  GreaseTrap = 'GREASE_TRAP',
  /** Gym Equipment */
  GymEquipment = 'GYM_EQUIPMENT',
  /** Heating & Cooling/HVAC */
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  /** Hoods */
  Hoods = 'HOODS',
  /** Hospitality */
  Hospitality = 'HOSPITALITY',
  /** Hot Water Systems */
  HotWaterTank = 'HOT_WATER_TANK',
  /** Ice Machines */
  IceMachine = 'ICE_MACHINE',
  /** Landscaping */
  Landscaping = 'LANDSCAPING',
  /** Locks & Doors */
  LocksDoors = 'LOCKS_DOORS',
  /** Medical Equipment */
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  /** Menu Screens */
  MenuScreens = 'MENU_SCREENS',
  /** Messenger Services */
  MessengerServices = 'MESSENGER_SERVICES',
  /** Millwork */
  Millwork = 'MILLWORK',
  /** Miscellaneous */
  Miscellaneous = 'MISCELLANEOUS',
  /** Moving Services */
  MovingServices = 'MOVING_SERVICES',
  /** Pack Screens */
  PackScreens = 'PACK_SCREENS',
  /** Painting */
  Painting = 'PAINTING',
  /** Parts/Supply Order */
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  /** Pavement */
  Pavement = 'PAVEMENT',
  /** Pest Control */
  PestControl = 'PEST_CONTROL',
  /** Planned Project */
  PlannedProject = 'PLANNED_PROJECT',
  /** Plumbing */
  Plumbing = 'PLUMBING',
  /** Refrigeration */
  Refrigeration = 'REFRIGERATION',
  /** Roofing */
  Roofing = 'ROOFING',
  /** Room Setup / Take Down */
  RoomSetupTakeDown = 'ROOM_SETUP_TAKE_DOWN',
  /** Security */
  Security = 'SECURITY',
  /** Shredding */
  Shredding = 'SHREDDING',
  /** Signage */
  Signage = 'SIGNAGE',
  /** Snow Removal */
  SnowRemoval = 'SNOW_REMOVAL',
  /** Soda/Beer */
  SodaBeer = 'SODA_BEER',
  /** Spa Equipment */
  SpaEquipment = 'SPA_EQUIPMENT',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Temp Services */
  TempServices = 'TEMP_SERVICES',
  /** Tiling */
  Tiling = 'TILING',
  /** Uniforms & Laundry */
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  /** Upholstery */
  Upholstery = 'UPHOLSTERY',
  /** Vending Machines */
  VendingMachines = 'VENDING_MACHINES',
  /** Ware Washing Equipment */
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  /** Waste Removal */
  WasteRemoval = 'WASTE_REMOVAL',
  /** Water Treatment */
  WaterFiltration = 'WATER_FILTRATION',
  /** Welding */
  Welding = 'WELDING',
  /** Windows, Doors & Locks */
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  /** Windows & Glass */
  WindowsGlass = 'WINDOWS_GLASS'
}

/** An enumeration. */
export enum OffResqWorkOrderStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Closed */
  Closed = 'CLOSED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Open */
  Open = 'OPEN'
}

export type OfferNode = Node & {
  __typename: 'OfferNode';
  createdOrUpdatedBy: Maybe<UserNode>;
  currency: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  offerType: Maybe<OfferType>;
  pricingType: Maybe<PricingType>;
  rate: Maybe<Scalars['Float']['output']>;
  resqService: Maybe<ResqServiceNode>;
};

export type OfferNodeConnection = {
  __typename: 'OfferNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OfferNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OfferNode` and its cursor. */
export type OfferNodeEdge = {
  __typename: 'OfferNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OfferNode>;
};

/** An enumeration. */
export enum OfferType {
  Subscription = 'SUBSCRIPTION',
  Transactional = 'TRANSACTIONAL'
}

/** An enumeration. */
export enum OfflinePaymentMethods {
  AchEft = 'ACH_EFT',
  Cheque = 'CHEQUE',
  WireTransfer = 'WIRE_TRANSFER'
}

export type OnDemandAndMaintenancePlanCounts = {
  __typename: 'OnDemandAndMaintenancePlanCounts';
  maintenancePlan: Scalars['Int']['output'];
  onDemand: Scalars['Int']['output'];
};

export type OnHoldActivity = Activity & Node & {
  __typename: 'OnHoldActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  miscellaneousHold: MiscellaneousHold;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type OnboardingActionNode = Node & {
  __typename: 'OnboardingActionNode';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isFirstTime: Scalars['Boolean']['output'];
  onboardingLogs: Maybe<Array<OnboardingLogNode>>;
  onboardingType: Maybe<OnboardingType>;
  organization: VendorOrganizationNode;
  steps: Array<Maybe<OnboardingSteps>>;
};

export type OnboardingActionNodeConnection = {
  __typename: 'OnboardingActionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OnboardingActionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OnboardingActionNode` and its cursor. */
export type OnboardingActionNodeEdge = {
  __typename: 'OnboardingActionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OnboardingActionNode>;
};

export type OnboardingLogNode = Node & {
  __typename: 'OnboardingLogNode';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  step: OnboardingSteps;
};

/** An enumeration. */
export enum OnboardingStatus {
  AbleToSubmitMarketplaceWorkOrders = 'ABLE_TO_SUBMIT_MARKETPLACE_WORK_ORDERS',
  InOnboarding = 'IN_ONBOARDING',
  NotReadyForOnboarding = 'NOT_READY_FOR_ONBOARDING'
}

/** An enumeration. */
export enum OnboardingSteps {
  AddCustomer = 'ADD_CUSTOMER',
  AddStaff = 'ADD_STAFF',
  BillingAndPaymentInfo = 'BILLING_AND_PAYMENT_INFO',
  BillingInfo = 'BILLING_INFO',
  BusinessDetails = 'BUSINESS_DETAILS',
  CreateJob = 'CREATE_JOB',
  Facilities = 'FACILITIES',
  GeneralInfo = 'GENERAL_INFO',
  GetStarted = 'GET_STARTED',
  InvitedCaTos = 'INVITED_CA_TOS',
  InvitedUkTos = 'INVITED_UK_TOS',
  InvitedUsTos = 'INVITED_US_TOS',
  MarketplaceCaTos = 'MARKETPLACE_CA_TOS',
  MarketplaceUkTos = 'MARKETPLACE_UK_TOS',
  MarketplaceUsTos = 'MARKETPLACE_US_TOS',
  NewFacility = 'NEW_FACILITY',
  NewStaff = 'NEW_STAFF',
  OperatingAreas = 'OPERATING_AREAS',
  PartnerAgreement = 'PARTNER_AGREEMENT',
  PaymentInfo = 'PAYMENT_INFO',
  PayoutInfo = 'PAYOUT_INFO',
  Rates = 'RATES',
  ReviewAndSubmit = 'REVIEW_AND_SUBMIT',
  Roles = 'ROLES',
  SelfServeTos = 'SELF_SERVE_TOS',
  ServiceCategories = 'SERVICE_CATEGORIES',
  ServiceProviders = 'SERVICE_PROVIDERS',
  Skills = 'SKILLS',
  Staff = 'STAFF',
  TermsOfService = 'TERMS_OF_SERVICE',
  Tos = 'TOS',
  TradesSubscription = 'TRADES_SUBSCRIPTION',
  UploadLogo = 'UPLOAD_LOGO'
}

/** An enumeration. */
export enum OnboardingType {
  Client = 'CLIENT',
  DispatchedVendor = 'DISPATCHED_VENDOR',
  Inherited = 'INHERITED',
  InheritedToMarketplace = 'INHERITED_TO_MARKETPLACE',
  SelfServeVendor = 'SELF_SERVE_VENDOR',
  SourcedVendor = 'SOURCED_VENDOR',
  Tos = 'TOS'
}

export type OperatingAreaNode = Node & {
  __typename: 'OperatingAreaNode';
  area: Maybe<Scalars['MultiPolygon']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  market: Maybe<MarketNode>;
  name: Scalars['String']['output'];
};

export type OperatingAreaNodeConnection = {
  __typename: 'OperatingAreaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatingAreaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OperatingAreaNode` and its cursor. */
export type OperatingAreaNodeEdge = {
  __typename: 'OperatingAreaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OperatingAreaNode>;
};

/** An enumeration. */
export enum OperatingAreaStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Transitioning = 'TRANSITIONING'
}

export enum OrganizationCanActions {
  AccessStatements = 'ACCESS_STATEMENTS',
  AccessSubscriptions = 'ACCESS_SUBSCRIPTIONS',
  ApproveInvoices = 'APPROVE_INVOICES',
  ApproveQuote = 'APPROVE_QUOTE',
  ChooseExpenseType = 'CHOOSE_EXPENSE_TYPE',
  ClientInternalAssignment = 'CLIENT_INTERNAL_ASSIGNMENT',
  CreateBudget = 'CREATE_BUDGET',
  ManageBusinessSettings = 'MANAGE_BUSINESS_SETTINGS',
  ManageChecklistAssignments = 'MANAGE_CHECKLIST_ASSIGNMENTS',
  ManageChecklistTemplates = 'MANAGE_CHECKLIST_TEMPLATES',
  ManageFavouriteVendors = 'MANAGE_FAVOURITE_VENDORS',
  ManagePreventativeMaintenance = 'MANAGE_PREVENTATIVE_MAINTENANCE',
  ManageProjects = 'MANAGE_PROJECTS',
  ManageStaff = 'MANAGE_STAFF',
  PayInvoice = 'PAY_INVOICE',
  SelectQuote = 'SELECT_QUOTE',
  SubmitWorkOrder = 'SUBMIT_WORK_ORDER',
  UpdateExpenseType = 'UPDATE_EXPENSE_TYPE'
}

export type OrganizationFeaturesNode = Node & {
  __typename: 'OrganizationFeaturesNode';
  additionalFeatures: Array<Features>;
  allFeatures: Array<Features>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  organizationId: Scalars['Int']['output'];
  removedFeatures: Array<Features>;
  tier: FeatureTierNode;
  unimplementedFeatures: Array<Features>;
};

/** An enumeration. */
export enum OrganizationSubscriptionBillingCycle {
  /** Annual */
  Annual = 'ANNUAL',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Prorated */
  Prorated = 'PRORATED',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Trial */
  Trial = 'TRIAL'
}

export type OrganizationSubscriptionNode = Node & {
  __typename: 'OrganizationSubscriptionNode';
  billingCycle: Maybe<OrganizationSubscriptionBillingCycle>;
  businessUnit: Maybe<BusinessUnitNode>;
  endDate: Maybe<Scalars['Date']['output']>;
  firstBillingDate: Maybe<Scalars['Date']['output']>;
  /** Whether this subscription has any unpaid invoices */
  hasUnpaidInvoices: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** All subscription invoices (billing history) */
  invoices: Array<VendorInvoiceNode>;
  lastBillingDate: Maybe<Scalars['Date']['output']>;
  nextBillingDate: Maybe<Scalars['Date']['output']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  startDate: Maybe<Scalars['Date']['output']>;
  status: OrganizationSubscriptionStatus;
  /** Unpaid client subscription invoices */
  unpaidSubscriptionInvoices: Array<ClientInvoiceNode>;
};

export enum OrganizationSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum Outcome {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  Rescheduled = 'RESCHEDULED'
}

export type OutstandingBalanceNode = Node & {
  __typename: 'OutstandingBalanceNode';
  customerName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  total: Maybe<Scalars['Decimal']['output']>;
  total30Days: Maybe<Scalars['Decimal']['output']>;
  total60Days: Maybe<Scalars['Decimal']['output']>;
  total90Days: Maybe<Scalars['Decimal']['output']>;
  totalOver90Days: Maybe<Scalars['Decimal']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type OutstandingBalanceNodeConnection = {
  __typename: 'OutstandingBalanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OutstandingBalanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OutstandingBalanceNode` and its cursor. */
export type OutstandingBalanceNodeEdge = {
  __typename: 'OutstandingBalanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<OutstandingBalanceNode>;
};

export enum OverdueInvoicesCallResultOutcomeEnum {
  Accepted = 'ACCEPTED',
  DeclinedToPay = 'DECLINED_TO_PAY',
  PayLater = 'PAY_LATER',
  Uncertain = 'UNCERTAIN'
}

export type OverrideLocationAddressMutationInput = {
  addressResolutionId?: InputMaybe<Scalars['ID']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
};

export type OverrideLocationAddressMutationPayload = {
  __typename: 'OverrideLocationAddressMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  locationAddressResolution: LocationAddressResolutionNode;
};

export type OvertimeStatus = {
  __typename: 'OvertimeStatus';
  facilityId: Scalars['ID']['output'];
  isOvertime: Scalars['Boolean']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PartneredDisplayType = {
  __typename: 'PartneredDisplayType';
  isPartnered: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type PartneredEstimateSubmissionNode = Node & {
  __typename: 'PartneredEstimateSubmissionNode';
  createdAt: Scalars['DateTime']['output'];
  currency: PartneredSubmissionCurrency;
  documentFile: FileType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lineItems: Array<Scalars['GenericScalar']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  overrideNotes: Scalars['String']['output'];
  previewImage: Maybe<ImageType>;
  source: PartneredSubmissionSource;
  submittingVendor: VendorOrganizationNode;
  subtotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
  validUntil: Maybe<Scalars['DateTime']['output']>;
  vendorReferenceNumber: Scalars['String']['output'];
};

export type PartneredInvoiceSubmissionNode = Node & {
  __typename: 'PartneredInvoiceSubmissionNode';
  callbackCostReason: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: PartneredSubmissionCurrency;
  documentFile: FileType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lineItems: Array<Scalars['GenericScalar']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  overrideNotes: Scalars['String']['output'];
  previewImage: Maybe<ImageType>;
  source: PartneredSubmissionSource;
  submittingVendor: VendorOrganizationNode;
  subtotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
  vendorNotes: Scalars['String']['output'];
  vendorReferenceNumber: Scalars['String']['output'];
};

/** An enumeration. */
export enum PartneredSubmissionCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

/** An enumeration. */
export enum PartneredSubmissionSource {
  CreatedInPmc = 'CREATED_IN_PMC',
  UploadedInPmc = 'UPLOADED_IN_PMC'
}

/** An enumeration. */
export enum PayQAgreementTosVersion {
  PayqAgreementAddendum = 'PAYQ_AGREEMENT_ADDENDUM'
}

/** An enumeration. */
export enum PaymentMethodAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

/** An enumeration. */
export enum PaymentMethodExternalType {
  Astra = 'ASTRA',
  Justifi = 'JUSTIFI',
  Kanmon = 'KANMON',
  Orum = 'ORUM',
  Stripe = 'STRIPE',
  Usio = 'USIO'
}

export type PaymentMethodNode = Node & {
  __typename: 'PaymentMethodNode';
  achAccountPayment: Maybe<AchAccountNode>;
  creditCardPayment: Maybe<CreditCardPaymentNode>;
  externalReferenceType: Maybe<PaymentMethodExternalType>;
  facilityCount: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  paymentType: PaymentMethodPaymentType;
  preAuthorizedDebitPayment: Maybe<PreAuthorizedDebitPaymentNode>;
};

export type PaymentMethodNodeConnection = {
  __typename: 'PaymentMethodNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentMethodNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentMethodNode` and its cursor. */
export type PaymentMethodNodeEdge = {
  __typename: 'PaymentMethodNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PaymentMethodNode>;
};

/** An enumeration. */
export enum PaymentMethodPaymentType {
  AchAccount = 'ACH_ACCOUNT',
  CreditCard = 'CREDIT_CARD',
  PreAuthorizedDebit = 'PRE_AUTHORIZED_DEBIT'
}

export enum PaymentMethodType {
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD'
}

export type PaymentNode = Node & {
  __typename: 'PaymentNode';
  amount: Scalars['Decimal']['output'];
  batchPayment: BatchPaymentNode;
  clientInvoice: ClientInvoiceNode;
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  permissions: PaymentPermissions;
  refunds: Array<PaymentRefundNode>;
};

export type PaymentNodeConnection = {
  __typename: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  __typename: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PaymentNode>;
};

export type PaymentPermissions = {
  __typename: 'PaymentPermissions';
  refund: Scalars['Boolean']['output'];
};

export type PaymentRefundInput = {
  amount: Scalars['Decimal']['input'];
  paymentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type PaymentRefundNode = Node & {
  __typename: 'PaymentRefundNode';
  amount: Scalars['Decimal']['output'];
  clientInvoice: ClientInvoiceNode;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  payment: PaymentNode;
};

/** An enumeration. */
export enum PaymentStatus {
  DisputeClosed = 'DISPUTE_CLOSED',
  DisputeLost = 'DISPUTE_LOST',
  DisputeNeedsResponse = 'DISPUTE_NEEDS_RESPONSE',
  DisputeRefunded = 'DISPUTE_REFUNDED',
  DisputeUnderReview = 'DISPUTE_UNDER_REVIEW',
  DisputeWon = 'DISPUTE_WON',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export enum PaymentType {
  Ach = 'ACH',
  Cheque = 'CHEQUE',
  Credit = 'CREDIT',
  CreditCard = 'CREDIT_CARD',
  Eft = 'EFT',
  Other = 'OTHER',
  Refund = 'REFUND'
}

export enum PayoutLevel {
  Facility = 'FACILITY',
  InvoiceSet = 'INVOICE_SET',
  Vendor = 'VENDOR'
}

export type PayoutOfferHistoryNode = Node & {
  __typename: 'PayoutOfferHistoryNode';
  currentPayoutOffer: PayoutOfferNode;
  historicalPayoutOffer: Maybe<PayoutOfferNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  version: Scalars['DateTime']['output'];
};

export type PayoutOfferHistoryNodeConnection = {
  __typename: 'PayoutOfferHistoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PayoutOfferHistoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PayoutOfferHistoryNode` and its cursor. */
export type PayoutOfferHistoryNodeEdge = {
  __typename: 'PayoutOfferHistoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PayoutOfferHistoryNode>;
};

export type PayoutOfferNode = Node & {
  __typename: 'PayoutOfferNode';
  effectiveOffer: EffectiveOfferNode;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceSet: Maybe<InvoiceSetNode>;
  offResqFacility: Maybe<OffResqFacilityNode>;
  offer: OfferNode;
  updatedBy: Maybe<UserNode>;
  vendor: VendorOrganizationNode;
};

export type PayoutOfferNodeConnection = {
  __typename: 'PayoutOfferNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PayoutOfferNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PayoutOfferNode` and its cursor. */
export type PayoutOfferNodeEdge = {
  __typename: 'PayoutOfferNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PayoutOfferNode>;
};

/** An enumeration. */
export enum PayoutRelationship {
  Customer = 'CUSTOMER',
  InvoiceSet = 'INVOICE_SET',
  Vendor = 'VENDOR'
}

/**
 * Configuration for per-user pricing tiers.
 * Defines included users and minimum billable users for each service.
 */
export type PerUserSubscriptionConfigurationNode = Node & {
  __typename: 'PerUserSubscriptionConfigurationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  includedUsers: Scalars['Int']['output'];
  minimumBillableUsers: Scalars['Int']['output'];
  /** Available pricing options for this service in different currencies */
  offers: Maybe<Array<OfferNode>>;
  resqService: Maybe<ResqServiceNode>;
};

export type PerUserSubscriptionConfigurationNodeConnection = {
  __typename: 'PerUserSubscriptionConfigurationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PerUserSubscriptionConfigurationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PerUserSubscriptionConfigurationNode` and its cursor. */
export type PerUserSubscriptionConfigurationNodeEdge = {
  __typename: 'PerUserSubscriptionConfigurationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PerUserSubscriptionConfigurationNode>;
};

/**
 * Impact analysis for adding a new member to an organization with per-user subscription pricing.
 *
 * This type provides cost calculations and warnings for UI to display before
 * inviting a member to a per-user subscription organization.
 */
export type PerUserSubscriptionImpactType = {
  __typename: 'PerUserSubscriptionImpactType';
  /** Currency code (USD, CAD, GBP) */
  currency: Maybe<Scalars['String']['output']>;
  /** Current billable user count (after included/minimum) */
  currentBillableCount: Maybe<Scalars['Int']['output']>;
  /** Current actual user count */
  currentUserCount: Maybe<Scalars['Int']['output']>;
  /** Whether organization has per-user subscription pricing */
  hasPerUserSubscription: Scalars['Boolean']['output'];
  /** Number of users included in the subscription tier */
  includedUsers: Maybe<Scalars['Int']['output']>;
  /** Minimum billable users commitment (Pro tier) */
  minimumBillableUsers: Maybe<Scalars['Int']['output']>;
  /** Billable count after adding the new member */
  newBillableCount: Maybe<Scalars['Int']['output']>;
  /** User count after adding the new member */
  newUserCount: Maybe<Scalars['Int']['output']>;
  /** Next billing renewal date */
  nextBillingDate: Maybe<Scalars['Date']['output']>;
  /** Whether organization has per-user pricing but no active subscription */
  noActiveSubscription: Maybe<Scalars['Boolean']['output']>;
  /** Ongoing cost per billing period starting from next renewal */
  ongoingCostPerPeriod: Maybe<Scalars['Decimal']['output']>;
  /** Number of months in billing period (1, 3, or 12) */
  periodMonths: Maybe<Scalars['Int']['output']>;
  /** Prorated cost for remainder of current billing period */
  proratedCost: Maybe<Scalars['Decimal']['output']>;
  /** Monthly rate per additional user */
  ratePerUserPerMonth: Maybe<Scalars['Decimal']['output']>;
  /** Human-readable warning message with cost details */
  warningMessage: Maybe<Scalars['String']['output']>;
  /** Whether adding this member would increase billable user count */
  wouldIncreaseBillable: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Input for checking per-user subscription impact of a single invite.
 *
 * Each invite can have different role assignments, allowing accurate cost
 * calculation for bulk invitations with mixed roles.
 */
export type PerUserSubscriptionInviteInput = {
  /** Role IDs to be assigned to this invite */
  roleIds: Array<Scalars['ID']['input']>;
};

/**
 * Per-user subscription for client organizations.
 * Links organization to subscription and tracks actual user count.
 */
export type PerUserSubscriptionNode = Node & {
  __typename: 'PerUserSubscriptionNode';
  actualUserCount: Scalars['Int']['output'];
  /** Number of available seats based on capacity (max(includedUsers, actualUserCount) - currentBillableMemberCount) */
  availableSeats: Scalars['Int']['output'];
  billableUserCount: Scalars['Int']['output'];
  configuration: Maybe<PerUserSubscriptionConfigurationNode>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserNode>;
  currency: Maybe<Scalars['String']['output']>;
  /** Live count of billable members in the organization (excludes submitter-only users) */
  currentBillableMemberCount: Scalars['Int']['output'];
  /** The GL code associated with this subscription for accounting purposes */
  glCode: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  organization: Maybe<ClientOrganizationNode>;
  periodMonths: Maybe<Scalars['Int']['output']>;
  ratePerUserPerMonth: Maybe<Scalars['Decimal']['output']>;
  subscription: Maybe<OrganizationSubscriptionNode>;
  totalAmount: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserNode>;
};

export type PerUserSubscriptionNodeConnection = {
  __typename: 'PerUserSubscriptionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PerUserSubscriptionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PerUserSubscriptionNode` and its cursor. */
export type PerUserSubscriptionNodeEdge = {
  __typename: 'PerUserSubscriptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PerUserSubscriptionNode>;
};

/**
 * Preview of per-user subscription costs before creating subscription.
 * Shows breakdown of billable users, rates, and total amounts.
 */
export type PerUserSubscriptionPreviewType = {
  __typename: 'PerUserSubscriptionPreviewType';
  actualUserCount: Scalars['Int']['output'];
  billableUserCount: Scalars['Int']['output'];
  billingCycle: Scalars['String']['output'];
  billingPeriod: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  includedUsers: Scalars['Int']['output'];
  minimumBillableUsers: Scalars['Int']['output'];
  periodMonths: Scalars['Int']['output'];
  ratePerUserPerMonth: Scalars['Decimal']['output'];
  tierName: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type PerformVendorWebsiteMonitorDomainActionMutationInput = {
  action: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  websiteUuid: Scalars['UUID']['input'];
};

export type PerformVendorWebsiteMonitorDomainActionMutationPayload = {
  __typename: 'PerformVendorWebsiteMonitorDomainActionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type PeriodicSpendComparison = {
  __typename: 'PeriodicSpendComparison';
  difference: Scalars['Decimal']['output'];
  differencePercent: Maybe<Scalars['Decimal']['output']>;
  period: MetricsPeriod;
  spendAmount: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum Permission {
  ClientAccessStatements = 'CLIENT_ACCESS_STATEMENTS',
  ClientAccessSubscriptions = 'CLIENT_ACCESS_SUBSCRIPTIONS',
  ClientCreateBudget = 'CLIENT_CREATE_BUDGET',
  ClientInternalAssignment = 'CLIENT_INTERNAL_ASSIGNMENT',
  ClientManageBilling = 'CLIENT_MANAGE_BILLING',
  ClientManageBusinessSettings = 'CLIENT_MANAGE_BUSINESS_SETTINGS',
  ClientManageEquipment = 'CLIENT_MANAGE_EQUIPMENT',
  ClientManageFacilitySettings = 'CLIENT_MANAGE_FACILITY_SETTINGS',
  ClientManageFavouriteVendors = 'CLIENT_MANAGE_FAVOURITE_VENDORS',
  ClientManageMembers = 'CLIENT_MANAGE_MEMBERS',
  ClientManageProjects = 'CLIENT_MANAGE_PROJECTS',
  ClientManageSensors = 'CLIENT_MANAGE_SENSORS',
  ClientPayInvoice = 'CLIENT_PAY_INVOICE',
  ClientReviewWorkOrder = 'CLIENT_REVIEW_WORK_ORDER',
  ClientSubmitWorkOrder = 'CLIENT_SUBMIT_WORK_ORDER',
  ClientUpdateExpenseType = 'CLIENT_UPDATE_EXPENSE_TYPE',
  OffResqAcceptEstimates = 'OFF_RESQ_ACCEPT_ESTIMATES',
  OffResqCreateWorkOrders = 'OFF_RESQ_CREATE_WORK_ORDERS',
  OffResqManageUsers = 'OFF_RESQ_MANAGE_USERS',
  OffResqPayInvoices = 'OFF_RESQ_PAY_INVOICES',
  OffResqUpdateWorkOrders = 'OFF_RESQ_UPDATE_WORK_ORDERS',
  OffResqViewInvoices = 'OFF_RESQ_VIEW_INVOICES',
  OffResqViewWorkOrders = 'OFF_RESQ_VIEW_WORK_ORDERS',
  VendorAccessReports = 'VENDOR_ACCESS_REPORTS',
  VendorCreateInvoice = 'VENDOR_CREATE_INVOICE',
  VendorCreateJobs = 'VENDOR_CREATE_JOBS',
  VendorManageMembers = 'VENDOR_MANAGE_MEMBERS',
  VendorManageProfile = 'VENDOR_MANAGE_PROFILE',
  VendorPerformWork = 'VENDOR_PERFORM_WORK',
  VendorReadInvoice = 'VENDOR_READ_INVOICE',
  VendorScheduleAppointment = 'VENDOR_SCHEDULE_APPOINTMENT'
}

export type PersistGoogleAdsAdvertiserGuideAcceptanceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedGoogleAdvertiserGuide: Scalars['Boolean']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
};

/** Persist advertiser-guide acceptance for a website-scoped Google Ads setup. */
export type PersistGoogleAdsAdvertiserGuideAcceptancePayload = {
  __typename: 'PersistGoogleAdsAdvertiserGuideAcceptancePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type PinnedEntityInternalNotePreview = {
  __typename: 'PinnedEntityInternalNotePreview';
  createdAt: Scalars['DateTime']['output'];
  createdByName: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PinnedEntityNode = Node & {
  __typename: 'PinnedEntityNode';
  entity: Maybe<PinnedEntityTarget>;
  entityType: PinnedEntityType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  latestInternalNote: Maybe<PinnedEntityInternalNotePreview>;
  pinnedAt: Scalars['DateTime']['output'];
};

export type PinnedEntityNodeConnection = {
  __typename: 'PinnedEntityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PinnedEntityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PinnedEntityNode` and its cursor. */
export type PinnedEntityNodeEdge = {
  __typename: 'PinnedEntityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PinnedEntityNode>;
};

export type PinnedEntityTarget = OffResqWorkOrderNode | WorkOrderNode;

/** An enumeration. */
export enum PinnedEntityType {
  OffResqWorkOrder = 'OFF_RESQ_WORK_ORDER',
  WorkOrder = 'WORK_ORDER'
}

/** An enumeration. */
export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type PolishAboutUsTextMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current About Us text to polish */
  currentAboutUs: Scalars['String']['input'];
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

/** Mutation to polish and professionalize the About Us text using AI. */
export type PolishAboutUsTextMutationPayload = {
  __typename: 'PolishAboutUsTextMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Success or error message */
  message: Maybe<Scalars['String']['output']>;
  /** The polished About Us text */
  polishedText: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Maybe<Scalars['Boolean']['output']>;
};

export type PreAuthorizedDebitPaymentNode = Node & {
  __typename: 'PreAuthorizedDebitPaymentNode';
  accountNumber: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type PreAuthorizedDebitPreview = {
  __typename: 'PreAuthorizedDebitPreview';
  accountNumberLastFour: Scalars['String']['output'];
  facilityPreviews: Array<FacilityPaymentPreview>;
  total: Scalars['Decimal']['output'];
  workOrders: Array<WorkOrderNode>;
};

export type PrefillOffResqEstimateFromFileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  estimateFile: Scalars['String']['input'];
  offResqWorkOrderId: Scalars['ID']['input'];
};

export type PrefillOffResqEstimateFromFileMutationPayload = {
  __typename: 'PrefillOffResqEstimateFromFileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  prefillData: Scalars['GenericScalar']['output'];
};

export type PrefillPartneredEstimateFromFileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partneredSubmissionId: Scalars['ID']['input'];
};

export type PrefillPartneredEstimateFromFileMutationPayload = {
  __typename: 'PrefillPartneredEstimateFromFileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  prefillData: Scalars['GenericScalar']['output'];
};

export type PrefillPartneredInvoiceFromFileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partneredSubmissionId: Scalars['ID']['input'];
};

export type PrefillPartneredInvoiceFromFileMutationPayload = {
  __typename: 'PrefillPartneredInvoiceFromFileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  prefillData: Scalars['GenericScalar']['output'];
};

/** An enumeration. */
export enum PreventativeMaintenanceFrequencyUnit {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PreventativeMaintenanceNode = Node & {
  __typename: 'PreventativeMaintenanceNode';
  additionalDetails: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedDuration: Maybe<Scalars['Int']['output']>;
  facility: FacilityNode;
  frequencyUnit: PreventativeMaintenanceFrequencyUnit;
  /** Number of units for the next work order creation */
  frequencyValue: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  nextWorkOrderCreationDate: Scalars['Date']['output'];
  /** For Monthly frequencies, the day of the month for the next work order creationFor dates that are higher than the maximum day of the month,we will resolve to the last day of the month instead */
  recurrenceDayOfMonth: Maybe<Scalars['Int']['output']>;
  serviceCategory: ServiceCategory;
  taskListAttachments: Array<AttachmentNode>;
  taskListUrls: Array<AttachedUrlNode>;
  tasks: Array<PreventativeMaintenanceTaskListItemNode>;
  teamMembers: Array<UserNode>;
  title: Scalars['String']['output'];
};

export type PreventativeMaintenanceNodeConnection = {
  __typename: 'PreventativeMaintenanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PreventativeMaintenanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PreventativeMaintenanceNode` and its cursor. */
export type PreventativeMaintenanceNodeEdge = {
  __typename: 'PreventativeMaintenanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PreventativeMaintenanceNode>;
};

export type PreventativeMaintenanceTaskListItemNode = Node & {
  __typename: 'PreventativeMaintenanceTaskListItemNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type PreviewAiTextSuggestionRequestInput = {
  fieldName: Scalars['String']['input'];
  processor?: InputMaybe<Scalars['String']['input']>;
  sourceText: Scalars['String']['input'];
};

export type PreviewAiTextSuggestionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requests: Array<PreviewAiTextSuggestionRequestInput>;
  targetLabel: Scalars['String']['input'];
};

export type PreviewAiTextSuggestionsPayload = {
  __typename: 'PreviewAITextSuggestionsPayload';
  aiTextSuggestions: Array<AiTextSuggestionType>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type PreviewPerUserSubscriptionInput = {
  /** Billing period (monthly, quarterly, or annual) */
  billingPeriod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client organization ID (Relay global ID). Control center only. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Tier name (Basic or Pro) */
  tierName: Scalars['String']['input'];
  /** Number of users (minimum 1) */
  userCount: Scalars['Int']['input'];
};

/**
 * Calculate a preview of per-user subscription costs without creating subscription.
 * Shows breakdown of billable users, rates, and total amounts.
 */
export type PreviewPerUserSubscriptionPayload = {
  __typename: 'PreviewPerUserSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  preview: Maybe<PerUserSubscriptionPreviewType>;
};

export type PreviewVendorNoraEmailForwardingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type PreviewVendorNoraEmailForwardingMutationPayload = {
  __typename: 'PreviewVendorNoraEmailForwardingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  noraEmailInbox: Scalars['String']['output'];
};

export type PreviouslyHiredVendorsNode = Node & {
  __typename: 'PreviouslyHiredVendorsNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  vendors: Array<VendorOrganizationNode>;
};

export type PrewarmVendorWebsiteGoogleAdsDraftMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
  websiteAdvertisingCampaignId: Scalars['ID']['input'];
};

/** Generate and persist the initial Google Ads setup draft. */
export type PrewarmVendorWebsiteGoogleAdsDraftMutationPayload = {
  __typename: 'PrewarmVendorWebsiteGoogleAdsDraftMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  generated: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
};

export type PriceBookCategoryNode = Node & {
  __typename: 'PriceBookCategoryNode';
  children: Maybe<Array<PriceBookCategoryNode>>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<PriceBookCategoryNode>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
};

export type PriceBookCategoryNodeConnection = {
  __typename: 'PriceBookCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PriceBookCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PriceBookCategoryNode` and its cursor. */
export type PriceBookCategoryNodeEdge = {
  __typename: 'PriceBookCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PriceBookCategoryNode>;
};

export type PriceBookItemNode = Node & {
  __typename: 'PriceBookItemNode';
  category: Maybe<PriceBookCategoryNode>;
  cost: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultRate: Maybe<Scalars['Decimal']['output']>;
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Whether this item is available for use */
  isActive: Scalars['Boolean']['output'];
  /** Whether this item is subject to tax */
  isTaxable: Scalars['Boolean']['output'];
  itemType: PriceBookLineItemTypeEnum;
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  unitOfMeasure: UnitOfMeasureEnum;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
};

export type PriceBookItemNodeConnection = {
  __typename: 'PriceBookItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PriceBookItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PriceBookItemNode` and its cursor. */
export type PriceBookItemNodeEdge = {
  __typename: 'PriceBookItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PriceBookItemNode>;
};

/** Line item types available for price book items. */
export enum PriceBookLineItemTypeEnum {
  EnvironmentalFees = 'ENVIRONMENTAL_FEES',
  Fee = 'FEE',
  FreightShippingHandling = 'FREIGHT_SHIPPING_HANDLING',
  FuelSurcharge = 'FUEL_SURCHARGE',
  Labour = 'LABOUR',
  Other = 'OTHER',
  Parking = 'PARKING',
  Part = 'PART',
  ServiceCharge = 'SERVICE_CHARGE',
  Travel = 'TRAVEL',
  Truck = 'TRUCK'
}

export type PriceRateOverrideNode = Node & {
  __typename: 'PriceRateOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourRate: Maybe<Scalars['Decimal']['output']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']['output']>;
  serviceCallRate: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  travelRate: Maybe<Scalars['Decimal']['output']>;
  truckRate: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type PriceRateOverrideNodeConnection = {
  __typename: 'PriceRateOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PriceRateOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PriceRateOverrideNode` and its cursor. */
export type PriceRateOverrideNodeEdge = {
  __typename: 'PriceRateOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PriceRateOverrideNode>;
};

/** An enumeration. */
export enum PricingModelName {
  PerFacilitySubscription = 'PER_FACILITY_SUBSCRIPTION',
  PerUserSubscription = 'PER_USER_SUBSCRIPTION'
}

export type PricingModelNode = Node & {
  __typename: 'PricingModelNode';
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: PricingModelName;
};

export type PricingModelNodeConnection = {
  __typename: 'PricingModelNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PricingModelNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PricingModelNode` and its cursor. */
export type PricingModelNodeEdge = {
  __typename: 'PricingModelNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<PricingModelNode>;
};

export type PricingPlanNode = {
  __typename: 'PricingPlanNode';
  advanceRatePercentage: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  repaymentWindow: Maybe<RepaymentWindowNode>;
  transactionFeePercentage: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum PricingType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type ProjectNode = Node & {
  __typename: 'ProjectNode';
  assignedUsers: Array<UserNode>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  completedWorkOrderCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  description: Scalars['String']['output'];
  facility: FacilityNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  latestWorkOrderUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  openWorkOrderCount: Scalars['Int']['output'];
  organization: ClientOrganizationNode;
  projectType: ProjectType;
  status: ProjectStatus;
  targetCompletionDate: Maybe<Scalars['Date']['output']>;
  targetStartDate: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserNode>;
  workOrderCount: Scalars['Int']['output'];
  workOrders: Array<WorkOrderNode>;
};


export type ProjectNodeWorkOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectNodeConnection = {
  __typename: 'ProjectNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProjectNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ProjectNode` and its cursor. */
export type ProjectNodeEdge = {
  __typename: 'ProjectNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ProjectNode>;
};

/** An enumeration. */
export enum ProjectStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  OnHold = 'ON_HOLD',
  Planning = 'PLANNING'
}

/** An enumeration. */
export enum ProjectType {
  Construction = 'CONSTRUCTION',
  Other = 'OTHER',
  Relocation = 'RELOCATION',
  Remodel = 'REMODEL'
}

/** An enumeration. */
export enum PromotionType {
  WorkOrders = 'WORK_ORDERS'
}

export enum PromotionTypeEnum {
  PromotionTypeAll = 'PROMOTION_TYPE_ALL',
  PromotionTypeClient = 'PROMOTION_TYPE_CLIENT',
  PromotionTypeVendor = 'PROMOTION_TYPE_VENDOR'
}

/** Action to perform on a proposal. */
export enum ProposalAction {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Publish = 'PUBLISH',
  Update = 'UPDATE'
}

export type ProposalApproverInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalCancelInput = {
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['ID']['input'];
};

export type ProposalCommentNode = Node & {
  __typename: 'ProposalCommentNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  proposalId: Scalars['ID']['output'];
};

export type ProposalCommentNodeConnection = {
  __typename: 'ProposalCommentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProposalCommentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProposalCommentNode` and its cursor. */
export type ProposalCommentNodeEdge = {
  __typename: 'ProposalCommentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ProposalCommentNode>;
};

/**
 * Union type for entities that can be referenced by a Proposal.
 *
 * Currently supports QuoteSet. Designed to be extensible for future types
 * like MaintenancePlan.
 */
export type ProposalContentObject = MaintenancePlanNode | QuoteSetNode;

export type ProposalCreateInput = {
  approver?: InputMaybe<ProposalApproverInput>;
  billingFrequencyUnit?: InputMaybe<Scalars['String']['input']>;
  billingFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  estimateTitle?: InputMaybe<Scalars['String']['input']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialWorkOrderStatus?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  maintenancePlan?: InputMaybe<Scalars['JSONString']['input']>;
  maintenancePlanTypeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextWorkOrderCreationDate?: InputMaybe<Scalars['Date']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  opsOwnerId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceAfterMarkup?: InputMaybe<Scalars['Decimal']['input']>;
  priceBeforeMarkup?: InputMaybe<Scalars['Decimal']['input']>;
  quotes?: InputMaybe<Array<ProposalQuoteInput>>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  selfService?: InputMaybe<Scalars['Boolean']['input']>;
  serviceFrequencyUnit?: InputMaybe<Scalars['String']['input']>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  templateLineItems?: InputMaybe<Array<LineItemInput>>;
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  templateVendorNotes?: InputMaybe<Scalars['String']['input']>;
  variablePricing?: InputMaybe<Scalars['Boolean']['input']>;
  vendorPreventiveMaintenanceRecommendationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Display status for proposals, representing the user-facing state.
 *
 * This is a computed status that combines the proposal's status with approval/rejection
 * state to provide a clear display status for UI purposes.
 *
 * Priority order:
 * 1. CANCELLED - if status is CANCELLED
 * 2. DRAFT - if status is DRAFT
 * 3. APPROVED - if is_approved is True
 * 4. REJECTED - if is_rejected is True
 * 5. NEEDS_RESPONSE - if published, needs_resolution is True, and not approved/rejected
 * 6. AWAITING_APPROVAL - if published and not approved/rejected/needs_response
 *
 */
export enum ProposalDisplayStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  NeedsResponse = 'NEEDS_RESPONSE',
  Rejected = 'REJECTED'
}

export type ProposalMutationInput = {
  action: ProposalAction;
  cancel?: InputMaybe<ProposalCancelInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  create?: InputMaybe<ProposalCreateInput>;
  /** On-resq facility ID. Required for CREATE action (mutually exclusive with off_resq_facility_id). */
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  /** Off-resq facility ID. Required for CREATE action (mutually exclusive with facility_id). */
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  publish?: InputMaybe<ProposalPublishInput>;
  /** Proposal strategy (STANDALONE_QUOTES, OFF_RESQ_WORK_ORDER_QUOTES, MAINTENANCE_PLAN). Required for CREATE action. */
  strategy: ProposalStrategy;
  update?: InputMaybe<ProposalUpdateInput>;
  /** Vendor organization ID. Required for CREATE action. */
  vendorId: Scalars['ID']['input'];
};

/**
 * Unified mutation for creating, updating, and publishing proposals.
 *
 * This mutation is a pure routing layer that delegates to proposal-level handlers.
 * All business logic is handled by the interactors, which use strategy-based routing.
 *
 * - CREATE: Routes to create_proposal router
 * - UPDATE: Routes to update_proposal router
 * - PUBLISH: Routes to PublishProposalInteractor
 */
export type ProposalMutationPayload = {
  __typename: 'ProposalMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  proposal: ProposalNode;
};

/**
 * GraphQL node for Proposal model.
 *
 * Proposal is an orchestrator model that tracks status (DRAFT/PUBLISHED)
 * for various entity types (currently QuoteSet, future: MaintenancePlan).
 */
export type ProposalNode = Node & {
  __typename: 'ProposalNode';
  /** When the proposal's content object was approved (computed, not persisted) */
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  /** Primary approver contact for this proposal, if set. */
  approver: Maybe<ApproverContact>;
  /** When the proposal was cancelled (set when status changes to CANCELLED) */
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  /** Human-readable identifier for the proposal */
  code: Maybe<Scalars['String']['output']>;
  combinedFacility: Maybe<CombinedFacilityNode>;
  /** The entity this proposal refers to (e.g., QuoteSet, MaintenancePlan) */
  contentObject: Maybe<ProposalContentObject>;
  /** Type of content object (e.g., 'quoteset') */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp of the latest decision for this proposal, if any */
  decisionAt: Maybe<Scalars['DateTime']['output']>;
  /** Latest decision status for this proposal (approved/rejected), if any */
  decisionStatus: Maybe<UserProposalDecisionStatus>;
  /** Computed display status for UI purposes (draft, awaitingApproval, needsResponse, approved, rejected, cancelled) */
  displayStatus: ProposalDisplayStatus;
  /** Human-readable title for the estimate */
  estimateTitle: Scalars['String']['output'];
  facilities: Array<FacilityNode>;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Whether the proposal's content object is approved (computed, not persisted) */
  isApproved: Scalars['Boolean']['output'];
  /** Whether the proposal's content object is rejected (computed, not persisted) */
  isRejected: Scalars['Boolean']['output'];
  /** Whether this proposal was created through the standalone estimates flow */
  isStandalone: Scalars['Boolean']['output'];
  /** Whether the vendor needs to resolve facility comments */
  needsResolution: Scalars['Boolean']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  /** When the proposal was published (set when status changes to PUBLISHED) */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Maybe<UserNode>;
  /** When the proposal's content object was rejected (computed, not persisted) */
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  status: ProposalStatus;
  vendor: Maybe<VendorOrganizationNode>;
};

export type ProposalNodeConnection = {
  __typename: 'ProposalNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProposalNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ProposalNode` and its cursor. */
export type ProposalNodeEdge = {
  __typename: 'ProposalNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ProposalNode>;
};

export type ProposalPublishInput = {
  proposalId: Scalars['ID']['input'];
};

export type ProposalQuoteInput = {
  lineItems?: InputMaybe<Array<LineItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum ProposalRequestIntent {
  SecondOpinion = 'SECOND_OPINION'
}

export type ProposalRequestNode = Node & {
  __typename: 'ProposalRequestNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  intent: ProposalRequestIntent;
  lastRequestedAt: Scalars['DateTime']['output'];
  requestCount: Scalars['Int']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Maybe<UserNode>;
  requestedVendor: Maybe<VendorOrganizationNode>;
  resultingProposal: Maybe<ProposalNode>;
  slackNotifiedAt: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  status: ProposalRequestStatus;
};

/** An enumeration. */
export enum ProposalRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ProposalCreated = 'PROPOSAL_CREATED',
  Requested = 'REQUESTED',
  SentToFacility = 'SENT_TO_FACILITY'
}

/**
 * Status for proposals (standalone quotes, maintenance plans, etc.).
 *
 * - DRAFT: Proposal is being prepared, not yet published
 * - PUBLISHED: Proposal has been published and is visible for approval
 * - CANCELLED: Proposal has been cancelled by the vendor
 *
 */
export enum ProposalStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/**
 * Strategy for proposal creation.
 *
 * Determines what type of content object the proposal will reference.
 *
 */
export enum ProposalStrategy {
  MaintenancePlan = 'MAINTENANCE_PLAN',
  OffResqWorkOrderQuotes = 'OFF_RESQ_WORK_ORDER_QUOTES',
  StandaloneQuotes = 'STANDALONE_QUOTES'
}

export type ProposalUpdateInput = {
  approver?: InputMaybe<ProposalApproverInput>;
  billingFrequencyUnit?: InputMaybe<Scalars['String']['input']>;
  billingFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  estimateTitle?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<LineItemInput>>;
  maintenancePlanTypeId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextWorkOrderCreationDate?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideNotes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  proposalId: Scalars['ID']['input'];
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  serviceFrequencyUnit?: InputMaybe<Scalars['String']['input']>;
  serviceFrequencyValue?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  variablePricing?: InputMaybe<Scalars['Boolean']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProtectionPlanCoverageUsageType = {
  __typename: 'ProtectionPlanCoverageUsageType';
  contractEndsOn: Maybe<Scalars['Date']['output']>;
  contractStartsOn: Maybe<Scalars['Date']['output']>;
  currentPeriodEndsOn: Scalars['Date']['output'];
  currentPeriodStartsOn: Scalars['Date']['output'];
  nextPeriodStartsOn: Maybe<Scalars['Date']['output']>;
  remainingCoveredWorkOrders: Scalars['Int']['output'];
  totalCoveredWorkOrders: Scalars['Int']['output'];
  usedCoveredWorkOrders: Scalars['Int']['output'];
};

export type ProtectionPlanEnrollmentNode = Node & {
  __typename: 'ProtectionPlanEnrollmentNode';
  client: Maybe<ClientOrganizationNode>;
  coveragePeriodMonths: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  endsOn: Maybe<Scalars['Date']['output']>;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategories: Array<ServiceCategory>;
  startsOn: Maybe<Scalars['Date']['output']>;
  vendor: VendorOrganizationNode;
};

export type ProtectionPlanEnrollmentNodeConnection = {
  __typename: 'ProtectionPlanEnrollmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProtectionPlanEnrollmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ProtectionPlanEnrollmentNode` and its cursor. */
export type ProtectionPlanEnrollmentNodeEdge = {
  __typename: 'ProtectionPlanEnrollmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ProtectionPlanEnrollmentNode>;
};

export type ProvinceNode = Node & {
  __typename: 'ProvinceNode';
  code: Maybe<Scalars['String']['output']>;
  country: CountryNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProvinceNodeConnection = {
  __typename: 'ProvinceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProvinceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProvinceNode` and its cursor. */
export type ProvinceNodeEdge = {
  __typename: 'ProvinceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ProvinceNode>;
};

export type PurchaseReceptionistPhoneNumberMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  tollFree?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type PurchaseReceptionistPhoneNumberMutationPayload = {
  __typename: 'PurchaseReceptionistPhoneNumberMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

/** An enumeration. */
export enum QrSubmissionAuthenticationMode {
  AllowAnonymousFacilityUser = 'ALLOW_ANONYMOUS_FACILITY_USER',
  RequireActualUserLogin = 'REQUIRE_ACTUAL_USER_LOGIN'
}

export type Query = {
  __typename: 'Query';
  _debug: Maybe<DjangoDebug>;
  accountingIntegrationCustomer: Maybe<AccountingIntegrationCustomerNode>;
  accountingIntegrationCustomers: Maybe<AccountingIntegrationCustomerNodeConnection>;
  accountingIntegrationInvoice: AccountingIntegrationInvoiceNode;
  accountingIntegrationInvoicePdf: AccountingIntegrationInvoicePdfNode;
  accountingIntegrationInvoices: Array<AccountingIntegrationInvoiceNode>;
  activities: Maybe<ActivityConnection>;
  activityFeed: Maybe<ActivityFeedEntryNodeConnection>;
  adBannerStats: Array<AdBannerStatsType>;
  agentMessages: Maybe<AgentMessageNodeConnection>;
  /** Get AI model analytics for invoice processing. */
  aiModelAnalytics: Maybe<AiModelAnalyticsResponseNode>;
  alerts: Array<Alert>;
  allGateways: Maybe<GatewayConnection>;
  allocations: Maybe<AllocationNodeConnection>;
  apBatch: Maybe<ApBatchNode>;
  apBatches: Maybe<ApBatchNodeConnection>;
  apBlock: Maybe<ApBlockNode>;
  apBlocks: Maybe<ApBlockNodeConnection>;
  appointment: Maybe<AppointmentNode>;
  appointmentReschedulingReasons: Array<AppointmentReschedulingReasonType>;
  appointments: Maybe<AppointmentNodeConnection>;
  attachment: Maybe<AttachmentNode>;
  attachments: Maybe<AttachmentNodeConnection>;
  availableReceptionPhoneNumbers: Maybe<AvailableReceptionPhoneNumbersType>;
  availableTestimonials: Maybe<Array<AvailableTestimonialNode>>;
  availableVendors: Maybe<AvailableVendorNodeConnection>;
  bankAccount: Maybe<BankAccountNode>;
  bankAccountRecord: Maybe<BankAccountRecordNode>;
  bankAccountRecords: Maybe<BankAccountRecordNodeConnection>;
  bankAccounts: Maybe<BankAccountNodeConnection>;
  barcode: Maybe<AttachmentNode>;
  barcodes: Maybe<BarcodeNodeConnection>;
  batchPayment: Maybe<BatchPaymentNode>;
  batchPayments: Maybe<BatchPaymentNodeConnection>;
  billingInformation: Maybe<BillingInformationNode>;
  billingInformations: Maybe<BillingInformationNodeConnection>;
  brands: Maybe<BrandNodeConnection>;
  budget: Maybe<BudgetNode>;
  budgets: Maybe<BudgetNodeConnection>;
  businessUnit: Maybe<BusinessUnitNode>;
  businessUnits: Maybe<BusinessUnitNodeConnection>;
  calculatedMarkupInvoiceFigures: Maybe<CalculatedInvoiceNode>;
  calculatedRevShareInvoiceFigures: Maybe<CalculatedInvoiceNode>;
  canRecommendPreventativeMaintenance: Scalars['Boolean']['output'];
  categories: Maybe<CategoryNodeConnection>;
  /** Check per-user subscription impact of changing an existing member's roles */
  checkMemberRoleChangeImpact: Maybe<PerUserSubscriptionImpactType>;
  /** Check notification settings hierarchy to determine if toggles should be disabled */
  checkNotificationSettings: Maybe<NotificationSettingsStateType>;
  /** Check per-user subscription impact of adding multiple invites with role assignments */
  checkPerUserSubscriptionImpact: Maybe<PerUserSubscriptionImpactType>;
  cities: Maybe<CityNodeConnection>;
  clientCalendarItems: ClientCalendarItemsSet;
  clientFeatures: Maybe<Array<Maybe<ClientFeature>>>;
  clientInvoice: Maybe<ClientInvoiceNode>;
  clientInvoices: Maybe<ClientInvoiceNodeConnection>;
  clientManagedInvoice: Maybe<ClientManagedInvoiceNode>;
  clientManagedInvoices: Maybe<ClientManagedInvoiceNodeConnection>;
  clientMetrics: Maybe<ClientMetricsNode>;
  clientOrganization: Maybe<ClientOrganizationNode>;
  clientOrganizationMembers: Maybe<ClientOrganizationMemberNodeConnection>;
  clientOrganizations: Maybe<ClientOrganizationNodeConnection>;
  clientPreferredSpendThreshold: Maybe<ClientPreferredSpendThresholdNode>;
  clientReport: Maybe<ClientReportNode>;
  clientReportSchedule: Maybe<ClientReportScheduleNode>;
  clientReportSchedules: Maybe<ClientReportScheduleNodeConnection>;
  clientReports: Maybe<ClientReportNodeConnection>;
  clientStaffSchedules: Array<ClientStaffSchedule>;
  clientStatements: Maybe<ClientMonthlyStatementNodeConnection>;
  clientVendorRelationships: Maybe<ClientVendorRelationshipNodeConnection>;
  combinedCustomer: Maybe<CombinedCustomerNode>;
  combinedCustomers: Maybe<CombinedCustomerNodeConnection>;
  combinedFacilities: Maybe<CombinedFacilityNodeConnection>;
  combinedFacility: Maybe<CombinedFacilityNode>;
  combinedVendorInvoice: Maybe<CombinedVendorInvoiceNode>;
  combinedVendorInvoices: Maybe<CombinedVendorInvoiceNodeConnection>;
  combinedWorkOrder: Maybe<CombinedWorkOrderNode>;
  combinedWorkOrders: Maybe<CombinedWorkOrderNodeConnection>;
  contactInquiries: Maybe<ContactInquiryNodeConnection>;
  contactInquiry: Maybe<ContactInquiryNode>;
  coordinator: Maybe<CoordinatorNode>;
  coordinatorUsers: Maybe<UserNodeConnection>;
  countries: Maybe<CountryNodeConnection>;
  customerMatchSet: CustomerMatchSet;
  dailyMenuIncidents: Maybe<IncidentConnection>;
  defaultMarkupLineItem: Maybe<RecordOfWorkDefaultLineItemNode>;
  defaultRevShareLineItem: Maybe<RecordOfWorkDefaultLineItemNode>;
  defaultVendorRevenueShare: Maybe<DefaultVendorRevenueShareNode>;
  defaultVendorRevenueShareOverride: Maybe<DefaultVendorRevenueShareOverrideNode>;
  defaultVendorRevenueShareOverrides: Maybe<DefaultVendorRevenueShareOverrideNodeConnection>;
  defaultVendorRevenueShares: Maybe<DefaultVendorRevenueShareNodeConnection>;
  determineTroubleshootingPlan: Maybe<DetermineTroubleshootingPlanNode>;
  deviceConfigs: Array<DeviceConfig>;
  deviceData: DeviceDataSet;
  devices: Array<Device>;
  djangoGroups: Maybe<DjangoGroupNodeConnection>;
  djangoPermissions: Maybe<DjangoPermissionNodeConnection>;
  effectiveOffers: Array<EffectiveOfferNode>;
  ephemeralAccountingIntegrationCustomers: Array<AccountingIntegrationCustomerNode>;
  equipment: Maybe<EquipmentNode>;
  equipmentCategories: Maybe<EquipmentCategoryNodeConnection>;
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  equipmentManufacturer: Maybe<EquipmentManufacturerNode>;
  equipmentManufacturers: Maybe<EquipmentManufacturerNodeConnection>;
  equipments: Maybe<EquipmentNodeConnection>;
  escalationChannels: Array<EscalationChannelType>;
  expectedServiceTimelines: Array<ExpectedServiceTimelineType>;
  experimentVariant: Maybe<VariantNode>;
  externalBankAccount: Maybe<ExternalBankAccountNode>;
  externalBankAccounts: Maybe<ExternalBankAccountNodeConnection>;
  facilities: Maybe<FacilityNodeConnection>;
  facilitiesOutsideVendorOperatingArea: Array<FacilityNode>;
  facility: Maybe<FacilityNode>;
  facilityGroup: Maybe<FacilityGroupNode>;
  facilityGroupSelection: Maybe<FacilityGroupSelectionNode>;
  facilityGroupSelections: Maybe<FacilityGroupSelectionNodeConnection>;
  facilityGroupSpend: Array<FacilityGroupSpendNode>;
  facilityGroups: Maybe<FacilityGroupNodeConnection>;
  facilityVendorRelationships: Maybe<FacilityVendorRelationshipNodeConnection>;
  fastpaySurprises: Maybe<FastPaySurpriseNodeConnection>;
  favouriteVendorConfigurations: Maybe<FavouriteVendorConfigurationNodeConnection>;
  featureFlags: Array<Scalars['String']['output']>;
  featureTier: Maybe<FeatureTierNode>;
  featureTiers: Maybe<FeatureTierNodeConnection>;
  financedInvoice: Maybe<FinancedInvoiceNode>;
  financedInvoices: Maybe<FinancedInvoiceNodeConnection>;
  gatewayClientOrganizations: Array<ClientOrganizationNode>;
  gateways: Array<Gateway>;
  glCode: Maybe<GlCodeNode>;
  glCodes: Maybe<GlCodeNodeConnection>;
  globalSearch: Maybe<Array<SearchResult>>;
  googleBusinessConnectionStatuses: Array<GoogleBusinessConnectionStatus>;
  hasOverdueUnresolvedDisputedInvoices: Scalars['Boolean']['output'];
  inboundVendorInvoiceExtraction: Maybe<InboundVendorInvoiceExtractionNode>;
  inboundVendorInvoiceExtractions: Maybe<InboundVendorInvoiceExtractionNodeConnection>;
  inboundVendorInvoiceValidation: Maybe<InboundVendorInvoiceValidationNode>;
  inboundVendorInvoices: Maybe<InboundVendorInvoiceNodeConnection>;
  inboxItem: Maybe<InboxItemNode>;
  inboxItems: Maybe<InboxItemNodeConnection>;
  incident: Incident;
  incidents: Maybe<IncidentConnection>;
  internalAppointment: Maybe<InternalAppointmentNode>;
  internalAppointments: Maybe<InternalAppointmentNodeConnection>;
  internalRequest: Maybe<InternalRequestNode>;
  internalRequests: Maybe<InternalRequestNodeConnection>;
  invite: Maybe<InviteNode>;
  invites: Maybe<InviteNodeConnection>;
  invoiceApprovalSettings: Maybe<InvoiceApprovalSettings>;
  invoiceBatchCharge: Maybe<InvoiceBatchChargeNode>;
  invoiceBatchCharges: Maybe<InvoiceBatchChargeNodeConnection>;
  invoiceEmailRecord: Maybe<InvoiceEmailRecordNode>;
  /** List and filter invoice email records */
  invoiceEmailRecords: Maybe<InvoiceEmailRecordNodeConnection>;
  invoiceLevelFees: Maybe<InvoiceLevelFeesNode>;
  invoicePaymentsPreview: Maybe<InvoicePaymentPreview>;
  invoiceSet: Maybe<InvoiceSetNode>;
  invoiceSetDispute: Maybe<InvoiceSetDisputeNode>;
  invoiceSetDisputes: Maybe<InvoiceSetDisputeNodeConnection>;
  invoiceSetNotes: Maybe<InvoiceSetNoteNodeConnection>;
  invoiceSets: Maybe<InvoiceSetNodeConnection>;
  isExpectedServiceTimelineValid: Scalars['Boolean']['output'];
  isPayoutOfferEligible: Maybe<Scalars['Boolean']['output']>;
  isVendorTosReconfirmDeadlinePassed: Scalars['Boolean']['output'];
  issuedProduct: Maybe<IssuedProductNode>;
  issuedProducts: Maybe<IssuedProductNodeConnection>;
  jobChangeSuggestions: Maybe<VendorJobChangeSuggestionNodeConnection>;
  jobCounts: Maybe<VendorJobCountNode>;
  kustomerWorkOrderEscalation: Maybe<KustomerWorkOrderEscalationNode>;
  languages: Array<LanguageType>;
  lead: Maybe<LeadNode>;
  leadInboundRequest: Maybe<LeadInboundRequestNode>;
  leadInboundRequestActionRequiredCount: Scalars['Int']['output'];
  leadInboundRequestConversionData: Maybe<LeadInboundRequestConversionDataType>;
  leadInboundRequests: Maybe<LeadInboundRequestNodeConnection>;
  leads: Maybe<LeadNodeConnection>;
  lendingOffer: Maybe<LendingOfferNode>;
  lendingOffers: Maybe<LendingOfferNodeConnection>;
  lendingOnboarding: Maybe<LendingOnboardingNode>;
  lendingOnboardings: Maybe<LendingOnboardingNodeConnection>;
  locationAddressResolution: Maybe<LocationAddressResolutionNode>;
  locationAddressResolutions: Maybe<LocationAddressResolutionNodeConnection>;
  maintenancePlan: Maybe<MaintenancePlanNode>;
  maintenancePlanNotesTemplatePreview: Maybe<Scalars['String']['output']>;
  maintenancePlanType: Maybe<MaintenancePlanTypeNode>;
  maintenancePlanTypes: Maybe<MaintenancePlanTypeNodeConnection>;
  maintenancePlans: Maybe<MaintenancePlanNodeConnection>;
  market: Maybe<MarketNode>;
  markets: Maybe<MarketNodeConnection>;
  markupInvoiceValidation: Maybe<InvoiceValidationNode>;
  markupQuoteValidation: Maybe<QuoteValidationNode>;
  matchingPayoutOffer: Maybe<PayoutOfferNode>;
  me: Maybe<UserNode>;
  miscellaneousHolds: Maybe<MiscellaneousHoldConnection>;
  myPinnedEntities: Maybe<PinnedEntityNodeConnection>;
  nondeactivatedVendors: Maybe<NonDeactivatedVendorOrganizationNodeConnection>;
  noraCallEvaluation: Maybe<NoraCallEvaluationNode>;
  noraCallEvaluations: Maybe<NoraCallEvaluationNodeConnection>;
  noraEnabledVendors: Array<VendorOrganizationNode>;
  noraGreetingExperimentResults: Array<NoraGreetingExperimentResultType>;
  notifications: Array<NotificationSkeleton>;
  oauthCredential: Maybe<OAuthCredentialNode>;
  offResqAppointment: Maybe<OffResqAppointmentNode>;
  offResqAppointments: Maybe<OffResqAppointmentNodeConnection>;
  offResqCustomer: Maybe<OffResqCustomerNode>;
  offResqCustomers: Maybe<OffResqCustomerNodeConnection>;
  /** Predefined off-resq roles for assigning facility/customer users. */
  offResqRoles: Array<RoleNode>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  offResqWorkOrders: Maybe<OffResqWorkOrderNodeConnection>;
  offer: Maybe<OfferNode>;
  offers: Maybe<OfferNodeConnection>;
  onboardingAction: Maybe<OnboardingActionNode>;
  onboardingActions: Maybe<OnboardingActionNodeConnection>;
  operatingArea: Maybe<OperatingAreaNode>;
  operatingAreas: Maybe<OperatingAreaNodeConnection>;
  organizationFeatures: Maybe<OrganizationFeaturesNode>;
  outsourceUsers: Maybe<UserNodeConnection>;
  outstandingBalance: Maybe<OutstandingBalanceNode>;
  outstandingBalances: Maybe<OutstandingBalanceNodeConnection>;
  overtimeStatus: Maybe<OvertimeStatus>;
  partneredEstimateSubmission: Maybe<PartneredEstimateSubmissionNode>;
  partneredInvoiceSubmission: Maybe<PartneredInvoiceSubmissionNode>;
  payment: Maybe<PaymentNode>;
  paymentMethod: Maybe<PaymentMethodNode>;
  paymentMethods: Maybe<PaymentMethodNodeConnection>;
  payments: Maybe<PaymentNodeConnection>;
  payoutOffer: Maybe<PayoutOfferNode>;
  payoutOfferHistories: Maybe<PayoutOfferHistoryNodeConnection>;
  payoutOfferHistory: Maybe<PayoutOfferHistoryNode>;
  payoutOffers: Maybe<PayoutOfferNodeConnection>;
  perUserSubscription: Maybe<PerUserSubscriptionNode>;
  perUserSubscriptionConfiguration: Maybe<PerUserSubscriptionConfigurationNode>;
  perUserSubscriptionConfigurations: Maybe<PerUserSubscriptionConfigurationNodeConnection>;
  perUserSubscriptions: Maybe<PerUserSubscriptionNodeConnection>;
  preventativeMaintenance: Maybe<PreventativeMaintenanceNode>;
  preventativeMaintenances: Maybe<PreventativeMaintenanceNodeConnection>;
  previouslyHiredVendors: PreviouslyHiredVendorsNode;
  priceBookCategories: Maybe<PriceBookCategoryNodeConnection>;
  priceBookCategory: Maybe<PriceBookCategoryNode>;
  priceBookItem: Maybe<PriceBookItemNode>;
  priceBookItems: Maybe<PriceBookItemNodeConnection>;
  priceRateOverride: Maybe<PriceRateOverrideNode>;
  priceRateOverrides: Maybe<PriceRateOverrideNodeConnection>;
  pricingModel: Maybe<PricingModelNode>;
  pricingModels: Maybe<PricingModelNodeConnection>;
  project: Maybe<ProjectNode>;
  projects: Maybe<ProjectNodeConnection>;
  proposal: Maybe<ProposalNode>;
  proposalComment: Maybe<ProposalCommentNode>;
  proposalComments: Maybe<ProposalCommentNodeConnection>;
  proposals: Maybe<ProposalNodeConnection>;
  protectionPlanCoverageUsage: Maybe<ProtectionPlanCoverageUsageType>;
  protectionPlanEnrollments: Maybe<ProtectionPlanEnrollmentNodeConnection>;
  provinces: Maybe<ProvinceNodeConnection>;
  quote: Maybe<QuoteNode>;
  quoteAcceptanceSettings: Maybe<QuoteAcceptanceSettings>;
  quoteApprovalThreshold: Maybe<QuoteApprovalThresholdNode>;
  quoteApprovalThresholds: Maybe<QuoteApprovalThresholdNodeConnection>;
  quoteSet: Maybe<QuoteSetNode>;
  quoteSets: Maybe<QuoteSetNodeConnection>;
  quoteSpendThreshold: Scalars['Decimal']['output'];
  quotes: Maybe<QuoteNodeConnection>;
  realMe: Maybe<UserNode>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  recordOfWorkRevenueShareValues: Maybe<RecordOfWorkRevenueShareValuesNode>;
  recordsOfWork: Maybe<RecordOfWorkNodeConnection>;
  release: Maybe<ReleaseNode>;
  releases: Maybe<ReleaseNodeConnection>;
  remittanceStatement: Maybe<RemittanceStatementNode>;
  remittanceStatements: Maybe<RemittanceStatementNodeConnection>;
  reportFilter: Maybe<ReportFilterNode>;
  reportFilters: Maybe<ReportFilterNodeConnection>;
  reportInstance: Maybe<ReportInstanceNode>;
  reportInstances: Maybe<ReportInstanceNodeConnection>;
  reportPreview: Maybe<ReportPreviewNode>;
  reportTemplate: Maybe<ReportTemplateNode>;
  reportTemplates: Maybe<ReportTemplateNodeConnection>;
  resqService: Maybe<ResqServiceNode>;
  resqServices: Maybe<ResqServiceNodeConnection>;
  revShareInvoiceValidation: Maybe<InvoiceValidationNode>;
  revShareQuoteValidation: Maybe<QuoteValidationNode>;
  revenueShareOverride: Maybe<RevenueShareOverrideNode>;
  revenueShareOverrides: Maybe<RevenueShareOverrideNodeConnection>;
  reviewRequests: Maybe<ReviewRequestNodeConnection>;
  role: Maybe<RoleNode>;
  roles: Maybe<RoleNodeConnection>;
  rsgCyovComparisonMetrics: RsgCyovComparisonMetrics;
  rsgEmergencyAssistMetrics: RsgEmergencyAssistMetrics;
  rsgPmMissingCoverageGaps: Array<RsgPmMissingCoverageGap>;
  ruleViolations: Maybe<RuleViolationsNodeConnection>;
  salesforceClientAccountResult: Maybe<SalesforceClientAccountResult>;
  salesforceClientExpansionPosibilities: Maybe<SalesforceClientExpansionPossibilities>;
  salesforceVendorAccountResult: Maybe<SalesforceVendorAccountResult>;
  schedulingRequests: Maybe<SchedulingRequestConnection>;
  schemaHash: Scalars['String']['output'];
  sensorHealthDashboard: SensorHealthDashboard;
  serviceCategories: Array<ServiceCategoryNode>;
  /** Preview a service order (calculate totals with taxes). Read-only operation. */
  serviceOrderPreview: Maybe<ServiceOrderPreviewOutput>;
  serviceableFacilities: Array<FacilityNode>;
  skill: Maybe<SkillNode>;
  skills: Maybe<SkillNodeConnection>;
  sourcingPartsHolds: Maybe<SourcingPartsHoldConnection>;
  spendApproval: Maybe<SpendApprovalNode>;
  spendApprovalOnWorkOrder: Maybe<SpendApprovalNode>;
  spendApprovalPreferences: Maybe<SpendApprovalPreferenceNodeConnection>;
  spendApprovals: Maybe<SpendApprovalNodeConnection>;
  spendItemAllocation: SpendItemAllocationNode;
  stripeCustomer: Maybe<StripeCustomerNode>;
  stripeCustomers: Maybe<StripeCustomerNodeConnection>;
  subcontractSettlementInvoice: Maybe<SubcontractSettlementInvoiceNode>;
  subcontractSettlementInvoices: Maybe<SubcontractSettlementInvoiceNodeConnection>;
  subcontractSettlementRemittanceStatement: Maybe<SubcontractSettlementRemittanceStatementNode>;
  subcontractSettlementRemittanceStatements: Maybe<SubcontractSettlementRemittanceStatementNodeConnection>;
  subcontractorShareTierSelections: Maybe<SubcontractorShareTierSelectionsType>;
  subscription: Maybe<SubscriptionNode>;
  subscriptions: Maybe<SubscriptionNodeConnection>;
  targetVendorEntitlements: Maybe<TargetVendorEntitlementsType>;
  taxRates: Maybe<TaxRateNodeConnection>;
  taxonomyNodes: Array<TaxonomyNodeNode>;
  technicians: Maybe<UserNodeConnection>;
  trades: Maybe<TradeNodeConnection>;
  tradesCustomerInvoicePayout: Maybe<TradesCustomerInvoicePayoutNode>;
  tradesCustomerInvoicePayouts: Maybe<TradesCustomerInvoicePayoutNodeConnection>;
  tradesCustomerInvoicePreview: Maybe<TradesCustomerInvoicePreviewOutput>;
  troubleshootingPlan: Maybe<TroubleshootingPlanNode>;
  user: Maybe<UserNode>;
  userNotificationPreferences: Maybe<UserNotificationPreferenceConnection>;
  userTags: Maybe<UserTagNodeConnection>;
  users: Maybe<UserNodeConnection>;
  validateAddress: Maybe<AddressValidation>;
  vapiOverdueInvoicesCallResult: Maybe<VapiOverdueInvoicesCallResultNode>;
  vapiOverdueInvoicesCallResults: Maybe<VapiOverdueInvoicesCallResultNodeConnection>;
  vapiOverdueInvoicesCallSuccessEvaluation: Maybe<VapiOverdueInvoicesCallSuccessEvaluationNode>;
  vapiOverdueInvoicesCallSuccessEvaluations: Maybe<VapiOverdueInvoicesCallSuccessEvaluationNodeConnection>;
  vendorAssignments: Maybe<VendorAssignmentNodeConnection>;
  vendorBusinessProfile: Maybe<VendorBusinessProfileNode>;
  vendorBusinessProfiles: Maybe<VendorBusinessProfileNodeConnection>;
  vendorBusinessReview: Maybe<VendorBusinessReviewNode>;
  vendorDispatchRequest: Maybe<VendorDispatchRequestNode>;
  vendorDispatchRequests: Maybe<VendorDispatchRequestNodeConnection>;
  vendorEquipmentCapabilities: Maybe<VendorEquipmentCapabilityNodeConnection>;
  vendorEquipmentCapability: Maybe<VendorEquipmentCapabilityNode>;
  vendorEquipmentCapabilitySuggestionRejection: Maybe<VendorEquipmentCapabilitySuggestionRejectionNode>;
  vendorEquipmentCapabilitySuggestionRejections: Maybe<VendorEquipmentCapabilitySuggestionRejectionNodeConnection>;
  vendorEquipmentCapabilitySuggestions: Maybe<Array<VendorEquipmentCapabilitySuggestionType>>;
  vendorEquipmentServiceHistory: Maybe<Array<VendorEquipmentServiceHistoryNode>>;
  vendorFacilityInvites: Maybe<VendorFacilityInviteNodeConnection>;
  vendorGrowthHubOverview: Maybe<VendorGrowthHubOverviewType>;
  vendorIncomingJobs: Maybe<VendorIncomingJobNodeConnection>;
  vendorInvoice: Maybe<VendorInvoiceNode>;
  vendorInvoices: Maybe<VendorInvoiceNodeConnection>;
  vendorMailInsights: Maybe<VendorMailInsights>;
  vendorMatches: VendorMatchSet;
  vendorMembers: Maybe<VendorMemberNodeConnection>;
  vendorMetrics: Maybe<VendorMetricsNode>;
  vendorOrganization: Maybe<VendorOrganizationNode>;
  vendorOverdueInvoices: Maybe<VendorOverdueInvoicesNode>;
  vendorPayout: Maybe<VendorPayoutNode>;
  vendorPerformanceProfile: Maybe<VendorPerformanceProfile>;
  vendorPlans: Maybe<VendorPlanNodeConnection>;
  vendorPriceRate: Maybe<VendorPriceRateNode>;
  vendorPriceRates: Maybe<VendorPriceRateNodeConnection>;
  vendorPromotion: Maybe<VendorPromotionNode>;
  vendorPromotions: Maybe<VendorPromotionNodeConnection>;
  vendorRanking: Maybe<VendorRankingNode>;
  vendorRankingEntry: Maybe<VendorRankingEntryNode>;
  vendorRankingForFacilityAndServiceCategories: Maybe<VendorRankingForFacilityAndServiceCategoryNodeConnection>;
  vendorReport: Maybe<VendorReportNode>;
  vendorReportSchedule: Maybe<VendorReportScheduleNode>;
  vendorReportSchedules: Maybe<VendorReportScheduleNodeConnection>;
  vendorReports: Maybe<VendorReportNodeConnection>;
  vendorRevenueShare: Maybe<VendorRevenueShareNode>;
  vendorRevenueShares: Maybe<VendorRevenueShareNodeConnection>;
  vendorReviewSummary: Maybe<VendorReviewSummary>;
  vendorSlaPolicy: Maybe<VendorSlaPolicyVersionType>;
  vendorSlaPolicyVersions: Array<VendorSlaPolicyVersionType>;
  vendorSlaRuleCatalog: Array<VendorSlaRuleCatalogRuleType>;
  vendorSubcontractPairings: Array<VendorSubcontractPairingType>;
  vendorSubcontractPairingsForVendor: Array<VendorSubcontractPairingType>;
  vendorTosReconfirmDeadline: Maybe<Scalars['DateTime']['output']>;
  vendorWebsite: Maybe<VendorWebsiteNode>;
  vendorWebsiteAnalyticsOverview: Maybe<VendorWebsiteAnalyticsOverview>;
  vendorWebsiteMonitorHealth: Array<VendorWebsiteMonitorInventoryRowType>;
  vendorWebsiteMonitorInventory: VendorWebsiteMonitorInventoryConnection;
  vendorWebsiteSearchConsoleAudit: VendorWebsiteSearchConsoleAuditType;
  vendorWebsites: Maybe<VendorWebsiteNodeConnection>;
  vendorWorkOrderInternalNotes: Maybe<VendorWorkOrderInternalNoteNodeConnection>;
  vendors: Maybe<VendorOrganizationNodeConnection>;
  verifiedVendors: Maybe<VerifiedVendorNodeConnection>;
  verifyFacilityAddress: Maybe<VerifyFacilityAddressNode>;
  verifyLocationAddress: Maybe<VerifyLocationAddressNode>;
  verifyOrganizationAddresses: Maybe<VerifyOrganizationAddressesNode>;
  visitReviewRequests: Maybe<VisitReviewRequestNodeConnection>;
  visits: Maybe<VisitNodeConnection>;
  workOrder: Maybe<WorkOrderNode>;
  workOrderCancellationDetail: Maybe<WorkOrderCancellationDetailNodeConnection>;
  workOrderCancellationReasons: Array<WorkOrderCancellationReasonType>;
  workOrderComments: Maybe<CommentNodeConnection>;
  workOrderCountsForCoordinatorStatuses: WorkOrderCountsByCoordinatorStatus;
  workOrderCountsForCyovDispatches: WorkOrderCountsByCyovDispatches;
  workOrderEscalation: Maybe<WorkOrderEscalationNode>;
  workOrderEscalationReasons: Array<WorkOrderEscalationReasonType>;
  workOrderEscalations: Maybe<WorkOrderEscalationNodeConnection>;
  workOrderExpenseType: Maybe<WorkOrderExpenseTypeNode>;
  workOrderInternalNotes: Maybe<WorkOrderInternalNoteNodeConnection>;
  workOrderNavCounts: Maybe<WorkOrderNavCounts>;
  workOrderNote: Maybe<WorkOrderNoteNode>;
  workOrderNotes: Maybe<WorkOrderNoteNodeConnection>;
  workOrderObserverTypes: Array<WorkOrderObserverTypeType>;
  workOrderPendingReview: Maybe<WorkOrderNode>;
  workOrderPriorities: Maybe<WorkOrderPriorityNodeConnection>;
  workOrderProtectionPlanCoverageUsage: Maybe<ProtectionPlanCoverageUsageType>;
  workOrderReviewFeedback: Maybe<WorkOrderReviewFeedbackNodeConnection>;
  workOrderReviews: Maybe<WorkOrderReviewNodeConnection>;
  workOrderSchedulingSla: Maybe<Scalars['DateTime']['output']>;
  workOrderSchedulingViolations: Maybe<Array<SchedulingViolation>>;
  workOrderStatusSuggestion: Maybe<WorkOrderStatusSuggestion>;
  workOrderSummaries: Maybe<WorkOrderSummaryNodeConnection>;
  workOrderTeamMemberAssignment: Maybe<WorkOrderTeamMemberAssignmentNode>;
  workOrderVendorEligibilityProfiles: Maybe<WorkOrderVendorEligibilityProfileNodeConnection>;
  workOrders: Maybe<WorkOrderNodeConnection>;
};


export type QueryAccountingIntegrationCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountingIntegrationCustomersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  exported?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  integrationTypes?: InputMaybe<Array<InputMaybe<OAuthIntegrationType>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccountingIntegrationInvoiceArgs = {
  externalInvoiceId: Scalars['String']['input'];
  integrationType: OAuthIntegrationType;
  vendorId: Scalars['ID']['input'];
};


export type QueryAccountingIntegrationInvoicePdfArgs = {
  externalInvoiceId: Scalars['String']['input'];
  integrationType: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};


export type QueryAccountingIntegrationInvoicesArgs = {
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationType: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryActivitiesArgs = {
  activityType_In?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facilityId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isOvertimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isSnoozed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  opsOwnerId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewType_In?: InputMaybe<Array<InputMaybe<ResqReviewActivityReviewType>>>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActivityFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entryType?: InputMaybe<ActivityFeedEntryEntryType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isVendor?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdBannerStatsArgs = {
  slugs: Array<Scalars['String']['input']>;
};


export type QueryAgentMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userTypes?: InputMaybe<Array<NoraUserType>>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAiModelAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAlertsArgs = {
  params: GetAllAlertsInput;
};


export type QueryAllGatewaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GatewayStatusFilter>;
};


export type QueryAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  budgetId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Array<InputMaybe<Currency>>>;
  dueAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  dueAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPdf?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ApBatchStatus>>>;
  vendorOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApBlockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blockedAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  blockedAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOutcome?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Array<InputMaybe<Outcome>>>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startsAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  startsAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attachedTo: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableReceptionPhoneNumbersArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tollFree?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryAvailableTestimonialsArgs = {
  vendorBusinessProfileId: Scalars['ID']['input'];
};


export type QueryAvailableVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankAccountRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankAccountRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  amount_Gt?: InputMaybe<Scalars['Decimal']['input']>;
  amount_Lt?: InputMaybe<Scalars['Decimal']['input']>;
  bankAccount?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBarcodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBarcodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attachedTo?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBatchPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryBillingInformationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingInformationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBudgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBusinessUnitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculatedMarkupInvoiceFiguresArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  lineItems: Array<MarkupInputLineItemType>;
  recordOfWorkId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
};


export type QueryCalculatedRevShareInvoiceFiguresArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  lineItems: Array<RevShareInputLineItemType>;
  recordOfWorkId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
};


export type QueryCanRecommendPreventativeMaintenanceArgs = {
  facilityId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
  vendorId: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckMemberRoleChangeImpactArgs = {
  memberId: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};


export type QueryCheckNotificationSettingsArgs = {
  checkingLevel?: InputMaybe<NotificationCheckingLevelEnum>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckPerUserSubscriptionImpactArgs = {
  invites: Array<PerUserSubscriptionInviteInput>;
  organizationId: Scalars['ID']['input'];
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientCalendarItemsArgs = {
  input: GetClientCalendarItemsSetInput;
};


export type QueryClientFeaturesArgs = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  approvedAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  clientOrganization_PaymentPreference_PaymentMethod?: InputMaybe<PaymentMethodType>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  expenseTypes?: InputMaybe<Array<InputMaybe<ExpenseType>>>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceCategory?: InputMaybe<Array<InputMaybe<InvoiceCategoryEnum>>>;
  invoiceSet_OffResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  invoiceType?: InputMaybe<Array<InputMaybe<InvoiceTypeEnum>>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscriptionInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<ClientInvoiceStatus>>>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientManagedInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientManagedInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<ClientManagedInvoiceStatus>>>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
  workOrder_ClientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientMetricsArgs = {
  clientId: Scalars['ID']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  lastPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  userTz?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientOrganizationMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeClientUsersWithResqEmails?: InputMaybe<Scalars['Boolean']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hideAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyColleaguesOfUser?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Permission>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryClientOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientPreferredSpendThresholdArgs = {
  organizationId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
};


export type QueryClientReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientReportScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientReportSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<ClientReportType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientStaffSchedulesArgs = {
  queryInput: GetClientStaffSchedulesInput;
};


export type QueryClientStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessUnit?: InputMaybe<Scalars['ID']['input']>;
  businessUnit_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryClientVendorRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFavourites?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inviteStatus?: InputMaybe<InviteStatus>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCombinedCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCombinedCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CombinedCustomerEntityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCombinedFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  entityType?: InputMaybe<EntityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstServicedEndDate?: InputMaybe<Scalars['Date']['input']>;
  firstServicedStartDate?: InputMaybe<Scalars['Date']['input']>;
  hasClientRelationshipOrAllServiceable?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientRelationshipOrServiceable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  payoutSpeed?: InputMaybe<Array<InputMaybe<ResqServiceName>>>;
  proposalPickerVendorId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  standaloneQuoteVendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCombinedFacilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCombinedVendorInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCombinedVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  deliveryMethod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dueAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  dueAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOverdueStandardPayout?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['Int']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<VendorInvoiceStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPayoutStatus?: InputMaybe<Array<InputMaybe<WorkOrderVendorPayoutStatus>>>;
  workOrderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCombinedWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCombinedWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  canCreateEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  completedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  creationSource_In?: InputMaybe<Array<InputMaybe<WorkOrderCreationSource>>>;
  entityType?: InputMaybe<CombinedWorkOrderEntityType>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppliedProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnresolvedRuleViolations?: InputMaybe<Scalars['Boolean']['input']>;
  holdReason_In?: InputMaybe<Array<InputMaybe<WorkOrderHoldReason>>>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdueForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  isPinnedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  isWithinAppointmentWindow?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  needsInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  needsScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  relationshipSource?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  requiresPartneredFinancialTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledForEnd?: InputMaybe<Scalars['Date']['input']>;
  scheduledForStart?: InputMaybe<Scalars['Date']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_Icontains?: InputMaybe<Scalars['String']['input']>;
  submittedById?: InputMaybe<Scalars['ID']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorStatus_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContactInquiriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactInquiryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoordinatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoordinatorUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerMatchSetArgs = {
  forceFacilityId?: InputMaybe<Scalars['ID']['input']>;
  forceOffResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  integrationCustomerId?: InputMaybe<Scalars['ID']['input']>;
  integrationType?: InputMaybe<OAuthIntegrationType>;
  invoicePdfData?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDailyMenuIncidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  configIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  readingType?: InputMaybe<DeviceConfigReadingType>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
};


export type QueryDefaultMarkupLineItemArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  newLineItem: MarkupInputLineItemType;
  notes?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryDefaultRevShareLineItemArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  newLineItem: RevShareInputLineItemType;
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDefaultVendorRevenueShareArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultVendorRevenueShareOverrideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultVendorRevenueShareOverridesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryDefaultVendorRevenueSharesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDetermineTroubleshootingPlanArgs = {
  clientId: Scalars['ID']['input'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxonomyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeviceConfigsArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeviceDataArgs = {
  params: GetDeviceDataInput;
};


export type QueryDevicesArgs = {
  params: GetAllDevicesInput;
};


export type QueryDjangoGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasGlobalPermission?: InputMaybe<Scalars['Boolean']['input']>;
  includeInternalCoordinator?: InputMaybe<Scalars['Boolean']['input']>;
  includeOnlyOutsourceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDjangoPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEffectiveOffersArgs = {
  resqServiceNames: Array<ResqServiceName>;
  vendorId: Scalars['ID']['input'];
};


export type QueryEphemeralAccountingIntegrationCustomersArgs = {
  integrationType: OAuthIntegrationType;
  vendorId: Scalars['ID']['input'];
};


export type QueryEquipmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Scalars['String']['input']>;
  showNotCategorized?: InputMaybe<Scalars['Boolean']['input']>;
  showOther?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEquipmentCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentManufacturerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentManufacturersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  showGeneric?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEquipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Istartswith?: InputMaybe<Scalars['String']['input']>;
  equipmentCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  equippedFacilities_Id?: InputMaybe<Scalars['ID']['input']>;
  equippedFacilities_Organization?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facility_Id?: InputMaybe<Scalars['ID']['input']>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facility_Organization?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOngoingIncident?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensor?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelNo?: InputMaybe<Scalars['String']['input']>;
  offResqFacility_Id?: InputMaybe<Scalars['ID']['input']>;
  offResqFacility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceEndDate?: InputMaybe<Scalars['Date']['input']>;
  serviceStartDate?: InputMaybe<Scalars['Date']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<EquipmentStatus>>>;
};


export type QueryExpectedServiceTimelinesArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryExperimentVariantArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  experimentName: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExternalBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExternalBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRelationshipWithVendorId?: InputMaybe<Scalars['ID']['input']>;
  hasWorkedWithVendorId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMissingBrd?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacilitiesOutsideVendorOperatingAreaArgs = {
  clientId: Scalars['ID']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};


export type QueryFacilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityGroupSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilityGroupSelectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityGroupSpendArgs = {
  budgetId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFacilityGroupsArgs = {
  activeFacilityOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  excludeLeaf?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupFacilityId?: InputMaybe<Scalars['ID']['input']>;
  groupUserId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrFacilityName?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFacilityVendorRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFastpaySurprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFavouriteVendorConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeatureFlagsArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeatureTierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureTiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pricingModel?: InputMaybe<Scalars['ID']['input']>;
  pricingModel_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFinancedInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFinancedInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<LenderProviderKey>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoicePaymentPlanId?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  updatedAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGatewayClientOrganizationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGlCodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGlobalSearchArgs = {
  q: Scalars['String']['input'];
};


export type QueryHasOverdueUnresolvedDisputedInvoicesArgs = {
  facilityId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};


export type QueryInboundVendorInvoiceExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundVendorInvoiceExtractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  autoApproveRejectionReason?: InputMaybe<Array<InputMaybe<InboundInvoiceAutoApproveRejectionReason>>>;
  autoApproved?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  customerType?: InputMaybe<Array<InputMaybe<CustomerTypeEnum>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inboundVendorInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  processingCompleteAfter?: InputMaybe<Scalars['DateTime']['input']>;
  processingCompleteBefore?: InputMaybe<Scalars['DateTime']['input']>;
  processingIssue?: InputMaybe<Array<InputMaybe<InboundInvoiceProcessingIssue>>>;
  provider?: InputMaybe<Array<InputMaybe<InvoiceExtractionProvider>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedById?: InputMaybe<Scalars['ID']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  retries_Gte?: InputMaybe<Scalars['Int']['input']>;
  retries_Lte?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Decimal']['input']>;
  total_Gte?: InputMaybe<Scalars['Decimal']['input']>;
  total_Lte?: InputMaybe<Scalars['Decimal']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderAwaitingCoordinatorApproval?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInboundVendorInvoiceValidationArgs = {
  invoiceFile: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};


export type QueryInboundVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInboxItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboxItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  itemTypes?: InputMaybe<Array<InputMaybe<InboxItemType>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIncidentArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  configIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  readingType?: InputMaybe<DeviceConfigReadingType>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<IncidentStatus>>;
  useUserFacilities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInternalAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Array<InputMaybe<InternalAppointmentOutcome>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryInternalRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIncompleteTasks?: InputMaybe<Scalars['Boolean']['input']>;
  isOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isUnscheduled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Array<InputMaybe<InternalRequestOutcome>>>;
  preventativeMaintenanceId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  teamMemberIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInviteArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QueryInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isOwnerInvite?: InputMaybe<Scalars['Boolean']['input']>;
  isVendorInvite?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoiceApprovalSettingsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryInvoiceBatchChargeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceBatchChargesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  resolvedAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  resolvedAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<InvoiceBatchChargeStatus>>>;
};


export type QueryInvoiceEmailRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceEmailRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inboundVendorInvoice?: InputMaybe<Scalars['ID']['input']>;
  inboundVendorInvoice_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInvoiceLevelFeesArgs = {
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoicePaymentsPreviewArgs = {
  workOrderIds: Array<Scalars['ID']['input']>;
};


export type QueryInvoiceSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceSetDisputeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceSetDisputesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientInvoices?: InputMaybe<Scalars['ID']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  disputedBy?: InputMaybe<Scalars['ID']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiredAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWorkOrder?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceSet?: InputMaybe<Scalars['ID']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  reasonEnum?: InputMaybe<InvoiceSetDisputeReason>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoiceSetNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoiceSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isInReview?: InputMaybe<Scalars['Boolean']['input']>;
  isOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqCustomer?: InputMaybe<Scalars['ID']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacility?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<InvoiceSetStatus>>>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
  workOrderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryIsExpectedServiceTimelineValidArgs = {
  expectedServiceTimeline: ExpectedServiceTimeline;
  facilityId: Scalars['ID']['input'];
  firstVisitExpectedArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryIsPayoutOfferEligibleArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIssuedProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIssuedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalBusinessId?: InputMaybe<Scalars['String']['input']>;
  externalIssuedProductId?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<Array<InputMaybe<LenderProviderKey>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lendingOfferId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobChangeSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJobCountsArgs = {
  today: Scalars['Date']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryKustomerWorkOrderEscalationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadInboundRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadInboundRequestActionRequiredCountArgs = {
  src?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryLeadInboundRequestConversionDataArgs = {
  extractionSetId?: InputMaybe<Scalars['ID']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
};


export type QueryLeadInboundRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  excludeResq?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeAllIntents?: InputMaybe<Scalars['Boolean']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  leadQuality?: InputMaybe<Scalars['String']['input']>;
  noraGreetingExperimentKey?: InputMaybe<Scalars['String']['input']>;
  noraGreetingVariantKey?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<LeadInboundRequestSrc>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLeadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LeadStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLendingOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLendingOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalOfferId?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<Array<InputMaybe<LenderProviderKey>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<LendingOfferStatus>>>;
};


export type QueryLendingOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLendingOnboardingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalProvider?: InputMaybe<Array<InputMaybe<LenderProviderKey>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  providerOrganizationRefId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<LendingOnboardingStatusEnum>>>;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  statusReason_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationAddressResolutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationAddressResolutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaintenancePlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaintenancePlanNotesTemplatePreviewArgs = {
  frequencyUnit: MaintenancePlanFrequencyUnit;
  frequencyValue: Scalars['Int']['input'];
  maintenancePlanTypeId: Scalars['ID']['input'];
  periodEndDate: Scalars['Date']['input'];
  template: Scalars['String']['input'];
};


export type QueryMaintenancePlanTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaintenancePlanTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaintenancePlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractEndDateEnd?: InputMaybe<Scalars['Date']['input']>;
  contractEndDateStart?: InputMaybe<Scalars['Date']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maintenancePlanType_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  nextWorkOrderCreationDateEnd?: InputMaybe<Scalars['Date']['input']>;
  nextWorkOrderCreationDateStart?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<MaintenancePlanStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMarketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryMarkupInvoiceValidationArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryMarkupQuoteValidationArgs = {
  lineItems?: InputMaybe<Array<MarkupInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryMatchingPayoutOfferArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryMiscellaneousHoldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyPinnedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityTypes?: InputMaybe<Array<PinnedEntityType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNondeactivatedVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_Istartswith?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  servicedClientId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNoraCallEvaluationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoraCallEvaluationsArgs = {
  actionCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callReceivedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  callReceivedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  callSid?: InputMaybe<Scalars['String']['input']>;
  callSid_Icontains?: InputMaybe<Scalars['String']['input']>;
  configComplianceCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationId_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  evaluatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  evaluatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  evaluationStatus?: InputMaybe<NoraCallEvaluationEvaluationStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  highestFindingSeverity?: InputMaybe<NoraCallEvaluationHighestFindingSeverity>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leadInboundRequestId?: InputMaybe<Scalars['ID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overallStatus?: InputMaybe<NoraCallEvaluationOverallStatus>;
  primaryIssueCategory?: InputMaybe<NoraCallEvaluationPrimaryIssueCategory>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewDecision?: InputMaybe<NoraCallEvaluationReviewDecision>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  urgencyCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  urgencyLevel?: InputMaybe<NoraCallEvaluationUrgencyLevel>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNoraEnabledVendorsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNoraGreetingExperimentResultsArgs = {
  experimentKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOauthCredentialArgs = {
  integrationType?: InputMaybe<OAuthIntegrationType>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOffResqAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOffResqAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  endsAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  endsAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startsAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  startsAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOffResqCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOffResqCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOffResqWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOffResqWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  combinedFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludePendingSubcontractInvites?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offResqFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<OffResqWorkOrderPriority>;
  priority_In?: InputMaybe<Array<InputMaybe<OffResqWorkOrderPriority>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<OffResqWorkOrderServiceCategory>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OffResqWorkOrderStatus>;
  status_In?: InputMaybe<Array<InputMaybe<OffResqWorkOrderStatus>>>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offerType?: InputMaybe<Array<InputMaybe<OfferType>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<Array<InputMaybe<PricingType>>>;
  resqServiceId?: InputMaybe<Scalars['ID']['input']>;
  resqService_Name_In?: InputMaybe<Array<InputMaybe<ResqServiceName>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOnboardingActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOperatingAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperatingAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  bbox?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  center?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_Istartswith?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<OperatingAreaStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationFeaturesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutsourceUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutstandingBalanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutstandingBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOvertimeStatusArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryPartneredEstimateSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartneredInvoiceSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentType?: InputMaybe<Array<InputMaybe<PaymentMethodPaymentType>>>;
  pendingDeletion?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchPaymentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  clientInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayoutOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutOfferHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  payoutLevel?: InputMaybe<Array<InputMaybe<PayoutLevel>>>;
  payoutOfferId?: InputMaybe<Scalars['ID']['input']>;
  payoutOffer_FacilityId?: InputMaybe<Scalars['ID']['input']>;
  payoutOffer_InvoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  payoutOffer_OffResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  payoutOffer_VendorId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayoutOfferHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPerUserSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPerUserSubscriptionConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPerUserSubscriptionConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resqServiceId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPerUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPreventativeMaintenanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPreventativeMaintenancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  teamMemberIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryPreviouslyHiredVendorsArgs = {
  clientId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryPriceBookCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPriceBookCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceBookItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceBookItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Scalars['Decimal']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sku_Icontains?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPriceRateOverrideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceRateOverridesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryPricingModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPricingModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<PricingModelName>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  projectType_In?: InputMaybe<Array<InputMaybe<ProjectType>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<ProjectStatus>>>;
};


export type QueryProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProposalCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProposalCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProposalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maintenancePlanId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProposalStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryProtectionPlanCoverageUsageArgs = {
  facilityId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
};


export type QueryProtectionPlanEnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProvincesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteAcceptanceSettingsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryQuoteApprovalThresholdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteApprovalThresholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Decimal']['input']>;
};


export type QueryQuoteSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<QuoteSetStatus>>>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordOfWorkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordOfWorkRevenueShareValuesArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecordsOfWorkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasUnresolvedRuleViolations?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RecordOfWorkStatus>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appName?: InputMaybe<AppName>;
  before?: InputMaybe<Scalars['String']['input']>;
  buildNumber?: InputMaybe<Scalars['Int']['input']>;
  buildNumber_Gte?: InputMaybe<Scalars['Int']['input']>;
  buildNumber_Lte?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minimumOtaCreatedAt_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumOtaCreatedAt_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOtaCreatedAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Platform>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  upgradeType?: InputMaybe<UpgradeType>;
};


export type QueryRemittanceStatementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRemittanceStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateGte?: InputMaybe<Scalars['Date']['input']>;
  dateLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportFilterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  datatype?: InputMaybe<Array<InputMaybe<ReportFilterDatatype>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  field_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Array<InputMaybe<ReportFilterOperator>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReportInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportInstancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryReportPreviewArgs = {
  organizationId: Scalars['ID']['input'];
  reportFields: Array<InputMaybe<Scalars['String']['input']>>;
  reportFilters: Array<InputMaybe<FilterInput>>;
  reportOrderBy: Scalars['String']['input'];
  reportType: ReportType;
};


export type QueryReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  description_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<ReportType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResqServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResqServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRevShareInvoiceValidationArgs = {
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  vendorNotes?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRevShareQuoteValidationArgs = {
  lineItems?: InputMaybe<Array<RevShareInputLineItemType>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryRevenueShareOverrideArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRevenueShareOverridesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDueForReminder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusIn?: InputMaybe<Array<InputMaybe<ReviewRequestStatus>>>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlySubsetOfUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  showAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRsgCyovComparisonMetricsArgs = {
  selectedVendorId: Scalars['ID']['input'];
};


export type QueryRsgPmMissingCoverageGapsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryRuleViolationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalesforceClientAccountResultArgs = {
  sfId: Scalars['String']['input'];
};


export type QuerySalesforceClientExpansionPosibilitiesArgs = {
  clientId: Scalars['ID']['input'];
};


export type QuerySalesforceVendorAccountResultArgs = {
  sfId: Scalars['String']['input'];
};


export type QuerySchedulingRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceCategoriesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  equipmentRelated?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  filterByVendorTradeQualifications?: InputMaybe<Scalars['Boolean']['input']>;
  submittable?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceOrderPreviewArgs = {
  businessUnitId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ServiceOrderLineItemInput>;
};


export type QueryServiceableFacilitiesArgs = {
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySourcingPartsHoldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySpendApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpendApprovalOnWorkOrderArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type QuerySpendApprovalPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpendApprovalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySpendItemAllocationArgs = {
  spendItemId: Scalars['ID']['input'];
};


export type QueryStripeCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStripeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubcontractSettlementInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubcontractSettlementInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coveredByProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  expectedPaymentEndDate?: InputMaybe<Scalars['Date']['input']>;
  expectedPaymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  issuedAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  paidAmountStatus?: InputMaybe<Scalars['String']['input']>;
  paidExternallyEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidExternallyStartDate?: InputMaybe<Scalars['Date']['input']>;
  parentVendorId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SubcontractSettlementInvoiceStatus>;
  status_In?: InputMaybe<Array<InputMaybe<SubcontractSettlementInvoiceStatus>>>;
  subcontractVendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubcontractSettlementRemittanceStatementArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubcontractSettlementRemittanceStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<SubcontractSettlementRemittanceStatementCurrency>;
  currency_In?: InputMaybe<Array<InputMaybe<SubcontractSettlementRemittanceStatementCurrency>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPdf?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subcontractVendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubcontractorShareTierSelectionsArgs = {
  invoiceAmount?: InputMaybe<Scalars['Decimal']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  selectedShareTierId?: InputMaybe<Scalars['Int']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasMissingPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpaidInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<InputMaybe<SubscriptionState>>>;
};


export type QueryTargetVendorEntitlementsArgs = {
  vendorTrackingId: Scalars['Int']['input'];
};


export type QueryTaxRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facility?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSet?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recordOfWork?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
  validTo_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTaxonomyNodesArgs = {
  serviceCategory: ServiceCategory;
};


export type QueryTechniciansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignableToWorkorder?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTradesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTradesCustomerInvoicePayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTradesCustomerInvoicePayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TradesCustomerInvoicePayoutStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTradesCustomerInvoicePreviewArgs = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  lineItems: Array<TradesCustomerInvoiceLineItemInput>;
};


export type QueryTroubleshootingPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateAddressArgs = {
  address: Scalars['String']['input'];
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVapiOverdueInvoicesCallResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVapiOverdueInvoicesCallResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callOutcome?: InputMaybe<OverdueInvoicesCallResultOutcomeEnum>;
  callSid?: InputMaybe<Scalars['String']['input']>;
  callSid_Icontains?: InputMaybe<Scalars['String']['input']>;
  clientInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  delayReason?: InputMaybe<Scalars['String']['input']>;
  delayReason_Icontains?: InputMaybe<Scalars['String']['input']>;
  delayTimeline?: InputMaybe<Scalars['String']['input']>;
  delayTimeline_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVapiOverdueInvoicesCallSuccessEvaluationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVapiOverdueInvoicesCallSuccessEvaluationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audioClarity?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callEndedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  callEndedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  callSid?: InputMaybe<Scalars['String']['input']>;
  callSid_Icontains?: InputMaybe<Scalars['String']['input']>;
  calledUserId?: InputMaybe<Scalars['ID']['input']>;
  clientInvoiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  correctness?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endedReason?: InputMaybe<Scalars['String']['input']>;
  endedReason_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phoneMenu?: InputMaybe<Scalars['Boolean']['input']>;
  phoneMenuNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  staysOnTopic?: InputMaybe<Scalars['Boolean']['input']>;
  userInteraction?: InputMaybe<Scalars['Boolean']['input']>;
  voicemail?: InputMaybe<Scalars['Boolean']['input']>;
  wrongContact?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVendorAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Array<InputMaybe<VendorAssignmentOutcome>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorBusinessProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorBusinessProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorBusinessReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorDispatchRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorDispatchRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<VendorDispatchRequestStatus>>>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorEquipmentCapabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  canPerformInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformRepairs?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manufacturerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  supportsWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorEquipmentCapabilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorEquipmentCapabilitySuggestionRejectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorEquipmentCapabilitySuggestionRejectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manufacturerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  originalSource?: InputMaybe<VendorEquipmentCapabilitySuggestionRejectionOriginalSource>;
  rejectedById?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorEquipmentCapabilitySuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorEquipmentServiceHistoryArgs = {
  equipmentId: Scalars['ID']['input'];
};


export type QueryVendorFacilityInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorGrowthHubOverviewArgs = {
  endAt: Scalars['DateTime']['input'];
  startAt: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorIncomingJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  codeOrOrgQuery?: InputMaybe<Scalars['String']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  dueAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  dueAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOverdueStandardPayout?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceSet_OffResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<InputMaybe<RelationshipSource>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<VendorInvoiceStatus>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPayoutStatus?: InputMaybe<Array<InputMaybe<WorkOrderVendorPayoutStatus>>>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
  workOrder_ClientId?: InputMaybe<Scalars['ID']['input']>;
  workOrder_Facility_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorMailInsightsArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorMatchesArgs = {
  input: VendorMatchesInput;
};


export type QueryVendorMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Permission>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorMetricsArgs = {
  categories?: InputMaybe<Array<ServiceCategory>>;
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  technicianIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
  verifiedDataOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVendorOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorOverdueInvoicesArgs = {
  month?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorPerformanceProfileArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legacyGroup?: InputMaybe<Scalars['Int']['input']>;
  legacyGroup_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorPriceRateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorPriceRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audienceType?: InputMaybe<AudienceType>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  promotionType?: InputMaybe<PromotionType>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  usageLimitType?: InputMaybe<UsageLimitType>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  validUntil_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorRankingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorRankingEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorRankingForFacilityAndServiceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorReportScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorReportSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<VendorReportType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorRevenueShareArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorRevenueSharesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorReviewSummaryArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorSlaPolicyArgs = {
  contractorVendorId?: InputMaybe<Scalars['ID']['input']>;
  scopeType: VendorSlaPolicyScopeType;
  subjectVendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorSlaPolicyVersionsArgs = {
  contractorVendorId?: InputMaybe<Scalars['ID']['input']>;
  scopeType: VendorSlaPolicyScopeType;
  subjectVendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorSlaRuleCatalogArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorSubcontractPairingsArgs = {
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  parentVendorId: Scalars['ID']['input'];
};


export type QueryVendorSubcontractPairingsForVendorArgs = {
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorWebsiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVendorWebsiteAnalyticsOverviewArgs = {
  endAt: Scalars['Float']['input'];
  startAt: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  websiteUuid: Scalars['UUID']['input'];
};


export type QueryVendorWebsiteMonitorHealthArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryVendorWebsiteMonitorInventoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  googleBusinessConnected?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorWebsiteSearchConsoleAuditArgs = {
  domain: Scalars['String']['input'];
  inspectionUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVendorWebsitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  websiteId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryVendorWorkOrderInternalNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  canServiceFacilityGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  equipmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPromotionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMarketplaceVendor?: InputMaybe<Scalars['Boolean']['input']>;
  isVerifiedVendor?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_Istartswith?: InputMaybe<Scalars['String']['input']>;
  noRelationshipWithClientId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  servicedClientId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<VendorStatus>>>;
  supportsWarranty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVerifiedVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVerifyFacilityAddressArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryVerifyLocationAddressArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['ID']['input'];
};


export type QueryVerifyOrganizationAddressesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryVisitReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointment?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusIn?: InputMaybe<Array<InputMaybe<VisitReviewRequestStatus>>>;
};


export type QueryVisitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderCancellationDetailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
  workOrderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryWorkOrderCancellationReasonsArgs = {
  source: WorkOrderCancellationSourceEnum;
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderCountsForCoordinatorStatusesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  isEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  noOpsOwner?: InputMaybe<Scalars['Boolean']['input']>;
  opsOwnerId?: InputMaybe<Scalars['ID']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderCountsForCyovDispatchesArgs = {
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<WorkOrderStatus>>;
};


export type QueryWorkOrderEscalationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderEscalationReasonsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  sourceOrgType?: InputMaybe<WorkOrderEscalationSourceOrgType>;
};


export type QueryWorkOrderEscalationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  isOvertimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  reasons?: InputMaybe<Array<InputMaybe<WorkOrderEscalationReason>>>;
  serviceCategory_In?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  serviceType_In?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sourceOrgId?: InputMaybe<Scalars['ID']['input']>;
  sourceOrgType?: InputMaybe<Array<InputMaybe<WorkOrderEscalationSourceOrgType>>>;
  unresolved?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderExpenseTypeArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderInternalNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderNavCountsArgs = {
  vendor: Scalars['ID']['input'];
};


export type QueryWorkOrderNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderPrioritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkOrderProtectionPlanCoverageUsageArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderReviewFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkOrderReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  satisfied?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderSchedulingSlaArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderSchedulingViolationsArgs = {
  selectedDate?: InputMaybe<Scalars['Date']['input']>;
  selectedEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  selectedStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderStatusSuggestionArgs = {
  workOrderId: Scalars['ID']['input'];
};


export type QueryWorkOrderSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  workOrder?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrderTeamMemberAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkOrderVendorEligibilityProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  newClientIncentive?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTechnician?: InputMaybe<Scalars['ID']['input']>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  canAcceptNewQuotes?: InputMaybe<Scalars['Boolean']['input']>;
  clientStatus_In?: InputMaybe<Array<InputMaybe<ClientWorkOrderStatus>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  code_Istartswith?: InputMaybe<Scalars['String']['input']>;
  combinedCustomerId?: InputMaybe<Scalars['ID']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  coordinatorStatus_In?: InputMaybe<Array<InputMaybe<CoordinatorStatusEnum>>>;
  creationSource_In?: InputMaybe<Array<InputMaybe<WorkOrderCreationSource>>>;
  cyovDispatchesCountGte?: InputMaybe<Scalars['Float']['input']>;
  cyovDispatchesCountLte?: InputMaybe<Scalars['Float']['input']>;
  equipment?: InputMaybe<Scalars['ID']['input']>;
  equipmentId_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  expectedServiceTimeline_In?: InputMaybe<Array<InputMaybe<ExpectedServiceTimeline>>>;
  expenseType_In?: InputMaybe<Array<InputMaybe<ExpenseType>>>;
  facility?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facility_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facility_Organization?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActionableQuoteForClient?: InputMaybe<Scalars['ID']['input']>;
  hasAppliedProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnresolvedRuleViolations?: InputMaybe<Scalars['Boolean']['input']>;
  holdReason_In?: InputMaybe<Array<InputMaybe<WorkOrderHoldReason>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoicesApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isCyov?: InputMaybe<Scalars['Boolean']['input']>;
  isDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  isEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalPm?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdueForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  isPinnedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  isSatisfied?: InputMaybe<Scalars['Boolean']['input']>;
  isSnoozed?: InputMaybe<Scalars['Boolean']['input']>;
  isWithinAppointmentWindow?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  needsPayment?: InputMaybe<Scalars['Boolean']['input']>;
  needsResponseNotes?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  opsOwner?: InputMaybe<Scalars['ID']['input']>;
  opsOwner_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  partneredVendorId?: InputMaybe<Scalars['ID']['input']>;
  pointOfContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  preventativeMaintenanceId?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  projectIsnull?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  scheduledForEnd?: InputMaybe<Scalars['Date']['input']>;
  scheduledForStart?: InputMaybe<Scalars['Date']['input']>;
  serviceCategory?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<WorkOrderStatus>>>;
  subcontractFirstVisitStatus_In?: InputMaybe<Array<InputMaybe<SubcontractFirstVisitStatus>>>;
  submittedBy?: InputMaybe<Scalars['ID']['input']>;
  technicianIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  undergoingCyov?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  vendorPayoutStatus_In?: InputMaybe<Array<InputMaybe<WorkOrderVendorPayoutStatus>>>;
  vendorStatus_In?: InputMaybe<Array<InputMaybe<WorkOrderVendorStatus>>>;
};

export type QuoteAcceptanceSettings = {
  __typename: 'QuoteAcceptanceSettings';
  approvalThresholds: Array<QuoteApprovalThresholdNode>;
  selectionRoles: Array<RoleNode>;
};

/** An enumeration. */
export enum QuoteApprovalStrategy {
  Cascading = 'CASCADING',
  Simple = 'SIMPLE'
}

export type QuoteApprovalThresholdInput = {
  roleIds: Array<Scalars['ID']['input']>;
  thresholdAmount?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuoteApprovalThresholdNode = Node & {
  __typename: 'QuoteApprovalThresholdNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  roles: Array<RoleNode>;
  threshold: Maybe<Scalars['Decimal']['output']>;
};

export type QuoteApprovalThresholdNodeConnection = {
  __typename: 'QuoteApprovalThresholdNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteApprovalThresholdNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `QuoteApprovalThresholdNode` and its cursor. */
export type QuoteApprovalThresholdNodeEdge = {
  __typename: 'QuoteApprovalThresholdNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<QuoteApprovalThresholdNode>;
};

export enum QuoteFeedbackType {
  ChangeScope = 'CHANGE_SCOPE',
  ClarifyPrice = 'CLARIFY_PRICE',
  ClarifyScope = 'CLARIFY_SCOPE'
}

export enum QuoteLineItemEnum {
  ItemTypeEnvironmentalFees = 'ITEM_TYPE_ENVIRONMENTAL_FEES',
  ItemTypeFreightShippingHandling = 'ITEM_TYPE_FREIGHT_SHIPPING_HANDLING',
  ItemTypeFuelSurcharge = 'ITEM_TYPE_FUEL_SURCHARGE',
  ItemTypeLabour = 'ITEM_TYPE_LABOUR',
  ItemTypeOther = 'ITEM_TYPE_OTHER',
  ItemTypeParking = 'ITEM_TYPE_PARKING',
  ItemTypePart = 'ITEM_TYPE_PART',
  ItemTypePromotion = 'ITEM_TYPE_PROMOTION',
  ItemTypeServiceCharge = 'ITEM_TYPE_SERVICE_CHARGE',
  ItemTypeTravel = 'ITEM_TYPE_TRAVEL',
  ItemTypeTruck = 'ITEM_TYPE_TRUCK'
}

export type QuoteLineItemNode = Node & {
  __typename: 'QuoteLineItemNode';
  description: Maybe<Scalars['String']['output']>;
  discount: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  itemType: QuoteLineItemEnum;
  markup: Scalars['Decimal']['output'];
  /** A boolean of whether the line item is flagged as an overtime value. Overtime values for service calls, labour, and travel are more expensive than their non-overtime counterparts. */
  overtime: Scalars['Boolean']['output'];
  /** This is applicable for line items with a type of Part (1). */
  partManufacturer: Maybe<Scalars['String']['output']>;
  /** This is applicable for line items with a type of Part (1). */
  partName: Maybe<Scalars['String']['output']>;
  /** This is applicable for line items with a type of Part (1). */
  partNumber: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
  ratePercentage: Maybe<Scalars['Decimal']['output']>;
  revShare: Scalars['Decimal']['output'];
  taxRates: Array<TaxRateNode>;
  /** A boolean of whether the line item is covered by warranty of not. */
  warranty: Scalars['Boolean']['output'];
};

export type QuoteNode = Node & {
  __typename: 'QuoteNode';
  actionedBy: Maybe<UserNode>;
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  can: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  declinedAt: Maybe<Scalars['DateTime']['output']>;
  facility: Maybe<FacilityNode>;
  feedbackCount: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoicingVersion: InvoicingVersion;
  lineItems: Array<QuoteLineItemNode>;
  notes: Scalars['String']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  overrideNotes: Maybe<Scalars['String']['output']>;
  pdfFile: Maybe<FileType>;
  price: Scalars['Decimal']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  quoteUploadSource: QuoteUploadSource;
  rejectionReason: Scalars['String']['output'];
  validUntil: Maybe<Scalars['DateTime']['output']>;
  vendor: VendorOrganizationNode;
  /** An identifier for the quote in the vendors quoting system. */
  vendorReferenceNumber: Maybe<Scalars['String']['output']>;
  workOrder: Maybe<WorkOrderNode>;
};


export type QuoteNodeCanArgs = {
  perform: QuotePermission;
};

export type QuoteNodeConnection = {
  __typename: 'QuoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuoteNode` and its cursor. */
export type QuoteNodeEdge = {
  __typename: 'QuoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<QuoteNode>;
};

export enum QuotePermission {
  Approve = 'APPROVE'
}

export type QuoteSetNode = Node & {
  __typename: 'QuoteSetNode';
  cancelReason: Scalars['String']['output'];
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  expectedPrice: Maybe<Scalars['Decimal']['output']>;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  offResqFacility: Maybe<OffResqFacilityNode>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  options: Array<QuoteSetOptionNode>;
  permissions: QuoteSetPermissions;
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  rejectedBy: Maybe<UserNode>;
  rejectionReason: Scalars['String']['output'];
  remainingApprovalSteps: Scalars['Int']['output'];
  status: QuoteSetStatus;
  workOrder: Maybe<WorkOrderNode>;
};


export type QuoteSetNodeOptionsArgs = {
  excludeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteSetNodeConnection = {
  __typename: 'QuoteSetNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteSetNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuoteSetNode` and its cursor. */
export type QuoteSetNodeEdge = {
  __typename: 'QuoteSetNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<QuoteSetNode>;
};

export type QuoteSetOptionApprovalNode = Node & {
  __typename: 'QuoteSetOptionApprovalNode';
  approvedAt: Scalars['DateTime']['output'];
  approvedBy: UserNode;
  approvedByMember: Maybe<ClientOrganizationMemberNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  quoteSetOption: QuoteSetOptionNode;
};

export type QuoteSetOptionNode = Node & {
  __typename: 'QuoteSetOptionNode';
  approvalNeededRoles: Array<Array<RoleNode>>;
  approvals: Array<QuoteSetOptionApprovalNode>;
  createdAt: Scalars['DateTime']['output'];
  expiredAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<QuoteSetOptionOutcome>;
  permissions: QuoteSetOptionPermissions;
  quote: QuoteNode;
  quoteSet: QuoteSetNode;
  rejectReasons: Array<Scalars['String']['output']>;
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  rejectedBy: Maybe<UserNode>;
  rejectedByMember: Maybe<ClientOrganizationMemberNode>;
  removeReason: Scalars['String']['output'];
  removedAt: Maybe<Scalars['DateTime']['output']>;
  removedBy: Maybe<UserNode>;
  selectedAt: Maybe<Scalars['DateTime']['output']>;
  selectedBy: Maybe<UserNode>;
  selectedByMember: Maybe<ClientOrganizationMemberNode>;
};

/** An enumeration. */
export enum QuoteSetOptionOutcome {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Selected = 'SELECTED'
}

export type QuoteSetOptionPermissions = {
  __typename: 'QuoteSetOptionPermissions';
  actionOnSpend: Scalars['Boolean']['output'];
  provideFeedback: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  select: Scalars['Boolean']['output'];
  selectAndApproveSpend: Scalars['Boolean']['output'];
};

export type QuoteSetPermissions = {
  __typename: 'QuoteSetPermissions';
  reject: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum QuoteSetStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Presented = 'PRESENTED',
  Rejected = 'REJECTED',
  Selected = 'SELECTED'
}

/** An enumeration. */
export enum QuoteUploadSource {
  PartnerApp = 'PARTNER_APP',
  Pmc = 'PMC',
  Rcc = 'RCC'
}

export type QuoteValidationNode = Node & {
  __typename: 'QuoteValidationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  validationMessages: Array<Scalars['String']['output']>;
  validationResults: Array<InvoiceValidationResult>;
};

export type RaiseApprovedSpendDuringWorkOrderSubmissionInput = {
  amount: Scalars['Decimal']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type RaiseApprovedSpendDuringWorkOrderSubmissionPayload = {
  __typename: 'RaiseApprovedSpendDuringWorkOrderSubmissionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  spendApproval: SpendApprovalNode;
};

export type ReactivateEquipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
};

export type ReactivateEquipmentPayload = {
  __typename: 'ReactivateEquipmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  equipment: EquipmentNode;
};

export type ReactivateFacilityMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
};

export type ReactivateFacilityMutationPayload = {
  __typename: 'ReactivateFacilityMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ReassignWorkOrderVendorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  vendor: Scalars['ID']['input'];
  workOrder: Scalars['ID']['input'];
};

export type ReassignWorkOrderVendorPayload = {
  __typename: 'ReassignWorkOrderVendorPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  newWorkOrder: WorkOrderNode;
};

/** An enumeration. */
export enum ReceptionistEnabledType {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  OnlyAfterHours = 'ONLY_AFTER_HOURS'
}

/** An enumeration. */
export enum ReceptionistTransferType {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  OnlyOnHours = 'ONLY_ON_HOURS'
}

export type RecordAdBannerClickMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type RecordAdBannerClickMutationPayload = {
  __typename: 'RecordAdBannerClickMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RecordClientVendorPromotionViewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  promotionId: Scalars['ID']['input'];
};

export type RecordClientVendorPromotionViewMutationPayload = {
  __typename: 'RecordClientVendorPromotionViewMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorPromotion: Maybe<VendorPromotionNode>;
};

export type RecordLeadInboundRequestConversionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdNewOffResqCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  createdNewOffResqFacility?: InputMaybe<Scalars['Boolean']['input']>;
  createdNewOffResqWorkOrder?: InputMaybe<Scalars['Boolean']['input']>;
  createdNewProposal?: InputMaybe<Scalars['Boolean']['input']>;
  createdNewWorkOrder?: InputMaybe<Scalars['Boolean']['input']>;
  extractionSetId?: InputMaybe<Scalars['ID']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Record extraction conversion links for a lead inbound request.
 *
 * Called after the conversion flow has created OffResq entities (work order,
 * proposal, customer, facility) via their respective mutations. This mutation
 * updates the Extraction records in the given ExtractionSet by setting their
 * ``converted_to`` GenericForeignKey to the created entities, so that each
 * Extraction (e.g. OffResqWorkOrderData_v1, ProposalData_v1) is linked to the
 * corresponding OffResqWorkOrder, Proposal, OffResqCustomer, or OffResqFacility.
 *
 * Use when: the user has completed the inbound-request conversion UI, created
 * any new customer/facility/work order/proposal, and the frontend needs to
 * persist which Extractions were converted to which entities (and optionally
 * drive Lead status updates when all extractions are converted).
 */
export type RecordLeadInboundRequestConversionMutationPayload = {
  __typename: 'RecordLeadInboundRequestConversionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  extractionSet: ExtractionSetNode;
  updatedSchemaNames: Array<Scalars['String']['output']>;
};

export type RecordOfWorkDefaultLineItemNode = Node & {
  __typename: 'RecordOfWorkDefaultLineItemNode';
  defaultLineItem: RecordOfWorkLineItemNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export enum RecordOfWorkLineItemEnum {
  ItemTypeCreditCardPaymentFee = 'ITEM_TYPE_CREDIT_CARD_PAYMENT_FEE',
  ItemTypeEnvironmentalFees = 'ITEM_TYPE_ENVIRONMENTAL_FEES',
  ItemTypeFastPayFee = 'ITEM_TYPE_FAST_PAY_FEE',
  ItemTypeFee = 'ITEM_TYPE_FEE',
  ItemTypeFreightShippingHandling = 'ITEM_TYPE_FREIGHT_SHIPPING_HANDLING',
  ItemTypeFuelSurcharge = 'ITEM_TYPE_FUEL_SURCHARGE',
  ItemTypeLabour = 'ITEM_TYPE_LABOUR',
  ItemTypeLatePaymentFee = 'ITEM_TYPE_LATE_PAYMENT_FEE',
  ItemTypeLegacyResqFee = 'ITEM_TYPE_LEGACY_RESQ_FEE',
  ItemTypeMarketplaceFee = 'ITEM_TYPE_MARKETPLACE_FEE',
  ItemTypeOffPlatformProcessingFee = 'ITEM_TYPE_OFF_PLATFORM_PROCESSING_FEE',
  ItemTypeOther = 'ITEM_TYPE_OTHER',
  ItemTypeParking = 'ITEM_TYPE_PARKING',
  ItemTypePart = 'ITEM_TYPE_PART',
  ItemTypePromotion = 'ITEM_TYPE_PROMOTION',
  ItemTypeServiceCharge = 'ITEM_TYPE_SERVICE_CHARGE',
  ItemTypeTravel = 'ITEM_TYPE_TRAVEL',
  ItemTypeTruck = 'ITEM_TYPE_TRUCK'
}

export type RecordOfWorkLineItemNode = Node & {
  __typename: 'RecordOfWorkLineItemNode';
  description: Maybe<Scalars['String']['output']>;
  discount: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal']['output'];
  /** A boolean of whether the line item is flagged as an overtime value. Overtime values for service calls, labour, and travel are more expensive than their non-overtime counterparts. */
  overtime: Scalars['Boolean']['output'];
  /** This is applicable for line items with a type of Part (1). */
  partManufacturer: Maybe<Scalars['String']['output']>;
  /** This is applicable for line items with a type of Part (1). */
  partName: Maybe<Scalars['String']['output']>;
  /** This is applicable for line items with a type of Part (1). */
  partNumber: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
  ratePercentage: Maybe<Scalars['Decimal']['output']>;
  revShare: Scalars['Decimal']['output'];
  taxRates: Array<TaxRateNode>;
  vendorTaxRates: Array<TaxRateNode>;
  /** A boolean of whether the line item is covered by warranty of not. */
  warranty: Scalars['Boolean']['output'];
};

export type RecordOfWorkNode = Node & {
  __typename: 'RecordOfWorkNode';
  /** A reference to the record of work from which the client invoice was created. Multiple client invoices can be created from the same record of work, usually due to the re-issuing of invoices that had an error. In this case, a new invoice with the correct amount is created and the old invoice is credited back its full amount. */
  clientInvoices: ClientInvoiceNodeConnection;
  clientRuleViolation: Maybe<RuleViolationsNode>;
  createdAt: Scalars['DateTime']['output'];
  /** The address of the facility for the work order. */
  facilityAddress: Scalars['String']['output'];
  /** The city of the facility for the work order. */
  facilityCity: Scalars['String']['output'];
  /** The name of the facility for the work order. */
  facilityName: Scalars['String']['output'];
  /** The postal code of the facility for the work order. */
  facilityPostalCode: Scalars['String']['output'];
  /** The province of the facility for the work order. */
  facilityProvince: Scalars['String']['output'];
  /** Denotes whether the associated partner invoice is eligible for fast payments. */
  fastPaymentsEligible: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** The inbound vendor invoice from which the record of work was created */
  inboundVendorInvoice: Maybe<InboundVendorInvoiceNode>;
  invoiceSet: InvoiceSetNode;
  invoicingVersion: InvoicingVersion;
  lineItems: Array<RecordOfWorkLineItemNode>;
  /** Notes about the work order and invoice provided by the vendor. This appears on the generated invoice. */
  notes: Scalars['String']['output'];
  /** When a record of work is created by internal ResQ employees, a number of validation rules are performed on save and submission for approval to ensure the integrity of the invoice. If an Customer Experience Manager chooses to override a validation rule, then they are asked to provide a justification and the reasons are stored in this field. A Customer Experience Manager can choose to not provide a reason. */
  overrideNotes: Scalars['String']['output'];
  /** The effective payment terms of the work order. */
  paymentTerms: Maybe<Scalars['Int']['output']>;
  pdfUrl: Scalars['String']['output'];
  status: RecordOfWorkStatus;
  total: Scalars['Float']['output'];
  /** The time at which the record of work was unapproved internally by the customer experience team. */
  unapprovedAt: Maybe<Scalars['DateTime']['output']>;
  unresolvedRuleViolation: Maybe<RuleViolationsNode>;
  /** A reference to the record of work from which the vendor invoice was created. Multiple vendor invoices can be created from the same record of work, usually due to the re-issuing of invoices that had an error. */
  vendorInvoices: VendorInvoiceNodeConnection;
  /** Notes about the work order and invoice provided by the vendor that are for internal consumption only. */
  vendorNotes: Scalars['String']['output'];
  /** The date that overrides the vendor invoice payout due date. */
  vendorPayoutOverrideDate: Maybe<Scalars['Date']['output']>;
  /** The reason why the vendor payout date was overridden. */
  vendorPayoutOverrideReason: Scalars['String']['output'];
  /** An identifier for the inbound invoice (i.e. the original invoice sent to ResQ) used by the vendor. */
  vendorReferenceNumber: Maybe<Scalars['String']['output']>;
  workOrder: Maybe<WorkOrderNode>;
};


export type RecordOfWorkNodeClientInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RecordOfWorkNodeVendorInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordOfWorkNodeConnection = {
  __typename: 'RecordOfWorkNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecordOfWorkNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RecordOfWorkNode` and its cursor. */
export type RecordOfWorkNodeEdge = {
  __typename: 'RecordOfWorkNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<RecordOfWorkNode>;
};

export type RecordOfWorkRevenueShareValuesNode = Node & {
  __typename: 'RecordOfWorkRevenueShareValuesNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourPercentage: Maybe<Scalars['Decimal']['output']>;
  labourRate: Maybe<Scalars['Decimal']['output']>;
  otherPercentage: Maybe<Scalars['Decimal']['output']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']['output']>;
  partsPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallRate: Maybe<Scalars['Decimal']['output']>;
  travelPercentage: Maybe<Scalars['Decimal']['output']>;
  travelRate: Maybe<Scalars['Decimal']['output']>;
  truckPercentage: Maybe<Scalars['Decimal']['output']>;
  truckRate: Maybe<Scalars['Decimal']['output']>;
};

export enum RecordOfWorkStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  StatusAwaitingVendorOnboarding = 'STATUS_AWAITING_VENDOR_ONBOARDING'
}

export type RecordOfWorkTemplateLineItemNode = Node & {
  __typename: 'RecordOfWorkTemplateLineItemNode';
  description: Maybe<Scalars['String']['output']>;
  discount: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  itemType: RecordOfWorkLineItemEnum;
  markup: Scalars['Decimal']['output'];
  partManufacturer: Maybe<Scalars['String']['output']>;
  partName: Maybe<Scalars['String']['output']>;
  partNumber: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  promotionType: Maybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
  ratePercentage: Maybe<Scalars['Decimal']['output']>;
  revShare: Scalars['Decimal']['output'];
  taxRates: Array<TaxRateNode>;
  warranty: Scalars['Boolean']['output'];
};

export type RecordOfWorkTemplateNode = Node & {
  __typename: 'RecordOfWorkTemplateNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lineItems: Array<RecordOfWorkTemplateLineItemNode>;
  notes: Scalars['String']['output'];
  vendorNotes: Scalars['String']['output'];
};

export type RecordPaymentInput = {
  amount: Scalars['Decimal']['input'];
  clientInvoiceIds: Array<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod: Scalars['String']['input'];
  referenceDate: Scalars['Date']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type RecordPaymentPayload = {
  __typename: 'RecordPaymentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RecordSuccessfulTroubleshootingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  selectedSteps: Scalars['Int']['input'];
  totalSteps: Scalars['Int']['input'];
};

export type RecordSuccessfulTroubleshootingMutationPayload = {
  __typename: 'RecordSuccessfulTroubleshootingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RecordVendorPromotionViewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  promotionId: Scalars['ID']['input'];
};

export type RecordVendorPromotionViewMutationPayload = {
  __typename: 'RecordVendorPromotionViewMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorPromotion: Maybe<VendorPromotionNode>;
};

export type RefundBatchPaymentMutationInput = {
  batchPaymentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  refundHashKey: Scalars['String']['input'];
  refunds: Array<PaymentRefundInput>;
};

export type RefundBatchPaymentMutationPayload = {
  __typename: 'RefundBatchPaymentMutationPayload';
  batchPayment: BatchPaymentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type RegenerateRsgCompletionReportMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type RegenerateRsgCompletionReportMutationPayload = {
  __typename: 'RegenerateRsgCompletionReportMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  ok: Scalars['Boolean']['output'];
  workOrder: Maybe<WorkOrderNode>;
};

export type RegenerateVendorCoverImageMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Generate preview only, don't save to profile */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

/** Mutation to regenerate AI cover image for a vendor business profile. */
export type RegenerateVendorCoverImageMutationPayload = {
  __typename: 'RegenerateVendorCoverImageMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Success or error message */
  message: Maybe<Scalars['String']['output']>;
  /** URL of the generated preview image */
  previewImageUrl: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Maybe<Scalars['Boolean']['output']>;
  /** Updated vendor business profile */
  vendorBusinessProfile: Maybe<VendorBusinessProfileNode>;
};

export type ReinitializeSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataHashKey: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
};

export type ReinitializeSubscriptionPayload = {
  __typename: 'ReinitializeSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RejectClientWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type RejectClientWorkOrderPayload = {
  __typename: 'RejectClientWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type RejectLeadInboundRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
};

export type RejectLeadInboundRequestMutationPayload = {
  __typename: 'RejectLeadInboundRequestMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type RejectQuoteSetInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expectedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  quoteSet: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectQuoteSetOptionForSpendInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteSetOptionId: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type RejectQuoteSetOptionForSpendPayload = {
  __typename: 'RejectQuoteSetOptionForSpendPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type RejectQuoteSetPayload = {
  __typename: 'RejectQuoteSetPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type RejectVendorEquipmentCapabilitySuggestionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional additional notes about the rejection */
  rejectionNotes?: InputMaybe<Scalars['String']['input']>;
  /** Optional reason for rejecting the suggestions */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  suggestions: Array<SuggestionRejectionInput>;
  vendorId: Scalars['ID']['input'];
};

export type RejectVendorEquipmentCapabilitySuggestionMutationPayload = {
  __typename: 'RejectVendorEquipmentCapabilitySuggestionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  rejectionIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum RelationshipSource {
  Inherited = 'INHERITED',
  Marketplace = 'MARKETPLACE'
}

export type ReleaseNode = Node & {
  __typename: 'ReleaseNode';
  appName: AppName;
  buildNumber: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Force OTA update for JS bundles created before this timestamp. Leave blank to disable forced OTA updates for this release. */
  minimumOtaCreatedAt: Maybe<Scalars['DateTime']['output']>;
  platform: Platform;
  updatedAt: Scalars['DateTime']['output'];
  upgradeType: UpgradeType;
  versionName: Scalars['String']['output'];
};

export type ReleaseNodeConnection = {
  __typename: 'ReleaseNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReleaseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReleaseNode` and its cursor. */
export type ReleaseNodeEdge = {
  __typename: 'ReleaseNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReleaseNode>;
};

export type RemindFacilityPaymentContactToAddPaymentMethodMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
};

export type RemindFacilityPaymentContactToAddPaymentMethodMutationPayload = {
  __typename: 'RemindFacilityPaymentContactToAddPaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/**
 * Type for RemittanceStatement, which tracks email attachments that may contain remittance
 * statements and their processing status.
 */
export type RemittanceStatementNode = Node & {
  __typename: 'RemittanceStatementNode';
  attachment: Maybe<InboundEmailAttachmentNode>;
  attachmentName: Maybe<Scalars['String']['output']>;
  attachmentUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundEmail: Maybe<InboundEmailNode>;
  status: RemittanceStatementStatus;
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RemittanceStatementNodeConnection = {
  __typename: 'RemittanceStatementNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RemittanceStatementNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RemittanceStatementNode` and its cursor. */
export type RemittanceStatementNodeEdge = {
  __typename: 'RemittanceStatementNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<RemittanceStatementNode>;
};

/** An enumeration. */
export enum RemittanceStatementStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Partially Reconciled */
  Partial = 'PARTIAL',
  /** Pending */
  Pending = 'PENDING',
  /** Reconciled */
  Reconciled = 'RECONCILED'
}

export type RemovePaymentMethodMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

export type RemovePaymentMethodMutationPayload = {
  __typename: 'RemovePaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RemoveQuoteArguments = {
  id: Scalars['ID']['input'];
};

export type RemoveQuoteMutation = {
  __typename: 'RemoveQuoteMutation';
  ok: Scalars['Boolean']['output'];
};

export type RemoveQuoteSetOptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteSetOptionId: Scalars['ID']['input'];
  removeReason: Scalars['String']['input'];
};

export type RemoveQuoteSetOptionPayload = {
  __typename: 'RemoveQuoteSetOptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type RemoveUpcomingAllocationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type RemoveUpcomingAllocationMutationPayload = {
  __typename: 'RemoveUpcomingAllocationMutationPayload';
  allocation: Maybe<AllocationNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type RemoveUserFromClientOrganizationMutation = {
  __typename: 'RemoveUserFromClientOrganizationMutation';
  ok: Scalars['Boolean']['output'];
};

export type RemoveUsersFromRoleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RemoveUsersFromRoleMutationPayload = {
  __typename: 'RemoveUsersFromRoleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RemoveVendorMemberArguments = {
  memberId: Scalars['ID']['input'];
};

export type RemoveVendorMemberMutation = {
  __typename: 'RemoveVendorMemberMutation';
  ok: Scalars['Boolean']['output'];
};

export type RemoveVendorPayoutInfoMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type RemoveVendorPayoutInfoMutationPayload = {
  __typename: 'RemoveVendorPayoutInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RemoveWorkOrdersFromProjectMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  workOrderIds: Array<Scalars['ID']['input']>;
};

export type RemoveWorkOrdersFromProjectMutationPayload = {
  __typename: 'RemoveWorkOrdersFromProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  project: ProjectNode;
};

export type ReopenLeadInboundRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leadInboundRequestId: Scalars['ID']['input'];
};

export type ReopenLeadInboundRequestMutationPayload = {
  __typename: 'ReopenLeadInboundRequestMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type RepaymentWindowNode = {
  __typename: 'RepaymentWindowNode';
  repaymentDurationDays: Maybe<Scalars['Int']['output']>;
};

export type ReplaceDisputedInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceFile: Scalars['String']['input'];
  invoiceSetDisputeId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type ReplaceDisputedInvoiceMutationPayload = {
  __typename: 'ReplaceDisputedInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  inboundVendorInvoice: InboundVendorInvoiceNode;
  note: WorkOrderNoteNode;
};

export type ReplaceVendorSlaPolicyMutationInput = {
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractorVendorId?: InputMaybe<Scalars['ID']['input']>;
  rules: Array<ReplaceVendorSlaPolicyRuleInput>;
  scopeMode: VendorSlaPolicyScopeMode;
  scopeType: VendorSlaPolicyScopeType;
  subjectVendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReplaceVendorSlaPolicyMutationPayload = {
  __typename: 'ReplaceVendorSlaPolicyMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  policy: VendorSlaPolicyVersionType;
};

export type ReplaceVendorSlaPolicyRuleInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<Scalars['GenericScalar']['input']>;
  ruleKey: Scalars['String']['input'];
};

/** An enumeration. */
export enum ReportDay {
  Daily = 'DAILY',
  FirstCalendarDay = 'FIRST_CALENDAR_DAY',
  FirstDayOfMonth = 'FIRST_DAY_OF_MONTH',
  Friday = 'FRIDAY',
  LastCalendarDay = 'LAST_CALENDAR_DAY',
  LastDayOfMonth = 'LAST_DAY_OF_MONTH',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** An enumeration. */
export enum ReportFilterDatatype {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING'
}

export type ReportFilterNode = Node & {
  __typename: 'ReportFilterNode';
  datatype: ReportFilterDatatype;
  /** The field being filtered. */
  field: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  operator: ReportFilterOperator;
  template: ReportTemplateNode;
  /** The value to compare against. */
  value: Maybe<Scalars['String']['output']>;
};

export type ReportFilterNodeConnection = {
  __typename: 'ReportFilterNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportFilterNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReportFilterNode` and its cursor. */
export type ReportFilterNodeEdge = {
  __typename: 'ReportFilterNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReportFilterNode>;
};

/** An enumeration. */
export enum ReportFilterOperator {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Empty = 'EMPTY',
  Equals = 'EQUALS',
  Greater = 'GREATER',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  Less = 'LESS',
  LessOrEqual = 'LESS_OR_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEmpty = 'NOT_EMPTY',
  NotEquals = 'NOT_EQUALS',
  PreviousMonths = 'PREVIOUS_MONTHS'
}

/** An enumeration. */
export enum ReportFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ReportInstanceNode = Node & {
  __typename: 'ReportInstanceNode';
  createdAt: Scalars['DateTime']['output'];
  csvUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** A list of emails that this report was delivered to when generated. */
  recipients: Array<Scalars['String']['output']>;
  template: ReportTemplateNode;
};

export type ReportInstanceNodeConnection = {
  __typename: 'ReportInstanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportInstanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReportInstanceNode` and its cursor. */
export type ReportInstanceNodeEdge = {
  __typename: 'ReportInstanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReportInstanceNode>;
};

export type ReportPreviewNode = {
  __typename: 'ReportPreviewNode';
  count: Maybe<Scalars['Int']['output']>;
  data: Maybe<Scalars['JSONString']['output']>;
};

export type ReportTemplateNode = Node & {
  __typename: 'ReportTemplateNode';
  /** The datetime of when this report was archived, which means it will no longer be generated and delivered. A null value means it is not archived. */
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  day: ReportDay;
  description: Maybe<Scalars['String']['output']>;
  /** The datetime of when this report was last edited by a person (ie ignoring next_report_on being updated). */
  editedAt: Scalars['DateTime']['output'];
  /** The list and order of fields contained in the report. */
  fields: Array<Scalars['String']['output']>;
  filters: Array<ReportFilterNode>;
  frequency: Maybe<ReportFrequency>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** How many cadences apart is the report generated. */
  interval: Scalars['Int']['output'];
  /** The datetime when the report should next go out. */
  nextReportOn: Maybe<Scalars['Date']['output']>;
  /** The field to order the data by, prefixed with - for descending order. */
  orderBy: Scalars['String']['output'];
  /** A list of emails the report will be delivered to when generated. */
  recipients: Array<Scalars['String']['output']>;
  reportType: ReportType;
  /** A short title to describe the report. */
  title: Scalars['String']['output'];
};

export type ReportTemplateNodeConnection = {
  __typename: 'ReportTemplateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReportTemplateNode` and its cursor. */
export type ReportTemplateNodeEdge = {
  __typename: 'ReportTemplateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReportTemplateNode>;
};

/** An enumeration. */
export enum ReportType {
  Invoices = 'INVOICES',
  Quotes = 'QUOTES',
  VendorInvoices = 'VENDOR_INVOICES',
  VendorMaintenancePlans = 'VENDOR_MAINTENANCE_PLANS',
  VendorWorkOrders = 'VENDOR_WORK_ORDERS',
  WorkOrders = 'WORK_ORDERS'
}

export type RequestAutopayChangesMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requestAutopay: Scalars['Boolean']['input'];
};

export type RequestAutopayChangesMutationPayload = {
  __typename: 'RequestAutopayChangesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestDispatchChangesMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requestDetails: Scalars['String']['input'];
};

export type RequestDispatchChangesMutationPayload = {
  __typename: 'RequestDispatchChangesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestEstimateMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
  subject?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type RequestEstimateMutationPayload = {
  __typename: 'RequestEstimateMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  leadInboundRequest: LeadInboundRequestNode;
};

export type RequestGoogleAdsGrowthExpertMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
};

export type RequestGoogleAdsGrowthExpertMutationPayload = {
  __typename: 'RequestGoogleAdsGrowthExpertMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestMaintenancePlanDateChangeMutation = {
  __typename: 'RequestMaintenancePlanDateChangeMutation';
  ok: Scalars['Boolean']['output'];
};

export type RequestMaintenancePlanMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  attachmentFileType?: InputMaybe<Scalars['String']['input']>;
  attachmentLabel?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fileUri?: InputMaybe<Scalars['String']['input']>;
  maintenancePlanTypeId: Scalars['ID']['input'];
};

export type RequestMaintenancePlanMutationPayload = {
  __typename: 'RequestMaintenancePlanMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestMaintenancePlanQuoteMutation = {
  __typename: 'RequestMaintenancePlanQuoteMutation';
  ok: Scalars['Boolean']['output'];
};

export type RequestNewCapexProjectMutationInput = {
  approvedById?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type RequestNewCapexProjectMutationPayload = {
  __typename: 'RequestNewCapexProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestPlannedMaintenanceQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type RequestPlannedMaintenanceQuoteMutationPayload = {
  __typename: 'RequestPlannedMaintenanceQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RequestRsgEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  source: RsgEstimateRequestSource;
  workOrderId: Scalars['ID']['input'];
};

export type RequestRsgEstimatePayload = {
  __typename: 'RequestRsgEstimatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  proposalRequest: Maybe<ProposalRequestNode>;
};

export type RerunNoraCallEvaluation = {
  __typename: 'RerunNoraCallEvaluation';
  noraCallEvaluation: NoraCallEvaluationNode;
};

export type RescheduleAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  otherReschedulingReason?: InputMaybe<Scalars['String']['input']>;
  reschedulingReason?: InputMaybe<AppointmentReschedulingReason>;
  startsAt: Scalars['DateTime']['input'];
  technicianId?: InputMaybe<Scalars['ID']['input']>;
};

export type RescheduleAppointmentPayload = {
  __typename: 'RescheduleAppointmentPayload';
  appointment: AppointmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type RescheduleInternalAppointmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  internalRequestId: Scalars['ID']['input'];
};

export type RescheduleInternalAppointmentPayload = {
  __typename: 'RescheduleInternalAppointmentPayload';
  appointment: InternalAppointmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type ResendClientVendorRelationshipInviteInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
  inviterName?: InputMaybe<Scalars['String']['input']>;
  inviterNote?: InputMaybe<Scalars['String']['input']>;
  subscribeToInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResendClientVendorRelationshipInvitePayload = {
  __typename: 'ResendClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  invite: InviteNode;
};

export type ResetQuoteSetInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteSetId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type ResetQuoteSetPayload = {
  __typename: 'ResetQuoteSetPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type ResolveFacilityExpansionMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expansionRequestType: ExpansionRequestType;
};

export type ResolveFacilityExpansionMutationPayload = {
  __typename: 'ResolveFacilityExpansionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ResolveFlaggedInvoiceInput = {
  action: RuleResolutionAction;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  ruleViolationsId: Scalars['ID']['input'];
};

export type ResolveFlaggedInvoicePayload = {
  __typename: 'ResolveFlaggedInvoicePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ResolveGoogleAdsLocationGeometriesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locations: Array<GoogleAdsLocationGeometryInput>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
};

export type ResolveGoogleAdsLocationGeometriesMutationPayload = {
  __typename: 'ResolveGoogleAdsLocationGeometriesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  geometries: Array<GoogleAdsResolvedLocationGeometryType>;
};

export type ResolveIncidentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentIds: Array<Scalars['ID']['input']>;
  incidentIds: Array<Scalars['String']['input']>;
};

export type ResolveIncidentsPayload = {
  __typename: 'ResolveIncidentsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ResolveInvoiceSetDisputeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceSetDisputeId: Scalars['ID']['input'];
  resolvedMethod: InvoiceSetDisputeResolvedMethod;
};

export type ResolveInvoiceSetDisputeMutationPayload = {
  __typename: 'ResolveInvoiceSetDisputeMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  dispute: InvoiceSetDisputeNode;
};

export type ResolveWorkOrderDisputeArguments = {
  comment: Scalars['String']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type ResolveWorkOrderDisputeMutation = {
  __typename: 'ResolveWorkOrderDisputeMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

export type ResolveWorkOrderEscalationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escalationId: Scalars['ID']['input'];
  resolutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type ResolveWorkOrderEscalationPayload = {
  __typename: 'ResolveWorkOrderEscalationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrderEscalation: WorkOrderEscalationNode;
};

export type ResqReviewActivity = Activity & Node & {
  __typename: 'ResqReviewActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reviewType: ResqReviewActivityReviewType;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export enum ResqReviewActivityReviewType {
  FindingQuote = 'FINDING_QUOTE',
  FindingVendor = 'FINDING_VENDOR',
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum ResqServiceName {
  BusinessCheck = 'BUSINESS_CHECK',
  FastPay_7 = 'FAST_PAY_7',
  FastPay_7Surprise = 'FAST_PAY_7_SURPRISE',
  FastPay_30 = 'FAST_PAY_30',
  Lending = 'LENDING',
  StandardPayout = 'STANDARD_PAYOUT',
  TradesBasicMonthly = 'TRADES_BASIC_MONTHLY',
  TradesPremiumMonthly = 'TRADES_PREMIUM_MONTHLY',
  UserBasicAnnual = 'USER_BASIC_ANNUAL',
  UserBasicMonthly = 'USER_BASIC_MONTHLY',
  UserBasicQuarterly = 'USER_BASIC_QUARTERLY',
  UserProAnnual = 'USER_PRO_ANNUAL',
  UserProMonthly = 'USER_PRO_MONTHLY',
  UserProQuarterly = 'USER_PRO_QUARTERLY'
}

export type ResqServiceNode = Node & {
  __typename: 'ResqServiceNode';
  brandedName: Maybe<Scalars['String']['output']>;
  createdOrUpdatedBy: Maybe<UserNode>;
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: ResqServiceName;
};

export type ResqServiceNodeConnection = {
  __typename: 'ResqServiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ResqServiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResqServiceNode` and its cursor. */
export type ResqServiceNodeEdge = {
  __typename: 'ResqServiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ResqServiceNode>;
};

export type ResubmitGoogleAdsBillingPaymentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorInvoiceId: Scalars['ID']['input'];
};

export type ResubmitGoogleAdsBillingPaymentMutationPayload = {
  __typename: 'ResubmitGoogleAdsBillingPaymentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RetryInvoiceBatchChargeMutationInput = {
  batchChargeId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

export type RetryInvoiceBatchChargeMutationPayload = {
  __typename: 'RetryInvoiceBatchChargeMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentSubmittedInvoices: Maybe<Array<ClientInvoiceNode>>;
};

export type RetrySubscriptionPaymentMutationInput = {
  /** Business unit ID for grouped v3 subscription invoices (mutually exclusive with facility_id and organization_subscription_id) */
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Facility ID for facility-scoped v3 subscriptions (mutually exclusive with business_unit_id and organization_subscription_id) */
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization subscription ID for per-user subscription (mutually exclusive with facility_id and business_unit_id) */
  organizationSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Retry payment for all unpaid subscription invoices for a given subscription.
 *
 * Accepts either a facility_id (for facility-scoped v3 subscriptions), a business_unit_id
 * (for grouped business-unit invoices), or an organization_subscription_id (for per-user
 * subscriptions). Uses the canonical payment method for that invoice scope.
 */
export type RetrySubscriptionPaymentMutationPayload = {
  __typename: 'RetrySubscriptionPaymentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentSubmittedInvoices: Maybe<Array<ClientInvoiceNode>>;
};

export type RevShareInputLineItemType = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount: Scalars['Decimal']['input'];
  itemType: RecordOfWorkLineItemEnum;
  order: Scalars['Int']['input'];
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
  partManufacturer?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partNumber?: InputMaybe<Scalars['String']['input']>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  quantity: Scalars['Decimal']['input'];
  rate: Scalars['Decimal']['input'];
  ratePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  revShare: Scalars['Decimal']['input'];
  taxRateIds: Array<Scalars['ID']['input']>;
  vendorTaxRateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  warranty: Scalars['Boolean']['input'];
};

export type RevenueShareOverrideNode = Node & {
  __typename: 'RevenueShareOverrideNode';
  facilityGroup: FacilityGroupNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourPercentage: Maybe<Scalars['Decimal']['output']>;
  otherPercentage: Maybe<Scalars['Decimal']['output']>;
  partsPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  travelPercentage: Maybe<Scalars['Decimal']['output']>;
  truckPercentage: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type RevenueShareOverrideNodeConnection = {
  __typename: 'RevenueShareOverrideNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RevenueShareOverrideNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RevenueShareOverrideNode` and its cursor. */
export type RevenueShareOverrideNodeEdge = {
  __typename: 'RevenueShareOverrideNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<RevenueShareOverrideNode>;
};

export type RevenueShareOverridePercentageInput = {
  labourPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  otherPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  partsPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCallPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  travelPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  truckPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RevenueSharePercentageInput = {
  labourPercentage: Scalars['Decimal']['input'];
  otherPercentage: Scalars['Decimal']['input'];
  partsPercentage: Scalars['Decimal']['input'];
  serviceCallPercentage: Scalars['Decimal']['input'];
  travelPercentage: Scalars['Decimal']['input'];
  truckPercentage: Scalars['Decimal']['input'];
};

export type ReverseClientInvoicePaymentMutationInput = {
  clientInvoiceId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ReverseClientInvoicePaymentMutationPayload = {
  __typename: 'ReverseClientInvoicePaymentMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type ReviewMetrics = {
  __typename: 'ReviewMetrics';
  negativeReviewCount: Scalars['Int']['output'];
  positiveReviewCount: Scalars['Int']['output'];
  topNegativeFeedback: Array<TopReviewFeedback>;
  topPositiveFeedback: Array<TopReviewFeedback>;
};

export type ReviewRequestNode = Node & {
  __typename: 'ReviewRequestNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type ReviewRequestNodeConnection = {
  __typename: 'ReviewRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReviewRequestNode` and its cursor. */
export type ReviewRequestNodeEdge = {
  __typename: 'ReviewRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<ReviewRequestNode>;
};

/** An enumeration. */
export enum ReviewRequestStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type ReviewSummary = {
  __typename: 'ReviewSummary';
  badReviewCount: Scalars['Int']['output'];
  badReviewTags: Array<Scalars['String']['output']>;
  goodReviewCount: Scalars['Int']['output'];
  goodReviewTags: Array<Scalars['String']['output']>;
};

export type RevokeClientVendorRelationshipInviteInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

export type RevokeClientVendorRelationshipInvitePayload = {
  __typename: 'RevokeClientVendorRelationshipInvitePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type RevokeVendorSubcontractPairingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentVendorId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  subcontractVendorId: Scalars['ID']['input'];
};

/** Coordinator-only pairing revocation between Parent Vendor and Subcontract Vendor orgs. */
export type RevokeVendorSubcontractPairingMutationPayload = {
  __typename: 'RevokeVendorSubcontractPairingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  pairing: VendorSubcontractPairingType;
};

export type RoleNode = Node & {
  __typename: 'RoleNode';
  /** @deprecated Moving forward, name should be suitable for display directly. */
  displayName: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isWorkOrderObserver: Scalars['Boolean']['output'];
  memberships: Array<ClientOrganizationMemberNode>;
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  userCount: Scalars['Int']['output'];
  workOrderObserverType: Maybe<WorkOrderObserverTypeType>;
};

export type RoleNodeConnection = {
  __typename: 'RoleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RoleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RoleNode` and its cursor. */
export type RoleNodeEdge = {
  __typename: 'RoleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<RoleNode>;
};

export type RsgCyovComparisonMetricSide = {
  __typename: 'RsgCyovComparisonMetricSide';
  acceptanceRate90d: Maybe<Scalars['Decimal']['output']>;
  label: Scalars['String']['output'];
  medianCompletionDays90d: Maybe<Scalars['Int']['output']>;
  medianDispatchToScheduleMinutes90d: Maybe<Scalars['Int']['output']>;
  vendorIds: Array<Scalars['ID']['output']>;
};

export type RsgCyovComparisonMetrics = {
  __typename: 'RsgCyovComparisonMetrics';
  rsgFamily: RsgCyovComparisonMetricSide;
  selectedVendor: RsgCyovComparisonMetricSide;
};

export type RsgEmergencyAssistMetrics = {
  __typename: 'RsgEmergencyAssistMetrics';
  acceptanceRate90d: Maybe<Scalars['Decimal']['output']>;
  averageAcceptanceMinutes90d: Maybe<Scalars['Int']['output']>;
  firstOnsiteWithin1DayRate90d: Maybe<Scalars['Decimal']['output']>;
};

/** An enumeration. */
export enum RsgEstimateRequestSource {
  InitialQuoteEmail = 'INITIAL_QUOTE_EMAIL',
  QuoteExpiredEmail = 'QUOTE_EXPIRED_EMAIL',
  QuotePage = 'QUOTE_PAGE',
  QuoteReminderEmail = 'QUOTE_REMINDER_EMAIL'
}

export type RsgPmMissingCoverageGap = {
  __typename: 'RsgPmMissingCoverageGap';
  facility: FacilityNode;
  serviceCategory: ServiceCategory;
};

/** An enumeration. */
export enum RuleBroken {
  OverQuotedAmount = 'OVER_QUOTED_AMOUNT',
  OverSpendApproval = 'OVER_SPEND_APPROVAL',
  PriceTooHigh = 'PRICE_TOO_HIGH',
  TooManyHours = 'TOO_MANY_HOURS'
}

/** An enumeration. */
export enum RuleResolutionAction {
  ConfirmInvoice = 'CONFIRM_INVOICE',
  CreateNewInvoice = 'CREATE_NEW_INVOICE',
  SentNote = 'SENT_NOTE',
  UploadNewInvoice = 'UPLOAD_NEW_INVOICE'
}

export type RuleViolationsFeedbackNode = Node & {
  __typename: 'RuleViolationsFeedbackNode';
  comment: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPositive: Scalars['Boolean']['output'];
  ruleViolations: RuleViolationsNode;
};

export type RuleViolationsNode = Node & {
  __typename: 'RuleViolationsNode';
  expiredAt: Maybe<Scalars['DateTime']['output']>;
  feedback: Maybe<RuleViolationsFeedbackNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  violations: Array<RuleBroken>;
};

export type RuleViolationsNodeConnection = {
  __typename: 'RuleViolationsNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RuleViolationsNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RuleViolationsNode` and its cursor. */
export type RuleViolationsNodeEdge = {
  __typename: 'RuleViolationsNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<RuleViolationsNode>;
};

export type SalesforceClientAccount = {
  __typename: 'SalesforceClientAccount';
  city: Scalars['String']['output'];
  contractSignedDate: Maybe<Scalars['Date']['output']>;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type SalesforceClientAccountResult = {
  __typename: 'SalesforceClientAccountResult';
  client: Maybe<ClientOrganizationNode>;
  customerSuccessManager: Maybe<UserNode>;
  reportingManager: Maybe<UserNode>;
  salesforceClientAccount: Maybe<SalesforceClientAccount>;
  /** Pricing metadata synced from Opportunities; not an Account property. */
  salesforceClientPricingInfo: Maybe<SalesforceClientPricingInfo>;
};

export type SalesforceClientExpansionPossibilities = {
  __typename: 'SalesforceClientExpansionPossibilities';
  numberOfFacilities: Scalars['Int']['output'];
};

/** Pricing metadata captured on Salesforce Opportunities, not on Account. */
export type SalesforceClientPricingInfo = {
  __typename: 'SalesforceClientPricingInfo';
  /** Latest Feature Tier recorded on related Salesforce Opportunities. */
  featureTier: Maybe<Scalars['String']['output']>;
  /** Latest Pricing Model recorded on related Salesforce Opportunities. */
  pricingModel: Maybe<Scalars['String']['output']>;
};

export type SalesforceVendorAccount = {
  __typename: 'SalesforceVendorAccount';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openToMarketplace: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type SalesforceVendorAccountResult = {
  __typename: 'SalesforceVendorAccountResult';
  salesforceVendorAccount: Maybe<SalesforceVendorAccount>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type SatisfactionRate = {
  __typename: 'SatisfactionRate';
  negativeCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
};

export type SaveRecordOfWorkArguments = {
  lineItems: Array<LineItemInput>;
  notes: Scalars['String']['input'];
  overrideNotes: Scalars['String']['input'];
  recordOfWorkId: Scalars['ID']['input'];
  vendorNotes: Scalars['String']['input'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']['input']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Creates or updates a record of work by work order. */
export type SaveRecordOfWorkMutation = {
  __typename: 'SaveRecordOfWorkMutation';
  recordOfWork: RecordOfWorkNode;
};

export type SaveReviewedOffResqWorkOrderVisitNotesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  offResqAppointmentId: Scalars['ID']['input'];
};

export type SaveReviewedOffResqWorkOrderVisitNotesMutationPayload = {
  __typename: 'SaveReviewedOffResqWorkOrderVisitNotesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqAppointment: Maybe<OffResqAppointmentNode>;
};

export type SaveReviewedVisitNotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  visit: Scalars['ID']['input'];
};

export type SaveReviewedVisitNotesPayload = {
  __typename: 'SaveReviewedVisitNotesPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  visit: VisitNode;
};

export type SaveVendorBrandLogoMutationInput = {
  brandLogo?: InputMaybe<Image>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type SaveVendorBrandLogoMutationPayload = {
  __typename: 'SaveVendorBrandLogoMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorBusinessProfile: Maybe<VendorBusinessProfileNode>;
};

export type SaveVendorCoverImageMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL of the image to save */
  imageUrl: Scalars['String']['input'];
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

/** Mutation to save a preview cover image URL to the vendor business profile. */
export type SaveVendorCoverImageMutationPayload = {
  __typename: 'SaveVendorCoverImageMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Success or error message */
  message: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Maybe<Scalars['Boolean']['output']>;
  /** Updated vendor business profile */
  vendorBusinessProfile: Maybe<VendorBusinessProfileNode>;
};

export type SaveVendorOrderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
  vendorIds: Array<Scalars['ID']['input']>;
};

export type SaveVendorOrderMutationPayload = {
  __typename: 'SaveVendorOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type SaveVendorRankingForFacilityAndServiceCategoryOrderMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorIds: Array<Scalars['ID']['input']>;
  vendorRankingForFacilityAndServiceCategoryId: Scalars['ID']['input'];
};

export type SaveVendorRankingForFacilityAndServiceCategoryOrderMutationPayload = {
  __typename: 'SaveVendorRankingForFacilityAndServiceCategoryOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorRanking: Maybe<VendorRankingNode>;
};

export type SaveVendorWebsiteGoogleAdsBillingConfigMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyBudgetAmount?: InputMaybe<Scalars['Decimal']['input']>;
  monthlyBudgetAmount?: InputMaybe<Scalars['Decimal']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
};

export type SaveVendorWebsiteGoogleAdsBillingConfigMutationPayload = {
  __typename: 'SaveVendorWebsiteGoogleAdsBillingConfigMutationPayload';
  billing: GoogleAdsBillingStateType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SaveVendorWebsiteGoogleAdsDraftMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftType: Scalars['String']['input'];
  payload: Scalars['GenericScalar']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
  websiteAdvertisingCampaignId: Scalars['ID']['input'];
};

export type SaveVendorWebsiteGoogleAdsDraftMutationPayload = {
  __typename: 'SaveVendorWebsiteGoogleAdsDraftMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ScheduleInternalAppointmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  internalRequestId: Scalars['ID']['input'];
};

export type ScheduleInternalAppointmentPayload = {
  __typename: 'ScheduleInternalAppointmentPayload';
  appointment: InternalAppointmentNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type ScheduleVendorNoraConfigurationInterviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetUserId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type ScheduleVendorNoraConfigurationInterviewMutationPayload = {
  __typename: 'ScheduleVendorNoraConfigurationInterviewMutationPayload';
  callSid: Maybe<Scalars['String']['output']>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type ScheduledExternalItem = {
  __typename: 'ScheduledExternalItem';
  appointment: AppointmentNode;
  date: Scalars['Date']['output'];
};

export type ScheduledInternalItem = {
  __typename: 'ScheduledInternalItem';
  date: Scalars['Date']['output'];
  internalAppointment: InternalAppointmentNode;
};

export type ScheduledTradesPlanChangeType = {
  __typename: 'ScheduledTradesPlanChangeType';
  currentPlanAccessUntil: Maybe<Scalars['Date']['output']>;
  effectiveDate: Scalars['Date']['output'];
  targetServiceName: Scalars['String']['output'];
};

export type SchedulingActivity = Activity & Node & {
  __typename: 'SchedulingActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  request: SchedulingRequest;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type SchedulingRequest = Node & {
  __typename: 'SchedulingRequest';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this request was cancelled. Operations that can cancel a scheduling request: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  /** The time at which this request was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']['output']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  permissions: SchedulingRequestPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type SchedulingRequestConnection = {
  __typename: 'SchedulingRequestConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SchedulingRequestEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SchedulingRequest` and its cursor. */
export type SchedulingRequestEdge = {
  __typename: 'SchedulingRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SchedulingRequest>;
};

export type SchedulingRequestPermissions = {
  __typename: 'SchedulingRequestPermissions';
  fulfill: Scalars['Boolean']['output'];
};

export type SchedulingViolation = {
  __typename: 'SchedulingViolation';
  type: SchedulingViolationType;
};

/** An enumeration. */
export enum SchedulingViolationType {
  MaintenancePlanScheduling = 'MAINTENANCE_PLAN_SCHEDULING',
  OnDemandScheduling = 'ON_DEMAND_SCHEDULING',
  Overtime = 'OVERTIME'
}

/** An enumeration. */
export enum ScoreMetric {
  ActionRate = 'ACTION_RATE',
  DispatchResponseTime = 'DISPATCH_RESPONSE_TIME',
  DisputeRate = 'DISPUTE_RATE',
  FirstTimeFixRate = 'FIRST_TIME_FIX_RATE',
  PlatformUsage = 'PLATFORM_USAGE',
  SatisfactionRate = 'SATISFACTION_RATE',
  TimeToInvoice = 'TIME_TO_INVOICE',
  TimeToOnsite = 'TIME_TO_ONSITE',
  TimeToQuote = 'TIME_TO_QUOTE'
}

/** An enumeration. */
export enum ScorePillar {
  Process = 'PROCESS',
  Quality = 'QUALITY',
  Speed = 'SPEED'
}

export type SearchGoogleAdsLocationTargetsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
};

export type SearchGoogleAdsLocationTargetsMutationPayload = {
  __typename: 'SearchGoogleAdsLocationTargetsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  locationTargets: Array<GoogleAdsCampaignInputSnapshotLocationTargetType>;
};

export type SearchResult = ClientOrganizationNode | FacilityNode | InvoiceSetNode | MaintenancePlanNode | OffResqCustomerNode | OffResqFacilityNode | OffResqWorkOrderNode | UserNode | VendorOrganizationNode | WorkOrderNode;

export type SelectQuoteSetOptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteSetOptionId: Scalars['ID']['input'];
};

export type SelectQuoteSetOptionPayload = {
  __typename: 'SelectQuoteSetOptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

/** Input for selecting testimonials to add to the business profile. */
export type SelectedTestimonialInput = {
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};

export type SendInviteSmsMutation = {
  __typename: 'SendInviteSMSMutation';
  ok: Scalars['Boolean']['output'];
};

export type SendProposalReminderMutationInput = {
  approver?: InputMaybe<ProposalApproverInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['ID']['input'];
};

export type SendProposalReminderMutationPayload = {
  __typename: 'SendProposalReminderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  proposal: ProposalNode;
};

export type SendReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportTemplateId: Scalars['ID']['input'];
};

export type SendReportPayload = {
  __typename: 'SendReportPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  reportTemplate: ReportTemplateNode;
};

export type SendVendorEmailNotificationInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inboundVendorInvoiceExtractionId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type SendVendorEmailNotificationPayload = {
  __typename: 'SendVendorEmailNotificationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SendVendorIntroEmailMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailContent: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Mutation to send intro email from vendor to facility. */
export type SendVendorIntroEmailMutationPayload = {
  __typename: 'SendVendorIntroEmailMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SendVendorPromoEmailMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotionId: Scalars['ID']['input'];
  recipients: Array<VendorPromoEmailRecipientInput>;
  subject: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type SendVendorPromoEmailMutationPayload = {
  __typename: 'SendVendorPromoEmailMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  sentCount: Scalars['Int']['output'];
};

export type SendVendorSubscriptionPaymentLinkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SendVendorSubscriptionPaymentLinkMutationPayload = {
  __typename: 'SendVendorSubscriptionPaymentLinkMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SendWelcomeEmailMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type SendWelcomeEmailMutationPayload = {
  __typename: 'SendWelcomeEmailMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum Sensitivity {
  PriceSensitive = 'PRICE_SENSITIVE',
  QualitySensitive = 'QUALITY_SENSITIVE'
}

/** An enumeration. */
export enum SensorConfigState {
  Disable = 'DISABLE',
  Enable = 'ENABLE'
}

export type SensorHealthDashboard = {
  __typename: 'SensorHealthDashboard';
  drilldown: Array<SensorHealthDashboardDrilldownRow>;
  gateways: SensorHealthDashboardGateways;
  generatedAt: Scalars['DateTime']['output'];
  incidents: SensorHealthDashboardIncidents;
  polling: SensorHealthDashboardPolling;
  sensors: SensorHealthDashboardSensors;
  service: SensorHealthDashboardService;
};

export type SensorHealthDashboardDrilldownRow = {
  __typename: 'SensorHealthDashboardDrilldownRow';
  configNeverPolled: Scalars['Boolean']['output'];
  configPollingOverdue: Scalars['Boolean']['output'];
  facilityId: Maybe<Scalars['Int']['output']>;
  gatewayId: Maybe<Scalars['ID']['output']>;
  gatewayIsOnline: Scalars['Boolean']['output'];
  gatewayLastUplinkReceived: Maybe<Scalars['DateTime']['output']>;
  gatewayName: Maybe<Scalars['String']['output']>;
  incidentId: Maybe<Scalars['ID']['output']>;
  incidentStatus: Maybe<IncidentStatus>;
  lastDataAt: Maybe<Scalars['DateTime']['output']>;
  lastPolledAt: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['Int']['output'];
  sensorId: Scalars['ID']['output'];
  sensorModel: Scalars['String']['output'];
  sensorName: Scalars['String']['output'];
};

export type SensorHealthDashboardGateways = {
  __typename: 'SensorHealthDashboardGateways';
  neverSeen: Scalars['Int']['output'];
  offline: Scalars['Int']['output'];
  online: Scalars['Int']['output'];
  stale24hPlus: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SensorHealthDashboardIncidents = {
  __typename: 'SensorHealthDashboardIncidents';
  oldestOngoingCreatedAt: Maybe<Scalars['DateTime']['output']>;
  ongoing: Scalars['Int']['output'];
  snoozed: Scalars['Int']['output'];
  unlinkedToWorkOrder: Scalars['Int']['output'];
};

export type SensorHealthDashboardPolling = {
  __typename: 'SensorHealthDashboardPolling';
  configsDue: Scalars['Int']['output'];
  configsNeverPolled: Scalars['Int']['output'];
  configsOverdue: Scalars['Int']['output'];
  lastDigestTickAt: Maybe<Scalars['DateTime']['output']>;
};

export type SensorHealthDashboardSensors = {
  __typename: 'SensorHealthDashboardSensors';
  neverReported: Scalars['Int']['output'];
  reportingRecently: Scalars['Int']['output'];
  stale: Scalars['Int']['output'];
  totalActive: Scalars['Int']['output'];
};

export type SensorHealthDashboardService = {
  __typename: 'SensorHealthDashboardService';
  lastSuccessfulStatsRefresh: Maybe<Scalars['DateTime']['output']>;
  reachable: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum ServiceCategory {
  AccessibilityHardware = 'ACCESSIBILITY_HARDWARE',
  AirCompressors = 'AIR_COMPRESSORS',
  ArchitectDesign = 'ARCHITECT_DESIGN',
  Asbestos = 'ASBESTOS',
  Audits = 'AUDITS',
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  Backflow = 'BACKFLOW',
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  BowlingEquipment = 'BOWLING_EQUIPMENT',
  BurglarAlarm = 'BURGLAR_ALARM',
  Checklist = 'CHECKLIST',
  Chowbotics = 'CHOWBOTICS',
  Cleaning = 'CLEANING',
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  Co2 = 'CO2',
  Coffee = 'COFFEE',
  ConsumablesReplenishment = 'CONSUMABLES_REPLENISHMENT',
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  DriveThuItems = 'DRIVE_THU_ITEMS',
  Electrical = 'ELECTRICAL',
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  EmergencyLights = 'EMERGENCY_LIGHTS',
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  EquipmentLeasing = 'EQUIPMENT_LEASING',
  FireAlarms = 'FIRE_ALARMS',
  FireSuppression = 'FIRE_SUPPRESSION',
  Fixtures = 'FIXTURES',
  Flooring = 'FLOORING',
  FoodEquipment = 'FOOD_EQUIPMENT',
  FuelOil = 'FUEL_OIL',
  Furniture = 'FURNITURE',
  Gaskets = 'GASKETS',
  GasBoilers = 'GAS_BOILERS',
  GeneralContracting = 'GENERAL_CONTRACTING',
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  Generators = 'GENERATORS',
  GreaseTrap = 'GREASE_TRAP',
  GymEquipment = 'GYM_EQUIPMENT',
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  Hoods = 'HOODS',
  Hospitality = 'HOSPITALITY',
  HotWaterTank = 'HOT_WATER_TANK',
  IceMachine = 'ICE_MACHINE',
  Landscaping = 'LANDSCAPING',
  LocksDoors = 'LOCKS_DOORS',
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  MenuScreens = 'MENU_SCREENS',
  MessengerServices = 'MESSENGER_SERVICES',
  Millwork = 'MILLWORK',
  Miscellaneous = 'MISCELLANEOUS',
  MovingServices = 'MOVING_SERVICES',
  PackScreens = 'PACK_SCREENS',
  Painting = 'PAINTING',
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  Pavement = 'PAVEMENT',
  PestControl = 'PEST_CONTROL',
  PlannedProject = 'PLANNED_PROJECT',
  Plumbing = 'PLUMBING',
  Refrigeration = 'REFRIGERATION',
  Roofing = 'ROOFING',
  RoomSetupTakeDown = 'ROOM_SETUP_TAKE_DOWN',
  Security = 'SECURITY',
  Shredding = 'SHREDDING',
  Signage = 'SIGNAGE',
  SnowRemoval = 'SNOW_REMOVAL',
  SodaBeer = 'SODA_BEER',
  SpaEquipment = 'SPA_EQUIPMENT',
  Technology = 'TECHNOLOGY',
  TempServices = 'TEMP_SERVICES',
  Tiling = 'TILING',
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  Upholstery = 'UPHOLSTERY',
  VendingMachines = 'VENDING_MACHINES',
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  WasteRemoval = 'WASTE_REMOVAL',
  WaterFiltration = 'WATER_FILTRATION',
  Welding = 'WELDING',
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  WindowsGlass = 'WINDOWS_GLASS'
}

export type ServiceCategoryCount = {
  __typename: 'ServiceCategoryCount';
  count: Scalars['Int']['output'];
  serviceCategory: ServiceCategory;
};

export type ServiceCategoryNode = {
  __typename: 'ServiceCategoryNode';
  isNew: Scalars['Boolean']['output'];
  key: ServiceCategory;
};

/**
 * Input type for a single service order line item.
 *
 * Service types allowed:
 * - TAGGING (12)
 * - SENSOR_GATEWAYS (13)
 * - IOT_SENSOR_INSTALLATION (15)
 * - SENSOR_HARDWARE (16)
 */
export type ServiceOrderLineItemInput = {
  /** Line item description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Service order line item type */
  itemType: ServiceOrderLineItemTypeEnum;
  /** Unit price (must be >= 0) */
  price: Scalars['Decimal']['input'];
  /** Quantity (must be > 0) */
  quantity: Scalars['Decimal']['input'];
};

/** Output type for a service order line item with tax calculation. */
export type ServiceOrderLineItemOutput = {
  __typename: 'ServiceOrderLineItemOutput';
  description: Maybe<Scalars['String']['output']>;
  itemType: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /** Taxable portion of line item */
  taxableAmount: Maybe<Scalars['Decimal']['output']>;
  /** Line total before tax */
  total: Scalars['Decimal']['output'];
  /** Tax amount for this line item */
  totalTax: Maybe<Scalars['Decimal']['output']>;
};

/** Line item types allowed for ResQ service orders. */
export enum ServiceOrderLineItemTypeEnum {
  IotSensorInstallation = 'IOT_SENSOR_INSTALLATION',
  SensorGateways = 'SENSOR_GATEWAYS',
  SensorHardware = 'SENSOR_HARDWARE',
  Tagging = 'TAGGING'
}

/** Output for created service order. */
export type ServiceOrderOutput = {
  __typename: 'ServiceOrderOutput';
  businessUnitId: Scalars['Int']['output'];
  clientInvoiceId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  invoiceCode: Scalars['String']['output'];
  issueDate: Scalars['Date']['output'];
  organizationId: Scalars['Int']['output'];
  subtotalAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

/** Preview of service order costs including taxes. */
export type ServiceOrderPreviewOutput = {
  __typename: 'ServiceOrderPreviewOutput';
  currency: Scalars['String']['output'];
  /** Line items with tax calculations */
  lineItems: Array<ServiceOrderLineItemOutput>;
  /** Subtotal before taxes */
  subtotal: Scalars['Decimal']['output'];
  /** Total tax amount */
  tax: Scalars['Decimal']['output'];
  /** Tax breakdown by rate */
  taxBreakdown: Array<TaxBreakdownOutput>;
  /** Total including tax */
  total: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum ServiceType {
  PreventiveMaintenance = 'PREVENTIVE_MAINTENANCE',
  Repair = 'REPAIR'
}

export type SetEntityPinnedMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  pinned: Scalars['Boolean']['input'];
};

export type SetEntityPinnedMutationPayload = {
  __typename: 'SetEntityPinnedMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  pinnedEntity: Maybe<PinnedEntityNode>;
};

export type SetEstimatedTimeOfArrivalSourcingPartsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partsEstimatedDateEnd: Scalars['Date']['input'];
  partsEstimatedDateStart: Scalars['Date']['input'];
  sourcingPartsHoldId: Scalars['ID']['input'];
};

export type SetEstimatedTimeOfArrivalSourcingPartsMutationPayload = {
  __typename: 'SetEstimatedTimeOfArrivalSourcingPartsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  sourcingPartsHold: SourcingPartsHold;
};

export type SetGoogleAdsCampaignBudgetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyBudgetAmount: Scalars['Decimal']['input'];
  googleAdsCampaignId: Scalars['ID']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
};

export type SetGoogleAdsCampaignBudgetMutationPayload = {
  __typename: 'SetGoogleAdsCampaignBudgetMutationPayload';
  billing: GoogleAdsBillingStateType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  dailyBudgetAmount: Scalars['Decimal']['output'];
  monthlyBudgetAmount: Scalars['Decimal']['output'];
  ok: Scalars['Boolean']['output'];
};

export type SetGoogleAdsCampaignStatusMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  googleAdsCampaignId: Scalars['ID']['input'];
  targetStatus: Scalars['String']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
};

export type SetGoogleAdsCampaignStatusMutationPayload = {
  __typename: 'SetGoogleAdsCampaignStatusMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  created: Scalars['Boolean']['output'];
  jobId: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  targetStatus: Scalars['String']['output'];
};

export type SetReceptionistEnabledMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  receptionistEnabledType?: InputMaybe<ReceptionistEnabledType>;
  vendorId: Scalars['ID']['input'];
};

export type SetReceptionistEnabledMutationPayload = {
  __typename: 'SetReceptionistEnabledMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

export type SetReceptionistTransferMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  receptionistTransferType?: InputMaybe<ReceptionistTransferType>;
  vendorId: Scalars['ID']['input'];
};

export type SetReceptionistTransferMutationPayload = {
  __typename: 'SetReceptionistTransferMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

export type SetSensorConfigStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceConfigId: Scalars['String']['input'];
  equipmentId: Scalars['ID']['input'];
  state: SensorConfigState;
};

export type SetSensorConfigStatePayload = {
  __typename: 'SetSensorConfigStatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetSubscriptionAddonsInput = {
  addons: Array<SubscriptionAddon>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['Boolean']['input']>;
  dataHashKey: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  prorate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetSubscriptionAddonsPayload = {
  __typename: 'SetSubscriptionAddonsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  dataHashKey: Scalars['String']['output'];
  newAddons: Array<SubscriptionAddonNode>;
  oldAddons: Array<SubscriptionAddonNode>;
};

export type SetUserNoficationPreferenceMutationInput = {
  channel: NotificationChannel;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  notificationName: Scalars['String']['input'];
};

export type SetUserNoficationPreferenceMutationPayload = {
  __typename: 'SetUserNoficationPreferenceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  userNotificationPreference: UserNotificationPreferenceNode;
};

export type SetVendorAgreementPlansMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enablePlansImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  overrideCurrentPlanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedPlanIds: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type SetVendorAgreementPlansMutationPayload = {
  __typename: 'SetVendorAgreementPlansMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorAgreement: VendorAgreementNode;
};

export type SetVendorSubscriptionPaymentMethodMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type SetVendorSubscriptionPaymentMethodMutationPayload = {
  __typename: 'SetVendorSubscriptionPaymentMethodMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  paymentMethod: PaymentMethodNode;
};

export type SetWebsiteAdvertisingCampaignDailyBudgetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyBudgetAmount: Scalars['Decimal']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
  websiteAdvertisingCampaignId: Scalars['ID']['input'];
};

export type SetWebsiteAdvertisingCampaignDailyBudgetMutationPayload = {
  __typename: 'SetWebsiteAdvertisingCampaignDailyBudgetMutationPayload';
  billing: GoogleAdsBillingStateType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  dailyBudgetAmount: Scalars['Decimal']['output'];
  monthlyBudgetAmount: Scalars['Decimal']['output'];
  ok: Scalars['Boolean']['output'];
};

export type SetupPreAuthorizedDebitMutationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditCardSetup?: InputMaybe<Scalars['Boolean']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetupPreAuthorizedDebitMutationPayload = {
  __typename: 'SetupPreAuthorizedDebitMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
  paymentMethod: Maybe<PaymentMethodNode>;
};

export type SignatureUploadInput = {
  dataUrl: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type SiteVisitActivity = Activity & Node & {
  __typename: 'SiteVisitActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  outcome: Maybe<SiteVisitActivityOutcome>;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  visit: VisitNode;
  workOrder: WorkOrderNode;
};

export enum SiteVisitActivityOutcome {
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type SkillNode = Node & {
  __typename: 'SkillNode';
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type SkillNodeConnection = {
  __typename: 'SkillNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SkillNode` and its cursor. */
export type SkillNodeEdge = {
  __typename: 'SkillNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SkillNode>;
};

export type SkipOnboardingStepMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId: Scalars['ID']['input'];
  step: OnboardingSteps;
};

export type SkipOnboardingStepMutationPayload = {
  __typename: 'SkipOnboardingStepMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SkipWorkOrderReviewMutation = {
  __typename: 'SkipWorkOrderReviewMutation';
  workOrder: WorkOrderNode;
};

export type SnoozeIncidentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationInMinutes: Scalars['Int']['input'];
  equipmentIds: Array<Scalars['ID']['input']>;
  incidentIds: Array<Scalars['String']['input']>;
};

export type SnoozeIncidentsPayload = {
  __typename: 'SnoozeIncidentsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SnoozeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  visibleAt: Scalars['DateTime']['input'];
};

export type SnoozeMutationPayload = {
  __typename: 'SnoozeMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SnoozeReviewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SnoozeReviewsPayload = {
  __typename: 'SnoozeReviewsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export enum SourceUserType {
  Client = 'CLIENT',
  Coordinator = 'COORDINATOR',
  Unknown = 'UNKNOWN',
  Vendor = 'VENDOR'
}

export type SourcingPartsActivity = Activity & Node & {
  __typename: 'SourcingPartsActivity';
  activityType: ActivityType;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<UserNode>;
  dueAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  sourcingPartsHold: SourcingPartsHold;
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  workOrder: WorkOrderNode;
};

export type SourcingPartsHold = Node & {
  __typename: 'SourcingPartsHold';
  appointment: Maybe<AppointmentNode>;
  /** The time at which this hold was cancelled. Operations that can cancel a hold: forced activity transitions. */
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  /** The time at which this hold was fulfilled to schedule an appointment. */
  fulfilledAt: Maybe<Scalars['DateTime']['output']>;
  fulfilledBy: Maybe<UserNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  partsEstimatedDateEnd: Maybe<Scalars['Date']['output']>;
  partsEstimatedDateSetBy: Maybe<UserNode>;
  partsEstimatedDateStart: Maybe<Scalars['Date']['output']>;
  permissions: SourcingPartsHoldPermissions;
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type SourcingPartsHoldConnection = {
  __typename: 'SourcingPartsHoldConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SourcingPartsHoldEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SourcingPartsHold` and its cursor. */
export type SourcingPartsHoldEdge = {
  __typename: 'SourcingPartsHoldEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SourcingPartsHold>;
};

export type SourcingPartsHoldPermissions = {
  __typename: 'SourcingPartsHoldPermissions';
  fulfill: Scalars['Boolean']['output'];
};

export type SpellCheckedAddressComponent = {
  __typename: 'SpellCheckedAddressComponent';
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type SpendApprovalNode = Node & {
  __typename: 'SpendApprovalNode';
  approvalRequiredOvertimeThreshold: Maybe<Scalars['Int']['output']>;
  approvalRequiredThreshold: Maybe<Scalars['Int']['output']>;
  approvedAmount: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  nteRaiseRequestApprovedBy: Maybe<UserNode>;
  nteRaiseRequestedApprovalThreshold: Maybe<Scalars['Int']['output']>;
  overtimeApprovedBy: Maybe<UserNode>;
  permissions: SpendApprovalPermissions;
  quoteBypassApprovedBy: Maybe<UserNode>;
  quotePrice: Maybe<Scalars['Int']['output']>;
  workOrderId: Scalars['ID']['output'];
};

export type SpendApprovalNodeConnection = {
  __typename: 'SpendApprovalNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpendApprovalNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpendApprovalNode` and its cursor. */
export type SpendApprovalNodeEdge = {
  __typename: 'SpendApprovalNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SpendApprovalNode>;
};

export type SpendApprovalPermissions = {
  __typename: 'SpendApprovalPermissions';
  /** Permissions to raise the approved spend */
  raiseApprovedSpend: Scalars['Boolean']['output'];
};

export type SpendApprovalPreferenceNode = Node & {
  __typename: 'SpendApprovalPreferenceNode';
  approvalRequiredOvertimeThreshold: Scalars['Int']['output'];
  approvalRequiredThreshold: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type SpendApprovalPreferenceNodeConnection = {
  __typename: 'SpendApprovalPreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpendApprovalPreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpendApprovalPreferenceNode` and its cursor. */
export type SpendApprovalPreferenceNodeEdge = {
  __typename: 'SpendApprovalPreferenceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SpendApprovalPreferenceNode>;
};

export type SpendByPeriod = {
  __typename: 'SpendByPeriod';
  internalSpendAmount: Maybe<Scalars['Decimal']['output']>;
  period: MetricsPeriod;
  spendAmount: Scalars['Decimal']['output'];
};

export type SpendByServiceCategory = {
  __typename: 'SpendByServiceCategory';
  internalSpendAmount: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  spendAmount: Scalars['Decimal']['output'];
};

export type SpendItemAllocationNode = Node & {
  __typename: 'SpendItemAllocationNode';
  allocatedAmount: Scalars['Decimal']['output'];
  attachment: Maybe<AttachmentNode>;
  description: Scalars['String']['output'];
  expenseDate: Scalars['Date']['output'];
  expenseType: ExpenseType;
  facility: Maybe<FacilityNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategory: Maybe<ServiceCategory>;
};

export type SpendThisPeriodBreakdown = {
  __typename: 'SpendThisPeriodBreakdown';
  externalSpend: Scalars['Decimal']['output'];
  internalSpend: Scalars['Decimal']['output'];
  totalSpend: Scalars['Decimal']['output'];
};

export type StandaloneQuoteActionMutationInput = {
  action: OffResqQuoteDecision;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

/** Unified mutation for accepting or rejecting standalone quotes. */
export type StandaloneQuoteActionMutationPayload = {
  __typename: 'StandaloneQuoteActionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quote: QuoteNode;
};

export type StartAppointmentActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  noteMessage?: InputMaybe<Scalars['String']['input']>;
  notifyVendor: Scalars['Boolean']['input'];
  startsAt: Scalars['DateTime']['input'];
  technician?: InputMaybe<Scalars['ID']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type StartAppointmentActivityPayload = {
  __typename: 'StartAppointmentActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartChooseVendorActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previousActivity: Scalars['ID']['input'];
  workOrder: Scalars['ID']['input'];
};

export type StartChooseVendorActivityPayload = {
  __typename: 'StartChooseVendorActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartDispatchActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  previousActivity?: InputMaybe<Scalars['ID']['input']>;
  vendor?: InputMaybe<Scalars['ID']['input']>;
  vendors?: InputMaybe<Array<Scalars['ID']['input']>>;
  workOrder: Scalars['ID']['input'];
};

export type StartDispatchActivityPayload = {
  __typename: 'StartDispatchActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartFindingQuoteActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type StartFindingQuoteActivityPayload = {
  __typename: 'StartFindingQuoteActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteSet: QuoteSetNode;
};

export type StartOffResqWorkOrderVisitMutationInput = {
  beforeImages?: InputMaybe<Array<Image>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqAppointmentId: Scalars['ID']['input'];
  technicianId?: InputMaybe<Scalars['ID']['input']>;
};

export type StartOffResqWorkOrderVisitMutationPayload = {
  __typename: 'StartOffResqWorkOrderVisitMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqAppointment: Maybe<OffResqAppointmentNode>;
};

export type StartOnHoldActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  notes: Scalars['String']['input'];
  workOrder: Scalars['ID']['input'];
};

export type StartOnHoldActivityPayload = {
  __typename: 'StartOnHoldActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartOrganizationSubscriptionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  subscriptionStartDate?: InputMaybe<Scalars['Date']['input']>;
  subscriptions: Array<SubscriptionInput>;
};

export type StartOrganizationSubscriptionMutationPayload = {
  __typename: 'StartOrganizationSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartOverdueInvoicesCalldownInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  overdueInvoiceIds: Array<Scalars['ID']['input']>;
  /** ID of the user to call */
  userToCallId: Scalars['ID']['input'];
};

/** Mutation to start an overdue invoices calldown. */
export type StartOverdueInvoicesCalldownPayload = {
  __typename: 'StartOverdueInvoicesCalldownPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type StartPerUserSubscriptionInput = {
  /** Billing period (monthly, quarterly, or annual) */
  billingPeriod: Scalars['String']['input'];
  /** Business unit ID (Relay global ID). Must belong to the organization. */
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** GL code for this subscription */
  glCode?: InputMaybe<Scalars['String']['input']>;
  /** Initial number of users (minimum 1) */
  initialUserCount: Scalars['Int']['input'];
  /** Client organization ID (Relay global ID) */
  organizationId: Scalars['ID']['input'];
  /** Payment method ID (Relay global ID). Must belong to the organization. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** Subscription start date (can be past, present, or future). Defaults to today. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type StartPerUserSubscriptionPayload = {
  __typename: 'StartPerUserSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  perUserSubscription: Maybe<PerUserSubscriptionNode>;
  warnings: Array<Scalars['String']['output']>;
};

export type StartResqReviewActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  reviewType: ResqReviewActivityReviewType;
  workOrder: Scalars['ID']['input'];
};

export type StartResqReviewActivityPayload = {
  __typename: 'StartResqReviewActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartSchedulingActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type StartSchedulingActivityPayload = {
  __typename: 'StartSchedulingActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartSchedulingCalldownInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userToCallId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type StartSchedulingCalldownPayload = {
  __typename: 'StartSchedulingCalldownPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type StartSiteVisitActivityInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerName: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  images: Array<Image>;
  visitedBy?: InputMaybe<Scalars['ID']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type StartSiteVisitActivityPayload = {
  __typename: 'StartSiteVisitActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  visit: VisitNode;
};

export type StartSourcingPartsActivityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  sourcingPartsHoldEtaEnd?: InputMaybe<Scalars['Date']['input']>;
  sourcingPartsHoldEtaStart?: InputMaybe<Scalars['Date']['input']>;
  workOrder: Scalars['ID']['input'];
};

export type StartSourcingPartsActivityPayload = {
  __typename: 'StartSourcingPartsActivityPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type StartSubscriptionInput = {
  addons: Array<SubscriptionAddon>;
  billingFrequency: BillingFrequency;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['Boolean']['input']>;
  dataHashKey: Scalars['String']['input'];
  effectiveStartDate: Scalars['Date']['input'];
  facilityId: Scalars['ID']['input'];
  glCode?: InputMaybe<Scalars['String']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  prorate?: InputMaybe<Scalars['Boolean']['input']>;
  unitAmount: Scalars['Decimal']['input'];
};

export type StartSubscriptionPayload = {
  __typename: 'StartSubscriptionPayload';
  addons: Array<SubscriptionAddonNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  dataHashKey: Scalars['String']['output'];
  invoicePreviewUrl: Maybe<Scalars['String']['output']>;
  subscription: SubscriptionNode;
};

export type StartVisitMutationInput = {
  appointmentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityManagerName: Scalars['String']['input'];
  images: Array<Image>;
};

export type StartVisitMutationPayload = {
  __typename: 'StartVisitMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  visit: VisitNode;
};

/** An enumeration. */
export enum StripeAccount {
  Ca = 'CA',
  Uk = 'UK',
  Us = 'US'
}

export type StripeCustomerNode = Node & {
  __typename: 'StripeCustomerNode';
  account: StripeAccount;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type StripeCustomerNodeConnection = {
  __typename: 'StripeCustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StripeCustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `StripeCustomerNode` and its cursor. */
export type StripeCustomerNodeEdge = {
  __typename: 'StripeCustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<StripeCustomerNode>;
};

export enum SubcontractFirstVisitStatus {
  NeedsScheduling = 'NEEDS_SCHEDULING',
  PendingAcceptance = 'PENDING_ACCEPTANCE'
}

/** An enumeration. */
export enum SubcontractSettlementInvoiceCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

export type SubcontractSettlementInvoiceLineItemType = {
  __typename: 'SubcontractSettlementInvoiceLineItemType';
  description: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
};

export type SubcontractSettlementInvoiceNode = Node & {
  __typename: 'SubcontractSettlementInvoiceNode';
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: SubcontractSettlementInvoiceCurrency;
  expectedPaymentDate: Maybe<Scalars['Date']['output']>;
  externalPaymentNote: Scalars['String']['output'];
  externalPaymentReference: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceTotal: Scalars['Decimal']['output'];
  isAdjustment: Scalars['Boolean']['output'];
  issuedAtDate: Maybe<Scalars['Date']['output']>;
  lineItems: Array<SubcontractSettlementInvoiceLineItemType>;
  lineItemsSubtotal: Scalars['Decimal']['output'];
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  paidAmount: Maybe<Scalars['Decimal']['output']>;
  paidExternallyAt: Maybe<Scalars['DateTime']['output']>;
  parentVendor: VendorOrganizationNode;
  paymentTermDays: Maybe<Scalars['Int']['output']>;
  pdfFile: Maybe<FileType>;
  sourceVendorInvoice: Maybe<VendorInvoiceNode>;
  sourceVendorInvoiceCode: Maybe<Scalars['String']['output']>;
  status: SubcontractSettlementInvoiceStatus;
  subcontractVendor: VendorOrganizationNode;
  subcontractorSharePercentage: Maybe<Scalars['Decimal']['output']>;
  total: Scalars['Decimal']['output'];
  voidReason: Scalars['String']['output'];
  voidedAt: Maybe<Scalars['DateTime']['output']>;
  voidedBy: Maybe<UserNode>;
  workOrder: Maybe<WorkOrderNode>;
};

export type SubcontractSettlementInvoiceNodeConnection = {
  __typename: 'SubcontractSettlementInvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubcontractSettlementInvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SubcontractSettlementInvoiceNode` and its cursor. */
export type SubcontractSettlementInvoiceNodeEdge = {
  __typename: 'SubcontractSettlementInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SubcontractSettlementInvoiceNode>;
};

/** An enumeration. */
export enum SubcontractSettlementInvoiceStatus {
  Issued = 'ISSUED',
  PaidExternally = 'PAID_EXTERNALLY',
  Voided = 'VOIDED'
}

/** An enumeration. */
export enum SubcontractSettlementRemittanceStatementCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

export type SubcontractSettlementRemittanceStatementNode = Node & {
  __typename: 'SubcontractSettlementRemittanceStatementNode';
  createdAt: Scalars['DateTime']['output'];
  currency: SubcontractSettlementRemittanceStatementCurrency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  pdfFile: Maybe<FileType>;
  statementDate: Scalars['Date']['output'];
  subcontractVendor: VendorOrganizationNode;
  totalAmount: Scalars['Decimal']['output'];
};

export type SubcontractSettlementRemittanceStatementNodeConnection = {
  __typename: 'SubcontractSettlementRemittanceStatementNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubcontractSettlementRemittanceStatementNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SubcontractSettlementRemittanceStatementNode` and its cursor. */
export type SubcontractSettlementRemittanceStatementNodeEdge = {
  __typename: 'SubcontractSettlementRemittanceStatementNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SubcontractSettlementRemittanceStatementNode>;
};

export type SubcontractorShareTierSelectionType = {
  __typename: 'SubcontractorShareTierSelectionType';
  appliesToInvoice: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  tier: VendorSubcontractPairingTierNode;
};

export type SubcontractorShareTierSelectionsType = {
  __typename: 'SubcontractorShareTierSelectionsType';
  errorMessage: Maybe<Scalars['String']['output']>;
  options: Array<SubcontractorShareTierSelectionType>;
  pairing: VendorSubcontractPairingType;
  recommendedTier: Maybe<VendorSubcontractPairingTierNode>;
  resolutionSource: Maybe<Scalars['String']['output']>;
  resolvedSubcontractorSharePercentage: Maybe<Scalars['Decimal']['output']>;
};

export type SubmitBusinessInformationInput = {
  beneficialOwners?: InputMaybe<Array<BeneficialOwnerInput>>;
  businessAdminAddress: BusinessAdminAddressInput;
  businessAdminDateOfBirth: Scalars['Date']['input'];
  businessAdminEmail: Scalars['String']['input'];
  businessAdminFirstName: Scalars['String']['input'];
  businessAdminJobTitle: Scalars['String']['input'];
  businessAdminLastName: Scalars['String']['input'];
  businessAdminPhone: Scalars['String']['input'];
  businessAdminSsn: Scalars['String']['input'];
  businessType: VendorBusinessType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type SubmitBusinessInformationPayload = {
  __typename: 'SubmitBusinessInformationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SubmitOffResqVendorInvoiceMutationInput = {
  cacheKey?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<InboundVendorInvoiceSource>;
  effectiveOffer?: InputMaybe<Scalars['String']['input']>;
  effectiveOfferType?: InputMaybe<Scalars['String']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  integrationType?: InputMaybe<OAuthIntegrationType>;
  invoiceFile: Scalars['String']['input'];
  invoiceTotal?: InputMaybe<Scalars['Decimal']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  selectedShareTierId?: InputMaybe<Scalars['Int']['input']>;
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmitOffResqVendorInvoiceMutationPayload = {
  __typename: 'SubmitOffResqVendorInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  inboundVendorInvoice: Maybe<InboundVendorInvoiceNode>;
  ok: Scalars['Boolean']['output'];
};

export type SubmitQuoteFeedbackArguments = {
  comment: Scalars['String']['input'];
  feedbackType: QuoteFeedbackType;
  quoteId: Scalars['ID']['input'];
};

export type SubmitQuoteFeedbackMutation = {
  __typename: 'SubmitQuoteFeedbackMutation';
  ok: Scalars['Boolean']['output'];
  quote: QuoteNode;
};

export type SubmitRecordOfWorkInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recordOfWorkId: Scalars['ID']['input'];
};

export type SubmitRecordOfWorkPayload = {
  __typename: 'SubmitRecordOfWorkPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SubmitVendorInvoiceMutation = {
  __typename: 'SubmitVendorInvoiceMutation';
  workOrder: WorkOrderNode;
};

export type SubmitVendorInvoiceMutationArguments = {
  applyProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  dispute: Scalars['Boolean']['input'];
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  selectedShareTierId?: InputMaybe<Scalars['Int']['input']>;
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  vendorNotes: Scalars['String']['input'];
  vendorPayoutOverrideDate?: InputMaybe<Scalars['Date']['input']>;
  vendorPayoutOverrideReason?: InputMaybe<Scalars['String']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type SubmitVendorWebsiteBuilderSurveyMutationInput = {
  afterHoursPhone?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hasDifferentAfterHoursNumber: Scalars['Boolean']['input'];
  hasWebsite: Scalars['Boolean']['input'];
  providesTwentyFourSevenService: Scalars['Boolean']['input'];
  usesAfterHoursService: Scalars['Boolean']['input'];
  vendorId: Scalars['ID']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitVendorWebsiteBuilderSurveyMutationPayload = {
  __typename: 'SubmitVendorWebsiteBuilderSurveyMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type SubmitWorkOrderForApproval = {
  __typename: 'SubmitWorkOrderForApproval';
  ok: Scalars['Boolean']['output'];
};

export type SubmitWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cyovData?: InputMaybe<CyovDataInput>;
  dispatchNote?: InputMaybe<Scalars['String']['input']>;
  internalAppointmentDate?: InputMaybe<Scalars['Date']['input']>;
  isCustomDispatchNote?: InputMaybe<Scalars['Boolean']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  taskListAttachedFiles?: InputMaybe<Array<AttachmentInput>>;
  taskListAttachedUrls?: InputMaybe<Array<AttachedUrlInput>>;
  taskListItems?: InputMaybe<Array<Scalars['String']['input']>>;
  teamMemberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  useEquipmentRanking?: InputMaybe<Scalars['Boolean']['input']>;
  useVendorRanking?: InputMaybe<Scalars['Boolean']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type SubmitWorkOrderPayload = {
  __typename: 'SubmitWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type SubscribeToWorkOrderNotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userToSubscribeId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type SubscribeToWorkOrderNotesPayload = {
  __typename: 'SubscribeToWorkOrderNotesPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type SubscriptionAddon = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  startDate: Scalars['Date']['input'];
  type: AddonType;
  unitAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SubscriptionAddonNode = Node & {
  __typename: 'SubscriptionAddonNode';
  endDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  percentage: Maybe<Scalars['Decimal']['output']>;
  startDate: Scalars['Date']['output'];
  subscription: SubscriptionNode;
  type: AddonType;
  unitAmount: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum SubscriptionCancelReason {
  /** Deleted Facility */
  DeletedFacility = 'DELETED_FACILITY',
  /** Facility App */
  FacilityShutDown = 'FACILITY_SHUT_DOWN',
  /** Group no longer on ResQ */
  GroupNoLongerOnResq = 'GROUP_NO_LONGER_ON_RESQ',
  /** Migrate deactivated facility */
  MigrateDeactivatedFacility = 'MIGRATE_DEACTIVATED_FACILITY',
  /** Migrating to UBP */
  MigratingToUbp = 'MIGRATING_TO_UBP',
  /** ResQ terminated relationship */
  ResqTerminatedRelationship = 'RESQ_TERMINATED_RELATIONSHIP'
}

export type SubscriptionInput = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  facilities: Array<FacilitySubscriptionInput>;
  memberUserIds: Array<Scalars['ID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  taggingFee?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice: Scalars['Decimal']['input'];
};

export type SubscriptionInvoicePreview = {
  __typename: 'SubscriptionInvoicePreview';
  billingDate: Scalars['Date']['output'];
  currency: Currency;
  lineItems: Array<SubscriptionInvoicePreviewLineItem>;
  subtotal: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
  taxes: Array<SubscriptionInvoicePreviewTax>;
  total: Scalars['Decimal']['output'];
};

export type SubscriptionInvoicePreviewLineItem = {
  __typename: 'SubscriptionInvoicePreviewLineItem';
  amount: Scalars['Decimal']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type SubscriptionInvoicePreviewTax = {
  __typename: 'SubscriptionInvoicePreviewTax';
  name: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type SubscriptionNode = Node & {
  __typename: 'SubscriptionNode';
  addons: Array<SubscriptionAddonNode>;
  billingFrequency: Maybe<BillingFrequency>;
  billingPeriod: Maybe<BillingPeriodNode>;
  cancelReason: Maybe<SubscriptionCancelReason>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  cancelledOn: Maybe<Scalars['Date']['output']>;
  dataHashKey: Scalars['String']['output'];
  effectiveStartDate: Maybe<Scalars['Date']['output']>;
  facility: FacilityNode;
  /** The GL code associated with this subscription for accounting purposes */
  glCode: Maybe<Scalars['String']['output']>;
  hasUnpaidInvoices: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isTaxExempt: Scalars['Boolean']['output'];
  /** The last time we billed the customer. The existence of this field means the customer has paid for the time between the last_billing_date to (next_billing_date - 1 day) */
  lastBillingDate: Maybe<Scalars['Date']['output']>;
  /** The next time we expect to bill the customer */
  nextBillingDate: Maybe<Scalars['Date']['output']>;
  paymentMethod: Maybe<PaymentMethodNode>;
  startedOn: Maybe<Scalars['Date']['output']>;
  state: SubscriptionState;
  unitAmount: Maybe<Scalars['Decimal']['output']>;
  unpaidSubscriptionInvoices: Array<ClientInvoiceNode>;
  upcomingSubscriptionInvoicePreview: Maybe<SubscriptionInvoicePreview>;
  updateOperation: SubscriptionOperation;
  updatedBy: UserNode;
};

export type SubscriptionNodeConnection = {
  __typename: 'SubscriptionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubscriptionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SubscriptionNode` and its cursor. */
export type SubscriptionNodeEdge = {
  __typename: 'SubscriptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<SubscriptionNode>;
};

/** An enumeration. */
export enum SubscriptionOperation {
  Bill = 'BILL',
  Cancel = 'CANCEL',
  Creation = 'CREATION',
  GenerateProratedInvoice = 'GENERATE_PRORATED_INVOICE',
  GenerateProratedInvoicePreview = 'GENERATE_PRORATED_INVOICE_PREVIEW',
  Migration = 'MIGRATION',
  Pause = 'PAUSE',
  Reinitialize = 'REINITIALIZE',
  Start = 'START',
  Update = 'UPDATE',
  UpdateAddons = 'UPDATE_ADDONS'
}

/** An enumeration. */
export enum SubscriptionState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Initial = 'INITIAL',
  Paused = 'PAUSED'
}

export type SuggestedMarkup = {
  __typename: 'SuggestedMarkup';
  markup: Scalars['Decimal']['output'];
  source: Scalars['String']['output'];
};

export type SuggestionInput = {
  canPerformInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformRepairs?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentCategoryId: Scalars['ID']['input'];
  manufacturerId: Scalars['ID']['input'];
  supportsWarranty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuggestionRejectionInput = {
  equipmentCategoryId: Scalars['ID']['input'];
  manufacturerId: Scalars['ID']['input'];
  /** Original confidence score of the suggestion being rejected */
  originalConfidenceScore?: InputMaybe<Scalars['Float']['input']>;
  /** Original work order count for the suggestion */
  originalHistoricalWorkOrdersCount?: InputMaybe<Scalars['Int']['input']>;
  /** Original source of the suggestion (e.g., 'historical_work_orders', 'service_categories') */
  originalSource?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum TaggingMethod {
  ResqTagging = 'RESQ_TAGGING',
  TagAsYouGo = 'TAG_AS_YOU_GO',
  Unknown = 'UNKNOWN'
}

export type TargetVendorEntitlementsType = {
  __typename: 'TargetVendorEntitlementsType';
  entitlements: Array<Scalars['String']['output']>;
  vendorTrackingId: Scalars['Int']['output'];
};

/** Tax breakdown by rate. */
export type TaxBreakdownOutput = {
  __typename: 'TaxBreakdownOutput';
  taxRateName: Scalars['String']['output'];
  taxRatePercentage: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type TaxRateInput = {
  rate: Scalars['Decimal']['input'];
  taxRateId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum TaxRateName {
  /** Gst */
  Gst = 'GST',
  /** Hst */
  Hst = 'HST',
  /** Pst */
  Pst = 'PST',
  /** Qst */
  Qst = 'QST',
  /** Sales Tax */
  SalesTax = 'SALES_TAX'
}

export type TaxRateNode = Node & {
  __typename: 'TaxRateNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: TaxRateName;
  permissions: TaxRatePermissions;
  rate: Scalars['Decimal']['output'];
  validFrom: Maybe<Scalars['DateTime']['output']>;
  validTo: Maybe<Scalars['DateTime']['output']>;
};

export type TaxRateNodeConnection = {
  __typename: 'TaxRateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaxRateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TaxRateNode` and its cursor. */
export type TaxRateNodeEdge = {
  __typename: 'TaxRateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<TaxRateNode>;
};

export type TaxRatePermissions = {
  __typename: 'TaxRatePermissions';
  update: Scalars['Boolean']['output'];
};

export type TaxonomyNodeNode = Node & {
  __typename: 'TaxonomyNodeNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<TaxonomyNodeNode>;
  path: Array<TaxonomyNodeNode>;
  symptoms: Array<TaxonomySymptomNode>;
};

export type TaxonomySymptomNode = Node & {
  __typename: 'TaxonomySymptomNode';
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type TechnicianPerformance = {
  __typename: 'TechnicianPerformance';
  completedMaintenanceJobCount: Scalars['Int']['output'];
  completedOnDemandJobCount: Scalars['Int']['output'];
  disputeCount: Scalars['Int']['output'];
  revenue: Scalars['Decimal']['output'];
  technician: UserNode;
};

export type TerminateUserSessionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type TerminateUserSessionMutationPayload = {
  __typename: 'TerminateUserSessionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  session: UserSessionNode;
};

/** An enumeration. */
export enum TimeSlotType {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING',
  Night = 'NIGHT'
}

export type TopReviewFeedback = {
  __typename: 'TopReviewFeedback';
  count: Scalars['Int']['output'];
  feedback: WorkOrderReviewFeedbackNode;
};

export type TopSpendFacilities = {
  __typename: 'TopSpendFacilities';
  externalSpendAmount: Maybe<Scalars['Decimal']['output']>;
  facilityName: Scalars['String']['output'];
  internalSpendAmount: Maybe<Scalars['Decimal']['output']>;
  percentDifference: Scalars['Decimal']['output'];
  spendAmount: Scalars['Decimal']['output'];
};

export type TopSpendWorkOrders = {
  __typename: 'TopSpendWorkOrders';
  spendAmount: Scalars['Decimal']['output'];
  workOrder: WorkOrderNode;
};

export type TopVendorReviewFeedback = {
  __typename: 'TopVendorReviewFeedback';
  count: Scalars['Int']['output'];
  feedback: Scalars['String']['output'];
};

export type TradeNode = Node & {
  __typename: 'TradeNode';
  category: CategoryNode;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TradeNodeConnection = {
  __typename: 'TradeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TradeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TradeNode` and its cursor. */
export type TradeNodeEdge = {
  __typename: 'TradeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<TradeNode>;
};

export type TradesCustomerInvoiceLineItemInput = {
  description: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  unitPrice: Scalars['Decimal']['input'];
};

export type TradesCustomerInvoiceLineItemOutput = {
  __typename: 'TradesCustomerInvoiceLineItemOutput';
  description: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  taxableAmount: Maybe<Scalars['Decimal']['output']>;
  total: Scalars['Decimal']['output'];
  totalTax: Maybe<Scalars['Decimal']['output']>;
  unitPrice: Scalars['Decimal']['output'];
};

export type TradesCustomerInvoiceOutput = {
  __typename: 'TradesCustomerInvoiceOutput';
  businessUnitId: Scalars['Int']['output'];
  clientInvoiceId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  dueDate: Scalars['Date']['output'];
  invoiceCode: Scalars['String']['output'];
  invoiceSetId: Scalars['Int']['output'];
  issueDate: Scalars['Date']['output'];
  subtotalAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  vendorId: Scalars['Int']['output'];
};

/** An enumeration. */
export enum TradesCustomerInvoicePayoutCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

export type TradesCustomerInvoicePayoutNode = Node & {
  __typename: 'TradesCustomerInvoicePayoutNode';
  clientInvoice: Maybe<ClientInvoiceNode>;
  clientInvoiceId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: TradesCustomerInvoicePayoutCurrency;
  customer: Maybe<ClientOrganizationNode>;
  customerId: Scalars['Int']['output'];
  customerInvoicePdfUrl: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  dueAtDate: Scalars['Date']['output'];
  grossAmount: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceCode: Maybe<Scalars['String']['output']>;
  invoiceProcessingFeeAmount: Scalars['Decimal']['output'];
  invoiceProcessingFeeRate: Scalars['Decimal']['output'];
  invoiceSet: Maybe<InvoiceSetNode>;
  invoiceSetId: Scalars['Int']['output'];
  issuedAtDate: Scalars['Date']['output'];
  lastModifiedAt: Scalars['DateTime']['output'];
  payoutAmount: Scalars['Decimal']['output'];
  status: TradesCustomerInvoicePayoutStatus;
  vendor: Maybe<VendorOrganizationNode>;
  vendorId: Scalars['Int']['output'];
};

export type TradesCustomerInvoicePayoutNodeConnection = {
  __typename: 'TradesCustomerInvoicePayoutNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TradesCustomerInvoicePayoutNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TradesCustomerInvoicePayoutNode` and its cursor. */
export type TradesCustomerInvoicePayoutNodeEdge = {
  __typename: 'TradesCustomerInvoicePayoutNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<TradesCustomerInvoicePayoutNode>;
};

export enum TradesCustomerInvoicePayoutStatus {
  AwaitingPayout = 'AWAITING_PAYOUT',
  Paid = 'PAID',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  PayoutFailed = 'PAYOUT_FAILED',
  PendingCustomerPayment = 'PENDING_CUSTOMER_PAYMENT'
}

export type TradesCustomerInvoicePreviewOutput = {
  __typename: 'TradesCustomerInvoicePreviewOutput';
  currency: Scalars['String']['output'];
  lineItems: Array<TradesCustomerInvoiceLineItemOutput>;
  subtotal: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
  taxBreakdown: Array<TradesCustomerInvoiceTaxBreakdownOutput>;
  total: Scalars['Decimal']['output'];
};

export type TradesCustomerInvoiceTaxBreakdownOutput = {
  __typename: 'TradesCustomerInvoiceTaxBreakdownOutput';
  taxRateName: Scalars['String']['output'];
  taxRatePercentage: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum TradesSubscriptionActivationFailureReason {
  AlreadyTrialed = 'ALREADY_TRIALED',
  OfferNotAvailable = 'OFFER_NOT_AVAILABLE',
  SubscriptionAlreadyExists = 'SUBSCRIPTION_ALREADY_EXISTS',
  VerifiedPaymentMethodRequired = 'VERIFIED_PAYMENT_METHOD_REQUIRED'
}

/** An enumeration. */
export enum TradesSubscriptionActivationStatus {
  Activated = 'ACTIVATED',
  Failed = 'FAILED'
}

/** An enumeration. */
export enum TradesSubscriptionChangeTiming {
  AtRenewal = 'AT_RENEWAL',
  Immediate = 'IMMEDIATE'
}

/** An enumeration. */
export enum TradesSubscriptionMissingPrerequisite {
  VerifiedPaymentMethod = 'VERIFIED_PAYMENT_METHOD'
}

export type TradesSubscriptionOfferNode = Node & {
  __typename: 'TradesSubscriptionOfferNode';
  currency: Scalars['String']['output'];
  eligibleForTrial: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  rate: Scalars['Decimal']['output'];
  serviceName: ResqServiceName;
  tier: TradesSubscriptionOfferTier;
};

/** An enumeration. */
export enum TradesSubscriptionOfferTier {
  Basic = 'BASIC',
  Premium = 'PREMIUM'
}

/** An enumeration. */
export enum TradesSubscriptionPlanChangeFailureReason {
  AlreadyOnTargetPlan = 'ALREADY_ON_TARGET_PLAN',
  DowngradeAlreadyScheduled = 'DOWNGRADE_ALREADY_SCHEDULED',
  NoExistingSubscription = 'NO_EXISTING_SUBSCRIPTION',
  OfferNotAvailable = 'OFFER_NOT_AVAILABLE',
  VerifiedPaymentMethodRequired = 'VERIFIED_PAYMENT_METHOD_REQUIRED'
}

/** An enumeration. */
export enum TradesSubscriptionPlanChangeStatus {
  Changed = 'CHANGED',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED'
}

export type TradesSubscriptionPreviewType = {
  __typename: 'TradesSubscriptionPreviewType';
  billingCycle: Scalars['String']['output'];
  billingPeriodEndDate: Scalars['Date']['output'];
  billingPeriodStartDate: Scalars['Date']['output'];
  changeTiming: Maybe<TradesSubscriptionChangeTiming>;
  chargeTodayAmount: Maybe<Scalars['Decimal']['output']>;
  currency: Scalars['String']['output'];
  currentPlanAccessUntil: Maybe<Scalars['Date']['output']>;
  effectiveStartDate: Maybe<Scalars['Date']['output']>;
  eligibleForTrial: Scalars['Boolean']['output'];
  firstChargeAmount: Scalars['Decimal']['output'];
  missingPrerequisites: Array<TradesSubscriptionMissingPrerequisite>;
  nextChargeDate: Scalars['Date']['output'];
  recurringChargeAmount: Scalars['Decimal']['output'];
  serviceName: ResqServiceName;
  tier: Scalars['String']['output'];
  trialPeriodEndDate: Maybe<Scalars['Date']['output']>;
  trialPeriodStartDate: Maybe<Scalars['Date']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export enum TradesTrialConversionFailureReason {
  AlreadyConverted = 'ALREADY_CONVERTED',
  NoTrialSubscription = 'NO_TRIAL_SUBSCRIPTION',
  OfferNotAvailable = 'OFFER_NOT_AVAILABLE',
  VerifiedPaymentMethodRequired = 'VERIFIED_PAYMENT_METHOD_REQUIRED'
}

/** An enumeration. */
export enum TradesTrialConversionStatus {
  Converted = 'CONVERTED',
  Failed = 'FAILED'
}

export type TriggerSampleNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationInputs: Scalars['JSONString']['input'];
  notificationName: Scalars['String']['input'];
  targetEmail: Scalars['String']['input'];
};

export type TriggerSampleNotificationPayload = {
  __typename: 'TriggerSampleNotificationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type TroubleshootingActionNode = Node & {
  __typename: 'TroubleshootingActionNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  troubleshootingStep: TroubleshootingStepNode;
};

export type TroubleshootingPlanNode = Node & {
  __typename: 'TroubleshootingPlanNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  troubleshootingSteps: Array<Maybe<TroubleshootingStepNode>>;
};

export type TroubleshootingSessionNode = Node & {
  __typename: 'TroubleshootingSessionNode';
  actions: Array<TroubleshootingActionNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum TroubleshootingSessionOutcome {
  Incomplete = 'INCOMPLETE',
  ResolvedIssue = 'RESOLVED_ISSUE',
  WorkOrderCreated = 'WORK_ORDER_CREATED'
}

export type TroubleshootingStepNode = Node & {
  __typename: 'TroubleshootingStepNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  /** A description of a single troubleshooting step. */
  stepDescription: Scalars['String']['output'];
  /** A support link relating to the troubleshooting step. */
  supportLink: Scalars['String']['output'];
};

export type UnapproveRecordOfWorkMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recordOfWorkId: Scalars['ID']['input'];
};

/** Unapproves a record of work for invoicing. */
export type UnapproveRecordOfWorkMutationPayload = {
  __typename: 'UnapproveRecordOfWorkMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  recordOfWork: RecordOfWorkNode;
};

export type UnarchiveReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportTemplateId: Scalars['ID']['input'];
};

export type UnarchiveReportTemplatePayload = {
  __typename: 'UnarchiveReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  reportTemplate: ReportTemplateNode;
};

export type UnassignWorkOrderFromVendorCompanyMutation = {
  __typename: 'UnassignWorkOrderFromVendorCompanyMutation';
  ok: Scalars['Boolean']['output'];
};

export type UnblockApMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
};

export type UnblockApMutationPayload = {
  __typename: 'UnblockAPMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UnblockVendorMutation = {
  __typename: 'UnblockVendorMutation';
  ok: Scalars['Boolean']['output'];
};

export type UncancelWorkOrderArguments = {
  workOrderId: Scalars['ID']['input'];
};

export type UncancelWorkOrderMutation = {
  __typename: 'UncancelWorkOrderMutation';
  workOrder: WorkOrderNode;
};

export type UninvoicedByPeriod = {
  __typename: 'UninvoicedByPeriod';
  count: Scalars['Int']['output'];
  period: MetricsPeriod;
};

/** Unit of measure options for price book items. */
export enum UnitOfMeasureEnum {
  Each = 'EACH',
  Flat = 'FLAT',
  Gallon = 'GALLON',
  Hour = 'HOUR',
  LinearFt = 'LINEAR_FT',
  Pound = 'POUND',
  SqFt = 'SQ_FT',
  Ton = 'TON'
}

export type UnscheduledExternalItem = {
  __typename: 'UnscheduledExternalItem';
  date: Scalars['Date']['output'];
  workOrder: WorkOrderNode;
};

export type UnscheduledInternalItem = {
  __typename: 'UnscheduledInternalItem';
  date: Scalars['Date']['output'];
  internalRequest: InternalRequestNode;
};

export type UnsubscribeFromWorkOrderNotesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userToUnsubscribeId: Scalars['ID']['input'];
  workOrderId: Scalars['ID']['input'];
};

export type UnsubscribeFromWorkOrderNotesPayload = {
  __typename: 'UnsubscribeFromWorkOrderNotesPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type UpcomingExternalItem = {
  __typename: 'UpcomingExternalItem';
  date: Scalars['Date']['output'];
  maintenancePlan: MaintenancePlanNode;
};

export type UpcomingInternalItem = {
  __typename: 'UpcomingInternalItem';
  date: Scalars['Date']['output'];
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type UpdateApBatchMutationInput = {
  batchId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
  vendorInvoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateApBatchMutationPayload = {
  __typename: 'UpdateApBatchMutationPayload';
  batch: ApBatchNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type UpdateBankAccountRecordNotesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the bank account record to update */
  id: Scalars['ID']['input'];
  /** The new notes to save for the bank account record */
  notes: Scalars['String']['input'];
};

export type UpdateBankAccountRecordNotesMutationPayload = {
  __typename: 'UpdateBankAccountRecordNotesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBatchPaymentMutationInput = {
  batchPaymentId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceDate: Scalars['Date']['input'];
};

export type UpdateBatchPaymentMutationPayload = {
  __typename: 'UpdateBatchPaymentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateBrandMutationInput = {
  brandId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Image>;
  name: Scalars['String']['input'];
};

export type UpdateBrandMutationPayload = {
  __typename: 'UpdateBrandMutationPayload';
  brand: BrandNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateBudgetMutationInput = {
  budgetId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  facilityGroupAllotments?: InputMaybe<Array<InputMaybe<FacilityGroupAllotmentInput>>>;
  isCapex?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  isOpex?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startDate: Scalars['Date']['input'];
  total: Scalars['Decimal']['input'];
};

export type UpdateBudgetMutationPayload = {
  __typename: 'UpdateBudgetMutationPayload';
  budget: Maybe<BudgetNode>;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type UpdateBusinessUnitArguments = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessRegistrationNumberType?: InputMaybe<BusinessRegistrationNumberType>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  businessUnitId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  groupingMode?: InputMaybe<BusinessUnitGroupingMode>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  taggingFee?: InputMaybe<Scalars['Decimal']['input']>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessUnitMutation = {
  __typename: 'UpdateBusinessUnitMutation';
  businessUnit: BusinessUnitNode;
  ok: Scalars['Boolean']['output'];
};

export type UpdateBusinessUnitSubscriptionPaymentMethodMutationInput = {
  businessUnitId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Payment method ID (Relay global ID). Pass null to remove payment method. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateBusinessUnitSubscriptionPaymentMethodMutationPayload = {
  __typename: 'UpdateBusinessUnitSubscriptionPaymentMethodMutationPayload';
  businessUnit: BusinessUnitNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentMethod: Maybe<PaymentMethodNode>;
};

export type UpdateClientManagedInvoiceInput = {
  amount: Scalars['Decimal']['input'];
  clientManagedInvoiceId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientManagedInvoicePayload = {
  __typename: 'UpdateClientManagedInvoicePayload';
  clientManagedInvoice: ClientManagedInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type UpdateClientMatchingProfileInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceCategoriesExcluded: Array<ServiceCategory>;
};

export type UpdateClientMatchingProfilePayload = {
  __typename: 'UpdateClientMatchingProfilePayload';
  clientMatchingProfile: ClientMatchingProfileNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type UpdateClientOrgSensitivityMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sensitivity?: InputMaybe<Sensitivity>;
};

export type UpdateClientOrgSensitivityMutationPayload = {
  __typename: 'UpdateClientOrgSensitivityMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateClientOrganizationStatusMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientStatus?: InputMaybe<ClientOrganizationStatus>;
  organizationId: Scalars['ID']['input'];
};

export type UpdateClientOrganizationStatusMutationPayload = {
  __typename: 'UpdateClientOrganizationStatusMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateClientReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  frequency: ClientReportFrequency;
  organizationId: Scalars['ID']['input'];
  recipientEmailAddresses: Array<Scalars['String']['input']>;
  reportType: ClientReportType;
};

export type UpdateClientReportScheduleMutationPayload = {
  __typename: 'UpdateClientReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  schedule: ClientReportScheduleNode;
};

export type UpdateClientVendorRelationshipPaymentTermsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientPaymentTerms?: InputMaybe<Scalars['Int']['input']>;
  clientVendorRelationshipId: Scalars['ID']['input'];
};

export type UpdateClientVendorRelationshipPaymentTermsPayload = {
  __typename: 'UpdateClientVendorRelationshipPaymentTermsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientVendorRelationship: ClientVendorRelationshipNode;
};

export type UpdateContactInquiryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactInquiryId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInquiryMutationPayload = {
  __typename: 'UpdateContactInquiryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  contactInquiry: ContactInquiryNode;
};

export type UpdateDeviceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configs: Array<DeviceConfigRequestInput>;
  equipmentId: Scalars['ID']['input'];
};

export type UpdateDeviceConfigsPayload = {
  __typename: 'UpdateDeviceConfigsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateDeviceMutation = {
  __typename: 'UpdateDeviceMutation';
  ok: Scalars['Boolean']['output'];
};

export type UpdateDispatchMethodPreferenceInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultDispatchMethod: DispatchMethod;
};

export type UpdateDispatchMethodPreferencePayload = {
  __typename: 'UpdateDispatchMethodPreferencePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  clientPaymentPreference: ClientPaymentPreferenceNode;
};

export type UpdateExternalBankAccountMutation = {
  __typename: 'UpdateExternalBankAccountMutation';
  externalBankAccount: ExternalBankAccountNode;
};

export type UpdateExternalExpenseMutationInput = {
  allocatedAmount: Scalars['Decimal']['input'];
  attachmentFileType?: InputMaybe<Scalars['String']['input']>;
  attachmentLabel?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  spendItemId: Scalars['ID']['input'];
  uploadedFileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalExpenseMutationPayload = {
  __typename: 'UpdateExternalExpenseMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  externalExpense: SpendItemAllocationNode;
};

export type UpdateFacilityAllowedServiceCategoriesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  serviceCategories: Array<Scalars['String']['input']>;
};

export type UpdateFacilityAllowedServiceCategoriesMutationPayload = {
  __typename: 'UpdateFacilityAllowedServiceCategoriesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facility: FacilityNode;
};

export type UpdateFacilityArguments = {
  accessInfo?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  businessLegalName?: InputMaybe<Scalars['String']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  busyHours?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  daysOpened?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['ID']['input'];
  goliveOn?: InputMaybe<Scalars['Date']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notReadyForOnboardingReason?: InputMaybe<NotReadyForOnboardingReasonChoice>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardingStatus?: InputMaybe<OnboardingStatus>;
  onsiteHours?: InputMaybe<Scalars['String']['input']>;
  openedOn?: InputMaybe<Scalars['Date']['input']>;
  parentGroupId?: InputMaybe<Scalars['ID']['input']>;
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>;
  paymentContactName?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Image>;
  plannedGoLiveOn?: InputMaybe<Scalars['Date']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  qrSubmissionAuthenticationMode?: InputMaybe<QrSubmissionAuthenticationMode>;
  status?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  taggingMethod?: InputMaybe<TaggingMethod>;
  transactionFee?: InputMaybe<Scalars['Float']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFacilityGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['ID']['input'];
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  qrSubmissionAuthenticationMode?: InputMaybe<QrSubmissionAuthenticationMode>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateFacilityGroupOpsOwnerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['ID']['input'];
  opsOwnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFacilityGroupOpsOwnerPayload = {
  __typename: 'UpdateFacilityGroupOpsOwnerPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facilityGroup: FacilityGroupNode;
};

export type UpdateFacilityGroupPayload = {
  __typename: 'UpdateFacilityGroupPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  facilityGroup: FacilityGroupNode;
};

export type UpdateFacilityMutation = {
  __typename: 'UpdateFacilityMutation';
  facility: FacilityNode;
  ok: Scalars['Boolean']['output'];
};

export type UpdateFacilitySubscriptionInput = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  goliveOn?: InputMaybe<Scalars['Date']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFavouriteVendorInviteSubscriptionMutationInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type UpdateFavouriteVendorInviteSubscriptionMutationPayload = {
  __typename: 'UpdateFavouriteVendorInviteSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateGlCodesInput = {
  code: Scalars['String']['input'];
  expenseType?: InputMaybe<ExpenseType>;
  serviceCategory: ServiceCategory;
};

export type UpdateGlCodesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  glCodes: Array<UpdateGlCodesInput>;
};

export type UpdateGlCodesMutationPayload = {
  __typename: 'UpdateGLCodesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  glCodes: Array<GlCodeNode>;
};

export type UpdateGoogleAdsCampaignLocationTargetsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  googleAdsCampaignId: Scalars['ID']['input'];
  locationTargets: Array<Scalars['GenericScalar']['input']>;
  vendorWebsiteId: Scalars['ID']['input'];
};

export type UpdateGoogleAdsCampaignLocationTargetsMutationPayload = {
  __typename: 'UpdateGoogleAdsCampaignLocationTargetsMutationPayload';
  addedLocationResourceNames: Array<Scalars['String']['output']>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  locationTargets: Array<GoogleAdsCampaignInputSnapshotLocationTargetType>;
  ok: Scalars['Boolean']['output'];
  removedLocationResourceNames: Array<Scalars['String']['output']>;
};

export type UpdateInboundInvoiceExtractionInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inboundInvoiceExtractionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateInboundInvoiceExtractionPayload = {
  __typename: 'UpdateInboundInvoiceExtractionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateInternalRequestStatusInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internalRequestId: Scalars['ID']['input'];
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldComments?: InputMaybe<Scalars['String']['input']>;
  onHoldReason?: InputMaybe<InternalRequestHoldReason>;
  transitionTo?: InputMaybe<WorkOrderStatus>;
};

/** This mutation only handles transitioning to CLIENT_IN_PROGRESS and on hold. */
export type UpdateInternalRequestStatusPayload = {
  __typename: 'UpdateInternalRequestStatusPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  workOrder: Maybe<WorkOrderNode>;
};

export type UpdateInternalRequestTeamMemberAssignmentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamMemberIds: Array<Scalars['ID']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type UpdateInternalRequestTeamMemberAssignmentsPayload = {
  __typename: 'UpdateInternalRequestTeamMemberAssignmentsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  internalRequest: InternalRequestNode;
};

export type UpdateInvoiceApprovalSettingsInput = {
  approvalRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstApprovalRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  secondApprovalRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  strategy: InvoiceApprovalStrategy;
};

export type UpdateInvoiceApprovalSettingsPayload = {
  __typename: 'UpdateInvoiceApprovalSettingsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  invoiceApprovalSettings: InvoiceApprovalSettings;
};

export type UpdateMaintenancePlanAutoRenewMutation = {
  __typename: 'UpdateMaintenancePlanAutoRenewMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean']['output'];
};

export type UpdateMaintenancePlanMutation = {
  __typename: 'UpdateMaintenancePlanMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean']['output'];
};

export type UpdateMaintenancePlanNextWorkOrderCreationDateMutation = {
  __typename: 'UpdateMaintenancePlanNextWorkOrderCreationDateMutation';
  maintenancePlan: MaintenancePlanNode;
  ok: Scalars['Boolean']['output'];
};

export type UpdateMarketInput = {
  acceptingNewTrades?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disabledCategories?: InputMaybe<Array<ServiceCategory>>;
  marketId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  operatingAreaIds: Array<Scalars['ID']['input']>;
  pricing: MarketPricingInput;
};

export type UpdateMarketPayload = {
  __typename: 'UpdateMarketPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  market: MarketNode;
};

export type UpdateOffResqCustomerMutationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  billingContacts?: InputMaybe<Array<BillingContactMutationInput>>;
  businessDateOfIncorporation?: InputMaybe<Scalars['Date']['input']>;
  businessLegalStructure?: InputMaybe<BusinessLegalStructure>;
  businessTaxNumber?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOffResqCustomerMutationPayload = {
  __typename: 'UpdateOffResqCustomerMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqCustomer: OffResqCustomerNode;
};

export type UpdateOffResqCustomerUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offResqCustomerId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

export type UpdateOffResqCustomerUserMutationPayload = {
  __typename: 'UpdateOffResqCustomerUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type UpdateOffResqFacilityMutationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offResqFacilityId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preResqPaymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOffResqFacilityMutationPayload = {
  __typename: 'UpdateOffResqFacilityMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqFacility: OffResqFacilityNode;
};

export type UpdateOffResqFacilityUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offResqFacilityId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

export type UpdateOffResqFacilityUserMutationPayload = {
  __typename: 'UpdateOffResqFacilityUserMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type UpdateOffResqWorkOrderMutationInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  appointmentEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  offResqWorkOrderId: Scalars['ID']['input'];
  onHoldReason?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  serviceCategory?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  techNotes?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOffResqWorkOrderMutationPayload = {
  __typename: 'UpdateOffResqWorkOrderMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
};

export type UpdateOrgSubscriptionInput = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  facilities: Array<UpdateFacilitySubscriptionInput>;
  memberUserIds: Array<Scalars['ID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  skipProrations: Scalars['Boolean']['input'];
  taggingFee?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice: Scalars['Decimal']['input'];
};

export type UpdateOrganizationSubscriptionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  subscriptions: Array<UpdateOrgSubscriptionInput>;
};

export type UpdateOrganizationSubscriptionMutationPayload = {
  __typename: 'UpdateOrganizationSubscriptionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdatePaymentMethodDefaultMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type UpdatePaymentMethodDefaultMutationPayload = {
  __typename: 'UpdatePaymentMethodDefaultMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  paymentMethod: PaymentMethodNode;
};

export type UpdatePerUserCountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New user count (minimum 0) */
  newUserCount: Scalars['Int']['input'];
  /** Per-user subscription ID (Relay global ID) */
  perUserSubscriptionId: Scalars['ID']['input'];
};

export type UpdatePerUserCountPayload = {
  __typename: 'UpdatePerUserCountPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  newUserCount: Scalars['Int']['output'];
  oldUserCount: Scalars['Int']['output'];
  perUserSubscription: Maybe<PerUserSubscriptionNode>;
  warnings: Array<Scalars['String']['output']>;
};

export type UpdatePerUserSubscriptionGlCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** GL code for this subscription */
  glCode?: InputMaybe<Scalars['String']['input']>;
  /** Per-user subscription ID (Relay global ID) */
  perUserSubscriptionId: Scalars['ID']['input'];
};

export type UpdatePerUserSubscriptionGlCodePayload = {
  __typename: 'UpdatePerUserSubscriptionGlCodePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  perUserSubscription: Maybe<PerUserSubscriptionNode>;
};

export type UpdatePreventativeMaintenanceTaskListItemsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deletedTaskListAdditionalUrls?: InputMaybe<Array<Scalars['ID']['input']>>;
  deletedTaskListAttachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  newTaskListAdditionalUrls?: InputMaybe<Array<AttachedUrlInput>>;
  newTaskListAttachments?: InputMaybe<Array<AttachmentInput>>;
  preventativeMaintenanceId: Scalars['ID']['input'];
  taskListItems: Array<Scalars['String']['input']>;
};

export type UpdatePreventativeMaintenanceTaskListItemsPayload = {
  __typename: 'UpdatePreventativeMaintenanceTaskListItemsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  preventativeMaintenance: PreventativeMaintenanceNode;
};

export type UpdatePriceBookCategoryMutationInput = {
  categoryId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePriceBookCategoryMutationPayload = {
  __typename: 'UpdatePriceBookCategoryMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  priceBookCategory: Maybe<PriceBookCategoryNode>;
};

export type UpdatePriceBookItemMutationInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  defaultRate?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['ID']['input'];
  itemType?: InputMaybe<PriceBookLineItemTypeEnum>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasureEnum>;
};

export type UpdatePriceBookItemMutationPayload = {
  __typename: 'UpdatePriceBookItemMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  priceBookItem: Maybe<PriceBookItemNode>;
};

export type UpdatePriceRateOverrideInput = {
  labourRate?: InputMaybe<Scalars['Decimal']['input']>;
  overtimeMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCallRate?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCategory: ServiceCategory;
  travelRate?: InputMaybe<Scalars['Decimal']['input']>;
  truckRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdatePriceRateOverridesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['ID']['input'];
  priceRateOverrides: Array<UpdatePriceRateOverrideInput>;
  vendorId: Scalars['ID']['input'];
};

export type UpdatePriceRateOverridesMutationPayload = {
  __typename: 'UpdatePriceRateOverridesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  priceRateOverrides: Array<PriceRateOverrideNode>;
};

export type UpdateProjectMutationInput = {
  assignedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  projectType?: InputMaybe<ProjectType>;
  status?: InputMaybe<ProjectStatus>;
  targetCompletionDate?: InputMaybe<Scalars['Date']['input']>;
  targetStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateProjectMutationPayload = {
  __typename: 'UpdateProjectMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  project: ProjectNode;
};

export type UpdateProtectionPlanEnrollmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coveragePeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  protectionPlanEnrollmentId: Scalars['ID']['input'];
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateProtectionPlanEnrollmentPayload = {
  __typename: 'UpdateProtectionPlanEnrollmentPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  protectionPlanEnrollment: ProtectionPlanEnrollmentNode;
};

export type UpdateQuoteAcceptanceSettingsInput = {
  approvalThresholds: Array<QuoteApprovalThresholdInput>;
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  selectionRoleIds: Array<Scalars['ID']['input']>;
};

export type UpdateQuoteAcceptanceSettingsPayload = {
  __typename: 'UpdateQuoteAcceptanceSettingsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quoteAcceptanceSettings: QuoteAcceptanceSettings;
};

export type UpdateQuoteApprovalThresholdsInput = {
  clientId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  thresholdData: Array<InputMaybe<QuoteApprovalThresholdInput>>;
};

export type UpdateQuoteApprovalThresholdsPayload = {
  __typename: 'UpdateQuoteApprovalThresholdsPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateReleaseMutationInput = {
  appName?: InputMaybe<AppName>;
  buildNumber?: InputMaybe<Scalars['Int']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  minimumOtaCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  platform?: InputMaybe<Platform>;
  upgradeType?: InputMaybe<UpgradeType>;
  versionName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update an existing mobile app release.
 *
 * Only accessible by staff users.
 */
export type UpdateReleaseMutationPayload = {
  __typename: 'UpdateReleaseMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  release: Maybe<ReleaseNode>;
};

export type UpdateReportTemplateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  day: ReportDay;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FilterInput>>;
  frequency?: InputMaybe<ReportFrequency>;
  interval: Scalars['Int']['input'];
  orderBy: Scalars['String']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  reportTemplateId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateReportTemplatePayload = {
  __typename: 'UpdateReportTemplatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  reportTemplate: ReportTemplateNode;
};

export type UpdateRevenueShareOverrideInput = {
  labourPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  otherPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  partsPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCallPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCategory: ServiceCategory;
  travelPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  truckPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateRevenueShareOverridesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultVendorRevenueShareOverrides?: InputMaybe<RevenueShareOverridePercentageInput>;
  facilityGroupId: Scalars['ID']['input'];
  revenueShareOverrides: Array<UpdateRevenueShareOverrideInput>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateRevenueShareOverridesMutationPayload = {
  __typename: 'UpdateRevenueShareOverridesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  defaultRevenueShareOverrides: Maybe<DefaultVendorRevenueShareOverrideNode>;
  revenueShareOverrides: Array<RevenueShareOverrideNode>;
};

export type UpdateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isWorkOrderObserver?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  roleId: Scalars['ID']['input'];
  workOrderObserverType?: InputMaybe<WorkOrderObserverType>;
};

export type UpdateRolePayload = {
  __typename: 'UpdateRolePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  role: RoleNode;
};

export type UpdateServiceCategoriesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateServiceCategoriesPayload = {
  __typename: 'UpdateServiceCategoriesPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: VendorOrganizationNode;
};

export type UpdateSpendApprovalPreferenceInput = {
  approvalRequiredOvertimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  approvalRequiredThreshold: Scalars['Decimal']['input'];
  serviceCategory?: InputMaybe<ServiceCategory>;
};

export type UpdateSpendApprovalPreferencesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  spendApprovalPreferences: Array<UpdateSpendApprovalPreferenceInput>;
};

export type UpdateSpendApprovalPreferencesPayload = {
  __typename: 'UpdateSpendApprovalPreferencesPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  spendApprovalPreferences: Array<SpendApprovalPreferenceNode>;
};

export type UpdateSubscriptionBusinessUnitInput = {
  /** Business unit ID (Relay global ID). Pass null to remove assignment. */
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organization subscription ID (Relay global ID) */
  subscriptionId: Scalars['ID']['input'];
};

export type UpdateSubscriptionBusinessUnitPayload = {
  __typename: 'UpdateSubscriptionBusinessUnitPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  subscription: Maybe<OrganizationSubscriptionNode>;
};

export type UpdateSubscriptionInput = {
  addons: Array<SubscriptionAddon>;
  billingFrequency?: InputMaybe<BillingFrequency>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['Boolean']['input']>;
  dataHashKey: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  glCode?: InputMaybe<Scalars['String']['input']>;
  isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  prorate?: InputMaybe<Scalars['Boolean']['input']>;
  unitAmount: Scalars['Decimal']['input'];
};

export type UpdateSubscriptionPayload = {
  __typename: 'UpdateSubscriptionPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  dataHashKey: Scalars['String']['output'];
  invoicePreviewUrl: Maybe<Scalars['String']['output']>;
  newAddons: Array<SubscriptionAddonNode>;
  newSubscription: SubscriptionNode;
  oldAddons: Array<SubscriptionAddonNode>;
  oldSubscription: SubscriptionNode;
};

export type UpdateSubscriptionPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Payment method ID (Relay global ID). Pass null to remove payment method. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization subscription ID (Relay global ID) */
  subscriptionId: Scalars['ID']['input'];
};

export type UpdateSubscriptionPaymentMethodPayload = {
  __typename: 'UpdateSubscriptionPaymentMethodPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  subscription: Maybe<OrganizationSubscriptionNode>;
};

export type UpdateTaxRatesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taxRates: Array<TaxRateInput>;
};

export type UpdateTaxRatesMutationPayload = {
  __typename: 'UpdateTaxRatesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  taxRates: Array<TaxRateNode>;
};

export type UpdateTroubleshootingActionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previousTroubleshootingActionId?: InputMaybe<Scalars['ID']['input']>;
  troubleshootingActionId: Scalars['ID']['input'];
  troubleshootingSessionId: Scalars['ID']['input'];
};

export type UpdateTroubleshootingActionMutationPayload = {
  __typename: 'UpdateTroubleshootingActionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateUserProfileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateUserProfileMutationPayload = {
  __typename: 'UpdateUserProfileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: UserNode;
};

export type UpdateUserStatusMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateUserStatusMutationPayload = {
  __typename: 'UpdateUserStatusMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  user: Maybe<UserNode>;
};

export type UpdateVendorAnticipatedStandardPayoutDaysMutationInput = {
  anticipatedStandardPayoutDays: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorAnticipatedStandardPayoutDaysMutationPayload = {
  __typename: 'UpdateVendorAnticipatedStandardPayoutDaysMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

export type UpdateVendorArguments = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  documents: Array<VendorDocumentInput>;
  email: Scalars['String']['input'];
  hasCrmFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  inheritedPaymentTerms?: InputMaybe<Scalars['Int']['input']>;
  isAutoApproveEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfServeSignup?: InputMaybe<Scalars['Boolean']['input']>;
  isTestData?: InputMaybe<Scalars['Boolean']['input']>;
  lastResort?: InputMaybe<Scalars['Boolean']['input']>;
  lendingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplacePaymentTerms?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  openToMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTerms: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  remittanceEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulesInApp?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  servicedOperatingAreaIds: Array<Scalars['ID']['input']>;
  skillIds: Array<Scalars['ID']['input']>;
  status: VendorStatus;
  successOwnerId?: InputMaybe<Scalars['ID']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
  tier?: InputMaybe<VendorTier>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorBusinessProfileMutationInput = {
  aboutUs?: InputMaybe<Scalars['String']['input']>;
  brandLogo?: InputMaybe<Image>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Image>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMetrics?: InputMaybe<Array<Metrics>>;
  selectedTestimonials?: InputMaybe<Array<SelectedTestimonialInput>>;
  showSiteUrl?: InputMaybe<Scalars['Boolean']['input']>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  trustedByImages?: InputMaybe<Array<InputMaybe<Image>>>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorBusinessProfileMutationPayload = {
  __typename: 'UpdateVendorBusinessProfileMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateVendorEquipmentCapabilityMutationInput = {
  canPerformInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  canPerformRepairs?: InputMaybe<Scalars['Boolean']['input']>;
  capabilityId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  supportsWarranty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVendorEquipmentCapabilityMutationPayload = {
  __typename: 'UpdateVendorEquipmentCapabilityMutationPayload';
  capabilityId: Maybe<Scalars['ID']['output']>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateVendorFacilityInsuranceDocumentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  insuranceCertificate?: InputMaybe<VendorFacilityInsuranceDocumentInput>;
  offResqFacilityId?: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorFacilityInsuranceDocumentMutationPayload = {
  __typename: 'UpdateVendorFacilityInsuranceDocumentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateVendorGeneralInfoMutationInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  afterHoursDispatchSetting?: InputMaybe<Scalars['Boolean']['input']>;
  afterHoursPhone?: InputMaybe<Scalars['String']['input']>;
  businessHours?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['ID']['input'];
  taxIdType?: InputMaybe<VendorTaxIdType>;
  taxRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorGeneralInfoMutationPayload = {
  __typename: 'UpdateVendorGeneralInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorInsuranceDocumentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  insuranceCertificate?: InputMaybe<VendorInsuranceDocumentInput>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorInsuranceDocumentMutationPayload = {
  __typename: 'UpdateVendorInsuranceDocumentMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateVendorMemberArguments = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorMemberMutation = {
  __typename: 'UpdateVendorMemberMutation';
  member: Maybe<VendorMemberNode>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateVendorMutation = {
  __typename: 'UpdateVendorMutation';
  ok: Scalars['Boolean']['output'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorOpenToMarketplaceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  openToMarketplace: Scalars['Boolean']['input'];
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorOpenToMarketplaceMutationPayload = {
  __typename: 'UpdateVendorOpenToMarketplaceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorPaymentInstructionsMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentInstructions?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorPaymentInstructionsMutationPayload = {
  __typename: 'UpdateVendorPaymentInstructionsMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

export type UpdateVendorPayoutInfoMutationInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<ExternalBankAccountType>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
  transitNumber?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
  voidCheck?: InputMaybe<VendorDocumentInput>;
};

export type UpdateVendorPayoutInfoMutationPayload = {
  __typename: 'UpdateVendorPayoutInfoMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateVendorPriceRateInput = {
  labourRate?: InputMaybe<Scalars['Decimal']['input']>;
  overtimeMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCallRate?: InputMaybe<Scalars['Decimal']['input']>;
  serviceCategory: ServiceCategory;
  travelRate?: InputMaybe<Scalars['Decimal']['input']>;
  truckRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateVendorPriceRatesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorPriceRates: Array<UpdateVendorPriceRateInput>;
};

export type UpdateVendorPriceRatesMutationPayload = {
  __typename: 'UpdateVendorPriceRatesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorPriceRates: Array<VendorPriceRateNode>;
};

export type UpdateVendorProfileDispatchMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingActionId?: InputMaybe<Scalars['ID']['input']>;
  servicedOperatingAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorProfileDispatchMutationPayload = {
  __typename: 'UpdateVendorProfileDispatchMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type UpdateVendorPromotionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deactivate?: InputMaybe<Scalars['Boolean']['input']>;
  promotionId: Scalars['ID']['input'];
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateVendorPromotionMutationPayload = {
  __typename: 'UpdateVendorPromotionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorPromotion: Maybe<VendorPromotionNode>;
};

export type UpdateVendorReceptionistGuidanceMutationInput = {
  answerGuidance?: InputMaybe<Array<VendorReceptionistAnswerGuidanceItemInput>>;
  businessSummary?: InputMaybe<Scalars['String']['input']>;
  callTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  diagnosisInstructions?: InputMaybe<Scalars['String']['input']>;
  emergencyIdentificationInstructions?: InputMaybe<Scalars['String']['input']>;
  pricingInstructions?: InputMaybe<Scalars['String']['input']>;
  receptionistEnabledType?: InputMaybe<ReceptionistEnabledType>;
  schedulingInstructions?: InputMaybe<Scalars['String']['input']>;
  serviceRequestAdditionalQuestions?: InputMaybe<Scalars['String']['input']>;
  serviceRequestTroubleshootingSteps?: InputMaybe<Scalars['String']['input']>;
  transferRuleOverrides?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorReceptionistGuidanceMutationPayload = {
  __typename: 'UpdateVendorReceptionistGuidanceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  receptionistGuidance: Maybe<VendorReceptionistGuidanceType>;
};

export type UpdateVendorRemittanceEmailAddressesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  remittanceEmailAddresses: Array<InputMaybe<Scalars['String']['input']>>;
  vendorId: Scalars['ID']['input'];
};

export type UpdateVendorRemittanceEmailAddressesMutationPayload = {
  __typename: 'UpdateVendorRemittanceEmailAddressesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  vendorProfile: Maybe<VendorProfileNode>;
};

export type UpdateVendorReportScheduleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  frequency: VendorReportFrequency;
  organizationId: Scalars['ID']['input'];
  recipientEmailAddresses: Array<Scalars['String']['input']>;
  reportType: VendorReportType;
};

export type UpdateVendorReportScheduleMutationPayload = {
  __typename: 'UpdateVendorReportScheduleMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  schedule: VendorReportScheduleNode;
};

export type UpdateVendorRevenueShareInput = {
  labourPercentage: Scalars['Decimal']['input'];
  otherPercentage: Scalars['Decimal']['input'];
  partsPercentage: Scalars['Decimal']['input'];
  serviceCallPercentage: Scalars['Decimal']['input'];
  serviceCategory: ServiceCategory;
  travelPercentage: Scalars['Decimal']['input'];
  truckPercentage: Scalars['Decimal']['input'];
};

export type UpdateVendorRevenueSharesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultVendorRevenueShares: RevenueSharePercentageInput;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorRevenueShares: Array<UpdateVendorRevenueShareInput>;
};

export type UpdateVendorRevenueSharesMutationPayload = {
  __typename: 'UpdateVendorRevenueSharesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  defaultVendorRevenueShares: DefaultVendorRevenueShareNode;
  vendorRevenueShares: Array<VendorRevenueShareNode>;
};

export type UpdateVendorSubcontractMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Resolve the active or pending subcontract for a work order target. */
export type UpdateVendorSubcontractMutationPayload = {
  __typename: 'UpdateVendorSubcontractMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  subcontract: WorkOrderSubcontractType;
  workOrder: Maybe<WorkOrderNode>;
};

export type UpdateVendorSubcontractPairingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentVendorId: Scalars['ID']['input'];
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<VendorSubcontractPairingScopeInput>>;
  shareTiers?: InputMaybe<Array<VendorSubcontractPairingShareTierInput>>;
  subcontractVendorId: Scalars['ID']['input'];
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Coordinator-only commercial term updates for an existing parent/subcontract pairing. */
export type UpdateVendorSubcontractPairingMutationPayload = {
  __typename: 'UpdateVendorSubcontractPairingMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  pairing: VendorSubcontractPairingType;
};

export type UpdateVendorWebsiteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
  sourceSiteRef?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorWebsiteMutationPayload = {
  __typename: 'UpdateVendorWebsiteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Maybe<Scalars['Boolean']['output']>;
  vendorWebsite: Maybe<VendorWebsiteNode>;
};

export type UpdateVisitInput = {
  afterImages: Array<Image>;
  beforeImages: Array<Image>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  recommendations: Scalars['String']['input'];
  visit: Scalars['ID']['input'];
};

export type UpdateVisitPayload = {
  __typename: 'UpdateVisitPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  visit: VisitNode;
};

export type UpdateWebsiteAdvertisingCampaignNameMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  vendorWebsiteId: Scalars['ID']['input'];
  websiteAdvertisingCampaignId: Scalars['ID']['input'];
};

export type UpdateWebsiteAdvertisingCampaignNameMutationPayload = {
  __typename: 'UpdateWebsiteAdvertisingCampaignNameMutationPayload';
  campaign: WebsiteAdvertisingCampaignType;
  clientMutationId: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpdateWorkOrderCompletionTimeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completionTime: Scalars['DateTime']['input'];
  workOrder: Scalars['ID']['input'];
};

export type UpdateWorkOrderCompletionTimePayload = {
  __typename: 'UpdateWorkOrderCompletionTimePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type UpdateWorkOrderNteInput = {
  amount: Scalars['Decimal']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type UpdateWorkOrderNtePayload = {
  __typename: 'UpdateWorkOrderNTEPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  spendApproval: SpendApprovalNode;
};

export type UpdateWorkOrderOpsOwnerMutation = {
  __typename: 'UpdateWorkOrderOpsOwnerMutation';
  ok: Scalars['Boolean']['output'];
  workOrder: Maybe<WorkOrderNode>;
};

/** An enumeration. */
export enum UpgradeType {
  Force = 'FORCE',
  Recommend = 'RECOMMEND'
}

export type UploadAfterImagesMutation = {
  __typename: 'UploadAfterImagesMutation';
  ok: Scalars['Boolean']['output'];
};

export type UploadClientManagedInvoiceInput = {
  amount: Scalars['Decimal']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceFile: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type UploadClientManagedInvoicePayload = {
  __typename: 'UploadClientManagedInvoicePayload';
  clientManagedInvoice: ClientManagedInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type UploadPartneredEstimateSubmissionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  estimateFile: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  subtotal: Scalars['Decimal']['input'];
  total: Scalars['Decimal']['input'];
  validForDays?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadPartneredEstimateSubmissionMutationPayload = {
  __typename: 'UploadPartneredEstimateSubmissionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  partneredEstimateSubmission: PartneredEstimateSubmissionNode;
};

export type UploadPartneredInvoiceSubmissionMutationInput = {
  callbackCostReason?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceFile: Scalars['String']['input'];
  offResqWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  subtotal: Scalars['Decimal']['input'];
  total: Scalars['Decimal']['input'];
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadPartneredInvoiceSubmissionMutationPayload = {
  __typename: 'UploadPartneredInvoiceSubmissionMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  partneredInvoiceSubmission: PartneredInvoiceSubmissionNode;
};

export type UploadQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quoteFile: Scalars['String']['input'];
  quoteUploadSource: QuoteUploadSource;
  subtotal: Scalars['Decimal']['input'];
  validForDays?: InputMaybe<Scalars['Int']['input']>;
  validUntil: Scalars['DateTime']['input'];
  vendorId: Scalars['ID']['input'];
  vendorReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type UploadQuoteMutationPayload = {
  __typename: 'UploadQuoteMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  quote: QuoteNode;
};

export type UploadRemittanceStatementInput = {
  bankAccountRecordId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  remittanceFile: Scalars['String']['input'];
};

export type UploadRemittanceStatementPayload = {
  __typename: 'UploadRemittanceStatementPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  remittanceStatement: RemittanceStatementNode;
};

export type UploadVendorInvoiceInput = {
  applyProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<InboundVendorInvoiceSource>;
  effectiveOffer?: InputMaybe<Scalars['String']['input']>;
  effectiveOfferType?: InputMaybe<Scalars['String']['input']>;
  invoiceFile: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['ID']['input']>;
  paymentTermDays?: InputMaybe<Scalars['Int']['input']>;
  replaceInboundInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorSharePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  workOrderId: Scalars['ID']['input'];
};

export type UploadVendorInvoicePayload = {
  __typename: 'UploadVendorInvoicePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  inboundVendorInvoice: InboundVendorInvoiceNode;
};

export type UploadedFileNode = {
  __typename: 'UploadedFileNode';
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  lastModified: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type UploadedInvoiceCheckMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceFile: Scalars['String']['input'];
  isOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type UploadedInvoiceCheckMutationPayload = {
  __typename: 'UploadedInvoiceCheckMutationPayload';
  cacheKey: Maybe<Scalars['String']['output']>;
  clientMutationId: Maybe<Scalars['String']['output']>;
  invoiceTotal: Maybe<Scalars['Decimal']['output']>;
  invoiceTotalLimit: Maybe<Scalars['Decimal']['output']>;
  invoiceType: Maybe<Scalars['String']['output']>;
  isOverAmount: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum UsageLimitType {
  FixedCount = 'FIXED_COUNT',
  Unlimited = 'UNLIMITED'
}

export type UserNode = Node & {
  __typename: 'UserNode';
  accountType: AccountType;
  canAccessFinanceTab: Scalars['Boolean']['output'];
  clientMemberships: Array<ClientOrganizationMemberNode>;
  djangoGroups: Array<DjangoGroupNode>;
  email: Scalars['String']['output'];
  entitlements: Array<Scalars['String']['output']>;
  facilityGroupMemberships: Array<FacilityGroupMembershipNode>;
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  isFinance: Scalars['Boolean']['output'];
  isFinanceSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  offResqCustomer: Maybe<OffResqCustomerNode>;
  phone: Maybe<Scalars['String']['output']>;
  profile: UserProfileNode;
  sessions: Array<UserSessionNode>;
  sourceId: Scalars['Int']['output'];
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
  vendorMemberships: Array<VendorMemberNode>;
};

export type UserNodeConnection = {
  __typename: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<UserNode>;
};

export type UserNotificationPreferenceConnection = {
  __typename: 'UserNotificationPreferenceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNotificationPreferenceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserNotificationPreference` and its cursor. */
export type UserNotificationPreferenceEdge = {
  __typename: 'UserNotificationPreferenceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<UserNotificationPreferenceNode>;
};

export type UserNotificationPreferenceNode = Node & {
  __typename: 'UserNotificationPreferenceNode';
  email: Maybe<Scalars['Boolean']['output']>;
  emailConfigurable: Maybe<Scalars['Boolean']['output']>;
  emailImplemented: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  notificationName: Scalars['String']['output'];
  push: Maybe<Scalars['Boolean']['output']>;
  pushConfigurable: Maybe<Scalars['Boolean']['output']>;
  pushImplemented: Maybe<Scalars['Boolean']['output']>;
  sms: Maybe<Scalars['Boolean']['output']>;
  smsConfigurable: Maybe<Scalars['Boolean']['output']>;
  smsImplemented: Maybe<Scalars['Boolean']['output']>;
};

export type UserProfileNode = Node & {
  __typename: 'UserProfileNode';
  avatarBackgroundColor: Scalars['String']['output'];
  avatarTextColor: Scalars['String']['output'];
  confirmationRequired: Scalars['Boolean']['output'];
  hasSetPassword: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Anonymous users are used to submit work orders without an account */
  isAnonymous: Scalars['Boolean']['output'];
  language: Maybe<LanguageType>;
  lastConfirmedAt: Maybe<Scalars['DateTime']['output']>;
  locale: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  picture: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<UserNode>;
  userTags: Array<UserTagNode>;
};

/** An enumeration. */
export enum UserProposalDecisionStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type UserSessionNode = Node & {
  __typename: 'UserSessionNode';
  authMethod: AuthMethodType;
  authMethodLabel: Scalars['String']['output'];
  clientBrowser: Maybe<Scalars['String']['output']>;
  clientDeviceType: Maybe<Scalars['String']['output']>;
  clientIsWebview: Maybe<Scalars['Boolean']['output']>;
  clientOs: Maybe<Scalars['String']['output']>;
  clientPlatform: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** When this session naturally ages out. Set to the refresh-token TTL at issuance and advanced on each rotation. */
  expiresAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Client IP captured at session issuance. */
  ipAddress: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** Last authenticated request observed for this session. Populated lazily. */
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  /** When this session was explicitly terminated. Null while the session is alive. */
  revokedAt: Maybe<Scalars['DateTime']['output']>;
  /** User-Agent header captured at session issuance. */
  userAgent: Scalars['String']['output'];
};

export type UserTagNode = Node & {
  __typename: 'UserTagNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserTagNodeConnection = {
  __typename: 'UserTagNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTagNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserTagNode` and its cursor. */
export type UserTagNodeEdge = {
  __typename: 'UserTagNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<UserTagNode>;
};

/** An enumeration. */
export enum ValidationRuleResultAction {
  NoAction = 'NO_ACTION',
  ProcessVendorInvoice = 'PROCESS_VENDOR_INVOICE'
}

export type ValueUnion = DecimalObjectType | RecordOfWorkRevenueShareValuesNode;

export type VapiOverdueInvoicesCallResultNode = Node & {
  __typename: 'VapiOverdueInvoicesCallResultNode';
  callOutcome: Maybe<OverdueInvoicesCallResultOutcomeEnum>;
  callSid: Scalars['String']['output'];
  clientInvoices: Maybe<Array<ClientInvoiceNode>>;
  createdAt: Scalars['DateTime']['output'];
  delayTimeline: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VapiOverdueInvoicesCallResultNodeConnection = {
  __typename: 'VapiOverdueInvoicesCallResultNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VapiOverdueInvoicesCallResultNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VapiOverdueInvoicesCallResultNode` and its cursor. */
export type VapiOverdueInvoicesCallResultNodeEdge = {
  __typename: 'VapiOverdueInvoicesCallResultNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VapiOverdueInvoicesCallResultNode>;
};

export type VapiOverdueInvoicesCallSuccessEvaluationNode = Node & {
  __typename: 'VapiOverdueInvoicesCallSuccessEvaluationNode';
  audioClarity: Maybe<Scalars['String']['output']>;
  callEndedAt: Maybe<Scalars['DateTime']['output']>;
  callSid: Scalars['String']['output'];
  callSummary: Maybe<Scalars['String']['output']>;
  calledUser: Maybe<UserNode>;
  clientInvoices: Maybe<Array<ClientInvoiceNode>>;
  correctness: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endedReason: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  phoneMenu: Scalars['Boolean']['output'];
  phoneMenuNavigation: Scalars['Boolean']['output'];
  recordingUrl: Maybe<Scalars['String']['output']>;
  staysOnTopic: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userInteraction: Scalars['Boolean']['output'];
  voicemail: Scalars['Boolean']['output'];
  wrongContact: Scalars['Boolean']['output'];
};

export type VapiOverdueInvoicesCallSuccessEvaluationNodeConnection = {
  __typename: 'VapiOverdueInvoicesCallSuccessEvaluationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VapiOverdueInvoicesCallSuccessEvaluationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VapiOverdueInvoicesCallSuccessEvaluationNode` and its cursor. */
export type VapiOverdueInvoicesCallSuccessEvaluationNodeEdge = {
  __typename: 'VapiOverdueInvoicesCallSuccessEvaluationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VapiOverdueInvoicesCallSuccessEvaluationNode>;
};

export type VariantNode = {
  __typename: 'VariantNode';
  enabled: Scalars['Boolean']['output'];
  experimentId: Scalars['ID']['output'];
  experimentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['GenericScalar']['output'];
  variantId: Scalars['ID']['output'];
  variantName: Scalars['String']['output'];
};

/** An enumeration. */
export enum VendorAcquisitionType {
  Invited = 'INVITED',
  SelfServe = 'SELF_SERVE'
}

export type VendorAgreementNode = Node & {
  __typename: 'VendorAgreementNode';
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  confirmedBy: Maybe<UserNode>;
  effectiveDate: Maybe<Scalars['Date']['output']>;
  futurePlans: Array<VendorPlanNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  plans: Array<VendorPlanNode>;
};

export type VendorAssignmentNode = Node & {
  __typename: 'VendorAssignmentNode';
  clientId: Scalars['Int']['output'];
  closedAt: Maybe<Scalars['DateTime']['output']>;
  facilityId: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  vendorId: Scalars['Int']['output'];
  workOrder: WorkOrderNode;
  workOrderId: Scalars['Int']['output'];
};

export type VendorAssignmentNodeConnection = {
  __typename: 'VendorAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorAssignmentNode` and its cursor. */
export type VendorAssignmentNodeEdge = {
  __typename: 'VendorAssignmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorAssignmentNode>;
};

/** An enumeration. */
export enum VendorAssignmentOutcome {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED'
}

export type VendorBusinessProfileNode = Node & {
  __typename: 'VendorBusinessProfileNode';
  aboutUs: Maybe<Scalars['String']['output']>;
  brandLogo: Maybe<ImageType>;
  coverImage: Maybe<ImageType>;
  eligiblePromotions: Maybe<Array<VendorPromotionNode>>;
  email: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  phone: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Maybe<UserNode>;
  reviews: Maybe<Array<VendorBusinessReviewNode>>;
  selectedMetrics: Maybe<Array<Metrics>>;
  showSiteUrl: Scalars['Boolean']['output'];
  siteUrl: Maybe<Scalars['String']['output']>;
  trustedByImages: Maybe<Array<VendorBusinessTrustedByImagesNode>>;
  vendor: Maybe<VendorOrganizationNode>;
  vendorPerformanceProfile: Maybe<VendorPerformanceProfile>;
};


export type VendorBusinessProfileNodeEligiblePromotionsArgs = {
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
};

export type VendorBusinessProfileNodeConnection = {
  __typename: 'VendorBusinessProfileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorBusinessProfileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorBusinessProfileNode` and its cursor. */
export type VendorBusinessProfileNodeEdge = {
  __typename: 'VendorBusinessProfileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorBusinessProfileNode>;
};

export type VendorBusinessReviewNode = Node & {
  __typename: 'VendorBusinessReviewNode';
  comment: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type VendorBusinessTrustedByImagesNode = Node & {
  __typename: 'VendorBusinessTrustedByImagesNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};


export type VendorBusinessTrustedByImagesNodeUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum VendorBusinessType {
  Corporation = 'CORPORATION',
  Llc = 'LLC',
  Nonprofit = 'NONPROFIT',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

export type VendorChangeWorkOrderStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  targetState?: InputMaybe<ActivityType>;
  workOrderId: Scalars['ID']['input'];
};

export type VendorChangeWorkOrderStatePayload = {
  __typename: 'VendorChangeWorkOrderStatePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  workOrder: Maybe<WorkOrderNode>;
};

export type VendorCreateWorkOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  images?: InputMaybe<Array<Image>>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  leadInboundRequestId?: InputMaybe<Scalars['ID']['input']>;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  requestorName: Scalars['String']['input'];
  serviceCategory: ServiceCategory;
  source?: InputMaybe<VendorCreatedWorkOrderSource>;
  title: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorCreateWorkOrderPayload = {
  __typename: 'VendorCreateWorkOrderPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  workOrder: WorkOrderNode;
};

export type VendorCreatedWorkOrderDetailNode = Node & {
  __typename: 'VendorCreatedWorkOrderDetailNode';
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  confirmedBy: Maybe<UserNode>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  requestorName: Scalars['String']['output'];
  vendorInternalNotes: Scalars['String']['output'];
};

/** An enumeration. */
export enum VendorCreatedWorkOrderSource {
  JobsTab = 'JOBS_TAB',
  VisitRecommendation = 'VISIT_RECOMMENDATION'
}

export type VendorCurrentRevenueShareBreakdownNode = Node & {
  __typename: 'VendorCurrentRevenueShareBreakdownNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  marketplaceRevenueShare: Scalars['Decimal']['output'];
  payoutRevenueShare: Scalars['Decimal']['output'];
  payoutTerms: Scalars['Int']['output'];
  vendorId: Scalars['Int']['output'];
};

export type VendorDispatchNode = Node & {
  __typename: 'VendorDispatchNode';
  endedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  requests: Array<VendorDispatchRequestNode>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  startedAutomatically: Maybe<Scalars['Boolean']['output']>;
  startedThroughCyov: Scalars['Boolean']['output'];
  status: VendorDispatchStatus;
  workOrder: Maybe<WorkOrderNode>;
};

/** An enumeration. */
export enum VendorDispatchRequestDeclineReasonChoices {
  DoNotHaveTheRightEquipment = 'DO_NOT_HAVE_THE_RIGHT_EQUIPMENT',
  NotInMyFieldOfExpertise = 'NOT_IN_MY_FIELD_OF_EXPERTISE',
  Other = 'OTHER',
  TooBusy = 'TOO_BUSY',
  TooFar = 'TOO_FAR',
  WeDoNotServiceThisRestaurant = 'WE_DO_NOT_SERVICE_THIS_RESTAURANT'
}

export type VendorDispatchRequestDeclineReasonNode = Node & {
  __typename: 'VendorDispatchRequestDeclineReasonNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  otherReason: Maybe<Scalars['String']['output']>;
  reasonChoice: VendorDispatchRequestDeclineReasonChoices;
  vendorDispatchRequest: VendorDispatchRequestNode;
};

export type VendorDispatchRequestNode = Node & {
  __typename: 'VendorDispatchRequestNode';
  actionedAt: Maybe<Scalars['DateTime']['output']>;
  can: Scalars['Boolean']['output'];
  declineReason: Maybe<VendorDispatchRequestDeclineReasonNode>;
  dispatchNote: Maybe<Scalars['String']['output']>;
  exclusivityWindow: Scalars['Int']['output'];
  expectedAcceptanceAt: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  onPlatformFastPayInvoiceTotalLimit: Scalars['Decimal']['output'];
  order: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: VendorDispatchRequestStatus;
  vendor: VendorOrganizationNode;
  vendorDispatch: VendorDispatchNode;
};


export type VendorDispatchRequestNodeCanArgs = {
  perform: VendorDispatchRequestPermission;
};

export type VendorDispatchRequestNodeConnection = {
  __typename: 'VendorDispatchRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorDispatchRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorDispatchRequestNode` and its cursor. */
export type VendorDispatchRequestNodeEdge = {
  __typename: 'VendorDispatchRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorDispatchRequestNode>;
};

export enum VendorDispatchRequestPermission {
  AcceptWithoutScheduling = 'ACCEPT_WITHOUT_SCHEDULING',
  Respond = 'RESPOND'
}

/** An enumeration. */
export enum VendorDispatchRequestStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum VendorDispatchStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export enum VendorDocumentEnum {
  FacilityInsurance = 'FACILITY_INSURANCE',
  Insurance = 'INSURANCE',
  Licence = 'LICENCE',
  Other = 'OTHER',
  TaxW9 = 'TAX_W9',
  VoidCheque = 'VOID_CHEQUE',
  Wsib = 'WSIB'
}

export type VendorDocumentInput = {
  documentFile: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  documentType: VendorDocumentEnum;
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
};

export type VendorDocumentNode = {
  __typename: 'VendorDocumentNode';
  createdAt: Scalars['DateTime']['output'];
  documentFile: FileType;
  documentName: Scalars['String']['output'];
  documentType: VendorDocumentEnum;
  expiresOn: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
};

export type VendorEntryInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Represents a vendor's current equipment capability. */
export type VendorEquipmentCapabilityNode = Node & {
  __typename: 'VendorEquipmentCapabilityNode';
  /** Can the vendor install this type of equipment? */
  canPerformInstallation: Scalars['Boolean']['output'];
  /** Can the vendor perform maintenance on this type of equipment? */
  canPerformMaintenance: Scalars['Boolean']['output'];
  /** Can the vendor repair this type of equipment? */
  canPerformRepairs: Scalars['Boolean']['output'];
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  manufacturer: Maybe<EquipmentManufacturerNode>;
  /** Any additional relevant notes about the capability. */
  notes: Scalars['String']['output'];
  /** Indicates if the vendor is authorized to perform warranty work for this specific manufacturer and equipment category. */
  supportsWarranty: Scalars['Boolean']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  /** Timestamp when warranty support was last verified. */
  warrantySupportLastVerifiedAt: Maybe<Scalars['DateTime']['output']>;
};

export type VendorEquipmentCapabilityNodeConnection = {
  __typename: 'VendorEquipmentCapabilityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorEquipmentCapabilityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorEquipmentCapabilityNode` and its cursor. */
export type VendorEquipmentCapabilityNodeEdge = {
  __typename: 'VendorEquipmentCapabilityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorEquipmentCapabilityNode>;
};

/** Represents a rejected vendor equipment capability suggestion. */
export type VendorEquipmentCapabilitySuggestionRejectionNode = Node & {
  __typename: 'VendorEquipmentCapabilitySuggestionRejectionNode';
  createdAt: Scalars['DateTime']['output'];
  equipmentCategory: Maybe<EquipmentCategoryNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  manufacturer: Maybe<EquipmentManufacturerNode>;
  /** The confidence score of the original suggestion that was rejected. */
  originalConfidenceScore: Scalars['Float']['output'];
  /** Number of historical work orders that supported the original suggestion. */
  originalHistoricalWorkOrdersCount: Scalars['Int']['output'];
  /** Source of the original suggestion. */
  originalSource: VendorEquipmentCapabilitySuggestionRejectionOriginalSource;
  rejectedBy: Maybe<UserNode>;
  /** Optional additional notes about why this suggestion was rejected. */
  rejectionNotes: Maybe<Scalars['String']['output']>;
  /** Optional reason for rejecting this capability suggestion. */
  rejectionReason: Maybe<Scalars['String']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type VendorEquipmentCapabilitySuggestionRejectionNodeConnection = {
  __typename: 'VendorEquipmentCapabilitySuggestionRejectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorEquipmentCapabilitySuggestionRejectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorEquipmentCapabilitySuggestionRejectionNode` and its cursor. */
export type VendorEquipmentCapabilitySuggestionRejectionNodeEdge = {
  __typename: 'VendorEquipmentCapabilitySuggestionRejectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorEquipmentCapabilitySuggestionRejectionNode>;
};

/** An enumeration. */
export enum VendorEquipmentCapabilitySuggestionRejectionOriginalSource {
  /** Historical Work Orders */
  HistoricalWorkOrders = 'HISTORICAL_WORK_ORDERS',
  /** Service Categories */
  ServiceCategories = 'SERVICE_CATEGORIES',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

/**
 * Represents a suggested equipment capability for a vendor.
 * This is a non-persisted type that represents potential capabilities.
 */
export type VendorEquipmentCapabilitySuggestionType = {
  __typename: 'VendorEquipmentCapabilitySuggestionType';
  canPerformEmergency: Maybe<Scalars['Boolean']['output']>;
  canPerformInstallation: Maybe<Scalars['Boolean']['output']>;
  canPerformMaintenance: Maybe<Scalars['Boolean']['output']>;
  canPerformRepairs: Maybe<Scalars['Boolean']['output']>;
  confidenceScore: Maybe<Scalars['Float']['output']>;
  equipmentCategoryId: Scalars['ID']['output'];
  equipmentCategoryName: Scalars['String']['output'];
  historicalWorkOrdersCount: Maybe<Scalars['Int']['output']>;
  manufacturerId: Scalars['ID']['output'];
  manufacturerName: Scalars['String']['output'];
  source: Maybe<Scalars['String']['output']>;
  supportsWarranty: Maybe<Scalars['Boolean']['output']>;
  vendorId: Scalars['ID']['output'];
};

/**
 * Represents a work order in equipment service history with conditional anonymization.
 *
 * Vendors see full details for their own work orders and anonymized details for others.
 * Access is restricted to equipment the vendor has actually worked on.
 */
export type VendorEquipmentServiceHistoryNode = Node & {
  __typename: 'VendorEquipmentServiceHistoryNode';
  code: Scalars['String']['output'];
  completedOn: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceNotes: Maybe<Scalars['String']['output']>;
  isOwnWorkOrder: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type VendorFacilityInsuranceDocumentInput = {
  documentFile: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  expiresOn: Scalars['Date']['input'];
};

export type VendorFacilityInviteNode = Node & {
  __typename: 'VendorFacilityInviteNode';
  convertedToWoAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  facility: Maybe<FacilityNode>;
  firstSeenAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  offResqFacility: Maybe<OffResqFacilityNode>;
  phoneNumber: Scalars['String']['output'];
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
  /** Optional E.164 number used to send the invite (AI/DID). Null for flexibility when unknown or not applicable. Consider a VendorAINumber table. */
  vendorAssistantPhoneNumber: Maybe<Scalars['String']['output']>;
};

export type VendorFacilityInviteNodeConnection = {
  __typename: 'VendorFacilityInviteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorFacilityInviteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorFacilityInviteNode` and its cursor. */
export type VendorFacilityInviteNodeEdge = {
  __typename: 'VendorFacilityInviteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorFacilityInviteNode>;
};

export type VendorGrowthHubFunnelType = {
  __typename: 'VendorGrowthHubFunnelType';
  estimatedRevenue: Maybe<VendorGrowthHubMoneyType>;
  jobsCreated: Scalars['Int']['output'];
  leadsCaptured: Scalars['Int']['output'];
  visitors: Maybe<Scalars['Int']['output']>;
  visitorsConfidence: Maybe<Scalars['String']['output']>;
};

export type VendorGrowthHubHeadlineType = {
  __typename: 'VendorGrowthHubHeadlineType';
  adSpend: Maybe<VendorGrowthHubMoneyType>;
  costPerLead: Maybe<VendorGrowthHubMoneyType>;
  estimatedRevenue: Maybe<VendorGrowthHubMoneyType>;
  googleAdsLeadsCaptured: Scalars['Int']['output'];
  jobsCreated: Scalars['Int']['output'];
  leadsCaptured: Scalars['Int']['output'];
  phoneCallsAnswered: Scalars['Int']['output'];
  phoneJobsCreated: Scalars['Int']['output'];
  phoneLeadsCaptured: Scalars['Int']['output'];
  visitors: Maybe<Scalars['Int']['output']>;
  visitorsConfidence: Maybe<Scalars['String']['output']>;
  webLeadsCaptured: Scalars['Int']['output'];
};

export type VendorGrowthHubLeadReplayEventType = {
  __typename: 'VendorGrowthHubLeadReplayEventType';
  channel: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  occurredAt: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
};

export type VendorGrowthHubLeadReplayType = {
  __typename: 'VendorGrowthHubLeadReplayType';
  estimatedValue: Maybe<VendorGrowthHubMoneyType>;
  events: Array<VendorGrowthHubLeadReplayEventType>;
  inboundRequestId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type VendorGrowthHubMarketplaceRevenueType = {
  __typename: 'VendorGrowthHubMarketplaceRevenueType';
  invoicesCreated: Scalars['Int']['output'];
  jobsCreated: Scalars['Int']['output'];
  revenue: VendorGrowthHubMoneyType;
};

export type VendorGrowthHubMoneyType = {
  __typename: 'VendorGrowthHubMoneyType';
  amount: Maybe<Scalars['Decimal']['output']>;
  confidence: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
};

export type VendorGrowthHubNextBestActionType = {
  __typename: 'VendorGrowthHubNextBestActionType';
  ctaPath: Scalars['String']['output'];
  key: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type VendorGrowthHubOverviewType = {
  __typename: 'VendorGrowthHubOverviewType';
  funnel: VendorGrowthHubFunnelType;
  growthScore: VendorGrowthHubScoreType;
  headline: VendorGrowthHubHeadlineType;
  leadReplays: Array<VendorGrowthHubLeadReplayType>;
  marketplaceRevenue: Maybe<VendorGrowthHubMarketplaceRevenueType>;
  nextBestActions: Array<VendorGrowthHubNextBestActionType>;
  range: VendorGrowthHubRangeType;
  serviceActivationDates: VendorGrowthHubServiceActivationDatesType;
};

export type VendorGrowthHubRangeType = {
  __typename: 'VendorGrowthHubRangeType';
  endAt: Scalars['DateTime']['output'];
  startAt: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
};

export type VendorGrowthHubScoreFactorType = {
  __typename: 'VendorGrowthHubScoreFactorType';
  key: Scalars['String']['output'];
  maxPoints: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type VendorGrowthHubScoreType = {
  __typename: 'VendorGrowthHubScoreType';
  factors: Array<VendorGrowthHubScoreFactorType>;
  maxScore: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type VendorGrowthHubServiceActivationDatesType = {
  __typename: 'VendorGrowthHubServiceActivationDatesType';
  advertising: Maybe<Scalars['DateTime']['output']>;
  emailInsights: Maybe<Scalars['DateTime']['output']>;
  nora: Maybe<Scalars['DateTime']['output']>;
  website: Maybe<Scalars['DateTime']['output']>;
};

export type VendorImprovementMetric = {
  __typename: 'VendorImprovementMetric';
  metric: ScoreMetric;
  percentileRank: Scalars['Decimal']['output'];
  pillar: ScorePillar;
};

/** An enumeration. */
export enum VendorIncomingJobItemType {
  OffResqSubcontract = 'OFF_RESQ_SUBCONTRACT',
  VendorDispatchRequest = 'VENDOR_DISPATCH_REQUEST'
}

export type VendorIncomingJobNode = Node & {
  __typename: 'VendorIncomingJobNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  itemType: VendorIncomingJobItemType;
  offResqWorkOrder: Maybe<OffResqWorkOrderNode>;
  requestedAt: Scalars['DateTime']['output'];
  vendorDispatchRequest: Maybe<VendorDispatchRequestNode>;
};

export type VendorIncomingJobNodeConnection = {
  __typename: 'VendorIncomingJobNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorIncomingJobNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorIncomingJobNode` and its cursor. */
export type VendorIncomingJobNodeEdge = {
  __typename: 'VendorIncomingJobNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorIncomingJobNode>;
};

export type VendorInsuranceDocumentInput = {
  documentFile: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  expiresOn: Scalars['Date']['input'];
};

export type VendorInternalNoteNode = Node & {
  __typename: 'VendorInternalNoteNode';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type VendorInviteValues = {
  email?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds: Array<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  previousMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCategories: Array<ServiceCategory>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** An enumeration. */
export enum VendorInvoiceCurrency {
  /** CAD */
  Cad = 'CAD',
  /** GBP */
  Gbp = 'GBP',
  /** USD */
  Usd = 'USD'
}

export type VendorInvoiceNode = Node & {
  __typename: 'VendorInvoiceNode';
  batch: Maybe<ApBatchNode>;
  billingPaymentProcessing: Scalars['Boolean']['output'];
  code: Maybe<Scalars['String']['output']>;
  /** The currency of the invoice amounts. */
  currency: VendorInvoiceCurrency;
  dueAtDate: Maybe<Scalars['DateTime']['output']>;
  financingStatus: Maybe<Scalars['String']['output']>;
  hasFastpayFees: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundVendorInvoice: Maybe<InboundVendorInvoiceNode>;
  invoiceSet: Maybe<InvoiceSetNode>;
  invoicingVersion: InvoicingVersion;
  isFastpaySurprise: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedAtDate: Scalars['Date']['output'];
  organizationSubscription: Maybe<OrganizationSubscriptionNode>;
  paidAt: Maybe<Scalars['DateTime']['output']>;
  paymentStanding: Maybe<Scalars['String']['output']>;
  /** The effective payment terms of the invoice. */
  paymentTerms: Maybe<Scalars['Int']['output']>;
  pdfUrl: Maybe<Scalars['String']['output']>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  referenceNumber: Maybe<Scalars['String']['output']>;
  status: VendorInvoiceStatus;
  total: Scalars['Float']['output'];
  /** The ID of the vendor that the invoice is associated with. This is also called organization_id in other models. */
  vendor: VendorOrganizationNode;
  /** The ID of the work order that the invoice is associated with. This is NULL when invoicing off resq customers. */
  workOrder: Maybe<WorkOrderNode>;
};

export type VendorInvoiceNodeConnection = {
  __typename: 'VendorInvoiceNodeConnection';
  cadTotal: Scalars['Decimal']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorInvoiceNodeEdge>>;
  gbpTotal: Scalars['Decimal']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  usdTotal: Scalars['Decimal']['output'];
};

/** A Relay edge containing a `VendorInvoiceNode` and its cursor. */
export type VendorInvoiceNodeEdge = {
  __typename: 'VendorInvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorInvoiceNode>;
};

export enum VendorInvoiceStatus {
  AwaitingPayout = 'AWAITING_PAYOUT',
  AwaitingReview = 'AWAITING_REVIEW',
  Disputed = 'DISPUTED',
  Paid = 'PAID',
  PaymentInitiated = 'PAYMENT_INITIATED'
}

export type VendorInvoiceTaxNode = Node & {
  __typename: 'VendorInvoiceTaxNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  taxRate: TaxRateNode;
  total: Scalars['Decimal']['output'];
};

export type VendorJobChangeSuggestionNode = Node & {
  __typename: 'VendorJobChangeSuggestionNode';
  endAt: Maybe<Scalars['DateTime']['output']>;
  endDate: Maybe<Scalars['Date']['output']>;
  endTime: Maybe<Scalars['Time']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  startAt: Maybe<Scalars['DateTime']['output']>;
  startDate: Maybe<Scalars['Date']['output']>;
  startTime: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type VendorJobChangeSuggestionNodeConnection = {
  __typename: 'VendorJobChangeSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorJobChangeSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorJobChangeSuggestionNode` and its cursor. */
export type VendorJobChangeSuggestionNodeEdge = {
  __typename: 'VendorJobChangeSuggestionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorJobChangeSuggestionNode>;
};

export type VendorJobCountNode = {
  __typename: 'VendorJobCountNode';
  awaitingPartsCount: Scalars['Int']['output'];
  awaitingPayoutCount: Scalars['Int']['output'];
  disputedCount: Scalars['Int']['output'];
  invoicesNeededCount: Scalars['Int']['output'];
  quotesInReviewCount: Scalars['Int']['output'];
  quotesNeededCount: Scalars['Int']['output'];
  todayCount: Scalars['Int']['output'];
};

export type VendorMailInsightBucketCount = {
  __typename: 'VendorMailInsightBucketCount';
  bucket: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type VendorMailInsightCustomer = {
  __typename: 'VendorMailInsightCustomer';
  bucket: Scalars['String']['output'];
  bucketSignalCount: Scalars['Int']['output'];
  company: Maybe<Scalars['String']['output']>;
  contactName: Maybe<Scalars['String']['output']>;
  existingResqUser: Scalars['Boolean']['output'];
  firstSeenAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastActiveAt: Maybe<Scalars['DateTime']['output']>;
  normalizedEmail: Scalars['String']['output'];
  promoReactivation: Maybe<VendorMailInsightPromoReactivation>;
  recentThreads: Array<VendorMailInsightThread>;
  threadCount: Scalars['Int']['output'];
};

export type VendorMailInsightPromoReactivation = {
  __typename: 'VendorMailInsightPromoReactivation';
  daysSinceLastEmail: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  offerCode: Maybe<Scalars['String']['output']>;
  reasonCode: Scalars['String']['output'];
};

export type VendorMailInsightPromotionOption = {
  __typename: 'VendorMailInsightPromotionOption';
  audienceType: AudienceType;
  discountType: DiscountType;
  discountValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VendorMailInsightThread = {
  __typename: 'VendorMailInsightThread';
  id: Scalars['ID']['output'];
  primaryClassification: Scalars['String']['output'];
  summary: Maybe<Scalars['String']['output']>;
  threadId: Scalars['String']['output'];
  threadLastMessageAt: Maybe<Scalars['DateTime']['output']>;
};

export type VendorMailInsights = {
  __typename: 'VendorMailInsights';
  availablePromotions: Array<VendorMailInsightPromotionOption>;
  bucketCounts: Array<VendorMailInsightBucketCount>;
  connected: Scalars['Boolean']['output'];
  customers: Array<VendorMailInsightCustomer>;
  mailboxOwner: Maybe<Scalars['String']['output']>;
};

export type VendorMatch = {
  __typename: 'VendorMatch';
  badExperiences: Array<MatchBadExperience>;
  completedWorkOrderCount: Scalars['Int']['output'];
  dispatchEnabled: Scalars['Boolean']['output'];
  eligiblePromotions: Maybe<Array<VendorPromotionNode>>;
  firstTimeFixRate: Maybe<Scalars['Decimal']['output']>;
  isCuratedTopSlot: Scalars['Boolean']['output'];
  isInherited: Scalars['Boolean']['output'];
  isMpProvider: Scalars['Boolean']['output'];
  isNewToFacility: Scalars['Boolean']['output'];
  isNewToPlatform: Scalars['Boolean']['output'];
  isRsg: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  negativeReviewCount: Scalars['Int']['output'];
  positiveReviewCount: Scalars['Int']['output'];
  priceLevel: Maybe<Scalars['Int']['output']>;
  qualityScore: Maybe<Scalars['Decimal']['output']>;
  rankingCohort: Maybe<VendorMatchRankingCohort>;
  satisfactionRate: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  timeToOnsite: Maybe<Scalars['Int']['output']>;
  vendor: VendorOrganizationNode;
  vendorPriceRate: Maybe<VendorPriceRateNode>;
  vendorSkills: Array<SkillNode>;
  willBypassExpiry: Scalars['Boolean']['output'];
};


export type VendorMatchEligiblePromotionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum VendorMatchRankingCohort {
  HighScore = 'HIGH_SCORE',
  NewVendor = 'NEW_VENDOR',
  Remainder = 'REMAINDER',
  SuperVendor = 'SUPER_VENDOR'
}

export type VendorMatchSet = {
  __typename: 'VendorMatchSet';
  favouriteVendors: Array<VendorMatch>;
  inheritedVendors: Array<VendorMatch>;
  marketplaceVendors: Array<VendorMatch>;
  rankedVendors: Array<VendorMatch>;
  suggestedVendors: Array<VendorMatch>;
  suspectedCallbackVendors: Array<VendorMatch>;
  verifiedVendors: Array<VendorMatch>;
};

export type VendorMatchesInput = {
  callbackOriginalWorkOrderId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['ID']['input']>;
  expectedServiceTimeline?: InputMaybe<ExpectedServiceTimeline>;
  facility?: InputMaybe<Scalars['ID']['input']>;
  hasPromotionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isSuspectedCallback?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  requestType?: InputMaybe<WorkOrderRequestType>;
  serviceCategory?: InputMaybe<ServiceCategory>;
  symptom?: InputMaybe<Scalars['ID']['input']>;
  taxonomyNode?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorMatchingProfileNode = Node & {
  __typename: 'VendorMatchingProfileNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  openToMarketplace: Scalars['Boolean']['output'];
  skills: Array<SkillNode>;
};

export type VendorMemberNode = Node & {
  __typename: 'VendorMemberNode';
  can: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  roles: Array<RoleNode>;
  user: UserNode;
  vendor: VendorOrganizationNode;
};


export type VendorMemberNodeCanArgs = {
  perform: MemberPermission;
};

export type VendorMemberNodeConnection = {
  __typename: 'VendorMemberNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorMemberNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorMemberNode` and its cursor. */
export type VendorMemberNodeEdge = {
  __typename: 'VendorMemberNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorMemberNode>;
};

export type VendorMetricsNode = {
  __typename: 'VendorMetricsNode';
  completedWorkOrdersComparison: CompletedWorkOrdersComparison;
  facilitiesServiced: Scalars['Int']['output'];
  jobsPerCategory: Array<JobsPerServiceCategory>;
  jobsPerType: JobsPerType;
  lifetimeCompletedJobCount: Scalars['Int']['output'];
  lifetimeCustomers: Maybe<FacilityNodeConnection>;
  lifetimeCustomersCount: Scalars['Int']['output'];
  lifetimeFacilitiesServiced: Scalars['Int']['output'];
  lifetimeJobCount: Scalars['Int']['output'];
  lifetimeRevenue: Scalars['Decimal']['output'];
  outstandingInvoiceCount: Scalars['Int']['output'];
  performanceByTechnician: Array<TechnicianPerformance>;
  revenue: Scalars['Decimal']['output'];
  satisfactionRate: SatisfactionRate;
};


export type VendorMetricsNodeLifetimeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorNoraReceptionistDowngradeSummary = {
  __typename: 'VendorNoraReceptionistDowngradeSummary';
  callCountPastMonth: Scalars['Int']['output'];
  exampleCall: Maybe<VendorNoraReceptionistExampleCall>;
  phoneNumber: Scalars['String']['output'];
};

export type VendorNoraReceptionistExampleCall = {
  __typename: 'VendorNoraReceptionistExampleCall';
  callSid: Scalars['String']['output'];
  durationSeconds: Maybe<Scalars['Int']['output']>;
  leadScore: Maybe<Scalars['Int']['output']>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** An enumeration. */
export enum VendorOption {
  Callback = 'CALLBACK',
  Directory = 'DIRECTORY',
  Favourite = 'FAVOURITE',
  VerifiedVendor = 'VERIFIED_VENDOR'
}

export type VendorOrganizationNode = Node & {
  __typename: 'VendorOrganizationNode';
  acquisitionType: Maybe<VendorAcquisitionType>;
  activeTradesSubscription: Maybe<OrganizationSubscriptionNode>;
  advertisingCommercialHoldState: AdvertisingCommercialHoldStateType;
  agreement: Maybe<VendorAgreementNode>;
  allBlockedBy: Array<FacilityGroupNode>;
  bankAccount: Maybe<BankAccountNode>;
  billingAddress: Maybe<BillingAddressNode>;
  billingInformation: BillingInformationNode;
  brandLogo: Maybe<ImageType>;
  businessProfile: Maybe<VendorBusinessProfileNode>;
  canAccessWebsite: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  /** @deprecated Renamed to `name`. */
  companyName: Scalars['String']['output'];
  currentRevenueShareBreakdown: Maybe<VendorCurrentRevenueShareBreakdownNode>;
  currentTradesSubscriptionTier: Maybe<TradesSubscriptionOfferTier>;
  documents: Array<VendorDocumentNode>;
  experienceAreas: ExperienceAreas;
  hasAcceptedPayqTos: Maybe<Scalars['Boolean']['output']>;
  hasActiveProtectionPlanConfiguration: Scalars['Boolean']['output'];
  hasCompletedWebsiteBuilderSurvey: Scalars['Boolean']['output'];
  hasCrmFeatures: Maybe<Scalars['Boolean']['output']>;
  hasSubmittedOrcInvoice: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalNotes: Array<VendorInternalNoteNode>;
  invites: Array<InviteNode>;
  isRsg: Scalars['Boolean']['output'];
  isSelfServeSignup: Maybe<Scalars['Boolean']['output']>;
  isTestData: Maybe<Scalars['Boolean']['output']>;
  isTradesMonetisationEnabled: Scalars['Boolean']['output'];
  isVerifiedVendor: Maybe<Scalars['Boolean']['output']>;
  lendingEnabled: Maybe<Scalars['Boolean']['output']>;
  matchingProfile: Maybe<VendorMatchingProfileNode>;
  members: Array<VendorMemberNode>;
  name: Scalars['String']['output'];
  noraEmailForwardingVerificationEmailReceived: Scalars['Boolean']['output'];
  noraEmailInbox: Maybe<Scalars['String']['output']>;
  noraReceptionistDowngradeSummary: Maybe<VendorNoraReceptionistDowngradeSummary>;
  owner: Maybe<UserNode>;
  payqTosVersion: Maybe<PayQAgreementTosVersion>;
  pendingTradesSubscription: Maybe<OrganizationSubscriptionNode>;
  permissions: VendorPermissions;
  profile: VendorProfileNode;
  recentlyWorkedWithFacilities: Maybe<Array<Maybe<FacilityNode>>>;
  scheduledTradesPlanChange: Maybe<ScheduledTradesPlanChangeType>;
  subscriptionInvoices: Array<VendorInvoiceNode>;
  successOwner: Maybe<UserNode>;
  tier: Maybe<VendorTier>;
  timezone: Scalars['String']['output'];
  trackingId: Scalars['Int']['output'];
  tradeQualifications: Array<VendorTradeQualificationNode>;
  tradesSubscriptionOffers: Array<TradesSubscriptionOfferNode>;
  tradesSubscriptionPreview: Maybe<TradesSubscriptionPreviewType>;
  /** @deprecated Use `members` instead. */
  users: Array<UserNode>;
  vendorIcsLink: Maybe<Scalars['String']['output']>;
  verifiedVendorCreatedAt: Maybe<Scalars['DateTime']['output']>;
  websiteBuilderSurvey: Maybe<VendorWebsiteBuilderSurveyNode>;
  websites: Array<VendorWebsiteNode>;
};


export type VendorOrganizationNodeExperienceAreasArgs = {
  facilityId: Scalars['ID']['input'];
};


export type VendorOrganizationNodeRecentlyWorkedWithFacilitiesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type VendorOrganizationNodeTradesSubscriptionPreviewArgs = {
  serviceName: ResqServiceName;
};

export type VendorOrganizationNodeConnection = {
  __typename: 'VendorOrganizationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorOrganizationNode` and its cursor. */
export type VendorOrganizationNodeEdge = {
  __typename: 'VendorOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorOrganizationNode>;
};

export type VendorOverdueInvoicesNode = {
  __typename: 'VendorOverdueInvoicesNode';
  averageMonthlyPayoutDays: Scalars['Int']['output'];
  month: Scalars['DateTime']['output'];
  monthlyPaidInvoiceCount: Scalars['Int']['output'];
  overdueInvoicesCount: Scalars['Int']['output'];
  overdueInvoicesTotal: Scalars['Decimal']['output'];
  payoutDays: Scalars['Int']['output'];
  threeMonthAverageDaysToGetPaid: Scalars['Int']['output'];
  threeMonthPaidInvoiceCount: Scalars['Int']['output'];
  vendorId: Scalars['ID']['output'];
};

export type VendorPayoutNode = Node & {
  __typename: 'VendorPayoutNode';
  currency: Currency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  operatingCountry: CountryNode;
};

export type VendorPerformancePillarPercentiles = {
  __typename: 'VendorPerformancePillarPercentiles';
  process: Maybe<Scalars['Decimal']['output']>;
  quality: Maybe<Scalars['Decimal']['output']>;
  speed: Maybe<Scalars['Decimal']['output']>;
};

export type VendorPerformanceProfile = {
  __typename: 'VendorPerformanceProfile';
  completedJobsCount: Maybe<Scalars['Int']['output']>;
  dispatchAcceptanceRate: Maybe<Scalars['Decimal']['output']>;
  dispatchAcceptanceWithin15mRate: Maybe<Scalars['Decimal']['output']>;
  dispatchAcceptanceWithin60mRate: Maybe<Scalars['Decimal']['output']>;
  firstTimeFixRates: Array<FirstTimeFixRate>;
  improvementMetrics: Array<VendorImprovementMetric>;
  pillarPercentiles: VendorPerformancePillarPercentiles;
  reviewSummary: ReviewMetrics;
  scoreFactorMetrics: Array<VendorImprovementMetric>;
  scoreSummary: VendorScoreSummary;
  timeToOnsite: Maybe<Scalars['Int']['output']>;
  timeToQuoteHours: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type VendorPermissions = {
  __typename: 'VendorPermissions';
  /** Permission to view and accept dispatch requests. */
  acceptDispatchRequests: Scalars['Boolean']['output'];
  accessReports: Scalars['Boolean']['output'];
  blockAp: Scalars['Boolean']['output'];
  canConfirmDetails: Scalars['Boolean']['output'];
  createInvoice: Scalars['Boolean']['output'];
  createJob: Scalars['Boolean']['output'];
  /** Permission to view and fulfill scheduling requests. */
  fulfillSchedulingRequests: Scalars['Boolean']['output'];
  manageProfile: Scalars['Boolean']['output'];
  manageUsers: Scalars['Boolean']['output'];
  modifyDetails: Scalars['Boolean']['output'];
  performWork: Scalars['Boolean']['output'];
  readInvoice: Scalars['Boolean']['output'];
  unblockAp: Scalars['Boolean']['output'];
  uploadInvoice: Scalars['Boolean']['output'];
  viewCustomers: Scalars['Boolean']['output'];
  /** Permission to view performance page */
  viewPerformance: Scalars['Boolean']['output'];
};

export type VendorPlanNode = Node & {
  __typename: 'VendorPlanNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  impactsInherited: Scalars['Boolean']['output'];
  isPopular: Scalars['Boolean']['output'];
  legacyGroup: Maybe<Scalars['Int']['output']>;
  paymentTerms: Maybe<Scalars['Int']['output']>;
  perks: Array<VendorPlanPerk>;
  revenueShareImpact: Scalars['Decimal']['output'];
  type: VendorPlanType;
};

export type VendorPlanNodeConnection = {
  __typename: 'VendorPlanNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPlanNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorPlanNode` and its cursor. */
export type VendorPlanNodeEdge = {
  __typename: 'VendorPlanNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorPlanNode>;
};

/** An enumeration. */
export enum VendorPlanPerk {
  BusinessReview = 'BUSINESS_REVIEW',
  CompetitiveQuoteAccess = 'COMPETITIVE_QUOTE_ACCESS',
  FastPayout = 'FAST_PAYOUT',
  MaintenacePlanAccess = 'MAINTENACE_PLAN_ACCESS',
  Marketplace = 'MARKETPLACE',
  QuickPayout = 'QUICK_PAYOUT',
  StandardPayout = 'STANDARD_PAYOUT'
}

/** An enumeration. */
export enum VendorPlanType {
  MarketplacePremium = 'MARKETPLACE_PREMIUM',
  MarketplaceStandard = 'MARKETPLACE_STANDARD',
  PayoutFast = 'PAYOUT_FAST',
  PayoutQuick = 'PAYOUT_QUICK',
  PayoutStandard = 'PAYOUT_STANDARD'
}

/** An enumeration. */
export enum VendorPreventiveMaintenanceRecommendationDeclineReason {
  AlreadyHaveAPm = 'ALREADY_HAVE_A_PM',
  EquipmentReplacedSoon = 'EQUIPMENT_REPLACED_SOON',
  NotAPriority = 'NOT_A_PRIORITY',
  NotInTheBudget = 'NOT_IN_THE_BUDGET'
}

export type VendorPreventiveMaintenanceRecommendationNode = Node & {
  __typename: 'VendorPreventiveMaintenanceRecommendationNode';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  photos: Array<VendorPreventiveMaintenanceRecommendationPhotoNode>;
  vendorName: Scalars['String']['output'];
};

export type VendorPreventiveMaintenanceRecommendationPhotoNode = Node & {
  __typename: 'VendorPreventiveMaintenanceRecommendationPhotoNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  photo: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type VendorPreventiveMaintenanceRecommendationPhotoNodeUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageFormat?: InputMaybe<FormatOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorPriceRateNode = Node & {
  __typename: 'VendorPriceRateNode';
  hourlyLabourRate: Maybe<Scalars['Decimal']['output']>;
  hourlyLabourRateLowerBound: Maybe<Scalars['Decimal']['output']>;
  hourlyLabourRateUpperBound: Maybe<Scalars['Decimal']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourRate: Maybe<Scalars['Decimal']['output']>;
  minServiceCallHours: Maybe<Scalars['Decimal']['output']>;
  minServiceCallRate: Maybe<Scalars['Decimal']['output']>;
  overtimeMultiplier: Maybe<Scalars['Decimal']['output']>;
  serviceCallRate: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  travelRate: Maybe<Scalars['Decimal']['output']>;
  truckRate: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vendor: VendorOrganizationNode;
};

export type VendorPriceRateNodeConnection = {
  __typename: 'VendorPriceRateNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPriceRateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VendorPriceRateNode` and its cursor. */
export type VendorPriceRateNodeEdge = {
  __typename: 'VendorPriceRateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorPriceRateNode>;
};

export type VendorProfileNode = Node & {
  __typename: 'VendorProfileNode';
  afterHoursDispatchSetting: AfterHoursDispatchSetting;
  afterHoursPhone: Scalars['String']['output'];
  anticipatedStandardPayoutDays: Maybe<Scalars['Int']['output']>;
  businessHoursJson: Maybe<Scalars['String']['output']>;
  businessType: Maybe<VendorBusinessType>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  dateOfBirth: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  favoritedBrands: Maybe<Array<BrandNode>>;
  hasConfirmedRequiredInfo: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inheritedPaymentTerms: Maybe<Scalars['Int']['output']>;
  invoicingVersion: InvoicingVersion;
  isAutoApproveEligible: Maybe<Scalars['Boolean']['output']>;
  isChowboticsPartner: Scalars['Boolean']['output'];
  isOperatingAreaRestricted: Maybe<Scalars['Boolean']['output']>;
  isVerified: Scalars['Boolean']['output'];
  lastResort: Scalars['Boolean']['output'];
  legalFirstName: Maybe<Scalars['String']['output']>;
  legalLastName: Maybe<Scalars['String']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  marketplacePaymentTerms: Maybe<Scalars['Int']['output']>;
  onboarded: Scalars['Boolean']['output'];
  openToMarketplace: Scalars['Boolean']['output'];
  operatingMarkets: Maybe<Array<MarketNode>>;
  /** Text field for vendor payment instructions */
  paymentInstructions: Maybe<Scalars['String']['output']>;
  paymentTerms: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  priceRates: Maybe<Array<VendorPriceRateNode>>;
  receptionistEnabledAt: Maybe<Scalars['DateTime']['output']>;
  receptionistEnabledType: ReceptionistEnabledType;
  receptionistGuidance: Maybe<VendorReceptionistGuidanceType>;
  receptionistGuidanceEnabled: Scalars['Boolean']['output'];
  receptionistPhone: Maybe<Scalars['String']['output']>;
  receptionistTransferType: ReceptionistTransferType;
  remittanceEmailAddresses: Array<Scalars['String']['output']>;
  schedulesInApp: Scalars['Boolean']['output'];
  servicedOperatingAreas: Array<OperatingAreaNode>;
  servicedOperatingAreasCount: Scalars['Int']['output'];
  skills: Array<SkillNode>;
  status: VendorStatus;
  taxIdType: Maybe<VendorTaxIdType>;
  taxRegistrationNumber: Scalars['String']['output'];
  vendorPerformanceProfile: Maybe<VendorPerformanceProfile>;
  website: Maybe<Scalars['String']['output']>;
};

export type VendorPromoEmailRecipientInput = {
  body: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type VendorPromotionNode = Node & {
  __typename: 'VendorPromotionNode';
  audienceType: AudienceType;
  discountType: DiscountType;
  discountValue: Scalars['Decimal']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  limitCount: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  promotionType: PromotionType;
  serviceCategory: ServiceCategory;
  timesClaimed: Scalars['Int']['output'];
  timesViewed: Scalars['Int']['output'];
  usageLimitType: UsageLimitType;
  validUntil: Maybe<Scalars['DateTime']['output']>;
  vendor: Maybe<VendorOrganizationNode>;
};

export type VendorPromotionNodeConnection = {
  __typename: 'VendorPromotionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPromotionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorPromotionNode` and its cursor. */
export type VendorPromotionNodeEdge = {
  __typename: 'VendorPromotionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorPromotionNode>;
};

export type VendorRankingEntryNode = Node & {
  __typename: 'VendorRankingEntryNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Optional notes for this vendor in this ranking */
  notes: Scalars['String']['output'];
  /** 1-based position (1 = highest priority) */
  position: Scalars['Int']['output'];
  ranking: Maybe<VendorRankingNode>;
  updatedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
};

export type VendorRankingForEquipmentNode = Node & {
  __typename: 'VendorRankingForEquipmentNode';
  createdAt: Scalars['DateTime']['output'];
  equipment: Maybe<EquipmentNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  ranking: Maybe<VendorRankingNode>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VendorRankingForFacilityAndServiceCategoryNode = Node & {
  __typename: 'VendorRankingForFacilityAndServiceCategoryNode';
  facilityGroup: Maybe<FacilityGroupNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  permissions: VendorRankingForFacilityAndServiceCategoryPermissions;
  ranking: VendorRankingNode;
  serviceCategory: ServiceCategory;
};

export type VendorRankingForFacilityAndServiceCategoryNodeConnection = {
  __typename: 'VendorRankingForFacilityAndServiceCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorRankingForFacilityAndServiceCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorRankingForFacilityAndServiceCategoryNode` and its cursor. */
export type VendorRankingForFacilityAndServiceCategoryNodeEdge = {
  __typename: 'VendorRankingForFacilityAndServiceCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorRankingForFacilityAndServiceCategoryNode>;
};

export type VendorRankingForFacilityAndServiceCategoryPermissions = {
  __typename: 'VendorRankingForFacilityAndServiceCategoryPermissions';
  edit: Scalars['Boolean']['output'];
};

export type VendorRankingNode = Node & {
  __typename: 'VendorRankingNode';
  client: Maybe<ClientOrganizationNode>;
  createdAt: Scalars['DateTime']['output'];
  entries: Maybe<Array<Maybe<VendorRankingEntryNode>>>;
  equipmentContext: Maybe<VendorRankingForEquipmentNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  orderedVendorIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  primaryVendorId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vendorCount: Maybe<Scalars['Int']['output']>;
};

export type VendorReceptionistAnswerGuidanceItemInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type VendorReceptionistAnswerGuidanceItemType = {
  __typename: 'VendorReceptionistAnswerGuidanceItemType';
  answer: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type VendorReceptionistGuidanceType = {
  __typename: 'VendorReceptionistGuidanceType';
  additionalInstructions: Maybe<Scalars['String']['output']>;
  answerGuidance: Array<VendorReceptionistAnswerGuidanceItemType>;
  businessSummary: Maybe<Scalars['String']['output']>;
  businessSummaryOverride: Maybe<Scalars['String']['output']>;
  callTransferInstructions: Maybe<Scalars['String']['output']>;
  diagnosisInstructions: Maybe<Scalars['String']['output']>;
  emergencyIdentificationInstructions: Maybe<Scalars['String']['output']>;
  emergencyPolicy: Maybe<Scalars['String']['output']>;
  equipmentBrandsSummary: Maybe<Scalars['String']['output']>;
  escalationRules: Maybe<Scalars['String']['output']>;
  faqs: Maybe<Scalars['String']['output']>;
  pricingInstructions: Maybe<Scalars['String']['output']>;
  promiseBoundaries: Maybe<Scalars['String']['output']>;
  quoteAndSchedulingPolicy: Maybe<Scalars['String']['output']>;
  schedulingInstructions: Maybe<Scalars['String']['output']>;
  serviceExclusions: Maybe<Scalars['String']['output']>;
  serviceRequestAdditionalQuestions: Maybe<Scalars['String']['output']>;
  serviceRequestTroubleshootingSteps: Maybe<Scalars['String']['output']>;
  servicesOfferedSummary: Maybe<Scalars['String']['output']>;
  transferRuleOverrides: Maybe<Scalars['String']['output']>;
  websitePrefillDraft: Maybe<VendorReceptionistWebsitePrefillDraftType>;
  websitePrefillError: Maybe<Scalars['String']['output']>;
  websitePrefillGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  websitePrefillSourceUrl: Maybe<Scalars['String']['output']>;
  websitePrefillStatus: Maybe<Scalars['String']['output']>;
};

export type VendorReceptionistWebsitePrefillDraftType = {
  __typename: 'VendorReceptionistWebsitePrefillDraftType';
  additionalInstructions: Maybe<Scalars['String']['output']>;
  businessSummary: Maybe<Scalars['String']['output']>;
  emergencyPolicy: Maybe<Scalars['String']['output']>;
  equipmentBrandsSummary: Maybe<Scalars['String']['output']>;
  escalationRules: Maybe<Scalars['String']['output']>;
  faqs: Maybe<Scalars['String']['output']>;
  promiseBoundaries: Maybe<Scalars['String']['output']>;
  quoteAndSchedulingPolicy: Maybe<Scalars['String']['output']>;
  serviceExclusions: Maybe<Scalars['String']['output']>;
  servicesOfferedSummary: Maybe<Scalars['String']['output']>;
  sourcePages: Maybe<Array<VendorReceptionistWebsitePrefillSourcePageType>>;
};

export type VendorReceptionistWebsitePrefillSourcePageType = {
  __typename: 'VendorReceptionistWebsitePrefillSourcePageType';
  title: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** An enumeration. */
export enum VendorReportFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type VendorReportNode = Node & {
  __typename: 'VendorReportNode';
  csvUrl: Maybe<Scalars['String']['output']>;
  /** The end date of the range this report was generated for. */
  endDate: Scalars['Date']['output'];
  /** The date this report was generated and sent out. */
  generatedOn: Scalars['Date']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reportType: VendorReportType;
  /** The start date of the range this report was generated for. */
  startDate: Scalars['Date']['output'];
};

export type VendorReportNodeConnection = {
  __typename: 'VendorReportNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorReportNode` and its cursor. */
export type VendorReportNodeEdge = {
  __typename: 'VendorReportNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorReportNode>;
};

export type VendorReportScheduleNode = Node & {
  __typename: 'VendorReportScheduleNode';
  frequency: VendorReportFrequency;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastReportOn: Maybe<Scalars['Date']['output']>;
  nextReportOn: Maybe<Scalars['Date']['output']>;
  recipientEmailAddresses: Array<Scalars['String']['output']>;
  reportType: VendorReportType;
};

export type VendorReportScheduleNodeConnection = {
  __typename: 'VendorReportScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorReportScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorReportScheduleNode` and its cursor. */
export type VendorReportScheduleNodeEdge = {
  __typename: 'VendorReportScheduleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorReportScheduleNode>;
};

/** An enumeration. */
export enum VendorReportType {
  InvoiceSummary = 'INVOICE_SUMMARY',
  MaintenancePlanSummary = 'MAINTENANCE_PLAN_SUMMARY',
  WorkOrderSummary = 'WORK_ORDER_SUMMARY'
}

export type VendorRevenueShareNode = Node & {
  __typename: 'VendorRevenueShareNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  labourPercentage: Maybe<Scalars['Decimal']['output']>;
  otherPercentage: Maybe<Scalars['Decimal']['output']>;
  partsPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCallPercentage: Maybe<Scalars['Decimal']['output']>;
  serviceCategory: ServiceCategory;
  travelPercentage: Maybe<Scalars['Decimal']['output']>;
  truckPercentage: Maybe<Scalars['Decimal']['output']>;
  vendor: VendorOrganizationNode;
};

export type VendorRevenueShareNodeConnection = {
  __typename: 'VendorRevenueShareNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorRevenueShareNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorRevenueShareNode` and its cursor. */
export type VendorRevenueShareNodeEdge = {
  __typename: 'VendorRevenueShareNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorRevenueShareNode>;
};

export type VendorReviewSummary = {
  __typename: 'VendorReviewSummary';
  negativeReviewCount: Scalars['Int']['output'];
  positiveReviewCount: Scalars['Int']['output'];
  topVendorNegativeFeedback: Array<TopVendorReviewFeedback>;
  topVendorPositiveFeedback: Array<TopVendorReviewFeedback>;
};

export type VendorScoreSummary = {
  __typename: 'VendorScoreSummary';
  score: Maybe<Scalars['Decimal']['output']>;
  scoreChange: Maybe<Scalars['Decimal']['output']>;
};

export type VendorSlaChecklistItemType = {
  __typename: 'VendorSlaChecklistItemType';
  actualLabel: Maybe<Scalars['String']['output']>;
  ruleKey: Scalars['String']['output'];
  status: VendorSlaStatus;
  title: Scalars['String']['output'];
};

export type VendorSlaChecklistType = {
  __typename: 'VendorSlaChecklistType';
  contractorVendor: Maybe<VendorOrganizationNode>;
  hasConfiguredRules: Scalars['Boolean']['output'];
  items: Array<VendorSlaChecklistItemType>;
  subjectVendor: VendorOrganizationNode;
};

export type VendorSlaPolicyRuleType = {
  __typename: 'VendorSlaPolicyRuleType';
  displayOrder: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  params: Scalars['GenericScalar']['output'];
  ruleKey: Scalars['String']['output'];
  ruleVersion: Scalars['Int']['output'];
  signalTypes: Array<VendorSlaSignalType>;
  targetFamilies: Array<VendorSlaTargetFamily>;
  title: Scalars['String']['output'];
};

/** An enumeration. */
export enum VendorSlaPolicyScopeMode {
  ApplyRules = 'APPLY_RULES',
  SuppressGlobalDefault = 'SUPPRESS_GLOBAL_DEFAULT'
}

/** An enumeration. */
export enum VendorSlaPolicyScopeType {
  ContractorSubcontractor = 'CONTRACTOR_SUBCONTRACTOR',
  GlobalDefault = 'GLOBAL_DEFAULT'
}

export type VendorSlaPolicyVersionType = {
  __typename: 'VendorSlaPolicyVersionType';
  changeSummary: Scalars['String']['output'];
  contractorVendorId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  rules: Array<VendorSlaPolicyRuleType>;
  scopeMode: VendorSlaPolicyScopeMode;
  scopeType: VendorSlaPolicyScopeType;
  subjectVendorId: Maybe<Scalars['ID']['output']>;
  version: Scalars['Int']['output'];
};

export type VendorSlaRuleCatalogRuleType = {
  __typename: 'VendorSlaRuleCatalogRuleType';
  defaultEnabled: Scalars['Boolean']['output'];
  defaultParams: Scalars['GenericScalar']['output'];
  key: Scalars['String']['output'];
  paramsSchema: Scalars['GenericScalar']['output'];
  signalTypes: Array<VendorSlaSignalType>;
  supportedTargetFamilies: Array<VendorSlaTargetFamily>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** An enumeration. */
export enum VendorSlaSignalType {
  AppointmentCanceled = 'APPOINTMENT_CANCELED',
  AppointmentCreated = 'APPOINTMENT_CREATED',
  AppointmentRescheduled = 'APPOINTMENT_RESCHEDULED',
  ArrivalNoticeSent = 'ARRIVAL_NOTICE_SENT',
  DeadlineReached = 'DEADLINE_REACHED',
  DispatchReceived = 'DISPATCH_RECEIVED',
  EstimateSubmitted = 'ESTIMATE_SUBMITTED',
  InvoiceSubmitted = 'INVOICE_SUBMITTED',
  VendorAssigned = 'VENDOR_ASSIGNED',
  VisitEnded = 'VISIT_ENDED',
  VisitStarted = 'VISIT_STARTED',
  VisitUpdated = 'VISIT_UPDATED',
  WorkOrderNoteCreated = 'WORK_ORDER_NOTE_CREATED'
}

/** An enumeration. */
export enum VendorSlaStatus {
  Failed = 'FAILED',
  InsufficientData = 'INSUFFICIENT_DATA',
  NotApplicable = 'NOT_APPLICABLE',
  Passed = 'PASSED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum VendorSlaTargetFamily {
  OffResqAppointmentVisit = 'OFF_RESQ_APPOINTMENT_VISIT',
  OffResqWorkOrder = 'OFF_RESQ_WORK_ORDER',
  OnResqVisit = 'ON_RESQ_VISIT',
  OnResqWorkOrder = 'ON_RESQ_WORK_ORDER'
}

/** An enumeration. */
export enum VendorStatus {
  Active = 'ACTIVE',
  AgreementPending = 'AGREEMENT_PENDING',
  Deactivated = 'DEACTIVATED',
  Declined = 'DECLINED',
  New = 'NEW',
  Paused = 'PAUSED',
  PendingInviteAccepted = 'PENDING_INVITE_ACCEPTED'
}

export type VendorSubcontractPairingScopeInput = {
  marketId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
};

export type VendorSubcontractPairingScopeType = {
  __typename: 'VendorSubcontractPairingScopeType';
  id: Scalars['Int']['output'];
  market: MarketNode;
  serviceCategory: ServiceCategory;
};

export type VendorSubcontractPairingShareTierInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  maxInvoiceAmount?: InputMaybe<Scalars['Decimal']['input']>;
  minInvoiceAmount: Scalars['Decimal']['input'];
  serviceCategory?: InputMaybe<ServiceCategory>;
  subcontractorSharePercentage: Scalars['Decimal']['input'];
};

export enum VendorSubcontractPairingStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type VendorSubcontractPairingTierNode = Node & {
  __typename: 'VendorSubcontractPairingTierNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  legacyId: Scalars['Int']['output'];
  maxInvoiceAmount: Maybe<Scalars['Decimal']['output']>;
  minInvoiceAmount: Scalars['Decimal']['output'];
  serviceCategory: Maybe<ServiceCategory>;
  subcontractorSharePercentage: Scalars['Decimal']['output'];
};

export type VendorSubcontractPairingType = Node & {
  __typename: 'VendorSubcontractPairingType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
  parentVendor: VendorOrganizationNode;
  paymentTermDays: Maybe<Scalars['Int']['output']>;
  revokedAt: Maybe<Scalars['DateTime']['output']>;
  revokedReason: Maybe<Scalars['String']['output']>;
  scopes: Array<VendorSubcontractPairingScopeType>;
  shareTiers: Array<VendorSubcontractPairingTierNode>;
  status: VendorSubcontractPairingStatus;
  subcontractVendor: VendorOrganizationNode;
  subcontractorSharePercentage: Maybe<Scalars['Decimal']['output']>;
};

export type VendorTosAgreementNode = Node & {
  __typename: 'VendorTOSAgreementNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  vendor: VendorOrganizationNode;
};

/** An enumeration. */
export enum VendorTaxIdType {
  Ein = 'EIN',
  Tin = 'TIN'
}

/** An enumeration. */
export enum VendorTier {
  VendorTier_1 = 'VENDOR_TIER_1',
  VendorTier_2 = 'VENDOR_TIER_2',
  VendorTier_3 = 'VENDOR_TIER_3'
}

export type VendorTradeQualificationNode = Node & {
  __typename: 'VendorTradeQualificationNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  serviceCategory: ServiceCategory;
};

export type VendorWebsiteAnalyticsOverview = {
  __typename: 'VendorWebsiteAnalyticsOverview';
  endAt: Scalars['Float']['output'];
  pageviews: VendorWebsiteAnalyticsSeries;
  startAt: Scalars['Float']['output'];
  stats: VendorWebsiteAnalyticsStats;
  websiteUuid: Scalars['UUID']['output'];
};

export type VendorWebsiteAnalyticsPoint = {
  __typename: 'VendorWebsiteAnalyticsPoint';
  x: Scalars['String']['output'];
  y: Scalars['Int']['output'];
};

export type VendorWebsiteAnalyticsSeries = {
  __typename: 'VendorWebsiteAnalyticsSeries';
  pageviews: Array<VendorWebsiteAnalyticsPoint>;
  sessions: Array<VendorWebsiteAnalyticsPoint>;
};

export type VendorWebsiteAnalyticsStats = {
  __typename: 'VendorWebsiteAnalyticsStats';
  bounces: Scalars['Int']['output'];
  pageviews: Scalars['Int']['output'];
  totaltime: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
};

export type VendorWebsiteBuilderSurveyNode = Node & {
  __typename: 'VendorWebsiteBuilderSurveyNode';
  afterHoursPhone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasDifferentAfterHoursNumber: Scalars['Boolean']['output'];
  hasWebsite: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  providesTwentyFourSevenService: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usesAfterHoursService: Scalars['Boolean']['output'];
  websiteUrl: Maybe<Scalars['String']['output']>;
};

export type VendorWebsiteMonitorDomainType = {
  __typename: 'VendorWebsiteMonitorDomainType';
  buildStatus: Maybe<Scalars['String']['output']>;
  buildTone: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  firstUrlGeneratedAt: Maybe<Scalars['String']['output']>;
  liveRevisionPublishedAt: Maybe<Scalars['String']['output']>;
  provisioningState: Scalars['String']['output'];
  provisioningTone: Scalars['String']['output'];
  reasonCode: Maybe<Scalars['String']['output']>;
  redirectTo: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  searchConsoleLastAttemptAt: Maybe<Scalars['String']['output']>;
  searchConsoleLastErrorCode: Maybe<Scalars['String']['output']>;
  searchConsoleLastErrorMessage: Maybe<Scalars['String']['output']>;
  searchConsoleStatus: Maybe<Scalars['String']['output']>;
  searchConsoleVerifiedAt: Maybe<Scalars['String']['output']>;
  stateUpdatedAt: Maybe<Scalars['String']['output']>;
  templateId: Maybe<Scalars['String']['output']>;
  templateName: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  websiteUuid: Maybe<Scalars['String']['output']>;
};

export type VendorWebsiteMonitorHealthActionItemType = {
  __typename: 'VendorWebsiteMonitorHealthActionItemType';
  code: Scalars['String']['output'];
  count: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  tone: Scalars['String']['output'];
};

export type VendorWebsiteMonitorInventoryConnection = {
  __typename: 'VendorWebsiteMonitorInventoryConnection';
  criticalCount: Scalars['Int']['output'];
  edges: Array<VendorWebsiteMonitorInventoryEdgeType>;
  healthyCount: Scalars['Int']['output'];
  matchedCount: Scalars['Int']['output'];
  pageInfo: VendorWebsiteMonitorInventoryPageInfoType;
  totalCount: Scalars['Int']['output'];
  unmatchedCount: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type VendorWebsiteMonitorInventoryEdgeType = {
  __typename: 'VendorWebsiteMonitorInventoryEdgeType';
  cursor: Scalars['String']['output'];
  node: Maybe<VendorWebsiteMonitorInventoryRowType>;
};

export type VendorWebsiteMonitorInventoryPageInfoType = {
  __typename: 'VendorWebsiteMonitorInventoryPageInfoType';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type VendorWebsiteMonitorInventoryRowType = {
  __typename: 'VendorWebsiteMonitorInventoryRowType';
  buildStatus: Maybe<Scalars['String']['output']>;
  buildTone: Scalars['String']['output'];
  builderMatchStatus: Scalars['String']['output'];
  builderMatchStatusTone: Scalars['String']['output'];
  canonicalDomain: Maybe<Scalars['String']['output']>;
  daysSincePublish: Maybe<Scalars['Int']['output']>;
  domains: Array<VendorWebsiteMonitorDomainType>;
  domainsAttached: Scalars['Int']['output'];
  googleBusinessConnected: Scalars['Boolean']['output'];
  healthActionItems: Array<VendorWebsiteMonitorHealthActionItemType>;
  liveRevisionPublishedAt: Maybe<Scalars['String']['output']>;
  matchedSiteBuilderRecord: Scalars['Boolean']['output'];
  overallStatus: Scalars['String']['output'];
  overallStatusTone: Scalars['String']['output'];
  primaryDomain: Maybe<Scalars['String']['output']>;
  provisioningState: Maybe<Scalars['String']['output']>;
  provisioningTone: Scalars['String']['output'];
  reasonCode: Maybe<Scalars['String']['output']>;
  redirectStatus: Scalars['String']['output'];
  redirectStatusTone: Scalars['String']['output'];
  sourceSiteRef: Maybe<Scalars['String']['output']>;
  templateName: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['Int']['output'];
  vendorName: Scalars['String']['output'];
  vendorOwnerUserId: Maybe<Scalars['ID']['output']>;
  vendorTrackingId: Maybe<Scalars['Int']['output']>;
  websiteName: Scalars['String']['output'];
  websiteUuid: Scalars['UUID']['output'];
};

export type VendorWebsiteNode = Node & {
  __typename: 'VendorWebsiteNode';
  campaigns: Array<WebsiteAdvertisingCampaignType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserNode>;
  googleAds: GoogleAdsStateType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryDomain: Maybe<Scalars['String']['output']>;
  sourceSiteRef: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<UserNode>;
  vendor: Maybe<VendorOrganizationNode>;
  websiteUuid: Scalars['UUID']['output'];
};

export type VendorWebsiteNodeConnection = {
  __typename: 'VendorWebsiteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorWebsiteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorWebsiteNode` and its cursor. */
export type VendorWebsiteNodeEdge = {
  __typename: 'VendorWebsiteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorWebsiteNode>;
};

export type VendorWebsiteSearchConsoleAuditDataType = {
  __typename: 'VendorWebsiteSearchConsoleAuditDataType';
  inspection: Maybe<VendorWebsiteSearchConsoleInspectionType>;
  inspectionUrl: Scalars['String']['output'];
  permissionLevel: Maybe<Scalars['String']['output']>;
  siteUrl: Scalars['String']['output'];
  sitemaps: Array<VendorWebsiteSearchConsoleSitemapType>;
};

export type VendorWebsiteSearchConsoleAuditType = {
  __typename: 'VendorWebsiteSearchConsoleAuditType';
  audit: VendorWebsiteSearchConsoleAuditDataType;
  domain: Scalars['String']['output'];
  searchConsoleLastAttemptAt: Maybe<Scalars['String']['output']>;
  searchConsoleLastErrorCode: Maybe<Scalars['String']['output']>;
  searchConsoleLastErrorMessage: Maybe<Scalars['String']['output']>;
  searchConsoleStatus: Maybe<Scalars['String']['output']>;
  searchConsoleVerifiedAt: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type VendorWebsiteSearchConsoleInspectionType = {
  __typename: 'VendorWebsiteSearchConsoleInspectionType';
  ampVerdict: Maybe<Scalars['String']['output']>;
  coverageState: Maybe<Scalars['String']['output']>;
  crawledAs: Maybe<Scalars['String']['output']>;
  googleCanonical: Maybe<Scalars['String']['output']>;
  indexingState: Maybe<Scalars['String']['output']>;
  inspectionResultLink: Maybe<Scalars['String']['output']>;
  issues: Array<VendorWebsiteSearchConsoleIssueType>;
  lastCrawlTime: Maybe<Scalars['String']['output']>;
  mobileUsabilityVerdict: Maybe<Scalars['String']['output']>;
  pageFetchState: Maybe<Scalars['String']['output']>;
  referringUrls: Array<Scalars['String']['output']>;
  richResultsVerdict: Maybe<Scalars['String']['output']>;
  robotsTxtState: Maybe<Scalars['String']['output']>;
  sitemap: Array<Scalars['String']['output']>;
  userCanonical: Maybe<Scalars['String']['output']>;
  verdict: Maybe<Scalars['String']['output']>;
};

export type VendorWebsiteSearchConsoleIssueType = {
  __typename: 'VendorWebsiteSearchConsoleIssueType';
  issueType: Maybe<Scalars['String']['output']>;
  itemName: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  richResultType: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type VendorWebsiteSearchConsoleSitemapType = {
  __typename: 'VendorWebsiteSearchConsoleSitemapType';
  errors: Maybe<Scalars['String']['output']>;
  isPending: Maybe<Scalars['Boolean']['output']>;
  isSitemapsIndex: Maybe<Scalars['Boolean']['output']>;
  lastDownloaded: Maybe<Scalars['String']['output']>;
  lastSubmitted: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  warnings: Maybe<Scalars['String']['output']>;
};

export type VendorWorkOrderInternalNoteNode = Node & {
  __typename: 'VendorWorkOrderInternalNoteNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserNode>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  offResqWorkOrderId: Maybe<Scalars['Int']['output']>;
  permissions: VendorWorkOrderInternalNotePermissions;
  vendorId: Scalars['Int']['output'];
  workOrderId: Maybe<Scalars['Int']['output']>;
};

export type VendorWorkOrderInternalNoteNodeConnection = {
  __typename: 'VendorWorkOrderInternalNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorWorkOrderInternalNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VendorWorkOrderInternalNoteNode` and its cursor. */
export type VendorWorkOrderInternalNoteNodeEdge = {
  __typename: 'VendorWorkOrderInternalNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VendorWorkOrderInternalNoteNode>;
};

export type VendorWorkOrderInternalNotePermissions = {
  __typename: 'VendorWorkOrderInternalNotePermissions';
  /** Permission to delete a vendor internal note */
  deleteNote: Scalars['Boolean']['output'];
};

export type VerifiedVendorNode = Node & {
  __typename: 'VerifiedVendorNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  market: Maybe<MarketNode>;
  serviceCategory: Maybe<VerifiedVendorServiceCategory>;
  validFrom: Maybe<Scalars['DateTime']['output']>;
  validTo: Maybe<Scalars['DateTime']['output']>;
};

export type VerifiedVendorNodeConnection = {
  __typename: 'VerifiedVendorNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VerifiedVendorNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VerifiedVendorNode` and its cursor. */
export type VerifiedVendorNodeEdge = {
  __typename: 'VerifiedVendorNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VerifiedVendorNode>;
};

/** An enumeration. */
export enum VerifiedVendorServiceCategory {
  /** Accessibility & Hardware */
  AccessibilityHardware = 'ACCESSIBILITY_HARDWARE',
  /** Air Compressors */
  AirCompressors = 'AIR_COMPRESSORS',
  /** Architect/Design */
  ArchitectDesign = 'ARCHITECT_DESIGN',
  /** Asbestos */
  Asbestos = 'ASBESTOS',
  /** Audits */
  Audits = 'AUDITS',
  /** Awaiting Categorization */
  AwaitingCategorization = 'AWAITING_CATEGORIZATION',
  /** Backflow */
  Backflow = 'BACKFLOW',
  /** Beverage Equipment */
  BeverageEquipment = 'BEVERAGE_EQUIPMENT',
  /** Bowling Equipment */
  BowlingEquipment = 'BOWLING_EQUIPMENT',
  /** Burglar Alarm */
  BurglarAlarm = 'BURGLAR_ALARM',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Chowbotics */
  Chowbotics = 'CHOWBOTICS',
  /** Cleaning */
  Cleaning = 'CLEANING',
  /** Closed Circuit Television */
  ClosedCircuitTelevision = 'CLOSED_CIRCUIT_TELEVISION',
  /** CO2 */
  Co2 = 'CO2',
  /** Coffee */
  Coffee = 'COFFEE',
  /** Consumables & Replenishment */
  ConsumablesReplenishment = 'CONSUMABLES_REPLENISHMENT',
  /** Cutting Board Resurfacing */
  CuttingBoardResurfacing = 'CUTTING_BOARD_RESURFACING',
  /** Drive Thru Items */
  DriveThuItems = 'DRIVE_THU_ITEMS',
  /** Electrical */
  Electrical = 'ELECTRICAL',
  /** Elevators & Dumbwaiters */
  ElevatorsDumbwaiters = 'ELEVATORS_DUMBWAITERS',
  /** EMERGENCY_LIGHTS */
  EmergencyLights = 'EMERGENCY_LIGHTS',
  /** Environmental Consulting */
  EnvironmentalConsulting = 'ENVIRONMENTAL_CONSULTING',
  /** Equipment Leasing */
  EquipmentLeasing = 'EQUIPMENT_LEASING',
  /** Fire Alarms */
  FireAlarms = 'FIRE_ALARMS',
  /** Fire Suppression */
  FireSuppression = 'FIRE_SUPPRESSION',
  /** FIXTURES */
  Fixtures = 'FIXTURES',
  /** Flooring */
  Flooring = 'FLOORING',
  /** Food Equipment */
  FoodEquipment = 'FOOD_EQUIPMENT',
  /** Fuel Oil */
  FuelOil = 'FUEL_OIL',
  /** Furniture */
  Furniture = 'FURNITURE',
  /** Gaskets */
  Gaskets = 'GASKETS',
  /** Gas & Boilers */
  GasBoilers = 'GAS_BOILERS',
  /** General Contracting */
  GeneralContracting = 'GENERAL_CONTRACTING',
  /** General Repair/Handywork */
  GeneralRepairHandywork = 'GENERAL_REPAIR_HANDYWORK',
  /** Generators & Power Supply */
  Generators = 'GENERATORS',
  /** Grease Traps */
  GreaseTrap = 'GREASE_TRAP',
  /** Gym Equipment */
  GymEquipment = 'GYM_EQUIPMENT',
  /** Heating & Cooling/HVAC */
  HeatingCoolingHvac = 'HEATING_COOLING_HVAC',
  /** Hoods */
  Hoods = 'HOODS',
  /** Hospitality */
  Hospitality = 'HOSPITALITY',
  /** Hot Water Systems */
  HotWaterTank = 'HOT_WATER_TANK',
  /** Ice Machines */
  IceMachine = 'ICE_MACHINE',
  /** Landscaping */
  Landscaping = 'LANDSCAPING',
  /** Locks & Doors */
  LocksDoors = 'LOCKS_DOORS',
  /** Medical Equipment */
  MedicalEquipment = 'MEDICAL_EQUIPMENT',
  /** Menu Screens */
  MenuScreens = 'MENU_SCREENS',
  /** Messenger Services */
  MessengerServices = 'MESSENGER_SERVICES',
  /** Millwork */
  Millwork = 'MILLWORK',
  /** Miscellaneous */
  Miscellaneous = 'MISCELLANEOUS',
  /** Moving Services */
  MovingServices = 'MOVING_SERVICES',
  /** Pack Screens */
  PackScreens = 'PACK_SCREENS',
  /** Painting */
  Painting = 'PAINTING',
  /** Parts/Supply Order */
  PartsSupplyOrder = 'PARTS_SUPPLY_ORDER',
  /** Pavement */
  Pavement = 'PAVEMENT',
  /** Pest Control */
  PestControl = 'PEST_CONTROL',
  /** Planned Project */
  PlannedProject = 'PLANNED_PROJECT',
  /** Plumbing */
  Plumbing = 'PLUMBING',
  /** Refrigeration */
  Refrigeration = 'REFRIGERATION',
  /** Roofing */
  Roofing = 'ROOFING',
  /** Room Setup / Take Down */
  RoomSetupTakeDown = 'ROOM_SETUP_TAKE_DOWN',
  /** Security */
  Security = 'SECURITY',
  /** Shredding */
  Shredding = 'SHREDDING',
  /** Signage */
  Signage = 'SIGNAGE',
  /** Snow Removal */
  SnowRemoval = 'SNOW_REMOVAL',
  /** Soda/Beer */
  SodaBeer = 'SODA_BEER',
  /** Spa Equipment */
  SpaEquipment = 'SPA_EQUIPMENT',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Temp Services */
  TempServices = 'TEMP_SERVICES',
  /** Tiling */
  Tiling = 'TILING',
  /** Uniforms & Laundry */
  UniformsLaundry = 'UNIFORMS_LAUNDRY',
  /** Upholstery */
  Upholstery = 'UPHOLSTERY',
  /** Vending Machines */
  VendingMachines = 'VENDING_MACHINES',
  /** Ware Washing Equipment */
  WareWashingEquipment = 'WARE_WASHING_EQUIPMENT',
  /** Waste Removal */
  WasteRemoval = 'WASTE_REMOVAL',
  /** Water Treatment */
  WaterFiltration = 'WATER_FILTRATION',
  /** Welding */
  Welding = 'WELDING',
  /** Windows, Doors & Locks */
  WindowsDoorsLocks = 'WINDOWS_DOORS_LOCKS',
  /** Windows & Glass */
  WindowsGlass = 'WINDOWS_GLASS'
}

export type VerifyBusinessUnitAddressNode = Node & {
  __typename: 'VerifyBusinessUnitAddressNode';
  addressesMatch: Scalars['Boolean']['output'];
  businessUnit: BusinessUnitNode;
  id: Scalars['ID']['output'];
  isOverridden: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  validationMessages: Array<Maybe<Scalars['String']['output']>>;
};

export type VerifyFacilityAddressNode = Node & {
  __typename: 'VerifyFacilityAddressNode';
  addressesMatch: Scalars['Boolean']['output'];
  facility: FacilityNode;
  id: Scalars['ID']['output'];
  isOverridden: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  validationMessages: Array<Maybe<Scalars['String']['output']>>;
};

export type VerifyLocationAddressNode = Node & {
  __typename: 'VerifyLocationAddressNode';
  addressesMatch: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  recommendedAddress: Maybe<AddressNode>;
  validationMessages: Array<Maybe<Scalars['String']['output']>>;
};

export type VerifyOrganizationAddressesNode = Node & {
  __typename: 'VerifyOrganizationAddressesNode';
  businessUnitAddressResolutions: Array<VerifyBusinessUnitAddressNode>;
  facilityAddressResolutions: Array<VerifyFacilityAddressNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type VisitNode = Node & {
  __typename: 'VisitNode';
  afterImages: Array<ImageNode>;
  appointment: Maybe<AppointmentNode>;
  beforeImages: Array<ImageNode>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  facilityManagerName: Maybe<Scalars['String']['output']>;
  facilityManagerSignatureUrl: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  outcome: Maybe<VisitOutcome>;
  permissions: VisitPermissions;
  recommendations: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  vendor: Maybe<VendorOrganizationNode>;
  visitedBy: Maybe<UserNode>;
};

export type VisitNodeConnection = {
  __typename: 'VisitNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VisitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VisitNode` and its cursor. */
export type VisitNodeEdge = {
  __typename: 'VisitNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VisitNode>;
};

export enum VisitOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  PartsNeeded = 'PARTS_NEEDED',
  PutOnHold = 'PUT_ON_HOLD',
  QuoteNeeded = 'QUOTE_NEEDED',
  SchedulingRequired = 'SCHEDULING_REQUIRED'
}

export type VisitPermissions = {
  __typename: 'VisitPermissions';
  /** Permission to end the visit. */
  end: Scalars['Boolean']['output'];
  /** Permission to schedule the next appointment when ending the visit. */
  scheduleNextAppointment: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum VisitReviewOutcome {
  Completed = 'COMPLETED',
  NextVisitRequired = 'NEXT_VISIT_REQUIRED',
  NoVendor = 'NO_VENDOR',
  PartsNeeded = 'PARTS_NEEDED',
  QuoteNeeded = 'QUOTE_NEEDED'
}

export type VisitReviewRequestNode = Node & {
  __typename: 'VisitReviewRequestNode';
  appointment: Maybe<AppointmentNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  vendor: VendorOrganizationNode;
  workOrder: WorkOrderNode;
};

export type VisitReviewRequestNodeConnection = {
  __typename: 'VisitReviewRequestNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VisitReviewRequestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `VisitReviewRequestNode` and its cursor. */
export type VisitReviewRequestNodeEdge = {
  __typename: 'VisitReviewRequestNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<VisitReviewRequestNode>;
};

/** An enumeration. */
export enum VisitReviewRequestStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED'
}

export type VoidSubcontractSettlementInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subcontractSettlementInvoiceId: Scalars['ID']['input'];
  voidReason: Scalars['String']['input'];
};

export type VoidSubcontractSettlementInvoiceMutationPayload = {
  __typename: 'VoidSubcontractSettlementInvoiceMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  subcontractSettlementInvoice: SubcontractSettlementInvoiceNode;
};

export type VoidSubcontractSettlementInvoicesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subcontractSettlementInvoiceIds: Array<Scalars['ID']['input']>;
  voidReason: Scalars['String']['input'];
};

export type VoidSubcontractSettlementInvoicesMutationPayload = {
  __typename: 'VoidSubcontractSettlementInvoicesMutationPayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  subcontractSettlementInvoices: Array<SubcontractSettlementInvoiceNode>;
};

export type VoidSubscriptionInvoiceMutationInput = {
  applyAsDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clientInvoiceId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type VoidSubscriptionInvoiceMutationPayload = {
  __typename: 'VoidSubscriptionInvoiceMutationPayload';
  clientInvoice: ClientInvoiceNode;
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum WebsiteAdvertisingAccountStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Disconnected = 'DISCONNECTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** How Google Ads funding is expected to work for this advertising account. */
export enum WebsiteAdvertisingBillingConfigFundingMode {
  MonthlyInvoicing = 'MONTHLY_INVOICING',
  StandardPayments = 'STANDARD_PAYMENTS'
}

/** An enumeration. */
export enum WebsiteAdvertisingCampaignActivationStatus {
  BillingSetupInProgress = 'BILLING_SETUP_IN_PROGRESS',
  Blocked = 'BLOCKED',
  ReadyToActivate = 'READY_TO_ACTIVATE'
}

/** An enumeration. */
export enum WebsiteAdvertisingCampaignProvider {
  GoogleAds = 'GOOGLE_ADS'
}

/** An enumeration. */
export enum WebsiteAdvertisingCampaignStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export type WebsiteAdvertisingCampaignType = {
  __typename: 'WebsiteAdvertisingCampaignType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  provider: WebsiteAdvertisingCampaignProvider;
  status: WebsiteAdvertisingCampaignStatus;
};

export type WorkOrderCancellationDetailNode = Node & {
  __typename: 'WorkOrderCancellationDetailNode';
  additionalDetails: Maybe<Scalars['String']['output']>;
  cancelReason: Maybe<WorkOrderCancellationReason>;
  cancelReasonDisplay: Maybe<Scalars['String']['output']>;
  cancellationReason: Maybe<WorkOrderCancellationReasonType>;
  cancelledOn: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  source: Maybe<WorkOrderCancellationSource>;
  workOrder: WorkOrderNode;
};

export type WorkOrderCancellationDetailNodeConnection = {
  __typename: 'WorkOrderCancellationDetailNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderCancellationDetailNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderCancellationDetailNode` and its cursor. */
export type WorkOrderCancellationDetailNodeEdge = {
  __typename: 'WorkOrderCancellationDetailNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderCancellationDetailNode>;
};

/** An enumeration. */
export enum WorkOrderCancellationReason {
  Duplicate = 'DUPLICATE',
  HandledByMaintenancePlan = 'HANDLED_BY_MAINTENANCE_PLAN',
  IssueNotHandledByResq = 'ISSUE_NOT_HANDLED_BY_RESQ',
  IssueResolved = 'ISSUE_RESOLVED',
  IssueWithQuote = 'ISSUE_WITH_QUOTE',
  NotRequested = 'NOT_REQUESTED',
  NoAvailableVendors = 'NO_AVAILABLE_VENDORS',
  Other = 'OTHER',
  SubmittedByMistake = 'SUBMITTED_BY_MISTAKE',
  VendorReassigned = 'VENDOR_REASSIGNED'
}

export type WorkOrderCancellationReasonType = {
  __typename: 'WorkOrderCancellationReasonType';
  key: WorkOrderCancellationReason;
  label: Scalars['String']['output'];
};

/** An enumeration. */
export enum WorkOrderCancellationSource {
  FacilityApp = 'FACILITY_APP',
  PartnerApp = 'PARTNER_APP',
  Pmc = 'PMC',
  Rcc = 'RCC',
  Rmc = 'RMC',
  System = 'SYSTEM'
}

export enum WorkOrderCancellationSourceEnum {
  Client = 'CLIENT',
  Resq = 'RESQ',
  Vendor = 'VENDOR'
}

export type WorkOrderClientInvoicesApprovalNode = Node & {
  __typename: 'WorkOrderClientInvoicesApprovalNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  user: UserNode;
};

export type WorkOrderCountsByCyovDispatches = {
  __typename: 'WorkOrderCountsByCYOVDispatches';
  additionalDispatches: Scalars['Int']['output'];
  firstDispatch: Scalars['Int']['output'];
  secondDispatch: Scalars['Int']['output'];
};

export type WorkOrderCountsByCoordinatorStatus = {
  __typename: 'WorkOrderCountsByCoordinatorStatus';
  awaitingAcceptance: Scalars['Int']['output'];
  awaitingAssignment: Scalars['Int']['output'];
  awaitingCompletion: Scalars['Int']['output'];
  awaitingFacilityApproval: Scalars['Int']['output'];
  awaitingPayment: Scalars['Int']['output'];
  awaitingRecordOfWork: Scalars['Int']['output'];
  awaitingResqApproval: Scalars['Int']['output'];
  awaitingScheduling: Scalars['Int']['output'];
  awaitingVendorPayout: Scalars['Int']['output'];
  awaitingVmApproval: Scalars['Int']['output'];
  missingVendorInvoice: Scalars['Int']['output'];
  multipleRecordsDraft: Scalars['Int']['output'];
  vendorClosed: Scalars['Int']['output'];
};

/** An enumeration. */
export enum WorkOrderCreationSource {
  Client = 'CLIENT',
  Resq = 'RESQ',
  Vendor = 'VENDOR'
}

export type WorkOrderEscalationNode = Node & {
  __typename: 'WorkOrderEscalationNode';
  assignedAt: Maybe<Scalars['DateTime']['output']>;
  assignedTo: Maybe<UserNode>;
  channel: Maybe<EscalationChannelType>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  escalatedBy: UserNode;
  escalationReason: Maybe<WorkOrderEscalationReasonType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  kustomerWorkOrderEscalation: Maybe<KustomerWorkOrderEscalationNode>;
  otherReason: Maybe<Scalars['String']['output']>;
  permissions: WorkOrderEscalationPermissions;
  reason: WorkOrderEscalationReason;
  resolutionComment: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Maybe<UserNode>;
  sourceOrgType: Maybe<WorkOrderEscalationSourceOrgType>;
  workOrder: WorkOrderNode;
};

export type WorkOrderEscalationNodeConnection = {
  __typename: 'WorkOrderEscalationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderEscalationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderEscalationNode` and its cursor. */
export type WorkOrderEscalationNodeEdge = {
  __typename: 'WorkOrderEscalationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderEscalationNode>;
};

export type WorkOrderEscalationPermissions = {
  __typename: 'WorkOrderEscalationPermissions';
  /** Permission to resolve escalations. */
  resolveEscalations: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum WorkOrderEscalationReason {
  BadQuote = 'BAD_QUOTE',
  CallbackRequired = 'CALLBACK_REQUIRED',
  CancelWorkOrder = 'CANCEL_WORK_ORDER',
  CantUpdateWorkOrderStatus = 'CANT_UPDATE_WORK_ORDER_STATUS',
  CantUploadInvoice = 'CANT_UPLOAD_INVOICE',
  ChangeSchedulingTimeline = 'CHANGE_SCHEDULING_TIMELINE',
  ChangeToEmergency = 'CHANGE_TO_EMERGENCY',
  ChangeVendor = 'CHANGE_VENDOR',
  DifficultyContactingCustomer = 'DIFFICULTY_CONTACTING_CUSTOMER',
  EmergencyApprovalForWorkOrder = 'EMERGENCY_APPROVAL_FOR_WORK_ORDER',
  InvoiceIssue = 'INVOICE_ISSUE',
  NobodyOnSite = 'NOBODY_ON_SITE',
  NoDispatchResponse = 'NO_DISPATCH_RESPONSE',
  Other = 'OTHER',
  PartsUpdate = 'PARTS_UPDATE',
  PaymentQuestion = 'PAYMENT_QUESTION',
  PoorQuality = 'POOR_QUALITY',
  ScheduleConflict = 'SCHEDULE_CONFLICT',
  VendorNotFound = 'VENDOR_NOT_FOUND',
  VendorNotResponsive = 'VENDOR_NOT_RESPONSIVE',
  VendorNoShow = 'VENDOR_NO_SHOW'
}

export type WorkOrderEscalationReasonType = {
  __typename: 'WorkOrderEscalationReasonType';
  key: WorkOrderEscalationReason;
  label: Scalars['String']['output'];
};

/** An enumeration. */
export enum WorkOrderEscalationSourceOrgType {
  Client = 'CLIENT',
  Vendor = 'VENDOR'
}

export type WorkOrderExpenseTypeNode = Node & {
  __typename: 'WorkOrderExpenseTypeNode';
  expenseType: ExpenseType;
  expenseTypeSetThrough: ExpenseTypeSetThrough;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  setBy: Maybe<UserNode>;
  workOrderId: Scalars['Int']['output'];
};

export enum WorkOrderHoldReason {
  AdditionalVisitRequired = 'ADDITIONAL_VISIT_REQUIRED',
  AwaitingParts = 'AWAITING_PARTS',
  AwaitingQuoteApprovalFromClient = 'AWAITING_QUOTE_APPROVAL_FROM_CLIENT',
  AwaitingQuoteFromVendor = 'AWAITING_QUOTE_FROM_VENDOR',
  Other = 'OTHER'
}

export type WorkOrderInternalNoteNode = Node & {
  __typename: 'WorkOrderInternalNoteNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  permissions: WorkOrderInternalNotePermissions;
  workOrderId: Scalars['Int']['output'];
};

export type WorkOrderInternalNoteNodeConnection = {
  __typename: 'WorkOrderInternalNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderInternalNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderInternalNoteNode` and its cursor. */
export type WorkOrderInternalNoteNodeEdge = {
  __typename: 'WorkOrderInternalNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderInternalNoteNode>;
};

export type WorkOrderInternalNotePermissions = {
  __typename: 'WorkOrderInternalNotePermissions';
  /** Permission to delete an internal note */
  deleteNote: Scalars['Boolean']['output'];
};

export type WorkOrderNavCounts = {
  __typename: 'WorkOrderNavCounts';
  maintenancePlansCount: Scalars['Int']['output'];
  needsSchedulingCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  vendorDispatchRequestsCount: Scalars['Int']['output'];
};

export type WorkOrderNode = Node & {
  __typename: 'WorkOrderNode';
  activeSubcontract: Maybe<WorkOrderSubcontractType>;
  activityFeedEntries: Array<ActivityFeedEntryNode>;
  appointment: Maybe<AppointmentNode>;
  approvalsCompleted: Scalars['Int']['output'];
  approvalsPreview: Array<WorkOrderClientInvoicesApprovalNode>;
  approvalsRequired: Scalars['Int']['output'];
  assignedToTechnician: Maybe<UserNode>;
  availableTimeSlots: Array<AvailableTimeSlotNode>;
  availableVendorTransitions: Array<ActivityType>;
  callbackOriginalWorkOrder: Maybe<WorkOrderNode>;
  callbackWorkOrder: Maybe<WorkOrderNode>;
  can: Scalars['Boolean']['output'];
  canAcceptNewQuotes: Scalars['Boolean']['output'];
  canShowProtectionPlanIndicator: Scalars['Boolean']['output'];
  /** Whether the viewer may load partnered estimate/invoice submissions and subcontract settlement invoices for this work order. */
  canViewPartneredFinancials: Scalars['Boolean']['output'];
  cancelledOn: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Replaced with service category */
  category: TradeNode;
  claimedPromotion: Maybe<VendorPromotionNode>;
  clientCombinedRuleViolations: Maybe<Array<RuleViolationsNode>>;
  clientInvoices: Maybe<Array<ClientInvoiceNode>>;
  clientInvoicesApprovals: Array<WorkOrderClientInvoicesApprovalNode>;
  clientManagedInvoices: Maybe<Array<ClientManagedInvoiceNode>>;
  clientRejectReason: Maybe<Scalars['String']['output']>;
  clientStatus: ClientWorkOrderStatus;
  code: Scalars['String']['output'];
  comments: Array<CommentNode>;
  completedOn: Maybe<Scalars['DateTime']['output']>;
  coordinator: Maybe<CoordinatorNode>;
  correlationId: Maybe<Scalars['String']['output']>;
  creationSource: Maybe<WorkOrderCreationSource>;
  currency: Currency;
  currentEscalations: Array<WorkOrderEscalationNode>;
  customerEstimateReceivedAt: Maybe<Scalars['DateTime']['output']>;
  customerInvoiceReceivedOn: Maybe<Scalars['Date']['output']>;
  cyovDispatchCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  disputeReason: Maybe<Scalars['String']['output']>;
  disputedOn: Maybe<Scalars['DateTime']['output']>;
  equipment: Maybe<EquipmentNode>;
  executingVendor: Maybe<VendorOrganizationNode>;
  expectedPrice: Maybe<Scalars['Decimal']['output']>;
  expectedServiceTimeline: Maybe<ExpectedServiceTimelineType>;
  expenseType: Maybe<ExpenseType>;
  externalReferenceNumber: Maybe<Scalars['String']['output']>;
  facility: FacilityNode;
  facilityAccessInfo: Maybe<Scalars['String']['output']>;
  facilityInsuranceDocument: Maybe<VendorDocumentNode>;
  firstVisitExpectedArrivalTime: Maybe<Scalars['DateTime']['output']>;
  firstVisitSchedulingNotes: Scalars['String']['output'];
  hasApplicableProtectionPlanEnrollment: Scalars['Boolean']['output'];
  hasAppliedProtectionPlan: Scalars['Boolean']['output'];
  hasMaintenancePlan: Scalars['Boolean']['output'];
  hasPendingSubcontractAcceptance: Scalars['Boolean']['output'];
  hasRsgCompletionReport: Scalars['Boolean']['output'];
  hasRsgOverdueBalanceWarning: Scalars['Boolean']['output'];
  hasSubmittedActualInvoice: Scalars['Boolean']['output'];
  hasVendorInvoiceEmail: Scalars['Boolean']['output'];
  heldOn: Maybe<Scalars['DateTime']['output']>;
  holdComments: Scalars['String']['output'];
  holdReason: Maybe<WorkOrderHoldReason>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  images: Array<ImageNode>;
  inProgressVisit: Maybe<VisitNode>;
  inboundVendorInvoices: Array<InboundVendorInvoiceNode>;
  internalPriority: Maybe<Scalars['String']['output']>;
  internalRequest: Maybe<InternalRequestNode>;
  invoiceApprovalProgress: Maybe<InvoiceApprovalProgress>;
  invoiceSets: Array<InvoiceSetNode>;
  invoiceStrategy: Maybe<InvoiceStrategyType>;
  isCallback: Scalars['Boolean']['output'];
  isCyov: Scalars['Boolean']['output'];
  isEssentials: Maybe<Scalars['Boolean']['output']>;
  isPinnedByMe: Scalars['Boolean']['output'];
  isSubcontracted: Scalars['Boolean']['output'];
  isSuspectedCallback: Scalars['Boolean']['output'];
  isUnderWarranty: Scalars['Boolean']['output'];
  /** Client says this WO is urgent. */
  isUrgent: Scalars['Boolean']['output'];
  isUserSubscribedToNotes: Maybe<Scalars['Boolean']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  latestSubcontract: Maybe<WorkOrderSubcontractType>;
  latestVisit: Maybe<VisitNode>;
  legacyId: Scalars['Int']['output'];
  maintenancePlan: Maybe<MaintenancePlanNode>;
  needsApproval: Scalars['Boolean']['output'];
  needsResponseNote: Maybe<WorkOrderNoteNode>;
  noteCount: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Array<WorkOrderNoteNode>>;
  onHold: Scalars['Boolean']['output'];
  opsOwner: Maybe<UserNode>;
  opsOwnerAssignedAt: Maybe<Scalars['DateTime']['output']>;
  originatingInboundRequest: Maybe<LeadInboundRequestNode>;
  overtimeApprovedBy: Maybe<UserNode>;
  partnerSla: Maybe<VendorSlaChecklistType>;
  partneredDisplay: Maybe<PartneredDisplayType>;
  partneredEstimateSubmissions: Array<PartneredEstimateSubmissionNode>;
  partneredInvoiceSubmissions: Array<PartneredInvoiceSubmissionNode>;
  pointOfContact: Maybe<WorkOrderPointOfContactNode>;
  priority: Maybe<WorkOrderPriorityNode>;
  project: Maybe<ProjectNode>;
  quoteRequiredThreshold: Scalars['Int']['output'];
  quoteSets: Array<QuoteSetNode>;
  quoteThresholdOverrideApprovedBy: Maybe<UserNode>;
  /** @deprecated Replaced by quote approvals system. */
  quotes: Array<QuoteNode>;
  raisedOn: Scalars['DateTime']['output'];
  reasonForEmergency: Maybe<Scalars['String']['output']>;
  recommendedRsgVendor: Maybe<VendorOrganizationNode>;
  recordOfWork: Maybe<RecordOfWorkNode>;
  requestType: Maybe<WorkOrderRequestType>;
  requestedTeamMember: Maybe<UserNode>;
  requestedVendor: Maybe<VendorOrganizationNode>;
  /** Name of the anonymous user submitting WO */
  requestorName: Maybe<Scalars['String']['output']>;
  reviews: Array<WorkOrderReviewNode>;
  rsgEstimateRequest: Maybe<ProposalRequestNode>;
  rsgOverdueBalanceWarningAmount: Scalars['Decimal']['output'];
  scheduledForEnd: Maybe<Scalars['DateTime']['output']>;
  scheduledForStart: Maybe<Scalars['DateTime']['output']>;
  scheduledOn: Maybe<Scalars['DateTime']['output']>;
  scopeOfWork: Maybe<Scalars['String']['output']>;
  serviceCategory: ServiceCategory;
  sourcingPartsHold: Maybe<SourcingPartsHold>;
  spend: Maybe<Scalars['Decimal']['output']>;
  spendApproval: Maybe<SpendApprovalNode>;
  status: WorkOrderStatus;
  statusDescription: Scalars['String']['output'];
  /** @deprecated Replaced with service category */
  subcategory: CategoryNode;
  subcontractHistory: Array<WorkOrderSubcontractType>;
  subcontractSettlementInvoices: Array<SubcontractSettlementInvoiceNode>;
  submittedBy: Maybe<UserNode>;
  submittedToMarketplaceAt: Maybe<Scalars['DateTime']['output']>;
  submittedToMarketplaceBy: Maybe<UserNode>;
  suggestedMarkup: SuggestedMarkup;
  summaries: Maybe<Array<WorkOrderSummaryNode>>;
  symptom: Maybe<TaxonomySymptomNode>;
  symptomDiscoveryPath: Maybe<Array<Scalars['String']['output']>>;
  taxonomyNode: Maybe<TaxonomyNodeNode>;
  teamMemberAssignments: Array<WorkOrderTeamMemberAssignmentNode>;
  title: Scalars['String']['output'];
  troubleshootingSession: Maybe<TroubleshootingSessionNode>;
  upcomingAppointment: Maybe<AppointmentNode>;
  vendor: Maybe<VendorOrganizationNode>;
  vendorCreationDetail: Maybe<VendorCreatedWorkOrderDetailNode>;
  vendorDispatch: Maybe<VendorDispatchNode>;
  vendorDueAtDate: Maybe<Scalars['DateTime']['output']>;
  vendorImages: Array<ImageNode>;
  vendorPaidAt: Maybe<Scalars['DateTime']['output']>;
  vendorPayoutStatus: Maybe<WorkOrderVendorPayoutStatus>;
  vendorPreventiveMaintenanceRecommendation: Maybe<VendorPreventiveMaintenanceRecommendationNode>;
  vendorStatus: WorkOrderVendorStatus;
  vendorTotal: Maybe<Scalars['Decimal']['output']>;
  viewerHasApproved: Scalars['Boolean']['output'];
};


export type WorkOrderNodeApprovalsPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkOrderNodeCanArgs = {
  perform: WorkOrderPermission;
};

export type WorkOrderNodeConnection = {
  __typename: 'WorkOrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderNode` and its cursor. */
export type WorkOrderNodeEdge = {
  __typename: 'WorkOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderNode>;
};

export type WorkOrderNoteMentionNode = Node & {
  __typename: 'WorkOrderNoteMentionNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  mentionedBy: UserNode;
  mentionedUser: UserNode;
};

export type WorkOrderNoteNode = Node & {
  __typename: 'WorkOrderNoteNode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inboundVendorInvoice: Maybe<InboundVendorInvoiceNode>;
  mentions: Maybe<Array<WorkOrderNoteMentionNode>>;
  message: Scalars['String']['output'];
  sourceUserType: NoteSource;
  workOrderId: Scalars['Int']['output'];
};

export type WorkOrderNoteNodeConnection = {
  __typename: 'WorkOrderNoteNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderNoteNode` and its cursor. */
export type WorkOrderNoteNodeEdge = {
  __typename: 'WorkOrderNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderNoteNode>;
};

/** Type of work order observer notifications a role receives. */
export enum WorkOrderObserverType {
  AllWorkOrders = 'ALL_WORK_ORDERS',
  EmergencyOnly = 'EMERGENCY_ONLY'
}

export type WorkOrderObserverTypeType = {
  __typename: 'WorkOrderObserverTypeType';
  key: WorkOrderObserverType;
  label: Scalars['String']['output'];
};

export enum WorkOrderPermission {
  ApproveInvoices = 'APPROVE_INVOICES',
  AssignToTeamMember = 'ASSIGN_TO_TEAM_MEMBER',
  BlockAp = 'BLOCK_AP',
  CancelJob = 'CANCEL_JOB',
  ChooseVendor = 'CHOOSE_VENDOR',
  CompleteJob = 'COMPLETE_JOB',
  CreateCallback = 'CREATE_CALLBACK',
  DisputeInvoices = 'DISPUTE_INVOICES',
  EditJob = 'EDIT_JOB',
  EditMatchingDetails = 'EDIT_MATCHING_DETAILS',
  Escalate = 'ESCALATE',
  ForceCompleteJob = 'FORCE_COMPLETE_JOB',
  HoldJob = 'HOLD_JOB',
  MarkAsAwaitingPayment = 'MARK_AS_AWAITING_PAYMENT',
  ModifyVendorStatus = 'MODIFY_VENDOR_STATUS',
  PayInvoices = 'PAY_INVOICES',
  ReassignVendor = 'REASSIGN_VENDOR',
  RemoveHold = 'REMOVE_HOLD',
  RequestRsgEstimate = 'REQUEST_RSG_ESTIMATE',
  ResolveInvoiceSetDispute = 'RESOLVE_INVOICE_SET_DISPUTE',
  ReviewJob = 'REVIEW_JOB',
  ScheduleAppointment = 'SCHEDULE_APPOINTMENT',
  StartJob = 'START_JOB',
  SubmitToMarketplace = 'SUBMIT_TO_MARKETPLACE',
  UnapproveInvoices = 'UNAPPROVE_INVOICES',
  UnblockAp = 'UNBLOCK_AP',
  VendorAddAttachments = 'VENDOR_ADD_ATTACHMENTS'
}

export type WorkOrderPointOfContactInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkOrderPointOfContactNode = Node & {
  __typename: 'WorkOrderPointOfContactNode';
  createdAt: Scalars['DateTime']['output'];
  fullName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  orgType: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  user: Maybe<UserNode>;
};

export type WorkOrderPriorityNode = Node & {
  __typename: 'WorkOrderPriorityNode';
  expectedResolutionDuration: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isEmergency: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type WorkOrderPriorityNodeConnection = {
  __typename: 'WorkOrderPriorityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderPriorityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderPriorityNode` and its cursor. */
export type WorkOrderPriorityNodeEdge = {
  __typename: 'WorkOrderPriorityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderPriorityNode>;
};

/** An enumeration. */
export enum WorkOrderRequestType {
  AssignToStaffMember = 'ASSIGN_TO_STAFF_MEMBER',
  Emergency = 'EMERGENCY',
  Quote = 'QUOTE',
  Repair = 'REPAIR'
}

export type WorkOrderReviewFeedbackNode = Node & {
  __typename: 'WorkOrderReviewFeedbackNode';
  comment: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPositive: Scalars['Boolean']['output'];
};

export type WorkOrderReviewFeedbackNodeConnection = {
  __typename: 'WorkOrderReviewFeedbackNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderReviewFeedbackNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WorkOrderReviewFeedbackNode` and its cursor. */
export type WorkOrderReviewFeedbackNodeEdge = {
  __typename: 'WorkOrderReviewFeedbackNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderReviewFeedbackNode>;
};

export type WorkOrderReviewNode = Node & {
  __typename: 'WorkOrderReviewNode';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: UserNode;
  feedback: Array<WorkOrderReviewFeedbackNode>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  satisfied: Maybe<Scalars['Boolean']['output']>;
  skipped: Scalars['Boolean']['output'];
  workOrder: WorkOrderNode;
};

export type WorkOrderReviewNodeConnection = {
  __typename: 'WorkOrderReviewNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderReviewNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderReviewNode` and its cursor. */
export type WorkOrderReviewNodeEdge = {
  __typename: 'WorkOrderReviewNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderReviewNode>;
};

export enum WorkOrderStatus {
  Assigned = 'ASSIGNED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** @deprecated Deprecated in favour of cancelled_on timestamp. */
  Cancelled = 'CANCELLED',
  ClientAssigned = 'CLIENT_ASSIGNED',
  ClientInProgress = 'CLIENT_IN_PROGRESS',
  ClientRejected = 'CLIENT_REJECTED',
  ClientResolved = 'CLIENT_RESOLVED',
  ClientTriage = 'CLIENT_TRIAGE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  NotYetCompleted = 'NOT_YET_COMPLETED',
  NotYetScanned = 'NOT_YET_SCANNED',
  NotYetScheduled = 'NOT_YET_SCHEDULED',
  Open = 'OPEN',
  WaitingForCoordinatorApproval = 'WAITING_FOR_COORDINATOR_APPROVAL',
  WaitingForFmApproval = 'WAITING_FOR_FM_APPROVAL',
  WaitingForVmApproval = 'WAITING_FOR_VM_APPROVAL'
}

export type WorkOrderStatusSuggestion = {
  __typename: 'WorkOrderStatusSuggestion';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  scheduledAtEnd: Maybe<Scalars['DateTime']['output']>;
  scheduledAtStart: Maybe<Scalars['DateTime']['output']>;
};

export enum WorkOrderSubcontractStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type WorkOrderSubcontractType = {
  __typename: 'WorkOrderSubcontractType';
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dispatchNote: Maybe<Scalars['String']['output']>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  endedReason: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  parentVendor: VendorOrganizationNode;
  paymentTermDays: Maybe<Scalars['Int']['output']>;
  status: WorkOrderSubcontractStatus;
  subcontractVendor: VendorOrganizationNode;
  subcontractorSharePercentage: Maybe<Scalars['Decimal']['output']>;
};

export type WorkOrderSummaryNode = Node & {
  __typename: 'WorkOrderSummaryNode';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** AI-generated summary sentence describing work completed */
  summary: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The work order this summary belongs to */
  workOrder: WorkOrderNode;
};

export type WorkOrderSummaryNodeConnection = {
  __typename: 'WorkOrderSummaryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderSummaryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderSummaryNode` and its cursor. */
export type WorkOrderSummaryNodeEdge = {
  __typename: 'WorkOrderSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderSummaryNode>;
};

export type WorkOrderTaskListItemNode = Node & {
  __typename: 'WorkOrderTaskListItemNode';
  checked: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
};

export type WorkOrderTeamMemberAssignmentNode = Node & {
  __typename: 'WorkOrderTeamMemberAssignmentNode';
  assignedUser: UserNode;
  can: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  outcome: Maybe<WorkOrderTeamMemberAssignmentOutcome>;
  photos: Array<WorkOrderTeamMemberAssignmentPhotoNode>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  workOrder: WorkOrderNode;
};


export type WorkOrderTeamMemberAssignmentNodeCanArgs = {
  perform: WorkOrderTeamMemberAssignmentPermission;
};

/** An enumeration. */
export enum WorkOrderTeamMemberAssignmentOutcome {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Reassigned = 'REASSIGNED',
  SentToVendor = 'SENT_TO_VENDOR',
  Unresolved = 'UNRESOLVED'
}

export enum WorkOrderTeamMemberAssignmentPermission {
  Complete = 'COMPLETE',
  Reassign = 'REASSIGN'
}

export type WorkOrderTeamMemberAssignmentPhotoNode = Node & {
  __typename: 'WorkOrderTeamMemberAssignmentPhotoNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  photo: ImageType;
};

export type WorkOrderVendorEligibilityProfileNode = Node & {
  __typename: 'WorkOrderVendorEligibilityProfileNode';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  facility: FacilityNode;
  facilityId: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  newClientIncentive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor: VendorOrganizationNode;
  vendorId: Scalars['Int']['output'];
  workOrder: WorkOrderNode;
  workOrderId: Scalars['Int']['output'];
};

export type WorkOrderVendorEligibilityProfileNodeConnection = {
  __typename: 'WorkOrderVendorEligibilityProfileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WorkOrderVendorEligibilityProfileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WorkOrderVendorEligibilityProfileNode` and its cursor. */
export type WorkOrderVendorEligibilityProfileNodeEdge = {
  __typename: 'WorkOrderVendorEligibilityProfileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<WorkOrderVendorEligibilityProfileNode>;
};

/** Pseudo-status for vendor payout. */
export enum WorkOrderVendorPayoutStatus {
  AwaitingInvoice = 'AWAITING_INVOICE',
  AwaitingPayout = 'AWAITING_PAYOUT',
  Closed = 'CLOSED',
  Disputed = 'DISPUTED'
}

export enum WorkOrderVendorStatus {
  AwaitingClientConfirmation = 'AWAITING_CLIENT_CONFIRMATION',
  AwaitingScheduling = 'AWAITING_SCHEDULING',
  Disputed = 'DISPUTED',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  NeedsApproval = 'NEEDS_APPROVAL',
  NeedsInvoice = 'NEEDS_INVOICE',
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export type WorkOrdersAwaitingPayment = {
  __typename: 'WorkOrdersAwaitingPayment';
  awaitingPayment: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
};

export type WorkOrdersByStatus = {
  __typename: 'WorkOrdersByStatus';
  completed: OnDemandAndMaintenancePlanCounts;
  invoiced: OnDemandAndMaintenancePlanCounts;
  onHold: OnDemandAndMaintenancePlanCounts;
  scheduled: OnDemandAndMaintenancePlanCounts;
  submitted: OnDemandAndMaintenancePlanCounts;
};

export type WorkOrdersSubmitted = {
  __typename: 'WorkOrdersSubmitted';
  nonUrgentCount: Scalars['Int']['output'];
  urgentCount: Scalars['Int']['output'];
};

export type Client_SpendApprovalFragment = { __typename: 'SpendApprovalNode', approvedAmount: number, nteRaiseRequestApprovedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'SpendApprovalPermissions', raiseApprovedSpend: boolean } };

export type GetFacilityGroupSpendQueryVariables = Exact<{
  budgetId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFacilityGroupSpendQueryNode = { __typename: 'Query', facilityGroupSpend: Array<{ __typename: 'FacilityGroupSpendNode', id: string, allottedAmount: string, spentAmount: string, upcomingSpendCount: number, upcomingSpendAmount: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> } }> };

export type FacilityGroupSpendInsightsFragment = { __typename: 'FacilityGroupSpendNode', id: string, allottedAmount: string, spentAmount: string, upcomingSpendCount: number, upcomingSpendAmount: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> } };

export type ActivityFeedEntrySummaryFragment = { __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, internalMessage?: string | null, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } };

export type Client_AppointmentSummaryFragment = { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } };

export type Client_BusinessUnitDetailsFragment = { __typename: 'BusinessUnitNode', id: string, name: string, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> };

export type BusinessUnitMembershipSummaryFragment = { __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> };

export type Client_BusinessUnitSummaryFragment = { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> };

export type Client_ClientDetailsFragment = { __typename: 'ClientOrganizationNode', id: string, name: string, trackingId: number, hasActiveProtectionPlanConfiguration: boolean, hasVendorIssuedInvoices: boolean, lendingEnabled: boolean | null, clientStatus: ClientOrganizationStatus | null, isSubscriptionLive: boolean, isSubscriptionMigrated: boolean, contractSignedOn: string | null, viewerDailyMenuFirstRunConfirmed: boolean, viewerDailyMenuFirstRunConfirmedAt: string | null, hasMissingSubscriptionPaymentMethod: boolean, canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canSelectQuotes: boolean, canApproveQuotes: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean, canManageProjects: boolean, owner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency, paymentTerms: number | null, isAutopay: boolean, isDirectVendorPayment: boolean, operatingCountry: { __typename: 'CountryNode', id: string, code: string | null } }, creditCardFeeNotice: { __typename: 'CreditCardFeeNotice', isNoticeActive: boolean, isFeeEffective: boolean, feeEffectiveOn: string, defaultRatePercentage: string | null, exemptFacilityRegionNames: Array<string>, regionalRateOverrides: Array<{ __typename: 'CreditCardFeeNoticeRegionalRateOverride', regionName: string, ratePercentage: string }> } | null, matchingProfile: { __typename: 'ClientMatchingProfileNode', id: string, favouriteVendorsImported: boolean | null, optedIntoMarketplace: boolean } | null, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, status: FacilityStatus, canManage: boolean, canManageEquipment: boolean, brand: { __typename: 'BrandNode', id: string, name: string, logo: { __typename: 'ImageType', url: string } | null } | null }>, successOwner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, paymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, invoiceApprovalStrategy: InvoiceApprovalStrategy, paymentMethod: PaymentMethodType }, pricingModel: { __typename: 'PricingModelNode', id: string, name: PricingModelName } | null, featureTier: { __typename: 'FeatureTierNode', id: string, name: string } | null };

export type Client_ClientInvoiceSummaryFragment = { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null };

export type ClientMembershipForQuoteActionFragment = { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> };

export type ClientMembershipPermissionsFragment = { __typename: 'ClientOrganizationMemberNode', canManage: boolean };

export type Client_ClientMembershipSummaryFragment = { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> };

export type ClientMonthlyStatementSummaryFragment = { __typename: 'ClientMonthlyStatementNode', id: string, createdAt: string, year: number, month: number, agingReportPdfUrl: string | null, transactionSummaryCsvUrl: string | null, businessUnit: { __typename: 'BusinessUnitNode', id: string } };

export type ClientOrganizationPermissionsFragment = { __typename: 'ClientOrganizationNode', canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canSelectQuotes: boolean, canApproveQuotes: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean, canManageProjects: boolean };

export type ClientReportDetailsFragment = { __typename: 'ClientReportNode', id: string, reportType: ClientReportType, generatedOn: string, startDate: string, endDate: string, csvUrl: string | null };

export type ClientReportScheduleDetailsFragment = { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null };

export type Client_EquipmentDetailsFragment = { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, internalTotalSpend: string | null, externalTotalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } } | null, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, vendorRanking: { __typename: 'VendorRankingNode', id: string, entries: Array<{ __typename: 'VendorRankingEntryNode', id: string, position: number, notes: string, createdAt: string, updatedAt: string, ranking: { __typename: 'VendorRankingNode', id: string } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, isVerifiedVendor: boolean | null, profile: { __typename: 'VendorProfileNode', vendorPerformanceProfile: { __typename: 'VendorPerformanceProfile', scoreSummary: { __typename: 'VendorScoreSummary', score: string | null } } | null }, businessProfile: { __typename: 'VendorBusinessProfileNode', isPublished: boolean } | null } | null } | null> | null } | null };

export type EquipmentServiceCountFragment = { __typename: 'EquipmentServiceCount', count: number, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } | null } };

export type Client_EquipmentSummaryFragment = { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null };

export type EquipmentSummaryShortVersionFragment = { __typename: 'EquipmentNode', id: string, name: string, manufacturer: string | null, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, shouldUpdateWarranty: boolean, totalSpend: string | null, cost: string | null, historicalSpend: string | null, facility: { __typename: 'FacilityNode', name: string, id: string, canManageEquipment: boolean } | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, devices: Array<{ __typename: 'Device', id: string, name: string }>, incidents: Array<{ __typename: 'Incident', id: string }> };

export type Client_FacilityDetailsFragment = { __typename: 'FacilityNode', id: string, name: string, code: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, currency: Currency, status: FacilityStatus, goliveOn: string | null, storeNumber: string | null, actualGoLiveOn: string | null, plannedGoLiveOn: string | null, onboardingStatus: OnboardingStatus | null, taggingMethod: TaggingMethod | null, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, notes: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, businessLegalName: string | null, businessTaxNumber: string | null, businessLegalStructure: BusinessLegalStructure | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, clientOrganization: { __typename: 'ClientOrganizationNode', id: string, featureTier: { __typename: 'FeatureTierNode', name: string } | null }, brand: { __typename: 'BrandNode', name: string } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isDefault: boolean, isVerified: boolean, externalReferenceType: PaymentMethodExternalType | null, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }> };

export type Facility_FacilityGroupsField_FacilityGroupFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } };

export type FacilityGroupDetailsFragment = { __typename: 'FacilityGroupNode', id: string, name: string, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } };

export type FacilityGroupForSelectionFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } };

export type Client_FacilityGroupMembershipDetailsFragment = { __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> };

export type Client_FacilityGroupSummaryFragment = { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null };

export type Client_FacilityPermissionsFragment = { __typename: 'FacilityNode', canManage: boolean, canManageEquipment: boolean };

export type Client_FacilitySummaryFragment = { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null };

export type Client_ImageSummaryFragment = { __typename: 'ImageNode', id: string, description: string, url: string, thumbnailUrl: string };

export type Client_InboundVendorInvoiceSummaryFragment = { __typename: 'InboundVendorInvoiceNode', id: string, name: string, createdAt: string, invoiceFile: { __typename: 'FileType', url: string } };

export type Client_InvitePermissionsFragment = { __typename: 'InviteNode', canCancel: boolean };

export type Client_InviteSummaryFragment = { __typename: 'InviteNode', id: string, firstName: string, lastName: string, phoneNumber: string, emailAddress: string, expiresAt: string | null, hasOnboardingAction: boolean, canCancel: boolean, assignedFacilityGroups: Array<{ __typename: 'FacilityGroupNode', id: string, name: string }>, assignedRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> };

export type InvoiceApprovalSettingsFragment = { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, firstApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, secondApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> };

export type Client_MaintenancePlanDetailsFragment = { __typename: 'MaintenancePlanNode', nextWorkOrderCreationDate: string, canDirectlyChangeDate: boolean, scopeOfWork: string, serviceFrequencyUnit: MaintenancePlanFrequencyUnit | null, serviceFrequencyValue: number | null, status: MaintenancePlanStatus, source: MaintenancePlanSource, selfService: boolean, id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, contractEndDate: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null }>, currentWorkOrder: { __typename: 'WorkOrderNode', id: string, completedOn: string | null } | null, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } };

export type Client_MaintenancePlanSummaryFragment = { __typename: 'MaintenancePlanNode', id: string, code: string, name: string | null, status: MaintenancePlanStatus, source: MaintenancePlanSource, selfService: boolean, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, nextWorkOrderCreationDate: string, contractEndDate: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } };

export type Client_MaintenancePlanTypeSummaryFragment = { __typename: 'MaintenancePlanTypeNode', id: string, name: string, description: string, defaultServiceFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultServiceFrequencyValue: number | null, defaultBillingFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultBillingFrequencyValue: number | null, defaultVariablePricing: boolean, defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus, serviceCategory: ServiceCategory, image: { __typename: 'ImageType', url: string } };

export type Client_PaymentMethodSummaryFragment = { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isDefault: boolean, isVerified: boolean, externalReferenceType: PaymentMethodExternalType | null, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null };

export type PeriodicSpendComparisonFragment = { __typename: 'PeriodicSpendComparison', spendAmount: string, differencePercent: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type QuoteAcceptanceSettingsFragment = { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> };

export type QuoteApprovalThresholdSummaryFragment = { __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> };

export type Client_QuoteSetDetailsFragment = { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } };

export type QuoteSetOptionDetailsFragment = { __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } };

export type Client_QuoteSummaryFragment = { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null };

export type ReviewFeedbackFragment = { __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string, isPositive: boolean };

export type ReviewRequestFragment = { __typename: 'ReviewRequestNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, correlationId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, timezone: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } };

export type Client_RoleDetailsFragment = { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null };

export type Client_RoleSummaryFragment = { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null };

export type Client_SkillDetailsFragment = { __typename: 'SkillNode', id: string, description: string };

export type SpendByPeriodFragment = { __typename: 'SpendByPeriod', spendAmount: string, internalSpendAmount: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type SpendByServiceCategoryFragment = { __typename: 'SpendByServiceCategory', serviceCategory: ServiceCategory, spendAmount: string, internalSpendAmount: string | null };

export type SpendThisPeriodBreakdownFragment = { __typename: 'SpendThisPeriodBreakdown', totalSpend: string, externalSpend: string, internalSpend: string };

export type Client_TaxRateDetailsFragment = { __typename: 'TaxRateNode', id: string, name: TaxRateName, rate: string, validTo: string | null, validFrom: string | null, permissions: { __typename: 'TaxRatePermissions', update: boolean } };

export type TopSpendFacilitiesFragment = { __typename: 'TopSpendFacilities', facilityName: string, spendAmount: string, percentDifference: string, internalSpendAmount: string | null, externalSpendAmount: string | null };

export type TopSpendWorkOrdersFragment = { __typename: 'TopSpendWorkOrders', spendAmount: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, completedOn: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, completion: { __typename: 'InternalRequestCompletionNode', id: string, completionDate: string | null } | null } | null } };

export type UninvoicedByPeriodFragment = { __typename: 'UninvoicedByPeriod', count: number, period: { __typename: 'MetricsPeriod', start: string, end: string } };

export type Client_UserDetailsFragment = { __typename: 'UserNode', id: string, accountType: AccountType, firstName: string, lastName: string, username: string, email: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, title: string | null }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> }>, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } }> };

export type Client_UserSummaryFragment = { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } };

export type Rmc_VendorField_VendorFragment = { __typename: 'VendorOrganizationNode', id: string, name: string };

export type VendorDispatchFragment = { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> };

export type VendorDispatchRequestFragment = { __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } };

export type Client_VendorSummaryFragment = { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> };

export type VisitReviewRequestFragment = { __typename: 'VisitReviewRequestNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, serviceCategory: ServiceCategory, facility: { __typename: 'FacilityNode', id: string, timezone: string, name: string } }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null };

export type WorkOrderClientInvoicesApprovalSummaryFragment = { __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } };

export type WorkOrderForSpendReportingFragment = { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null };

export type Client_WorkOrderReviewFragment = { __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> };

export type Client_WorkOrderSummaryFragment = { __typename: 'WorkOrderNode', id: string, code: string, hasAppliedProtectionPlan: boolean, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, project?: { __typename: 'ProjectNode', id: string, name: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, vendor: { __typename: 'VendorOrganizationNode', name: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null };

export type WorkOrderTeamMemberAssignmentDetailsFragment = { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> };

export type WorkOrderTeamMemberAssignmentPhotoDetailsFragment = { __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } };

export type AddEquipmentMutationVariables = Exact<{
  facilityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  mainImage?: InputMaybe<Image>;
  modelTagImage?: InputMaybe<Image>;
  location: Scalars['String']['input'];
  serialNo: Scalars['String']['input'];
  modelNo: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  barCode: Scalars['String']['input'];
  installedOn?: InputMaybe<Scalars['Date']['input']>;
  warrantyNotes?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  historicalSpend?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type AddEquipmentMutationNode = { __typename: 'Mutations', addEquipment: { __typename: 'AddEquipmentMutation', ok: boolean, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } } | null };

export type AddExternalExpenseMutationVariables = Exact<{
  input: AddExternalExpenseMutationInput;
}>;


export type AddExternalExpenseMutationNode = { __typename: 'Mutations', addExternalExpense: { __typename: 'AddExternalExpenseMutationPayload', externalExpense: { __typename: 'SpendItemAllocationNode', id: string } } | null };

export type ApproveQuoteSetOptionForSpendMutationVariables = Exact<{
  input: ApproveQuoteSetOptionForSpendInput;
}>;


export type ApproveQuoteSetOptionForSpendMutationNode = { __typename: 'Mutations', approveQuoteSetOptionForSpend: { __typename: 'ApproveQuoteSetOptionForSpendPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, workOrder: { __typename: 'WorkOrderNode', id: string } | null, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type ApproveWorkOrderInvoicesMutationVariables = Exact<{
  arguments: ApproveWorkOrderClientInvoicesArguments;
}>;


export type ApproveWorkOrderInvoicesMutationNode = { __typename: 'Mutations', approveWorkOrderInvoices: { __typename: 'ApproveWorkOrderClientInvoicesMutation', ok: boolean } | null };

export type AssignUsersToRoleMutationVariables = Exact<{
  input: AssignUsersToRoleMutationInput;
}>;


export type AssignUsersToRoleMutationNode = { __typename: 'Mutations', assignUsersToRole: { __typename: 'AssignUsersToRoleMutationPayload', ok: boolean } | null };

export type BulkInviteMembersToClientOrganizationMutationVariables = Exact<{
  input: BulkInviteMembersToClientOrganizationMutationInput;
}>;


export type BulkInviteMembersToClientOrganizationMutationNode = { __typename: 'Mutations', bulkInviteMembersToClientOrganization: { __typename: 'BulkInviteMembersToClientOrganizationMutationPayload', invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string, phoneNumber: string, firstName: string, lastName: string }> } | null };

export type CancelInviteMutationVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type CancelInviteMutationNode = { __typename: 'Mutations', cancelInvite: { __typename: 'CancelInviteMutation', ok: boolean } | null };

export type ClientCancelMaintenancePlanMutationVariables = Exact<{
  maintenancePlanId: Scalars['ID']['input'];
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClientCancelMaintenancePlanMutationNode = { __typename: 'Mutations', cancelMaintenancePlan: { __typename: 'CancelMaintenancePlanMutation', ok: boolean } | null };

export type CancelWorkOrderMutationVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifyVendor?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<WorkOrderCancellationSource>;
  cancelReason?: InputMaybe<WorkOrderCancellationReason>;
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelWorkOrderMutationNode = { __typename: 'Mutations', cancelWorkOrder: { __typename: 'CancelWorkOrderMutation', ok: boolean } | null };

export type ChangePasswordMutationVariables = Exact<{
  arguments: ChangePasswordArguments;
}>;


export type ChangePasswordMutationNode = { __typename: 'Mutations', changePassword: { __typename: 'ChangePasswordMutation', ok: boolean } | null };

export type ChargePaymentMethodMutationVariables = Exact<{
  input: ChargePaymentMethodInput;
}>;


export type ChargePaymentMethodMutationNode = { __typename: 'Mutations', chargePaymentMethod: { __typename: 'ChargePaymentMethodPayload', paymentSubmittedInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null }> | null } | null };

export type ChargeSubscriptionInvoicesMutationVariables = Exact<{
  input: ChargeSubscriptionInvoicesMutationInput;
}>;


export type ChargeSubscriptionInvoicesMutationNode = { __typename: 'Mutations', chargeSubscriptionInvoices: { __typename: 'ChargeSubscriptionInvoicesMutationPayload', ok: boolean, paymentSubmittedInvoices: Array<{ __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null }> | null } | null };

export type CompleteBillingEntityOnboardingStepMutationVariables = Exact<{
  input: CompleteBillingEntityOnboardingStepMutationInput;
}>;


export type CompleteBillingEntityOnboardingStepMutationNode = { __typename: 'Mutations', completeBillingEntityOnboardingStep: { __typename: 'CompleteBillingEntityOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteClientOnboardingMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CompleteClientOnboardingMutationNode = { __typename: 'Mutations', completeClientOnboarding: { __typename: 'CompleteClientOnboardingMutation', ok: boolean } | null };

export type CompleteFacilitiesOnboardingStepMutationVariables = Exact<{
  input: CompleteFacilitiesOnboardingStepMutationInput;
}>;


export type CompleteFacilitiesOnboardingStepMutationNode = { __typename: 'Mutations', completeFacilitiesOnboardingStep: { __typename: 'CompleteFacilitiesOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteGetStartedOnboardingStepMutationVariables = Exact<{
  input: CompleteGetStartedOnboardingStepMutationInput;
}>;


export type CompleteGetStartedOnboardingStepMutationNode = { __typename: 'Mutations', completeGetStartedOnboardingStep: { __typename: 'CompleteGetStartedOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteStaffOnboardingStepMutationVariables = Exact<{
  input: CompleteStaffOnboardingStepMutationInput;
}>;


export type CompleteStaffOnboardingStepMutationNode = { __typename: 'Mutations', completeStaffOnboardingStep: { __typename: 'CompleteStaffOnboardingStepMutationPayload', ok: boolean } | null };

export type CompleteTroubleshootingSessionMutationVariables = Exact<{
  input: CompleteTroubleshootingSessionMutationInput;
}>;


export type CompleteTroubleshootingSessionMutationNode = { __typename: 'Mutations', completeTroubleshootingSession: { __typename: 'CompleteTroubleshootingSessionMutationPayload', ok: boolean } | null };

export type CompleteWorkOrderMutationVariables = Exact<{
  input: ForceWorkOrderCompletionMutationInput;
}>;


export type CompleteWorkOrderMutationNode = { __typename: 'Mutations', forceWorkOrderCompletion: { __typename: 'ForceWorkOrderCompletionMutationPayload', ok: boolean } | null };

export type CompleteWorkOrderTeamMemberAssignmentMutationVariables = Exact<{
  input: CompleteWorkOrderTeamMemberAssignmentInput;
}>;


export type CompleteWorkOrderTeamMemberAssignmentMutationNode = { __typename: 'Mutations', completeWorkOrderTeamMemberAssignment: { __typename: 'CompleteWorkOrderTeamMemberAssignmentPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type ConfirmPerUserDailyMenuFirstRunMutationVariables = Exact<{
  input: ConfirmPerUserDailyMenuFirstRunMutationInput;
}>;


export type ConfirmPerUserDailyMenuFirstRunMutationNode = { __typename: 'Mutations', confirmPerUserDailyMenuFirstRun: { __typename: 'ConfirmPerUserDailyMenuFirstRunMutationPayload', ok: boolean, confirmedAt: string | null } | null };

export type CreateBudgetMutationVariables = Exact<{
  input: CreateBudgetMutationInput;
}>;


export type CreateBudgetMutationNode = { __typename: 'Mutations', createBudget: { __typename: 'CreateBudgetMutationPayload', budget: { __typename: 'BudgetNode', id: string, name: string, endDate: string, startDate: string, description: string } | null } | null };

export type CreateBusinessUnitMutationVariables = Exact<{
  arguments: CreateBusinessUnitArguments;
}>;


export type CreateBusinessUnitMutationNode = { __typename: 'Mutations', createBusinessUnit: { __typename: 'CreateBusinessUnitMutation', businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null };

export type CreateCyovDispatchMutationVariables = Exact<{
  input: CreateCyovDispatchInput;
}>;


export type CreateCyovDispatchMutationNode = { __typename: 'Mutations', createCyovDispatch: { __typename: 'CreateCYOVDispatchPayload', vendorDispatch: { __typename: 'VendorDispatchNode', id: string, status: VendorDispatchStatus, startedThroughCyov: boolean, startedAt: string | null, requests: Array<{ __typename: 'VendorDispatchRequestNode', id: string, status: VendorDispatchRequestStatus, startedAt: string | null, expectedAcceptanceAt: string | null, declineReason: { __typename: 'VendorDispatchRequestDeclineReasonNode', id: string, reasonChoice: VendorDispatchRequestDeclineReasonChoices, otherReason: string | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } }> } } | null };

export type CreateFacilityMutationVariables = Exact<{
  input: CreateFacilityInput;
}>;


export type CreateFacilityMutationNode = { __typename: 'Mutations', createFacility: { __typename: 'CreateFacilityPayload', facility: { __typename: 'FacilityNode', id: string } } | null };

export type CreateFacilityGroupMutationVariables = Exact<{
  input: CreateFacilityGroupInput;
}>;


export type CreateFacilityGroupMutationNode = { __typename: 'Mutations', createFacilityGroup: { __typename: 'CreateFacilityGroupPayload', facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } } | null };

export type CreateOrUpdateBusinessUnitOnboardingMutationVariables = Exact<{
  input: CreateOrUpdateBusinessUnitOnboardingMutationInput;
}>;


export type CreateOrUpdateBusinessUnitOnboardingMutationNode = { __typename: 'Mutations', createOrUpdateBusinessUnitOnboarding: { __typename: 'CreateOrUpdateBusinessUnitOnboardingMutationPayload', businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutationNode = { __typename: 'Mutations', createRole: { __typename: 'CreateRolePayload', role: { __typename: 'RoleNode', id: string } } | null };

export type CreateTroubleshootingSessionMutationVariables = Exact<{
  input: CreateTroubleshootingSessionMutationInput;
}>;


export type CreateTroubleshootingSessionMutationNode = { __typename: 'Mutations', createTroubleshootingSession: { __typename: 'CreateTroubleshootingSessionMutationPayload', troubleshootingSession: { __typename: 'TroubleshootingSessionNode', id: string, actions: Array<{ __typename: 'TroubleshootingActionNode', id: string, troubleshootingStep: { __typename: 'TroubleshootingStepNode', id: string, order: number, stepDescription: string, supportLink: string } }> } | null } | null };

export type CreateUpdateWorkOrderExpenseTypeMutationVariables = Exact<{
  input: CreateUpdateWorkOrderExpenseTypeMutationInput;
}>;


export type CreateUpdateWorkOrderExpenseTypeMutationNode = { __typename: 'Mutations', createUpdateWorkOrderExpenseType: { __typename: 'CreateUpdateWorkOrderExpenseTypeMutationPayload', workOrderExpenseType: { __typename: 'WorkOrderExpenseTypeNode', id: string, workOrderId: number, expenseType: ExpenseType, expenseTypeSetThrough: ExpenseTypeSetThrough, setBy: { __typename: 'UserNode', id: string } | null } | null } | null };

export type CreateVisitReviewMutationVariables = Exact<{
  visitReviewRequestId: Scalars['ID']['input'];
  outcome: VisitReviewOutcome;
}>;


export type CreateVisitReviewMutationNode = { __typename: 'Mutations', createVisitReview: { __typename: 'CreateVisitReviewMutation', ok: boolean } | null };

export type CreateWorkOrderEscalationMutationVariables = Exact<{
  input: CreateWorkOrderEscalationInput;
}>;


export type CreateWorkOrderEscalationMutationNode = { __typename: 'Mutations', createWorkOrderEscalation: { __typename: 'CreateWorkOrderEscalationPayload', workOrderEscalation: { __typename: 'WorkOrderEscalationNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, canEscalate: boolean }, kustomerWorkOrderEscalation: { __typename: 'KustomerWorkOrderEscalationNode', ticketNumber: string | null, kustomerUrl: string | null } | null } } | null };

export type CreateWorkOrderReviewMutationVariables = Exact<{
  input: CreateWorkOrderReviewArguments;
}>;


export type CreateWorkOrderReviewMutationNode = { __typename: 'Mutations', createWorkOrderReview: { __typename: 'CreateWorkOrderReviewMutation', workOrder: { __typename: 'WorkOrderNode', reviews: Array<{ __typename: 'WorkOrderReviewNode', id: string, createdAt: string, satisfied: boolean | null, skipped: boolean, comment: string | null, createdBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, feedback: Array<{ __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string }> }> } | null } | null };

export type DeactivateEquipmentMutationVariables = Exact<{
  input: DeactivateEquipmentInput;
}>;


export type DeactivateEquipmentMutationNode = { __typename: 'Mutations', deactivateEquipmentMutation: { __typename: 'DeactivateEquipmentPayload', equipment: { __typename: 'EquipmentNode', id: string, status: EquipmentStatus, barCode: string | null } } | null };

export type DeactivateFacilityMutationVariables = Exact<{
  input: DeactivateFacilityInput;
}>;


export type DeactivateFacilityMutationNode = { __typename: 'Mutations', deactivateFacility: { __typename: 'DeactivateFacilityPayload', facility: { __typename: 'FacilityNode', id: string, status: FacilityStatus } } | null };

export type DeleteBusinessUnitMutationVariables = Exact<{
  input: DeleteBusinessUnitMutationInput;
}>;


export type DeleteBusinessUnitMutationNode = { __typename: 'Mutations', deleteBusinessUnit: { __typename: 'DeleteBusinessUnitMutationPayload', ok: boolean } | null };

export type DeleteClientReportScheduleMutationVariables = Exact<{
  input: DeleteClientReportScheduleMutationInput;
}>;


export type DeleteClientReportScheduleMutationNode = { __typename: 'Mutations', deleteClientReportSchedule: { __typename: 'DeleteClientReportScheduleMutationPayload', ok: boolean } | null };

export type DeleteFacilityMutationVariables = Exact<{
  input: DeleteFacilityInput;
}>;


export type DeleteFacilityMutationNode = { __typename: 'Mutations', deleteFacility: { __typename: 'DeleteFacilityPayload', facility: { __typename: 'FacilityNode', id: string, status: FacilityStatus } } | null };

export type DeleteFacilityGroupMutationVariables = Exact<{
  input: DeleteFacilityGroupInput;
}>;


export type DeleteFacilityGroupMutationNode = { __typename: 'Mutations', deleteFacilityGroup: { __typename: 'DeleteFacilityGroupPayload', ok: boolean | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutationNode = { __typename: 'Mutations', deleteRole: { __typename: 'DeleteRolePayload', ok: boolean } | null };

export type DisputeWorkOrderMutationVariables = Exact<{
  arguments: DisputeWorkOrderArguments;
}>;


export type DisputeWorkOrderMutationNode = { __typename: 'Mutations', disputeWorkOrder: { __typename: 'DisputeWorkOrderMutation', workOrder: { __typename: 'WorkOrderNode', id: string } } | null };

export type EditClientMembershipDetailsMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EditClientMembershipDetailsMutationNode = { __typename: 'Mutations', EditClientMembershipDetails: { __typename: 'EditClientOrganizationMemberMutation', member: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> } } | null };

export type EditClientOrganizationMemberMutationVariables = Exact<{
  clientOrganizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  businessUnitIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EditClientOrganizationMemberMutationNode = { __typename: 'Mutations', editClientOrganizationMember: { __typename: 'EditClientOrganizationMemberMutation', member: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> } } | null };

export type EditClientVendorRelationshipInviteMutationVariables = Exact<{
  input: EditClientVendorRelationshipInviteInput;
}>;


export type EditClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', editClientVendorRelationshipInvite: { __typename: 'EditClientVendorRelationshipInvitePayload', invite: { __typename: 'InviteNode', id: string } } | null };

export type EditEquipmentMutationVariables = Exact<{
  equipmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  mainImage?: InputMaybe<Image>;
  modelTagImage?: InputMaybe<Image>;
  location: Scalars['String']['input'];
  serialNo: Scalars['String']['input'];
  modelNo: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  barCode: Scalars['String']['input'];
  installedOn?: InputMaybe<Scalars['Date']['input']>;
  warrantyNotes?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiresOn?: InputMaybe<Scalars['Date']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  historicalSpend?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type EditEquipmentMutationNode = { __typename: 'Mutations', editEquipment: { __typename: 'EditEquipmentMutation', ok: boolean, equipment: { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, internalTotalSpend: string | null, externalTotalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } } | null, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, vendorRanking: { __typename: 'VendorRankingNode', id: string, entries: Array<{ __typename: 'VendorRankingEntryNode', id: string, position: number, notes: string, createdAt: string, updatedAt: string, ranking: { __typename: 'VendorRankingNode', id: string } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, isVerifiedVendor: boolean | null, profile: { __typename: 'VendorProfileNode', vendorPerformanceProfile: { __typename: 'VendorPerformanceProfile', scoreSummary: { __typename: 'VendorScoreSummary', score: string | null } } | null }, businessProfile: { __typename: 'VendorBusinessProfileNode', isPublished: boolean } | null } | null } | null> | null } | null } } | null };

export type GetInboundVendorInvoiceValidationQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  invoiceFile: Scalars['String']['input'];
}>;


export type GetInboundVendorInvoiceValidationQueryNode = { __typename: 'Query', inboundVendorInvoiceValidation: { __typename: 'InboundVendorInvoiceValidationNode', validationResult: { __typename: 'InboundVendorInvoiceValidationResult', validationMessage: string, canOverride: boolean } | null } | null };

export type InviteMemberToClientOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  assignedFacilityGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assignedRoleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  noExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  inviteType?: InputMaybe<InviteType>;
}>;


export type InviteMemberToClientOrganizationMutationNode = { __typename: 'Mutations', inviteMemberToClientOrganization: { __typename: 'InviteMemberToClientOrganizationMutation', invite: { __typename: 'InviteNode', id: string } } | null };

export type InviteOwnerToOnboardingMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  ownerFirstName: Scalars['String']['input'];
  ownerLastName: Scalars['String']['input'];
}>;


export type InviteOwnerToOnboardingMutationNode = { __typename: 'Mutations', inviteOwnerToOnboarding: { __typename: 'InviteOwnerToOnboardingMutation', ok: boolean } | null };

export type MarkClientManagedInvoicesAsPaidMutationVariables = Exact<{
  input: MarkClientManagedInvoicesAsPaidInput;
}>;


export type MarkClientManagedInvoicesAsPaidMutationNode = { __typename: 'Mutations', markClientManagedInvoicesAsPaid: { __typename: 'MarkClientManagedInvoicesAsPaidPayload', clientManagedInvoices: Array<{ __typename: 'ClientManagedInvoiceNode', id: string }> } | null };

export type MarkClientManagedInvoicesAsUnpaidMutationVariables = Exact<{
  input: MarkClientManagedInvoicesAsUnpaidInput;
}>;


export type MarkClientManagedInvoicesAsUnpaidMutationNode = { __typename: 'Mutations', markClientManagedInvoicesAsUnpaid: { __typename: 'MarkClientManagedInvoicesAsUnpaidPayload', clientManagedInvoices: Array<{ __typename: 'ClientManagedInvoiceNode', id: string }> } | null };

export type Rcc_WorkOrderDetails_MarkWorkOrderAsAwaitingPaymentMutationVariables = Exact<{
  input: MarkWorkOrderAsAwaitingPaymentInput;
}>;


export type Rcc_WorkOrderDetails_MarkWorkOrderAsAwaitingPaymentMutationNode = { __typename: 'Mutations', markWorkOrderAsAwaitingPayment: { __typename: 'MarkWorkOrderAsAwaitingPaymentPayload', workOrder: { __typename: 'WorkOrderNode', id: string } } | null };

export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables = Exact<{
  input: MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput;
}>;


export type MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode = { __typename: 'Mutations', markWorkOrderTeamMemberAssignmentAsUnresolved: { __typename: 'MarkWorkOrderTeamMemberAssignmentAsUnresolvedPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type MoveAllEquipmentToAnotherFacilityMutationVariables = Exact<{
  input: MoveAllEquipmentToAnotherFacilityInput;
}>;


export type MoveAllEquipmentToAnotherFacilityMutationNode = { __typename: 'Mutations', moveAllEquipmentToAnotherFacility: { __typename: 'MoveAllEquipmentToAnotherFacilityPayload', ok: boolean } | null };

export type MoveEquipmentToFacilityMutationVariables = Exact<{
  input: MoveEquipmentToFacilityInput;
}>;


export type MoveEquipmentToFacilityMutationNode = { __typename: 'Mutations', moveEquipmentToFacility: { __typename: 'MoveEquipmentToFacilityPayload', ok: boolean } | null };

export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables = Exact<{
  input: CompleteInternalRequestTeamMemberAssignmentInput;
}>;


export type Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode = { __typename: 'Mutations', completeInternalRequestTeamMemberAssignment: { __typename: 'CompleteInternalRequestTeamMemberAssignmentPayload', assignment: { __typename: 'WorkOrderTeamMemberAssignmentNode', id: string } } | null };

export type ReactivateEquipmentMutationVariables = Exact<{
  input: ReactivateEquipmentInput;
}>;


export type ReactivateEquipmentMutationNode = { __typename: 'Mutations', reactivateEquipmentMutation: { __typename: 'ReactivateEquipmentPayload', equipment: { __typename: 'EquipmentNode', id: string, status: EquipmentStatus, barCode: string | null } } | null };

export type ReactivateFacilityMutationVariables = Exact<{
  input: ReactivateFacilityMutationInput;
}>;


export type ReactivateFacilityMutationNode = { __typename: 'Mutations', reactivateFacility: { __typename: 'ReactivateFacilityMutationPayload', ok: boolean } | null };

export type ReassignWorkOrderVendorMutationVariables = Exact<{
  input: ReassignWorkOrderVendorInput;
}>;


export type ReassignWorkOrderVendorMutationNode = { __typename: 'Mutations', reassignWorkOrderVendor: { __typename: 'ReassignWorkOrderVendorPayload', newWorkOrder: { __typename: 'WorkOrderNode', id: string } } | null };

export type RejectQuoteSetMutationVariables = Exact<{
  input: RejectQuoteSetInput;
}>;


export type RejectQuoteSetMutationNode = { __typename: 'Mutations', rejectQuoteSet: { __typename: 'RejectQuoteSetPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type RejectQuoteSetOptionForSpendMutationVariables = Exact<{
  input: RejectQuoteSetOptionForSpendInput;
}>;


export type RejectQuoteSetOptionForSpendMutationNode = { __typename: 'Mutations', rejectQuoteSetOptionForSpend: { __typename: 'RejectQuoteSetOptionForSpendPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type RemoveUserFromClientOrganizationMutationVariables = Exact<{
  clientOrganizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromClientOrganizationMutationNode = { __typename: 'Mutations', removeUserFromClientOrganization: { __typename: 'RemoveUserFromClientOrganizationMutation', ok: boolean } | null };

export type RemoveUsersFromRoleMutationVariables = Exact<{
  input: RemoveUsersFromRoleMutationInput;
}>;


export type RemoveUsersFromRoleMutationNode = { __typename: 'Mutations', removeUsersFromRole: { __typename: 'RemoveUsersFromRoleMutationPayload', ok: boolean } | null };

export type RequestDispatchChangesMutationVariables = Exact<{
  input: RequestDispatchChangesMutationInput;
}>;


export type RequestDispatchChangesMutationNode = { __typename: 'Mutations', requestDispatchChanges: { __typename: 'RequestDispatchChangesMutationPayload', ok: boolean } | null };

export type RequestPlannedMaintenanceQuoteMutationVariables = Exact<{
  input: RequestPlannedMaintenanceQuoteMutationInput;
}>;


export type RequestPlannedMaintenanceQuoteMutationNode = { __typename: 'Mutations', requestPlannedMaintenanceQuote: { __typename: 'RequestPlannedMaintenanceQuoteMutationPayload', ok: boolean } | null };

export type RescheduleAppointmentMutationVariables = Exact<{
  input: RescheduleAppointmentInput;
}>;


export type RescheduleAppointmentMutationNode = { __typename: 'Mutations', rescheduleAppointment: { __typename: 'RescheduleAppointmentPayload', appointment: { __typename: 'AppointmentNode', id: string } } | null };

export type ResendClientVendorRelationshipInviteMutationVariables = Exact<{
  input: ResendClientVendorRelationshipInviteInput;
}>;


export type ResendClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', resendClientVendorRelationshipInvite: { __typename: 'ResendClientVendorRelationshipInvitePayload', invite: { __typename: 'InviteNode', id: string } } | null };

export type RevokeClientVendorRelationshipInviteMutationVariables = Exact<{
  input: RevokeClientVendorRelationshipInviteInput;
}>;


export type RevokeClientVendorRelationshipInviteMutationNode = { __typename: 'Mutations', revokeClientVendorRelationshipInvite: { __typename: 'RevokeClientVendorRelationshipInvitePayload', ok: boolean } | null };

export type SelectQuoteSetOptionMutationVariables = Exact<{
  input: SelectQuoteSetOptionInput;
}>;


export type SelectQuoteSetOptionMutationNode = { __typename: 'Mutations', selectQuoteSetOption: { __typename: 'SelectQuoteSetOptionPayload', quoteSet: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, workOrder: { __typename: 'WorkOrderNode', id: string } | null, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } } | null };

export type SendInviteSmsMutationVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type SendInviteSmsMutationNode = { __typename: 'Mutations', sendInviteSms: { __typename: 'SendInviteSMSMutation', ok: boolean } | null };

export type SetUserNotificationPreferenceMutationVariables = Exact<{
  input: SetUserNoficationPreferenceMutationInput;
}>;


export type SetUserNotificationPreferenceMutationNode = { __typename: 'Mutations', setUserNotificationPreference: { __typename: 'SetUserNoficationPreferenceMutationPayload', userNotificationPreference: { __typename: 'UserNotificationPreferenceNode', id: string, email: boolean | null, push: boolean | null, sms: boolean | null } } | null };

export type SetupPreAuthorizedDebitMutationVariables = Exact<{
  input: SetupPreAuthorizedDebitMutationInput;
}>;


export type SetupPreAuthorizedDebitMutationNode = { __typename: 'Mutations', setupPreAuthorizedDebit: { __typename: 'SetupPreAuthorizedDebitMutationPayload', clientSecret: string, paymentMethod: { __typename: 'PaymentMethodNode', id: string, creditCardPayment: { __typename: 'CreditCardPaymentNode', funding: string | null } | null } | null } | null };

export type SnoozeReviewsMutationVariables = Exact<{
  input: SnoozeReviewsInput;
}>;


export type SnoozeReviewsMutationNode = { __typename: 'Mutations', snoozeReviews: { __typename: 'SnoozeReviewsPayload', ok: boolean | null } | null };

export type SubmitQuoteFeedbackMutationVariables = Exact<{
  arguments: SubmitQuoteFeedbackArguments;
}>;


export type SubmitQuoteFeedbackMutationNode = { __typename: 'Mutations', submitQuoteFeedback: { __typename: 'SubmitQuoteFeedbackMutation', quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null } } | null };

export type UpdateBudgetMutationVariables = Exact<{
  input: UpdateBudgetMutationInput;
}>;


export type UpdateBudgetMutationNode = { __typename: 'Mutations', updateBudget: { __typename: 'UpdateBudgetMutationPayload', budget: { __typename: 'BudgetNode', id: string, name: string, endDate: string, startDate: string, description: string } | null } | null };

export type UpdateBusinessUnitMutationVariables = Exact<{
  arguments: UpdateBusinessUnitArguments;
}>;


export type UpdateBusinessUnitMutationNode = { __typename: 'Mutations', updateBusinessUnit: { __typename: 'UpdateBusinessUnitMutation', businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> } } | null };

export type Client_ManageCategories_UpdateClientMatchingProfileMutationVariables = Exact<{
  input: UpdateClientMatchingProfileInput;
}>;


export type Client_ManageCategories_UpdateClientMatchingProfileMutationNode = { __typename: 'Mutations', updateClientMatchingProfile: { __typename: 'UpdateClientMatchingProfilePayload', clientMatchingProfile: { __typename: 'ClientMatchingProfileNode', id: string } } | null };

export type UpdateClientReportScheduleMutationVariables = Exact<{
  input: UpdateClientReportScheduleMutationInput;
}>;


export type UpdateClientReportScheduleMutationNode = { __typename: 'Mutations', updateClientReportSchedule: { __typename: 'UpdateClientReportScheduleMutationPayload', schedule: { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null } } | null };

export type UpdateDispatchMethodPreferenceMutationVariables = Exact<{
  input: UpdateDispatchMethodPreferenceInput;
}>;


export type UpdateDispatchMethodPreferenceMutationNode = { __typename: 'Mutations', updateDispatchMethodPreference: { __typename: 'UpdateDispatchMethodPreferencePayload', clientPaymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, defaultDispatchMethod: DispatchMethod } } | null };

export type UpdateFacilityMutationVariables = Exact<{
  arguments: UpdateFacilityArguments;
}>;


export type UpdateFacilityMutationNode = { __typename: 'Mutations', updateFacility: { __typename: 'UpdateFacilityMutation', facility: { __typename: 'FacilityNode', id: string, name: string, code: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, currency: Currency, status: FacilityStatus, goliveOn: string | null, storeNumber: string | null, actualGoLiveOn: string | null, plannedGoLiveOn: string | null, onboardingStatus: OnboardingStatus | null, taggingMethod: TaggingMethod | null, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, notes: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, businessLegalName: string | null, businessTaxNumber: string | null, businessLegalStructure: BusinessLegalStructure | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, clientOrganization: { __typename: 'ClientOrganizationNode', id: string, featureTier: { __typename: 'FeatureTierNode', name: string } | null }, brand: { __typename: 'BrandNode', name: string } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isDefault: boolean, isVerified: boolean, externalReferenceType: PaymentMethodExternalType | null, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }> } } | null };

export type UpdateFacilityGroupMutationVariables = Exact<{
  input: UpdateFacilityGroupInput;
}>;


export type UpdateFacilityGroupMutationNode = { __typename: 'Mutations', updateFacilityGroup: { __typename: 'UpdateFacilityGroupPayload', facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } } | null };

export type UpdateInternalRequestTeamMemberAssignmentsMutationVariables = Exact<{
  input: UpdateInternalRequestTeamMemberAssignmentsInput;
}>;


export type UpdateInternalRequestTeamMemberAssignmentsMutationNode = { __typename: 'Mutations', updateInternalRequestTeamMemberAssignments: { __typename: 'UpdateInternalRequestTeamMemberAssignmentsPayload', internalRequest: { __typename: 'InternalRequestNode', id: string } } | null };

export type UpdateInvoiceApprovalSettingsMutationVariables = Exact<{
  input: UpdateInvoiceApprovalSettingsInput;
}>;


export type UpdateInvoiceApprovalSettingsMutationNode = { __typename: 'Mutations', updateInvoiceApprovalSettings: { __typename: 'UpdateInvoiceApprovalSettingsPayload', invoiceApprovalSettings: { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, firstApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, secondApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> } } | null };

export type UpdatePaymentMethodDefaultMutationVariables = Exact<{
  input: UpdatePaymentMethodDefaultMutationInput;
}>;


export type UpdatePaymentMethodDefaultMutationNode = { __typename: 'Mutations', updatePaymentMethodDefault: { __typename: 'UpdatePaymentMethodDefaultMutationPayload', ok: boolean, paymentMethod: { __typename: 'PaymentMethodNode', id: string, isDefault: boolean } } | null };

export type UpdateQuoteAcceptanceSettingsMutationVariables = Exact<{
  input: UpdateQuoteAcceptanceSettingsInput;
}>;


export type UpdateQuoteAcceptanceSettingsMutationNode = { __typename: 'Mutations', updateQuoteAcceptanceSettings: { __typename: 'UpdateQuoteAcceptanceSettingsPayload', quoteAcceptanceSettings: { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> } } | null };

export type UpdateQuoteApprovalThresholdsMutationVariables = Exact<{
  input: UpdateQuoteApprovalThresholdsInput;
}>;


export type UpdateQuoteApprovalThresholdsMutationNode = { __typename: 'Mutations', updateQuoteApprovalThresholds: { __typename: 'UpdateQuoteApprovalThresholdsPayload', ok: boolean } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutationNode = { __typename: 'Mutations', updateRole: { __typename: 'UpdateRolePayload', role: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null } } | null };

export type UpdateTroubleshootingActionMutationVariables = Exact<{
  input: UpdateTroubleshootingActionMutationInput;
}>;


export type UpdateTroubleshootingActionMutationNode = { __typename: 'Mutations', updateTroubleshootingAction: { __typename: 'UpdateTroubleshootingActionMutationPayload', ok: boolean } | null };

export type UpdateWorkOrderNteMutationVariables = Exact<{
  input: UpdateWorkOrderNteInput;
}>;


export type UpdateWorkOrderNteMutationNode = { __typename: 'Mutations', updateWorkOrderNte: { __typename: 'UpdateWorkOrderNTEPayload', spendApproval: { __typename: 'SpendApprovalNode', id: string, approvedAmount: number } } | null };

export type UploadAfterImagesMutationVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
  images: Array<InputMaybe<Image>> | InputMaybe<Image>;
}>;


export type UploadAfterImagesMutationNode = { __typename: 'Mutations', uploadAfterImages: { __typename: 'UploadAfterImagesMutation', ok: boolean } | null };

export type UploadClientManagedInvoiceMutationVariables = Exact<{
  input: UploadClientManagedInvoiceInput;
}>;


export type UploadClientManagedInvoiceMutationNode = { __typename: 'Mutations', uploadClientManagedInvoice: { __typename: 'UploadClientManagedInvoicePayload', clientManagedInvoice: { __typename: 'ClientManagedInvoiceNode', id: string } } | null };

export type UploadVendorInvoiceMutationVariables = Exact<{
  input: UploadVendorInvoiceInput;
}>;


export type UploadVendorInvoiceMutationNode = { __typename: 'Mutations', uploadVendorInvoice: { __typename: 'UploadVendorInvoicePayload', inboundVendorInvoice: { __typename: 'InboundVendorInvoiceNode', workOrder: { __typename: 'WorkOrderNode', id: string }, invoiceFile: { __typename: 'FileType', key: string } } } | null };

export type CreateUpdateExternalReferenceMutationVariables = Exact<{
  input: CreateUpdateExternalReferenceMutationInput;
}>;


export type CreateUpdateExternalReferenceMutationNode = { __typename: 'Mutations', createUpdateExternalReference: { __typename: 'CreateUpdateExternalReferenceMutationPayload', ok: boolean | null } | null };

export type DetermineTroubleshootingPlanQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  equipmentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxonomyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DetermineTroubleshootingPlanQueryNode = { __typename: 'Query', determineTroubleshootingPlan: { __typename: 'DetermineTroubleshootingPlanNode', id: string, troubleshootingPlan: { __typename: 'TroubleshootingPlanNode', id: string, troubleshootingSteps: Array<{ __typename: 'TroubleshootingStepNode', id: string, order: number, stepDescription: string, supportLink: string } | null> } | null } | null };

export type GetActivityFeedEntriesQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  isVendor?: Scalars['Boolean']['input'];
}>;


export type GetActivityFeedEntriesQueryNode = { __typename: 'Query', activityFeed: { __typename: 'ActivityFeedEntryNodeConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'ActivityFeedEntryNodeEdge', node: { __typename: 'ActivityFeedEntryNode', id: string, entryType: ActivityFeedEntryEntryType, createdAt: string, activityDate: string, defaultMessage: string, internalMessage?: string | null, parameters: any, triggeredBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null } | null> } | null };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppointmentQueryNode = { __typename: 'Query', appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> } | null }, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } | null };

export type GetBusinessUnitDetailsQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetBusinessUnitDetailsQueryNode = { __typename: 'Query', businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }>, members: Array<{ __typename: 'BusinessUnitMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> } | null };

export type GetBusinessUnitsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBusinessUnitsQueryNode = { __typename: 'Query', businessUnits: { __typename: 'BusinessUnitNodeConnection', totalCount: number, edges: Array<{ __typename: 'BusinessUnitNodeEdge', node: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null> } | null };

export type GetCanWorkOrderBeForceCompletedQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
}>;


export type GetCanWorkOrderBeForceCompletedQueryNode = { __typename: 'Query', workOrder: { __typename: 'WorkOrderNode', canBeForceCompleted: boolean } | null };

export type GetCitiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetCitiesQueryNode = { __typename: 'Query', cities: { __typename: 'CityNodeConnection', edges: Array<{ __typename: 'CityNodeEdge', node: { __typename: 'CityNode', id: string, name: string } | null } | null> } | null };

export type GetClientDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientDetailsQueryNode = { __typename: 'Query', clientOrganization: { __typename: 'ClientOrganizationNode', id: string, name: string, trackingId: number, hasActiveProtectionPlanConfiguration: boolean, hasVendorIssuedInvoices: boolean, lendingEnabled: boolean | null, clientStatus: ClientOrganizationStatus | null, isSubscriptionLive: boolean, isSubscriptionMigrated: boolean, contractSignedOn: string | null, viewerDailyMenuFirstRunConfirmed: boolean, viewerDailyMenuFirstRunConfirmedAt: string | null, hasMissingSubscriptionPaymentMethod: boolean, canManageStaff: boolean, canManageBusinessSettings: boolean, canAccessStatements: boolean, canAccessSubscriptions: boolean, canSubmitWorkOrder: boolean, canSelectQuotes: boolean, canApproveQuotes: boolean, canPay: boolean, canApprove: boolean, canManageFavouriteVendors: boolean, canManagePreventativeMaintenance: boolean, canManageProjects: boolean, owner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency, paymentTerms: number | null, isAutopay: boolean, isDirectVendorPayment: boolean, operatingCountry: { __typename: 'CountryNode', id: string, code: string | null } }, creditCardFeeNotice: { __typename: 'CreditCardFeeNotice', isNoticeActive: boolean, isFeeEffective: boolean, feeEffectiveOn: string, defaultRatePercentage: string | null, exemptFacilityRegionNames: Array<string>, regionalRateOverrides: Array<{ __typename: 'CreditCardFeeNoticeRegionalRateOverride', regionName: string, ratePercentage: string }> } | null, matchingProfile: { __typename: 'ClientMatchingProfileNode', id: string, favouriteVendorsImported: boolean | null, optedIntoMarketplace: boolean } | null, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string, status: FacilityStatus, canManage: boolean, canManageEquipment: boolean, brand: { __typename: 'BrandNode', id: string, name: string, logo: { __typename: 'ImageType', url: string } | null } | null }>, successOwner: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, paymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, invoiceApprovalStrategy: InvoiceApprovalStrategy, paymentMethod: PaymentMethodType }, pricingModel: { __typename: 'PricingModelNode', id: string, name: PricingModelName } | null, featureTier: { __typename: 'FeatureTierNode', id: string, name: string } | null } | null };

export type GetClientFeaturesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetClientFeaturesQueryNode = { __typename: 'Query', clientFeatures: Array<ClientFeature | null> | null };

export type GetClientInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  clientOrganizationId: Scalars['ID']['input'];
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ClientInvoiceStatus> | ClientInvoiceStatus>;
  serviceCategory?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscriptionInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtStartDate?: InputMaybe<Scalars['Date']['input']>;
  paidAtEndDate?: InputMaybe<Scalars['Date']['input']>;
  expenseTypes?: InputMaybe<Array<InputMaybe<ExpenseType>> | InputMaybe<ExpenseType>>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  dueAtDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetClientInvoicesQueryNode = { __typename: 'Query', clientInvoices: { __typename: 'ClientInvoiceNodeConnection', totalCount: number, total: string, edges: Array<{ __typename: 'ClientInvoiceNodeEdge', node: { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetClientMetricsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  periodStart: Scalars['DateTime']['input'];
  periodEnd: Scalars['DateTime']['input'];
  lastPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  lastPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  serviceTypes?: InputMaybe<Array<ServiceType> | ServiceType>;
  serviceCategories?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  userTz?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientMetricsQueryNode = { __typename: 'Query', clientMetrics: { __typename: 'ClientMetricsNode', clientId: string, spendThisPeriod: string, combinedSpend: Array<{ __typename: 'SpendByPeriod', spendAmount: string, internalSpendAmount: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } }>, combinedUninvoiced: Array<{ __typename: 'UninvoicedByPeriod', count: number, period: { __typename: 'MetricsPeriod', start: string, end: string } }>, serviceCategorySpend: Array<{ __typename: 'SpendByServiceCategory', serviceCategory: ServiceCategory, spendAmount: string, internalSpendAmount: string | null }>, mostServicedEquipment: Array<{ __typename: 'EquipmentServiceCount', count: number, equipment: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } | null } }>, lastMonthSpendComparison: { __typename: 'PeriodicSpendComparison', spendAmount: string, differencePercent: string | null, period: { __typename: 'MetricsPeriod', start: string, end: string } }, spendThisPeriodBreakdown: { __typename: 'SpendThisPeriodBreakdown', totalSpend: string, externalSpend: string, internalSpend: string }, topSpendWorkOrders: Array<{ __typename: 'TopSpendWorkOrders', spendAmount: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, completedOn: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, internalRequest: { __typename: 'InternalRequestNode', id: string, completion: { __typename: 'InternalRequestCompletionNode', id: string, completionDate: string | null } | null } | null } }>, topSpendFacilities: Array<{ __typename: 'TopSpendFacilities', facilityName: string, spendAmount: string, percentDifference: string, internalSpendAmount: string | null, externalSpendAmount: string | null }>, averageMonthlyFacilitySpend: Array<{ __typename: 'AverageMonthlyFacilitySpend', date: string, avgRepairSpend: string, avgMpSpend: string, avgInternalSpend: string, avgInternalMpSpend: string }>, workOrdersAwaitingPayment: { __typename: 'WorkOrdersAwaitingPayment', overdueCount: number, awaitingPayment: number } } | null };

export type GetClientOrganizationMembersQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  onlyColleaguesOfUser?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetClientOrganizationMembersQueryNode = { __typename: 'Query', clientOrganizationMembers: { __typename: 'ClientOrganizationMemberNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientOrganizationMemberNodeEdge', node: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } }>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> } | null } | null> } | null };

export type GetClientPaymentPreferenceQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetClientPaymentPreferenceQueryNode = { __typename: 'Query', clientOrganization: { __typename: 'ClientOrganizationNode', id: string, paymentPreference: { __typename: 'ClientPaymentPreferenceNode', id: string, defaultDispatchMethod: DispatchMethod } } | null };

export type GetClientPerformanceMetricsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  periodStart: Scalars['DateTime']['input'];
  periodEnd: Scalars['DateTime']['input'];
  serviceTypes?: InputMaybe<Array<ServiceType> | ServiceType>;
  serviceCategories?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
}>;


export type GetClientPerformanceMetricsQueryNode = { __typename: 'Query', clientMetrics: { __typename: 'ClientMetricsNode', clientId: string, quotesAwaitingClientApproval: number, invoicesAwaitingClientApproval: number, workOrdersAwaitingTriage: number, workOrdersCompleted: number, transactingFacilities: number, workOrdersSubmitted: { __typename: 'WorkOrdersSubmitted', urgentCount: number, nonUrgentCount: number }, averageSchedulingSpeed: { __typename: 'AverageSchedulingSpeed', hasData: boolean, months: number, days: number, hours: number, minutes: number }, reviewSummary: { __typename: 'ReviewSummary', goodReviewCount: number, badReviewCount: number, goodReviewTags: Array<string>, badReviewTags: Array<string> }, workOrdersByStatus: { __typename: 'WorkOrdersByStatus', submitted: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, scheduled: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, onHold: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, completed: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number }, invoiced: { __typename: 'OnDemandAndMaintenancePlanCounts', onDemand: number, maintenancePlan: number } }, workOrdersByCategory: Array<{ __typename: 'ServiceCategoryCount', serviceCategory: ServiceCategory, count: number }> } | null };

export type GetClientReportSchedulesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetClientReportSchedulesQueryNode = { __typename: 'Query', clientReportSchedules: { __typename: 'ClientReportScheduleNodeConnection', edges: Array<{ __typename: 'ClientReportScheduleNodeEdge', node: { __typename: 'ClientReportScheduleNode', id: string, frequency: ClientReportFrequency, reportType: ClientReportType, recipientEmailAddresses: Array<string>, nextReportOn: string | null, lastReportOn: string | null } | null } | null> } | null };

export type GetClientReportsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  reportType?: InputMaybe<Array<InputMaybe<ClientReportType>> | InputMaybe<ClientReportType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientReportsQueryNode = { __typename: 'Query', clientReports: { __typename: 'ClientReportNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientReportNodeEdge', node: { __typename: 'ClientReportNode', id: string, reportType: ClientReportType, generatedOn: string, startDate: string, endDate: string, csvUrl: string | null } | null } | null> } | null };

export type GetClientStatementsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  businessUnitId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClientStatementsQueryNode = { __typename: 'Query', clientStatements: { __typename: 'ClientMonthlyStatementNodeConnection', totalCount: number, edges: Array<{ __typename: 'ClientMonthlyStatementNodeEdge', node: { __typename: 'ClientMonthlyStatementNode', id: string, createdAt: string, year: number, month: number, agingReportPdfUrl: string | null, transactionSummaryCsvUrl: string | null, businessUnit: { __typename: 'BusinessUnitNode', id: string } } | null } | null> } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQueryNode = { __typename: 'Query', countries: { __typename: 'CountryNodeConnection', edges: Array<{ __typename: 'CountryNodeEdge', node: { __typename: 'CountryNode', id: string, name: string, code: string | null } | null } | null> } | null };

export type GetClientPreferredSpendThresholdQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  serviceCategory: ServiceCategory;
}>;


export type GetClientPreferredSpendThresholdQueryNode = { __typename: 'Query', clientPreferredSpendThreshold: { __typename: 'ClientPreferredSpendThresholdNode', approvalRequiredThreshold: number, approvalRequiredOvertimeThreshold: number } | null };

export type GetEquipmentQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  serviceStartDate?: InputMaybe<Scalars['Date']['input']>;
  serviceEndDate?: InputMaybe<Scalars['Date']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEquipmentQueryNode = { __typename: 'Query', equipments: { __typename: 'EquipmentNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentNodeEdge', node: { __typename: 'EquipmentNode', id: string, name: string, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, totalSpend: string | null, historicalSpend: string | null, cost: string | null, shouldUpdateWarranty: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string, taxonomyNode: { __typename: 'TaxonomyNodeNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetEquipmentDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEquipmentDetailsQueryNode = { __typename: 'Query', equipment: { __typename: 'EquipmentNode', id: string, name: string, description: string | null, barCode: string | null, status: EquipmentStatus, installedOn: string | null, warrantyNotes: string | null, warrantyExpiresOn: string | null, manufacturer: string | null, modelNo: string | null, location: string, totalSpend: string | null, internalTotalSpend: string | null, externalTotalSpend: string | null, historicalSpend: string | null, cost: string | null, serialNo: string | null, serviceCategory: ServiceCategory | null, facility: { __typename: 'FacilityNode', id: string, name: string, phone: string, timezone: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, zipCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, name: string } } | null, mainImage: { __typename: 'ImageType', url: string } | null, modelTagImage: { __typename: 'ImageType', url: string } | null, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }>, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, vendorRanking: { __typename: 'VendorRankingNode', id: string, entries: Array<{ __typename: 'VendorRankingEntryNode', id: string, position: number, notes: string, createdAt: string, updatedAt: string, ranking: { __typename: 'VendorRankingNode', id: string } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, isVerifiedVendor: boolean | null, profile: { __typename: 'VendorProfileNode', vendorPerformanceProfile: { __typename: 'VendorPerformanceProfile', scoreSummary: { __typename: 'VendorScoreSummary', score: string | null } } | null }, businessProfile: { __typename: 'VendorBusinessProfileNode', isPublished: boolean } | null } | null } | null> | null } | null } | null };

export type GetEquipmentShortVersionQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  equipmentCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  serviceStartDate?: InputMaybe<Scalars['Date']['input']>;
  serviceEndDate?: InputMaybe<Scalars['Date']['input']>;
  hasOngoingIncident?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensor?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  incidentStatus?: InputMaybe<Array<IncidentStatus> | IncidentStatus>;
  statuses?: InputMaybe<Array<EquipmentStatus> | EquipmentStatus>;
}>;


export type GetEquipmentShortVersionQueryNode = { __typename: 'Query', equipments: { __typename: 'EquipmentNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentNodeEdge', node: { __typename: 'EquipmentNode', id: string, name: string, manufacturer: string | null, barCode: string | null, status: EquipmentStatus, workOrderCount: number, serviceCategory: ServiceCategory | null, shouldUpdateWarranty: boolean, totalSpend: string | null, cost: string | null, historicalSpend: string | null, facility: { __typename: 'FacilityNode', name: string, id: string, canManageEquipment: boolean } | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, devices: Array<{ __typename: 'Device', id: string, name: string }>, incidents: Array<{ __typename: 'Incident', id: string }> } | null } | null> } | null };

export type GetEquipmentSymptomsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEquipmentSymptomsQueryNode = { __typename: 'Query', equipment: { __typename: 'EquipmentNode', id: string, symptoms: Array<{ __typename: 'TaxonomySymptomNode', id: string, description: string }> } | null };

export type GetEquipmentWorkOrdersQueryVariables = Exact<{
  equipmentId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEquipmentWorkOrdersQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null> } | null };

export type GetExpenseTypePermissionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseTypePermissionsQueryNode = { __typename: 'Query', clientOrganization: { __typename: 'ClientOrganizationNode', id: string, canUpdateExpenseType: boolean } | null };

export type GetFacilitiesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  isMissingBrd?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFacilitiesQueryNode = { __typename: 'Query', facilities: { __typename: 'FacilityNodeConnection', totalCount: number, edges: Array<{ __typename: 'FacilityNodeEdge', node: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } | null> } | null };

export type GetFacilityDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFacilityDetailsQueryNode = { __typename: 'Query', facility: { __typename: 'FacilityNode', id: string, name: string, code: string, address: string, addressLine2: string | null, cityName: string | null, zipCode: string, postalCode: string, phone: string, email: string, currency: Currency, status: FacilityStatus, goliveOn: string | null, storeNumber: string | null, actualGoLiveOn: string | null, plannedGoLiveOn: string | null, onboardingStatus: OnboardingStatus | null, taggingMethod: TaggingMethod | null, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, notes: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, businessLegalName: string | null, businessTaxNumber: string | null, businessLegalStructure: BusinessLegalStructure | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, clientOrganization: { __typename: 'ClientOrganizationNode', id: string, featureTier: { __typename: 'FeatureTierNode', name: string } | null }, brand: { __typename: 'BrandNode', name: string } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null, paymentMethod: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isDefault: boolean, isVerified: boolean, externalReferenceType: PaymentMethodExternalType | null, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null, group: { __typename: 'FacilityGroupNode', id: string, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }> } | null };

export type GetVendorSearchFacilityEquipmentQueryVariables = Exact<{
  facilityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVendorSearchFacilityEquipmentQueryNode = { __typename: 'Query', equipments: { __typename: 'EquipmentNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentNodeEdge', node: { __typename: 'EquipmentNode', id: string, name: string, manufacturer: string | null, isUnderCyovWarranty: boolean | null, equipmentCategory: { __typename: 'EquipmentCategoryNode', id: string, name: string } | null, facility: { __typename: 'FacilityNode', id: string, name: string } | null } | null } | null> } | null };

export type GetFacilityGroupAllMembershipsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFacilityGroupAllMembershipsQueryNode = { __typename: 'Query', facilityGroup: { __typename: 'FacilityGroupNode', id: string, allMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> } | null };

export type GetFacilityGroupsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  excludeLeaf?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFacilityGroupsQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, qrSubmissionAuthenticationMode: QrSubmissionAuthenticationMode | null, parentId: string | null, memberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }>, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } | null } | null> } | null };

export type GetFacilityGroupsForBudgetCreationQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFacilityGroupsForBudgetCreationQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> } | null } | null> } | null };

export type FacilityGroupForBudgetCreationFragment = { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string } | null, children: Array<{ __typename: 'FacilityGroupNode', id: string }> };

export type GetFacilityGroupsForSelectionQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  onlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  activeFacilityOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFacilityGroupsForSelectionQueryNode = { __typename: 'Query', facilityGroups: { __typename: 'FacilityGroupNodeConnection', pageInfo: { __typename: 'PageInfo', endCursor: string | null }, edges: Array<{ __typename: 'FacilityGroupNodeEdge', node: { __typename: 'FacilityGroupNode', id: string, name: string, parentId: string | null, permissions: { __typename: 'FacilityGroupPermissions', manage: boolean } } | null } | null> } | null };

export type GetInvitesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInvitesQueryNode = { __typename: 'Query', invites: { __typename: 'InviteNodeConnection', totalCount: number, edges: Array<{ __typename: 'InviteNodeEdge', node: { __typename: 'InviteNode', id: string, firstName: string, lastName: string, phoneNumber: string, emailAddress: string, expiresAt: string | null, hasOnboardingAction: boolean, canCancel: boolean, assignedFacilityGroups: Array<{ __typename: 'FacilityGroupNode', id: string, name: string }>, assignedRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> } | null } | null> } | null };

export type GetInvoiceApprovalSettingsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetInvoiceApprovalSettingsQueryNode = { __typename: 'Query', invoiceApprovalSettings: { __typename: 'InvoiceApprovalSettings', strategy: InvoiceApprovalStrategy, approvalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, firstApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, secondApprovalRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> } | null };

export type InvoicePaymentsPreviewQueryVariables = Exact<{
  workOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InvoicePaymentsPreviewQueryNode = { __typename: 'Query', invoicePaymentsPreview: { __typename: 'InvoicePaymentPreview', total: string, invoiceCount: string, workOrderCount: number, creditCardPreviews: Array<{ __typename: 'CreditCardPaymentPreview', total: string, creditCardLastFour: string, brand: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, invoiceSets: Array<{ __typename: 'InvoiceSetNode', id: string }> }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null, eftPreviews: Array<{ __typename: 'PreAuthorizedDebitPreview', total: string, accountNumberLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, invoiceSets: Array<{ __typename: 'InvoiceSetNode', id: string }> }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null, achPreviews: Array<{ __typename: 'PreAuthorizedDebitPreview', total: string, accountNumberLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, invoiceSets: Array<{ __typename: 'InvoiceSetNode', id: string }> }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, workOrderCount: number, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null } | null };

export type InvoicePaymentsPreviewPreEftQueryVariables = Exact<{
  workOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InvoicePaymentsPreviewPreEftQueryNode = { __typename: 'Query', invoicePaymentsPreview: { __typename: 'InvoicePaymentPreview', total: string, invoiceCount: string, creditCardPreviews: Array<{ __typename: 'CreditCardPaymentPreview', total: string, creditCardLastFour: string, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string }>, facilityPreviews: Array<{ __typename: 'FacilityPaymentPreview', total: string, invoiceCount: string, facility: { __typename: 'FacilityNode', id: string, name: string } }> }> | null } | null };

export type GetMaintenancePlanDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMaintenancePlanDetailsQueryNode = { __typename: 'Query', maintenancePlan: { __typename: 'MaintenancePlanNode', nextWorkOrderCreationDate: string, canDirectlyChangeDate: boolean, scopeOfWork: string, serviceFrequencyUnit: MaintenancePlanFrequencyUnit | null, serviceFrequencyValue: number | null, status: MaintenancePlanStatus, source: MaintenancePlanSource, selfService: boolean, id: string, code: string, name: string | null, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, contractEndDate: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, workOrders: Array<{ __typename: 'WorkOrderNode', id: string, code: string, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, completedOn: string | null, spend: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null }>, currentWorkOrder: { __typename: 'WorkOrderNode', id: string, completedOn: string | null } | null, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } } | null };

export type GetMaintenancePlanTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenancePlanTypesQueryNode = { __typename: 'Query', maintenancePlanTypes: { __typename: 'MaintenancePlanTypeNodeConnection', edges: Array<{ __typename: 'MaintenancePlanTypeNodeEdge', node: { __typename: 'MaintenancePlanTypeNode', id: string, name: string, description: string, defaultServiceFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultServiceFrequencyValue: number | null, defaultBillingFrequencyUnit: MaintenancePlanFrequencyUnit | null, defaultBillingFrequencyValue: number | null, defaultVariablePricing: boolean, defaultInitialWorkOrderStatus: MaintenancePlanInitialWorkOrderStatus, serviceCategory: ServiceCategory, image: { __typename: 'ImageType', url: string } } | null } | null> } | null };

export type GetMaintenancePlansQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  maintenancePlanTypeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>> | InputMaybe<ServiceCategory>>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMaintenancePlansQueryNode = { __typename: 'Query', maintenancePlans: { __typename: 'MaintenancePlanNodeConnection', totalCount: number, edges: Array<{ __typename: 'MaintenancePlanNodeEdge', node: { __typename: 'MaintenancePlanNode', id: string, code: string, name: string | null, status: MaintenancePlanStatus, source: MaintenancePlanSource, selfService: boolean, billingFrequencyUnit: MaintenancePlanFrequencyUnit, billingFrequencyValue: number, currency: Currency, price: string, variablePricing: boolean, nextWorkOrderCreationDate: string, contractEndDate: string | null, facility: { __typename: 'FacilityNode', id: string, name: string } | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, maintenancePlanType: { __typename: 'MaintenancePlanTypeNode', id: string, name: string } } | null } | null> } | null };

export type GetManufacturersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManufacturersQueryNode = { __typename: 'Query', equipmentManufacturers: { __typename: 'EquipmentManufacturerNodeConnection', totalCount: number, edges: Array<{ __typename: 'EquipmentManufacturerNodeEdge', node: { __typename: 'EquipmentManufacturerNode', id: string, name: string } | null } | null> } | null };

export type Orc_Settings_GetOffResqCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type Orc_Settings_GetOffResqCustomersQueryNode = { __typename: 'Query', offResqCustomers: { __typename: 'OffResqCustomerNodeConnection', edges: Array<{ __typename: 'OffResqCustomerNodeEdge', node: { __typename: 'OffResqCustomerNode', id: string, name: string | null, legalName: string | null, businessDateOfIncorporation: string | null, businessLegalStructure: BusinessLegalStructure | null, businessTaxNumber: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, cityName: string | null, postalCode: string, province: { __typename: 'ProvinceNode', id: string, name: string, code: string | null }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'OffResqFacilityNode', id: string, name: string }> } | null } | null> } | null };

export type Orc_Settings_BusinessDetailsFragment = { __typename: 'OffResqCustomerNode', id: string, name: string | null, legalName: string | null, businessDateOfIncorporation: string | null, businessLegalStructure: BusinessLegalStructure | null, businessTaxNumber: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, cityName: string | null, postalCode: string, province: { __typename: 'ProvinceNode', id: string, name: string, code: string | null }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'OffResqFacilityNode', id: string, name: string }> };

export type Rmc_Staff_GetOrganizationSeatsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type Rmc_Staff_GetOrganizationSeatsQueryNode = { __typename: 'Query', perUserSubscriptions: { __typename: 'PerUserSubscriptionNodeConnection', edges: Array<{ __typename: 'PerUserSubscriptionNodeEdge', node: { __typename: 'PerUserSubscriptionNode', id: string, actualUserCount: number, billableUserCount: number, currentBillableMemberCount: number, availableSeats: number, configuration: { __typename: 'PerUserSubscriptionConfigurationNode', id: string, includedUsers: number, minimumBillableUsers: number } | null } | null } | null> } | null, clientOrganizationMembers: { __typename: 'ClientOrganizationMemberNodeConnection', edges: Array<{ __typename: 'ClientOrganizationMemberNodeEdge', node: { __typename: 'ClientOrganizationMemberNode', id: string, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null } | null> } | null };

export type GetOvertimeStatusQueryVariables = Exact<{
  facilityId: Scalars['ID']['input'];
}>;


export type GetOvertimeStatusQueryNode = { __typename: 'Query', overtimeStatus: { __typename: 'OvertimeStatus', isOvertime: boolean } | null };

export type GetPaymentMethodsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaymentMethodsQueryNode = { __typename: 'Query', paymentMethods: { __typename: 'PaymentMethodNodeConnection', totalCount: number, edges: Array<{ __typename: 'PaymentMethodNodeEdge', node: { __typename: 'PaymentMethodNode', id: string, paymentType: PaymentMethodPaymentType, isDefault: boolean, isVerified: boolean, externalReferenceType: PaymentMethodExternalType | null, facilityCount: number, creditCardPayment: { __typename: 'CreditCardPaymentNode', id: string, brand: string | null, number: string, cardholderName: string, expiryMonth: string, expiryYear: string } | null, preAuthorizedDebitPayment: { __typename: 'PreAuthorizedDebitPaymentNode', id: string, bankName: string, accountNumber: string } | null, achAccountPayment: { __typename: 'ACHAccountNode', id: string, bankName: string, accountNumber: string, status: AchStatus | null } | null } | null } | null> } | null };

export type GetProvincesQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
}>;


export type GetProvincesQueryNode = { __typename: 'Query', provinces: { __typename: 'ProvinceNodeConnection', edges: Array<{ __typename: 'ProvinceNodeEdge', node: { __typename: 'ProvinceNode', id: string, code: string | null, name: string } | null } | null> } | null };

export type GetQuoteAcceptanceSettingsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetQuoteAcceptanceSettingsQueryNode = { __typename: 'Query', quoteAcceptanceSettings: { __typename: 'QuoteAcceptanceSettings', selectionRoles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, approvalThresholds: Array<{ __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> }> } | null };

export type GetQuoteApprovalThresholdsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  roleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  threshold?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type GetQuoteApprovalThresholdsQueryNode = { __typename: 'Query', quoteApprovalThresholds: { __typename: 'QuoteApprovalThresholdNodeConnection', edges: Array<{ __typename: 'QuoteApprovalThresholdNodeEdge', node: { __typename: 'QuoteApprovalThresholdNode', id: string, threshold: string | null, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }> } | null } | null> } | null };

export type GetQuoteSetsQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  statuses: Array<QuoteSetStatus> | QuoteSetStatus;
}>;


export type GetQuoteSetsQueryNode = { __typename: 'Query', quoteSets: { __typename: 'QuoteSetNodeConnection', edges: Array<{ __typename: 'QuoteSetNodeEdge', node: { __typename: 'QuoteSetNode', id: string, status: QuoteSetStatus, createdAt: string, rejectedAt: string | null, rejectionReason: string, expectedPrice: string | null, cancelledAt: string | null, cancelReason: string, remainingApprovalSteps: number, options: Array<{ __typename: 'QuoteSetOptionNode', id: string, outcome: QuoteSetOptionOutcome | null, rejectReasons: Array<string>, createdAt: string, selectedAt: string | null, rejectedAt: string | null, quote: { __typename: 'QuoteNode', id: string, code: string, price: string, currency: Currency, feedbackCount: number, validUntil: string | null, notes: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string, email: string }, invites: Array<{ __typename: 'InviteNode', id: string, emailAddress: string }>, tradeQualifications: Array<{ __typename: 'VendorTradeQualificationNode', id: string, serviceCategory: ServiceCategory }> }, pdfFile: { __typename: 'FileType', url: string } | null }, approvals: Array<{ __typename: 'QuoteSetOptionApprovalNode', id: string, approvedAt: string, approvedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, approvedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null }>, approvalNeededRoles: Array<Array<{ __typename: 'RoleNode', id: string, name: string }>>, selectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, selectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, rejectedByMember: { __typename: 'ClientOrganizationMemberNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> } | null, permissions: { __typename: 'QuoteSetOptionPermissions', select: boolean, actionOnSpend: boolean, selectAndApproveSpend: boolean, provideFeedback: boolean } }>, rejectedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, cancelledBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, permissions: { __typename: 'QuoteSetPermissions', reject: boolean } } | null } | null> } | null };

export type GetReviewRequestsQueryVariables = Exact<{
  workOrder?: InputMaybe<Scalars['ID']['input']>;
  statusIn?: InputMaybe<Array<ReviewRequestStatus> | ReviewRequestStatus>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isDueForReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReviewRequestsQueryNode = { __typename: 'Query', reviewRequests: { __typename: 'ReviewRequestNodeConnection', edges: Array<{ __typename: 'ReviewRequestNodeEdge', node: { __typename: 'ReviewRequestNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, title: string, correlationId: string | null, facility: { __typename: 'FacilityNode', id: string, name: string, timezone: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } } | null } | null> } | null };

export type GetRoleDetailsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type GetRoleDetailsQueryNode = { __typename: 'Query', role: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null } | null };

export type GetRolesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  onlySubsetOfUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRolesQueryNode = { __typename: 'Query', roles: { __typename: 'RoleNodeConnection', totalCount: number, edges: Array<{ __typename: 'RoleNodeEdge', node: { __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null } | null } | null> } | null };

export type GetSourcingPartsHoldsQueryVariables = Exact<{
  workOrder: Scalars['ID']['input'];
}>;


export type GetSourcingPartsHoldsQueryNode = { __typename: 'Query', sourcingPartsHolds: { __typename: 'SourcingPartsHoldConnection', edges: Array<{ __typename: 'SourcingPartsHoldEdge', node: { __typename: 'SourcingPartsHold', id: string, partsEstimatedDateStart: string | null, partsEstimatedDateEnd: string | null, permissions: { __typename: 'SourcingPartsHoldPermissions', fulfill: boolean }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } } | null } | null> } | null };

export type GetStripeCustomersQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  offResqCustomerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetStripeCustomersQueryNode = { __typename: 'Query', stripeCustomers: { __typename: 'StripeCustomerNodeConnection', edges: Array<{ __typename: 'StripeCustomerNodeEdge', node: { __typename: 'StripeCustomerNode', id: string, account: StripeAccount } | null } | null> } | null };

export type Rcc_GetTaxRatesQueryVariables = Exact<{
  invoiceSetId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  recordOfWorkId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type Rcc_GetTaxRatesQueryNode = { __typename: 'Query', taxRates: { __typename: 'TaxRateNodeConnection', edges: Array<{ __typename: 'TaxRateNodeEdge', node: { __typename: 'TaxRateNode', id: string, name: TaxRateName, rate: string, validTo: string | null, validFrom: string | null, permissions: { __typename: 'TaxRatePermissions', update: boolean } } | null } | null> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQueryNode = { __typename: 'Query', user: { __typename: 'UserNode', id: string, accountType: AccountType, firstName: string, lastName: string, username: string, email: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, title: string | null }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, canManage: boolean, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, editable: boolean, name: string, permissions: Array<Permission>, userCount: number, isWorkOrderObserver: boolean, workOrderObserverType: { __typename: 'WorkOrderObserverTypeType', key: WorkOrderObserverType, label: string } | null }>, businessUnits: Array<{ __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> }> }>, facilityGroupMemberships: Array<{ __typename: 'FacilityGroupMembershipNode', id: string, facilityGroup: { __typename: 'FacilityGroupNode', id: string, name: string, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null } | null } }> } | null };

export type GetUserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationPreferencesQueryNode = { __typename: 'Query', userNotificationPreferences: { __typename: 'UserNotificationPreferenceConnection', totalCount: number, edges: Array<{ __typename: 'UserNotificationPreferenceEdge', node: { __typename: 'UserNotificationPreferenceNode', id: string, notificationName: string, email: boolean | null, push: boolean | null, sms: boolean | null, emailConfigurable: boolean | null, pushConfigurable: boolean | null, smsConfigurable: boolean | null, emailImplemented: boolean | null, pushImplemented: boolean | null, smsImplemented: boolean | null } | null } | null> } | null };

export type GetUserSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserSummaryQueryNode = { __typename: 'Query', user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null };

export type GetVisitReviewRequestsQueryVariables = Exact<{
  appointment?: InputMaybe<Scalars['ID']['input']>;
  statusIn?: InputMaybe<Array<VisitReviewRequestStatus> | VisitReviewRequestStatus>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVisitReviewRequestsQueryNode = { __typename: 'Query', visitReviewRequests: { __typename: 'VisitReviewRequestNodeConnection', edges: Array<{ __typename: 'VisitReviewRequestNodeEdge', node: { __typename: 'VisitReviewRequestNode', id: string, workOrder: { __typename: 'WorkOrderNode', id: string, title: string, code: string, serviceCategory: ServiceCategory, facility: { __typename: 'FacilityNode', id: string, timezone: string, name: string } }, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string }, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null } | null } | null> } | null };

export type GetVisitsQueryVariables = Exact<{
  workOrder: Scalars['ID']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVisitsQueryNode = { __typename: 'Query', visits: { __typename: 'VisitNodeConnection', edges: Array<{ __typename: 'VisitNodeEdge', node: { __typename: 'VisitNode', id: string, startedAt: string, endedAt: string | null, facilityManagerName: string | null, facilityManagerSignatureUrl: string | null, notes: string, recommendations: string, outcome: VisitOutcome | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null } | null, visitedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, beforeImages: Array<{ __typename: 'ImageNode', id: string, url: string }>, afterImages: Array<{ __typename: 'ImageNode', id: string, url: string }> } | null } | null> } | null };

export type GetWorkOrderActivitiesQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
}>;


export type GetWorkOrderActivitiesQueryNode = { __typename: 'Query', activities: { __typename: 'ActivityConnection', edges: Array<{ __typename: 'ActivityEdge', node:
        | { __typename: 'AppointmentActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, fulfilledAt: string | null, cancelledAt: string | null, permissions: { __typename: 'AppointmentPermissions', reschedule: boolean } } }
        | { __typename: 'ApproveQuoteActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'ChooseVendorActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'CreateQuoteActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'DispatchActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'OnHoldActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'ResqReviewActivity', reviewType: ResqReviewActivityReviewType, id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'SchedulingActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'SiteVisitActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
        | { __typename: 'SourcingPartsActivity', id: string, activityType: ActivityType, startedAt: string, endedAt: string | null, cancelledAt: string | null, dueAt: string }
       | null } | null> } | null };

export type GetWorkOrderCancellationDetailQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
}>;


export type GetWorkOrderCancellationDetailQueryNode = { __typename: 'Query', workOrderCancellationDetail: { __typename: 'WorkOrderCancellationDetailNodeConnection', edges: Array<{ __typename: 'WorkOrderCancellationDetailNodeEdge', node: { __typename: 'WorkOrderCancellationDetailNode', id: string, cancelReason: WorkOrderCancellationReason | null } | null } | null> } | null };

export type GetWorkOrderClientInvoicesQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
}>;


export type GetWorkOrderClientInvoicesQueryNode = { __typename: 'Query', clientInvoices: { __typename: 'ClientInvoiceNodeConnection', edges: Array<{ __typename: 'ClientInvoiceNodeEdge', node: { __typename: 'ClientInvoiceNode', id: string, code: string, dueAtDate: string, issuedAtDate: string, outstandingAmount: string, paidAmount: number, paidAt: string | null, pdfUrl: string | null, status: ClientInvoiceStatus, subtotal: string, tax: string, total: number, currency: Currency, expenseType: ExpenseType | null, externalReferenceNumber: string | null, latestFailureReason: string | null, paymentInitiatedAt: string | null, paymentInitiatedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string } | null, workOrder: { __typename: 'WorkOrderNode', id: string, code: string, serviceCategory: ServiceCategory, needsApproval: boolean, disputedOn: string | null, canApproveInvoices: boolean, canPay: boolean, facility: { __typename: 'FacilityNode', id: string, name: string, address: string, addressLine2: string | null, phone: string, email: string, cityName: string | null, zipCode: string, postalCode: string, currency: Currency, status: FacilityStatus, timezone: string, onsiteHoursJson: string | null, busyHoursJson: string | null, accessInfo: string, isMissingBrd: boolean | null, canManage: boolean, canManageEquipment: boolean, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null }, maintenancePlans: Array<{ __typename: 'MaintenancePlanNode', id: string }>, businessUnit: { __typename: 'BusinessUnitNode', id: string, name: string, memberCount: number, facilityCount: number, contactName: string | null, contactEmail: string | null, billingAddress: { __typename: 'BillingAddressNode', id: string, address: string, addressLine2: string | null, cityName: string | null, postalCode: string, city: { __typename: 'CityNode', id: string, name: string }, province: { __typename: 'ProvinceNode', id: string, code: string | null, name: string }, country: { __typename: 'CountryNode', id: string, name: string, code: string | null } }, facilities: Array<{ __typename: 'FacilityNode', id: string, name: string }> } | null }, clientInvoicesApprovals: Array<{ __typename: 'WorkOrderClientInvoicesApprovalNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } }>, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null } | null> } | null };

export type GetWorkOrderReviewFeedbackItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkOrderReviewFeedbackItemsQueryNode = { __typename: 'Query', workOrderReviewFeedback: { __typename: 'WorkOrderReviewFeedbackNodeConnection', edges: Array<{ __typename: 'WorkOrderReviewFeedbackNodeEdge', node: { __typename: 'WorkOrderReviewFeedbackNode', id: string, comment: string, isPositive: boolean } | null } | null> } | null };

export type GetWorkOrderSummaryQueryVariables = Exact<{
  workOrderId: Scalars['ID']['input'];
  includeProject?: Scalars['Boolean']['input'];
}>;


export type GetWorkOrderSummaryQueryNode = { __typename: 'Query', workOrder: { __typename: 'WorkOrderNode', id: string, code: string, hasAppliedProtectionPlan: boolean, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string, profile: { __typename: 'VendorProfileNode', id: string, phone: string } } | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, project?: { __typename: 'ProjectNode', id: string, name: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null } | null };

export type GetWorkOrderVendorsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  clientId: Scalars['ID']['input'];
}>;


export type GetWorkOrderVendorsQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null> } | null };

export type GetWorkOrdersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  status?: InputMaybe<Array<ClientWorkOrderStatus> | ClientWorkOrderStatus>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  holdReason?: InputMaybe<Array<WorkOrderHoldReason> | WorkOrderHoldReason>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  equipment?: InputMaybe<Scalars['ID']['input']>;
  facilityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  facility?: InputMaybe<Scalars['ID']['input']>;
  serviceCategory?: InputMaybe<Array<ServiceCategory> | ServiceCategory>;
  isMaintenancePlan?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalPm?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isSatisfied?: InputMaybe<Scalars['Boolean']['input']>;
  completedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  completedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnStartDate?: InputMaybe<Scalars['Date']['input']>;
  raisedOnEndDate?: InputMaybe<Scalars['Date']['input']>;
  assignedVendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  pointOfContactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  overtimeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  hasActionableQuoteForClient?: InputMaybe<Scalars['ID']['input']>;
  expectedServiceTimeline?: InputMaybe<Array<ExpectedServiceTimeline> | ExpectedServiceTimeline>;
  expenseTypes?: InputMaybe<Array<ExpenseType> | ExpenseType>;
  hasAppliedProtectionPlan?: InputMaybe<Scalars['Boolean']['input']>;
  includeProject?: Scalars['Boolean']['input'];
}>;


export type GetWorkOrdersQueryNode = { __typename: 'Query', workOrders: { __typename: 'WorkOrderNodeConnection', totalCount: number, edges: Array<{ __typename: 'WorkOrderNodeEdge', node: { __typename: 'WorkOrderNode', id: string, code: string, hasAppliedProtectionPlan: boolean, raisedOn: string, title: string, clientStatus: ClientWorkOrderStatus, onHold: boolean, holdReason: WorkOrderHoldReason | null, completedOn: string | null, cancelledOn: string | null, disputedOn: string | null, submittedToMarketplaceAt: string | null, serviceCategory: ServiceCategory, noteCount: number | null, equipment: { __typename: 'EquipmentNode', id: string, name: string } | null, coordinator: { __typename: 'CoordinatorNode', id: string, user: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } } | null, submittedBy: { __typename: 'UserNode', id: string, username: string, email: string, phone: string | null, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, locale: string, isAnonymous: boolean } } | null, appointment: { __typename: 'AppointmentNode', id: string, startsAt: string | null, endsAt: string | null, cancelledAt: string | null } | null, facility: { __typename: 'FacilityNode', id: string, name: string }, maintenancePlan: { __typename: 'MaintenancePlanNode', id: string } | null, project?: { __typename: 'ProjectNode', id: string, name: string } | null, overtimeApprovedBy: { __typename: 'UserNode', id: string } | null, teamMemberAssignments: Array<{ __typename: 'WorkOrderTeamMemberAssignmentNode', id: string, resolvedAt: string | null, outcome: WorkOrderTeamMemberAssignmentOutcome | null, notes: string, canCompleteAssignment: boolean, canReassignAssignment: boolean, assignedUser: { __typename: 'UserNode', id: string, firstName: string, lastName: string, username: string, email: string, phone: string | null, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }> }, photos: Array<{ __typename: 'WorkOrderTeamMemberAssignmentPhotoNode', id: string, photo: { __typename: 'ImageType', url: string } }> }>, vendor: { __typename: 'VendorOrganizationNode', name: string } | null, expectedServiceTimeline: { __typename: 'ExpectedServiceTimelineType', key: ExpectedServiceTimeline } | null } | null } | null> } | null };

export type Rmc_VendorField_GetServicedVendorsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
}>;


export type Rmc_VendorField_GetServicedVendorsQueryNode = { __typename: 'Query', vendors: { __typename: 'VendorOrganizationNodeConnection', edges: Array<{ __typename: 'VendorOrganizationNodeEdge', node: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null> } | null };

export type Rmc_VendorField_GetVendorsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
}>;


export type Rmc_VendorField_GetVendorsQueryNode = { __typename: 'Query', vendors: { __typename: 'VendorOrganizationNodeConnection', totalCount: number, edges: Array<{ __typename: 'VendorOrganizationNodeEdge', node: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null> } | null };

export type CitySummaryFragment = { __typename: 'CityNode', id: string, name: string };

export type CountrySummaryFragment = { __typename: 'CountryNode', id: string, name: string, code: string | null };

export type ProvinceSummaryFragment = { __typename: 'ProvinceNode', id: string, code: string | null, name: string };

export type RealSessionDetailsFragment = { __typename: 'UserNode', id: string, sourceId: number, accountType: AccountType, username: string, email: string, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string } }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> };

export type SessionClientDetailsFragment = { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } };

export type SessionDetailsFragment = { __typename: 'UserNode', id: string, isActive: boolean, accountType: AccountType, isFinance: boolean, isFinanceSuperuser: boolean, canAccessFinanceTab: boolean, username: string, email: string, phone: string | null, firstName: string, lastName: string, sourceId: number, entitlements: Array<string>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, title: string | null, isAnonymous: boolean, confirmationRequired: boolean, hasSetPassword: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string, acquisitionType: VendorAcquisitionType | null, isSelfServeSignup: boolean | null } }>, offResqCustomer: { __typename: 'OffResqCustomerNode', id: string, name: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null };

export type SessionVendorDetailsFragment = { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string, acquisitionType: VendorAcquisitionType | null, isSelfServeSignup: boolean | null };

export type GetFeatureFlagsQueryVariables = Exact<{
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFeatureFlagsQueryNode = { __typename: 'Query', featureFlags: Array<string> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQueryNode = { __typename: 'Query', me: { __typename: 'UserNode', id: string, isActive: boolean, accountType: AccountType, isFinance: boolean, isFinanceSuperuser: boolean, canAccessFinanceTab: boolean, username: string, email: string, phone: string | null, firstName: string, lastName: string, sourceId: number, entitlements: Array<string>, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, locale: string, phone: string | null, title: string | null, isAnonymous: boolean, confirmationRequired: boolean, hasSetPassword: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string, billingInformation: { __typename: 'BillingInformationNode', id: string, currency: Currency } }, roles: Array<{ __typename: 'RoleNode', id: string, name: string }> }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string, acquisitionType: VendorAcquisitionType | null, isSelfServeSignup: boolean | null } }>, offResqCustomer: { __typename: 'OffResqCustomerNode', id: string, name: string | null, vendor: { __typename: 'VendorOrganizationNode', id: string, name: string } | null } | null } | null, realMe: { __typename: 'UserNode', id: string, sourceId: number, accountType: AccountType, username: string, email: string, firstName: string, lastName: string, profile: { __typename: 'UserProfileNode', id: string, avatarBackgroundColor: string, avatarTextColor: string, phone: string | null, isAnonymous: boolean }, clientMemberships: Array<{ __typename: 'ClientOrganizationMemberNode', id: string, client: { __typename: 'ClientOrganizationNode', id: string, trackingId: number, name: string } }>, vendorMemberships: Array<{ __typename: 'VendorMemberNode', id: string, vendor: { __typename: 'VendorOrganizationNode', id: string, trackingId: number, name: string } }> } | null };

export type GetSchemaHashQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchemaHashQueryNode = { __typename: 'Query', schemaHash: string };

export const Client_UserSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<Client_UserSummaryFragment, unknown>;
export const Client_SpendApprovalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_SpendApproval"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"nteRaiseRequestApprovedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raiseApprovedSpend"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<Client_SpendApprovalFragment, unknown>;
export const FacilityGroupSpendInsightsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupSpendInsights"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupSpendNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allottedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"spentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingSpendCount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingSpendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FacilityGroupSpendInsightsFragment, unknown>;
export const ActivityFeedEntrySummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedEntrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityFeedEntryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activityDate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMessage"}},{"kind":"Field","name":{"kind":"Name","value":"internalMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVendor"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parameters"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<ActivityFeedEntrySummaryFragment, unknown>;
export const Client_AppointmentSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_AppointmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reschedule"}}]}}]}}]} as unknown as DocumentNode<Client_AppointmentSummaryFragment, unknown>;
export const CitySummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CitySummaryFragment, unknown>;
export const ProvinceSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ProvinceSummaryFragment, unknown>;
export const CountrySummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<CountrySummaryFragment, unknown>;
export const Client_FacilityPermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}}]} as unknown as DocumentNode<Client_FacilityPermissionsFragment, unknown>;
export const Client_BusinessUnitSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<Client_BusinessUnitSummaryFragment, unknown>;
export const Client_FacilitySummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Client_FacilitySummaryFragment, unknown>;
export const Client_RoleSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Client_RoleSummaryFragment, unknown>;
export const BusinessUnitMembershipSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<BusinessUnitMembershipSummaryFragment, unknown>;
export const Client_BusinessUnitDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]} as unknown as DocumentNode<Client_BusinessUnitDetailsFragment, unknown>;
export const ClientOrganizationPermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientOrganizationPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManageStaff"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_STAFF"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageBusinessSettings"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_BUSINESS_SETTINGS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessStatements"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_STATEMENTS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessSubscriptions"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_SUBSCRIPTIONS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSubmitWorkOrder"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SUBMIT_WORK_ORDER"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSelectQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SELECT_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApproveQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApprove"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageFavouriteVendors"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_FAVOURITE_VENDORS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManagePreventativeMaintenance"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PREVENTATIVE_MAINTENANCE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageProjects"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PROJECTS"}}]}]}}]} as unknown as DocumentNode<ClientOrganizationPermissionsFragment, unknown>;
export const Client_ClientDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveProtectionPlanConfiguration"}},{"kind":"Field","name":{"kind":"Name","value":"hasVendorIssuedInvoices"}},{"kind":"Field","name":{"kind":"Name","value":"lendingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"operatingCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}},{"kind":"Field","name":{"kind":"Name","value":"isAutopay"}},{"kind":"Field","name":{"kind":"Name","value":"isDirectVendorPayment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditCardFeeNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isNoticeActive"}},{"kind":"Field","name":{"kind":"Name","value":"isFeeEffective"}},{"kind":"Field","name":{"kind":"Name","value":"feeEffectiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRatePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"regionalRateOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"Field","name":{"kind":"Name","value":"ratePercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptFacilityRegionNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favouriteVendorsImported"}},{"kind":"Field","name":{"kind":"Name","value":"optedIntoMarketplace"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionLive"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionMigrated"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientOrganizationPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"successOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceApprovalStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignedOn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerDailyMenuFirstRunConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"viewerDailyMenuFirstRunConfirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionLive"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionMigrated"}},{"kind":"Field","name":{"kind":"Name","value":"hasMissingSubscriptionPaymentMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientOrganizationPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManageStaff"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_STAFF"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageBusinessSettings"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_BUSINESS_SETTINGS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessStatements"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_STATEMENTS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessSubscriptions"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_SUBSCRIPTIONS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSubmitWorkOrder"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SUBMIT_WORK_ORDER"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSelectQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SELECT_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApproveQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApprove"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageFavouriteVendors"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_FAVOURITE_VENDORS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManagePreventativeMaintenance"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PREVENTATIVE_MAINTENANCE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageProjects"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PROJECTS"}}]}]}}]} as unknown as DocumentNode<Client_ClientDetailsFragment, unknown>;
export const WorkOrderClientInvoicesApprovalSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<WorkOrderClientInvoicesApprovalSummaryFragment, unknown>;
export const Client_ClientInvoiceSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dueAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"latestFailureReason"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientInvoicesApprovals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"canApproveInvoices"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICES"}}]},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}}]} as unknown as DocumentNode<Client_ClientInvoiceSummaryFragment, unknown>;
export const Facility_FacilityGroupsField_FacilityGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}}]} as unknown as DocumentNode<Facility_FacilityGroupsField_FacilityGroupFragment, unknown>;
export const Client_ClientMembershipSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroupMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Client_ClientMembershipSummaryFragment, unknown>;
export const ClientMonthlyStatementSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMonthlyStatementSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientMonthlyStatementNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"agingReportPdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transactionSummaryCsvUrl"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClientMonthlyStatementSummaryFragment, unknown>;
export const ClientReportDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientReportDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"generatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"csvUrl"}}]}}]} as unknown as DocumentNode<ClientReportDetailsFragment, unknown>;
export const ClientReportScheduleDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientReportScheduleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportScheduleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"recipientEmailAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"nextReportOn"}},{"kind":"Field","name":{"kind":"Name","value":"lastReportOn"}}]}}]} as unknown as DocumentNode<ClientReportScheduleDetailsFragment, unknown>;
export const Client_EquipmentDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installedOn"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyNotes"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyExpiresOn"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNo"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"internalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modelTagImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNo"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"symptoms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorRanking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isVerifiedVendor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorPerformanceProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Client_EquipmentDetailsFragment, unknown>;
export const EquipmentServiceCountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentServiceCount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentServiceCount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]} as unknown as DocumentNode<EquipmentServiceCountFragment, unknown>;
export const Client_EquipmentSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomyNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}}]} as unknown as DocumentNode<Client_EquipmentSummaryFragment, unknown>;
export const EquipmentSummaryShortVersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentSummaryShortVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"statusFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EquipmentSummaryShortVersionFragment, unknown>;
export const Client_PaymentMethodSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_PaymentMethodSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizedDebitPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achAccountPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<Client_PaymentMethodSummaryFragment, unknown>;
export const Client_FacilityDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featureTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_PaymentMethodSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goliveOn"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actualGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"taggingMethod"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"businessTaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalStructure"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_PaymentMethodSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizedDebitPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achAccountPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Client_FacilityDetailsFragment, unknown>;
export const Client_FacilityGroupMembershipDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Client_FacilityGroupMembershipDetailsFragment, unknown>;
export const FacilityGroupDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}}]} as unknown as DocumentNode<FacilityGroupDetailsFragment, unknown>;
export const FacilityGroupForSelectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupForSelection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}}]} as unknown as DocumentNode<FacilityGroupForSelectionFragment, unknown>;
export const Client_ImageSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ImageSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"thumbnailUrl"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"120"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"120"}}]}]}}]} as unknown as DocumentNode<Client_ImageSummaryFragment, unknown>;
export const Client_InboundVendorInvoiceSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InboundVendorInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InboundVendorInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Client_InboundVendorInvoiceSummaryFragment, unknown>;
export const Client_InvitePermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InvitePermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canCancel"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"CANCEL"}}]}]}}]} as unknown as DocumentNode<Client_InvitePermissionsFragment, unknown>;
export const Client_InviteSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InviteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignedFacilityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_InvitePermissions"}},{"kind":"Field","name":{"kind":"Name","value":"hasOnboardingAction"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InvitePermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canCancel"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"CANCEL"}}]}]}}]} as unknown as DocumentNode<Client_InviteSummaryFragment, unknown>;
export const InvoiceApprovalSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceApprovalSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceApprovalSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<InvoiceApprovalSettingsFragment, unknown>;
export const Client_MaintenancePlanSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractEndDate"}}]}}]} as unknown as DocumentNode<Client_MaintenancePlanSummaryFragment, unknown>;
export const Client_VendorSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}}]} as unknown as DocumentNode<Client_VendorSummaryFragment, unknown>;
export const WorkOrderForSpendReportingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderForSpendReporting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<WorkOrderForSpendReportingFragment, unknown>;
export const Client_MaintenancePlanDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderForSpendReporting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"canDirectlyChangeDate"}},{"kind":"Field","name":{"kind":"Name","value":"scopeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractEndDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderForSpendReporting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Client_MaintenancePlanDetailsFragment, unknown>;
export const Client_MaintenancePlanTypeSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanTypeSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanTypeNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultServiceFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"defaultServiceFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"defaultInitialWorkOrderStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]} as unknown as DocumentNode<Client_MaintenancePlanTypeSummaryFragment, unknown>;
export const PeriodicSpendComparisonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeriodicSpendComparison"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeriodicSpendComparison"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"differencePercent"}}]}}]} as unknown as DocumentNode<PeriodicSpendComparisonFragment, unknown>;
export const QuoteApprovalThresholdSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteApprovalThresholdNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threshold"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<QuoteApprovalThresholdSummaryFragment, unknown>;
export const QuoteAcceptanceSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteAcceptanceSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteAcceptanceSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectionRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalThresholds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteApprovalThresholdNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threshold"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]} as unknown as DocumentNode<QuoteAcceptanceSettingsFragment, unknown>;
export const Client_QuoteSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}}]} as unknown as DocumentNode<Client_QuoteSummaryFragment, unknown>;
export const ClientMembershipForQuoteActionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<ClientMembershipForQuoteActionFragment, unknown>;
export const QuoteSetOptionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<QuoteSetOptionDetailsFragment, unknown>;
export const Client_QuoteSetDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}}]} as unknown as DocumentNode<Client_QuoteSetDetailsFragment, unknown>;
export const ReviewFeedbackFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewFeedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderReviewFeedbackNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isPositive"}}]}}]} as unknown as DocumentNode<ReviewFeedbackFragment, unknown>;
export const ReviewRequestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}}]} as unknown as DocumentNode<ReviewRequestFragment, unknown>;
export const Client_RoleDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Client_RoleDetailsFragment, unknown>;
export const Client_SkillDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_SkillDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SkillNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<Client_SkillDetailsFragment, unknown>;
export const SpendByPeriodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendByPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendByPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}}]}}]} as unknown as DocumentNode<SpendByPeriodFragment, unknown>;
export const SpendByServiceCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendByServiceCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendByServiceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}}]}}]} as unknown as DocumentNode<SpendByServiceCategoryFragment, unknown>;
export const SpendThisPeriodBreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendThisPeriodBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendThisPeriodBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpend"}}]}}]} as unknown as DocumentNode<SpendThisPeriodBreakdownFragment, unknown>;
export const Client_TaxRateDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_TaxRateDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRateNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"}}]}}]}}]} as unknown as DocumentNode<Client_TaxRateDetailsFragment, unknown>;
export const TopSpendFacilitiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopSpendFacilities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopSpendFacilities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityName"}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentDifference"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"externalSpendAmount"}}]}}]} as unknown as DocumentNode<TopSpendFacilitiesFragment, unknown>;
export const TopSpendWorkOrdersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopSpendWorkOrders"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopSpendWorkOrders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}}]}}]} as unknown as DocumentNode<TopSpendWorkOrdersFragment, unknown>;
export const UninvoicedByPeriodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UninvoicedByPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UninvoicedByPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]} as unknown as DocumentNode<UninvoicedByPeriodFragment, unknown>;
export const ClientMembershipPermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]}]}}]} as unknown as DocumentNode<ClientMembershipPermissionsFragment, unknown>;
export const Client_FacilityGroupSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}}]} as unknown as DocumentNode<Client_FacilityGroupSummaryFragment, unknown>;
export const Client_UserDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroupMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}}]}}]} as unknown as DocumentNode<Client_UserDetailsFragment, unknown>;
export const Rmc_VendorField_VendorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RMC_VendorField_Vendor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<Rmc_VendorField_VendorFragment, unknown>;
export const VendorDispatchRequestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorDispatchRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorDispatchRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedAcceptanceAt"}},{"kind":"Field","name":{"kind":"Name","value":"declineReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reasonChoice"}},{"kind":"Field","name":{"kind":"Name","value":"otherReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}}]} as unknown as DocumentNode<VendorDispatchRequestFragment, unknown>;
export const VendorDispatchFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorDispatch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorDispatchNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedThroughCyov"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorDispatchRequest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorDispatchRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorDispatchRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedAcceptanceAt"}},{"kind":"Field","name":{"kind":"Name","value":"declineReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reasonChoice"}},{"kind":"Field","name":{"kind":"Name","value":"otherReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<VendorDispatchFragment, unknown>;
export const VisitReviewRequestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisitReviewRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisitReviewRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]} as unknown as DocumentNode<VisitReviewRequestFragment, unknown>;
export const Client_WorkOrderReviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_WorkOrderReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderReviewNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"satisfied"}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<Client_WorkOrderReviewFragment, unknown>;
export const WorkOrderTeamMemberAssignmentPhotoDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<WorkOrderTeamMemberAssignmentPhotoDetailsFragment, unknown>;
export const WorkOrderTeamMemberAssignmentDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"canCompleteAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"COMPLETE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canReassignAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"REASSIGN"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<WorkOrderTeamMemberAssignmentDetailsFragment, unknown>;
export const Client_WorkOrderSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_WorkOrderSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasAppliedProtectionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"onHold"}},{"kind":"Field","name":{"kind":"Name","value":"holdReason"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledOn"}},{"kind":"Field","name":{"kind":"Name","value":"coordinator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}},{"kind":"Field","name":{"kind":"Name","value":"submittedToMarketplaceAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProject"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overtimeApprovedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteCount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedServiceTimeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"canCompleteAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"COMPLETE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canReassignAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"REASSIGN"}}]}]}}]} as unknown as DocumentNode<Client_WorkOrderSummaryFragment, unknown>;
export const FacilityGroupForBudgetCreationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupForBudgetCreation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FacilityGroupForBudgetCreationFragment, unknown>;
export const Orc_Settings_BusinessDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Orc_Settings_BusinessDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OffResqCustomerNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"businessDateOfIncorporation"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalStructure"}},{"kind":"Field","name":{"kind":"Name","value":"businessTaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Orc_Settings_BusinessDetailsFragment, unknown>;
export const RealSessionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RealSessionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<RealSessionDetailsFragment, unknown>;
export const SessionClientDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionClientDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<SessionClientDetailsFragment, unknown>;
export const SessionVendorDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionVendorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionType"}},{"kind":"Field","name":{"kind":"Name","value":"isSelfServeSignup"}}]}}]} as unknown as DocumentNode<SessionVendorDetailsFragment, unknown>;
export const SessionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"isFinance"}},{"kind":"Field","name":{"kind":"Name","value":"isFinanceSuperuser"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessFinanceTab"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasSetPassword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionClientDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionVendorDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offResqCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionClientDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionVendorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionType"}},{"kind":"Field","name":{"kind":"Name","value":"isSelfServeSignup"}}]}}]} as unknown as DocumentNode<SessionDetailsFragment, unknown>;
export const GetFacilityGroupSpendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityGroupSpend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"budgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroupSpend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"budgetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"budgetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupSpendInsights"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupSpendInsights"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupSpendNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allottedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"spentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingSpendCount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingSpendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFacilityGroupSpendQueryNode, GetFacilityGroupSpendQueryVariables>;
export const AddEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelTagImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serialNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"barCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warrantyNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warrantyExpiresOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"historicalSpend"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelTagImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelTagImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"serialNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serialNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"manufacturer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}}},{"kind":"Argument","name":{"kind":"Name","value":"barCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"barCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"installedOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"warrantyNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warrantyNotes"}}},{"kind":"Argument","name":{"kind":"Name","value":"warrantyExpiresOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warrantyExpiresOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"equipmentCategoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}},{"kind":"Argument","name":{"kind":"Name","value":"historicalSpend"},"value":{"kind":"Variable","name":{"kind":"Name","value":"historicalSpend"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_EquipmentSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomyNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AddEquipmentMutationNode, AddEquipmentMutationVariables>;
export const AddExternalExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddExternalExpense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddExternalExpenseMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addExternalExpense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalExpense"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AddExternalExpenseMutationNode, AddExternalExpenseMutationVariables>;
export const ApproveQuoteSetOptionForSpendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveQuoteSetOptionForSpend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApproveQuoteSetOptionForSpendInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveQuoteSetOptionForSpend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSetDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}}]} as unknown as DocumentNode<ApproveQuoteSetOptionForSpendMutationNode, ApproveQuoteSetOptionForSpendMutationVariables>;
export const ApproveWorkOrderInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveWorkOrderInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApproveWorkOrderClientInvoicesArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"approveWorkOrderInvoices"},"name":{"kind":"Name","value":"approveWorkOrderClientInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ApproveWorkOrderInvoicesMutationNode, ApproveWorkOrderInvoicesMutationVariables>;
export const AssignUsersToRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignUsersToRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignUsersToRoleMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignUsersToRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<AssignUsersToRoleMutationNode, AssignUsersToRoleMutationVariables>;
export const BulkInviteMembersToClientOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkInviteMembersToClientOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkInviteMembersToClientOrganizationMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkInviteMembersToClientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<BulkInviteMembersToClientOrganizationMutationNode, BulkInviteMembersToClientOrganizationMutationVariables>;
export const CancelInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CancelInviteMutationNode, CancelInviteMutationVariables>;
export const ClientCancelMaintenancePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClientCancelMaintenancePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancelledReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelMaintenancePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maintenancePlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cancelledReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancelledReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ClientCancelMaintenancePlanMutationNode, ClientCancelMaintenancePlanMutationVariables>;
export const CancelWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notifyCustomer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notifyVendor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderCancellationSource"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancelReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderCancellationReason"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"notifyCustomer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notifyCustomer"}}},{"kind":"Argument","name":{"kind":"Name","value":"notifyVendor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notifyVendor"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"cancelReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancelReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"additionalDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalDetails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CancelWorkOrderMutationNode, CancelWorkOrderMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutationNode, ChangePasswordMutationVariables>;
export const ChargePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChargePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChargePaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentSubmittedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dueAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"latestFailureReason"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientInvoicesApprovals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"canApproveInvoices"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICES"}}]},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}}]}}]}}]} as unknown as DocumentNode<ChargePaymentMethodMutationNode, ChargePaymentMethodMutationVariables>;
export const ChargeSubscriptionInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChargeSubscriptionInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChargeSubscriptionInvoicesMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeSubscriptionInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubmittedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dueAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"latestFailureReason"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientInvoicesApprovals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"canApproveInvoices"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICES"}}]},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}}]}}]}}]} as unknown as DocumentNode<ChargeSubscriptionInvoicesMutationNode, ChargeSubscriptionInvoicesMutationVariables>;
export const CompleteBillingEntityOnboardingStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteBillingEntityOnboardingStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteBillingEntityOnboardingStepMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeBillingEntityOnboardingStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteBillingEntityOnboardingStepMutationNode, CompleteBillingEntityOnboardingStepMutationVariables>;
export const CompleteClientOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteClientOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeClientOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteClientOnboardingMutationNode, CompleteClientOnboardingMutationVariables>;
export const CompleteFacilitiesOnboardingStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteFacilitiesOnboardingStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteFacilitiesOnboardingStepMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeFacilitiesOnboardingStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteFacilitiesOnboardingStepMutationNode, CompleteFacilitiesOnboardingStepMutationVariables>;
export const CompleteGetStartedOnboardingStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteGetStartedOnboardingStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteGetStartedOnboardingStepMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeGetStartedOnboardingStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteGetStartedOnboardingStepMutationNode, CompleteGetStartedOnboardingStepMutationVariables>;
export const CompleteStaffOnboardingStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteStaffOnboardingStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteStaffOnboardingStepMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeStaffOnboardingStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteStaffOnboardingStepMutationNode, CompleteStaffOnboardingStepMutationVariables>;
export const CompleteTroubleshootingSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteTroubleshootingSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteTroubleshootingSessionMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeTroubleshootingSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteTroubleshootingSessionMutationNode, CompleteTroubleshootingSessionMutationVariables>;
export const CompleteWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ForceWorkOrderCompletionMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forceWorkOrderCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CompleteWorkOrderMutationNode, CompleteWorkOrderMutationVariables>;
export const CompleteWorkOrderTeamMemberAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteWorkOrderTeamMemberAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteWorkOrderTeamMemberAssignmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeWorkOrderTeamMemberAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteWorkOrderTeamMemberAssignmentMutationNode, CompleteWorkOrderTeamMemberAssignmentMutationVariables>;
export const ConfirmPerUserDailyMenuFirstRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmPerUserDailyMenuFirstRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmPerUserDailyMenuFirstRunMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPerUserDailyMenuFirstRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}}]}}]}}]} as unknown as DocumentNode<ConfirmPerUserDailyMenuFirstRunMutationNode, ConfirmPerUserDailyMenuFirstRunMutationVariables>;
export const CreateBudgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBudgetMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBudget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"budget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBudgetMutationNode, CreateBudgetMutationVariables>;
export const CreateBusinessUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBusinessUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBusinessUnitArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBusinessUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBusinessUnitMutationNode, CreateBusinessUnitMutationVariables>;
export const CreateCyovDispatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCYOVDispatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCYOVDispatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCyovDispatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorDispatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorDispatch"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorDispatchRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorDispatchRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedAcceptanceAt"}},{"kind":"Field","name":{"kind":"Name","value":"declineReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reasonChoice"}},{"kind":"Field","name":{"kind":"Name","value":"otherReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorDispatch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorDispatchNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startedThroughCyov"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorDispatchRequest"}}]}}]}}]} as unknown as DocumentNode<CreateCyovDispatchMutationNode, CreateCyovDispatchMutationVariables>;
export const CreateFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFacilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFacilityMutationNode, CreateFacilityMutationVariables>;
export const CreateFacilityGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFacilityGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFacilityGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFacilityGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}}]} as unknown as DocumentNode<CreateFacilityGroupMutationNode, CreateFacilityGroupMutationVariables>;
export const CreateOrUpdateBusinessUnitOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrUpdateBusinessUnitOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrUpdateBusinessUnitOnboardingMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateBusinessUnitOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateBusinessUnitOnboardingMutationNode, CreateOrUpdateBusinessUnitOnboardingMutationVariables>;
export const CreateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRoleMutationNode, CreateRoleMutationVariables>;
export const CreateTroubleshootingSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTroubleshootingSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTroubleshootingSessionMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTroubleshootingSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"troubleshootingSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troubleshootingStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"stepDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supportLink"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateTroubleshootingSessionMutationNode, CreateTroubleshootingSessionMutationVariables>;
export const CreateUpdateWorkOrderExpenseTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUpdateWorkOrderExpenseType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUpdateWorkOrderExpenseTypeMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUpdateWorkOrderExpenseType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderExpenseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"setBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expenseTypeSetThrough"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUpdateWorkOrderExpenseTypeMutationNode, CreateUpdateWorkOrderExpenseTypeMutationVariables>;
export const CreateVisitReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVisitReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitReviewRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outcome"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitReviewOutcome"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVisitReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitReviewRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitReviewRequestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"outcome"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outcome"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CreateVisitReviewMutationNode, CreateVisitReviewMutationVariables>;
export const CreateWorkOrderEscalationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrderEscalation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderEscalationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderEscalation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderEscalation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"canEscalate"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ESCALATE"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"kustomerWorkOrderEscalation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketNumber"}},{"kind":"Field","name":{"kind":"Name","value":"kustomerUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderEscalationMutationNode, CreateWorkOrderEscalationMutationVariables>;
export const CreateWorkOrderReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrderReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderReviewArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkOrderReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_WorkOrderReview"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_WorkOrderReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderReviewNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"satisfied"}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderReviewMutationNode, CreateWorkOrderReviewMutationVariables>;
export const DeactivateEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeactivateEquipmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateEquipmentMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateEquipmentMutationNode, DeactivateEquipmentMutationVariables>;
export const DeactivateFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeactivateFacilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateFacilityMutationNode, DeactivateFacilityMutationVariables>;
export const DeleteBusinessUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBusinessUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteBusinessUnitMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBusinessUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteBusinessUnitMutationNode, DeleteBusinessUnitMutationVariables>;
export const DeleteClientReportScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteClientReportSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteClientReportScheduleMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteClientReportSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteClientReportScheduleMutationNode, DeleteClientReportScheduleMutationVariables>;
export const DeleteFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFacilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFacilityMutationNode, DeleteFacilityMutationVariables>;
export const DeleteFacilityGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFacilityGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFacilityGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFacilityGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteFacilityGroupMutationNode, DeleteFacilityGroupMutationVariables>;
export const DeleteRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteRoleMutationNode, DeleteRoleMutationVariables>;
export const DisputeWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisputeWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisputeWorkOrderArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disputeWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DisputeWorkOrderMutationNode, DisputeWorkOrderMutationVariables>;
export const EditClientMembershipDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditClientMembershipDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"EditClientMembershipDetails"},"name":{"kind":"Name","value":"editClientOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnitIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<EditClientMembershipDetailsMutationNode, EditClientMembershipDetailsMutationVariables>;
export const EditClientOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditClientOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editClientOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnitIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientMembershipSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroupMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}}]}}]} as unknown as DocumentNode<EditClientOrganizationMemberMutationNode, EditClientOrganizationMemberMutationVariables>;
export const EditClientVendorRelationshipInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditClientVendorRelationshipInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditClientVendorRelationshipInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editClientVendorRelationshipInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EditClientVendorRelationshipInviteMutationNode, EditClientVendorRelationshipInviteMutationVariables>;
export const EditEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelTagImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serialNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"barCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warrantyNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warrantyExpiresOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"historicalSpend"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"equipmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"mainImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelTagImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelTagImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"serialNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serialNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"modelNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"manufacturer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}}},{"kind":"Argument","name":{"kind":"Name","value":"barCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"barCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"installedOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"warrantyNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warrantyNotes"}}},{"kind":"Argument","name":{"kind":"Name","value":"warrantyExpiresOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warrantyExpiresOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"equipmentCategoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}},{"kind":"Argument","name":{"kind":"Name","value":"historicalSpend"},"value":{"kind":"Variable","name":{"kind":"Name","value":"historicalSpend"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_EquipmentDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installedOn"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyNotes"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyExpiresOn"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNo"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"internalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modelTagImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNo"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"symptoms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorRanking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isVerifiedVendor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorPerformanceProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditEquipmentMutationNode, EditEquipmentMutationVariables>;
export const GetInboundVendorInvoiceValidationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInboundVendorInvoiceValidation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inboundVendorInvoiceValidation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoiceFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceFile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"canOverride"}}]}}]}}]}}]} as unknown as DocumentNode<GetInboundVendorInvoiceValidationQueryNode, GetInboundVendorInvoiceValidationQueryVariables>;
export const InviteMemberToClientOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteMemberToClientOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedFacilityGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedRoleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendInvite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noExpiry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteMemberToClientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"emailAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedFacilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedFacilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedRoleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sendInvite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendInvite"}}},{"kind":"Argument","name":{"kind":"Name","value":"noExpiry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noExpiry"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"inviteType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InviteMemberToClientOrganizationMutationNode, InviteMemberToClientOrganizationMutationVariables>;
export const InviteOwnerToOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteOwnerToOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerFirstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerLastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteOwnerToOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"ownerFirstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerFirstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"ownerLastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerLastName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<InviteOwnerToOnboardingMutationNode, InviteOwnerToOnboardingMutationVariables>;
export const MarkClientManagedInvoicesAsPaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkClientManagedInvoicesAsPaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkClientManagedInvoicesAsPaidInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markClientManagedInvoicesAsPaid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientManagedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MarkClientManagedInvoicesAsPaidMutationNode, MarkClientManagedInvoicesAsPaidMutationVariables>;
export const MarkClientManagedInvoicesAsUnpaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkClientManagedInvoicesAsUnpaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkClientManagedInvoicesAsUnpaidInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markClientManagedInvoicesAsUnpaid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientManagedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MarkClientManagedInvoicesAsUnpaidMutationNode, MarkClientManagedInvoicesAsUnpaidMutationVariables>;
export const Rcc_WorkOrderDetails_MarkWorkOrderAsAwaitingPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RCC_WorkOrderDetails_MarkWorkOrderAsAwaitingPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkWorkOrderAsAwaitingPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markWorkOrderAsAwaitingPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Rcc_WorkOrderDetails_MarkWorkOrderAsAwaitingPaymentMutationNode, Rcc_WorkOrderDetails_MarkWorkOrderAsAwaitingPaymentMutationVariables>;
export const MarkWorkOrderTeamMemberAssignmentAsUnresolvedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkWorkOrderTeamMemberAssignmentAsUnresolved"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkWorkOrderTeamMemberAssignmentAsUnresolvedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markWorkOrderTeamMemberAssignmentAsUnresolved"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationNode, MarkWorkOrderTeamMemberAssignmentAsUnresolvedMutationVariables>;
export const MoveAllEquipmentToAnotherFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveAllEquipmentToAnotherFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveAllEquipmentToAnotherFacilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveAllEquipmentToAnotherFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<MoveAllEquipmentToAnotherFacilityMutationNode, MoveAllEquipmentToAnotherFacilityMutationVariables>;
export const MoveEquipmentToFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveEquipmentToFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveEquipmentToFacilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveEquipmentToFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<MoveEquipmentToFacilityMutationNode, MoveEquipmentToFacilityMutationVariables>;
export const Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RMC_InternalRequest_CompleteInternalRequestTeamMemberAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteInternalRequestTeamMemberAssignmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeInternalRequestTeamMemberAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationNode, Rmc_InternalRequest_CompleteInternalRequestTeamMemberAssignmentMutationVariables>;
export const ReactivateEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReactivateEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReactivateEquipmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactivateEquipmentMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}}]}}]}}]}}]} as unknown as DocumentNode<ReactivateEquipmentMutationNode, ReactivateEquipmentMutationVariables>;
export const ReactivateFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReactivateFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReactivateFacilityMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactivateFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ReactivateFacilityMutationNode, ReactivateFacilityMutationVariables>;
export const ReassignWorkOrderVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReassignWorkOrderVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReassignWorkOrderVendorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reassignWorkOrderVendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ReassignWorkOrderVendorMutationNode, ReassignWorkOrderVendorMutationVariables>;
export const RejectQuoteSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectQuoteSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectQuoteSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectQuoteSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSetDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}}]} as unknown as DocumentNode<RejectQuoteSetMutationNode, RejectQuoteSetMutationVariables>;
export const RejectQuoteSetOptionForSpendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectQuoteSetOptionForSpend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectQuoteSetOptionForSpendInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectQuoteSetOptionForSpend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSetDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}}]} as unknown as DocumentNode<RejectQuoteSetOptionForSpendMutationNode, RejectQuoteSetOptionForSpendMutationVariables>;
export const RemoveUserFromClientOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromClientOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromClientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RemoveUserFromClientOrganizationMutationNode, RemoveUserFromClientOrganizationMutationVariables>;
export const RemoveUsersFromRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUsersFromRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveUsersFromRoleMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUsersFromRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RemoveUsersFromRoleMutationNode, RemoveUsersFromRoleMutationVariables>;
export const RequestDispatchChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestDispatchChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestDispatchChangesMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDispatchChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RequestDispatchChangesMutationNode, RequestDispatchChangesMutationVariables>;
export const RequestPlannedMaintenanceQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPlannedMaintenanceQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestPlannedMaintenanceQuoteMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPlannedMaintenanceQuote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RequestPlannedMaintenanceQuoteMutationNode, RequestPlannedMaintenanceQuoteMutationVariables>;
export const RescheduleAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RescheduleAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RescheduleAppointmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rescheduleAppointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentMutationNode, RescheduleAppointmentMutationVariables>;
export const ResendClientVendorRelationshipInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendClientVendorRelationshipInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendClientVendorRelationshipInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendClientVendorRelationshipInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ResendClientVendorRelationshipInviteMutationNode, ResendClientVendorRelationshipInviteMutationVariables>;
export const RevokeClientVendorRelationshipInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeClientVendorRelationshipInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeClientVendorRelationshipInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeClientVendorRelationshipInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RevokeClientVendorRelationshipInviteMutationNode, RevokeClientVendorRelationshipInviteMutationVariables>;
export const SelectQuoteSetOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectQuoteSetOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectQuoteSetOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectQuoteSetOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSetDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}}]} as unknown as DocumentNode<SelectQuoteSetOptionMutationNode, SelectQuoteSetOptionMutationVariables>;
export const SendInviteSmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendInviteSms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendInviteSms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<SendInviteSmsMutationNode, SendInviteSmsMutationVariables>;
export const SetUserNotificationPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserNotificationPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetUserNoficationPreferenceMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserNotificationPreference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotificationPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"push"}},{"kind":"Field","name":{"kind":"Name","value":"sms"}}]}}]}}]}}]} as unknown as DocumentNode<SetUserNotificationPreferenceMutationNode, SetUserNotificationPreferenceMutationVariables>;
export const SetupPreAuthorizedDebitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetupPreAuthorizedDebit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPreAuthorizedDebitMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupPreAuthorizedDebit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"funding"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetupPreAuthorizedDebitMutationNode, SetupPreAuthorizedDebitMutationVariables>;
export const SnoozeReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SnoozeReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SnoozeReviewsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"snoozeReviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<SnoozeReviewsMutationNode, SnoozeReviewsMutationVariables>;
export const SubmitQuoteFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitQuoteFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitQuoteFeedbackArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitQuoteFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<SubmitQuoteFeedbackMutationNode, SubmitQuoteFeedbackMutationVariables>;
export const UpdateBudgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBudgetMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBudget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"budget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBudgetMutationNode, UpdateBudgetMutationVariables>;
export const UpdateBusinessUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBusinessUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBusinessUnitArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBusinessUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"}}]}}]}}]} as unknown as DocumentNode<UpdateBusinessUnitMutationNode, UpdateBusinessUnitMutationVariables>;
export const Client_ManageCategories_UpdateClientMatchingProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Client_ManageCategories_UpdateClientMatchingProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientMatchingProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientMatchingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMatchingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Client_ManageCategories_UpdateClientMatchingProfileMutationNode, Client_ManageCategories_UpdateClientMatchingProfileMutationVariables>;
export const UpdateClientReportScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClientReportSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientReportScheduleMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientReportSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientReportScheduleDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientReportScheduleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportScheduleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"recipientEmailAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"nextReportOn"}},{"kind":"Field","name":{"kind":"Name","value":"lastReportOn"}}]}}]} as unknown as DocumentNode<UpdateClientReportScheduleMutationNode, UpdateClientReportScheduleMutationVariables>;
export const UpdateDispatchMethodPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDispatchMethodPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDispatchMethodPreferenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDispatchMethodPreference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPaymentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDispatchMethod"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDispatchMethodPreferenceMutationNode, UpdateDispatchMethodPreferenceMutationVariables>;
export const UpdateFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFacilityArguments"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFacility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arguments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_PaymentMethodSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizedDebitPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achAccountPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featureTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_PaymentMethodSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goliveOn"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actualGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"taggingMethod"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"businessTaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalStructure"}}]}}]} as unknown as DocumentNode<UpdateFacilityMutationNode, UpdateFacilityMutationVariables>;
export const UpdateFacilityGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFacilityGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFacilityGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFacilityGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}}]} as unknown as DocumentNode<UpdateFacilityGroupMutationNode, UpdateFacilityGroupMutationVariables>;
export const UpdateInternalRequestTeamMemberAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInternalRequestTeamMemberAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInternalRequestTeamMemberAssignmentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInternalRequestTeamMemberAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInternalRequestTeamMemberAssignmentsMutationNode, UpdateInternalRequestTeamMemberAssignmentsMutationVariables>;
export const UpdateInvoiceApprovalSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInvoiceApprovalSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInvoiceApprovalSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoiceApprovalSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceApprovalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceApprovalSettings"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceApprovalSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceApprovalSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}}]}}]} as unknown as DocumentNode<UpdateInvoiceApprovalSettingsMutationNode, UpdateInvoiceApprovalSettingsMutationVariables>;
export const UpdatePaymentMethodDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentMethodDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentMethodDefaultMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentMethodDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentMethodDefaultMutationNode, UpdatePaymentMethodDefaultMutationVariables>;
export const UpdateQuoteAcceptanceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuoteAcceptanceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQuoteAcceptanceSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuoteAcceptanceSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteAcceptanceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteAcceptanceSettings"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteApprovalThresholdNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threshold"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteAcceptanceSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteAcceptanceSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectionRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalThresholds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"}}]}}]}}]} as unknown as DocumentNode<UpdateQuoteAcceptanceSettingsMutationNode, UpdateQuoteAcceptanceSettingsMutationVariables>;
export const UpdateQuoteApprovalThresholdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuoteApprovalThresholds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQuoteApprovalThresholdsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuoteApprovalThresholds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdateQuoteApprovalThresholdsMutationNode, UpdateQuoteApprovalThresholdsMutationVariables>;
export const UpdateRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<UpdateRoleMutationNode, UpdateRoleMutationVariables>;
export const UpdateTroubleshootingActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTroubleshootingAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTroubleshootingActionMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTroubleshootingAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdateTroubleshootingActionMutationNode, UpdateTroubleshootingActionMutationVariables>;
export const UpdateWorkOrderNteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkOrderNTE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWorkOrderNTEInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkOrderNte"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spendApproval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAmount"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateWorkOrderNteMutationNode, UpdateWorkOrderNteMutationVariables>;
export const UploadAfterImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadAfterImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAfterImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"images"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UploadAfterImagesMutationNode, UploadAfterImagesMutationVariables>;
export const UploadClientManagedInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadClientManagedInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadClientManagedInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadClientManagedInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientManagedInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UploadClientManagedInvoiceMutationNode, UploadClientManagedInvoiceMutationVariables>;
export const UploadVendorInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadVendorInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadVendorInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadVendorInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inboundVendorInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UploadVendorInvoiceMutationNode, UploadVendorInvoiceMutationVariables>;
export const CreateUpdateExternalReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUpdateExternalReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUpdateExternalReferenceMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUpdateExternalReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<CreateUpdateExternalReferenceMutationNode, CreateUpdateExternalReferenceMutationVariables>;
export const DetermineTroubleshootingPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DetermineTroubleshootingPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxonomyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"determineTroubleshootingPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"equipmentCategoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxonomyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxonomyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troubleshootingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"troubleshootingSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"stepDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supportLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DetermineTroubleshootingPlanQueryNode, DetermineTroubleshootingPlanQueryVariables>;
export const GetActivityFeedEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivityFeedEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isVendor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityFeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"-created_at","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"isVendor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVendor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedEntrySummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedEntrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityFeedEntryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activityDate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMessage"}},{"kind":"Field","name":{"kind":"Name","value":"internalMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVendor"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parameters"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}}]} as unknown as DocumentNode<GetActivityFeedEntriesQueryNode, GetActivityFeedEntriesQueryVariables>;
export const GetAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_AppointmentSummary"}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_AppointmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reschedule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}}]} as unknown as DocumentNode<GetAppointmentQueryNode, GetAppointmentQueryVariables>;
export const GetBusinessUnitDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBusinessUnitDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessUnitMembershipSummary"}}]}}]}}]} as unknown as DocumentNode<GetBusinessUnitDetailsQueryNode, GetBusinessUnitDetailsQueryVariables>;
export const GetBusinessUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBusinessUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyAccessible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyAccessible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyAccessible"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetBusinessUnitsQueryNode, GetBusinessUnitsQueryVariables>;
export const GetCanWorkOrderBeForceCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCanWorkOrderBeForceCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canBeForceCompleted"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"FORCE_COMPLETE_JOB"}}]}]}}]}}]} as unknown as DocumentNode<GetCanWorkOrderBeForceCompletedQueryNode, GetCanWorkOrderBeForceCompletedQueryVariables>;
export const GetCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provinceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"province"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provinceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetCitiesQueryNode, GetCitiesQueryVariables>;
export const GetClientDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientOrganizationPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManageStaff"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_STAFF"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageBusinessSettings"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_BUSINESS_SETTINGS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessStatements"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_STATEMENTS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canAccessSubscriptions"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"ACCESS_SUBSCRIPTIONS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSubmitWorkOrder"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SUBMIT_WORK_ORDER"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canSelectQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"SELECT_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApproveQuotes"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_QUOTE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canApprove"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageFavouriteVendors"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_FAVOURITE_VENDORS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManagePreventativeMaintenance"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PREVENTATIVE_MAINTENANCE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageProjects"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_PROJECTS"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveProtectionPlanConfiguration"}},{"kind":"Field","name":{"kind":"Name","value":"hasVendorIssuedInvoices"}},{"kind":"Field","name":{"kind":"Name","value":"lendingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"operatingCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}},{"kind":"Field","name":{"kind":"Name","value":"isAutopay"}},{"kind":"Field","name":{"kind":"Name","value":"isDirectVendorPayment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditCardFeeNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isNoticeActive"}},{"kind":"Field","name":{"kind":"Name","value":"isFeeEffective"}},{"kind":"Field","name":{"kind":"Name","value":"feeEffectiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRatePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"regionalRateOverrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"Field","name":{"kind":"Name","value":"ratePercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptFacilityRegionNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favouriteVendorsImported"}},{"kind":"Field","name":{"kind":"Name","value":"optedIntoMarketplace"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionLive"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionMigrated"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientOrganizationPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"successOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceApprovalStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignedOn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerDailyMenuFirstRunConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"viewerDailyMenuFirstRunConfirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionLive"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionMigrated"}},{"kind":"Field","name":{"kind":"Name","value":"hasMissingSubscriptionPaymentMethod"}}]}}]} as unknown as DocumentNode<GetClientDetailsQueryNode, GetClientDetailsQueryVariables>;
export const GetClientFeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientFeatures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}]}]}}]} as unknown as DocumentNode<GetClientFeaturesQueryNode, GetClientFeaturesQueryVariables>;
export const GetClientInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMaintenancePlan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSubscriptionInvoice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedOnStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedOnEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paidAtStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paidAtEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expenseTypes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpenseType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedVendorIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDisputed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overtimeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueAtDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientOrganizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"isMaintenancePlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMaintenancePlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSubscriptionInvoice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSubscriptionInvoice"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"completedOnStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedOnStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"completedOnEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedOnEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"paidAtStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paidAtStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"paidAtEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paidAtEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"expenseTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expenseTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedVendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedVendorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"isApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isApproved"}}},{"kind":"Argument","name":{"kind":"Name","value":"overtimeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overtimeApproved"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDisputed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDisputed"}}},{"kind":"Argument","name":{"kind":"Name","value":"dueAtDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueAtDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dueAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"latestFailureReason"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientInvoicesApprovals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"canApproveInvoices"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICES"}}]},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}}]}}]}}]} as unknown as DocumentNode<GetClientInvoicesQueryNode, GetClientInvoicesQueryVariables>;
export const GetClientMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastPeriodStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastPeriodEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userTz"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastPeriodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastPeriodStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastPeriodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastPeriodEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"userTz"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userTz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"combinedSpend"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpendByPeriod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinedUninvoiced"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UninvoicedByPeriod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategorySpend"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpendByServiceCategory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mostServicedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EquipmentServiceCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastMonthSpendComparison"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeriodicSpendComparison"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendThisPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"spendThisPeriodBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpendThisPeriodBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topSpendWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopSpendWorkOrders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topSpendFacilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopSpendFacilities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"averageMonthlyFacilitySpend"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"avgRepairSpend"}},{"kind":"Field","name":{"kind":"Name","value":"avgMpSpend"}},{"kind":"Field","name":{"kind":"Name","value":"avgInternalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"avgInternalMpSpend"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersAwaitingPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overdueCount"}},{"kind":"Field","name":{"kind":"Name","value":"awaitingPayment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendByPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendByPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UninvoicedByPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UninvoicedByPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendByServiceCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendByServiceCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentServiceCount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentServiceCount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeriodicSpendComparison"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeriodicSpendComparison"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"differencePercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpendThisPeriodBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpendThisPeriodBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpend"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopSpendWorkOrders"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopSpendWorkOrders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopSpendFacilities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopSpendFacilities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityName"}},{"kind":"Field","name":{"kind":"Name","value":"spendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"percentDifference"}},{"kind":"Field","name":{"kind":"Name","value":"internalSpendAmount"}},{"kind":"Field","name":{"kind":"Name","value":"externalSpendAmount"}}]}}]} as unknown as DocumentNode<GetClientMetricsQueryNode, GetClientMetricsQueryVariables>;
export const GetClientOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyColleaguesOfUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientOrganizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyColleaguesOfUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyColleaguesOfUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientMembershipSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientMembershipSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroupMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Facility_FacilityGroupsField_FacilityGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}}]}}]} as unknown as DocumentNode<GetClientOrganizationMembersQueryNode, GetClientOrganizationMembersQueryVariables>;
export const GetClientPaymentPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientPaymentPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDispatchMethod"}}]}}]}}]}}]} as unknown as DocumentNode<GetClientPaymentPreferenceQueryNode, GetClientPaymentPreferenceQueryVariables>;
export const GetClientPerformanceMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientPerformanceMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"periodEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"periodEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"quotesAwaitingClientApproval"}},{"kind":"Field","name":{"kind":"Name","value":"invoicesAwaitingClientApproval"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersAwaitingTriage"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersSubmitted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urgentCount"}},{"kind":"Field","name":{"kind":"Name","value":"nonUrgentCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"averageSchedulingSpeed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasData"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goodReviewCount"}},{"kind":"Field","name":{"kind":"Name","value":"badReviewCount"}},{"kind":"Field","name":{"kind":"Name","value":"goodReviewTags"}},{"kind":"Field","name":{"kind":"Name","value":"badReviewTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersByStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDemand"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDemand"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onHold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDemand"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDemand"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiced"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDemand"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersByCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactingFacilities"}}]}}]}}]} as unknown as DocumentNode<GetClientPerformanceMetricsQueryNode, GetClientPerformanceMetricsQueryVariables>;
export const GetClientReportSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientReportSchedules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientReportSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientReportScheduleDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientReportScheduleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportScheduleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"recipientEmailAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"nextReportOn"}},{"kind":"Field","name":{"kind":"Name","value":"lastReportOn"}}]}}]} as unknown as DocumentNode<GetClientReportSchedulesQueryNode, GetClientReportSchedulesQueryVariables>;
export const GetClientReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"-generated_on","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientReportDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientReportDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientReportNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"generatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"csvUrl"}}]}}]} as unknown as DocumentNode<GetClientReportsQueryNode, GetClientReportsQueryVariables>;
export const GetClientStatementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientStatements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientStatements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMonthlyStatementSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMonthlyStatementSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientMonthlyStatementNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"agingReportPdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transactionSummaryCsvUrl"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetClientStatementsQueryNode, GetClientStatementsQueryVariables>;
export const GetCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetCountriesQueryNode, GetCountriesQueryVariables>;
export const GetClientPreferredSpendThresholdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientPreferredSpendThreshold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPreferredSpendThreshold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvalRequiredThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequiredOvertimeThreshold"}}]}}]}}]} as unknown as DocumentNode<GetClientPreferredSpendThresholdQueryNode, GetClientPreferredSpendThresholdQueryVariables>;
export const GetEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facility_Organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_EquipmentSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomyNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentQueryNode, GetEquipmentQueryVariables>;
export const GetEquipmentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEquipmentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_EquipmentDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_EquipmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installedOn"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyNotes"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyExpiresOn"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNo"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"internalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"externalTotalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modelTagImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNo"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"symptoms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorRanking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isVerifiedVendor"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorPerformanceProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentDetailsQueryNode, GetEquipmentDetailsQueryVariables>;
export const GetEquipmentShortVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEquipmentShortVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasOngoingIncident"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasSensor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentStatus"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentStatus"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility_Organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"equipmentCategoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentCategoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasOngoingIncident"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasOngoingIncident"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasSensor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasSensor"}}},{"kind":"Argument","name":{"kind":"Name","value":"manufacturer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"manufacturer"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EquipmentSummaryShortVersion"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentSummaryShortVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"barCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateWarranty"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"historicalSpend"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"statusFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetEquipmentShortVersionQueryNode, GetEquipmentShortVersionQueryVariables>;
export const GetEquipmentSymptomsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEquipmentSymptoms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symptoms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentSymptomsQueryNode, GetEquipmentSymptomsQueryVariables>;
export const GetEquipmentWorkOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEquipmentWorkOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"equipment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"-submitted_to_marketplace_at","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderForSpendReporting"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderForSpendReporting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetEquipmentWorkOrdersQueryNode, GetEquipmentWorkOrdersQueryVariables>;
export const GetExpenseTypePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExpenseTypePermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"canUpdateExpenseType"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"UPDATE_EXPENSE_TYPE"}}]}]}}]}}]} as unknown as DocumentNode<GetExpenseTypePermissionsQueryNode, GetExpenseTypePermissionsQueryVariables>;
export const GetFacilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"name","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMissingBrd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessUnitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isMissingBrd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMissingBrd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}}]} as unknown as DocumentNode<GetFacilitiesQueryNode, GetFacilitiesQueryVariables>;
export const GetFacilityDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_PaymentMethodSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizedDebitPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achAccountPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featureTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_PaymentMethodSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"goliveOn"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actualGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"plannedGoLiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"taggingMethod"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"businessTaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalStructure"}}]}}]} as unknown as DocumentNode<GetFacilityDetailsQueryNode, GetFacilityDetailsQueryVariables>;
export const GetVendorSearchFacilityEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorSearchFacilityEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUnderCyovWarranty"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorSearchFacilityEquipmentQueryNode, GetVendorSearchFacilityEquipmentQueryVariables>;
export const GetFacilityGroupAllMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityGroupAllMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]} as unknown as DocumentNode<GetFacilityGroupAllMembershipsQueryNode, GetFacilityGroupAllMembershipsQueryVariables>;
export const GetFacilityGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRoot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLeaf"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isRoot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRoot"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeLeaf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeLeaf"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupMembershipNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qrSubmissionAuthenticationMode"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupMembershipDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}}]} as unknown as DocumentNode<GetFacilityGroupsQueryNode, GetFacilityGroupsQueryVariables>;
export const GetFacilityGroupsForBudgetCreationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityGroupsForBudgetCreation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRoot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isRoot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRoot"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"activeFacilityOnly"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupForBudgetCreation"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupForBudgetCreation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetFacilityGroupsForBudgetCreationQueryNode, GetFacilityGroupsForBudgetCreationQueryVariables>;
export const GetFacilityGroupsForSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacilityGroupsForSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyAccessible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activeFacilityOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyAccessible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyAccessible"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"nameOrFacilityName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"activeFacilityOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activeFacilityOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGroupForSelection"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGroupForSelection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manage"}}]}}]}}]} as unknown as DocumentNode<GetFacilityGroupsForSelectionQueryNode, GetFacilityGroupsForSelectionQueryVariables>;
export const GetInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_InviteSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InvitePermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canCancel"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"CANCEL"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_InviteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignedFacilityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_InvitePermissions"}},{"kind":"Field","name":{"kind":"Name","value":"hasOnboardingAction"}}]}}]} as unknown as DocumentNode<GetInvitesQueryNode, GetInvitesQueryVariables>;
export const GetInvoiceApprovalSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceApprovalSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceApprovalSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceApprovalSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceApprovalSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceApprovalSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondApprovalRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}}]}}]} as unknown as DocumentNode<GetInvoiceApprovalSettingsQueryNode, GetInvoiceApprovalSettingsQueryVariables>;
export const InvoicePaymentsPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicePaymentsPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicePaymentsPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardLastFour"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eftPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumberLastFour"}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"achPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumberLastFour"}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicePaymentsPreviewQueryNode, InvoicePaymentsPreviewQueryVariables>;
export const InvoicePaymentsPreviewPreEftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicePaymentsPreviewPreEFT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicePaymentsPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardLastFour"}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityPreviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicePaymentsPreviewPreEftQueryNode, InvoicePaymentsPreviewPreEftQueryVariables>;
export const GetMaintenancePlanDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenancePlanDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_MaintenancePlanDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractEndDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderForSpendReporting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderForSpendReporting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"canDirectlyChangeDate"}},{"kind":"Field","name":{"kind":"Name","value":"scopeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}}]}}]} as unknown as DocumentNode<GetMaintenancePlanDetailsQueryNode, GetMaintenancePlanDetailsQueryVariables>;
export const GetMaintenancePlanTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenancePlanTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_MaintenancePlanTypeSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanTypeSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanTypeNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultServiceFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"defaultServiceFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVariablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"defaultInitialWorkOrderStatus"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]} as unknown as DocumentNode<GetMaintenancePlanTypesQueryNode, GetMaintenancePlanTypesQueryVariables>;
export const GetMaintenancePlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenancePlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"maintenancePlanType_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"facility__name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_MaintenancePlanSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyUnit"}},{"kind":"Field","name":{"kind":"Name","value":"billingFrequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variablePricing"}},{"kind":"Field","name":{"kind":"Name","value":"nextWorkOrderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractEndDate"}}]}}]} as unknown as DocumentNode<GetMaintenancePlansQueryNode, GetMaintenancePlansQueryVariables>;
export const GetManufacturersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentManufacturers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetManufacturersQueryNode, GetManufacturersQueryVariables>;
export const Orc_Settings_GetOffResqCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orc_Settings_GetOffResqCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offResqCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Orc_Settings_BusinessDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Orc_Settings_BusinessDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OffResqCustomerNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"businessDateOfIncorporation"}},{"kind":"Field","name":{"kind":"Name","value":"businessLegalStructure"}},{"kind":"Field","name":{"kind":"Name","value":"businessTaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Orc_Settings_GetOffResqCustomersQueryNode, Orc_Settings_GetOffResqCustomersQueryVariables>;
export const Rmc_Staff_GetOrganizationSeatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RMC_Staff_GetOrganizationSeats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perUserSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualUserCount"}},{"kind":"Field","name":{"kind":"Name","value":"billableUserCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBillableMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"availableSeats"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"includedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"minimumBillableUsers"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientOrganizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Rmc_Staff_GetOrganizationSeatsQueryNode, Rmc_Staff_GetOrganizationSeatsQueryVariables>;
export const GetOvertimeStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOvertimeStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overtimeStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOvertime"}}]}}]}}]} as unknown as DocumentNode<GetOvertimeStatusQueryNode, GetOvertimeStatusQueryVariables>;
export const GetPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_PaymentMethodSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_PaymentMethodSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentMethodNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"creditCardPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cardholderName"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizedDebitPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"achAccountPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetPaymentMethodsQueryNode, GetPaymentMethodsQueryVariables>;
export const GetProvincesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProvinces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provinces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetProvincesQueryNode, GetProvincesQueryVariables>;
export const GetQuoteAcceptanceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQuoteAcceptanceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteAcceptanceSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteAcceptanceSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteApprovalThresholdNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threshold"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteAcceptanceSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteAcceptanceSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectionRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalThresholds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"}}]}}]}}]} as unknown as DocumentNode<GetQuoteAcceptanceSettingsQueryNode, GetQuoteAcceptanceSettingsQueryVariables>;
export const GetQuoteApprovalThresholdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQuoteApprovalThresholds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"threshold"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteApprovalThresholds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"threshold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"threshold"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteApprovalThresholdSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteApprovalThresholdNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threshold"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]} as unknown as DocumentNode<GetQuoteApprovalThresholdsQueryNode, GetQuoteApprovalThresholdsQueryVariables>;
export const GetQuoteSetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQuoteSets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetStatus"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteSets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSetDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_VendorSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeQualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_VendorSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedbackCount"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteSetOptionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetOptionNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_QuoteSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"rejectReasons"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalNeededRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipForQuoteAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select"}},{"kind":"Field","name":{"kind":"Name","value":"actionOnSpend"}},{"kind":"Field","name":{"kind":"Name","value":"selectAndApproveSpend"}},{"kind":"Field","name":{"kind":"Name","value":"provideFeedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_QuoteSetDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteSetNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteSetOptionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"rejectedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingApprovalSteps"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reject"}}]}}]}}]} as unknown as DocumentNode<GetQuoteSetsQueryNode, GetQuoteSetsQueryVariables>;
export const GetReviewRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusIn"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewRequestStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDueForReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"statusIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusIn"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDueForReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDueForReminder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewRequest"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetReviewRequestsQueryNode, GetReviewRequestsQueryVariables>;
export const GetRoleDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoleDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetRoleDetailsQueryNode, GetRoleDetailsQueryVariables>;
export const GetRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlySubsetOfUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlySubsetOfUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlySubsetOfUser"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetRolesQueryNode, GetRolesQueryVariables>;
export const GetSourcingPartsHoldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSourcingPartsHolds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingPartsHolds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fulfill"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partsEstimatedDateStart"}},{"kind":"Field","name":{"kind":"Name","value":"partsEstimatedDateEnd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSourcingPartsHoldsQueryNode, GetSourcingPartsHoldsQueryVariables>;
export const GetStripeCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStripeCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offResqCustomerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offResqCustomerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offResqCustomerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStripeCustomersQueryNode, GetStripeCustomersQueryVariables>;
export const Rcc_GetTaxRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RCC_GetTaxRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceSetId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordOfWorkId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceSet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceSetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recordOfWork"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordOfWorkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_TaxRateDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_TaxRateDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxRateNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"}}]}}]}}]} as unknown as DocumentNode<Rcc_GetTaxRatesQueryNode, Rcc_GetTaxRatesQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_RoleSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderObserver"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObserverType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientMembershipPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationMemberNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityGroupSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityGroupNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_RoleSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientMembershipPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroupMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facilityGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityGroupSummary"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQueryNode, GetUserQueryVariables>;
export const GetUserNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"push"}},{"kind":"Field","name":{"kind":"Name","value":"sms"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfigurable"}},{"kind":"Field","name":{"kind":"Name","value":"pushConfigurable"}},{"kind":"Field","name":{"kind":"Name","value":"smsConfigurable"}},{"kind":"Field","name":{"kind":"Name","value":"emailImplemented"}},{"kind":"Field","name":{"kind":"Name","value":"pushImplemented"}},{"kind":"Field","name":{"kind":"Name","value":"smsImplemented"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserNotificationPreferencesQueryNode, GetUserNotificationPreferencesQueryVariables>;
export const GetUserSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<GetUserSummaryQueryNode, GetUserSummaryQueryVariables>;
export const GetVisitReviewRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisitReviewRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusIn"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitReviewRequestStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitReviewRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointment"}}},{"kind":"Argument","name":{"kind":"Name","value":"statusIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusIn"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisitReviewRequest"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisitReviewRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisitReviewRequestNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]} as unknown as DocumentNode<GetVisitReviewRequestsQueryNode, GetVisitReviewRequestsQueryVariables>;
export const GetVisitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"visitedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityManagerName"}},{"kind":"Field","name":{"kind":"Name","value":"facilityManagerSignatureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}},{"kind":"Field","name":{"kind":"Name","value":"beforeImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"afterImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}}]} as unknown as DocumentNode<GetVisitsQueryNode, GetVisitsQueryVariables>;
export const GetWorkOrderActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"-started_at","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResqReviewActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_AppointmentSummary"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_AppointmentSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilledAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reschedule"}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderActivitiesQueryNode, GetWorkOrderActivitiesQueryVariables>;
export const GetWorkOrderCancellationDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorkOrderCancellationDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderCancellationDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderCancellationDetailQueryNode, GetWorkOrderCancellationDetailQueryVariables>;
export const GetWorkOrderClientInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderClientInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvinceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProvinceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilityPermissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"canManage"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canManageEquipment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"MANAGE_EQUIPMENT"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_BusinessUnitSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"facilityCount"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_FacilitySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FacilityNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvinceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilityPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"busyHoursJson"}},{"kind":"Field","name":{"kind":"Name","value":"accessInfo"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_BusinessUnitSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMissingBrd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_ClientInvoiceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInvoiceNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dueAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"expenseType"}},{"kind":"Field","name":{"kind":"Name","value":"externalReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"latestFailureReason"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_FacilitySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientInvoicesApprovals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderClientInvoicesApprovalSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"canApproveInvoices"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"APPROVE_INVOICES"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canPay"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"PAY_INVOICES"}}]},{"kind":"Field","name":{"kind":"Name","value":"needsApproval"}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderClientInvoicesQueryNode, GetWorkOrderClientInvoicesQueryVariables>;
export const GetWorkOrderReviewFeedbackItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderReviewFeedbackItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderReviewFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewFeedback"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewFeedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderReviewFeedbackNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isPositive"}}]}}]} as unknown as DocumentNode<GetWorkOrderReviewFeedbackItemsQueryNode, GetWorkOrderReviewFeedbackItemsQueryVariables>;
export const GetWorkOrderSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_WorkOrderSummary"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"canCompleteAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"COMPLETE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canReassignAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"REASSIGN"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_WorkOrderSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasAppliedProtectionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"onHold"}},{"kind":"Field","name":{"kind":"Name","value":"holdReason"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledOn"}},{"kind":"Field","name":{"kind":"Name","value":"coordinator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}},{"kind":"Field","name":{"kind":"Name","value":"submittedToMarketplaceAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProject"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overtimeApprovedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteCount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedServiceTimeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderSummaryQueryNode, GetWorkOrderSummaryQueryVariables>;
export const GetWorkOrderVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility_Organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderVendorsQueryNode, GetWorkOrderVendorsQueryVariables>;
export const GetWorkOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientWorkOrderStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onHold"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"holdReason"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderHoldReason"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facility"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceCategory"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMaintenancePlan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isInternalPm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCancelled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSatisfied"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedOnStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedOnEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"raisedOnStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"raisedOnEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedVendorIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pointOfContactIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overtimeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasActionableQuoteForClient"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expectedServiceTimeline"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpectedServiceTimeline"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expenseTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpenseType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasAppliedProtectionPlan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility_Organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientStatus_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"onHold"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onHold"}}},{"kind":"Argument","name":{"kind":"Name","value":"holdReason_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"holdReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"facility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facility"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduledForEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"scheduledForStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"equipment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}}},{"kind":"Argument","name":{"kind":"Name","value":"facilityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"isMaintenancePlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMaintenancePlan"}}},{"kind":"Argument","name":{"kind":"Name","value":"isInternalPm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isInternalPm"}}},{"kind":"Argument","name":{"kind":"Name","value":"isCancelled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCancelled"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSatisfied"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSatisfied"}}},{"kind":"Argument","name":{"kind":"Name","value":"completedOnStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedOnStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"completedOnEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedOnEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"raisedOnStartDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raisedOnStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"raisedOnEndDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raisedOnEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedVendorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedVendorIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"pointOfContactIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pointOfContactIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"overtimeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overtimeApproved"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasActionableQuoteForClient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasActionableQuoteForClient"}}},{"kind":"Argument","name":{"kind":"Name","value":"expectedServiceTimeline_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expectedServiceTimeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"expenseType_In"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expenseTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasAppliedProtectionPlan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasAppliedProtectionPlan"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_WorkOrderSummary"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_UserSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentPhotoDetails"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"canCompleteAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"COMPLETE"}}]},{"kind":"Field","alias":{"kind":"Name","value":"canReassignAssignment"},"name":{"kind":"Name","value":"can"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"perform"},"value":{"kind":"EnumValue","value":"REASSIGN"}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Client_WorkOrderSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasAppliedProtectionPlan"}},{"kind":"Field","name":{"kind":"Name","value":"raisedOn"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"onHold"}},{"kind":"Field","name":{"kind":"Name","value":"holdReason"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledOn"}},{"kind":"Field","name":{"kind":"Name","value":"coordinator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputedOn"}},{"kind":"Field","name":{"kind":"Name","value":"submittedToMarketplaceAt"}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Client_UserSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategory"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProject"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overtimeApprovedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderTeamMemberAssignmentDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteCount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedServiceTimeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<GetWorkOrdersQueryNode, GetWorkOrdersQueryVariables>;
export const Rmc_VendorField_GetServicedVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RMC_VendorField_GetServicedVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"id","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"servicedClientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name_Icontains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RMC_VendorField_Vendor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RMC_VendorField_Vendor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<Rmc_VendorField_GetServicedVendorsQueryNode, Rmc_VendorField_GetServicedVendorsQueryVariables>;
export const Rmc_VendorField_GetVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RMC_VendorField_GetVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"id","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"name_Icontains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RMC_VendorField_Vendor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RMC_VendorField_Vendor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<Rmc_VendorField_GetVendorsQueryNode, Rmc_VendorField_GetVendorsQueryVariables>;
export const GetFeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeatureFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"facilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<GetFeatureFlagsQueryNode, GetFeatureFlagsQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"realMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RealSessionDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionClientDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionVendorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorOrganizationNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionType"}},{"kind":"Field","name":{"kind":"Name","value":"isSelfServeSignup"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"isFinance"}},{"kind":"Field","name":{"kind":"Name","value":"isFinanceSuperuser"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessFinanceTab"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasSetPassword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionClientDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionVendorDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offResqCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RealSessionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"avatarTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeQueryNode, GetMeQueryVariables>;
export const GetSchemaHashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchemaHash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaHash"}}]}}]} as unknown as DocumentNode<GetSchemaHashQueryNode, GetSchemaHashQueryVariables>;